export const QUESTIONS = [
  {
    "id": 1,
    "question": "Which of the following is <i>not</i> considered a system component that can be found inside a computer?",
    "choice_a": "CPU",
    "choice_b": "RAM",
    "choice_c": "PCIe graphics adapter",
    "choice_d": "Motherboard",
    "correct_answer": "C",
    "explanation": "System components are essential for the basic functionality of a computer system. Many of the landmarks found on the motherboard can be considered system components, even expansion slots to a degree. What you plug into those slots, however, must be considered peripheral to the basic operation of the system.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      2,
      30,
      7,
      5,
      1
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 2,
    "question": "Which of the following is a physical memory format installed directly in today\u2019s desktop computer systems?",
    "choice_a": "DIMM",
    "choice_b": "HDD",
    "choice_c": "SSD",
    "choice_d": "eMMC",
    "correct_answer": "A",
    "explanation": "Except for DIMMs, all options represent some form of secondary storage.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      18,
      26,
      6,
      16,
      38
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 3,
    "question": "Which of the following are components that can commonly be found on a motherboard? (Choose all that apply.)",
    "choice_a": "Headers",
    "choice_b": "Fan connectors",
    "choice_c": "Gyroscope",
    "choice_d": "Scanner",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Motherboards commonly have headers for lights and buttons and for powering cooling fans. Gyroscopes are most commonly found in mobile devices. Scanners are external devices. Although there might be one or more types of HDD interfaces built into the motherboard, the HDD itself is not.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      7,
      6,
      4,
      8,
      21
    ],
    "source": "330034_Vol1_AssessmentTest",
    "choice_e": "HDD"
  },
  {
    "id": 4,
    "question": "Which of the following statements is true regarding ECC RAM?",
    "choice_a": "ECC RAM has full functionality in a non-ECC motherboard.",
    "choice_b": "ECC RAM will not fit in a non-ECC motherboard.",
    "choice_c": "ECC RAM will fit but not work in a non-ECC motherboard.",
    "choice_d": "ECC RAM will fit and function without error-correction in a non-ECC motherboard.",
    "correct_answer": "D",
    "explanation": "Error-correcting code (ECC) RAM will fit and work in a non-ECC motherboard, but it will not have error-correcting capabilities.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      14,
      16,
      20,
      26,
      3
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 5,
    "question": "Which of the following hard drives will fit into an M.2 slot with a B-key and an M-key?",
    "choice_a": "B-key",
    "choice_b": "M-key",
    "choice_c": "B+M-key",
    "choice_d": "All of the above",
    "correct_answer": "A",
    "explanation": "An M.2 slot with B- and M-keys has posts in the B- and M- positions. Therefore, the drive must have notches in both the B- and M- positions or it will not fit.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      36,
      4,
      35,
      34,
      39
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 6,
    "question": "You are replacing a power supply with a new one. What is the primary characteristic you should look for to ensure all internal components can be supported?",
    "choice_a": "Amperage rating",
    "choice_b": "20-pin to 24-pin motherboard adapter",
    "choice_c": "Wattage rating",
    "choice_d": "Voltage rating",
    "correct_answer": "C",
    "explanation": "Wattage is the unit of output for power supplies. Make sure that the power supply has enough wattage to support all components.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      41,
      43,
      44,
      45,
      47
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 7,
    "question": "A user has asked you to install a RAID array. Except in the case of RAID 0, which two things do all types of RAID offer? (Choose two.)",
    "choice_a": "Faster read speeds",
    "choice_b": "Faster write speeds",
    "choice_c": "Redundancy",
    "choice_d": "Fault tolerance",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Except for RAID 0, all implementations of RAID offer a way to recover from the failure of at least one drive, which is an example of fault tolerance, through the implementation of some mechanism that stores redundant information for that purpose. Some RAID types offer faster read and/or write performance. RAID 1, for instance does not guarantee either. RAID also does not automatically restore from backup.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      37,
      29,
      46,
      35,
      4
    ],
    "source": "330034_Vol1_AssessmentTest",
    "choice_e": "Automatic restores from backup after a drive failure"
  },
  {
    "id": 8,
    "question": "You are installing a new SATA hard drive. Which of the following is true, without using an adapter?",
    "choice_a": "It will connect to a SATA controller only.",
    "choice_b": "It will connect to a SATA controller or SAS controller.",
    "choice_c": "It will connect to a SATA controller or PATA controller.",
    "choice_d": "It will connect to a SATA controller or a PCIe controller.",
    "correct_answer": "B",
    "explanation": "SATA drives will of course connect to SATA controllers. They will connect to SAS controllers as well, although they will be much slower than SAS hard drives.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      35,
      4,
      33,
      40,
      62
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 9,
    "question": "Which of the following types of connectors would you expect to see on the end of a serial cable?",
    "choice_a": "DB-9",
    "choice_b": "RS-232",
    "choice_c": "Molex",
    "choice_d": "VGA",
    "correct_answer": "A",
    "explanation": "Serial cables use a DB-9 connector. Some people will call them an RS-232 connector, but RS-232 is the transmission standard used by serial cables. Molex are power connectors for PATA hard drives and optical drives. VGA is a video connector.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      63,
      57,
      60,
      61,
      62
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 10,
    "question": "Which of the following video connectors has an analog variety and a digital variety?",
    "choice_a": "VGA",
    "choice_b": "HDMI",
    "choice_c": "DisplayPort",
    "choice_d": "DVI",
    "correct_answer": "D",
    "explanation": "DVI comes in both analog (DVI-A) and digital (DVI-D) varieties. VGA is always analog; HDMI and DisplayPort are always digital.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      60,
      63,
      61,
      62,
      59
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 11,
    "question": "Which of the following connectors will you not find on the end of a USB cable? (Choose two.)",
    "choice_a": "Lightning",
    "choice_b": "USB-C",
    "choice_c": "Molex",
    "choice_d": "DB-9",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "USB cables are multipurpose cables that connect many types of peripherals. Connectors include USB-C, Lightning, and eSATA. Molex connectors provide power to PATA hard drives and optical drives. A DB-9 connector is found on the end of a serial cable.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      57,
      56,
      44,
      62,
      60
    ],
    "source": "330034_Vol1_AssessmentTest",
    "choice_e": "eSATA"
  },
  {
    "id": 12,
    "question": "In an LCD panel, what is the name of the component that provides power to the backlight?",
    "choice_a": "Diffuser",
    "choice_b": "Inverter",
    "choice_c": "Converter",
    "choice_d": "Digitizer",
    "correct_answer": "B",
    "explanation": "A backlight is given power by an inverter, which converts DC power from the power supply to AC power for the backlight. There are no diffusers or converters in an LCD panel. A digitizer takes input from a stylus or fingertip and turns it into digital signals.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      49,
      48,
      54,
      41,
      43
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 13,
    "question": "You are installing a new display for a laptop. Which LCD component is responsible for providing brightness?",
    "choice_a": "Backlight",
    "choice_b": "Inverter",
    "choice_c": "Screen",
    "choice_d": "Digitizer",
    "correct_answer": "A",
    "explanation": "The backlight provides light to the LCD screen. The inverter provides power to the backlight, and the screen displays the picture. Digitizers take physical input (such as touch) and turn it into electronic data.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      66,
      64,
      65,
      71,
      70
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 14,
    "question": "Your laptop has 8 GB of installed memory and uses shared video memory. If the video card is using 512 MB, how much is left for the rest of the system?",
    "choice_a": "8 GB",
    "choice_b": "7.5 GB",
    "choice_c": "512 MB",
    "choice_d": "Cannot determine",
    "correct_answer": "B",
    "explanation": "If the laptop is using shared video memory, then the system memory is shared with the video card. If the video card is using 512 MB (half a gigabyte), then there is 7.5 GB left for the system.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      68,
      67,
      64,
      71,
      69
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 15,
    "question": "On a typical laptop, which of the following components runs through the hinge from the base of the laptop up into the display unit?",
    "choice_a": "Webcam connector",
    "choice_b": "Speaker wires",
    "choice_c": "Microphone connector",
    "choice_d": "Wi-Fi antenna",
    "correct_answer": "D",
    "explanation": "In most laptops, the Wi-Fi antenna runs from the base of the unit through the hinge and into the display. The webcam and microphone are generally part of the display unit only. Speakers are most often in the base of the laptop, not the display.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      66,
      64,
      65,
      71,
      70
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 16,
    "question": "Which of the following laptop accessories is most likely to have a full-sized internal hard drive bay?",
    "choice_a": "Docking station",
    "choice_b": "Port replicator",
    "choice_c": "SAN",
    "choice_d": "NAS",
    "correct_answer": "A",
    "explanation": "A docking station might have an internal full-sized hard drive bay. Port replicators only have additional ports, such as HDMI, DisplayPort, and USB. Storage area networks (SAN) and network attached storage (NAS) are not laptop accessories.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      71,
      69,
      64,
      65,
      66
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 17,
    "question": "A technician is preparing to perform inkjet printer maintenance. Which of the following should they consider?",
    "choice_a": "Replace toner, apply maintenance kit, calibrate, clean.",
    "choice_b": "Replace paper, clean heating element, remove debris.",
    "choice_c": "Replace ribbon, replace printhead, replace paper.",
    "choice_d": "Clean printheads, replace cartridges, calibrate, clear jams.",
    "correct_answer": "D",
    "explanation": "Inkjet printer maintenance includes clean printheads, replace cartridges, calibrate, clear jams. Laser printer maintenance includes replace toner, apply maintenance kit, calibrate, clean. Thermal printer maintenance includes replace paper, clean heating element, remove debris. Impact printer maintenance includes replace ribbon, replace printhead, replace paper.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      96,
      74,
      97,
      75,
      76
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 18,
    "question": "What is the function of the laser in a laser printer?",
    "choice_a": "It heats up the toner so that it adheres to the page.",
    "choice_b": "It charges the paper so that it will attract toner.",
    "choice_c": "It creates an image of the page on the drum.",
    "choice_d": "It cleans the drum before a page is printed.",
    "correct_answer": "C",
    "explanation": "The laser creates an image on the photosensitive drum that is then transferred to the paper by the transfer corona. The fuser heats up the toner so that it adheres to the page. The transfer corona charges the page, and the eraser lamp cleans the drum before a page is printed. A rubber blade is also used to remove toner physically from the drum.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      80,
      77,
      79,
      78,
      96
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 19,
    "question": "What is the component called that stores the material that ends up printed to the page in a laser printer?",
    "choice_a": "Toner cartridge",
    "choice_b": "Ink cartridge",
    "choice_c": "Laser module",
    "choice_d": "Laser cartridge",
    "correct_answer": "A",
    "explanation": "Laser printers use toner, which they melt to the page in the image of the text and graphics being printed. A toner cartridge holds the fine toner dust until it is used in the printing process.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      77,
      80,
      78,
      96,
      79
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 20,
    "question": "When used with network scanning services, what does SMB allow for?",
    "choice_a": "Scan to the cloud",
    "choice_b": "Scan to email",
    "choice_c": "Scan to a network folder",
    "choice_d": "Scan to secured print",
    "correct_answer": "C",
    "explanation": "The Server Message Block (SMB) protocol allows for the saving of scanned documents onto a network folder.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      95,
      89,
      90,
      93,
      94
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 21,
    "question": "Which network connectivity device stops broadcasts from being sent to computers on a different network segment?",
    "choice_a": "Hub",
    "choice_b": "Switch",
    "choice_c": "Router",
    "choice_d": "Firewall",
    "correct_answer": "C",
    "explanation": "A router does not pass along broadcasts to computers on other segments. Hubs and switches send broadcasts along because they do not segment traffic at the logical network address level.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      114,
      125,
      106,
      122,
      99
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 22,
    "question": "Which of the following cable types is made with a plastic coating that does not produce toxic fumes when it burns?",
    "choice_a": "Plenum",
    "choice_b": "Fiber",
    "choice_c": "Coaxial",
    "choice_d": "UTP",
    "correct_answer": "A",
    "explanation": "The plenum is an air space within buildings used to circulate breathable air for occupants of a building. Fiber, coaxial, and UTP cables are normally enclosed with a PVC plastic coating, which produces toxic fumes if burned. For air ventilation spaces, plenum grade cable is required. All cable types have plenum-rated versions.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      110,
      111,
      113,
      116,
      112
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 23,
    "question": "Which of the following are standards used by coaxial cable? (Choose two.)",
    "choice_a": "RG-6",
    "choice_b": "RG-59",
    "choice_c": "RJ11",
    "choice_d": "RJ45",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "RG-6 and RG-59 are coaxial cable standards. RJ11 and RJ45 are connectors used with twisted pair cabling.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      110,
      116,
      112,
      113,
      148
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 24,
    "question": "You have a PoE switch that says it supports PoE Type 3. How many watts can it provide to attached devices?",
    "choice_a": "30 watts",
    "choice_b": "60 watts",
    "choice_c": "100 watts",
    "choice_d": "120 watts",
    "correct_answer": "B",
    "explanation": "Power over Ethernet Type 3 can provide 60 W of power. PoE is 15.4 W, PoE+ is 30 W, and PoE++ Type 4 is 100 W.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      115,
      114,
      108,
      107,
      112
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 25,
    "question": "On which port does FTP run by default?",
    "choice_a": "21",
    "choice_b": "25",
    "choice_c": "53",
    "choice_d": "80",
    "correct_answer": "A",
    "explanation": "FTP operates on ports 20 and 21. Port 25 is used by SMTP, port 53 is DNS, and port 80 is HTTP.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      120,
      128,
      121,
      119,
      117
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 26,
    "question": "Which of the following protocols can be used by a client to access email on a server?",
    "choice_a": "DNS",
    "choice_b": "FTP",
    "choice_c": "SMTP",
    "choice_d": "IMAP",
    "correct_answer": "D",
    "explanation": "The IMAP and POP3 protocols can be used to retrieve email from mail servers. DNS is used to resolve host names to IP addresses. FTP is for file transfers, and SMTP is used to send email.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      120,
      121,
      119,
      106,
      117
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 27,
    "question": "Which of the following protocols provide secure network transmissions? (Choose two.)",
    "choice_a": "SMTP",
    "choice_b": "SNMP",
    "choice_c": "SSH",
    "choice_d": "HTTPS",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Secure Shell (SSH) and Hypertext Transfer Protocol Secure (HTTPS) are both secure transport protocols. Simple Network Management Protocol (SNMP) and Simple Mail Transfer Protocol (SMTP) are not inherently secure.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      120,
      126,
      127,
      119,
      106
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 28,
    "question": "Which of the following IP addresses is not routable on the Internet?",
    "choice_a": "192.16.33.220",
    "choice_b": "172.18.1.101",
    "choice_c": "33.33.33.33",
    "choice_d": "192.186.33.220",
    "correct_answer": "B",
    "explanation": "Private IP addresses are not routable on the Internet. The Private IP address ranges are 10.0.0.0/8, 172.16.0.0/12, and 192.168.0.0/16.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      124,
      122,
      123,
      155,
      126
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 29,
    "question": "One of your network users was recently caught at work browsing pornographic websites. Which of the following servers could be installed to prohibit this activity?",
    "choice_a": "Web",
    "choice_b": "Security",
    "choice_c": "Proxy",
    "choice_d": "DNS",
    "correct_answer": "C",
    "explanation": "A proxy server can be configured to block access to websites containing potentially objectionable material. Web servers host websites. There is no specific security server, although there are authentication servers which provide security. A DNS server resolves hostnames to IP addresses.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      135,
      129,
      131,
      155,
      121
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 30,
    "question": "Which of the following Internet appliances will include services provided by an IDS or IPS?",
    "choice_a": "UTM",
    "choice_b": "Spam gateway",
    "choice_c": "Load balancer",
    "choice_d": "Proxy server",
    "correct_answer": "A",
    "explanation": "Unified threat management (UTM) is a security-based Internet appliance that will likely contain the services of an intrusion detection system (IDS) or intrusion protection system (IPS).",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      135,
      137,
      131,
      132,
      106
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 31,
    "question": "For security purposes, your network needs to ensure that all devices have synchronized time stamps for login events. Which network service will help provide this?",
    "choice_a": "DNS",
    "choice_b": "DHCP",
    "choice_c": "AAA",
    "choice_d": "NTP",
    "correct_answer": "D",
    "explanation": "A Network Time Protocol (NTP) server can ensure that all devices on the network are operating on the same time. DNS, DHCP, and AAA do not provide timekeeping services.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      121,
      128,
      131,
      117,
      119
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 32,
    "question": "Which DNS record type is used for IPv4 addresses?",
    "choice_a": "AAAA",
    "choice_b": "A",
    "choice_c": "CNAME",
    "choice_d": "MX",
    "correct_answer": "B",
    "explanation": "IPv4 addresses are identified with an A DNS record type. AAAA is for IPv6, CNAME is an alias, and MX is a mail server.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      129,
      121,
      122,
      124,
      128
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 33,
    "question": "Which of the following is a company that provides direct access to the Internet for home and business computer users?",
    "choice_a": "ASP",
    "choice_b": "ISP",
    "choice_c": "DNS",
    "choice_d": "DNP",
    "correct_answer": "B",
    "explanation": "An Internet service provider (ISP) provides direct access to the Internet. ASP is a programming language. DNS resolves hostnames to IP addresses. DNP is not a computer networking acronym.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      121,
      149,
      147,
      148,
      156
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 34,
    "question": "What is the maximum range for a Bluetooth Class 2 device?",
    "choice_a": "100 meters",
    "choice_b": "10 meters",
    "choice_c": "1 meter",
    "choice_d": "0.5 meters",
    "correct_answer": "B",
    "explanation": "A Bluetooth class 2 device (which includes headsets, keyboards, and mice) is 10 meters. Class 1 devices can transmit up to 100 meters, class 3 one meter, and class 4 half a meter.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      145,
      100,
      99,
      108,
      106
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 35,
    "question": "Which of the following 802.11 technologies can communicate in the 2.4 GHz and 5 GHz frequencies? (Choose two.)",
    "choice_a": "802.11ax",
    "choice_b": "802.11ac",
    "choice_c": "802.11n",
    "choice_d": "802.11g",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "802.11ax (Wi-Fi 6) and 802.11n were designed to communicate at 2.4 GHz and 5 GHz. 802.11ac runs at 5 GHz, and 802.11g runs at 2.4 GHz.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      138,
      143,
      141,
      142,
      107
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 36,
    "question": "Which wireless networking technology has the longest range?",
    "choice_a": "Bluetooth",
    "choice_b": "802.11",
    "choice_c": "NFC",
    "choice_d": "RFID",
    "correct_answer": "B",
    "explanation": "802.11 has the longest range. Bluetooth is next longest, and then the two shortest are the radio frequency standards NFC and RFID.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      141,
      100,
      145,
      138,
      99
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 37,
    "question": "Which of the following is used to remotely manage corporate mobile devices on a network?",
    "choice_a": "Location services",
    "choice_b": "Synchronization",
    "choice_c": "BYOD",
    "choice_d": "MDM",
    "correct_answer": "D",
    "explanation": "Mobile device management (MDM) controls which devices are on the network and can wipe entire devices. Location services does not manage software. Synchronization can back up apps and data but does not help with updates or deleting apps. BYOD is when a user owns the device that they use on a corporate network.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      168,
      169,
      171,
      157,
      167
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 38,
    "question": "What term refers to copying data between a mobile device and a computer system to mirror such things as contacts, programs, pictures, and music?",
    "choice_a": "Calibration",
    "choice_b": "Remote wipe",
    "choice_c": "Pairing",
    "choice_d": "Synchronization",
    "correct_answer": "D",
    "explanation": "Synchronizing a mobile device with a computer system allows you to mirror personal data between the devices, regardless of which one contains the most current data. Calibration refers to matching the device\u2019s and user\u2019s perceptions of where the user is touching the screen. Remote wipes allow you to remove personal data from a lost or stolen device. Pairing is what must be done in Bluetooth for two Bluetooth devices to connect and communicate.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      171,
      172,
      173,
      70,
      159
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 39,
    "question": "You want to send emails from your smartphone using a secure connection. Which port will enable that?",
    "choice_a": "25",
    "choice_b": "110",
    "choice_c": "143",
    "choice_d": "587",
    "correct_answer": "D",
    "explanation": "Port 587 is used by SMTP (an email sending protocol) secured with TLS. Ports 25 (SMTP), 110 (POP), and 143 (IMAP) are not secure.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      170,
      164,
      157,
      162,
      159
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 40,
    "question": "A network administrator wants ten users in three different countries to be able to access all of the same data for a project. Which solution is best?",
    "choice_a": "MDM",
    "choice_b": "Data cap",
    "choice_c": "Synchronization",
    "choice_d": "Cloud storage",
    "correct_answer": "D",
    "explanation": "Cloud storage is the best solution to allow geographically dispersed users to access the same data. MDM is mobile device management, which configures the devices allowed to join a network. Synchronization is the act of mirroring all unique changes and additions from one device to the other.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      173,
      171,
      168,
      169,
      172
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 41,
    "question": "When using cloud services, which of the following may incur an additional charge as part of metered utilization?",
    "choice_a": "Elasticity",
    "choice_b": "Availability",
    "choice_c": "Egress",
    "choice_d": "Ingress",
    "correct_answer": "C",
    "explanation": "Metered utilization means client usage is tracked and they are billed for their usage. Many service providers charge extra for downloading data, which is data egress (uploading, or ingress, is generally free). Elasticity and availability are separate cloud characteristics from metered utilization.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      183,
      180,
      182,
      185,
      184
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 42,
    "question": "Google Docs is an example of what type of cloud service?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "PaaS",
    "choice_d": "GaaS",
    "correct_answer": "A",
    "explanation": "Google Docs is software, so it is an example of software as a service (SaaS). IaaS is infrastructure as a service. PaaS is platform as a service. GaaS is not a test objective and is not currently a cloud service type.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      182,
      186,
      180,
      183,
      185
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 43,
    "question": "Which type of software is required to run client-side virtualization on your home network?",
    "choice_a": "Terminal emulation",
    "choice_b": "Process replication",
    "choice_c": "Hyperthreading",
    "choice_d": "Hypervisor",
    "correct_answer": "D",
    "explanation": "The hypervisor is the key piece of software needed for virtualization. Terminal emulation, process replication, and Hyper-Threading are not related to client-side virtualization.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      176,
      174,
      178,
      179,
      175
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 44,
    "question": "What type of cloud has elements from a public cloud run by a CSP and others owned by the client company on its internal network?",
    "choice_a": "Private",
    "choice_b": "Public",
    "choice_c": "Hybrid",
    "choice_d": "Community",
    "correct_answer": "C",
    "explanation": "A hybrid cloud is a combination of a public cloud (owned and operated by a CSP) and a private cloud (owned and operated by an individual company). A community cloud is one created by multiple organizations with similar interests.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      181,
      180,
      183,
      182,
      184
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 45,
    "question": "A desktop computer has recently started exhibiting slow performance, particularly when opening and saving files to the hard drive. What should you try first?",
    "choice_a": "Replace the hard drive.",
    "choice_b": "Remove old files and applications to free up disk space.",
    "choice_c": "Delete and reinstall the OS.",
    "choice_d": "Defragment the hard drive.",
    "correct_answer": "B",
    "explanation": "Hard drive performance can slow down if the drive gets short on space, particularly under 10 percent free space. Try removing old files and applications to free up disk space first. If that doesn\u2019t resolve it, then defragment. If neither of those work, it could indicate a failing hard drive.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      200,
      206,
      188,
      190,
      233
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 46,
    "question": "A network cable has not been working properly. Another technician suggests testing the cable. Which tool should be used to do this? (Choose two.)",
    "choice_a": "Loopback plug",
    "choice_b": "Network tap",
    "choice_c": "Cable tester",
    "choice_d": "Toner probe",
    "correct_answer": "C",
    "explanation": "Cable testers are for verifying that a cable works properly. Network taps create copies of network traffic for analysis. A loopback plug is for testing the ability of a network adapter to send and receive. A toner probe is used to trace a cable from one location to another.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      111,
      112,
      116,
      113,
      109
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 47,
    "question": "You are troubleshooting a network issue. What feature do switches most likely have to help troubleshoot connectivity issues?",
    "choice_a": "Port toggles",
    "choice_b": "Beep codes",
    "choice_c": "Indicator lights",
    "choice_d": "Log entries",
    "correct_answer": "C",
    "explanation": "Switches and other connectivity devices have indicator lights to help indicate when things are working normally and when something isn\u2019t working right. There are no port toggles and switches don\u2019t use beep codes. A switch might make a log entry into an event logger, but this is less likely than it having indicator lights.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      217,
      216,
      209,
      210,
      212
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 48,
    "question": "When you turn a computer on, you immediately hear a loud screeching sound coming from it. What components could be making this noise? (Choose two.)",
    "choice_a": "SSD",
    "choice_b": "HDD",
    "choice_c": "CPU",
    "choice_d": "PSU",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "A screeching sound can be made only by components that have moving parts. This includes conventional hard drives (HDDs) and power supplies (PSUs) with fans. Solid-state drives (SSDs) and CPUs have no moving parts.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      193,
      194,
      201,
      198,
      200
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 49,
    "question": "Your laser printer has recently starting printing vertical white lines on documents it prints. What is the most likely cause of the problem?",
    "choice_a": "The print driver is faulty.",
    "choice_b": "The fuser is not heating properly.",
    "choice_c": "There is toner on the transfer corona wire.",
    "choice_d": "There is a scratch on the EP drum.",
    "correct_answer": "C",
    "explanation": "White streaks on printouts are most likely caused by toner on the transfer corona wire. Vertical black lines are caused by a scratch or a groove in the EP drum. If the fuser was not heating properly, toner would not bond to the paper and you would have smearing. Faulty print drivers will cause garbage to print or there will be no printing at all.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      239,
      238,
      188,
      190,
      234
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 50,
    "question": "A laptop\u2019s display has several spots where it does not light up. If the screen is set to a solid white background, there are at least a dozen dots that will still be black. What\u2019s the solution to this problem?",
    "choice_a": "Change the screen resolution to a lower one.",
    "choice_b": "Replace the laptop display.",
    "choice_c": "Degauss the laptop display.",
    "choice_d": "Replace the laptop display inverter.",
    "correct_answer": "B",
    "explanation": "The symptom being described is called dead pixels. If they will not light up, the only solution is to replace the display. Changing the resolution won\u2019t help. Degaussing was done on old CRT monitors. The inverter provides power to the laptop display backlight, but if it were failing, the screen would be dim or flickering.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      221,
      222,
      223,
      220,
      190
    ],
    "source": "330034_Vol1_AssessmentTest"
  },
  {
    "id": 51,
    "question": "Which of the following should a user do to avoid malware on an Android phone?",
    "choice_a": "Use a screen protector.",
    "choice_b": "Block the digitizer from receiving external input.",
    "choice_c": "Install apps from only the Google Play store.",
    "choice_d": "",
    "correct_answer": "C",
    "explanation": "Android OS can be subjected to malware. To avoid malware, install apps only from the Google Play store and avoid tapping on suspicious links.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      231,
      232,
      189,
      188,
      191
    ],
    "source": "330034_Vol1_AssessmentTest",
    "choice_f": "None of the above. Android phones are not susceptible to malware."
  },
  {
    "id": 52,
    "question": "Which computer component contains all the circuitry necessary for other components or devices to communicate with one another?",
    "choice_a": "Motherboard",
    "choice_b": "CPU",
    "choice_c": "RAM",
    "choice_d": "Expansion bus",
    "correct_answer": "A",
    "explanation": "The spine of the computer is the system board, otherwise known as the motherboard. All other computer components plug into the motherboard. On the motherboard, you will find the CPU, underlying circuitry, expansion slots, video components, RAM slots, and various other chips.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      6,
      5,
      27,
      29
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 53,
    "question": "You are told by a technician over the phone that you need to bring replacement DDR4 SDRAM memory. What type of packaging is used for DDR4 SDRAM memory?",
    "choice_a": "224-pin DIMM",
    "choice_b": "240-pin DIMM",
    "choice_c": "288-pin DIMM",
    "choice_d": "296-pin DIMM",
    "correct_answer": "C",
    "explanation": "DDR4 SDRAM is manufactured on a 288-pin DIMM, as is DDR5 (although the two are keyed differently and are not compatible). DIMMs with 224 pins and 296 pins do not exist. DIMMs with 240 pins are used for DDR2 and DDR3 SDRAM.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      16,
      6,
      15,
      11,
      2
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 54,
    "question": "You need to replace memory in a server that is using ECC RAM. Which of the following statements regarding the replacement RAM is true?",
    "choice_a": "Installing non-ECC RAM will work fine, but the new RAM won\u2019t have error-correcting.",
    "choice_b": "You can only install ECC RAM for it to work properly.",
    "choice_c": "You can install non-ECC RAM and it will adapt for error-correction.",
    "choice_d": "Installing non-ECC RAM will work fine as long as the new RAM includes a parity bit.",
    "correct_answer": "B",
    "explanation": "If a system requires ECC RAM, then only ECC-RAM will work. Non-ECC RAM will not have error-correcting capabilities. There is no parity bit on RAM (at least not anymore).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      14,
      16,
      18,
      26,
      19
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 55,
    "question": "A client wants you to build a new PC for her, with a smaller case and lower power requirements. When selecting a motherboard, which form factor should you choose for a smaller size and lower power consumption?",
    "choice_a": "ATX",
    "choice_b": "AT",
    "choice_c": "DTX",
    "choice_d": "ITX",
    "correct_answer": "D",
    "explanation": "The ITX motherboard family consists of smaller boards that fit in standard or miniature cases and use less power than their larger counterparts. ATX are \u201cstandard\u201d sized motherboards in today\u2019s world. AT is a legacy form factor that was bigger than ATX. There are no DTX motherboards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      6,
      7,
      41,
      45
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 56,
    "question": "A motherboard failed on your desktop PC, which has an Intel Core i5-13600K processor. When you\u2019re looking for a replacement motherboard, which CPU socket does it need to have?",
    "choice_a": "LGA 1366",
    "choice_b": "LGA 1150",
    "choice_c": "LGA 1200",
    "choice_d": "LGA 1700",
    "correct_answer": "D",
    "explanation": "The Core i5-13600K is a Raptor Lake-series processor, which uses the LGA 1700 socket. LGA 1150 sockets are for older i7s, and the LGA 1366 socket is for even older ones than that. The LGA 1200 socket is for 10th generation Intel Core processors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      3,
      11,
      12,
      13,
      1
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 57,
    "question": "You have just replaced a processor in a computer and now need to add a cooling mechanism. What should you use to attach the cooling system to the processor?",
    "choice_a": "Heat sink",
    "choice_b": "Thermal paste",
    "choice_c": "Fan",
    "choice_d": "Superglue",
    "correct_answer": "B",
    "explanation": "Thermal paste and thermal pads are used to attach heat sinks and fans to processors. A heat sink usually gets attached to the processor using thermal paste, and then the fan is attached to the heat sink. Superglue would make it adhere, but it does not transfer heat properly\u2014it would likely melt and cause a mess and processor failure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      22,
      24,
      23,
      3,
      11
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 58,
    "question": "A technician asks you how to get a computer\u2019s processor to run faster than it currently does. What is he trying to achieve?",
    "choice_a": "Hyperthreading",
    "choice_b": "Overclocking",
    "choice_c": "Virtualization",
    "choice_d": "Multicore support",
    "correct_answer": "B",
    "explanation": "Overclocking is when someone sets the speed of the processor to run faster than it was rated for. While overclocking can make a computer faster, it can also cause the processor to produce more heat. Hyperthreading allows a processor core to handle multiple processes simultaneously. Virtualization is when you create multiple virtual machines on a computer. Multicore means that the processor has more than one core\u2014it\u2019s not a configurable option.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      12,
      22,
      24,
      21,
      23
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 59,
    "question": "You are assembling a new computer and are looking at new cooling systems. Which of the following cooling systems requires the use of a pump?",
    "choice_a": "Liquid",
    "choice_b": "Thermal paste",
    "choice_c": "Heat sink",
    "choice_d": "Heat sink plus fan",
    "correct_answer": "A",
    "explanation": "Liquid cooling systems require a reservoir of liquid and a pump to circulate the liquid. It\u2019s possible that the system could malfunction, causing a mess inside the computer. Thermal paste is used to adhere a heat sink to a processor. Heat sinks and fans do not use pumps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      24,
      22,
      21,
      25,
      5
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 60,
    "question": "Which of the following types of processors will likely generally be preferred for mobile devices?",
    "choice_a": "x64",
    "choice_b": "x86",
    "choice_c": "ARM",
    "choice_d": "LGA",
    "correct_answer": "C",
    "explanation": "ARM processors usually are smaller and generate less heat than do x64/x86 CISC processors; therefore, they are better options for mobile devices. LGA is a type of CPU socket.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      10,
      9,
      22,
      12,
      25
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 61,
    "question": "You press the front power button on a computer and the system boots. Later, you press it briefly and the system hibernates. When you press it again, the system resumes. You press and hold the button and the system shuts down. What is this feature called?",
    "choice_a": "Programmable power",
    "choice_b": "Soft power",
    "choice_c": "Relay power",
    "choice_d": "Hot power",
    "correct_answer": "B",
    "explanation": "Soft power is the feature whereby the front power button acts as a relay to initiate various system power changes, depending on the duration that the button is held. Programmable power, relay power, and hot power are not valid power options.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      7,
      5,
      23,
      43,
      41
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 62,
    "question": "You are training new technicians to install RAM and pointing out differences between packages. Which of the following are the numbers of pins that can be found on DIMM modules used in desktop motherboards? (Choose two.)",
    "choice_a": "180",
    "choice_b": "184",
    "choice_c": "200",
    "choice_d": "204",
    "correct_answer": [
      "B",
      "F"
    ],
    "explanation": "DIMMs used in desktop motherboard applications have one of four possible pin counts. SDR SDRAM is implemented on 168-pin modules. DDR SDRAM is implemented on 184-pin modules. DDR2 and DDR3 are implemented on 240-pin modules with different keying, and DDR4 and DDR5 DIMMs have 288 pins but different keying. Older dual-channel DIMM modules have 232 pins. Modules with 200 and 204 pins are used in the SODIMM line, and there are no modules with 180 pins.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      18,
      16,
      15,
      26,
      6
    ],
    "source": "330034_Vol1_Ch01",
    "choice_e": "232",
    "choice_f": "240"
  },
  {
    "id": 63,
    "question": "You are installing a new computer, and the user wants to use virtualization. Which two hardware components need to support virtual technology for this to work properly? (Choose two.)",
    "choice_a": "RAM",
    "choice_b": "Motherboard",
    "choice_c": "CPU",
    "choice_d": "BIOS",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "For virtualization to work, both the CPU and the BIOS need to support it. The operating system does as well. Virtualization support may need to be manually enabled in the BIOS. RAM does not need to support virtualization, and neither does the motherboard (except for the BIOS).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      13,
      5,
      8,
      3,
      11
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 64,
    "question": "You find out that a disgruntled ex-employee\u2019s computer has a boot password that must be entered before the operating system is ever loaded. There is also a password preventing your access to the BIOS utility. Which of the following motherboard components can most likely be used to return the computer to a state that will allow you to boot the system without knowing the password?",
    "choice_a": "Cable header",
    "choice_b": "Power reset connector",
    "choice_c": "Toggle switch",
    "choice_d": "Jumper",
    "correct_answer": "D",
    "explanation": "Most motherboards have a jumper or similar momentary closure mechanism that will allow you to clear the CMOS memory of any user settings and cause the BIOS to use factory defaults, including no user or supervisor passwords.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      5,
      7,
      1,
      9
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 65,
    "question": "Your Core i5 fan has a 4-pin connector, but your motherboard only has a single 3-pin header with the CPU_FAN label. Which of the following will be the easiest solution to get the necessary cooling for your CPU?",
    "choice_a": "Plug the 4-pin connector into the 3-pin header.",
    "choice_b": "Buy a 4-pin to 3-pin adapter.",
    "choice_c": "Leave the plug disconnected and use only the heat sink.",
    "choice_d": "Add an extra chassis fan.",
    "correct_answer": "A",
    "explanation": "The easiest solution that works to cool your CPU is to connect the 4-pin connector into the 3-pin header. The missing pin allows you to control the speed of the fan. Without it, the fan will run at top speed, which is fine, albeit a little noisier. There is no 4-pin to 3-pin power adapter. The heat sink alone should not be relied on for proper cooling of modern CPUs, and an extra chassis fan isn\u2019t designed to specifically help cool the CPU.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      23,
      7,
      22,
      24,
      43
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 66,
    "question": "You are installing a new video card into a PCIe slot. What is the combined total throughput of a PCIe 4.0 x16 slot?",
    "choice_a": "500 MBps",
    "choice_b": "1 GBps",
    "choice_c": "64 GBps",
    "choice_d": "128 GBps",
    "correct_answer": "C",
    "explanation": "The PCIe 1.1 specification provided 250 MBps of throughput per lane per direction. With the 2.x versions of PCIe, this rate was doubled to 500 MBps. PCIe 4.0 doubles that twice more. As a result, each v2.0 lane is capable of a combined 4 GBps. An x16 slot consists of 16 lanes, for a total bidirectional throughput of 64 GBps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      27,
      25,
      36,
      59
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 67,
    "question": "Which of the following allows you to perform the most complete restart of the computer without removing power?",
    "choice_a": "Start  Restart",
    "choice_b": "Start  Hibernate",
    "choice_c": "Reset button",
    "choice_d": "Power button",
    "correct_answer": "C",
    "explanation": "The reset button causes the computer to return to nearly the same point it is in when you power it on, but without the need for power cycling. Using Restart in the Start menu does not reboot as deeply as the reset button. Hibernation is a power state that completely removes power after saving the contents of RAM to the hard drive; pressing the power button is required to resume the session in the same manner as starting the computer after a complete shutdown. The power button cannot be used as a method of restarting the system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      7,
      8,
      23,
      43,
      56
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 68,
    "question": "You have just found out that a new UEFI upgrade exists for your computer, and you obtain a copy on a flash drive to install it. Which of the following is most helpful when flashing the UEFI on a desktop computer system?",
    "choice_a": "DVD-ROM",
    "choice_b": "Uninterruptable power supply",
    "choice_c": "Internet connection",
    "choice_d": "Windows administrator password",
    "correct_answer": "B",
    "explanation": "None of the options are required, but a UPS is by far the most helpful among the answers in that loss of power during this procedure can range from annoying to devastating.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      46,
      5,
      38,
      41,
      45
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 69,
    "question": "The 32 GB of DDR4 memory has failed in a client\u2019s desktop computer. The client requests that you upgrade the system for better performance when replacing the RAM. Which of the following is the best option?",
    "choice_a": "Install two new 32 GB DDR4 RAM modules.",
    "choice_b": "Install two new 128 GB DDR4 RAM modules.",
    "choice_c": "Install two new 32 GB DDR5 RAM modules.",
    "choice_d": "Install two new 128 GB DDR5 RAM modules.",
    "correct_answer": "A",
    "explanation": "The only viable option listed is to install two new 32 GB DDR4 RAM modules. Check the motherboard documentation first to make sure the system will support that much memory, though. DDR4 does not come in modules larger than 64 GB. DDR5 is not compatible with DDR4 motherboards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      19,
      16,
      26,
      15,
      18
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 70,
    "question": "You are replacing an HP laptop\u2019s motherboard. Which type of motherboard should you use?",
    "choice_a": "ATX",
    "choice_b": "AT",
    "choice_c": "One for the specific model",
    "choice_d": "mini-ITX",
    "correct_answer": "C",
    "explanation": "Laptop motherboards are usually custom-built for the specific case. A replacement board should be obtained that is the exact same size as the one that failed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      9,
      1,
      18,
      11,
      3
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 71,
    "question": "You need to install a new video card into a desktop computer. What type of expansion slot is preferred today for high-performance graphics adapters?",
    "choice_a": "AGP",
    "choice_b": "PCIe",
    "choice_c": "PCI",
    "choice_d": "SATA",
    "correct_answer": "B",
    "explanation": "PCIe is the newest and fastest slot for video cards. AGP and PCI are legacy technologies. SATA is for hard drives.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      2,
      27,
      25,
      43,
      35
    ],
    "source": "330034_Vol1_Ch01"
  },
  {
    "id": 72,
    "question": "You are installing a new graphics adapter in a Windows 11 system. Which of the following expansion slots is designed for high-speed, 3D graphics adapters?",
    "choice_a": "USB",
    "choice_b": "NVMe",
    "choice_c": "PCI",
    "choice_d": "PCIe",
    "correct_answer": "D",
    "explanation": "Although technically PCI could be used for graphics adapters, PCIe supports high-speed, 3D graphic video cards. PCIe offers better performance than older graphics adapters. USB can stream video, but it is not used for attachment of internal graphics adapters. NVMe is an SSD communications interface.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      27,
      25,
      31,
      60
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 73,
    "question": "You need to install a new M.2 hard drive into a desktop computer. The motherboard has an open M.2 slot that is M-keyed. Which types of M.2 hard drives will you be able to install into that motherboard?",
    "choice_a": "B-key",
    "choice_b": "M-key",
    "choice_c": "B+M-key",
    "choice_d": "A, B, and C",
    "correct_answer": "E",
    "explanation": "If the slot is M-keyed, that means it has a block in the M position. For a drive to fit into that slot, it must have a slot in the M position (called being M-keyed). A drive that is B-keyed only will not fit because its slot will not line up with the block in the connector. A B+M-keyed drive has slots in both the B and M positions, so it will fit as well.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      4,
      34,
      1,
      9
    ],
    "source": "330034_Vol1_Ch02",
    "choice_e": "B and C"
  },
  {
    "id": 74,
    "question": "You install a new NIC for a user, and he asks what it does. Which of the following best characterizes the functions of this device?",
    "choice_a": "Multimedia",
    "choice_b": "Communications",
    "choice_c": "Input/Output",
    "choice_d": "Storage",
    "correct_answer": "B",
    "explanation": "A network interface card (NIC) is used as a communications device. It enables the computer to talk to other computers on a network. It does not provide multimedia, input/output (such as a USB port does), or storage capabilities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      63,
      27,
      28,
      32
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 75,
    "question": "A client wants to ensure that their server does not lose power if their power supply fails. Which of the following best describes the type of power supply needed in this situation?",
    "choice_a": "A power supply that provides twice as much wattage than what is needed to power system components",
    "choice_b": "A power supply that provides a voltage output selector",
    "choice_c": "A modular power supply",
    "choice_d": "A redundant power supply",
    "correct_answer": "D",
    "explanation": "To protect against a power supply failure, use a redundant power supply, which is basically two PSUs in one unit. More wattage will not help if the power supply fails. There are no voltage output selectors on PSUs. There are voltage input switches on some, but that wouldn\u2019t help in this case. A modular power supply has removable and attachable cables to support a variety of peripherals.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      46,
      41,
      45,
      43,
      44
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 76,
    "question": "A client is looking for a desktop storage technology that provides the fastest possible data transfers. Which technology should you recommend?",
    "choice_a": "SATA",
    "choice_b": "NVMe",
    "choice_c": "10,000 rpm",
    "choice_d": "15,000 rpm",
    "correct_answer": "B",
    "explanation": "The fastest SSD communications interface is NVMe. SATA 10,000 rpm and 15,000 rpm refer to conventional hard drive spin rates, and conventional hard drives will always be slower than SSDs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      34,
      4,
      36,
      33
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 77,
    "question": "You are choosing an optical drive format for a client. The client needs to store video files which are about 20 GB in size. Which technology should they use?",
    "choice_a": "Double-sided, double-layer DVD+R",
    "choice_b": "Single-sided, single-layer Blu-ray disc",
    "choice_c": "Double-sided, single-layer DVD-R",
    "choice_d": "Double-sided, single-layer DVD+R",
    "correct_answer": "B",
    "explanation": "Blu-ray discs have a single-sided, single-layer capacity of 25 GB. A double-sided, single layer DVD can store about 9.4 GB, and a double-sided, double-layer DVD can store about 17.1 GB.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      39,
      38,
      44,
      34,
      33
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 78,
    "question": "Which of the following best describes the concept of hot-swappable devices?",
    "choice_a": "Power does not need to be turned off before the device is inserted or removed.",
    "choice_b": "The device can be removed with power applied after it is properly stopped in the operating system.",
    "choice_c": "Care must be taken when swapping the device because it can be hot to the touch.",
    "choice_d": "The device can be swapped while still hot, immediately after powering down the system.",
    "correct_answer": "A",
    "explanation": "Hot-swappable devices can be removed while the power to the system is still on. Warm-swappable devices need to be stopped in the operating system before being removed. The term has nothing to do with the heat level of the device.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      39,
      46,
      40,
      41,
      45
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 79,
    "question": "Of the following voltage pairings, which one accurately represents the input and output, respectively, of power supplies and AC adapters?",
    "choice_a": "AC in, AC out",
    "choice_b": "DC in, DC out",
    "choice_c": "AC in, DC out",
    "choice_d": "DC in, AC out",
    "correct_answer": "C",
    "explanation": "Power supplies and AC adapters use standard wall outlets for an input of AC voltage, which they convert to the DC voltages required by the components to which they supply power.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      41,
      42,
      43,
      44,
      47
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 80,
    "question": "What are the output voltages that are commonly produced by PC power supplies? (Choose all that apply.)",
    "choice_a": "+3.3VDC",
    "choice_b": "+4.3VDC",
    "choice_c": "+5VDC",
    "choice_d": "+8VDC",
    "correct_answer": [
      "A",
      "C",
      "E",
      "F"
    ],
    "explanation": "A PC\u2019s power supply produces +3.3VDC, +5VDC, +12VDC, and \u201312VDC from a 110VAC input.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      41,
      43,
      44,
      45,
      42
    ],
    "source": "330034_Vol1_Ch02",
    "choice_e": "+12VDC",
    "choice_f": "\u201312VDC",
    "choice_g": "+110VDC",
    "choice_h": "\u2013110VDC"
  },
  {
    "id": 81,
    "question": "You are installing a new power supply in a desktop computer. Which of the following statements about power supplies is true?",
    "choice_a": "You must make sure that the voltage selector switch on the back of the power supply is switched to the lower setting if the computer is going to be used in Europe.",
    "choice_b": "SATA hard drives most often use the same type of power connector that PATA hard drives use.",
    "choice_c": "Power supplies require a 20-pin to 24-pin motherboard adapter to supply power to ATX-based motherboards.",
    "choice_d": "Power supplies convert AC input to DC output.",
    "correct_answer": "D",
    "explanation": "PC power supplies accept alternating current (AC) as input and produce direct current (DC) for the internal components. Europe requires the voltage selector switch be set at the higher setting, if the power supply does not auto-detect voltage input. SATA drives most often use a specific power connector that is not compatible with the Molex connector used by PATA drives. ATX motherboards can have a 20- or 24-pin single power connector but an adapter is not always required.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      41,
      43,
      44,
      42,
      47
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 82,
    "question": "You have been asked to install a new hard drive for a client. Which of the following is not a consideration when installing an internal storage device?",
    "choice_a": "You should match the form factor of the drive or adapt it to an available drive bay or slot.",
    "choice_b": "You should secure the drive with at least two screws on one side and preferably two on each side.",
    "choice_c": "Due to the high revolutions at which modern hard drives spin, you must secure an external power source because the internal power supplies do not have the capacity.",
    "choice_d": "You need to be sure that the routing of the drive\u2019s data cable, if applicable, does not obstruct the engineered flow of air across internal components.",
    "correct_answer": "C",
    "explanation": "Today\u2019s hard drives, regardless of their rpm, have standard internal power connections. The other options are valid concerns when installing an internal drive.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40,
      44,
      33,
      25,
      4
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 83,
    "question": "A client just bought a new digital camera for his photography business. Which of the following is specifically designed as an internal storage device for cameras?",
    "choice_a": "Memory cards",
    "choice_b": "Optical discs",
    "choice_c": "Flash drives",
    "choice_d": "mSATA",
    "correct_answer": "A",
    "explanation": "Memory cards such as SD cards were designed for devices such as digital cameras. Optical discs are larger and used mostly with laptops and larger systems. Flash drives are USB. Some cameras may have a USB port, but that is external storage and not internal storage. mSATA is a laptop expansion card technology.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      38,
      36,
      4,
      39,
      40
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 84,
    "question": "You are installing a second hard drive into a desktop computer. The hard drive is an NVMe PCIe card. Which of the following steps will you need to take during installation?",
    "choice_a": "Install the hard drive into an open PCIe slot.",
    "choice_b": "Install the hard drive into an open PCIe slot. Connect the NVMe PCIe data cable.",
    "choice_c": "Install the hard drive into an open PCIe slot. Connect the NVMe PCIe power connector.",
    "choice_d": "Install the hard drive into an open PCIe slot. Connect the NVMe PCIe data cable and power connector.",
    "correct_answer": "A",
    "explanation": "NVMe is a communications standard and there are no NVMe slots. This drive needs to be installed into an open PCIe slot. PCIe hard drives do not require an additional data cable or power connector.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      36,
      2,
      40,
      44
    ],
    "source": "330034_Vol1_Ch02",
    "choice_e": "Install the hard drive into an open NVMe slot.",
    "choice_f": "Install the hard drive into an open NVMe slot. Connect the NVMe PCIe data cable.",
    "choice_g": "Install the hard drive into an open NVMe slot. Connect the NVMe PCIe power connector.",
    "choice_h": "Install the hard drive into an open NVMe slot. Connect the NVMe PCIe data cable and power connector."
  },
  {
    "id": 85,
    "question": "You are purchasing a new video card in a desktop computer. For the best performance, which type of video card should you purchase?",
    "choice_a": "PCI x16",
    "choice_b": "PCI x128",
    "choice_c": "AGP",
    "choice_d": "PCIe x128",
    "correct_answer": "E",
    "explanation": "For a video card, the best standard currently available is PCIe, and the widest channel width is x16. There are no PCI x16 or PCI x128 slots, nor is there a PCIe x128 slot. AGP is an older video expansion standard that is now obsolete.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      27,
      30,
      43,
      25
    ],
    "source": "330034_Vol1_Ch02",
    "choice_e": "PCIe x16"
  },
  {
    "id": 86,
    "question": "Which of the following is not a consideration when upgrading power supplies?",
    "choice_a": "You might find that you do not have a matching motherboard connector on your new power supply.",
    "choice_b": "You might find that your case has a nonremovable power supply.",
    "choice_c": "You might find that your power rating is not adequate on the new power supply.",
    "choice_d": "You might find that you do not have enough of the appropriate connectors coming from the power supply for the devices that you have installed.",
    "correct_answer": "B",
    "explanation": "Personal computers do not have permanently installed power supplies. Like other electrical and electronic components, power supplies can and do fail on a regular basis. Permanently mounting a power supply to a chassis would be a disservice to the consumer. You should consider the cumulative power needs of your installed components, and you might have to obtain adapters and splitters if you do not have enough or you have the wrong types of connectors coming from the power supply.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      43,
      44,
      45,
      41,
      42
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 87,
    "question": "You are choosing a flash standard for a client. They want the smallest flash cards possible. Which standard should you recommend?",
    "choice_a": "SD",
    "choice_b": "CompactFlash",
    "choice_c": "microSD",
    "choice_d": "miniSD",
    "correct_answer": "C",
    "explanation": "The smallest of the options is microSD, at 15 mm  11 mm. Perhaps \u201cmicro\u201d gives it away, but that also makes it easy to remember. SD cards are 32 mm \u00d7 24 mm. CompactFlash cards are the largest, at 36 mm \u00d7 43 mm. MiniSD cards measure at 21.5 mm \u00d7 20 mm.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      38,
      34,
      20,
      16,
      6
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 88,
    "question": "Your goal is to build the fastest computer possible. Which of the following hard drive technologies should you choose for the fastest read performance?",
    "choice_a": "M.2 PCIe",
    "choice_b": "M.2 SATA",
    "choice_c": "NVMe M.2",
    "choice_d": "NVMe SATA",
    "correct_answer": "C",
    "explanation": "The fastest drive will be an NVMe M.2 drive. M.2, PCIe, and SATA are different connector types, so there are no M.2 PCIe drives or M.2 SATA drives. NVMe over SATA is limited to 600 MBps transfer speeds, whereas M.2 is not.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      36,
      34,
      4,
      2
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 89,
    "question": "You have been asked to configure a RAID 5 system for a client. Which of the following statements about RAID 5 is true?",
    "choice_a": "It provides fault tolerance but no performance improvement.",
    "choice_b": "It provides performance improvement but no fault tolerance.",
    "choice_c": "If multiple drives in the array fail, the data can be saved provided that one drive is still operational.",
    "choice_d": "It requires at least three drives to implement.",
    "correct_answer": "D",
    "explanation": "RAID 5 arrays require a minimum of three hard drives to implement. If one drive fails, the data is fine and the system can still function, albeit slowly. If more than one drive fails, the system will be inoperable. RAID 5 provides both fault tolerance and a performance improvement.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      33,
      34,
      35,
      4
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 90,
    "question": "You have a motherboard with integrated video, and the video fails. You install a video add-on card. Which of the following statements are the most accurate? (Choose two.)",
    "choice_a": "The add-on card will not function properly because of the integrated video.",
    "choice_b": "The add-on card will function if it is bridged to the integrated video chipset.",
    "choice_c": "The add-on card will be detected automatically and function properly if it\u2019s PCIe.",
    "choice_d": "For the card to work properly, you might need to disable the integrated video in the BIOS.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Most likely, the new card will be detected and function properly once the computer is booted up. However, the driver will need to be installed. Odds are the new card will be a different model from the integrated card, which will require a new driver. On some systems, you will need to go into the BIOS and disable the integrated adapter.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      27,
      31,
      5,
      25,
      60
    ],
    "source": "330034_Vol1_Ch02",
    "choice_e": "The add-on card will work properly by using the integrated card\u2019s video driver."
  },
  {
    "id": 91,
    "question": "When replacing a power supply, which of the following tends to vary among power supplies and must be chosen properly to support all connected devices?",
    "choice_a": "Wattage",
    "choice_b": "Voltage",
    "choice_c": "Amperage",
    "choice_d": "Resistance",
    "correct_answer": "A",
    "explanation": "Power supplies are rated in watts. When you purchase a power supply, you should make sure the devices inside the computer do not require more wattage than the chosen power supply can offer. The voltage is fairly standard among power supplies, and it has nothing to do with the devices connected to the power supply. Amperage and resistance are not selling points for power supplies. Another thing that could vary is the number of power connectors\u2014make sure the new power supply has enough to support all installed peripherals.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      41,
      43,
      44,
      45,
      47
    ],
    "source": "330034_Vol1_Ch02"
  },
  {
    "id": 92,
    "question": "Which of the following could be used with an analog monitor? (Choose two.)",
    "choice_a": "HDMI",
    "choice_b": "DVI-A",
    "choice_c": "DVI-D",
    "choice_d": "DisplayPort",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "Analog monitors require an analog signal. VGA is an analog video standard and will work. DVI-A is also analog. (DVI-I would work as well.) HDMI, DVI-D, and DisplayPort are all digital standards.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      60,
      61,
      63,
      62,
      59
    ],
    "source": "330034_Vol1_Ch03",
    "choice_e": "VGA"
  },
  {
    "id": 93,
    "question": "You are attaching an external hard drive to a computer with USB 2.0 ports. The user is concerned about data transfer speed. What is the maximum speed of USB 2.0?",
    "choice_a": "480 Mbps",
    "choice_b": "5 Gbps",
    "choice_c": "10 Gbps",
    "choice_d": "20 Gbps",
    "correct_answer": "A",
    "explanation": "USB 2.0 has a maximum speed of 480 Mbps. USB 3.0 is 5 Gbps, USB 3.1 is 10 Gbps, USB 3.2 is 20 Gbps, and USB4 is up to 40 Gbps.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      56,
      58,
      30,
      38,
      62
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 94,
    "question": "You got a new desktop computer for a designer at your company. On the front panel is a rectangular yellow USB port. What does that mean?",
    "choice_a": "It\u2019s USB 2.0.",
    "choice_b": "It\u2019s USB 3.0.",
    "choice_c": "It\u2019s a port capable of charging devices even with the system powered off.",
    "choice_d": "It\u2019s a port to be used with USB-C compatible devices.",
    "correct_answer": "C",
    "explanation": "A yellow USB port is an \u201calways on\u201d charging port. It could be either USB 2 or USB 3. USB-C connectors are oval in shape vs. the rectangular older USB connectors.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      56,
      57,
      63,
      7,
      30
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 95,
    "question": "You are installing a replacement monitor on a desktop computer. Which of the following is true regarding a monitor\u2019s refresh rate?",
    "choice_a": "As long as the graphics adapter can refresh the image at a particular rate, the attached monitor can accommodate that refresh rate.",
    "choice_b": "The refresh rate is normally expressed in MHz.",
    "choice_c": "The refresh rate is normally selected by using the controls on the front panel of the monitor.",
    "choice_d": "As you lower the resolution, the maximum refresh rate allowed tends to increase.",
    "correct_answer": "D",
    "explanation": "As you lower the resolution, the maximum refresh rate allowed tends to increase. The refresh rate is most often expressed in cycles per second (Hz), not millions of cycles per second (MHz). You must usually select the refresh rate that you want from the display settings dialog boxes, not through the monitor\u2019s built-in menu system, although the monitor can often tell you the refresh rate that you\u2019re using. Finally, both the monitor and adapter must agree on the refresh rate you select. If either device does not support a particular refresh rate, such a rate cannot be used.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      50,
      51,
      53,
      60,
      31
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 96,
    "question": "Which of the following connector types is typically not associated with hard drive use?",
    "choice_a": "USB-C",
    "choice_b": "eSATA",
    "choice_c": "DB-9",
    "choice_d": "SATA",
    "correct_answer": "C",
    "explanation": "DB-9 connectors are most often used with serial cables and are not associated with hard drives. USB-C, eSATA, and SATA are examples of connectors used with hard drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      4,
      62,
      44,
      57,
      63
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 97,
    "question": "The company photographer is interested in buying a new digital camera. He wants to be able to plug it directly into his laptop to transfer pictures for editing. What type of connector will most likely be on his camera?",
    "choice_a": "Mini-USB",
    "choice_b": "Thunderbolt",
    "choice_c": "Molex",
    "choice_d": "Lightning",
    "correct_answer": "A",
    "explanation": "For smaller electronic devices such as cameras, micro-USB and mini-USB connectors are common. Thunderbolt is primarily used for video. Molex is a power connector. Lightning is an Apple proprietary connector that has been replaced by USB-C on newer devices.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      57,
      56,
      59,
      30,
      61
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 98,
    "question": "You are installing a new video card that has an HDMI port. Which of the following are true about HDMI cables? (Choose all that apply.)",
    "choice_a": "They can transmit analog or digital signals.",
    "choice_b": "They can transmit audio as well as video.",
    "choice_c": "They are not used to connect to projectors.",
    "choice_d": "They can use HDMI or mini-HDMI connectors.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "HDMI cables transmit digital video and audio signals. They can be used to connect to projectors or monitors. HDMI cables can have standard HDMI connectors, mini-HDMI connectors, or micro-HDMI connectors.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      61,
      60,
      63,
      55,
      52
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 99,
    "question": "Which of the following display interfaces is equivalent to DisplayPort with PCIe added in?",
    "choice_a": "Thunderbolt",
    "choice_b": "HDMI",
    "choice_c": "DVI",
    "choice_d": "VGA",
    "correct_answer": "A",
    "explanation": "Intel and Apple collaborated on Thunderbolt to add PCIe to VESA\u2019s DisplayPort and to make the resulting interface smaller and less expensive to connect. HDMI, DVI, and VGA are not equivalent to DisplayPort with PCIe added in.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      62,
      60,
      30,
      27
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 100,
    "question": "Which of the two standards use the same connector? (Choose two.)",
    "choice_a": "eSATA",
    "choice_b": "Thunderbolt 3",
    "choice_c": "USB4",
    "choice_d": "USB 2.0",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "USB4 is based on the Thunderbolt 3 specifications, and both natively use USB-C connectors.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      56,
      59,
      57,
      30,
      60
    ],
    "source": "330034_Vol1_Ch03",
    "choice_e": "Mini-USB"
  },
  {
    "id": 101,
    "question": "How do you connect a DVI-A interface on a peripheral to a DVI-D interface on the computer?",
    "choice_a": "With a DVI-I cable.",
    "choice_b": "With a cable that is terminated on one end with a DVI-A connector and on the other end with a DVD-D connector.",
    "choice_c": "You wouldn\u2019t interconnect those two interfaces.",
    "choice_d": "With a standard DVI cable.",
    "correct_answer": "C",
    "explanation": "Such a connection should not be made. DVI-I cables act like universal cables; they can connect two DVI-A interfaces or two DVI-D interfaces with adapters. Natively, they are used to connect two DVI-I interfaces, both of which are configured as either analog or digital. They are unable to convert the analog signal to a digital one, however. Analog and digital DVI interfaces are too disparate to interconnect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      63,
      61,
      51,
      48
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 102,
    "question": "A technician says he needs to provide power to a PATA hard drive and a DVD-ROM in a desktop. The computer now has a new fully modular power supply, and the technician wants to know what type of power connectors he should take. What do you tell him?",
    "choice_a": "SATA",
    "choice_b": "SCSI",
    "choice_c": "Serial",
    "choice_d": "Molex",
    "correct_answer": "D",
    "explanation": "A Molex connector is a power connector for IDE (PATA) storage devices. This includes hard drives and optical drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      44,
      45,
      4,
      33,
      40
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 103,
    "question": "Which of the following connectors is oval shaped?",
    "choice_a": "Micro-USB",
    "choice_b": "Mini-USB",
    "choice_c": "Thunderbolt 2",
    "choice_d": "Thunderbolt 3",
    "correct_answer": "D",
    "explanation": "Thunderbolt 3 uses the oval-shaped USB-C connector. Thunderbolt 2 used a proprietary connector that was more of a square. Micro-USB and mini-USB connectors look more like trapezoids.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      59,
      56,
      61,
      30
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 104,
    "question": "Which of the following connector types are capable of conducting power and transmitting data? (Choose all that apply.)",
    "choice_a": "Lightning",
    "choice_b": "Molex",
    "choice_c": "USB-C",
    "choice_d": "DB-9",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "USB cables and eSATA cables can transmit power and data. You will find Lightning, USB-C, and micro-USB connectors on the ends of USB cables. A Molex connector is power-only. A DB-9 is for serial cables and is data-only.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      62,
      30,
      44
    ],
    "source": "330034_Vol1_Ch03",
    "choice_e": "Micro-USB"
  },
  {
    "id": 105,
    "question": "Which of the following statements is true about eSATA cables and connectors?",
    "choice_a": "eSATA cables provide power and data to devices.",
    "choice_b": "eSATA connectors are smaller than USB-C connectors.",
    "choice_c": "eSATA is faster than USB4 and Thunderbolt 3.",
    "choice_d": "eSATA maximum throughput is 6 Gbps.",
    "correct_answer": "D",
    "explanation": "The eSATA standards limit throughput to 6 Gbps, which is much slower than USB4 and Thunderbolt 3, both of which can get to 40 Gbps. Standard eSATA cables do not provide power, although there are versions of eSATA that do include power. The connectors are larger than USB-C connectors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      30,
      56,
      57,
      63
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 106,
    "question": "Which of the following is not an example of a connector for a standard peripheral input device?",
    "choice_a": "1/8 jack",
    "choice_b": "Molex",
    "choice_c": "D-sub",
    "choice_d": "USB",
    "correct_answer": "B",
    "explanation": "Peripherals most often use USB today, but they can also use D-sub connectors (rarely), and audio devices such as microphones and speakers use 1/8 jacks. Molex connectors are power connectors for PATA hard drives and optical drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      44,
      55,
      60,
      63
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 107,
    "question": "You are asked to hook up a projector in a classroom. What type of cable are you most likely to need?",
    "choice_a": "USB Type A",
    "choice_b": "eSATA",
    "choice_c": "HDMI",
    "choice_d": "DB-9",
    "correct_answer": "C",
    "explanation": "A projector uses a standard video cable. In this case, HDMI is the most likely choice. eSATA is for hard drives, and DB-9 is a slow serial cable. It\u2019s possible that the projector has a USB interface, but the best selection is HDMI.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      61,
      63,
      62,
      56
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 108,
    "question": "A user with an iPhone 14 needs to charge her device and asks you to bring a cable. Which of the following connector types should you ensure that the cable has?",
    "choice_a": "Thunderbolt",
    "choice_b": "Lightning",
    "choice_c": "Mini-USB",
    "choice_d": "Micro-USB",
    "correct_answer": "B",
    "explanation": "Starting with the iPhone 5 and ending with iPhone 15, Apple iPhones used the proprietary Lightning connector for charging and connecting peripherals. Thunderbolt connectors are used on MacBooks for peripherals. iPhones do not have built-in mini- or micro-USB connectors.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      59,
      56,
      57,
      30,
      62
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 109,
    "question": "Which of the following types of cables will transfer data at the slowest rate?",
    "choice_a": "USB4",
    "choice_b": "Serial",
    "choice_c": "Thunderbolt 3",
    "choice_d": "HDMI",
    "correct_answer": "B",
    "explanation": "Classic serial ports and serial cables have the slowest data transmission speeds of any cable.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      57,
      56,
      62,
      63,
      60
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 110,
    "question": "What is the maximum data transfer rate of USB High Speed?",
    "choice_a": "10 Gbps",
    "choice_b": "5 Gbps",
    "choice_c": "480 Mbps",
    "choice_d": "12 Mbps",
    "correct_answer": "C",
    "explanation": "Full Speed USB is 12 Mbps. High Speed is 480 Mbps. SuperSpeed runs at 5 Gbps and SuperSpeed+ at 10 Gbps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      57,
      58,
      30,
      59
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 111,
    "question": "VGA cables use what type of signal between the adapter and monitor?",
    "choice_a": "Digital",
    "choice_b": "Analog",
    "choice_c": "Composite",
    "choice_d": "Compressed",
    "correct_answer": "B",
    "explanation": "VGA signals are analog, uncompressed, component signals that carry all of the video information for all three components of the original RGB signal. VGA signals are not digital, composite, or compressed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      63,
      48,
      50,
      27
    ],
    "source": "330034_Vol1_Ch03"
  },
  {
    "id": 112,
    "question": "A client has a laptop with which you are unfamiliar. You are asked to perform a memory upgrade. How can you obtain the service manual for this laptop computer?",
    "choice_a": "By pressing F1 while in Windows",
    "choice_b": "By pressing F2 while the system is booting up",
    "choice_c": "By reading the paper copy that comes with the laptop",
    "choice_d": "By searching the manufacturer\u2019s website",
    "correct_answer": "D",
    "explanation": "Laptop service manuals can be obtained from the manufacturer\u2019s website. It\u2019s very rare that paper service manuals are shipped with the laptop. Pressing F1 while in Windows will open Windows Help, and pressing F2 on many laptops during the system boot will take you into the BIOS/UEFI.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      65,
      68,
      64,
      72,
      71
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 113,
    "question": "Your manager tells you to replace the inverter on a broken laptop. Where will you find this component?",
    "choice_a": "Underneath the keyboard",
    "choice_b": "In the display",
    "choice_c": "Next to the heat sink and fan",
    "choice_d": "Near the CPU",
    "correct_answer": "B",
    "explanation": "The inverter, which transforms DC power into AC power for an LCD backlight, is found in the display. It\u2019s not underneath the keyboard, next to the heat sink and fan, or near the processor, which are all located in the bottom half of the laptop.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      66,
      64,
      65,
      67,
      71
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 114,
    "question": "You need to replace an LCD on a defective laptop. Which of the following are components of an LCD? (Choose all that apply.)",
    "choice_a": "Inverter",
    "choice_b": "Screen",
    "choice_c": "Wi-Fi card",
    "choice_d": "Backdrop",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The components of an LCD screen are the inverter, screen, and backlight. LCD display units will also have a Wi-Fi antenna (not the card), webcam, and microphone. There is no backdrop component.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      66,
      64,
      65,
      67,
      68
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 115,
    "question": "A user complains that his mouse cursor randomly jumps to different places on the screen when he types. Which device might you want to disable to prevent this from happening?",
    "choice_a": "Trackpad",
    "choice_b": "Mouse",
    "choice_c": "Point stick",
    "choice_d": "Trackball",
    "correct_answer": "A",
    "explanation": "The trackpad sits below the keyboard, where a user\u2019s palms may rest when he is typing. That contact may cause the mouse cursor to appear to jump on the screen. Disabling the touchpad should prevent this from happening.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      70,
      64,
      65,
      66,
      67
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 116,
    "question": "A user needs to get their laptop connected to the Internet, but no Wi-Fi connections are available. They do have their smartphone with them. What is the best option for them to get Internet access for their laptop?",
    "choice_a": "NFC",
    "choice_b": "Tethering",
    "choice_c": "Lightning",
    "choice_d": "Bluetooth",
    "correct_answer": "B",
    "explanation": "Tethering is connecting a device to an Internet hotspot. One assumes in this case that the smartphone can function as a hotspot, and then the laptop will tether to it either via Wi-Fi or a wired connection. Internet connections cannot be shared over NFC or Bluetooth.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      56,
      90,
      31,
      58
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 117,
    "question": "You need to replace defective DDR4 memory in a laptop. How many pins will the replacement memory module have?",
    "choice_a": "200",
    "choice_b": "204",
    "choice_c": "260",
    "choice_d": "288",
    "correct_answer": "C",
    "explanation": "DDR4 SODIMMs have 260 pints. DDR2 SODIMMs have 200 pins, DDR3 SODIMMs have 204 pins, and DDR5 has 262. No SODIMMs currently have 288 pins, but DDR4 DIMMs do.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      68,
      64,
      67,
      65,
      71
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 118,
    "question": "A user complains that his 2-in-1 laptop screen does not properly detect where he places his finger on the screen. What should you do first to resolve the issue?",
    "choice_a": "Replace the touchscreen.",
    "choice_b": "Replace the trackpad.",
    "choice_c": "Recalibrate the touchscreen.",
    "choice_d": "Recalibrate the trackpad.",
    "correct_answer": "C",
    "explanation": "If the touchscreen is not responding properly, the first step is to recalibrate it. If it continues to have problems, the screen may be defective and might need to be replaced. Degaussing is a process used on old CRT monitors and is not relevant to touchscreens.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      66,
      65,
      64,
      68
    ],
    "source": "330034_Vol1_Ch04",
    "choice_e": "Degauss the touchscreen.",
    "choice_f": "Degauss the trackpad."
  },
  {
    "id": 119,
    "question": "You need to wirelessly connect two accessories to a smartphone. Which of the following could be valid options to connect these wireless accessories? (Choose two.)",
    "choice_a": "USB",
    "choice_b": "Lightning",
    "choice_c": "NFC",
    "choice_d": "Bluetooth",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Two wireless connectivity options are NFC and Bluetooth; hotspot (not mentioned) is the third. USB and Lightning are wired connectivity methods.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      159,
      162,
      166,
      157,
      164
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 120,
    "question": "There has recently been a string of hardware thefts in your office building. What should you recommend that your users implement to help avoid this problem?",
    "choice_a": "Enable GPS tracking.",
    "choice_b": "Use a docking station.",
    "choice_c": "Use a cable lock.",
    "choice_d": "Use the screensaver lock.",
    "correct_answer": "C",
    "explanation": "Sometimes the only way to ensure that equipment doesn\u2019t walk away is to lock it down physically. Laptops come equipped with holes for cable locks that can be used to secure them to a desk or other workstation. GPS tracking might help after the device is stolen, but it\u2019s best to prevent that in the first place. A docking station does not prevent physical theft, nor does a screensaver with a password.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      64,
      71,
      165,
      168,
      169
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 121,
    "question": "Which of the following describes the job of an inverter in a laptop?",
    "choice_a": "It changes the screen orientation when the laptop is rotated.",
    "choice_b": "It converts AC power into DC power for the display backlight.",
    "choice_c": "It converts DC power into AC power for the display backlight.",
    "choice_d": "It allows the laptop display to function in tablet mode.",
    "correct_answer": "C",
    "explanation": "The laptop power supply converts AC power into DC power for the laptop\u2019s internal circuitry. The display backlight, if used, needs AC power. The inverter\u2019s job is to convert (invert) the DC power into AC power for the backlight.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      66,
      71,
      64,
      67,
      65
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 122,
    "question": "A user is getting a new laptop. Which of the following is <i>not</i> a valid option to get his files and data from the old hard drive to the new hard drive?",
    "choice_a": "Manually copy files from the old drive to the cloud, and then to the new drive.",
    "choice_b": "Manually copy files from the old drive to an external hard drive, and then to the new drive.",
    "choice_c": "Use a hard drive migration app.",
    "choice_d": "Use the NFC disk transfer utility.",
    "correct_answer": "D",
    "explanation": "To migrate data from one hard drive to another, you can manually copy the data or use a migration app. There is no NFC disk transfer utility.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      38,
      56,
      33,
      34,
      4
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 123,
    "question": "A user on your network wants to be able to draw images on a screen and have the laptop capture them. What type of device needs to be installed on their laptop?",
    "choice_a": "Inverter",
    "choice_b": "Capturer",
    "choice_c": "Digitizer",
    "choice_d": "Trackpad",
    "correct_answer": "C",
    "explanation": "The user needs a digitizer, which takes input from the device, such as drawn images, and converts them into electronic images on the computer. The user could also use a touchscreen for the same purpose. An inverter changes DC power into AC power for a display backlight. There is no capturer laptop device. A trackpad is a pointing device that allows a user to control the mouse cursor.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      66,
      70,
      65,
      64,
      71
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 124,
    "question": "A user has requested a laptop memory upgrade. The technician attempts to put in new memory, but the memory module is barely too wide for the slot. What is the most likely scenario?",
    "choice_a": "The technician is trying to install DDR4 into a motherboard with DDR3 slots.",
    "choice_b": "The technician is trying to install DDR3 into a motherboard with DDR4 slots.",
    "choice_c": "The technician is trying to install MicroDIMMs into SODIMM slots.",
    "choice_d": "The technician is trying to install DIMMs into SODIMM slots.",
    "correct_answer": "A",
    "explanation": "Laptops most often use SODIMMs (or possibly MicroDIMMs), which are much smaller than standard DIMMs used in desktops. DDR2 and DDR3 SODIMMs are 67.6 millimeters wide, whereas DDR4 SODIMMs are 69.6 millimeters wide. It\u2019s likely that the technician has DDR4 SODIMMs and the motherboard supports DDR3 SODIMMs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      64,
      67,
      65,
      71
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 125,
    "question": "You have a user who needs to keep desktop devices such as keyboard, monitor, and mouse permanently connected so that they can be used by an attached laptop. What type of device do you recommend that they use?",
    "choice_a": "Docking station",
    "choice_b": "Keyboard, video, mouse (KVM) switch",
    "choice_c": "Input/output virtual server",
    "choice_d": "USB hub",
    "correct_answer": "A",
    "explanation": "A docking station made specifically for its associated brand and model of laptop can host desktop components permanently, regardless of whether the laptop is attached to the docking station. When the laptop\u2019s portability is not required, but instead use of the desktop components is the priority, attaching the laptop to the docking station makes such components available to the laptop without separately attaching each component.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      71,
      70,
      68,
      69
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 126,
    "question": "The process by which the processor slows down to conserve power is officially called ____________.",
    "choice_a": "Underclocking",
    "choice_b": "Cooling",
    "choice_c": "Disengaging",
    "choice_d": "Throttling",
    "correct_answer": "D",
    "explanation": "The processor can reduce how fast it\u2019s working, which is called throttling, to help conserve battery life. CPUs do not perform underclocking, cooling, or disengaging.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      67,
      64,
      71,
      68,
      69
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 127,
    "question": "You need to replace a failed AC adapter for a client\u2019s laptop. When replacing the adapter, which of the following purchases is acceptable to obtain the same or better results?",
    "choice_a": "An AC adapter with a higher voltage rating than the original",
    "choice_b": "An AC adapter with a higher wattage rating than the original",
    "choice_c": "A DC adapter with the same voltage rating as the original",
    "choice_d": "An AC adapter with a lower voltage and wattage rating than the original",
    "correct_answer": "B",
    "explanation": "Think of wattage as a \u201cbucket\u201d of power that the attached device can draw from. A bigger bucket simply holds more power but does not force the power on the device. Less wattage is not advised, however. Voltage can be thought of as the pressure behind the power to the device. Anything but the proper voltage is dangerous for the device. When you replace a laptop\u2019s AC adapter, you should match the voltage ratings of the original adapter. This also means that you should use an adapter with a fixed voltage if that matches the characteristics of the original; otherwise, obtain one that automatically switches voltages at the levels needed.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      71,
      65,
      64,
      67,
      68
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 128,
    "question": "What should you do for a Li-ion battery that appears to charge fully but does not last as long as the battery\u2019s meter indicates that it will last?",
    "choice_a": "Replace the battery.",
    "choice_b": "Exercise the battery.",
    "choice_c": "Calibrate the battery.",
    "choice_d": "Short the terminals to discharge the battery.",
    "correct_answer": "C",
    "explanation": "Battery calibration for Li-ion batteries allows the powered device to drain the battery\u2019s power before recharging. Battery exercising is the initial charging and discharging of nickel-based batteries so that they will function as expected. You should never short a battery\u2019s terminals, and replacement is a last resort, used when any battery has reached the end of its life.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      71,
      64,
      67,
      68,
      69
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 129,
    "question": "You are giving a seminar to new technicians on replacing laptop hard drives. A student asks how do laptop hard drives differ from desktop hard drives. What do you tell them?",
    "choice_a": "Laptop hard drives use completely different standards from those used by desktop hard drives for communication with the host.",
    "choice_b": "Laptop hard drives are solid-state, whereas desktop hard drives have spinning platters.",
    "choice_c": "Laptop hard drives require a separate power connection, whereas desktop hard drives are powered through the drive interface.",
    "choice_d": "The most common form factors for laptop hard drives is smaller than that of a desktop hard drive.",
    "correct_answer": "D",
    "explanation": "Laptop hard drives commonly have a 2\u00bd form factor, and smaller drives, such as M.2, are becoming more popular. The most common form factor for desktop hard drives is 3\u00bd. Laptop hard drives use the same drive technologies as their desktop counterparts, such as SATA. As with desktop hard drives, laptop hard drives are available in both solid-state and conventional varieties. Unlike desktop hard drives, laptop hard drives do not have separate power connectors.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      69,
      64,
      72,
      71,
      68
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 130,
    "question": "One of your network users has an older laptop with no Bluetooth support. He recently received a Bluetooth headset that he needs to use with his laptop. What is the quickest and cheapest way to make the headset compatible with his laptop?",
    "choice_a": "Buy a Wi-Fi\u2013compatible headset.",
    "choice_b": "Buy a USB Bluetooth adapter.",
    "choice_c": "Buy a Mini PCIe Bluetooth adapter.",
    "choice_d": "Replace the laptop.",
    "correct_answer": "B",
    "explanation": "A USB Bluetooth adapter should do the trick. There are Mini PCIe Bluetooth adapters, but installing one is trickier than inserting a USB device. There aren\u2019t really any Wi-Fi compatible headsets on the market\u2014headsets are exactly what Bluetooth was designed for. Replacing the laptop is a much more expensive proposition.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      71,
      64,
      65,
      159,
      162
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 131,
    "question": "A user wants her laptop to have a full-sized optical drive and external hard drive. Which of the following accessories is most likely to have full-sized bays for these devices?",
    "choice_a": "Laptop base",
    "choice_b": "Port replicator",
    "choice_c": "Docking station",
    "choice_d": "Mini PCIe dock",
    "correct_answer": "C",
    "explanation": "A docking station is a device that a laptop can be plugged into that replicates common laptop ports, and may also have full-sized bays for PC desktop expansion cards and storage devices, such as hard drives and optical drives. A port replicator will replicate laptop ports but does not usually have expansion bays. There is no specific laptop base accessory or a Mini PCIe dock. (Mini PCIe is an internal laptop technology.).",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      64,
      71,
      69,
      65,
      68
    ],
    "source": "330034_Vol1_Ch04"
  },
  {
    "id": 132,
    "question": "A user has a printer attached to their computer. They configured the printer so other users on the network can print to it. What does that make their computer?",
    "choice_a": "Print server",
    "choice_b": "Printer share",
    "choice_c": "Network scan service",
    "choice_d": "ADF",
    "correct_answer": "A",
    "explanation": "If a user shares their printer on a network, their computer becomes a print server. The shared printer itself is the printer share. It\u2019s possible other users could use the device as a network scan service but that\u2019s not specified. An automatic document feeder (ADF) is a physical feature of some MFDs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      93,
      90,
      95,
      89
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 133,
    "question": "Which types of printers are referred to as page printers because they receive their print job instructions one page at a time? (Choose two.)",
    "choice_a": "Impact",
    "choice_b": "Inkjet",
    "choice_c": "Laser",
    "choice_d": "Thermal",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A page printer is a type of computer printer that prints a page at a time. Common types of page printers are the inkjet printer and the laser printer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      74,
      76,
      79,
      80,
      73
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 134,
    "question": "Which of the following is not an advantage of a Universal Serial Bus (USB) printer interface?",
    "choice_a": "It has a higher transfer rate than a serial connection.",
    "choice_b": "It has a higher transfer rate than a parallel connection.",
    "choice_c": "It automatically recognizes new devices.",
    "choice_d": "It allows the printer to communicate with networks, servers, and workstations.",
    "correct_answer": "D",
    "explanation": "The rate of transfer and the ability to recognize new devices automatically are two of the major advantages that currently make USB the most popular type of printer interface. However, it is the network printer interface that allows the printer to communicate with networks, servers, and workstations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      93,
      57,
      89,
      91
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 135,
    "question": "You have a finance manager who needs to print contracts in triplicate. Which type of printers are best for printing on multipart forms?",
    "choice_a": "Inkjet printers",
    "choice_b": "Laser printers",
    "choice_c": "Thermal printers",
    "choice_d": "Dot-matrix printers",
    "correct_answer": "D",
    "explanation": "Dot-matrix printers are impact printers and therefore are the best for multipart forms. Daisy-wheel printers can be used with multipart forms as well.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      73,
      89,
      90,
      92,
      94
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 136,
    "question": "Which step in the EP imaging process uses a laser to discharge selected areas of the photosensitive drum, thus forming an image on the drum?",
    "choice_a": "Exposing",
    "choice_b": "Transferring",
    "choice_c": "Developing",
    "choice_d": "Cleaning",
    "correct_answer": "A",
    "explanation": "The exposing step uses a laser to discharge selected areas of the photosensitive drum, thus forming an image on the drum.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      80,
      77,
      79,
      78,
      81
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 137,
    "question": "Which of the following is a type of device that lets users scan in 10-page double-sided documents all at once?",
    "choice_a": "SMB",
    "choice_b": "MFD",
    "choice_c": "ADF",
    "choice_d": "Flatbed",
    "correct_answer": "C",
    "explanation": "An automatic document feeder (ADF) allows users to put multiple pieces of paper into it, and scan them in all as one job. SMB is used with network scan services to scan to a folder. An MFD is another name for a printer/scanner combination device. Flatbed scanners only allow for one piece of paper at a time.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      95,
      92,
      75,
      74,
      73
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 138,
    "question": "Recently, employees have printed off unauthorized materials which may contain prohibited hate speech. Which of the following can be used to see which users printed specific jobs?",
    "choice_a": "Audit logs",
    "choice_b": "Badging",
    "choice_c": "User authentication",
    "choice_d": "Secured prints",
    "correct_answer": "A",
    "explanation": "Audit logs will track print jobs and the users who printed them. User authentication is where a user is required to log into the printer. This can be done via badging\u2014or swiping an employee badge on a badge reader on the printer\u2014or by manually entering credentials. Secured prints is when a print job is held until a user authenticates at the printer and tells it to start printing.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      94,
      92,
      93,
      91,
      90
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 139,
    "question": "Which device in an inkjet printer contains the printhead?",
    "choice_a": "Toner cartridge",
    "choice_b": "Ink cartridge",
    "choice_c": "Daisy wheel",
    "choice_d": "Paper tray",
    "correct_answer": "B",
    "explanation": "In an inkjet printer, the ink cartridge is the actual printhead. This is where the ink is expelled to form letters or graphics. Toner cartridges are used by laser printers to store toner. A daisy wheel is the device that impacts the letters on the paper in a daisy-wheel printer. Paper trays are the storage bins in laser printers and inkjet printers that allow the pickup rollers to feed the paper into the printer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      74,
      96,
      77,
      73,
      76
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 140,
    "question": "What is the correct order of the steps in the EP imaging process?",
    "choice_a": "Developing, exposing, transferring, fusing, charging, cleaning, processing",
    "choice_b": "Charging, processing, exposing, developing, transferring, fusing, cleaning",
    "choice_c": "Processing, transferring, exposing, developing, charging, cleaning, fusing",
    "choice_d": "Processing, charging, exposing, developing, transferring, fusing, cleaning",
    "correct_answer": "D",
    "explanation": "The correct sequence in the EP imaging process is processing, charging, exposing, developing, transferring, fusing, and cleaning.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      80,
      79,
      77,
      76,
      89
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 141,
    "question": "The network administrator has set up security on office MFDs that requires users to authenticate before printing. Which of the following are valid methods for users to authenticate to the MFD? (Choose two.)",
    "choice_a": "Use an authentication log.",
    "choice_b": "Enable secured print.",
    "choice_c": "Type their username and password on the MFD\u2019s touchscreen.",
    "choice_d": "Use SMB.",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Two ways for users to authenticate are to use user authentication (which requires typing in the username and password) or badging, which requires the MFD to have a badge scanning feature. Secured print will save print jobs until they are ready to be released. SMB is a file and print sharing protocol used by MFDs to send scanned documents to a shared network folder. There are no printer authentication logs, but audit logs may be used to see who has used the MFD.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      90,
      95,
      89
    ],
    "source": "330034_Vol1_Ch05",
    "choice_e": "Use their company ID for badging."
  },
  {
    "id": 142,
    "question": "What is typically included in the EP laser printer toner cartridge? (Choose three.)",
    "choice_a": "Toner",
    "choice_b": "Print drum",
    "choice_c": "Laser",
    "choice_d": "Cleaning blade",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "An electrophotographic (EP) laser printer toner cartridge includes the toner, print drum, and cleaning blade. The laser is usually contained within the printer, not within the toner cartridge.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      77,
      80,
      78,
      79,
      96
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 143,
    "question": "What happens during the developing stage of laser printing?",
    "choice_a": "An electrostatic charge is applied to the drum to attract toner particles.",
    "choice_b": "Heat is applied to the paper to melt the toner.",
    "choice_c": "The laser creates an image of the page on the drum.",
    "choice_d": "An electrostatic charge is applied to the paper to attract toner particles.",
    "correct_answer": "A",
    "explanation": "After a laser has created an image of the page, the developing roller uses a magnet and electrostatic charges to attract toner to itself and then transfers the toner to the areas on the drum that have been exposed to the laser. The toner is melted during the fusing stage. The laser creates an image of the page on the drum in the exposing stage. An electrostatic charge is applied to the paper to attract toner in the transferring stage, which happens immediately after the developing stage.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      80,
      77,
      79,
      78,
      96
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 144,
    "question": "Which of the following are possible interfaces for printers? (Choose three.)",
    "choice_a": "Parallel",
    "choice_b": "SATA",
    "choice_c": "USB",
    "choice_d": "Network",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Printers can communicate via parallel, serial, USB, wireless, and network (Ethernet) connections. SATA is a bus interface that connects host bus adapters to storage devices such as hard drives and optical drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      93,
      62,
      58,
      76
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 145,
    "question": "You have just installed a new printer, but it prints only garbled text. Which of the following is most likely the problem?",
    "choice_a": "Wrong IP address",
    "choice_b": "Worn printhead",
    "choice_c": "Incorrect printer drivers",
    "choice_d": "Unsupported printer",
    "correct_answer": "C",
    "explanation": "If a printer is using out-of-date or incorrect printer drivers, the printer may produce pages of garbled text. The solution is to ensure that the most recent printer drivers are downloaded from the manufacturer\u2019s website.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      91,
      92,
      90,
      96,
      89
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 146,
    "question": "Which printer contains a wheel that looks like a flower with raised letters and symbols on each \u201cpetal\u201d?",
    "choice_a": "Inkjet printer",
    "choice_b": "Daisy-wheel printer",
    "choice_c": "Dot-matrix printer",
    "choice_d": "Laser printer",
    "correct_answer": "B",
    "explanation": "The daisy-wheel printer gets its name because it contains a wheel with raised letters and symbols on each \u201cpetal.\u201d.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      96,
      89,
      91
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 147,
    "question": "What part of a laser printer supplies the voltages for charging and transferring corona assemblies?",
    "choice_a": "High-voltage power supply (HVPS)",
    "choice_b": "DC power supply (DCPS)",
    "choice_c": "Controller circuitry",
    "choice_d": "Transfer corona",
    "correct_answer": "A",
    "explanation": "The high-voltage power supply (HVPS) is the part of the laser printer that supplies the voltages for charging and transferring corona assemblies.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      78,
      80,
      79,
      77,
      76
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 148,
    "question": "Which printer part gets the toner from the photosensitive drum onto the paper?",
    "choice_a": "Laser-scanning assembly",
    "choice_b": "Fusing assembly",
    "choice_c": "Corona assembly",
    "choice_d": "Drum",
    "correct_answer": "C",
    "explanation": "The transfer corona assembly gets the toner from the photosensitive drum onto the paper. For some printers, this is a transfer corona wire; for other printers, it is a transfer corona roller.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      79,
      80,
      77,
      96,
      89
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 149,
    "question": "Which step in the laser printer printing process occurs immediately after the exposing phase?",
    "choice_a": "Charging",
    "choice_b": "Fusing",
    "choice_c": "Transferring",
    "choice_d": "Developing",
    "correct_answer": "D",
    "explanation": "Developing happens after exposing. The correct order is processing, charging, exposing, developing, transferring, fusing, and cleaning.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      80,
      77,
      79,
      78,
      96
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 150,
    "question": "Which laser printer component permanently presses the toner into the paper?",
    "choice_a": "Transfer corona",
    "choice_b": "Fuser assembly",
    "choice_c": "Printer controller circuitry",
    "choice_d": "Paper transport assembly",
    "correct_answer": "B",
    "explanation": "The fuser assembly presses and melts the toner into the paper. The transfer corona transfers the toner from the drum to the paper. The printer controller circuitry converts signals from the PC into signals for the various printer assemblies. The paper transport assembly controls the movement of the paper through the printer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      79,
      80,
      77,
      78,
      96
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 151,
    "question": "Which of the following most accurately describes how to obtain a firmware upgrade for your laser printer?",
    "choice_a": "Download the firmware upgrade for free from the manufacturer\u2019s website.",
    "choice_b": "Pay to download the firmware upgrade from the manufacturer\u2019s website.",
    "choice_c": "Have a certified laser printer technician come to your site and install a new firmware chip.",
    "choice_d": "Contact the manufacturer of the printer, and they will send you the firmware upgrade on an SSD.",
    "correct_answer": "A",
    "explanation": "Firmware upgrades for laser printers are downloaded for free from the manufacturer\u2019s website. A technician does not need to install a new chip, because firmware is upgraded via software. It\u2019s unlikely that the manufacturer will send you the upgrade on an SSD; it will refer you to its website to download it.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      91,
      5,
      89,
      93,
      77
    ],
    "source": "330034_Vol1_Ch05"
  },
  {
    "id": 152,
    "question": "The answers to the chapter review questions can be found in Appendix A.<br>1.____________________ is immune to electromagnetic or radio-frequency interference.",
    "choice_a": "Twisted pair cabling",
    "choice_b": "CSMA/CD",
    "choice_c": "Broadband coaxial cabling",
    "choice_d": "Fiber-optic cabling",
    "correct_answer": "D",
    "explanation": "Companies that want to ensure the safety and integrity of their data should use fiber-optic cable because it is not affected by electromagnetic or radio-frequency interference. Even though some copper cables have shielding, they are not immune to EMI or RFI. This eliminates twisted pair and coaxial. CSMA/CD is an access method, not a cable type.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      113,
      110,
      111,
      107,
      106
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 153,
    "question": "Which of the following is a type of connector used with coaxial cable?",
    "choice_a": "RJ11",
    "choice_b": "RJ45",
    "choice_c": "F-type",
    "choice_d": "SC",
    "correct_answer": "C",
    "explanation": "Coaxial cable can use BNC connectors and F-type connectors. RJ11 and RJ45 are twisted pair connectors. SC is a fiber-optic connector.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      110,
      116,
      112,
      113,
      148
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 154,
    "question": "You need to put a connector on the end of an Ethernet crossover cable. The existing end has a white and green colored wire at pin 1. What color do you need to make pin 1 on the new end?",
    "choice_a": "White/green",
    "choice_b": "Green",
    "choice_c": "White/orange",
    "choice_d": "Orange",
    "correct_answer": "C",
    "explanation": "A crossover cable will flip pins 1 and 3 on each end. Therefore, this end needs to have the white/orange wire as pin 1. The correct order for this cable should be white/orange, orange, white/green, blue, white/blue, green, white/brown, brown.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      116,
      111,
      115,
      108
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 155,
    "question": "___________________ is the type of media access method used by NICs that listen to or sense the cable to check for traffic and send only when they hear that no one else is transmitting.",
    "choice_a": "T568A/T568B",
    "choice_b": "CSMA/CD",
    "choice_c": "CSMA/CA",
    "choice_d": "Demand priority",
    "correct_answer": "B",
    "explanation": "Carrier Sense Multiple Access with Collision Detection (CSMA/CD) specifies that the NIC pause before transmitting a packet to ensure that the line is not being used. If no activity is detected, then it transmits the packet. If activity is detected, it waits until it is clear. In the case of two NICs transmitting at the same time (a collision), both NICs pause to detect and then retransmit the data. CSMA/CA listens to the line as well but tries to avoid collisions. T568A/T568B are twisted pair wiring standards. Demand priority is a media access method, but we didn\u2019t discuss it at all in the chapter as it\u2019s not related to the A+ exam. It\u2019s used with a standard called 100BaseVG.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      107,
      108,
      106,
      111,
      112
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 156,
    "question": "What is the lowest grade of UTP that is rated for 100 Mbps transmission?",
    "choice_a": "Cat 5",
    "choice_b": "Cat 5e",
    "choice_c": "Cat 6",
    "choice_d": "Cat 6a",
    "correct_answer": "A",
    "explanation": "Cat 5 was the first UTP standard ratified for 100 Mbps transmissions. Before that, Cat 3 was popular but only supported 10 Mbps. Cat 5e, Cat 6, and Cat 6a all support at least 1 Gbps and came after Cat 5.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      111,
      146,
      108,
      105,
      99
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 157,
    "question": "An administrator needs to run a network cable between two buildings that are about 150 yards apart on a campus. Company regulations say the cable must be underground. What type of cable should the administrator use?",
    "choice_a": "Fiber-optic",
    "choice_b": "STP",
    "choice_c": "Plenum",
    "choice_d": "Direct burial",
    "correct_answer": "D",
    "explanation": "Direct burial cable is designed to be buried underground, as its name implies. Direct burial can be fiber-optic or copper. Plenum cable is used for cables run through spaces that circulate breathable air inside a building.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      111,
      113,
      110,
      146,
      101
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 158,
    "question": "Of all the network cabling options, ___________________ offers the longest possible segment length.",
    "choice_a": "Unshielded twisted pair",
    "choice_b": "Coaxial",
    "choice_c": "SMF",
    "choice_d": "MMF",
    "correct_answer": "C",
    "explanation": "Fiber-optic cable can span distances of several kilometers because it has much lower attenuation, crosstalk, and interference as compared to copper cables. Single-mode fiber (SMF) can run longer distances than multimode fiber (MMF).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      113,
      110,
      146,
      112,
      148
    ],
    "source": "330034_Vol1_Ch06",
    "choice_e": "Shielded twisted pair"
  },
  {
    "id": 159,
    "question": "What devices transfer packets across multiple networks and use tables to store network addresses to determine the best destination?",
    "choice_a": "Routers",
    "choice_b": "Firewalls",
    "choice_c": "Hubs",
    "choice_d": "Switches",
    "correct_answer": "A",
    "explanation": "Routers are designed to route (transfer) packets across networks. They are able to do this routing, determining the best path to take, based on the internal routing tables that they maintain.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      118,
      122,
      106,
      117
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 160,
    "question": "Which of the following networking hardware devices is capable of creating VLANs?",
    "choice_a": "Firewall",
    "choice_b": "Patch panel",
    "choice_c": "Unmanaged switch",
    "choice_d": "Managed switch",
    "correct_answer": "D",
    "explanation": "A managed switch can create virtual LANs (VLANs) using its management software. A firewall is a hardware or software solution that serves as your network\u2019s security guard. Patch panels and unmanaged switches cannot create VLANs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      114,
      115,
      107,
      108
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 161,
    "question": "Which of the following wireless communication standards is often described in terms of a wireless personal area network?",
    "choice_a": "Bluetooth",
    "choice_b": "Infrared",
    "choice_c": "Cellular",
    "choice_d": "Ethernet",
    "correct_answer": "A",
    "explanation": "Bluetooth networks are often called wireless personal area networks (WPANs).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      145,
      99,
      102,
      101
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 162,
    "question": "Your ISP has just finished running fiber-optic cable in your neighborhood, and you want to switch from cable Internet to a faster fiber-optic connection. Which of the following statements is true about how you will get an Internet connection?",
    "choice_a": "You will continue to use your cable modem.",
    "choice_b": "You need to switch to using a DSL modem.",
    "choice_c": "You need to switch to using an ONT.",
    "choice_d": "You need to switch to using PoE.",
    "correct_answer": "C",
    "explanation": "Fiber-optic Internet connections use an optical network terminal (ONT) to terminate the fiber and translate it into a digital connection over copper cable inside your home. A cable modem and DSL modem connect copper to copper. Power over Ethernet (PoE) is not relevant in this situation.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      149,
      148,
      156,
      147,
      110
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 163,
    "question": "If you are going to run a network cable in the space above the drop ceiling in your office, which type of cable should you use?",
    "choice_a": "Plenum",
    "choice_b": "PVC",
    "choice_c": "Coaxial",
    "choice_d": "Fiber-optic",
    "correct_answer": "A",
    "explanation": "For areas where a cable must be fire retardant, such as in a drop ceiling, you must run plenum-grade cable. Plenum refers to the coating on the sleeve of the cable, not the copper or fiber within the cable itself. PVC is the other type of coating typically found on network cables, but it produces poisonous gas when burned. Direct burial cables are designed to be buried underground.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      111,
      110,
      113,
      146,
      116
    ],
    "source": "330034_Vol1_Ch06",
    "choice_e": "Direct burial"
  },
  {
    "id": 164,
    "question": "Which of the following connector types is an MFF connector?",
    "choice_a": "BNC",
    "choice_b": "ST",
    "choice_c": "SC",
    "choice_d": "LC",
    "correct_answer": "D",
    "explanation": "The local connector (LC) is a mini form factor (MFF) fiber-optic connector developed by Lucent Technologies. If it helps, think of LC as \u201cLittle Connector.\u201d.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      113,
      116,
      106,
      108,
      105
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 165,
    "question": "What Ethernet specification would you be running if you needed to make a connection of 10 Gbps over a distance of five kilometers?",
    "choice_a": "10GBaseER",
    "choice_b": "10GBaseT",
    "choice_c": "10GBaseSR",
    "choice_d": "10GBaseDR",
    "correct_answer": "A",
    "explanation": "If you need to make a connection that is 5 kilometers long, then you are limited to fiber-optic cable, specifically single-mode fiber (SMF). Two common SMF standards are 10GBaseER and 10GBaseEW. (Think of the <i>E</i> as <i>extended</i>.) A <i>T</i> designation is an Ethernet standard that refers to twisted pair. SR (short reach) and DR (distance reach) are fiber standards that do not stretch for 5 kilometers.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      113,
      107,
      108,
      116,
      146
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 166,
    "question": "Which of the following are advantages to using a SAN? (Choose two.)",
    "choice_a": "More storage space on the network",
    "choice_b": "More efficient data storage",
    "choice_c": "Faster data access",
    "choice_d": "Automated data backups",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Storage area networks (SANs) have many advantages, including block-level data storage, which is more efficient. They also reduce network loads, provide faster data access, and area easily expandable. They do not inherently provide more storage space (although they are easy to expand) or do automated data backups (although they are easier to set up).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      101,
      99,
      114,
      105,
      102
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 167,
    "question": "Which type of fiber-optic cable connector uses a twist to lock mechanism to secure the cable in place?",
    "choice_a": "BNC",
    "choice_b": "SC",
    "choice_c": "ST",
    "choice_d": "LC",
    "correct_answer": "C",
    "explanation": "A straight tip (ST) connector uses a twist to lock mechanism. BNC twists to lock as well, but it\u2019s for copper cable. SC and LC snap to lock into place.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      113,
      110,
      116,
      112,
      111
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 168,
    "question": "What type of device will block unwanted traffic from your network using a set of rules called an ACL?",
    "choice_a": "Router",
    "choice_b": "Firewall",
    "choice_c": "Switch",
    "choice_d": "NAS",
    "correct_answer": "B",
    "explanation": "The job of a firewall is to block unwanted network traffic. Firewalls do this by using a list of rules called an access control list (ACL). Routers connect networks to each other, and switches are central connectivity points for networks. A network attached storage (NAS) device is like a dedicated file server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      155,
      114,
      125,
      135,
      126
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 169,
    "question": "What type of coaxial cable is recommended for digital television cable signals?",
    "choice_a": "RG-6",
    "choice_b": "RG-8",
    "choice_c": "RG-58",
    "choice_d": "RG-59",
    "correct_answer": "A",
    "explanation": "The two RG standards used for cable television are RG-6 and RG-59. Of the two, RG6 is better because it can run longer distances and can handle digital signals. RG-59 is for analog signals only. RG-8 is thicknet coax, and RG-58 is thinnet coax.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      110,
      116,
      148,
      113,
      111
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 170,
    "question": "Which type of device works with MAC addresses to determine what to do with network traffic?",
    "choice_a": "Hub",
    "choice_b": "Router",
    "choice_c": "Patch panel",
    "choice_d": "Switch",
    "correct_answer": "D",
    "explanation": "A switch works at Layer 2; therefore, it works with hardware (MAC) addresses. Hubs and patch panels work at Layer 1 and deal with bits, and routers work at Layer 3 and work with logical IP addresses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      106,
      108,
      117,
      107
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 171,
    "question": "Which type of networking device uses bare wires for attachments rather than a connector?",
    "choice_a": "Patch panel",
    "choice_b": "Punchdown block",
    "choice_c": "PoE injector",
    "choice_d": "Access point",
    "correct_answer": "B",
    "explanation": "A punchdown block connects bare wires to its frame to make a network connection. There are no other cable connectors used on that end of the cable. A patch panel uses RJ45 or other connectors, as does a PoE injector. Access points are wireless and therefore don\u2019t use wires.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      116,
      112,
      115,
      110,
      113
    ],
    "source": "330034_Vol1_Ch06"
  },
  {
    "id": 172,
    "question": "You are setting up clients to use the new corporate VPN. The VPN will encrypt all data in transit between employees who work from home and the corporate office. Which protocol will secure the VPN?",
    "choice_a": "HTTPS",
    "choice_b": "IPSec",
    "choice_c": "TLS",
    "choice_d": "SSL",
    "correct_answer": "B",
    "explanation": "IPSec is the only one of the protocols listed that works at OSI layer 3, and therefore the only one that can encrypt all communications. HTTPS uses TLS or SSL, which operate at OSI Layer 7.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      126,
      106,
      117,
      119,
      121
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 173,
    "question": "Which of the following protocols was designed to access information stored in an information directory, such as employee phonebooks?",
    "choice_a": "FTP",
    "choice_b": "LDAP",
    "choice_c": "RDP",
    "choice_d": "CIFS",
    "correct_answer": "B",
    "explanation": "Lightweight Directory Access Protocol (LDAP) is designed to access information stored in an information directory typically known as an LDAP directory or LDAP database. This typically includes employee data and network configuration data. FTP is designed to transfer files. RDP is a remote desktop protocol, and CIFS is used to share files and printers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      131,
      106,
      119
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 174,
    "question": "Which TCP/IP protocol uses port 80?",
    "choice_a": "HTTP",
    "choice_b": "HTTPS",
    "choice_c": "Telnet",
    "choice_d": "POP3",
    "correct_answer": "A",
    "explanation": "HTTP uses port 80. HTTPS uses port 443; Telnet uses port 23; and POP3 uses port 110.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      121,
      120,
      128,
      117,
      119
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 175,
    "question": "What is the maximum number of IPv6 addresses that can be assigned to one IPv6 interface?",
    "choice_a": "One (unicast)",
    "choice_b": "Two (unicast and anycast)",
    "choice_c": "Three (unicast, anycast, and multicast)",
    "choice_d": "None of the above",
    "correct_answer": "D",
    "explanation": "An IPv6 interface is not limited in the number of addresses that can be assigned, although there could be limitations based on practicality.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      118,
      117,
      124,
      106,
      109
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 176,
    "question": "Which of the following are valid examples of IPv6 addresses? (Choose all that apply.)",
    "choice_a": "2001:0db8:3c4d:0012:0000:0000:1234:56ab",
    "choice_b": "::ffff:c0a8:173",
    "choice_c": "2001:db8:3c4d:12::1234:56ab",
    "choice_d": "2001::1ab4::5468",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "An IPv6 address contains 128 bits, written in eight 16-bit fields represented by four hexadecimal digits. Option A contains all eight fields expressed in full. Option B is an IPv4 address expressed in IPv6 form. Option C is the same address as option A, but written in accepted shorthand. Option D is not valid because the double colons (::) can be used only once within an IPv6 address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      124,
      126,
      117,
      121
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 177,
    "question": "Which of the following IP addresses would not be valid for a DNS server on the Internet?",
    "choice_a": "10.25.11.33",
    "choice_b": "18.33.66.254",
    "choice_c": "155.118.63.11",
    "choice_d": "192.186.12.2",
    "correct_answer": "A",
    "explanation": "DNS servers resolve hostnames to IP addresses. On the Internet, a DNS server needs to have a public IP address. The address 10.25.11.33 is in a private address space, so that address would not be valid for a DNS server on the Internet.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      129,
      121,
      122,
      123
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 178,
    "question": "The workstations on your network are configured to use a DHCP server. One of the workstations can\u2019t communicate with other computers. Its IP address is 169.254.1.18. What could be the problem?",
    "choice_a": "The subnet mask is wrong.",
    "choice_b": "It has a private IP address.",
    "choice_c": "The default gateway is wrong.",
    "choice_d": "It can\u2019t reach the DHCP server.",
    "correct_answer": "D",
    "explanation": "The address assigned to the computer is an APIPA address. Microsoft client computers (and others) will configure themselves with an address in this range if they are unable to reach a DHCP server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      122,
      124,
      108
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 179,
    "question": "Which of the following protocols is responsible for sending email?",
    "choice_a": "IMAP4",
    "choice_b": "POP3",
    "choice_c": "SMTP",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "Simple Mail Transfer Protocol (SMTP) is responsible for sending email. IMAP4 and POP3 both receive email. SNMP is a network management protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      117,
      106,
      128
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 180,
    "question": "What port does the RDP protocol work on?",
    "choice_a": "53",
    "choice_b": "143",
    "choice_c": "389",
    "choice_d": "3389",
    "correct_answer": "D",
    "explanation": "Remote Desktop Protocol (RDP) works on port 3389. DNS works on port 53; IMAP4 works on port 143; and LDAP works on port 389.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      120,
      121,
      119,
      117
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 181,
    "question": "Which of the following solutions can help reduce broadcast traffic received by TCP/IP-based computers on a network?",
    "choice_a": "DNS",
    "choice_b": "DHCP",
    "choice_c": "VPN",
    "choice_d": "VLAN",
    "correct_answer": "D",
    "explanation": "A VLAN is a virtual LAN configured on a switch, and breaks logical networks into smaller broadcast domains, reducing the number of broadcasts each computer will receive. DNS resolves hostnames to IP addresses. DHCP assigns IP configuration information. A VPN is a virtual private network over a public Internet connection.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      125,
      121,
      114,
      130,
      129
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 182,
    "question": "What are advantages that TCP has over UDP? (Choose two.)",
    "choice_a": "Acknowledged delivery",
    "choice_b": "Faster delivery",
    "choice_c": "Lower overhead",
    "choice_d": "Virtual circuits",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "TCP is a connection-oriented protocol that establishes virtual circuits and acknowledges delivery of packets. Because of these features, it has higher overhead than UDP and is a little slower.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      117,
      128,
      118,
      114
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 183,
    "question": "Your friend is concerned about the security of making an online purchase. What should you tell her to look for in the address bar of the web browser?",
    "choice_a": "HTTP",
    "choice_b": "HTTPS",
    "choice_c": "SSH",
    "choice_d": "TLS",
    "correct_answer": "B",
    "explanation": "The HTTP protocol is inherently unsecure, but the HTTPS protocol is secure. (SSH and TLS are secure as well, but they are not protocols used to connect to websites.).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      120,
      126,
      106,
      131
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 184,
    "question": "You are manually configuring a TCP/IP host. Another administrator gives you the router\u2019s IP address. What is the TCP/IP term for this?",
    "choice_a": "Default gateway",
    "choice_b": "Subnet mask",
    "choice_c": "DNS server",
    "choice_d": "DHCP server",
    "correct_answer": "A",
    "explanation": "The router is your doorway out into other networks, and it is known in TCP/IP terms as the default gateway. Without this configuration option, you would not be able to get to external networks. The subnet mask tells a host which network it\u2019s on. The DNS server resolves hostnames to IP addresses, and a DHCP server provides IP configuration information to hosts.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      121,
      114,
      119,
      123
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 185,
    "question": "Your network is running IPv4. Which of the configuration options are mandatory for your host to communicate on the network? (Choose all that apply.)",
    "choice_a": "IP address",
    "choice_b": "Subnet mask",
    "choice_c": "Default gateway",
    "choice_d": "DNS server address",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The only mandatory IPv4 configuration items are an IP address and a subnet mask. If you are not connecting to another network, you do not need a default gateway. DNS servers resolve hostnames to IP addresses, but they are not mandatory.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      121,
      130,
      118,
      124
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 186,
    "question": "Which of the following protocols is used for secure retrieval of email?",
    "choice_a": "SMTP",
    "choice_b": "LDAP",
    "choice_c": "POP3",
    "choice_d": "IMAP4",
    "correct_answer": "D",
    "explanation": "IMAP4 and POP3 are the two protocols that are used for email retrieval. Of the two, only IMAP4 provides security features. SMTP sends email. LDAP is a directory services protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      126,
      131,
      106
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 187,
    "question": "Which of the following is the name of a secure point-to-point connection made over a public network?",
    "choice_a": "NAT",
    "choice_b": "APIPA",
    "choice_c": "VLAN",
    "choice_d": "VPN",
    "correct_answer": "D",
    "explanation": "A virtual private network (VPN) is a secure point-to-point connection made over a public network. NAT translates private IP address to public IP addresses. APIPA is an automatic IP address assignment if a client computer can\u2019t reach a DHCP server. VLANs are virtual local area networks configured through switches.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      126,
      124,
      125,
      130,
      155
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 188,
    "question": "Which network protocol is used for file and printer sharing and which port does it use?",
    "choice_a": "CIFS, 445",
    "choice_b": "RDP, 3389",
    "choice_c": "CIFS, 3389",
    "choice_d": "RDP, 445",
    "correct_answer": "A",
    "explanation": "Common Internet File System (port 445) is used to share files and printers on a network. Remote Desktop Protocol (port 3389) is used for remote computer administration.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      120,
      215,
      119,
      103
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 189,
    "question": "Which of the following is an IPv6 broadcast address?",
    "choice_a": "::1",
    "choice_b": "FE80::",
    "choice_c": "FF00::",
    "choice_d": "::FFFF",
    "correct_answer": "E",
    "explanation": "IPv6 does not have broadcasts. IPv6 does have multicasts, which are a bit like targeted broadcasts. ::1 is the loopback address used for troubleshooting. FE80:: is the first part of a link local address. FF00:: is the first part of a multicast address. :FFFF will often be used as part of an IPv4 address designation (the IPv4 address will follow it).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      118,
      117,
      124,
      106,
      99
    ],
    "source": "330034_Vol1_Ch07",
    "choice_e": "None of the above"
  },
  {
    "id": 190,
    "question": "Which of the following protocols can help an application store and manage user information on the network?",
    "choice_a": "LDAP",
    "choice_b": "SMTP",
    "choice_c": "NetBT",
    "choice_d": "SMB",
    "correct_answer": "A",
    "explanation": "Lightweight Directory Access Protocol (LDAP, port 389) is the \u201cphonebook\u201d protocol of TCP/IP, helping manage user information. Simple Mail Transfer Protocol (SMTP, 25) is an email-sending protocol. NetBIOS over TCP/IP (NetBT, 137-139) allows computers to communicate with each other over the network using APIs. Server Message Block (SMB, 445) is a file- and printer-sharing protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      131,
      106,
      119
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 191,
    "question": "Which of the following protocols is responsible for resolving IP addresses to hardware addresses?",
    "choice_a": "DNS",
    "choice_b": "DHCP",
    "choice_c": "ARP",
    "choice_d": "RARP",
    "correct_answer": "C",
    "explanation": "The Address Resolution Protocol (ARP) resolves IP addresses to hardware (MAC) addresses. RARP does the reverse\u2014it resolves MAC addresses to IP addresses. DNS resolves hostnames to IP addresses. DHCP automatically configures TCP/IP clients.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      118,
      121,
      108,
      119,
      117
    ],
    "source": "330034_Vol1_Ch07"
  },
  {
    "id": 192,
    "question": "Your company hosts its own web server, and it allows consumers to make purchases via the server. The help line has been getting complaints that users are unable to access the website. You open the site from an internal workstation and it seems fine. What is the most likely cause?",
    "choice_a": "The firewall is blocking TCP port 23.",
    "choice_b": "The firewall is blocking TCP port 443.",
    "choice_c": "The security module of the web server is malfunctioning.",
    "choice_d": "The web server is down.",
    "correct_answer": "B",
    "explanation": "For secure transactions, the web server will be using HTTPS, which uses port 443. If the website works from an internal workstation, then the server is fine. It\u2019s most likely that the firewall is blocking inbound traffic on port 443. Port 23 is Telnet.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      155,
      128,
      121,
      119,
      120
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 193,
    "question": "Your manager wants you to install a networked Internet appliance that prevents network traffic\u2013based attacks and includes antimalware and antispam software. What should you install?",
    "choice_a": "Spam gateway",
    "choice_b": "Load balancer",
    "choice_c": "UTM",
    "choice_d": "Proxy server",
    "correct_answer": "C",
    "explanation": "It sounds like the manager wants a unified threat management (UTM) device. They are designed to be one-stop network protection devices. Spam gateways will help with spam email but not other malware. A load balancer spreads work around to multiple servers. A proxy server fulfills requests for clients.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      137,
      135,
      134,
      132,
      153
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 194,
    "question": "You are installing a file server for the accounting department. Where should this file server be located on the network?",
    "choice_a": "Outside of the firewall",
    "choice_b": "In the screened subnet",
    "choice_c": "In the secure network",
    "choice_d": "On the router",
    "correct_answer": "C",
    "explanation": "If the data on the server does not need to be accessed via the Internet, then the server should be in the most secure place possible, which is inside the firewall(s) in the secure network. The screened subnet is also behind a firewall, but by nature will be partially open to the outside world, so it\u2019s not as secure as the internal network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      137,
      131,
      146,
      135,
      124
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 195,
    "question": "Which of the following are services that a print server should provide? (Choose two.)",
    "choice_a": "Accepting print jobs from clients",
    "choice_b": "Turning off printers on demand",
    "choice_c": "Providing clients with the appropriate printer driver during installation",
    "choice_d": "Notifying users when the print job is complete",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Print servers should make printers available to clients and accept print jobs. They also process print jobs and manage print priorities. Finally, they provide client computers with the right print drivers when the clients attempt to install the printer. They do not turn printers off on demand nor provide notification that a job has printed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      103,
      215,
      120,
      106
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 196,
    "question": "Which type of server is responsible for preventing users from accessing websites with objectionable content?",
    "choice_a": "Proxy",
    "choice_b": "Web",
    "choice_c": "DHCP",
    "choice_d": "DNS",
    "correct_answer": "A",
    "explanation": "A proxy server can be configured to block access to websites that contain potentially dangerous or inflammatory material. Web servers host web pages, some of which may have objectionable content. DHCP servers provide clients with IP addresses, and DNS servers resolve host names to IP addresses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      135,
      129,
      130,
      121,
      137
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 197,
    "question": "What does a DHCP server need to be configured with to operate properly?",
    "choice_a": "DNS server",
    "choice_b": "Scope",
    "choice_c": "Range",
    "choice_d": "DHCP relay agent",
    "correct_answer": "B",
    "explanation": "Every DHCP server needs to have a scope, which is the range of addresses available to clients, as well as other options that it can give to client computers. A DHCP server can optionally provide clients with the address of a DNS server. There is no DHCP range. A DHCP relay agent is a system configured on a subnet with no DHCP server that relays DHCP requests to the DHCP server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      128,
      122,
      124
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 198,
    "question": "When configuring a DNS server, administrators must create which of the following?",
    "choice_a": "Zone file",
    "choice_b": "Hosts file",
    "choice_c": "Scope file",
    "choice_d": "DNS proxy",
    "correct_answer": "A",
    "explanation": "DNS server records are contained in the zone file, which must be configured by administrators. A hosts file is an alternative to using DNS (but that does not work well when scaling to the Internet). A scope is created on DHCP servers. There is no DNS proxy.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      121,
      130,
      119,
      106
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 199,
    "question": "You are configuring two email servers on your company\u2019s network. Which network protocol do the servers use to transfer mail to each other?",
    "choice_a": "POP3",
    "choice_b": "IMAP4",
    "choice_c": "SNMP",
    "choice_d": "SMTP",
    "correct_answer": "D",
    "explanation": "Simple Mail Transfer Protocol (SMTP) is used to transfer (send) email between servers. POP3 and IMAP4 are used to download (receive) email. SNMP is Simple Network Management Protocol and not related to email.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      117,
      119,
      106,
      128
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 200,
    "question": "You have five web servers that manage requests for online purchases. An administrator notices that one of the severs is always busy while another is idle, and the company is getting some online complaints about the slow website. Which of the following servers will help fix this?",
    "choice_a": "DNS",
    "choice_b": "DHCP",
    "choice_c": "Proxy",
    "choice_d": "Load balancer",
    "correct_answer": "D",
    "explanation": "A load balancer can spread the work around to multiple servers. It accepts the inbound request and then sends it to the most appropriate web server. DNS resolves host names to IP addresses. DHCP provides IP configuration information. A proxy makes requests (usually outbound) on behalf of clients.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      121,
      130,
      129,
      135
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 201,
    "question": "A computer using which of the following would be considered a legacy device? (Choose all that apply.)",
    "choice_a": "A 386 processor",
    "choice_b": "The IPX/SPX protocol",
    "choice_c": "An application developed in 1983",
    "choice_d": "1 GB of RAM",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Legacy systems are ones that use older hardware, software, or network protocols that are not commonly used today. A system with only 1 GB of RAM might be woefully underpowered, but that in and of itself does not make it a legacy system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      136,
      141,
      98,
      108,
      110
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 202,
    "question": "You are configuring a DHCP server for a small network with a network address of 192.168.1.0/24. You want the DHCP server to manage and assign all IP addresses and also want to ensure that there are 20 addresses available for servers, printers, and router interfaces. Which of the following is the best solution?",
    "choice_a": "Create a scope with addresses 192.168.1.1 to 192.168.1.200. Create an exclusion for addresses 192.168.1.1 to 192.168.1.20.",
    "choice_b": "Create a scope with addresses 192.168.1.1 to 192.168.1.200. Create a lease for addresses 192.168.1.1 to 192.168.1.20.",
    "choice_c": "Create a scope with addresses 192.168.1.21 to 192.168.1.200. Create an inclusion for addresses 192.168.1.1 to 192.168.1.20.",
    "choice_d": "Create a scope with addresses 192.168.1.1 to 192.168.1.200. Create reservations for addresses 192.168.1.1 to 192.168.1.20.",
    "correct_answer": "D",
    "explanation": "The best answer is to create a scope with the available addresses that the server will manage. Then, if you want the server to assign the same address each time to servers, printers, and router interfaces, create reservations for these addresses. An exclusion could work, but then you would have to manually assign addresses to those devices and the DHCP server wouldn\u2019t assign all addresses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      123,
      122,
      146
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 203,
    "question": "You\u2019re adding entries for new servers into the corporate DNS server and have IPv6 addresses for those servers. Which type of entries will you create?",
    "choice_a": "A",
    "choice_b": "CNAME",
    "choice_c": "AAAA",
    "choice_d": "TXT",
    "correct_answer": "C",
    "explanation": "IPv6 hosts have AAAA records in a DNS zone file. IPv4 addresses have A records. A CNAME record is an alias, and TXT is a text entry.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      121,
      122,
      124,
      118
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 204,
    "question": "An administrator sets up an NTP server on their local network. What is the purpose of an NTP server on the local network?",
    "choice_a": "To query national NTP servers to ensure all computers on the local network are set to the same time",
    "choice_b": "To provide the correct time to all computers on the local network",
    "choice_c": "To ensure all local computers have the same newsfeed",
    "choice_d": "To resolve SCADA control issues between compliant devices",
    "correct_answer": "B",
    "explanation": "The purpose of an NTP server is to provide the correct time to all computers (or devices) on a network. A local NTP server can query national severs but does not need to; it can function on its own. NTP has nothing to do with newsfeeds or SCADA.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      132,
      129,
      130,
      117,
      99
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 205,
    "question": "Company employees have recently started receiving large amounts of spam emails. Which of the following systems can help reduce the amount of spam received? (Choose all that apply.)",
    "choice_a": "UTM",
    "choice_b": "DMARC",
    "choice_c": "SCADA",
    "choice_d": "AAA",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Unified threat management (UTM) systems can include antispam capabilities. DMARC is a type of spam management inclusion into DNS zone files. SCADA refers to legacy hardware systems, and AAA is authentication, authorization, and accounting.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      135,
      136,
      131,
      121
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 206,
    "question": "A network administrator is updating features on an AAA server. Which aspect of that server deals specifically with determining which users get to access which network resources?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accounting",
    "choice_d": "All of the above",
    "correct_answer": "B",
    "explanation": "Authentication refers to verification of user identity. Authorization is the set of permissions a user has to access resources. Accounting is the tracking or logging of who accessed what resource.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      131,
      132,
      127,
      102,
      133
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 207,
    "question": "Which type of network service is responsible for collecting and tracking error messages generated by networked devices such as routers?",
    "choice_a": "AAA",
    "choice_b": "NTP",
    "choice_c": "Syslog",
    "choice_d": "UTM",
    "correct_answer": "C",
    "explanation": "A syslog server collects and tracks error messages sent from network devices such as routers. AAA is for authentication, authorization, and accounting. NTP is a time server. UTM is unified threat management, which is a security server or servers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      131,
      121,
      118,
      114
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 208,
    "question": "Which of the following is a term that refers to legacy industrial servers that control critical infrastructure?",
    "choice_a": "DKIM",
    "choice_b": "SPF",
    "choice_c": "DMARC",
    "choice_d": "SCADA",
    "correct_answer": "D",
    "explanation": "Supervisory control and data acquisition (SCADA) systems are legacy systems that often control public infrastructure. DKIM, SPF, and DMARC all deal with spam management.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      136,
      129,
      121,
      135,
      102
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 209,
    "question": "Your company has decided to set up its own DHCP server. How many DHCP servers is the company required to maintain?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "It depends on how many computers are on the network.",
    "correct_answer": "A",
    "explanation": "If a company wants to implement DHCP, it only needs one DHCP server. In fact, having more than one can cause administrative headaches if they are not configured properly. If a company wants to run their own DNS, they are required to have two DNS servers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      129,
      128,
      117
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 210,
    "question": "You just purchased an Alexa smart assistant. What type of service is this?",
    "choice_a": "UTM",
    "choice_b": "SCADA",
    "choice_c": "IoT",
    "choice_d": "AAA",
    "correct_answer": "C",
    "explanation": "Smart assistants are examples of Internet of Things (IoT) devices. UTM is unified threat management, which is a security service. SCADA refers to legacy hardware and software. AAA is authentication, authorization, and accounting.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      98,
      103,
      135,
      136,
      137
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 211,
    "question": "Which spam management capability authenticates email servers based on their IP addresses?",
    "choice_a": "SPF",
    "choice_b": "DKIM",
    "choice_c": "DMARC",
    "choice_d": "SCADA",
    "correct_answer": "A",
    "explanation": "Sender Policy Framework (SPF) is the simplest of the three DNS TXT record types that deals with spam management. It authenticates servers based on their IP address. DomainKeys Identified Mail (DKIM) authenticates servers using a public-private key pair. Domain-based Message Authentication, Reporting, and Conformance (DMARC) allows domains to decide what to do to emails that fail SPF or DKIM authentication. SCADA refers to legacy hardware and software.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      121,
      120,
      131,
      118
    ],
    "source": "330034_Vol1_Ch08"
  },
  {
    "id": 212,
    "question": "Which of the following legacy wireless IEEE standards operate on the 2.4 GHz radio frequency and are directly compatible with each other? (Choose two.)",
    "choice_a": "802.11a",
    "choice_b": "802.11b",
    "choice_c": "802.11ac",
    "choice_d": "802.11g",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Both 802.11b and 802.11g operate in the 2.4 GHz range and use similar transmission standards. Alternatively, 802.11a and 802.11ac operate in the 5 GHz range.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      138,
      140,
      139,
      107
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 213,
    "question": "What is the primary function of the SSID?",
    "choice_a": "To secure communication between a web server and a browser",
    "choice_b": "To secure communication between a server and a remote host",
    "choice_c": "To serve as a parameter used to identify a network and configure a wireless connection",
    "choice_d": "To serve as a type of password used to secure a wireless connection",
    "correct_answer": "C",
    "explanation": "A service-set identifier (SSID) is the unique name given to the wireless network. All hardware that is to participate on the network must be configured to use the same SSID. Essentially, it is the network name. When you are using Windows to connect to a wireless network, all available wireless networks will be listed by their SSID.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      152,
      102,
      138,
      139,
      154
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 214,
    "question": "Which of the following are features that allow 802.11ac to achieve higher data throughput? (Choose two.)",
    "choice_a": "MIMO",
    "choice_b": "Beamforming",
    "choice_c": "Channel bonding",
    "choice_d": "Code division multiplexing",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The two technologies that 802.11ac employs to achieve high throughput are channel bonding and MIMO. Channel bonding is the combination of multiple smaller channels into one large channel for greater bandwidth. MIMO is enhanced over 802.11n to allow for more multiple inputs and outputs. 802.11ac also uses beamforming, but that helps the range, not the throughput.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      142,
      143,
      144,
      138,
      141
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 215,
    "question": "What of the following is the most secure wireless encryption standard for 802.11 networks?",
    "choice_a": "WEP",
    "choice_b": "WPA",
    "choice_c": "WPA2",
    "choice_d": "WPA3",
    "correct_answer": "D",
    "explanation": "WEP was the original encryption standard developed for Wi-Fi networks, but it is easily hacked. WPA is an upgrade, but WPA2 is more secure and incorporates the entire 802.11i standard. WPA3 is of course the safest.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      153,
      107,
      138,
      139,
      140
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 216,
    "question": "You are upgrading a wireless network from Wi-Fi 5 over to Wi-Fi 6. Which of the following statements is <i>not</i> correct?",
    "choice_a": "Users should get faster speeds.",
    "choice_b": "Network range will be similar.",
    "choice_c": "Fewer users will be able to use each access point.",
    "choice_d": "Devices may have lower power usage while using the network.",
    "correct_answer": "C",
    "explanation": "Wi-Fi 6 is faster than Wi-Fi 5, and the network range is similar. More users should be able to access each access point, not fewer. Devices may have lower power usage in Wi-Fi 6 due to a new sleep feature.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      143,
      142,
      138,
      140,
      102
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 217,
    "question": "You have just installed a wireless router on your home network. Which of the following should you do to make it highly secure? (Choose all that apply.)",
    "choice_a": "Change the default administrator name and password.",
    "choice_b": "Change the SSID.",
    "choice_c": "Enable WEP.",
    "choice_d": "Configure it to channel 11.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "You should always change the default administrator name and password as well as the default SSID when installing a new wireless router. Enabling encryption is also a good idea, but WPA, WPA2, and WPA3 are better options than WEP. The channel has nothing to do with security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      153,
      152,
      156,
      138,
      154
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 218,
    "question": "You are setting up a small office network for a client. Which Internet service would you recommend to provide the best speed?",
    "choice_a": "DSL",
    "choice_b": "Cable",
    "choice_c": "Satellite",
    "choice_d": "Fiber",
    "correct_answer": "D",
    "explanation": "Of the options listed, fiber provides the best speed. DSL and cable provide similar speeds, but can\u2019t match fiber. Satellite will be the slowest of the options listed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      148,
      147,
      150,
      151
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 219,
    "question": "Which service allows users with private IP addresses to access the Internet using a public IP address?",
    "choice_a": "DHCP",
    "choice_b": "DNS",
    "choice_c": "DSL",
    "choice_d": "NAT",
    "correct_answer": "D",
    "explanation": "Network Address Translation (NAT) allows users to have a private IP address and still access the Internet with a public IP address. NAT is installed on a router and translates the private IP address into a public address for the user to access the Internet. DHCP assigns IP configuration information to clients. DNS resolves hostnames to IP addresses. DSL is a type of broadband Internet access.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      155,
      121,
      122,
      117
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 220,
    "question": "You are configuring a single 802.11g wireless network that has been having intermittent communications issues. The office space is large enough that it has three WAPs. What channels should you configure the WAPs on to avoid communication issues?",
    "choice_a": "2, 5, and 7",
    "choice_b": "1, 8, and 14",
    "choice_c": "1, 6, and 11",
    "choice_d": "3, 6, and 9",
    "correct_answer": "C",
    "explanation": "There are 14 communication channels in the 2.4 GHz range, but only the first 11 are configurable. The three nonoverlapping channels are 1, 6, and 11.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      139,
      154,
      141,
      138,
      152
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 221,
    "question": "You are setting up a wireless network. Which wireless standards would give the users over 1 Gbps throughput? (Choose all that apply.)",
    "choice_a": "802.11ac",
    "choice_b": "802.11be",
    "choice_c": "802.11g",
    "choice_d": "802.11n",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Two standards listed\u2014802.11be (46 Gbps) 802.11ac (6.9 Gbps)\u2014give users the required throughput. 802.11ax would do so as well, although it\u2019s not an option. The 802.11g (54 Mbps), and 802.11n (600 Mbps) standards are too slow.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      142,
      143,
      141,
      138
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 222,
    "question": "You have been asked to configure a network for a small office. The wireless router is installed, and now you need to connect the client computers. What do you enter on the client computers to connect to the router?",
    "choice_a": "The administrator password",
    "choice_b": "The security passphrase",
    "choice_c": "The client\u2019s MAC address",
    "choice_d": "The default router password",
    "correct_answer": "B",
    "explanation": "To join the network, client computers need to find the SSID, ensure that the security settings are correct (to match the router), and enter the security passphrase. As an administrator, you should have configured this passphrase to be different from the router\u2019s administrator password.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      153,
      152,
      108,
      103,
      130
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 223,
    "question": "Which of the following technologies can operate in the 125 kHz to 134 kHz range?",
    "choice_a": "Bluetooth",
    "choice_b": "RFID",
    "choice_c": "NFC",
    "choice_d": "LTE",
    "correct_answer": "B",
    "explanation": "Radio frequency identification (RFID) can operate in three frequency bands: 125 kHz to 134 kHz, 13.56 MHz, or 856 MHz to 960 MHz. Bluetooth is 2.4 GHz; NFC is 13.56 MHz; and LTE is between 600 MHz and 6 GHz.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      145,
      151,
      99,
      140
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 224,
    "question": "Due to channel interference, you are upgrading a wireless network from Wi-Fi 5 to Wi-Fi 6. Which feature of Wi-Fi 6 reduces channel interference?",
    "choice_a": "OFDMA",
    "choice_b": "BSS coloring",
    "choice_c": "MU-MIMO",
    "choice_d": "DFS",
    "correct_answer": "B",
    "explanation": "The feature of Wi-Fi 6 that reduces channel interference is Basic Service Set (BSS) coloring, which adds a field to the wireless frame that distinguishes it from others. Orthogonal Frequency Division Multiple Access (OFDMA) is a modulation technique that improves speed because it allows transmission to multiple clients at once. MU-MIMO also increases speed because in Wi-Fi 6 it works for uplink connections as well as downlink ones. Dynamic Frequency Selection (DFS) was introduced with 802.11n, and it detects radar interference and adjusts frequencies accordingly.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      140,
      142,
      138,
      139
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 225,
    "question": "Which of the following security standards was the first to introduce a dynamic 128-bit per-packet security key?",
    "choice_a": "WEP",
    "choice_b": "TKIP",
    "choice_c": "AES",
    "choice_d": "CCMP",
    "correct_answer": "B",
    "explanation": "WEP could use a 64-bit or 128-bit security key, but it was a static key. TKIP introduced a dynamic per-packet key. AES and CCMP came after TKIP.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      153,
      141,
      126,
      107,
      117
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 226,
    "question": "Which was the first Wi-Fi version to support WPA3 and OFDMA?",
    "choice_a": "Wi-Fi 5",
    "choice_b": "Wi-Fi 6",
    "choice_c": "Wi-Fi 6E",
    "choice_d": "Wi-Fi 7",
    "correct_answer": "B",
    "explanation": "Wi-Fi 6 (802.11ax) was the first standard to support WPA3 security and OFDMA modulation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      153,
      140,
      142,
      144
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 227,
    "question": "When enabled, which feature of a wireless router allows only specified computers to access the network?",
    "choice_a": "Port forwarding",
    "choice_b": "NAT",
    "choice_c": "SSID",
    "choice_d": "MAC filtering",
    "correct_answer": "D",
    "explanation": "MAC filtering is a security option that can specify that only computers with specific MAC (hardware) addresses can access the network. Port forwarding is a feature of firewalls. NAT translates private IP addresses into public ones. SSID is the wireless network name.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      152,
      155,
      153,
      114
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 228,
    "question": "A firewall operates by using a set of rules known as what?",
    "choice_a": "SLA",
    "choice_b": "ACL",
    "choice_c": "NAT",
    "choice_d": "APIPA",
    "correct_answer": "B",
    "explanation": "The set of rules for access on a firewall is called an access control list (ACL). A service level agreement (SLA) is an agreement on service level for quality of service (QoS). NAT translates private IP addresses into public ones. APIPA assigns an IP address to a client that can\u2019t reach the DHCP server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      155,
      131,
      125,
      135,
      126
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 229,
    "question": "You have set up a wireless router on your network and configured it to use AES. What configuration option do you need to choose on the client computers?",
    "choice_a": "WEP",
    "choice_b": "WPA",
    "choice_c": "WPA3",
    "choice_d": "TKIP",
    "correct_answer": "C",
    "explanation": "If your router is using AES, the clients will need to use WPA2 or WPA3. TKIP is a protocol utilized by WPA. WEP is the weakest of the encryption options.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      153,
      152,
      141,
      154,
      99
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 230,
    "question": "Besides 802.11 standards, which wireless communication method also works in the 2.4 GHz range?",
    "choice_a": "Bluetooth",
    "choice_b": "Satellite",
    "choice_c": "mmWave",
    "choice_d": "NFC",
    "correct_answer": "A",
    "explanation": "Bluetooth also operates in the 2.4 GHz range. Satellite uses satellite waves; 5G cellular mmWave is between 24 GHz and 86 GHz; and NFC uses 13.56 MHz.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      145,
      100,
      138,
      139,
      151
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 231,
    "question": "You are configuring a SOHO client to use TCP/IP. Which parameter is needed to tell the client where to communicate to get on the Internet?",
    "choice_a": "Static address",
    "choice_b": "Dynamic address",
    "choice_c": "APIPA",
    "choice_d": "Gateway",
    "correct_answer": "D",
    "explanation": "The gateway, also known as a default gateway, is the address to the router to take a client to the next network (or Internet). Gateways can be configured with a static assignment or dynamically through a DHCP server. APIPA will automatically configure a client with IP address information if it\u2019s set to get its configuration form a DHCP server but none is available. APIPA-configured clients can\u2019t get on the Internet.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      121,
      130,
      156,
      124,
      122
    ],
    "source": "330034_Vol1_Ch09"
  },
  {
    "id": 232,
    "question": "A friend asks you why she would ever disable cellular data networking. Which of the following is <i>not</i> a valid reason to disable cellular data networking?",
    "choice_a": "You have a limited amount of data in your monthly plan.",
    "choice_b": "You have access to a reliable Wi-Fi signal.",
    "choice_c": "You are about to download an update to your phone.",
    "choice_d": "Your phone calls are going out over your carrier\u2019s cellular network.",
    "correct_answer": "D",
    "explanation": "Whenever you have a reliable Wi-Fi signal available, which you do not pay for \u201cas you go,\u201d you should feel free to disable your cellular access to data networking. The wireless network is often faster and does not cost you anything to use. If data networking works better when you leave the cellular network available as a fallback, you can choose to disable it only for certain large downloads or disable it completely until the download is complete. Phone calls will continue to be sent over the cellular network. This does not imply that your data is not using an available Wi-Fi connection. Therefore, unless you are particularly sensitive to the situation or know that data is going out over your cell access, you might not need to disable the cellular data-networking feature.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      163,
      162,
      157,
      159,
      171
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 233,
    "question": "You need to pair two Bluetooth devices with each other. Which of the following is true regarding Bluetooth pairing?",
    "choice_a": "Bluetooth connections support wireless device control but not file transfers.",
    "choice_b": "Bluetooth is not yet a fully standardized protocol.",
    "choice_c": "Bluetooth connections do not reach as far as Wi-Fi connections.",
    "choice_d": "You must reboot the paired devices to complete the connection.",
    "correct_answer": "C",
    "explanation": "The range of Bluetooth connections is considered short compared to Wi-Fi connections. Bluetooth is a fully standardized protocol that supports file transfers using FTP. Rebooting, or even restarting, paired devices is not a requirement for Bluetooth connection.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      162,
      164,
      157,
      166
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 234,
    "question": "A technician is configuring a mobile client to use email through an ISP. Which port number should he configure to use SMTP?",
    "choice_a": "25",
    "choice_b": "110",
    "choice_c": "143",
    "choice_d": "995",
    "correct_answer": "A",
    "explanation": "SMTP sends mail to the server on TCP port 25. POP3 uses port 110. IMAP4 uses port 143. POP3 uses port 995 securely over SSL or TLS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      170,
      157,
      162,
      164,
      172
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 235,
    "question": "You need to configure email for a mobile client. His device has a setting referring to port 587. Which mail protocol is likely using this protocol?",
    "choice_a": "SMTP with SSL",
    "choice_b": "SMTP with TLS",
    "choice_c": "IMAP4 with SSL/TLS",
    "choice_d": "POP3 with SSL/TLS",
    "correct_answer": "B",
    "explanation": "SMTP with TLS uses port 587 by default. With SSL, SMTP uses port 465. IMAP4 with SSL/TLS uses port 993, whereas POP3 with SSL/TLS uses port 995.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      170,
      172,
      164,
      162,
      163
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 236,
    "question": "You are enabling email on a mobile client. Which of the following is <i>not</i> a standard integrated commercial provider for email?",
    "choice_a": "iCloud",
    "choice_b": "Hotmail",
    "choice_c": "Yahoo Mail",
    "choice_d": "Exchange Online",
    "correct_answer": "B",
    "explanation": "Four commercial email providers to be familiar with are iCloud, Google/Inbox, Exchange Online, and Yahoo Mail. Hotmail used to be a commercial email provider, but it no longer exists; it\u2019s now part of Outlook.com.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      170,
      172,
      173,
      162,
      164
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 237,
    "question": "If a user wanted to disable location services on an iPhone, where would they do that?",
    "choice_a": "Settings  Location Services",
    "choice_b": "Settings  Communications",
    "choice_c": "Settings  Privacy & Security",
    "choice_d": "Settings  GPS",
    "correct_answer": "C",
    "explanation": "In iOS (at least iOS 18), location services are under Settings  Privacy & Security. There are no location services, communications, and GPS sections directly in Settings.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      167,
      159,
      165,
      166,
      162
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 238,
    "question": "A mobile device is having intermittent communications issues. Which software component of a mobile phone is most likely responsible for these issues?",
    "choice_a": "Either iOS or Android OS",
    "choice_b": "SIM OS",
    "choice_c": "Baseband OS",
    "choice_d": "Wireless OS",
    "correct_answer": "C",
    "explanation": "Each mobile phone has a separate processor that manages wireless communications, also known as radio communications or baseband communications. There is a baseband OS that manages this, and it works with the primary OS on the phone. A SIM OS is for managing data transfers between the phone and the SIM chip. There is no wireless OS.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      160,
      158,
      159,
      157,
      163
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 239,
    "question": "An administrator needs to be able to control which apps are installed on the corporate network\u2019s mobile devices, and update or delete them and their data as necessary. Which type of service does she need?",
    "choice_a": "MAM",
    "choice_b": "MDM",
    "choice_c": "Location services",
    "choice_d": "Device synchronization",
    "correct_answer": "A",
    "explanation": "Mobile application management (MAM) is a service that allows administrators to control corporate software on mobile devices, including updating and wiping apps. Mobile device management (MDM) controls which devices are on the network and can wipe entire devices. Location services does not manage software. Synchronization can back up apps and data but does not help with updates or deleting apps.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      168,
      169,
      171,
      157,
      159
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 240,
    "question": "You need to synchronize Windows desktop settings between two laptop computers. Which service is designed to do this?",
    "choice_a": "Microsoft 365",
    "choice_b": "MAM",
    "choice_c": "MDM",
    "choice_d": "iCloud",
    "correct_answer": "A",
    "explanation": "Microsoft 365 is able to sync desktop settings between multiple Windows-based computers. ActiveSync is for syncing mobile devices with an Exchange email server. Mobile application management (MAM) and mobile device management (MDM) are for managing apps and network access for mobile devices. iCloud is a cloud-based storage solution.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      171,
      168,
      169,
      160
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 241,
    "question": "You are pairing a Bluetooth headset to a mobile device. On the mobile device, after finding the device for pairing, what is the next step to take?",
    "choice_a": "Enable Bluetooth.",
    "choice_b": "Test connectivity.",
    "choice_c": "Enter the appropriate PIN code.",
    "choice_d": "Enable pairing.",
    "correct_answer": "C",
    "explanation": "The next step is to enter the PIN code. The steps, in order, are as follows: enable Bluetooth, enable pairing, find a device for pairing, enter the appropriate PIN code, and test connectivity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      162,
      164,
      157,
      160
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 242,
    "question": "Which of the following most accurately describes the purpose of a SIM?",
    "choice_a": "It\u2019s the data storage space for a mobile device.",
    "choice_b": "It stores phone identification and security data.",
    "choice_c": "It manages the mobile device\u2019s wireless connections.",
    "choice_d": "It\u2019s the controller for location services on a mobile device.",
    "correct_answer": "B",
    "explanation": "The subscriber identity module (SIM) is a chip in a mobile device that stores user information, phone identification, and security data. It does not store user data, manage wireless connections, or location services.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      161,
      160,
      159,
      158,
      157
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 243,
    "question": "Which of the following location services typically provides the best accuracy when detecting a user\u2019s location?",
    "choice_a": "Cellular",
    "choice_b": "GPS",
    "choice_c": "eSIM",
    "choice_d": "MDM",
    "correct_answer": "B",
    "explanation": "GPS is generally more accurate than cellular when determining location. eSIM is a SIM chip built into a mobile device\u2019s motherboard. MDM is a mobile device management concept.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      165,
      166,
      167,
      168,
      160
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 244,
    "question": "Which of the following statements about configuring email access on a mobile device is true?",
    "choice_a": "Most Internet mail services offer an Exchange option.",
    "choice_b": "The TCP ports used for configuring access are usually standard port numbers.",
    "choice_c": "Most ports used for access are UDP ports.",
    "choice_d": "You must download third-party apps for connecting to email services.",
    "correct_answer": "B",
    "explanation": "Mail access uses standard secure or unsecure TCP ports, not UDP ports. Exchange access to such mail services is not unheard of, but it is exceedingly rare. Mobile devices tend to have email clients built-in.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      170,
      172,
      162,
      164,
      168
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 245,
    "question": "Which of the following are disabled on an Android device when airplane mode is switched on? (Choose all that apply.)",
    "choice_a": "Cellular",
    "choice_b": "Wi-Fi",
    "choice_c": "Bluetooth",
    "choice_d": "Settings app",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "On an Android phone, airplane mode disables all radio communications, including cellular, Wi-Fi, and Bluetooth (and NFC as well). It does not affect the opening of any other apps or the lock screen.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      157,
      158,
      162,
      163
    ],
    "source": "330034_Vol1_Ch10",
    "choice_e": "Lock screen"
  },
  {
    "id": 246,
    "question": "You need to enable clients to synchronize their mobile devices to their laptops. Which of the following are common connection types to enable laptop synchronization? (Choose all that apply.)",
    "choice_a": "Cellular",
    "choice_b": "Bluetooth",
    "choice_c": "Wi-Fi",
    "choice_d": "USB",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Three common connection types for synchronization to a desktop (or laptop) are cellular, Wi-Fi and USB. Bluetooth is not used for desktop synchronization. Tethering is when a laptop or other device is granted cellular network access by connecting to a mobile device, such as a smartphone.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      171,
      172,
      157,
      162,
      163
    ],
    "source": "330034_Vol1_Ch10",
    "choice_e": "Tethering"
  },
  {
    "id": 247,
    "question": "A user calls in from their morning commute, using their iPad, which seems to be experiencing data problems. While traveling in the car or on the train, they can\u2019t download data from the corporate cloud. However, they can once they are in the office. This has been happening for three days. What is the most likely cause of the problem?",
    "choice_a": "The train is moving too fast for the cellular connection to be able to download data.",
    "choice_b": "The cellular connection is disabled. Check to ensure that airplane mode is not enabled.",
    "choice_c": "The user has reached the cellular data cap for the month.",
    "choice_d": "Their iPad is configured as BYOD and needs to be switched to corporate.",
    "correct_answer": "C",
    "explanation": "The user has most likely reached their cellular data cap. Cellular connections (including data) work fine on commuter trains. If the cellular connection were disabled, the user would not be able to call using the device. BYOD versus corporate configurations will not affect the ability to download data.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      163,
      158,
      162,
      157,
      159
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 248,
    "question": "When changing an Android smartphone from one service provider to another, which chip would be physically removed from the device and replaced with a new one?",
    "choice_a": "SIM",
    "choice_b": "eSIM",
    "choice_c": "GPS",
    "choice_d": "BYOD",
    "correct_answer": "A",
    "explanation": "The subscriber identity module (SIM) chip contains the information needed to join the cellular network of the provider. If a device has a SIM chip, it can be replaced. eSIM is built into the motherboard and electronically reprogrammed. GPS is a location service. BYOD is bring your own device, a type of device configuration for using a corporate network.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      161,
      160,
      168,
      159,
      157
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 249,
    "question": "A network administrator wants to be able to remotely wipe everything off of corporate smartphones if they are lost or stolen. What type of service does she need?",
    "choice_a": "MAM",
    "choice_b": "MDM",
    "choice_c": "eSIM",
    "choice_d": "Location services",
    "correct_answer": "B",
    "explanation": "Mobile device management (MDM) is a type of service that allows network administrators to specify which mobile devices can join the network. It also gives administrators the ability to remotely lock and completely wipe mobile devices. Mobile application management (MAM) lets an administrator control the corporate apps on a mobile device. An eSIM has phone and user configuration information. Location services can help find a mobile device, but not remotely wipe it.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      168,
      169,
      166,
      167,
      157
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 250,
    "question": "A user needs to synchronize her iPhone to another platform. Which two options are the default ones for her to choose? (Choose two.)",
    "choice_a": "Google Drive",
    "choice_b": "SharePoint",
    "choice_c": "iCloud",
    "choice_d": "iTunes",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Apple devices natively sync with iCloud and iTunes. Android devices sync with Google Drive. SharePoint is a Microsoft service which can be used to share files.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      171,
      172,
      173,
      159,
      162
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 251,
    "question": "You are investigating potential location services options for a client. Which type of location services will need to be paid for versus being free of charge?",
    "choice_a": "GPS",
    "choice_b": "Cellular",
    "choice_c": "Bluetooth",
    "choice_d": "Wi-Fi",
    "correct_answer": "B",
    "explanation": "GPS, cellular, Bluetooth, and Wi-Fi can all be used as part of a location services solution. GPS is free, and Wi-Fi and Bluetooth likely are as well, if part of a company or organization\u2019s network. Cellular requires a contract with a provider, which is a paid service.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      166,
      165,
      157,
      158,
      167
    ],
    "source": "330034_Vol1_Ch10"
  },
  {
    "id": 252,
    "question": "You have been asked to identify the right type of cloud service to help the team of developers to provide programming elements such as runtime environments. Which service do you recommend?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "A",
    "explanation": "Platform as a service (PaaS) is probably the right level of service for the developer team. It provides infrastructure, like IaaS, and also supplies needed programming elements. Infrastructure as a service doesn\u2019t provide runtime environments; think of it as hardware. Software as a service provides apps and is too high of a service for what\u2019s needed here. There is no current DaaS on the exam objectives.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      182,
      180,
      183,
      177,
      178
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 253,
    "question": "You are setting up a cloud contract with a provider. Your team needs the ability to quickly increase capacity to meet peak demands. What do you request?",
    "choice_a": "Elasticity",
    "choice_b": "Availability",
    "choice_c": "Resource pooling",
    "choice_d": "Metered utilization",
    "correct_answer": "A",
    "explanation": "The ability to expand services quickly refers to elasticity (or specifically, rapid elasticity). Availability guarantees uptime for services. All cloud services use resource pooling. Metered utilization is how many suppliers track usage and charge accordingly.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      183,
      180,
      182,
      184,
      181
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 254,
    "question": "Your company wants to move to a cloud provider to be able to scale resources quickly, but it is concerned about the security of confidential information. Which of the following types of cloud models might be the most appropriate for your company?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Community",
    "choice_d": "Hybrid",
    "correct_answer": "D",
    "explanation": "A hybrid cloud provides the best of public and private clouds. You get the scalability and cost effectiveness of a public cloud but also the security that you need for important files on the private portion of the cloud.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      181,
      180,
      182,
      183,
      179
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 255,
    "question": "You have been asked to advise a group of several universities that want to combine research efforts and store data in the cloud. Which type of cloud solution might be best for them?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Community",
    "choice_d": "Hybrid",
    "correct_answer": "C",
    "explanation": "When multiple organizations with similar objectives want to combine efforts in a cloud, the best choice is generally a community cloud. This allows for the flexibility and scalability normally found in a public cloud, but it also limits the number of users to a smaller, trusted group. Hybrid clouds also combine public and private, but are for a single company to use.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      181,
      180,
      183,
      182,
      185
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 256,
    "question": "Your manager wants to use the cloud because everyone seems to be talking about it. What should you include when you are listing the benefits of using the cloud? (Choose all that apply.)",
    "choice_a": "Increased security",
    "choice_b": "Increased scalability",
    "choice_c": "Lower cost",
    "choice_d": "Improved reliability",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Cloud solutions are great for enhancing scalability and reliability while generally lowering costs. Security could be an issue with cloud computing, depending on your organization\u2019s needs, because the resources aren\u2019t locally controlled and managed.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      180,
      183,
      184,
      185,
      186
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 257,
    "question": "You have been asked to configure a client-side virtualization solution with three guest OSs. Each one needs Internet access. How should you configure the solution in the most cost-effective way?",
    "choice_a": "Three physical NICs",
    "choice_b": "One physical NIC, three virtual NICs, and one virtual switch",
    "choice_c": "One physical NIC, one virtual NIC, and three virtual switches",
    "choice_d": "One physical NIC, three virtual NICs, and three virtual switches",
    "correct_answer": "B",
    "explanation": "Each virtual machine will use its own virtual NIC, so you need three virtual NICs. The virtual NICs will communicate with one virtual switch managed by the hypervisor. The virtual switch will communicate with one physical NIC on the host system.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      178,
      174,
      176,
      179,
      175
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 258,
    "question": "You have been asked to install Linux in a VM on a Windows 11 client. The Windows 11 client needs 4 GB of RAM, and Linux needs 2 GB of RAM. How much RAM does the system need at a minimum?",
    "choice_a": "4 GB",
    "choice_b": "6 GB",
    "choice_c": "8 GB",
    "choice_d": "Unable to determine from the question",
    "correct_answer": "B",
    "explanation": "There needs to be enough RAM to support both OSs, so the answer is 6 GB. More is better, though!",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      178,
      174,
      176,
      175,
      179
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 259,
    "question": "A computer using which of the following would be considered a legacy device? (Choose all that apply.)",
    "choice_a": "A 386 processor",
    "choice_b": "The IPX/SPX protocol",
    "choice_c": "An application developed in 1989",
    "choice_d": "1 GB of RAM",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Legacy systems are ones that use older hardware, software, or network protocols that are not commonly used today. A system with only 1 GB of RAM might be woefully underpowered, but that in and of itself does not make it a legacy system.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      175,
      174,
      179,
      178,
      180
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 260,
    "question": "You have been asked to set up client-side virtualization on an office computer. The host OS is Windows 11, and there will be three Windows 11 guest OSs. Which of the following is true about the need for antivirus security?",
    "choice_a": "The host OS needs an antivirus program, but virtual machines can\u2019t be affected by viruses.",
    "choice_b": "The host OS antivirus software will also protect the guest OSs on the VMs.",
    "choice_c": "Installing antivirus software on the virtual switch will protect all guest OSs.",
    "choice_d": "The host OS and each guest OS need their own antivirus software installed.",
    "correct_answer": "D",
    "explanation": "Each instance of the OS you are running requires its own security software.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      179,
      174,
      178,
      175,
      176
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 261,
    "question": "You need to set up a temporary operating system environment to quickly test a piece of software your manager wants to install on the network. Which should you use?",
    "choice_a": "AAA server",
    "choice_b": "Sandbox",
    "choice_c": "SCADA",
    "choice_d": "Application virtualization",
    "correct_answer": "B",
    "explanation": "A sandbox is a temporary operating system environment, kind of like a lite version of a virtual machine. It\u2019s ideal for testing software such as this. An AAA server is for authentication, authorization, and accounting of security. Supervisory Control and Data Acquisition (SCADA) is a hardware and/or software environment used to control industrial systems, and in many cases it is older, so therefore it is considered legacy. Application virtualization is used for legacy apps or cross-platform virtualization.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      175,
      174,
      177,
      179,
      178
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 262,
    "question": "You have been asked to set up client-side virtualization on a computer at work. The manager asks for a Type 2 hypervisor. What is the disadvantage of using that type of hypervisor?",
    "choice_a": "The guest OS will compete for resources with the host OS.",
    "choice_b": "The guest OS will be forced to a lower priortity with the CPU than the host OS.",
    "choice_c": "The guest OS will be forced to use less RAM than the host OS.",
    "choice_d": "The virtual guest OS will not be able to get on the physical network.",
    "correct_answer": "A",
    "explanation": "A Type 2 hypervisor sits on top of an existing OS, meaning that OSs installed in VMs will compete for resources with the host OS. The amount of resources available to a guest OS can be configured. Virtual OSs can get on the physical network if configured properly.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      176,
      178,
      179,
      174,
      175
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 263,
    "question": "Your software development team has created an app that needs to be quickly deployed to all network users, using virtualization. Which technology is best suited for this purpose?",
    "choice_a": "Type 1 hypervisor",
    "choice_b": "Type 2 hypervisor",
    "choice_c": "Containers",
    "choice_d": "VDI",
    "correct_answer": "C",
    "explanation": "Containers are used to quickly deploy single apps and all of the files needed to run them, regardless of what platform (OS) the user is using. Hypervisors virtualize entire machines. VDI is the virtual desktop infrastructure.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      177,
      175,
      176,
      178,
      179
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 264,
    "question": "Which type of cloud is generally most cost effective for companies to use?",
    "choice_a": "Private",
    "choice_b": "Public",
    "choice_c": "Hybrid",
    "choice_d": "Community",
    "correct_answer": "B",
    "explanation": "Public clouds are usually the most cost effective. The client doesn\u2019t need to purchase any hardware, the cloud provider benefits from economies of scale.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      181,
      180,
      183,
      182,
      184
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 265,
    "question": "A development team is creating containers. Which of the following statements are not true regarding containers? (Choose two.)",
    "choice_a": "Containers are faster to deploy than hypervisors.",
    "choice_b": "Each container has a minimum RAM requirement.",
    "choice_c": "Containers can only hold one app.",
    "choice_d": "Containers are designed to work on one OS.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Containers are faster to deploy than hypervisors. They can hold more than one app, but best practices usually specify that they hold only one. Containers do not have their own RAM requirements. They are designed to work on any OS.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      177,
      178,
      174,
      176,
      179
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 266,
    "question": "Your manager read that multiple client companies might share the same hardware in a cloud and is extremely concerned about the security of company data. What should you tell them?",
    "choice_a": "Data security is a serious concern in a multitenancy environment, so the data should be limited to non-sensitive materials.",
    "choice_b": "Thanks to the use of containers, data from different companies is always separated to help avoid data security issues.",
    "choice_c": "Cloud providers guarantee that clients will not share the same storge devices, so data security is not a significant issue.",
    "choice_d": "Multiple tenants may share the same hardware, but their data and apps are separated to avoid data security issues.",
    "correct_answer": "D",
    "explanation": "Multitenancy happens all the time in cloud computing, meaning that multiple clients will share the same hardware resources. Their apps and data are separated though to avoid any data security issues.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      183,
      180,
      179,
      174,
      176
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 267,
    "question": "A software developer wants to be able to test their in-progress apps in three different OSs. Which type of setup is best for their Windows 11 client computer?",
    "choice_a": "Type 1 hypervisor",
    "choice_b": "Type 2 hypervisor",
    "choice_c": "Containers",
    "choice_d": "VDI",
    "correct_answer": "B",
    "explanation": "A type 2 hypervisor is the best choice. It can sit on top of the developer\u2019s Windows workstation, and virtualize other OSs as needed for testing. A Type 1 (bare-metal) hypervisor is better suited for server virtualization. Containers may be useful in quickly deploying the apps once they are complete and ensuring they can run in multiple operating environments. VDI is the virtual desktop infrastructure.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      176,
      175,
      174,
      178,
      177
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 268,
    "question": "A manager is demanding more storage space for his department, immediately. What type of cloud solution is best in this case?",
    "choice_a": "IaaS",
    "choice_b": "SaaS",
    "choice_c": "PaaS",
    "choice_d": "VDI",
    "correct_answer": "A",
    "explanation": "Infrastructure as a service (IaaS) provides hardware, which includes storage space. Platform as a service (PaaS) would include software development tools, and Software as a service (SaaS) would include apps as well. Neither of those seem needed in this instance. VDI is virtual desktop infrastructure.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      182,
      180,
      183,
      185,
      187
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 269,
    "question": "A cloud provider is asking if you know what all of the software and hardware is that\u2019s needed to create an appropriate virtual environment for your users. What are they referring to?",
    "choice_a": "Type 1 hypervisor",
    "choice_b": "Type 2 hypervisor",
    "choice_c": "Containers",
    "choice_d": "VDI",
    "correct_answer": "D",
    "explanation": "The virtual desktop infrastructure (VDI) is the hardware and software needed to create a virtual environment. Hypervisors are the software packages that create and manage virtual environments. Containers are used for software virtualization.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      178,
      176,
      174,
      177,
      179
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 270,
    "question": "On the latest invoice from your CSP, you notice an egress surcharge. What is this most likely for?",
    "choice_a": "Downloading data from the cloud.",
    "choice_b": "Uploading data to the cloud.",
    "choice_c": "Creating new containers for applications.",
    "choice_d": "Creating new virtual desktop infrastructure (VDI) instances.",
    "correct_answer": "A",
    "explanation": "Ingress (uploading data) and egress (downloading data) may be part of metered utilization in a cloud agreement. Generally, ingress is free, but many cloud providers will charge for data egress. Egress is not related to containers or VDI.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      180,
      182,
      183,
      185,
      186
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 271,
    "question": "A CSP is setting up services for three client companies. Each client has contracted for 10 TB storage space. How much storage space does the cloud provider need to have, in total, to satisfy the contracts?",
    "choice_a": "10 TB, because clients will share hardware in a multitenancy environment.",
    "choice_b": "20 TB, because clients will share hardware in a multitenancy environment.",
    "choice_c": "30 TB, because that is what the clients contracted in total.",
    "choice_d": "60 TB, because the CSP must have reserve storage space in reserve for elasticity.",
    "correct_answer": "C",
    "explanation": "If the CSP has guaranteed three clients 10 TB each, then the CSP needs at least 30 TB of available storage space. Clients may share hardware in a multitenancy environment, but each is guaranteed its contract terms. Having extra storage available for elasticity purposes is a good idea but not required.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      183,
      180,
      182,
      185,
      181
    ],
    "source": "330034_Vol1_Ch11"
  },
  {
    "id": 272,
    "question": "When a user turns on their desktop computer, nothing appears on the screen. They hear three long beeps, followed by three short beeps, and three long beeps. What should you do as a next step?",
    "choice_a": "Replace the motherboard.",
    "choice_b": "Replace the RAM.",
    "choice_c": "Replace the CPU.",
    "choice_d": "Look up the beep code on the manufacturer\u2019s website.",
    "correct_answer": "D",
    "explanation": "This system is producing a beep code and not completing the POST process. Different BIOS/UEFI manufacturers use different beep codes. Look up this beep code on the manufacturer\u2019s website before replacing any hardware.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      196,
      190,
      188,
      202,
      198
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 273,
    "question": "A field technician reports back that the computer they are troubleshooting has exposed distended capacitors. Which component has most likely failed?",
    "choice_a": "Power supply",
    "choice_b": "Motherboard",
    "choice_c": "CPU",
    "choice_d": "RAM",
    "correct_answer": "B",
    "explanation": "Capacitors store energy and are located on the motherboard and inside the power supply. Since the capacitors are exposed, it likely means the technician is seeing the problem on the motherboard. CPUs and RAM do not have capacitors.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      197,
      201,
      194,
      196,
      188
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 274,
    "question": "You are troubleshooting a Windows-based desktop computer that is experiencing unexpected shutdowns. Which of the following would be a good next step to resolve the issue? (Choose two.)",
    "choice_a": "Replace the motherboard, CPU, and RAM to see if it resolves the problem.",
    "choice_b": "Replace the RAM to see if it resolves the problem.",
    "choice_c": "Reinstall Windows to see if it resolves the problem.",
    "choice_d": "Replace the CPU to see if it resolves the problem.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Intermittent shutdowns are hard to troubleshoot but are most likely hardware-related. When troubleshooting, always make one change at a time to try to resolve the issue. Replacing the RAM or the CPU to see if it resolves the problem could be a good next step, but replacing three components at once is too many changes unless you have specific reason to believe it is all three. Reinstalling Windows is probably overkill as well. Narrow down the issue before implementing sweeping solutions such as that.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      190,
      188,
      189,
      198,
      199
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 275,
    "question": "When a desktop computer boots up, there is no video on the LED monitor, just a blank screen. The system makes one beep when it powers on, and air is coming out of the case fan. What is the most likely cause of the problem?",
    "choice_a": "The motherboard has failed.",
    "choice_b": "The video card has failed.",
    "choice_c": "The monitor is disconnected.",
    "choice_d": "The CPU or RAM has failed.",
    "correct_answer": "C",
    "explanation": "When troubleshooting, always question the obvious. In this case, the system beeps once, which is usually a signal from the BIOS that POST completed successfully, and air is coming from the system fan. All of that appears to be normal. Check to see that the monitor is connected properly to the desktop computer and that it\u2019s receiving power.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      202,
      218,
      190,
      196,
      188
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 276,
    "question": "You are training a class of new technicians on troubleshooting motherboard issues. Which of the following are issues most likely caused by a failing CMOS battery? (Choose two.)",
    "choice_a": "BIOS time and setting resets",
    "choice_b": "Attempts to boot to the incorrect device",
    "choice_c": "Intermittent device failure",
    "choice_d": "BSOD/pinwheel errors",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "When the system is powered off, BIOS settings on a motherboard are maintained by the CMOS battery. If the battery fails, the system will likely forget the BIOS time and date settings and the boot order configuration. Replacing the CMOS battery will resolve the issue.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      195,
      197,
      196,
      190,
      188
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 277,
    "question": "A desktop computer is experiencing continuous reboots. It gets to the BIOS screen and then reboots every time. Which two components are most likely to cause this problem? (Choose two.)",
    "choice_a": "Power supply",
    "choice_b": "RAM",
    "choice_c": "Motherboard",
    "choice_d": "CPU",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Continuous reboots are most likely caused by the motherboard or CPU failing. It\u2019s possible it\u2019s the RAM, but less likely. The power supply is the least likely cause of the problem in this scenario.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      196,
      197,
      198,
      201,
      188
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 278,
    "question": "A user pushes the power button on their desktop computer but nothing happens. They double-check that it is plugged in and that the wall outlet is working properly. Which components are most likely to cause this problem? (Choose two.)",
    "choice_a": "Power supply",
    "choice_b": "Motherboard",
    "choice_c": "Power cord",
    "choice_d": "CPU",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "If the wall outlet is functioning and the power cable is connected properly (always check the obvious), then the most likely culprits are the power supply or the power cord. The motherboard, CPU, and RAM are unlikely to cause a complete power failure in a computer.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      201,
      188,
      190,
      196,
      194
    ],
    "source": "330034_Vol1_Ch12",
    "choice_e": "RAM"
  },
  {
    "id": 279,
    "question": "A technician who has been troubleshooting a computer tells you that the system is having problems with overheating. Which component is most likely to cause this issue?",
    "choice_a": "Power supply",
    "choice_b": "Motherboard",
    "choice_c": "CPU",
    "choice_d": "RAM",
    "correct_answer": "C",
    "explanation": "The processor runs the hottest of all computer components and is the most likely to overheat. Motherboards and RAM don\u2019t generate a lot of heat. Power supplies most often have fans to help dissipate heat, and don\u2019t run as hot as CPUs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      194,
      226,
      233,
      188,
      190
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 280,
    "question": "You turn on a desktop computer and it fails to boot. You hear a rhythmic ticking coming from inside the case. What is most likely the problem?",
    "choice_a": "Failed hard drive",
    "choice_b": "Failed motherboard",
    "choice_c": "Failed CPU",
    "choice_d": "Failed RAM",
    "correct_answer": "A",
    "explanation": "Only components with moving parts can make ticking or clicking noises. (Bombs can too, but hopefully you recognized that as a fake answer!) This question assumes that the hard drive is an HDD and not an SSD, but none of the other components would make a ticking noise.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      203,
      193,
      190,
      188,
      196
    ],
    "source": "330034_Vol1_Ch12",
    "choice_e": "A bomb"
  },
  {
    "id": 281,
    "question": "When you turn on a desktop computer, you hear a loud squealing noise coming from inside the case. Which components are potential culprits for making the noise? (Choose all that apply.)",
    "choice_a": "CPU fan",
    "choice_b": "Power supply fan",
    "choice_c": "HDD",
    "choice_d": "SSD",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Only components with moving parts can make ticking, clicking, or squealing noises. It\u2019s probably a fan of some sort (such as the CPU fan or power supply fan), or it could be a conventional hard drive. SSDs, CPUs, and RAM do not have moving parts and therefore could not be causing this problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      193,
      194,
      198,
      201,
      188
    ],
    "source": "330034_Vol1_Ch12",
    "choice_e": "CPU",
    "choice_f": "RAM"
  },
  {
    "id": 282,
    "question": "A user complains of smoke and a foul odor coming from their desktop computer, so they shut it down. Which component is most likely causing the problem?",
    "choice_a": "Power supply",
    "choice_b": "RAM",
    "choice_c": "CPU",
    "choice_d": "Motherboard",
    "correct_answer": "A",
    "explanation": "Smoke and foul odors such as burning smells are not normal for computers! The most likely component causing the problem is the power supply. With the system off, open the computer case (not the power supply case!) to examine the inside for possible physical damage.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      201,
      193,
      194,
      190,
      189
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 283,
    "question": "A Windows user complains that their computer keeps crashing. What is the proprietary crash screen they are most likely seeing?",
    "choice_a": "Stop sign",
    "choice_b": "Pinwheel",
    "choice_c": "BSOD",
    "choice_d": "Black screen",
    "correct_answer": "C",
    "explanation": "When Windows-based systems crash, as can happen due to a memory, CPU, or motherboard problem, they will most likely display a Blue Screen of Death (BSOD). The good news is that the BSOD can often provide useful information, such as an error code, to help troubleshoot the problem. There is no stop sign proprietary crash screen, and the pinwheel is used in macOS. A black screen may indicate a system crash but is not proprietary to one operating system.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      199,
      196,
      197,
      188,
      190
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 284,
    "question": "A laptop user with an 802.11ax wireless network card just switched desk locations. In the new location, they say that their wireless drops connectivity intermittently and seems to have slow transfer speeds. Which of the following is most likely to resolve these issues?",
    "choice_a": "Replace the network card.",
    "choice_b": "Run <code>ipconfig</code> to ensure that they are receiving the right IP address from the DHCP server.",
    "choice_c": "Install a new WAP closer to their new desk.",
    "choice_d": "Use a network monitor to ensure that there are no IP address conflicts.",
    "correct_answer": "C",
    "explanation": "Distance matters in wireless networks. Being too far away from an access point will result in a weaker signal, which can cause intermittent signal drops and poor performance. Moving closer to the wireless access point (WAP) or wireless router can help, as can installing additional WAPs or wireless routers. The IP address from the DHCP server won\u2019t matter, and since they reported no error message, there is not likely to be an IP address conflict. Unless there are other issues, replacing the NIC seems to be overkill.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      102,
      154,
      139,
      152
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 285,
    "question": "While troubleshooting a client computer, you decide to obtain a new IP address from the DHCP server. After releasing the existing address, which command do you use to get new IP information from the DHCP server?",
    "choice_a": "<code>ipconfig /refresh</code>",
    "choice_b": "<code>ipconfig /renew</code>",
    "choice_c": "<code>ip /release </code>",
    "choice_d": "<code>ip /start</code>",
    "correct_answer": "B",
    "explanation": "The <code>ipconfig</code> command is perhaps the most-used utility in troubleshooting and network configuration. The <code>ipconfig /renew</code> command will send a query to the DHCP server asking it to resend and renew all DHCP information. For a more detailed look at the <code>ipconfig</code> command, type <code>ipconfig /?</code> at the command prompt. The <code>ip</code> command is used with Linux and macOS clients. There is no <code>/refresh</code> or <code>/start</code> switch for these commands.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      121,
      130,
      128,
      122,
      119
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 286,
    "question": "You believe that a network card is beginning to fail. Which of the following tools should you use to see if the network card is capable of sending and receiving data from an RJ-45 port?",
    "choice_a": "Toner probe",
    "choice_b": "Loopback plug",
    "choice_c": "Multimeter",
    "choice_d": "Cable tester",
    "correct_answer": "B",
    "explanation": "A loopback plug is used to test the ability of a network adapter to send and receive. The plug gets plugged into the NIC, and then a loopback test is performed using troubleshooting software. A toner probe is used to trace a cable. Multimeters test for electrical issues. Cable testers are for verifying that a cable works properly.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      109,
      112,
      116,
      110
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 287,
    "question": "Troubleshooting a network connectivity issue takes you into the wiring closet, where you realize that none of the cables are properly labeled. Several are disconnected. Which tool should you use to determine where the cables run to?",
    "choice_a": "Loopback plug",
    "choice_b": "Punch-down tool",
    "choice_c": "Cable tester",
    "choice_d": "Toner probe",
    "correct_answer": "D",
    "explanation": "A toner probe is used to trace a cable from one location to another. A loopback plug is for testing the ability of a network adapter to send and receive. Punch-down tools are used to connect the wires of a cable to a wiring rack, such as a 110-block. Cable testers are for verifying that a cable works properly.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      116,
      111,
      110,
      113,
      146
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 288,
    "question": "You turn on a laptop computer and the hard drive is not recognized. Where should you go to troubleshoot the issue?",
    "choice_a": "S.M.A.R.T. diagnostics",
    "choice_b": "BIOS/UEFI",
    "choice_c": "Windows Device Manager",
    "choice_d": "Boot sector manager",
    "correct_answer": "B",
    "explanation": "If the hard drive is not recognized, the BIOS/UEFI is the place to check. Most systems do not come with built-in S.M.A.R.T. diagnostics software, even if the hard drive is capable of gathering S.M.A.R.T. data. And if there were one, it would give you potential errors on a working drive. Windows Device Manager is inaccessible without the drive being recognized. There is no boot sector manager, although this issue could be related to the boot sector.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      195,
      204,
      196,
      203,
      190
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 289,
    "question": "A network cable for a crucial server has failed. There are no pre-made Ethernet cables available, but there is bulk cable and connectors. Which tool do you need to use to make a new cable?",
    "choice_a": "Crimper",
    "choice_b": "Punch-down tool",
    "choice_c": "Cable tester",
    "choice_d": "Loopback plug",
    "correct_answer": "A",
    "explanation": "A crimper is used to make network cables. Punch-down tools are used to connect the wires of a cable to a wiring rack, such as a 110-block. Cable testers are for verifying that a cable works properly (and may be handy after you complete the cable). A loopback plug is for testing the ability of a network adapter to send and receive.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      111,
      116,
      113,
      115
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 290,
    "question": "You are troubleshooting a server and discover that one of the hard drives in the RAID 0 array has failed. Which statement is true?",
    "choice_a": "You need to replace the failed drive, but the data is okay because the drive is configured as a mirror.",
    "choice_b": "You need to replace the failed drive, but the data is okay because the drive is configured as a disk stripe with parity.",
    "choice_c": "You need to replace the failed drive, and the data on the array is lost.",
    "choice_d": "You do not need to replace the failed drive; the system will function normally.",
    "correct_answer": "C",
    "explanation": "A RAID 0 array is also known as disk striping. RAID 0 actually decreases your fault tolerance versus one hard drive because there are more points of failure. You need to replace the drive, and hopefully you had it backed up so that you can restore the data.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      208,
      206,
      190,
      188,
      192
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 291,
    "question": "While troubleshooting an intermittent Internet connectivity problem, you notice that port 443 on the router keeps opening and closing. What is this an example of?",
    "choice_a": "Jitter",
    "choice_b": "High latency",
    "choice_c": "External interference",
    "choice_d": "Port flapping",
    "correct_answer": "D",
    "explanation": "The port quickly opening and closing is an example of port flapping. High latency is having a lot of delay on a network, and jitter is variable latency. The port issues could possibly be caused by external interference, but that may not be true as well.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      214,
      216,
      217,
      212,
      229
    ],
    "source": "330034_Vol1_Ch12"
  },
  {
    "id": 292,
    "question": "If the video on your laptop is not working, what should you do to troubleshoot it? (Choose two.)",
    "choice_a": "Toggle the video function key.",
    "choice_b": "Try using an external monitor.",
    "choice_c": "Remove the display unit and reattach it.",
    "choice_d": "Power the system off and back on.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Two helpful things to try are toggling the video output function key (usually something like Fn+F8) and plugging an external monitor into the laptop. Removing the display is possible but not necessary yet. Powering the system off and back on isn\u2019t likely to correct the problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      218,
      202,
      227,
      222,
      190
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 293,
    "question": "A printer is printing unusually large margins on documents that are sent to it. You suspect that the paper size is set incorrectly. Where should you go to change this?",
    "choice_a": "Print spooler",
    "choice_b": "Paper selection switch on the printer",
    "choice_c": "Printing preferences",
    "choice_d": "Print queue",
    "correct_answer": "C",
    "explanation": "Printing preferences sets configuration options such as color vs. black and white, paper size, and page orientation. The print spooler is where print jobs are held for printing. The print queue is the list of print jobs waiting to be printed. There is no paper selection switch on printers (at least not that we\u2019ve seen).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      241,
      240,
      242,
      188,
      190
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 294,
    "question": "A user tells you that his Android phone case is bulging, and the device has been hot to the touch lately. You suspect a swollen battery. Which of the following is a good next step?",
    "choice_a": "Replace the device.",
    "choice_b": "Leave the device on to drain the battery, and then recharge the device.",
    "choice_c": "Turn the device off, let it cool to room temperature, and then recharge the device.",
    "choice_d": "Use the battery calibration utility.",
    "correct_answer": "A",
    "explanation": "With a swollen battery, the best solution is to replace the device. If you are experienced with mobile device batteries, you may be able to replace the battery, but be careful! You should not charge a swollen battery or freeze the system. A battery calibration utility will do no good.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      225,
      226,
      233,
      230,
      189
    ],
    "source": "330034_Vol1_Ch13",
    "choice_e": "Freeze the system."
  },
  {
    "id": 295,
    "question": "Users are complaining that their print jobs are not printing. You open the print queue and see 50 jobs lined up. The printer is connected properly and online. What should you do?",
    "choice_a": "Open the Printer Troubleshooting utility on the printing device and have it diagnose the problem.",
    "choice_b": "Stop and restart the print spooler.",
    "choice_c": "Delete and reinstall the printer.",
    "choice_d": "Delete and reinstall Windows.",
    "correct_answer": "B",
    "explanation": "If print jobs are seemingly getting \u201cstuck\u201d in the printer queue, you should stop and restart the print spooler service. There is no Printer Troubleshooting utility on the physical printer. (There is a Printer Troubleshooter in Windows 11 that might help resolve a print queue issue.) Deleting and reinstalling the printer and/or Windows is not necessary.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      242,
      240,
      188,
      190,
      233
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 296,
    "question": "The display on a laptop computer is continuously flickering. Which of the following are most likely to cause this problem? (Choose two.)",
    "choice_a": "A failing display",
    "choice_b": "Interference from a nearby fan",
    "choice_c": "A failing backlight",
    "choice_d": "A failing inverter",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Perpetually dim or flickering screens are most likely caused by a failing backlight or inverter, which supplies power to the backlight. LCD devices are not subject to interference from fans. An incorrect video driver will not cause a flickering image.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      222,
      223,
      188,
      190,
      202
    ],
    "source": "330034_Vol1_Ch13",
    "choice_e": "Incorrect video driver"
  },
  {
    "id": 297,
    "question": "You are having problems with the video card in one of your computers. Where should you check for troubleshooting information?",
    "choice_a": "Another computer with the same video card",
    "choice_b": "The video card manufacturer\u2019s website",
    "choice_c": "The manual that came with the card",
    "choice_d": "The server log",
    "correct_answer": "B",
    "explanation": "The manufacturer\u2019s website is the first place you should go for information on your products, including troubleshooting information. Many years ago, manufacturers would provide paper manuals with their products, but that\u2019s almost unheard of today, unless you download a PDF version from the website. Server logs can show error codes, but they won\u2019t tell you how to fix anything.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      190,
      188,
      202,
      224,
      191
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 298,
    "question": "Your laser printer keeps printing vertical black lines on its output pages. What is the most likely cause of the problem?",
    "choice_a": "There is a groove or scratch in the EP drum.",
    "choice_b": "The EP drum-cleaning blade is broken.",
    "choice_c": "The printer is low on toner.",
    "choice_d": "The transfer corona wire is not working properly.",
    "correct_answer": "A",
    "explanation": "The most likely cause is a groove or a scratch in the EP drum. Toner is collecting in that groove or scratch, and then it is being deposited onto the page. A broken drum-cleaning blade would result in unreadable images (too much toner). Low toner would cause faded images, and a bad transfer corona wire would cause blank images.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      239,
      238,
      237,
      190,
      188
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 299,
    "question": "The display on your laptop appears warped and fuzzy. You plug in an external monitor, and the image on it is fine. What is the most likely cause of the problem?",
    "choice_a": "The video card",
    "choice_b": "The LCD display",
    "choice_c": "The motherboard",
    "choice_d": "The video driver",
    "correct_answer": "B",
    "explanation": "It has to be a problem with the LCD display. If it were the video card, the display would appear warped and fuzzy on the external monitor as well. While many motherboards contain video circuitry, this answer is not specific enough. If the video driver were corrupted, you would have the same problem on all displays.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      220,
      222,
      202,
      223,
      188
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 300,
    "question": "You have an inkjet printer. Recently, papers are being printed with excessive amounts of ink, and the ink is smearing. What is the most likely cause of the problem?",
    "choice_a": "A faulty ink cartridge",
    "choice_b": "A corrupted print driver",
    "choice_c": "A faulty fuser",
    "choice_d": "Too much humidity in the air",
    "correct_answer": "A",
    "explanation": "If an ink cartridge is faulty or develops a hole, it can release excessive amounts of ink, which will lead to smearing. A corrupted print driver would result in printing garbage. Inkjet printers do not have a fuser. Excessive humidity may cause smearing, but it wouldn\u2019t cause the disbursement of too much ink.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      235,
      236,
      188,
      190,
      191
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 301,
    "question": "When you print documents on your laser printer, you see residue from previous images on the output. Which two things are the most likely causes of this problem? (Choose two.)",
    "choice_a": "A faulty transfer corona wire",
    "choice_b": "An overheating printer",
    "choice_c": "A bad erasure lamp",
    "choice_d": "A broken cleaning blade",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Seeing images from previous print jobs is a phenomenon called ghosting (or ghost images). It\u2019s most likely due to a bad erasure lamp or a broken cleaning blade. If the transfer corona wire were faulty, there would likely be blank pages. An overheating printer will not necessarily leave residue behind.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      239,
      238,
      190,
      188,
      226
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 302,
    "question": "You support an old impact printer at work. When the printer prints, there is always a blank horizontal line in the middle of each line of output. What is the most likely cause of the problem?",
    "choice_a": "The print ribbon is old and needs to be replaced.",
    "choice_b": "The print ribbon is not advancing properly.",
    "choice_c": "The printhead needs to be replaced.",
    "choice_d": "The wrong print driver is installed.",
    "correct_answer": "C",
    "explanation": "If there is a consistent blank space, it likely means that a pin is not firing properly and the printhead needs to be replaced. If the print ribbon were old, you would have consistently faded printing. If the ribbon were not advancing properly, you would get light and dark printing. If the wrong driver were installed, you would get garbage.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      234,
      235,
      239,
      190,
      188
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 303,
    "question": "A user brings in an iPhone and the touchscreen is not responding. What should you do to try first to get the device functioning again?",
    "choice_a": "Hold the power button and the sleep/wake button for 10 seconds to reset the device.",
    "choice_b": "Restore the device to factory settings.",
    "choice_c": "Replace the battery in the device.",
    "choice_d": "Hold the power button for 10 seconds to force the device to power off.",
    "correct_answer": "D",
    "explanation": "The first step should be to try to reboot the device. In most cases with a frozen smartphone, holding the power button down for about 10 seconds will force it to power off. If that doesn\u2019t work, then you can move to trying to reset the phone by holding down the power button and the sleep/wake button for 10 seconds. There is no need to restore the device to factory settings (yet) or replace the battery.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      228,
      190,
      188,
      191,
      225
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 304,
    "question": "The stylus for your manager\u2019s tablet has stopped working. The tablet responds to input when you touch the screen with your finger. Which troubleshooting steps should you try next? (Choose three.)",
    "choice_a": "Replace the battery in the stylus.",
    "choice_b": "Replace the tip of the stylus.",
    "choice_c": "Replace the stylus sensor in the tablet.",
    "choice_d": "Shut down and restart the tablet.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Usually we say to check the easy stuff, and rebooting is almost always a good option. That might work here, but in this case, though, if the tablet seems to be performing normally but the stylus appears to be the problem, focus there. Many styluses have batteries that can go bad, or it\u2019s possible the tip has gone bad as well. There is no stylus sensor in tablets. The screen digitizer picks up the signal.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      228,
      190,
      188,
      227,
      191
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 305,
    "question": "When printing to a laser printer, all you get is random characters on the page. What is the first thing to try?",
    "choice_a": "Replace the formatter board in the laser printer.",
    "choice_b": "Reseat the printer cable.",
    "choice_c": "Reinstall the printer driver.",
    "choice_d": "Perform calibration to align the printheads.",
    "correct_answer": "C",
    "explanation": "If the printer is printing garbled output, the most likely cause of the problem is the print driver. Make sure it\u2019s the correct driver for the printer. Then, either update the driver, or remove the printer from the OS and reinstall it to get a new driver. It could be the formatter board too, but checking the print driver is far easier. If the printer cable were not seated properly, there likely would be no output. Laser printers do not have printheads.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      239,
      238,
      237,
      190,
      188
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 306,
    "question": "You are unable to charge an Android smartphone. You tried a second charger that is known to work, and the phone will still not charge. What should you do next?",
    "choice_a": "Replace the smartphone.",
    "choice_b": "Use the secondary auxiliary port to charge the smartphone.",
    "choice_c": "Use a DC charger instead of an AC charger.",
    "choice_d": "Try a different outlet.",
    "correct_answer": "D",
    "explanation": "If the charger works, what about the outlet? If the phone refuses to charge with either charger or outlet, try restarting the device. If it still won\u2019t charge, it could have a problem with the battery or the charging port. An AC versus DC adapter won\u2019t make a difference, and there are no secondary auxiliary ports on Android phones.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      225,
      230,
      190,
      188,
      191
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 307,
    "question": "You are connecting a laptop to a conference room\u2019s A/V system for a presentation using an HDMI cable. Your screen image appears on the displays, but when you play a video, there is no audio. When you unplug from the A/V system, the audio plays on your laptop. What should you do next?",
    "choice_a": "Use a DVI cable instead of an HDMI cable.",
    "choice_b": "Reboot the laptop and reconnect to the A/V system.",
    "choice_c": "Check the audio output settings on the laptop.",
    "choice_d": "Restart the A/V system and reconnect to the laptop.",
    "correct_answer": "C",
    "explanation": "If the video works but the audio doesn\u2019t, it\u2019s probably a settings issue. Either the audio output is set incorrectly, or the volume is turned down or muted. Check those things first. HDMI cables carry audio but DVI cables do not. Rebooting or restarting either device probably isn\u2019t necessary if it\u2019s a setting that\u2019s not configured properly.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      224,
      190,
      188,
      218,
      220
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 308,
    "question": "When an inkjet printer is printing jobs, it\u2019s making a squealing sound. What is most likely causing this problem?",
    "choice_a": "A failing stepper motor.",
    "choice_b": "Improperly refilled ink cartridges.",
    "choice_c": "The paper caliper is too thick.",
    "choice_d": "A failing formatter board.",
    "correct_answer": "A",
    "explanation": "Squealing or grinding noises are made by components that have moving parts. In this case, it\u2019s possibly a motor such as the stepper motor. Ink cartridges shouldn\u2019t be refilled but they won\u2019t make a squealing sound. Paper thickness won\u2019t cause squealing, nor will a failing formatter board.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      193,
      234,
      236,
      188,
      190
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 309,
    "question": "An office has a flat-screen monitor in the lobby that displays information for visitors. Recently, an employee changed the material in the slide that\u2019s always shown. Even though the new slide can be seen, the old slide material still appears faintly on the screen. What is the solution to the problem?",
    "choice_a": "Shut down and restart the monitor.",
    "choice_b": "Shut down the presentation software. Reopen it, delete the old slide completely, and then restart presentation mode.",
    "choice_c": "Degauss the monitor.",
    "choice_d": "Replace the monitor.",
    "correct_answer": "D",
    "explanation": "The symptom here is a display burn-in, also known as a ghost image. The only solution is to replace the monitor.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      221,
      222,
      202,
      223,
      190
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 310,
    "question": "An inkjet printer consistently feeds two or three pieces of paper for every page it\u2019s supposed to print. Which of the following could be the cause of the problem? (Choose two.)",
    "choice_a": "The paper moisture content is too high.",
    "choice_b": "The tension in the pickup tray needs to be adjusted.",
    "choice_c": "The printer is using the incorrect tray setting.",
    "choice_d": "The printer is using the incorrect page orientation.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Paper that is too damp, possibly due to high humidity, can become sticky, making the printer grab more than one sheet at a time. It could also be a tension issue in the paper pickup mechanism. Tray settings affect things like the size of paper or different types of paper such as envelopes. Orientation affects the width and height of output, and finishing issues are more often related to stapling or hole punching.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      236,
      235,
      241,
      190,
      188
    ],
    "source": "330034_Vol1_Ch13",
    "choice_e": "The printer is experiencing finishing issues."
  },
  {
    "id": 311,
    "question": "The video projector mounted to the ceiling in a conference room periodically shuts down during the middle of presentations without warning. When it shuts down, it won\u2019t power back on for about an hour. What should you check for?",
    "choice_a": "Ensure that the proper mounting bracket was used for the projector.",
    "choice_b": "Look for dust buildup in the projector\u2019s air filter.",
    "choice_c": "Ensure that the input source is set correctly.",
    "choice_d": "Look at the display settings to change the auto power-off time setting.",
    "correct_answer": "B",
    "explanation": "The projector is probably shutting off because it\u2019s overheating, and that can be caused by dust buildup in the air filter. Check that first, but preferably not when the projector is hot. The mounting bracket likely has nothing to do with it, unless it somehow covers the air intake. Input source will have nothing to do with shutting down and refusing to power back on. If the projector does have auto power-off, it will typically only do that after a certain period of inactivity.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      219,
      194,
      226,
      188,
      190
    ],
    "source": "330034_Vol1_Ch13"
  },
  {
    "id": 312,
    "question": "Which of the following does not contribute to the cooling of system components?",
    "choice_a": "Heat sink",
    "choice_b": "Motherboard",
    "choice_c": "Slot cover",
    "choice_d": "Fan",
    "correct_answer": "B",
    "explanation": "Motherboards do not aid in the cooling process. Heat sinks draw heat away from components and radiate it via fins. Fans on the heat sinks flush them with cooler air, and system fans help in removing warmer air from the system or introducing cooler air into the system. Slot covers ensure that the original airflow design of the system case is not compromised.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      22,
      21,
      25,
      24,
      47
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 313,
    "question": "Which of the following is <i>not</i> a term relating to CPUs?",
    "choice_a": "Multithreading",
    "choice_b": "I/O port",
    "choice_c": "Multicore",
    "choice_d": "L1 cache",
    "correct_answer": "B",
    "explanation": "The communication between a CPU and the rest of the system is considered I/O from the perspective of the CPU, but an I/O port is not used for this purpose. I/O ports, such as USB or sound ports, are not directly related to the CPU.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      3,
      11,
      10,
      30,
      63
    ],
    "source": "330034_Vol1_PT1",
    "choice_e": "System bus width"
  },
  {
    "id": 314,
    "question": "If a motherboard doesn\u2019t have a TPM module, what can be installed to provide the same functionality?",
    "choice_a": "HSM expansion card",
    "choice_b": "TPM expansion card",
    "choice_c": "Secure boot",
    "choice_d": "Nothing",
    "correct_answer": "A",
    "explanation": "Trusted Platform Module (TPM) is an encryption processor installed on a motherboard. If a motherboard doesn\u2019t have TPM, a hardware security module (HSM) expansion card can be added and provide similar functionality.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      5,
      2,
      30,
      9,
      1
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 315,
    "question": "You are troubleshooting a computer and think that the CMOS battery might be bad. Which of the following is <i>not</i> held in CMOS memory while the system power is off?",
    "choice_a": "Boot sequence",
    "choice_b": "BIOS passwords",
    "choice_c": "Operating system passwords",
    "choice_d": "Memory and CPU settings",
    "correct_answer": "C",
    "explanation": "The CMOS memory only stores hardware-level settings, not those related to operating systems. Those settings are kept in files maintained by the operating systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      5,
      31,
      20,
      7
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 316,
    "question": "Which of the following is an error-checking scheme that is not capable of error correction and sometimes implemented in main memory?",
    "choice_a": "ECC",
    "choice_b": "Dual-channel memory",
    "choice_c": "Asynchronous RAM",
    "choice_d": "Parity checking",
    "correct_answer": "D",
    "explanation": "Parity checking stores an extra bit with each byte in memory. If the check shows an error, the byte is rejected because there is no way to determine the nature of the error. ECC works differently, and it is capable of correcting single-bit errors. Dual-channel and asynchronous RAM are not error-checking schemes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      14,
      20,
      15,
      16,
      6
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 317,
    "question": "Which of the following enables a computer to support TPM?",
    "choice_a": "BIOS",
    "choice_b": "UEFI",
    "choice_c": "HSM",
    "choice_d": "ARM",
    "correct_answer": "B",
    "explanation": "The UEFI, which is an extension of the BIOS, enables security measures such as Trusted Platform Module (TPM). The BIOS itself cannot support TPM, only UEFI. HSM is an alternative to TPM, and ARM is a type of CPU.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      13,
      10,
      8,
      6
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 318,
    "question": "You are selecting a storage device for a client, and they request an energy-efficient drive. Which of the following should you install for the best efficiency?",
    "choice_a": "80 PLUS Platinum",
    "choice_b": "80 PLUS Bronze",
    "choice_c": "80 PLUS Ultimate",
    "choice_d": "80 PLUS",
    "correct_answer": "A",
    "explanation": "The most efficient option listed is the 80 PLUS Platinum. 80 PLUS Titanium is more efficient but isn\u2019t listed as an option. There is not currently an 80 PLUS Ultimate standard.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      47,
      45,
      46,
      33,
      4
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 319,
    "question": "You are purchasing SSDs for a RAID array. Which of the following RAID arrays requires at least four hard drives? (Choose all that apply.)",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 6",
    "correct_answer": [
      "D",
      "E"
    ],
    "explanation": "RAID 6 (double parity) and RAID 10 (mirrored stripe set) require at least four drives to implement. RAID 5 requires three drives, and RAID 0 and RAID 1 require two drives.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      37,
      35,
      36,
      40,
      33
    ],
    "source": "330034_Vol1_PT1",
    "choice_e": "RAID 10"
  },
  {
    "id": 320,
    "question": "You are choosing a flash technology for a school. Which of the following is <i>not</i> an example of a memory-card format?",
    "choice_a": "microSD",
    "choice_b": "microCF",
    "choice_c": "CF",
    "choice_d": "miniSD",
    "correct_answer": "B",
    "explanation": "There is no micro version of CompactFlash modules. MicroSD and miniSD are smaller versions of the SD format. CF is CompactFlash.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      38,
      34,
      35,
      20,
      4
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 321,
    "question": "Which component has a switch that might need to be changed when moving a computer from one country to another?",
    "choice_a": "M.2 expansion card",
    "choice_b": "PCIe expansion card",
    "choice_c": "Motherboard",
    "choice_d": "Power supply",
    "correct_answer": "D",
    "explanation": "Some power supplies have voltage selector switches that allow the power supply to be used in regions, such as North America, that have power grids based on voltages in the 110\u2013120 range with a 60Hz phase but then be moved to other regions, such as Europe, where voltages in the range of 220\u2013240 and a phase of 50 Hz are used. Expansion cards and motherboards do not need to be configured per country, because they draw their power from the power supply.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      41,
      43,
      47,
      7
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 322,
    "question": "You are installing a new power supply. What power-supply feature supports two independent sources of 12VDC for internal components?",
    "choice_a": "Auto switching",
    "choice_b": "Dual rail",
    "choice_c": "Switching vs. linear design",
    "choice_d": "Extended wattage",
    "correct_answer": "B",
    "explanation": "The dual-rail feature of modern power supplies provides independent 12VDC rails, which allow dedication of power to specific components, but which do not allow a single component to access the collective power from both rails.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      41,
      42,
      43,
      47,
      45
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 323,
    "question": "Which add-on card is needed to be able to record video from a computer so it can be edited?",
    "choice_a": "A capture card",
    "choice_b": "A video card",
    "choice_c": "A splitter",
    "choice_d": "A NIC",
    "correct_answer": "A",
    "explanation": "A capture card is needed to record video from a computer so it can be edited later.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      32,
      27,
      30,
      28,
      56
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 324,
    "question": "Which of the following statements is true regarding SATA and SAS hard drives?",
    "choice_a": "SATA and SAS hard drives are incompatible with each other\u2019s controllers.",
    "choice_b": "A SATA hard drive can connect to a SAS controller and work properly.",
    "choice_c": "A SAS hard drive can connect to a SATA controller and work properly.",
    "choice_d": "SATA and SAS hard drives can connect to each other\u2019s controllers and work properly.",
    "correct_answer": "B",
    "explanation": "A SATA hard drive can connect to a SAS controller and work properly. It won\u2019t get any of the benefits of SAS though, and will be slower. A SAS hard drive should never be connected to a SATA controller.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      4,
      62,
      40,
      37
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 325,
    "question": "What is the maximum number of devices that can be supported by USB?",
    "choice_a": "63",
    "choice_b": "127",
    "choice_c": "256",
    "choice_d": "16",
    "correct_answer": "B",
    "explanation": "Though it is unlikely that it would ever be necessary, a single USB chain can theoretically support 127 different peripheral devices. This includes scanners, cameras, MP3 players, printers, keyboards, and so on.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      58,
      56,
      57,
      30,
      7
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 326,
    "question": "Which of the following is the maximum speed difference between USB 2.0 and USB 3.0 cables?",
    "choice_a": "USB 2.0 is 480 Mbps and USB 3.0 is 5 Gbps.",
    "choice_b": "USB 2.0 is 5 Gbps and USB 3.0 is 10 Gbps.",
    "choice_c": "USB 2.0 is 10 Gbps and USB 3.0 is 20 Gbps.",
    "choice_d": "USB 2.0 is 12 Mbps and USB 3.0 is 480 Mbps.",
    "correct_answer": "A",
    "explanation": "The USB maximum speeds are as follows: 1.0 is 12 Mbps, 2.0 is 480 Mbps, 3.0 is 5 Gbps, 3.1 is 10 Gbps, 3.2 is 20 Gbps, and USB4 is 20 Gbps or 40 Gbps. Each version can slow down to older version speeds, or to low speed which is 1.5 Mbps.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      56,
      57,
      30,
      63,
      2
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 327,
    "question": "In Windows 11, you just changed resolutions on a monitor. The new display is warped and unreadable. What\u2019s the easiest way to fix the issue?",
    "choice_a": "Turn the monitor off and back on again.",
    "choice_b": "Unplug the monitor, wait 5 second, and plug it back in and turn it on.",
    "choice_c": "Wait 15 seconds for the settings to revert to the previous resolution.",
    "choice_d": "Reinstall the video card driver.",
    "correct_answer": "C",
    "explanation": "After changing video settings such as resolution or refresh rate, Windows will give you 15 seconds to accept the new settings or revert back to the previous settings. If you do nothing, it will revert back.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      51,
      31,
      27,
      53,
      52
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 328,
    "question": "Which of the following is definitely an analog video technology?",
    "choice_a": "DVI",
    "choice_b": "HDMI",
    "choice_c": "DisplayPort",
    "choice_d": "VGA",
    "correct_answer": "D",
    "explanation": "VGA is an analog video technology. DVI could be analog (DVI-A) or digital (DVI-D). HDMI and DisplayPort are digital technologies.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      63,
      61,
      59,
      62
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 329,
    "question": "You have a keyboard with a round purple connector and need to attach it to a desktop computer that does not have that type of port. Which of the following adapters should you use to make the connection?",
    "choice_a": "IDE to USB",
    "choice_b": "Serial to USB",
    "choice_c": "micro-USB to USB",
    "choice_d": "PS/2 to USB",
    "correct_answer": "D",
    "explanation": "Older keyboards and mice might have used a PS/2 connector, which is a round 6-pin connector. Keyboards had purple connectors and mouse connectors were green. A PS/2 to USB adapter is what you need.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      63,
      57,
      56,
      60,
      62
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 330,
    "question": "In looking up the specs on a new monitor, you notice that the default resolution is 1920 x 1080. What does that mean? (Choose two.)",
    "choice_a": "That there is a matrix of 1920 pixels wide by 1080 pixels high per inch in the monitor.",
    "choice_b": "The only resolution allowed is 1920 x 1080.",
    "choice_c": "The monitor has an aspect ratio of 16:9.",
    "choice_d": "The monitor has an aspect ratio of 16:10.",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "The default resolution refers to the number of pixels wide and tall the monitor supports by default. Pixels per inch is a measure of pixel density, not resolution. This monitor is 16:9, because that\u2019s the ratio of 1920 to 1080 (1920 divided by 1080 is 1.78).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      51,
      53,
      48,
      49,
      52
    ],
    "source": "330034_Vol1_PT1",
    "choice_e": "That there is a matrix of 1920 pixels wide by 1080 pixels high across the entire the monitor."
  },
  {
    "id": 331,
    "question": "You need to replace memory in an older laptop. Which of the following standard is the most likely one that you will find?",
    "choice_a": "MiniDIMM",
    "choice_b": "MicroDIMM",
    "choice_c": "SlotDIMM",
    "choice_d": "SODIMM",
    "correct_answer": "D",
    "explanation": "The two laptop memory form factor standards are the SODIMM and the MicroDIMM. MicroDIMMs are not nearly as popular as SODIMMs. There is no MiniDIMM or SlotDIMM memory.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      64,
      71,
      65,
      67
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 332,
    "question": "You are replacing a Mini PCIe wireless card in an older laptop. What type of connector does a Mini PCIe card have?",
    "choice_a": "52-pin card edge",
    "choice_b": "66-pin card edge",
    "choice_c": "100-pin card edge",
    "choice_d": "124-pin card edge",
    "correct_answer": "A",
    "explanation": "Mini PCIe cards have 52-pin card edge connectors. M.2 slots have 66 pins. There is a legacy Mini PCI card standard and those devices used either a 100-pin stacking connector or a 124-pin card edge connector. (You won\u2019t be tested on Mini PCI.).",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      71,
      64,
      67,
      69,
      68
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 333,
    "question": "You are replacing an LCD display on a laptop. Which LCD component is responsible for providing the right kind of power to the display?",
    "choice_a": "Backlight",
    "choice_b": "Inverter",
    "choice_c": "Screen",
    "choice_d": "Backdrop",
    "correct_answer": "B",
    "explanation": "The inverter provides power to the backlight. The backlight provides light to the LCD screen, and the screen displays the picture. There is no backdrop component.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      64,
      65,
      71,
      67
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 334,
    "question": "Which of the following statements is true about OLEDs versus LCDs?",
    "choice_a": "OLED cells will decay quicker than LCDs because they are organic.",
    "choice_b": "OLED types include IPS, TN, and VA.",
    "choice_c": "OLEDs don\u2019t need a backlight.",
    "choice_d": "OLEDs don\u2019t need an inverter.",
    "correct_answer": "C",
    "explanation": "OLEDs don\u2019t need a backlight, because the OLED itself provides the light. They do need a power inverter still. Even though they are named organic light emitting diodes, you do not need to worry about them decaying at any appreciable rate. LCD types include IPS, TN, and VA.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      66,
      64,
      67,
      71,
      70
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 335,
    "question": "Which of the following laptop accessories is both an input and output device?",
    "choice_a": "Stylus",
    "choice_b": "Headset",
    "choice_c": "Speakers",
    "choice_d": "Webcam",
    "correct_answer": "B",
    "explanation": "A headset has speakers and a microphone, so it is both input and output. A stylus and a webcam are input-only, and speakers are output-only.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      66,
      70,
      71,
      64,
      65
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 336,
    "question": "Your office has two printers. The manager calls and tells you to come replace the multipart paper in the printer because it\u2019s out. Which printer should you service?",
    "choice_a": "Inkjet",
    "choice_b": "Impact",
    "choice_c": "Laser",
    "choice_d": "Thermal",
    "correct_answer": "B",
    "explanation": "Impact printers are capable of using multipart paper. None of the other printer types impact the paper; therefore, they can\u2019t take advantage of printing on multipart paper.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      75,
      76,
      96
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 337,
    "question": "Users are complaining that the ink is smudging on laser printer output. Which stage of a laser printer process melts the toner onto the paper?",
    "choice_a": "Exposing",
    "choice_b": "Charging",
    "choice_c": "Fusing",
    "choice_d": "Transferring",
    "correct_answer": "C",
    "explanation": "The drum is first charged to prepare for the exposing stage, which charges the print pattern onto the drum. After toner is applied to the drum, the toner is transferred to paper. At this point the toner is melted and fused to the paper by using heat.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      80,
      79,
      77,
      96,
      78
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 338,
    "question": "Which benefits of a USB connection make it the popular choice for printers? (Choose all that apply.)",
    "choice_a": "It automatically recognizes new devices.",
    "choice_b": "It has a higher transfer rate than a parallel connection.",
    "choice_c": "It has a higher transfer rate than a serial connection.",
    "choice_d": "It allows the printer to communicate with networks, servers, and workstations.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "The rate of transfer and the ability to automatically recognize new devices are two of the major advantages that make USB a popular type of printer interface. However, it is the network printer interface that allows the printer to communicate with networks, servers, and workstations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      56,
      58,
      89,
      91
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 339,
    "question": "A technician is preparing to perform thermal printer maintenance. Which of the following should they consider?",
    "choice_a": "Replace toner, apply maintenance kit, calibrate, clean.",
    "choice_b": "Replace paper, clean heating element, remove debris.",
    "choice_c": "Replace ribbon, replace printhead, replace paper.",
    "choice_d": "Clean heads, replace cartridges, calibrate, clear jams.",
    "correct_answer": "B",
    "explanation": "Thermal printer maintenance includes: replace paper, clean heating element, remove debris. Inkjet printer maintenance includes: clean printheads, replace cartridges, calibrate, clear jams. Laser printer maintenance includes: replace toner, apply maintenance kit, calibrate, clean. Impact printer maintenance includes: replace ribbon, replace printhead, replace paper.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81,
      96,
      74,
      73,
      77
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 340,
    "question": "You are working with a laser printer. Which of the following components offers the greatest risk to technicians?",
    "choice_a": "Fuser",
    "choice_b": "Refuser",
    "choice_c": "Corona wire",
    "choice_d": "Drum",
    "correct_answer": "A",
    "explanation": "When you are working with laser printers, the device most likely to cause damage is the fuser. The fuser works at high temperatures and can cause a burn.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      79,
      80,
      77,
      78,
      74
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 341,
    "question": "Which of the following is the most common paper feed mechanism associated with an impact printer?",
    "choice_a": "Gravity feed",
    "choice_b": "Impact feed",
    "choice_c": "Tractor feed",
    "choice_d": "Dual feed",
    "correct_answer": "C",
    "explanation": "Impact printers often use tractor feed mechanisms. They are designed to pull or weave the paper through the printer. Some can use regular printer paper.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      75,
      78,
      96
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 342,
    "question": "You are configuring a new laser printer. Users want to have both letter-sized paper and legal-sized paper automatically available. Which configuration setting do you need to change?",
    "choice_a": "Duplex",
    "choice_b": "Orientation",
    "choice_c": "Tray settings",
    "choice_d": "Quality",
    "correct_answer": "C",
    "explanation": "Having multiple paper trays in a laser printer lets the printer automatically supply different paper sizes. To configure which tray has which type of paper, change the tray settings configuration option. Duplex is for two-sided printing. Orientation is for portrait or landscape, and quality affects options such as resolution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      78,
      75,
      89,
      96
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 343,
    "question": "When users want to access the company MFD, they are required to type in their account name on the MFD touchscreen. What is this an example of?",
    "choice_a": "User authentication",
    "choice_b": "Badging",
    "choice_c": "Audit logs",
    "choice_d": "Secured prints",
    "correct_answer": "A",
    "explanation": "The users are being required to log in to the MFD, so this is user authentication. Badging is similar but the user can use their company ID to log in instead of typing in their credentials. Audit logs track who printed, and secured prints will hold a job until the user arrives at the printer and tells it to start printing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      54,
      92,
      90,
      95
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 344,
    "question": "Which networking device transforms data into the format needed to be transmitted over a physical medium?",
    "choice_a": "Switch",
    "choice_b": "Firewall",
    "choice_c": "Repeater",
    "choice_d": "NIC",
    "correct_answer": "D",
    "explanation": "The network interface card (NIC) is responsible for transforming the data into the proper format needed to transmit over the network. Switches, firewalls, and repeaters will each take the data received and pass it along as is appropriate, but they do not transform data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      106,
      107,
      109,
      152
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 345,
    "question": "You need to run network cables outside to support a music festival. Which type of cabling should you use for this?",
    "choice_a": "Direct burial",
    "choice_b": "STP",
    "choice_c": "UTP",
    "choice_d": "Fiber-optic",
    "correct_answer": "A",
    "explanation": "For outdoor use, direct burial cable is recommended because it has extra shielding and is designed to be waterproof. Direct burial cable is a type of shielded twisted pair (STP). Unshielded twisted pair (UTP) does not have the shielding to be used outside. Standard fiber-optic cable does not either.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      111,
      110,
      113,
      146,
      156
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 346,
    "question": "You have been asked to install a network cable that offers the greatest level of resistance to electromagnetic interference (EMI). Which of the following network media would you select?",
    "choice_a": "Coaxial",
    "choice_b": "Fiber-optic",
    "choice_c": "Direct burial",
    "choice_d": "Twisted pair",
    "correct_answer": "B",
    "explanation": "Because fiber-optic cables use light pulses over a glass fiber as opposed to electrical signals over a copper conductor, fiber-optic cable is not susceptible to EMI. Coaxial and twisted pair are copper cables, so they are susceptible to EMI. Direct burial is a type of STP and is made of copper as well.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      113,
      110,
      111,
      116,
      106
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 347,
    "question": "Which of the following communication technologies is designed for a network known as a PAN?",
    "choice_a": "Cellular",
    "choice_b": "Wi-Fi",
    "choice_c": "Bluetooth",
    "choice_d": "Ethernet",
    "correct_answer": "C",
    "explanation": "Bluetooth was made to work as a wireless personal area network (WPAN). As such, it\u2019s perfect for computer peripherals such as keyboards, mice, and wireless headsets. Cellular, Wi-Fi, and Ethernet networks do not connect as PANs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      145,
      99,
      102,
      107
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 348,
    "question": "Which of the following network types makes use of block-level storage?",
    "choice_a": "WAN",
    "choice_b": "PAN",
    "choice_c": "SAN",
    "choice_d": "WLAN",
    "correct_answer": "C",
    "explanation": "A storge area network (SAN) uses block-level storage for more efficient data storage. A wide area network (WAN) is a network that spans multiple geographic locations. A personal area network (PAN) is a small Bluetooth-based network. A wireless local area network (WLAN) is a smaller network that employes wireless communication.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      101,
      99,
      100,
      102,
      114
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 349,
    "question": "Which TCP/IP protocol uses port 23?",
    "choice_a": "HTTP",
    "choice_b": "SMTP",
    "choice_c": "Telnet",
    "choice_d": "POP3",
    "correct_answer": "C",
    "explanation": "Telnet uses port 23. HTTP uses port 80, SMTP uses port 25, and POP3 uses port 110.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      128,
      119,
      117
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 350,
    "question": "You are configuring an IPv6 client on your network. Which of the following are valid ways to assign the interface ID portion of the IP address to the network card? (Choose all that apply.)",
    "choice_a": "Obtain the address from a DHCPv6 server.",
    "choice_b": "Assign the address based on the CPU\u2019s ID.",
    "choice_c": "Configure the address manually.",
    "choice_d": "Assign a random address.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "IPv6 interface IDs can be assigned in one of four ways. They can be assigned through a DHCPv6 sever, based on the MAC address of the adapter, configured manually, or assigned randomly. They cannot be assigned based on any of the CPU\u2019s identifying information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      130,
      108,
      117,
      109
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 351,
    "question": "Which of the following IPv4 addresses is not valid for routing on the Internet?",
    "choice_a": "155.128.1.269",
    "choice_b": "172.61.2.143",
    "choice_c": "192.186.198.198",
    "choice_d": "133.22.240.121",
    "correct_answer": "A",
    "explanation": "The address 155.128.1.269 is invalid, because all IPv4 addresses must use numbers in the 0\u2013255 range. All of the other addresses are valid addresses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      123,
      124,
      118,
      106
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 352,
    "question": "Which of the following protocols can be used by a client to send email to an email server?",
    "choice_a": "POP3",
    "choice_b": "SMTP",
    "choice_c": "IMAP",
    "choice_d": "FTP",
    "correct_answer": "B",
    "explanation": "SMTP is for sending email to an email server. The IMAP and POP3 protocols can be used to retrieve email from mail servers. FTP is for file transfers.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      120,
      119,
      106,
      117,
      128
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 353,
    "question": "While configuring your firewall, you inadvertently block port 443. Which of the following will be unavailable?",
    "choice_a": "HTTPS",
    "choice_b": "HTTP",
    "choice_c": "SSL",
    "choice_d": "Telnet",
    "correct_answer": "A",
    "explanation": "Hypertext Transfer Protocol (Secure) is a combination of HTTP with Secure Sockets Layer (SSL) or Transport Layer Security (TLS) to make for a secure connection. It uses port 443 by default, and the beginning of the site address becomes <code>https://</code>. Telnet is an insecure terminal emulation protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      126,
      155,
      119,
      106
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 354,
    "question": "What does the CIFS protocol do?",
    "choice_a": "Translates private IP addresses into public IP addresses",
    "choice_b": "Allows for remote login to workstations",
    "choice_c": "Allows computers to talk to each other using APIs",
    "choice_d": "Provides file and printer sharing",
    "correct_answer": "D",
    "explanation": "The Common Internet File System (CIFS) is the TCP/IP protocol that uses port 445. It is used to share files and printers between computers, regardless of the operating system that they run. Network Address Translation (NAT) is a service that translates private, nonroutable IP addresses into public addresses that can be used on the Internet. RDP (port 3389) is the Remote Desktop Protocol. NetBT (137-139) lets computers talk to each other using APIs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      120,
      215,
      124,
      155
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 355,
    "question": "Your network has two subnets separated by a router. To make network administration easier, you install a DHCP server on subnet A. Clients on subnet B are not getting IP addresses automatically. What is the best way to resolve this?",
    "choice_a": "Install a DHCP relay agent on subnet A.",
    "choice_b": "Install a DHCP relay agent on subnet B.",
    "choice_c": "Install a second DHCP server on subnet B.",
    "choice_d": "Configure the router to forward broadcast messages.",
    "correct_answer": "B",
    "explanation": "DHCP requests are made via broadcast and will not travel through the router. It\u2019s never a good idea to allow routers to forward broadcasts. You could install a second DHCP server, but that\u2019s inefficient. Install a DHCP relay agent on subnet B.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      130,
      114,
      118,
      125
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 356,
    "question": "You are configuring two email servers on your company\u2019s network, and they are on opposite sides of a router. Which port do you need to make sure is open to traffic for the servers to be able to transfer mail to each other?",
    "choice_a": "23",
    "choice_b": "25",
    "choice_c": "110",
    "choice_d": "143",
    "correct_answer": "B",
    "explanation": "The SMTP protocol is used to transfer email between servers, and it uses port 25. Telnet uses port 23, POP3 uses 110, IMAP4 uses 143, and HTTPS uses 443.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      120,
      128,
      155,
      121,
      114
    ],
    "source": "330034_Vol1_PT1",
    "choice_e": "443"
  },
  {
    "id": 357,
    "question": "What type of server is most likely to be running Microsoft SQL?",
    "choice_a": "Fileshare",
    "choice_b": "Print",
    "choice_c": "AAA",
    "choice_d": "Database",
    "correct_answer": "D",
    "explanation": "Microsoft SQL is a database package, so it\u2019s most likely a database server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      102,
      130,
      129,
      103
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 358,
    "question": "Which of the following Internet appliances specifically helps protect against malicious email? (Choose two.)",
    "choice_a": "Spam gateway",
    "choice_b": "UTM",
    "choice_c": "Load balancer",
    "choice_d": "Web proxy server",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Spam gateways are specifically designed to help protect against spam email. Unified threat management (UTM) devices also typically help protect against spam. Load balancers and proxy servers do not. They help spread the workload and make requests on behalf of clients, respectively.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      135,
      134,
      136,
      131,
      102
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 359,
    "question": "What type of network appliance can help prevent web servers from becoming overloaded during peak traffic times?",
    "choice_a": "Spam gateway",
    "choice_b": "UTM",
    "choice_c": "Load balancer",
    "choice_d": "Proxy server",
    "correct_answer": "C",
    "explanation": "A load balancer spreads out incoming network traffic workload among different servers. One can be used to help spread traffic during peak hours so one server isn\u2019t overloaded. Spam gateways help protect uses from spam email. UTM protects against network threats, and proxy servers make requests on behalf of other devices.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      134,
      135,
      155,
      114,
      99
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 360,
    "question": "Which of the following wireless networking frequencies is able to transmit the most amount of data at one time?",
    "choice_a": "2.4 GHz",
    "choice_b": "5 GHz",
    "choice_c": "6 GHz",
    "choice_d": "10 MHz",
    "correct_answer": "C",
    "explanation": "Higher frequencies are able to transmit more data at once than lower frequencies are. Therefore, 6 GHz can transmit more than 5 GHz or 2.4 GHz. 10 MHz would be the lowest, but it\u2019s not used for wireless networks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      142,
      143,
      144,
      140
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 361,
    "question": "Which of the following are types of broadband access? (Choose all that apply.)",
    "choice_a": "Dial-up",
    "choice_b": "DSL",
    "choice_c": "Cable",
    "choice_d": "Fiber-optic",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Dial-up is the predecessor to broadband access. Available broadband methods include DSL, cable, fiber-optic, and satellite.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      147,
      148,
      149,
      150,
      151
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 362,
    "question": "Which of the following standards supports communications up to 46 Gbps?",
    "choice_a": "802.11ax",
    "choice_b": "802.11ac",
    "choice_c": "802.11be",
    "choice_d": "802.11gb",
    "correct_answer": "C",
    "explanation": "The 802.11be (Wi-Fi 7) standard supports speeds up to 46 Gbps. 802.11ac (Wi-Fi 5) has a PHY speed of 6.9 Gbps and 802.11ax (Wi-Fi 6) is 9.6 Gbps. There is no 802.11gb Wi-Fi standard.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      143,
      142,
      141,
      140
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 363,
    "question": "Which of the following is the best way to ensure that only clients with the correct hardware addresses access your wireless router?",
    "choice_a": "Enable MAC filtering.",
    "choice_b": "Disable SSID broadcasts.",
    "choice_c": "Leave the SSID as the default.",
    "choice_d": "Use WPA3 instead of WPA2.",
    "correct_answer": "A",
    "explanation": "Enabling MAC filtering only allows specific computers to use the wireless router. Disabling an SSID broadcast makes it so the router doesn\u2019t broadcast its name, which can make it seem \u201cinvisible\u201d to a casual snoop. It\u2019s not a reliable security procedure, though. Changing the SSID from the default is always a good idea. WPA3 is more secure than WPA2 but has nothing to do with the MAC address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      152,
      153,
      131,
      107
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 364,
    "question": "OFDMA was introduced with which 802.11 standard?",
    "choice_a": "802.11ac",
    "choice_b": "802.11ax",
    "choice_c": "802.11be",
    "choice_d": "802.11n",
    "correct_answer": "B",
    "explanation": "Orthogonal Frequency Division Multiple Access (OFDMA) was introduced with 802.11ax (Wi-Fi 6). It\u2019s an enhancement on OFDM, which had a limitation that it could only transmit to one recipient at a time. OFDMA can handle communications with several clients at once.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      143,
      140,
      141,
      138,
      107
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 365,
    "question": "Which standard was the first to introduce the use of 40 MHz wireless channels?",
    "choice_a": "802.11be",
    "choice_b": "802.11ac",
    "choice_c": "802.11g",
    "choice_d": "802.11n",
    "correct_answer": "D",
    "explanation": "An older legacy standard, 802.11n was the first to use 40 MHz channels. 802.11n was the first Wi-Fi standard to have a PHY rate over 100 Mbps (600 Mbps), partially due to bonding 20 MHz channels together.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      143,
      142,
      144,
      140
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 366,
    "question": "What can disabling cellular data networking on a mobile device accomplish?",
    "choice_a": "Prevent large updates from occurring",
    "choice_b": "Prevent overages in the subscriber\u2019s data plan",
    "choice_c": "Force calls to go out over Wi-Fi",
    "choice_d": "Allow use of caller ID to reject unwanted incoming calls",
    "correct_answer": "B",
    "explanation": "Use of the cellular data network counts against the subscriber\u2019s monthly data plan. Disabling the cellular data connection does not change how calls are processed or presented. Updates will not occur over the cellular network when cellular data is disabled but can still occur over Wi-Fi.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      163,
      159,
      157,
      162,
      171
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 367,
    "question": "You are in a location with no Wi-Fi connectivity, but you have cellular reception. You need to have your Wi-Fi\u2013enabled laptop send an urgent email. How can you have the laptop use Wi-Fi to send the email?",
    "choice_a": "Use the smartphone to create a mobile hotspot.",
    "choice_b": "Use the smartphone to create a Wi-Fi hotspot.",
    "choice_c": "Use the laptop to create a mobile hotspot.",
    "choice_d": "Use the laptop to create a Wi-Fi hotspot.",
    "correct_answer": "A",
    "explanation": "By creating a mobile hotspot, the smartphone will allow the laptop to connect to it using Wi-Fi. Then use the cellular connection on the phone to get on the Internet.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      157,
      162,
      159,
      170,
      171
    ],
    "source": "330034_Vol1_PT1",
    "choice_e": "There is no Wi-Fi connectivity, so there is no way to send the email."
  },
  {
    "id": 368,
    "question": "A user wants to ensure that all contacts from her mobile device are copied onto her computer before migrating to a new device. Which of the following processes can accomplish this?",
    "choice_a": "Mirroring",
    "choice_b": "Synchronization",
    "choice_c": "Calling each contact",
    "choice_d": "Attaching the contacts to an email",
    "correct_answer": "B",
    "explanation": "Synchronization can copy all contacts and calendars between a mobile device and a computer. Mirroring is a term reserved for when devices replicate themselves to similar devices. Calling the contacts won\u2019t achieve the desired result, and emailing contacts is inefficient and does not immediately result in placing the contacts on the computer.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      171,
      172,
      173,
      69,
      160
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 369,
    "question": "Which of the following is an Internet mail protocol used to send email from a mobile device?",
    "choice_a": "IMAP4",
    "choice_b": "POP3",
    "choice_c": "Exchange",
    "choice_d": "SMTP",
    "correct_answer": "D",
    "explanation": "Simple Mail Transfer Protocol (SMTP) is used for sending Internet (TCP/IP-based) mail from a client to a recipient\u2019s server. IMAP4 and POP3 are used for retrieving mail, and Exchange is a proprietary messaging system, not an Internet protocol.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      170,
      172,
      171,
      157,
      159
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 370,
    "question": "Which of the following provides applications such as office productivity suites?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "AaaS",
    "correct_answer": "C",
    "explanation": "Software as a service (SaaS) provides applications such as office productivity suites. Infrastructure as a service (IaaS) and platform as a service (PaaS) do not. There is no AaaS in the A+ exam objectives.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      182,
      186,
      180,
      183,
      185
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 371,
    "question": "Which feature of cloud computing refers to the ability to obtain additional storage space or processing power at a moment\u2019s notice?",
    "choice_a": "Elasticity",
    "choice_b": "Availability",
    "choice_c": "Shared resources",
    "choice_d": "Metered utilization",
    "correct_answer": "A",
    "explanation": "The ability to quickly expand services is called elasticity, or rapid elasticity. Availability guarantees uptime for services. Shared resources is taking resources from multiple machines and making them available as one pool. Metered utilization is how many suppliers track usage and charge accordingly.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      183,
      180,
      182,
      184,
      181
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 372,
    "question": "If a company wants to share the responsibility of cloud management with another company with similar interests, which type of cloud is likely best for them?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Hybrid",
    "choice_d": "Community",
    "correct_answer": "D",
    "explanation": "A community cloud is a semi-public one that is owned and managed by two or more organizations with similar interests. Public clouds are owned by cloud providers, and private ones by one company. Hybrid clouds are a combination of public and private ones.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      181,
      180,
      183,
      182,
      184
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 373,
    "question": "Which of the following should be used if a user wants to virtualize an application but not hardware?",
    "choice_a": "Container",
    "choice_b": "Type 1 hypervisor",
    "choice_c": "Type 2 hypervisor",
    "choice_d": "VDI",
    "correct_answer": "A",
    "explanation": "Containers are used to quickly deploy single apps and all of the files needed to run them, regardless of what platform (OS) the user is using. Hypervisors virtualize entire machines. VDI is the virtual desktop infrastructure.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      177,
      175,
      176,
      174,
      178
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 374,
    "question": "On the network, there is a server that contains four virtual servers. The virtual servers need to communicate with each other. Which of the following is true for the network requirements of these four virtual servers?",
    "choice_a": "Each virtualized compuer needs a virtual NIC and a physical NIC.",
    "choice_b": "Each virtualized compuer needs a physical NIC, but there is no virtual NIC requirement.",
    "choice_c": "Each virtualized server needs a virtual NIC, but there is no physical NIC requirement.",
    "choice_d": "Each virtualized server needs a virtual NIC and only one physical NIC is required.",
    "correct_answer": "C",
    "explanation": "Virtual servers will be assigned to a virtual NIC. Normally, that virtual NIC will be linked to a physical NIC. If all four virtual servers are on the same computer, however, they don\u2019t need a physical NIC to communicate. Their communication will be managed by the virtual NICs and a virtual switch.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      178,
      176,
      174,
      179,
      177
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 375,
    "question": "A computer you are troubleshooting can\u2019t get on the Internet or access local resources. You run <code>IPCONFIG</code> and the system has an IP address of 169.254.18.36 and a subnet mask of 255.255.0.0. Computers on the network get their IP configuration information from a DHCP server. What appears to be the issue?",
    "choice_a": "Incorrect subnet mask.",
    "choice_b": "The network card is failing.",
    "choice_c": "The client cannot reach the DHCP server.",
    "choice_d": "There is an IP address conflict.",
    "correct_answer": "C",
    "explanation": "If a DHCP client can\u2019t access a DHCP server, it will autoconfigure with an APIPA address. Any address starting with 169.254.x.x is an APIPA address. Such systems will not be able to get on the Internet, or access local resources unless those resources somehow have an APIPA address as well.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      211,
      216,
      212,
      188,
      190
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 376,
    "question": "Every time you turn a laptop computer on, you need to reenter the correct time and date. What is the most likely cause of the problem?",
    "choice_a": "Failed CMOS battery",
    "choice_b": "Corrupted BIOS",
    "choice_c": "Failed motherboard",
    "choice_d": "Incorrect POST settings",
    "correct_answer": "A",
    "explanation": "Whenever a system fails to hold the time and date when it\u2019s powered off, the most likely culprit is the CMOS battery. It\u2019s a lot like a watch battery and is usually easy to replace. Simply replace it, and the system should work normally.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      195,
      188,
      190,
      226,
      225
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 377,
    "question": "You turn a desktop computer on but the screen stays blank. You can see the power button light is on and the hard drive light is flickering occasionally. What is the most likely cause of the problem?",
    "choice_a": "Failed HDD",
    "choice_b": "Dead CMOS battery",
    "choice_c": "Failed motherboard",
    "choice_d": "Bad video cable",
    "correct_answer": "D",
    "explanation": "If the power light and hard drive lights are working, the system is getting power. The most likely culprit is in the chain of the video system\u2014the video card, cable, or monitor. A failed hard drive will cause system errors on boot about not being able to locate the hard drive. A dead CMOS battery would make the system forget the time/date or boot settings. A failed motherboard will make the system inoperable. A faulty power supply would provide no power to the desktop.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      202,
      196,
      188,
      201,
      195
    ],
    "source": "330034_Vol1_PT1",
    "choice_e": "Faulty power supply"
  },
  {
    "id": 378,
    "question": "A network administrator is reporting intermittent connectivity issues for a wired network client. It appears that the switch port is rapidly opening and closing. Which of the following could cause this problem? (Choose two.)",
    "choice_a": "A failing network cable",
    "choice_b": "Incorrect SSID configuration",
    "choice_c": "Too many clients on the network",
    "choice_d": "A failing SFP connector",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The issue sounds like port flapping. This can be caused by a failing cable, a bad or failing small form factor pluggable (SFP) connector, a speed or duplex mismatch, or a failing port on the switch. SSID configuration is only valid for wireless networks. Too many clients on a network could lead to slow network speeds, but not a port flapping issue.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      216,
      209,
      217,
      190,
      188
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 379,
    "question": "A drive letter associated with a user\u2019s RAID 5 array is not showing up in Windows File Explorer. What could be causing this problem? (Choose two.)",
    "choice_a": "Bad RAID controller",
    "choice_b": "Failed hard drive",
    "choice_c": "Capacitor swelling",
    "choice_d": "Incorrect POST settings",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "A missing RAID array could be caused by a bad RAID controller, a bad cable, or a failed hard drive. Hard drives don\u2019t have capacitors to swell. An incorrect BIOS/UEFI setting might cause the array to disappear, but a POST setting specifically won\u2019t be the problem.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      208,
      205,
      204,
      196,
      188
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 380,
    "question": "A UTP cable that runs through the wall appears to have failed. You go to the server closet and see that there are six unmarked cables coming from the conduit that runs through that wall. Which tool can help you identify the cable that runs to your destination?",
    "choice_a": "Punchdown tool",
    "choice_b": "Network tap",
    "choice_c": "Cable tester",
    "choice_d": "Toner probe",
    "correct_answer": "D",
    "explanation": "To trace a cable from one location to another, use a toner probe. A punchdown tool fastens wires to a 110-block. Network taps monitor network traffic. A cable tester can determine if a cable is working or not.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      116,
      112,
      111,
      146,
      109
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 381,
    "question": "You support an old impact printer at work. When the printer prints, the text always goes from darker to lighter as it moves across the page. What is the most likely cause of the problem?",
    "choice_a": "The print ribbon is old and needs to be replaced.",
    "choice_b": "The print ribbon is not advancing properly.",
    "choice_c": "The printhead needs to be replaced.",
    "choice_d": "The wrong print driver is installed",
    "correct_answer": "B",
    "explanation": "If an impact printer outputs dark to light across a page, that means that the printer ribbon is not advancing properly; the gear likely needs to be replaced. If the output were consistently faded, then you would replace the ribbon.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      234,
      190,
      188,
      189,
      193
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 382,
    "question": "What would be the first step to perform if you are getting garbled print jobs?",
    "choice_a": "Check the printer cable.",
    "choice_b": "Reinstall the print driver.",
    "choice_c": "Change the font used in the print job.",
    "choice_d": "Replace the toner cartridge.",
    "correct_answer": "B",
    "explanation": "Garbled print usually indicates an invalid or out-of-date print driver. If there were a cabling issue, the printer would not print at all. Bad toner would tend to produce faint or blurry print jobs.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      190,
      188,
      189,
      239,
      235
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 383,
    "question": "A user is having difficulty printing to a network printer. Other users are using the printer without a problem. What should you try first?",
    "choice_a": "Print a test page from the user\u2019s computer.",
    "choice_b": "Delete and reinstall the printer.",
    "choice_c": "Print a test page by using the printer\u2019s self test.",
    "choice_d": "Open Microsoft Word and try to print a document.",
    "correct_answer": "A",
    "explanation": "Printing a test page is the best place to start. If that does not work you may want to delete and reinstall the printer. Printing a test page using the printer\u2019s self-test will only tell you if the printer is printing fine, not if that one user is having a problem. Always use the test page feature from the printer properties, not from an application, to test printing.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      190,
      188,
      189,
      242,
      237
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 384,
    "question": "One laser printer in your office keeps getting frequent paper jams. What is the most likely cause of the problem?",
    "choice_a": "Worn paper feed rollers.",
    "choice_b": "Faulty stepper motor.",
    "choice_c": "Faulty fuser assembly.",
    "choice_d": "The EP drum isn\u2019t advancing properly.",
    "correct_answer": "A",
    "explanation": "The most likely cause of those listed is a worn paper feed roller. Stepper motors control the back-and-forth motion of a printhead in an inkjet printer. If the fuser assembly were faulty, the images would smear. If the EP drum doesn\u2019t advance properly, multiple parts of the image will appear on top of each other.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      236,
      234,
      239,
      238,
      188
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 385,
    "question": "A user dropped their smartphone in a swimming pool, and now the device won\u2019t turn on. What should their next step be?",
    "choice_a": "Replace the smartphone.",
    "choice_b": "Dry the smartphone off. Let the smartphone dry out for 48 hours and then try turning it on.",
    "choice_c": "Dry the smartphone off. Plug the smartphone into its charger and let it fully recharge.",
    "choice_d": "Dry the smartphone off. Wrap the smartphone in plastic wrap for 48 hours and then try turning it on.",
    "correct_answer": "B",
    "explanation": "The device may be salvageable. Dry the smartphone thoroughly, then let it air dry (or try the \u201crice trick\u201d) for 48 hours. After that, try powering it back on. If it won\u2019t power on, it may be time for a new device. Plugging it into its charger is a very bad idea, because water and electricity don\u2019t go well together. Wrapping it in plastic wrap is also a bad idea because that won\u2019t give the phone a change to dry out.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      230,
      225,
      189,
      188,
      201
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 386,
    "question": "The display on a user\u2019s laptop is very dim. They tried to make it brighter using the function keys on the keyboard but it didn\u2019t help. What will resolve the problem?",
    "choice_a": "Reinstall the video driver.",
    "choice_b": "Change the video resolution to a higher resolution.",
    "choice_c": "Recalibrate the video input source.",
    "choice_d": "Replace the backlight.",
    "correct_answer": "D",
    "explanation": "If the display is dim, and the controls on the laptop won\u2019t make it any brighter, than odds are the backlight is failing. Replacing the backlight is the best solution.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      223,
      222,
      190,
      189,
      191
    ],
    "source": "330034_Vol1_PT1"
  },
  {
    "id": 387,
    "question": "What is the name for the successor to the system BIOS that expands on classic features by allowing modular extensions to the basic code?",
    "choice_a": "MBR",
    "choice_b": "EEPROM",
    "choice_c": "Extended BIOS",
    "choice_d": "UEFI",
    "correct_answer": "D",
    "explanation": "The Unified Extensible Firmware Interface (UEFI) enhances the classic BIOS concept by starting with a base configuration and allowing its extension through UEFI partitions on attached storage devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      13,
      6,
      4,
      35
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 388,
    "question": "You just purchased a used system, and there is a BIOS password preventing you from modifying the settings. Which of the following options allows you to gain access to the BIOS configuration when an unknown password prevents such access?",
    "choice_a": "Repositioning a jumper on the motherboard to clear the CMOS memory",
    "choice_b": "Holding down a BIOS-specific key or key sequence while booting the machine",
    "choice_c": "Unplugging the computer for at least two minutes",
    "choice_d": "Pressing F8 early in the boot sequence and selecting the option to clear the password from the resulting menu",
    "correct_answer": "A",
    "explanation": "Most motherboards have a Clear CMOS or Reset CMOS jumper that immediately resets the CMOS memory to its default state. Clearing the CMOS removes any BIOS supervisor and user passwords that might be set, along with many other user-configured BIOS settings, returning the BIOS to factory defaults.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      5,
      9,
      26,
      6
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 389,
    "question": "You have a computer that is running slowly when multiple applications are open. Increasing which of the following allows running more applications simultaneously?",
    "choice_a": "CPU speed",
    "choice_b": "CPU bus width",
    "choice_c": "HDD space",
    "choice_d": "Memory",
    "correct_answer": "D",
    "explanation": "Applications and their data must reside in RAM during execution. Increasing anything but RAM, despite various benefits, does not lead directly to being able to run more applications simultaneously.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      19,
      6,
      16,
      20,
      26
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 390,
    "question": "You need to enable systemwide security. Which of the following is a technology that is dependent on UEFI and that will load files at startup, only if the files have not been tampered with?",
    "choice_a": "Power-on Self-Test",
    "choice_b": "Master Boot",
    "choice_c": "Secure Boot",
    "choice_d": "ReadyBoot",
    "correct_answer": "C",
    "explanation": "Secure Boot loads boot files only if their digital signatures are valid. The boot files checked include option ROMs, the boot loader, and other operating-system boot files.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      8,
      13,
      2,
      4
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 391,
    "question": "You are replacing RAM in a desktop computer. There are four DIMM slots, alternating (closest to the CPU) black, white, black, white. If you want to use dual-channel capabilities, which two slots should you fill?",
    "choice_a": "The first two slots",
    "choice_b": "The two black slots",
    "choice_c": "The two white slots",
    "choice_d": "The last two slots",
    "correct_answer": "B",
    "explanation": "Dual-channel means filling two slots. In most cases, the color coding on the motherboard refers to the banks that need to be filled to complete a dual-channel bank. In most cases it will be the one closest to the CPU and then the other of the same color. Check the motherboard documentation to be sure!",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      15,
      6,
      26,
      18,
      1
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 392,
    "question": "You are asked to replace an ATX motherboard in a system. The case has a limited amount of space and you\u2019d like to free some up. Which motherboard form factor could you use instead?",
    "choice_a": "AT",
    "choice_b": "ATX+",
    "choice_c": "microATX",
    "choice_d": "miniATX",
    "correct_answer": "C",
    "explanation": "The microATX standard was developed as a smaller alternative to ATX, and should be compatible with an ATX-style case. ATX replaced AT as the standard for desktop systems. There are no ATX+ or miniATX motherboards. ITX is a series of smaller form-factor motherboards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      21,
      7,
      2,
      41
    ],
    "source": "330034_Vol1_PT2",
    "choice_e": "ITX"
  },
  {
    "id": 393,
    "question": "You currently have an old motherboard with an 8-pin power connector. Your power supply has failed. Your new power supply has a rectangular 24-pin connector coming from it. Which one of the following is true?",
    "choice_a": "You need an adapter to connect to your motherboard.",
    "choice_b": "You need an adapter to connect to your hard drives.",
    "choice_c": "You need an adapter to connect to your PCIe slots.",
    "choice_d": "That\u2019s the same connector your old power supply had. There is no problem.",
    "correct_answer": "A",
    "explanation": "Device connectors for hard drives are the same as they have been since each one was introduced. It\u2019s the motherboard power header that changes from time to time. Adapters exist to bridge the discrepancy, which means that there is a way to use the 24-pin ATX power supply with the other connectors on the older motherboard.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      43,
      45,
      44,
      7,
      1
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 394,
    "question": "You need to install a storage solution for a client who wants faster disk performance but doesn\u2019t care about fault tolerance. Which RAID type is the best choice for this client?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 6",
    "correct_answer": "A",
    "explanation": "RAID 0 offers larger volumes and read/write-speed improvement, but no redundancy\u2014if one drive is lost, so is all data in the array\u2014hence, no fault tolerance. RAID 1 is a mirrored set, RAID 5 and 6 have parity, and RAID 10 is a mirror of a striped set. All of them offer fault tolerance.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      33,
      34,
      35,
      40
    ],
    "source": "330034_Vol1_PT2",
    "choice_e": "RAID 10"
  },
  {
    "id": 395,
    "question": "When choosing an internal hard drive, which of the following rates of rotation could be considered the optimal speed for the best read and write performance?",
    "choice_a": "10,000 rpm",
    "choice_b": "7,200 rpm",
    "choice_c": "5,400 rpm",
    "choice_d": "5,000 rpm",
    "correct_answer": "A",
    "explanation": "The faster a hard disk drive spins its platters, the faster that data can be read or written. Hard drives are manufactured to spin at a certain speed, most of which are given as options here. Therefore, the fastest speed listed, 10,000 rpm, could be considered optimal, at least in terms of read/write performance. It will also generate the most heat of any of the options.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      33,
      34,
      25,
      35,
      22
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 396,
    "question": "A video editor is building a new system and wants to ensure there are enough power connectors for her multiple internal drives and video adapters. What should they look for in a PSU?",
    "choice_a": "Motherboard adapter",
    "choice_b": "A voltage input selector",
    "choice_c": "A redundance power supply",
    "choice_d": "A modular power supply",
    "correct_answer": "D",
    "explanation": "Modular power supplies have attachable and detachable power connectors and can generally support a wide range of internal devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      45,
      44,
      43,
      41,
      27
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 397,
    "question": "Which of the following pin counts have been used in the primary power supply connectors going to ATX and later motherboards? (Choose two.)",
    "choice_a": "4",
    "choice_b": "6",
    "choice_c": "8",
    "choice_d": "20",
    "correct_answer": [
      "D",
      "E"
    ],
    "explanation": "ATX motherboards have used 20- and 24-pin connectors as their primary power leads to the motherboard. PCIe devices can use 6- or 8-pin connectors, and Molex has 4 pins.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      43,
      44,
      41,
      2,
      1
    ],
    "source": "330034_Vol1_PT2",
    "choice_e": "24"
  },
  {
    "id": 398,
    "question": "Which of the following is a concept that applies only to magnetic hard disk drives and not to solid-state drives?",
    "choice_a": "Storage capacity",
    "choice_b": "External attachment",
    "choice_c": "Access time",
    "choice_d": "RPM",
    "correct_answer": "D",
    "explanation": "RPM is rotations per minute, and it only applies to conventional magnetic hard drives with spinning platters. SSDs have no moving components. All hard drives have a storage capacity and an attachment of some sort, and can be rated on access time.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      33,
      34,
      4,
      35,
      36
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 399,
    "question": "You are installing a new SATA hard drive into a desktop computer. When installing the drive, what do you need to be sure to connect?",
    "choice_a": "The power connector.",
    "choice_b": "The data cable.",
    "choice_c": "The power connector and data cable.",
    "choice_d": "Neither a power connector nor a data cable is required. The drive will get power and data from the SATA port.",
    "correct_answer": "C",
    "explanation": "SATA hard drives require the installation of separate power and data connectors to function properly. The power connector will come from the power supply, and the data cable will connect to the SATA connector on the motherboard.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      44,
      4,
      40,
      41,
      35
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 400,
    "question": "Which of the following statements are true about HDMI cables? (Choose all that apply.)",
    "choice_a": "They can carry digital or analog signals.",
    "choice_b": "They can carry audio and video signals.",
    "choice_c": "They can carry power as well as data.",
    "choice_d": "They can support 4k and 8k signals.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "HDMI cables are digital only; they do not carry analog signals (or power). They can, however, transmit video and audio and support 4k and 8k signals.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      61,
      62,
      63,
      53
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 401,
    "question": "Which of the following are differences between DVI-D and DVI-A interfaces? (Choose two.)",
    "choice_a": "DVI-A interfaces have more pins than DVI-D interfaces.",
    "choice_b": "DVI-A interfaces are larger than DVI-D interfaces.",
    "choice_c": "DVI-D interfaces have more pins than DVI-A interfaces.",
    "choice_d": "DVI-A interfaces have the same color code as VGA interfaces.",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Despite the analog pins that DVI-D does not use, DVI-A interfaces use two fewer pins than DVI-D interfaces. The interfaces are the same size and both use an off-white color code, not the blue VGA color code.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      63,
      32,
      27,
      53
    ],
    "source": "330034_Vol1_PT2",
    "choice_e": "DVI-A interfaces use pins that DVI-D interfaces do not use."
  },
  {
    "id": 402,
    "question": "Which of the following connections will provide the fastest data transfer speeds for a hard drive?",
    "choice_a": "Molex",
    "choice_b": "SATA",
    "choice_c": "PATA",
    "choice_d": "DB-9",
    "correct_answer": "B",
    "explanation": "The two common hard drive connection types here are SATA and PATA. Of the two, SATA is decidedly faster. It supports speeds of up to 6 Gbps, which equals data transfers of about 600 MBps. By comparison, PATA is limited to about 100 Mbps. Molex is a power connector type, and DB-9 connectors are for serial cables.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      4,
      35,
      33,
      62,
      40
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 403,
    "question": "Which of the following connectors uses 4 pins and is shaped like a rectangle?",
    "choice_a": "USB-C",
    "choice_b": "Molex",
    "choice_c": "Lightning",
    "choice_d": "mini-USB",
    "correct_answer": "B",
    "explanation": "Molex connectors are rectangular shaped (with a small key cut out of one corner) and have 4 pins.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      44,
      43,
      45,
      23,
      57
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 404,
    "question": "Which of the following capabilities and features were introduced with Thunderbolt 3? (Choose two.)",
    "choice_a": "10 Gbps Ethernet support",
    "choice_b": "20 Gbps maximum throughput",
    "choice_c": "USB-C connector",
    "choice_d": "DisplayPort 1.2",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Thunderbolt 3 introduced 10 Gbps Ethernet support and a maximum speed of 40 Gbps, as well as the use of the USB-C connector. DisplayPort 1.2 compatibility was first included with Thunderbolt 2.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      57,
      62,
      61,
      63
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 405,
    "question": "You are looking to purchase a new monitor for a kiosk that will have a near-permanent image displayed. You want to avoid the potential of burn-in. What type of monitor should you <i>not</i> purchase?",
    "choice_a": "OLED",
    "choice_b": "Mini-LED",
    "choice_c": "IPS",
    "choice_d": "TN",
    "correct_answer": "A",
    "explanation": "OLED monitors are susceptible to burn-in, where a permanent discoloration or artifact on a monitor screen happens after an image has been displayed for a long time. None of the other monitor types are susceptible to burn-in.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      49,
      48,
      53,
      50,
      51
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 406,
    "question": "You need to replace RAM in a laptop. How many pins does a DDR3 SODIMM memory module have?",
    "choice_a": "200",
    "choice_b": "204",
    "choice_c": "260",
    "choice_d": "288",
    "correct_answer": "B",
    "explanation": "DDR4 SODIMMs have 260 pints. DDR2 SODIMMs have 200 pins and DDR3 ones have 204 pins. No SODIMMs currently have 288 pins, but DDR4 and DDR5 DIMMs do.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      68,
      64,
      65,
      67,
      71
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 407,
    "question": "You are buying a new Mini PCIe network card for a laptop, and you want to make sure it uses the same power as the old card. Which of the following are valid power options for Mini PCIe cards? (Choose all that apply.)",
    "choice_a": "1.5V",
    "choice_b": "2.3V",
    "choice_c": "3.3V",
    "choice_d": "5V",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Mini PCIe cards can use either 1.5V or 3.3V. They do not use 2.3V or 5V.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      71,
      64,
      67,
      68,
      69
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 408,
    "question": "You are giving a seminar to new laptop technicians. What are the current types of displays you should discuss? (Choose two.)",
    "choice_a": "CRT",
    "choice_b": "CCFL",
    "choice_c": "LCD",
    "choice_d": "OLED",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The two current laptop display technologies are liquid crystal display (LCD) or organic light-emitting diode (OLED). CRT is an old display technology used for desktop monitors. Cold cathode fluorescent lamp (CCFL) is a display backlight technology.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      66,
      64,
      70,
      71,
      68
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 409,
    "question": "Your laptop has 8 GB of installed memory and uses shared video memory. If the video card is using 1 GB, how much is left for the rest of the system?",
    "choice_a": "1 GB",
    "choice_b": "7 GB",
    "choice_c": "8 GB",
    "choice_d": "9 GB",
    "correct_answer": "B",
    "explanation": "If the laptop is using shared video memory, then the system memory is shared with the video card. If the video card is using 1 GB, and the system has 8 GB total, then there is 7 GB left for the system.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      68,
      67,
      71,
      64,
      72
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 410,
    "question": "Which of the following laptop accessories provide input? (Choose all that apply.)",
    "choice_a": "Stylus",
    "choice_b": "Headsets",
    "choice_c": "Speakers",
    "choice_d": "Webcam",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "A stylus is used on a drawing pad, trackpad, or touchscreen and provides input. Headsets have microphones for audio input, and webcams are used for video input. Speakers are output-only.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      70,
      66,
      64,
      65,
      68
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 411,
    "question": "A user is trying to print a two-page document to an MFD but what comes out is eight pages with one line of garbage on top of each page. What is most likely the appropriate way to fix this problem?",
    "choice_a": "Reboot the user\u2019s computer.",
    "choice_b": "Update the printer firmware.",
    "choice_c": "Install the appropriate driver.",
    "choice_d": "Perform appropriate printer maintenance.",
    "correct_answer": "C",
    "explanation": "Printing garbage is most likely caused by an incorrect print driver. Reinstalling the appropriate driver should resolve the issue. Rebooting the user\u2019s computer will likely not help. The printer firmware shouldn\u2019t cause this problem, nor should a lack of maintenance.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      91,
      31,
      92,
      76,
      89
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 412,
    "question": "What type of printer can use ink that comes in a wax form?",
    "choice_a": "Inkjet",
    "choice_b": "Thermal",
    "choice_c": "Laser",
    "choice_d": "Impact",
    "correct_answer": "B",
    "explanation": "Thermal printers use either heat only or heat along with a ribbon that contains a wax-based ink. Inkjet and impact printers use liquid ink, and laser printers use toner.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      81,
      74,
      73,
      77,
      96
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 413,
    "question": "Which of the following would not be used to connect a printer to a system?",
    "choice_a": "USB",
    "choice_b": "SMB",
    "choice_c": "Shared network access",
    "choice_d": "Parallel port",
    "correct_answer": "B",
    "explanation": "Server Message Block (SMB) is a protocol used for file sharing, or when saving a scanned document on a network folder. Legacy parallel ports were traditionally used as a printer port because they supported faster speeds than serial ports did. USB is popular today because it is even faster than a parallel port and easy to configure. Shared network access is used to share a printer among many networked users.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      56,
      63,
      95,
      91
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 414,
    "question": "When properly unboxing a printer, which of the following is <i>not</i> something you should consider doing?",
    "choice_a": "Placing the device on a flat surface",
    "choice_b": "Setting up the printer near an RJ45 wall jack",
    "choice_c": "Locating the printer in a common area",
    "choice_d": "Turning the printer on its side to look for damage on the bottom",
    "correct_answer": "D",
    "explanation": "Printers should be placed on flat surfaces, set up near the appropriate type of connection, and located in easy-to-access areas. They should not be turned on their sides or upside down as that could cause toner to spill.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      89,
      77,
      79,
      96,
      73
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 415,
    "question": "You are attempting to fix a laser printer. During printing, the toner does not seem to be placed on the paper. Which assembly is responsible for permanently pressing the toner into the paper?",
    "choice_a": "Transfer corona",
    "choice_b": "Fuser",
    "choice_c": "Printer controller circuitry",
    "choice_d": "Paper transport assembly",
    "correct_answer": "B",
    "explanation": "The fuser assembly presses and melts the toner into the paper. The transfer corona transfers the toner from the drum to the paper. The printer controller circuitry converts signals from the PC into signals for the various printer assemblies. The paper transport assembly controls the movement of the paper through the printer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      79,
      80,
      77,
      78,
      96
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 416,
    "question": "Which of the following components in a laser printer charges the drum after it has been cleaned?",
    "choice_a": "Transfer corona",
    "choice_b": "Multiplier",
    "choice_c": "Primary corona",
    "choice_d": "Conditioning wire",
    "correct_answer": "C",
    "explanation": "The primary corona wire applies a negative charge to the drum after it has gone through the cleaning phase.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      80,
      77,
      78,
      96,
      79
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 417,
    "question": "Which of the following is the correct function that a duplexing assembly on an MFD provides?",
    "choice_a": "Printing two pages at the same time",
    "choice_b": "Sequencing pages of a print job in the correct order",
    "choice_c": "Printing on both sides of a page",
    "choice_d": "Aligning the orientation to portrait or landscape",
    "correct_answer": "C",
    "explanation": "A duplexing assembly allows for printing on both sides of a piece of paper. Printers can\u2019t print two pages at the same time (at least not that we know of). Changing the order of page prints to be in a sequence is called collating, and all printers can print in portrait or landscape.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      75,
      74,
      78,
      80,
      77
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 418,
    "question": "The office manager has requested that employees be able to use their company-issued IDs to log into the new MFD. What is this an example of?",
    "choice_a": "User authentication",
    "choice_b": "Badging",
    "choice_c": "Audit logs",
    "choice_d": "Secured prints",
    "correct_answer": "B",
    "explanation": "If users can log into a printer using their ID\u2014often a badge\u2014that is called badging. If the user needs to type in their credentials, then it\u2019s user authentication. Audit logs track who prints what. Secured prints will hold a print job until the user arrives at the device and tells it to print.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      89,
      90,
      91
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 419,
    "question": "You are configuring a network that has multiple wireless access points all within the same building. Which type of network have you created?",
    "choice_a": "WLAN",
    "choice_b": "WAN",
    "choice_c": "LAN",
    "choice_d": "MAN",
    "correct_answer": "A",
    "explanation": "You have created a wireless local area network (WLAN). A wide area network (WAN) is one that spans large geographical areas. A local area network (LAN) is a small network, typically within one location. A metropolitan area network (MAN) is one that is spread throughout an area such as a city or campus.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      99,
      154,
      107,
      138
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 420,
    "question": "Which of the following best describes what a firewall does on a computer network?",
    "choice_a": "Prevents power supply fires from spreading to other computers",
    "choice_b": "Filters network traffic coming into the network",
    "choice_c": "Directs traffic between network segments",
    "choice_d": "Allocates and manages MAC addresses",
    "correct_answer": "B",
    "explanation": "A firewall is a security device that monitors incoming network traffic and blocks potentially malicious traffic. Routers direct traffic between network segments. No devices keep power supply fires from spreading, nor do they allocate and manage MAC addresses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      155,
      135,
      114,
      106,
      117
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 421,
    "question": "What kind of cables use either an F-type connector or an RJ45 connector?",
    "choice_a": "Copper",
    "choice_b": "Plenum",
    "choice_c": "Optical",
    "choice_d": "Direct burial",
    "correct_answer": "A",
    "explanation": "Both connectors are used for copper cables, RJ45 is used for twisted pair Ethernet networks, and F-type connectors are used on coaxial cable. Optical cables use ST, SC, or LC connectors. Plenum and direct burial are special types of copper or fiber-optic cables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      110,
      112,
      116,
      111,
      148
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 422,
    "question": "You are configuring a network and need to connect a local LAN segment to an external network. Which device will connect multiple networks together and determine the best path for sending data?",
    "choice_a": "Hub",
    "choice_b": "Router",
    "choice_c": "Switch",
    "choice_d": "Firewall",
    "correct_answer": "B",
    "explanation": "Routers are highly intelligent devices that connect multiple network types and determine the best path for sending data. They can route packets across multiple networks and use routing tables to store network addresses to determine the best destination. Routers operate at the Network layer of the OSI model.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      106,
      118,
      117,
      99
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 423,
    "question": "You need to provide power to an IP security camera in an area where there are no electrical outlets. It will be the only device in the area. Which device can help do this at the lowest cost?",
    "choice_a": "PoE switch",
    "choice_b": "PoE injector",
    "choice_c": "EoP switch",
    "choice_d": "EoP injector",
    "correct_answer": "B",
    "explanation": "A Power over Ethernet (PoE) injector is the best choice. It will be the lowest-cost device that can provide power over the Ethernet cable to one device. PoE switches provide power to multiple devices and cost more.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      115,
      114,
      108,
      121,
      99
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 424,
    "question": "Which TCP/IP protocol uses port 110?",
    "choice_a": "HTTP",
    "choice_b": "HTTPS",
    "choice_c": "SNMP",
    "choice_d": "POP3",
    "correct_answer": "D",
    "explanation": "POP3 uses port 110. HTTP uses port 80, HTTPS uses 443, and SNMP uses ports 161 and 162.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      128,
      119,
      117
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 425,
    "question": "Which of the following addresses is a nonroutable IP address?",
    "choice_a": "172.36.32.1",
    "choice_b": "192.168.32.1",
    "choice_c": "168.192.32.1",
    "choice_d": "169.192.32.1",
    "correct_answer": "B",
    "explanation": "Private, nonroutable addresses are 10.0.0.0\u201310.255.255.255, 172.16.0.0\u2013172.31.255.255, and 192.168.0.0\u2013192.168.255.255.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      124,
      122,
      123,
      121,
      118
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 426,
    "question": "You have just set up a network that will use the TCP/IP protocol, and you want client computers to be able to search for and communicate with other computers by using hostnames. Which type of server will help with this?",
    "choice_a": "DNS",
    "choice_b": "DHCP",
    "choice_c": "Hostname server",
    "choice_d": "NetBIOS server",
    "correct_answer": "A",
    "explanation": "A Domain Name System (DNS) server resolves hostnames to IP addresses. A Dynamic Host Configuration Protocol (DHCP) server provides IP configuration information to hosts when they join the network. There is no hostname server. A NetBIOS name is a computer network name that was used exclusively in Microsoft networks, but it\u2019s different than a hostname.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      129,
      130,
      117,
      122
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 427,
    "question": "Which of the following is true for computers configured with APIPA?",
    "choice_a": "They will be able to communicate with other APIPA-configured computers on their local network.",
    "choice_b": "They will not be able to communicate with other APIPA-configured computers on their local network.",
    "choice_c": "They will be able to communicate with any computer on their local network.",
    "choice_d": "They will not be able to communicate with any computer on their local network.",
    "correct_answer": "A",
    "explanation": "Computers configured with APIPA will have an IP address in the 169.254.0.0 range with a subnet mask of 255.255.0.0. They will be able to communicate with other computers on the local network that have the same network address. They will not be able to get on the Internet.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      130,
      124,
      122,
      121,
      118
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 428,
    "question": "You have blocked port 110 on your firewall. Based on this action, which of the following may be true?",
    "choice_a": "Clients on your network will not be able to access web pages.",
    "choice_b": "Clients on your network will not be able to send email.",
    "choice_c": "Clients on your network will not be able to retrieve email unless their email client supports POP3.",
    "choice_d": "Clients on your network will not be able to retrieve email unless their email client supports IMAP4.",
    "correct_answer": "D",
    "explanation": "Port 110 is used for POP3, which is an email retrieval protocol. Client computers with email software that supports IMAP4 may still be able to download email.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      155,
      119,
      117
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 429,
    "question": "How many IPv4 addresses can be assigned to each network interface?",
    "choice_a": "One",
    "choice_b": "Two (unicast, multicast)",
    "choice_c": "Three (unicast, multicast, anycast)",
    "choice_d": "None of the above",
    "correct_answer": "A",
    "explanation": "Each network interface can have only one IPv4 address assigned to it. IPv6 can use multiple IP addresses for each interface. Unicast, multicast, and anycast are IPv6 concepts.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      122,
      118,
      121,
      109
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 430,
    "question": "Which of the following are not examples of common IoT devices? (Choose two.)",
    "choice_a": "SCADA",
    "choice_b": "Security camera",
    "choice_c": "Virtual assistant",
    "choice_d": "Proxy server",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Security cameras and virtual assistants are examples of IoT devices. SCADA is a legacy embedded system for managing industrial applications. A proxy server fulfills requests for clients.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      136,
      135,
      99,
      148,
      151
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 431,
    "question": "If a DNS server is unable to resolve a name, what will it do?",
    "choice_a": "Check its cache file",
    "choice_b": "Query the top-level DNS server",
    "choice_c": "Query the root DNS server",
    "choice_d": "Nothing",
    "correct_answer": "C",
    "explanation": "If a DNS server is unable to resolve a name (and it checks its cache after it checks its zone file), it will query the root DNS server. There is no top-level DNS server; that\u2019s what the root DNS server essentially is.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      129,
      121,
      118,
      119,
      106
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 432,
    "question": "Which of the following security frameworks helps eliminate email spam by validating the sending email server\u2019s IP address?",
    "choice_a": "SCADA",
    "choice_b": "DKIM",
    "choice_c": "SPF",
    "choice_d": "DMARC",
    "correct_answer": "C",
    "explanation": "Sender Policy Framework (SPF) validates email servers by verifying their IP addresses. DKIM validates with a public-private key pair. DMARC is a decision framework that tells an inbound email server what to do with email marked as spam. SCADA refers to legacy hardware and software systems.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      121,
      120,
      136,
      131
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 433,
    "question": "Your network is protected by a three-pronged firewall. Where on the network should a print server be placed to best provide the appropriate access to users?",
    "choice_a": "On the public side",
    "choice_b": "On the internal network side",
    "choice_c": "On the screened subnet",
    "choice_d": "On the firewall",
    "correct_answer": "B",
    "explanation": "A print server will need to be accessed by internal network users so it should be on the internal network side of the firewall. External users likely have no reason to print to a corporate print server. Print servers should never be placed on a firewall.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      137,
      155,
      146,
      104,
      103
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 434,
    "question": "Which of the following best describes a DHCP scope?",
    "choice_a": "A list of IP addresses and options that the DHCP server can assign to clients",
    "choice_b": "The network address of segments that the DHCP server can assign IP addresses to",
    "choice_c": "The list of hostname-to\u2013IP address mappings for name resolution",
    "choice_d": "The list of IP address\u2013to\u2013hostname mappings for name resolution",
    "correct_answer": "A",
    "explanation": "A DHCP scope is the list of IP addresses that the DHCP server can assign to clients. DNS servers resolve hostnames to IP addresses, not DHCP servers.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      130,
      121,
      122,
      123,
      128
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 435,
    "question": "Which of the following Internet connection types uses an ONT?",
    "choice_a": "Satellite",
    "choice_b": "Fiber",
    "choice_c": "Cable",
    "choice_d": "DSL",
    "correct_answer": "B",
    "explanation": "Fiber Internet connections use an optical network terminal (ONT). Cable uses a cable modem and DSL uses a DSL modem.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      148,
      147,
      150,
      151
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 436,
    "question": "Which of the following standards would you want to use if you need high-bandwidth wireless LAN communications?",
    "choice_a": "Bluetooth",
    "choice_b": "Wireless Ethernet",
    "choice_c": "Cellular",
    "choice_d": "RFID",
    "correct_answer": "B",
    "explanation": "Wireless Ethernet is the best of the four wireless communication methods for networking, and it has the highest bandwidth of all four options.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      138,
      140,
      107,
      99
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 437,
    "question": "Which of the following legacy 802.11 standards provides data transmission speeds up to 54 Mbps and is backward compatible with a slower technology?",
    "choice_a": "802.11a",
    "choice_b": "802.11b",
    "choice_c": "802.11g",
    "choice_d": "802.11i",
    "correct_answer": "C",
    "explanation": "Both 802.11a and 802.11g provide data transmission speeds of up to 54 Mbps, but only 802.11g is backward compatible with 802.11b. 802.11b only goes up to 11 Mbps. 802.11i is a security standard.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      140,
      107,
      138,
      139
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 438,
    "question": "Which of the following Wi-Fi standards introduced the ability for WAPs to coordinate channel configurations?",
    "choice_a": "Wi-Fi 6",
    "choice_b": "Wi-Fi 7",
    "choice_c": "Wi-Fi 6E",
    "choice_d": "Wi-Fi 5",
    "correct_answer": "B",
    "explanation": "Wi-Fi 7 was the first to introduce Multi-AP coordination. Wi-Fi 6 did introduce BSS coloring, which allows one AP to avoid a channel conflict with another, but true coordination was not yet available.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      143,
      142,
      154,
      139
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 439,
    "question": "Which of the following best describes WPA?",
    "choice_a": "The wireless network name",
    "choice_b": "The hashed version of the wireless NIC\u2019s hardware address",
    "choice_c": "A wireless modulation scheme",
    "choice_d": "A network security protocol",
    "correct_answer": "D",
    "explanation": "WPA is a wireless security standard. The SSID is the name of the wireless network. MAC is the hardware address built into network cards. There are several modulation schemes such as BPSK, QPSK, and QAM.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      153,
      152,
      140,
      138,
      107
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 440,
    "question": "A user tethers their laptop to their smartphone to get Internet access. What Internet connection type are they most likely using?",
    "choice_a": "Cellular",
    "choice_b": "Satellite",
    "choice_c": "Fiber",
    "choice_d": "WISP",
    "correct_answer": "A",
    "explanation": "The smartphone is most likely using a cellular Internet connection. The only other option that could be considered is wireless Internet service provider (WISP), but that typically refers to an Internet connection provided to a location through a cellular provider to a fixed location.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      151,
      150,
      99,
      138,
      145
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 441,
    "question": "A warehouse manager wants to be able to track the journey of parts through the warehouse. What type of service would be best for this?",
    "choice_a": "Synchronization",
    "choice_b": "Location services",
    "choice_c": "BYOD",
    "choice_d": "eSIM",
    "correct_answer": "B",
    "explanation": "Location services can be used to track the location of items, such as parts in a warehouse. Synchronization is copying the data or information from one device to another. BYOD is a mobile device configuration. eSIM is a mobile device identifier.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      165,
      166,
      167,
      168,
      171
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 442,
    "question": "Which port number is used for SMTP when SSL is used to secure the connection?",
    "choice_a": "25",
    "choice_b": "465",
    "choice_c": "587",
    "choice_d": "993",
    "correct_answer": "B",
    "explanation": "Simple Mail Transfer Protocol (SMTP) uses port 465 when secured with SSL. Port 25 is used with SMTP when an insecure connection is used. SMTP uses port 587 when secured with TLS. Port 993 is used by secure IMAP.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      170,
      164,
      162,
      172,
      173
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 443,
    "question": "You are pairing two Bluetooth devices, and have just entered the appropriate PIN code. What is the next step to pair the devices?",
    "choice_a": "Turn them off and back on.",
    "choice_b": "Enable Bluetooth.",
    "choice_c": "Test connectivity.",
    "choice_d": "Find the device for pairing.",
    "correct_answer": "C",
    "explanation": "The steps for Bluetooth pairing are enable Bluetooth, enable pairing, find a device for pairing, enter the appropriate PIN code, and test connectivity. Turning the devices off and back on is not required for pairing.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      159,
      162,
      164,
      157,
      170
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 444,
    "question": "A mobile user has a large number of videos to synchronize to another device. If security is of the utmost concern to the user, which synchronization option should they choose?",
    "choice_a": "Corporate email",
    "choice_b": "Commercial email",
    "choice_c": "Desktop",
    "choice_d": "Cloud",
    "correct_answer": "C",
    "explanation": "There is no email synchronization option, to either corporate or commercial email. For security, the best option is to avoid an Internet connection and sync to the desktop versus syncing to the cloud.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      171,
      172,
      173,
      164,
      168
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 445,
    "question": "Which cloud term refers to the process by which a provider charges for resources used?",
    "choice_a": "Elasticity",
    "choice_b": "Availability",
    "choice_c": "Resource pooling",
    "choice_d": "Metered utilization",
    "correct_answer": "D",
    "explanation": "Providers typically measure the amount of resources used by clients and charge them for what has been used. This is called metered utilization, and functions much like utilities. The ability to quickly expand services is called rapid elasticity. High availability guarantees services will be available. Resource pooling is taking resources from multiple machines and making them available as one pool.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      183,
      180,
      182,
      184,
      181
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 446,
    "question": "Which of the following types of clouds provides the highest level of security?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Hybrid",
    "choice_d": "Community",
    "correct_answer": "B",
    "explanation": "By definition, a private cloud will provide the most security because all resources are controlled by the local company on premises.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      181,
      180,
      182,
      179,
      183
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 447,
    "question": "A network administrator suggests the use of containers as part of the company virtualization strategy. Which of the following statements is true about containers?",
    "choice_a": "They can run on multiple operating environments.",
    "choice_b": "They can only run a single application.",
    "choice_c": "They contain apps as well as a virtualized hardware image.",
    "choice_d": "They reconstruct a user\u2019s VDI.",
    "correct_answer": "A",
    "explanation": "Containers are used to deploy software packages and ensure a similar operating experience regardless of the operating environment (or OS) that they are used on. They contain an app as well as all dependencies needed to run the app. Containers generally only have one app, but they can handle more than one. Containers do not virtualize hardware or reconstruct a virtual desktop.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      177,
      174,
      175,
      178,
      179
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 448,
    "question": "Your company is moving towards using cloud services. The finance leader wants the company to use Office 365 for email and productivity. What type of cloud service would include this?",
    "choice_a": "OaaS",
    "choice_b": "SaaS",
    "choice_c": "IaaS",
    "choice_d": "PaaS",
    "correct_answer": "B",
    "explanation": "If apps are included in a cloud service, that service is software as a service (SaaS). Infrastructure as a service (IaaS) is hardware only, and platform as a service (PaaS) includes software development tools. There is no OaaS on the A+ objectives.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      182,
      186,
      180,
      183,
      185
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 449,
    "question": "A network administrator wants to virtualize four servers that are on the network. Which type of solution would best meet the needs for these servers?",
    "choice_a": "Containers",
    "choice_b": "Type 2 hypervisor",
    "choice_c": "Type 1 hypervisor",
    "choice_d": "VDI",
    "correct_answer": "C",
    "explanation": "Type 1 hypervisors, also known as bare metal hypervisors, are the best solution for server-side virtualization. Type 2 hypervisors sit on an operating system, which takes more resources. Containers are for software deployment, and VDI is the virtual desktop infrastructure.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      176,
      174,
      177,
      175,
      178
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 450,
    "question": "You have been given a new toolkit for troubleshooting computer problems. In it is a device marked loopback. What is the function of a loopback plug?",
    "choice_a": "It\u2019s used to test a telephone line.",
    "choice_b": "It terminates a SCSI cable.",
    "choice_c": "It tests the functionality of a NIC.",
    "choice_d": "It measures the signal strength of an Ethernet cable.",
    "correct_answer": "C",
    "explanation": "Loopback plugs take the signal going out on the transmit path and connect it back to the receive path. This allows you to test certain legacy ports as well as Ethernet NICs to make certain they are working correctly.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      109,
      106,
      107,
      115
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 451,
    "question": "You push the power button on a desktop computer and the case fan comes on. However, there does not seem to be power to the rest of the computer as it does not boot up. Which component should you first suspect of causing the problem?",
    "choice_a": "Motherboard",
    "choice_b": "CPU",
    "choice_c": "RAM",
    "choice_d": "Power supply",
    "correct_answer": "D",
    "explanation": "The most likely culprit is the power supply. It\u2019s possible but highly unlikely that the motherboard, CPU, or RAM could be causing the issue. It\u2019s definitely not the power cord, because the system is getting power.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      201,
      196,
      190,
      188,
      194
    ],
    "source": "330034_Vol1_PT2",
    "choice_e": "Power cord"
  },
  {
    "id": 452,
    "question": "Application crashes and pinwheel crash screens are most likely caused by which physical component?",
    "choice_a": "Motherboard",
    "choice_b": "RAM",
    "choice_c": "CPU",
    "choice_d": "PSU",
    "correct_answer": "B",
    "explanation": "App crashes and system crash screens such as a pinwheel or BSOD are most likely caused by faulty memory. The motherboard, central processing unit, power supply unit, and graphics processing unit are unlikely to cause these errors.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      199,
      196,
      200,
      188,
      198
    ],
    "source": "330034_Vol1_PT2",
    "choice_e": "GPU"
  },
  {
    "id": 453,
    "question": "A user calls to complain that their computer sometimes makes a horrible grinding sound. When you investigate, they say it only happens when they use their Blu-ray drive. What should you do?",
    "choice_a": "Clean the Blu-ray drive.",
    "choice_b": "Replace the Blu-ray drive.",
    "choice_c": "Try a different disc.",
    "choice_d": "Check the user manual for a solution.",
    "correct_answer": "B",
    "explanation": "If the drive is grinding whenever you put a disc into it, it\u2019s likely that the drive needs to be replaced. If it won\u2019t read properly or consistently, then it might need to be cleaned.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      193,
      203,
      188,
      189,
      190
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 454,
    "question": "You believe that a malicious user is trying to hack into a secure section of the network. Which of the following networking tools should use you use to help determine if this is true?",
    "choice_a": "Toner probe",
    "choice_b": "Network tap",
    "choice_c": "Wi-Fi analyzer",
    "choice_d": "Loopback plug",
    "correct_answer": "B",
    "explanation": "A network tap makes a copy of network traffic for further analysis. It\u2019s the only tool listed that will help capture traffic on a wired network. A toner probe is for locating two ends of a cable. A Wi-Fi analyzer can look at wireless network signal strength but will not help analyze traffic. A loopback plug is for testing NICs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      106,
      117,
      118,
      107,
      108
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 455,
    "question": "You need to connect a UTP cable to a 110-block. Which tool should you use?",
    "choice_a": "Crimper",
    "choice_b": "Punchdown tool",
    "choice_c": "Cable stripper",
    "choice_d": "Network tap",
    "correct_answer": "B",
    "explanation": "A punchdown tool is used to connect wires to a 110-block. Crimpers fasten connectors to the ends of cables. A cable stripper cuts and strips cables but does not fasten them to anything. A network tap monitors network traffic.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      112,
      111,
      116,
      146,
      109
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 456,
    "question": "After printing documents, the toner smears on the output pages whenever you touch it. Otherwise, things appear to be working properly. What is the most likely cause of the problem?",
    "choice_a": "The print driver is faulty.",
    "choice_b": "The fuser is not heating properly.",
    "choice_c": "There is toner on the transfer corona wire.",
    "choice_d": "There is a scratch on the EP drum.",
    "correct_answer": "B",
    "explanation": "If the fuser does not heat properly, toner will not bond to the paper and you will have smearing. White streaks on printouts are most likely caused by toner on the transfer corona wire. Vertical black lines are caused by a scratch or a groove in the EP drum. Faulty print drivers will cause garbage to print or there will be no printing at all.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      239,
      238,
      188,
      190,
      234
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 457,
    "question": "You have been using your laser printer for just over five months. Recently, you noticed that the printed characters on the left side of your documents are faint compared to the letters on the right. How can you quickly resolve this problem?",
    "choice_a": "Print your documents backward.",
    "choice_b": "Use different paper.",
    "choice_c": "Gently shake the toner cartridge.",
    "choice_d": "Blow the excess dust out of the cartridge.",
    "correct_answer": "C",
    "explanation": "Most documents have more characters printed on the left side of the paper than on the right side. Therefore, the toner from the left side of the cartridge runs out sooner, and the print on the left side of the documents will be faint. Gently shaking the toner cartridge redistributes the toner evenly on both sides.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      238,
      239,
      235,
      190,
      188
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 458,
    "question": "You are troubleshooting a laser printer that is producing blank images. There seems to be toner all over the inside of the printer. Which of the following components in a laser printer is responsible for properly transferring toner from the drum to the paper?",
    "choice_a": "Fuser",
    "choice_b": "Transport corona",
    "choice_c": "Transfer corona",
    "choice_d": "Development wire",
    "correct_answer": "C",
    "explanation": "The transfer corona in the laser printer puts a positive charge on the paper, forcing the toner on a negatively charged drum to transfer to the paper.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      238,
      239,
      190,
      188,
      234
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 459,
    "question": "You have just installed a new printer. After it is installed, it prints only garbled text. Which of the following is likely the problem?",
    "choice_a": "Wrong IP address",
    "choice_b": "Worn print head",
    "choice_c": "Incorrect print drivers",
    "choice_d": "Unsupported printer",
    "correct_answer": "C",
    "explanation": "If a printer is using out-of-date or incorrect printer drivers, the printer may produce pages of garbled text. The solution is to ensure that the most recent printer drivers are downloaded from the manufacturer\u2019s website.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      190,
      188,
      191,
      242,
      240
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 460,
    "question": "A user reports that their laptop has a number of places on the display that do not light up, even when the screen should be entirely white. What is the most likely cause of this problem?",
    "choice_a": "Burn-in",
    "choice_b": "Artifacts",
    "choice_c": "Distorted image",
    "choice_d": "Dead pixels",
    "correct_answer": "D",
    "explanation": "Dead pixels occur when certain points on the screen will not light up. The only solution is to replace the display unit. Burn-in and artifacts are when other, dim images show up on the computer along with the intended image. Distorted images look pulled or stretched. Faulty video drivers do not cause burn-in, artifacts, distorted images, or dead pixels.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      221,
      223,
      220,
      188,
      190
    ],
    "source": "330034_Vol1_PT2",
    "choice_e": "Faulty video driver"
  },
  {
    "id": 461,
    "question": "A user\u2019s iPhone will not respond to the touch of their fingertip. The power button on the side will turn the phone off and back on, but the iPhone still doesn\u2019t respond to touch. What should the user do?",
    "choice_a": "Replace the smartphone.",
    "choice_b": "Remove the battery and reinstall it.",
    "choice_c": "Use a stylus instead of a fingertip.",
    "choice_d": "Perform a factory reset, and when the device reboots, recalibrate the digitizer.",
    "correct_answer": "A",
    "explanation": "If an iPhone will not respond to touch, even after restarting, chances are the digitizer or screen is damaged in some way. Either the screen or the device needs to be replaced. Apple does not want its users removing and replacing batteries; even so, it probably wouldn\u2019t help. If the digitizer is not responding, then a stylus won\u2019t work either. There is no recalibrating the digitizer after a factory reset.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      228,
      230,
      189,
      190,
      188
    ],
    "source": "330034_Vol1_PT2"
  },
  {
    "id": 462,
    "question": "You are installing a new CPU. Which of the following is a reason for using thermal paste on a CPU?",
    "choice_a": "To promote the uniform transfer of heat from the CPU to the heat sink",
    "choice_b": "To use the Peltier effect to cool the CPU to below ambient temperatures",
    "choice_c": "To seal the heat sink to the CPU",
    "choice_d": "To create a liquid barrier, protecting against condensation",
    "correct_answer": "A",
    "explanation": "Thermal paste has become mandatory in creating a uniform heat-transfer layer between the CPU and heat sink.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      22,
      24,
      25,
      12,
      47
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 463,
    "question": "To support a new hard drive, you need to upgrade the system BIOS on a computer. From where should the BIOS flashing utility and firmware be obtained?",
    "choice_a": "Downloaded from the website of the BIOS manufacturer",
    "choice_b": "Downloaded from the website of the system/motherboard manufacturer",
    "choice_c": "Ordered on flash drive from the BIOS manufacturer",
    "choice_d": "Through Windows Update",
    "correct_answer": "B",
    "explanation": "You should consult the system manufacturer\u2019s website to check for later BIOS versions and the issues they address. The system manufacturer will also supply the appropriate utility to be used to flash the BIOS. The BIOS manufacturer does not have the specific modified BIOS firmware for your machine.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      5,
      19,
      4,
      91,
      7
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 464,
    "question": "Which type of memory is best used in a system where data integrity is critical, such as a server?",
    "choice_a": "Non-ECC",
    "choice_b": "DDR",
    "choice_c": "ECC",
    "choice_d": "Dual-channel",
    "correct_answer": "C",
    "explanation": "Error-correcting code (ECC) RAM is best used in data critical environments, such as on servers. It is a type of DDR. Dual-channel memory does not help preserve the integrity of data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      14,
      20,
      16,
      15,
      6
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 465,
    "question": "A client wants you to build a new system, and they want it to be small and consume low power. Which of the following motherboard form factors is the smallest?",
    "choice_a": "microATX",
    "choice_b": "Mini-ITX",
    "choice_c": "ATX",
    "choice_d": "AT",
    "correct_answer": "B",
    "explanation": "The ITX family of motherboard form factors is the smallest. microATX, ATX, and AT are larger.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      18,
      6,
      43,
      7
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 466,
    "question": "You need to replace the RAM in an old Pentium-based computer that uses DDR2 memory. DDR2 modules insert into which of the following?",
    "choice_a": "Sockets",
    "choice_b": "Stabilizers",
    "choice_c": "Receptacles",
    "choice_d": "Slots",
    "correct_answer": "D",
    "explanation": "RAM modules insert into slots mated to the module\u2019s form factor. DDR2 modules insert into 240-pin slots with a keying structure different from DDR3\u2019s 240-pin slots.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      16,
      18,
      6,
      26,
      15
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 467,
    "question": "You plug in a new eSATA hard drive into the eSATA port on a desktop running Windows 11. The computer will not recognize the hard drive. What is the first thing you should do to resolve the problem?",
    "choice_a": "Plug in power to the eSATA drive.",
    "choice_b": "Enable the eSATA ports in the system BIOS.",
    "choice_c": "Enable the eSATA ports in Windows.",
    "choice_d": "Flash the system BIOS to support eSATA.",
    "correct_answer": "A",
    "explanation": "eSATA cables do not carry power. You will need to plug in power separately. There is no need to enable eSATA ports as they should be automatically detected. Similarly, there is no need to flash the BIOS.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      44,
      62,
      30,
      31,
      4
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 468,
    "question": "You are choosing a new hard drive system. Which of the following would be the fastest for disk reads and writes?",
    "choice_a": "SSD SATA",
    "choice_b": "SSD PATA",
    "choice_c": "NVMe SATA",
    "choice_d": "NVMe PCIe",
    "correct_answer": "D",
    "explanation": "NVMe is a newer flash-memory hard drive communication standard that is a faster technology than a conventional SSD. PCIe connectors are faster than SATA or PATA.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      34,
      4,
      36,
      2
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 469,
    "question": "What differentiates a solid-state drive from a conventional hard disk drive?",
    "choice_a": "Larger storage capacity",
    "choice_b": "No moving parts",
    "choice_c": "Different drive interface and cabling",
    "choice_d": "Lower cost per byte",
    "correct_answer": "B",
    "explanation": "Solid-state drives have no moving parts like conventional hard disk drives. They rival smaller conventional drives in capacity but are not yet offered in as large capacities overall. They tend to be more expensive than conventional drives per byte of capacity, but they use the same drive interfaces, such as SATA interfaces, for example.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      35,
      33,
      36,
      4
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 470,
    "question": "Which of the following form factors was specifically designed for laptops and mobile devices?",
    "choice_a": "PCIe",
    "choice_b": "NVMe",
    "choice_c": "mSAS",
    "choice_d": "mSATA",
    "correct_answer": "D",
    "explanation": "Mini-Serial ATA (mSATA) was designed specifically for laptops and mobile devices. In addition, mSATA is the only option that is a form factor. PCIe, NVMe, and SAS are all communications standards. There is no mSAS.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      4,
      35,
      18,
      40
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 471,
    "question": "You are educating a client on why they should transition away from optical drive backups to online backups. One of your key points is that optical drives don\u2019t hold as much as is needed. What\u2019s the storage capacity of a single layer standard DVD?",
    "choice_a": "2.88 MB",
    "choice_b": "2.88 GB",
    "choice_c": "4.7 GB",
    "choice_d": "25 GB",
    "correct_answer": "C",
    "explanation": "A single-sided, single-layer DVD holds 4.7 GB of data. A single-sided BD can hold 25 GB. No current optical discs have a maximum capacity of 2.88 MB or 2.88 GB.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      39,
      38,
      34,
      33,
      4
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 472,
    "question": "A client needs to be able to plug in more external storage devices. Which of the following add-on cards will allow her to do this? (Choose all that apply.)",
    "choice_a": "NIC",
    "choice_b": "USB",
    "choice_c": "eSATA",
    "choice_d": "Multimedia",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "USB and eSATA add-on cards provide more ports for USB and eSATA devices, which include storage devices. NICs are network cards, and multimedia cards are for audio or video, not external storage.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      30,
      56,
      62,
      29,
      32
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 473,
    "question": "You are choosing a new hard drive technology for a client. Which of the following are valid choices? (Choose all that apply.)",
    "choice_a": "SD",
    "choice_b": "SSD",
    "choice_c": "M.2",
    "choice_d": "NVMe",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Hard drive technologies include conventional hard disk drives (HDD), solid-state drives (SSD), and M.2 and NVMe. SD and CF are flash memory standards not intended for use as hard drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      33,
      36,
      38,
      4
    ],
    "source": "330034_Vol1_PT3",
    "choice_e": "CF"
  },
  {
    "id": 474,
    "question": "You are setting up a fault-tolerant storage solution for a client. Which of the following are differences between RAID 5 and RAID 6? (Choose two.)",
    "choice_a": "RAID 5 uses one parity stripe; RAID 6 uses two parity stripes.",
    "choice_b": "RAID 5 uses two parity stripes; RAID 6 uses one parity stripe.",
    "choice_c": "RAID 5 requires a minimum of three hard drives; RAID 6 requires a minimum of four hard drives.",
    "choice_d": "RAID 5 requires a minimum of four hard drives; RAID 6 requires a minimum of three hard drives.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "RAID 5 is a stripe set with parity and uses one parity stripe, requiring a minimum of three hard drives. RAID 6 uses double parity, so there are two parity stripes. Four hard drives are required.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      33,
      4,
      40,
      35
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 475,
    "question": "Which of the following graphics interface connectors produces an analog signal?",
    "choice_a": "DVI-D",
    "choice_b": "HDMI",
    "choice_c": "VGA",
    "choice_d": "DisplayPort",
    "correct_answer": "C",
    "explanation": "The VGA DB-15 connector produces an analog signal from the graphics adapter to the monitor. The DVI-D, HDMI, and DisplayPort connectors produce digital signals.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      63,
      61,
      62,
      59
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 476,
    "question": "Which of the following cables provides a maximum data transfer rate of 10 Gbps?",
    "choice_a": "USB 1.1",
    "choice_b": "USB 2.0",
    "choice_c": "USB 3.0",
    "choice_d": "USB 3.1",
    "correct_answer": "D",
    "explanation": "USB 1.1 is slow\u2014only 12 Mbps. USB 2.0 tops out at 480 Mbps, and USB 3.0 at 5 Gbps. You have to employ USB 3.1 to get 10 Gbps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      57,
      59,
      30,
      63
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 477,
    "question": "You\u2019re shopping for a new monitor that will play live-action movies in the reception area. Which monitor type will be best suited for this application?",
    "choice_a": "VA",
    "choice_b": "TN",
    "choice_c": "IPS",
    "choice_d": "VGA",
    "correct_answer": "B",
    "explanation": "A twisted nematic (TN) monitor is probably the best choice because they have the least amount of lag and can support high refresh rates, ensuring smooth motion for the movies.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      48,
      50,
      53,
      49
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 478,
    "question": "Which types of cables provide power to attached devices? (Choose all that apply.)",
    "choice_a": "USB4",
    "choice_b": "eSATA",
    "choice_c": "Molex",
    "choice_d": "Thunderbolt",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "USB and Thunderbolt cables provide power to attached peripherals as well as transfer data. Molex is a power-specific connector. eSATA and DVI do not power attached devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      59,
      44,
      57,
      62
    ],
    "source": "330034_Vol1_PT3",
    "choice_e": "DVI"
  },
  {
    "id": 479,
    "question": "Which of the following types of cables were not specifically designed for storage devices? (Choose two.)",
    "choice_a": "eSATA",
    "choice_b": "Serial",
    "choice_c": "USB",
    "choice_d": "SATA",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "USB cables are designed for multiple types of peripherals. They can be used for hard drives as well. Serial cables are also general peripheral cables but generally not used for storage. eSATA and SATA are cables designed for storage devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      62,
      4,
      38,
      63
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 480,
    "question": "Which connector type was created by and used exclusively with Apple products?",
    "choice_a": "Lightning",
    "choice_b": "Thunderbolt",
    "choice_c": "USB-C",
    "choice_d": "MicroUSB",
    "correct_answer": "A",
    "explanation": "The Lightning connector was created by Apple and used with iPads and iPhones. Apple has moved away from the Lightning connector now and uses USB-C.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      59,
      63,
      62
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 481,
    "question": "A user has a Windows 11 laptop and needs to connect a set of external speakers for a presentation. Which of the following types of connection methods would they most likely use? (Choose two.)",
    "choice_a": "USB",
    "choice_b": "Serial",
    "choice_c": "NFC",
    "choice_d": "Bluetooth",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Speakers are most likely to be connected via USB or the audio jack, if wired, or Bluetooth, if wireless. Serial connections are more likely to be for external storage devices. NFC does not have long enough range to be used for speakers. Hotspots are for Internet access.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      159,
      162,
      164,
      70,
      71
    ],
    "source": "330034_Vol1_PT3",
    "choice_e": "Hotspot"
  },
  {
    "id": 482,
    "question": "You need to replace an inverter in a laptop display. Your manager tells you to be careful. Why would your manager say that?",
    "choice_a": "Because the inverter provides low-voltage, low-frequency energy.",
    "choice_b": "Because the inverter provides low-voltage, high-frequency energy.",
    "choice_c": "Because the inverter provides high-voltage, low-frequency energy.",
    "choice_d": "Because the inverter provides high-voltage, high-frequency energy.",
    "correct_answer": "D",
    "explanation": "The inverter provides high-voltage, high-frequency power to the backlight. This energy can be discharged into a technician if the tech isn\u2019t careful working with it, which can cause serious injury.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      66,
      65,
      64,
      71,
      70
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 483,
    "question": "You need to install a new hard drive into a laptop. What sizes are most common for laptop hard drives? (Choose two.)",
    "choice_a": "1.5 inches",
    "choice_b": "1.8 inches",
    "choice_c": "2.5 inches",
    "choice_d": "3.5 inches",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Conventional desktop hard drives are 3.5 inches. Laptop hard drives will often be 2.5 inches or 1.8 inches. Smaller M.2 SSDs will be about the size of a stick of a desktop DIMM.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      69,
      64,
      72,
      71,
      68
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 484,
    "question": "You are training new users on how to use a laptop. Which laptop input device is a flat surface that you can slide across with your finger to control the cursor?",
    "choice_a": "Trackpad",
    "choice_b": "Trackball",
    "choice_c": "Point stick",
    "choice_d": "Mouse",
    "correct_answer": "A",
    "explanation": "The trackpad is an input device usually built into the laptop. It allows you to control the mouse pointer by dragging your finger across the surface. Trackballs, point sticks, and a mouse can also be used to control the cursor, but none of them are flat surfaces.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      70,
      64,
      66,
      68,
      69
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 485,
    "question": "You open a laptop to upgrade the memory and realize that the current RAM is soldered to the motherboard. What is the best option to upgrade the RAM?",
    "choice_a": "Use two SODIMM modules.",
    "choice_b": "Use two MicroDIMM modules.",
    "choice_c": "Use M.2 RAM modules.",
    "choice_d": "Replace the laptop.",
    "correct_answer": "D",
    "explanation": "If the RAM is soldered to the motherboard, there is no replacing it without replacing the entire motherboard. The best option, really the only option, is to replace the motherboard.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      67,
      68,
      64,
      65,
      71
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 486,
    "question": "A user is printing a one-page spreadsheet to a laser printer. The printer prints half of the spreadsheet on the top half of one piece of paper, and then the other half of the spreadsheet on the top half of a second piece of paper. What setting could be causing this to happen?",
    "choice_a": "Duplex",
    "choice_b": "Orientation",
    "choice_c": "Tray settings",
    "choice_d": "Quality",
    "correct_answer": "B",
    "explanation": "This is most likely an orientation issue. The spreadsheet might be designed to print in landscape mode (wider than it is tall), but the printer may be configured to print in portrait mode (taller than it is wide). Duplex refers to double-sided printing. Tray settings determine which paper tray to pull paper from, and quality sets options such as color and resolution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      91,
      96,
      89,
      78
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 487,
    "question": "Which of the following are valid methods to connect an inkjet printer? (Choose two.)",
    "choice_a": "USB",
    "choice_b": "IDE",
    "choice_c": "SATA",
    "choice_d": "Ethernet",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A common method for connecting printers today is using a USB connection. USB speeds are high and configuration is relatively easy. You might also be able to connect your printer to an Ethernet cable if it has an Ethernet port. IDE and SATA are storage device interfaces.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      56,
      57,
      63,
      89
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 488,
    "question": "What is the most basic printer type?",
    "choice_a": "Impact printer",
    "choice_b": "Inkjet printer",
    "choice_c": "Laser printer",
    "choice_d": "Thermal printer",
    "correct_answer": "A",
    "explanation": "Of the types listed here, the impact printer is the most basic. All of the other technologies were developed after the impact printer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      76,
      81,
      80
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 489,
    "question": "Which laser printer component formats the print job for the type of printer being used?",
    "choice_a": "Corona assembly",
    "choice_b": "DC power supply",
    "choice_c": "Printer controller assembly",
    "choice_d": "Formatter software",
    "correct_answer": "C",
    "explanation": "The printer controller assembly is responsible for formatting the print job for the type of printer being used. It formats the information into a page\u2019s worth of line-by-line commands for the laser scanner.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      91,
      80,
      78,
      77,
      76
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 490,
    "question": "Which of the following components in a laser printer is responsible for transferring toner from the drum to the paper?",
    "choice_a": "Fuser",
    "choice_b": "Transport corona",
    "choice_c": "Transfer corona",
    "choice_d": "Development wire",
    "correct_answer": "C",
    "explanation": "The transfer corona in the laser printer puts a positive charge on the paper, forcing the toner on a negatively charged drum to transfer to the paper.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      79,
      80,
      77,
      78,
      96
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 491,
    "question": "The ___________________ in a laser printer provides voltages to the corona wires.",
    "choice_a": "Corona assembly",
    "choice_b": "HVPS",
    "choice_c": "ACPS",
    "choice_d": "DCPS",
    "correct_answer": "B",
    "explanation": "The high-voltage power supply (HVPS) provides power to the corona wires in most laser printers. There is no ACPS or DCPS.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      78,
      80,
      77,
      79,
      76
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 492,
    "question": "A manager needs to ensure that an employee\u2019s review does not start printing until they are at the printer to retrieve it. Which feature should they use?",
    "choice_a": "Secure print",
    "choice_b": "User authentication",
    "choice_c": "Badging",
    "choice_d": "Audit log",
    "correct_answer": "A",
    "explanation": "The manager wants to print this as a secure print. Realistically, it\u2019s up to the printer administrator to enable this feature, but the manager should print to a printer with this feature. In order to use secure print, the manager may need to authenticate to the printer, and they may be able to use their company ID (badge) to authenticate.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      91,
      89,
      90
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 493,
    "question": "When installing a new inkjet printer in the office, a user asks to make sure it can print on both sides of the page. Which configuration option should be enabled to make this happen?",
    "choice_a": "Orientation",
    "choice_b": "Tray settings",
    "choice_c": "Duplex",
    "choice_d": "Quality",
    "correct_answer": "C",
    "explanation": "Duplex is the option for printing on both sides of the paper. Orientation specifies portrait or landscape. Tray settings let users choose different types of paper (and usually, inkjet printers only have one paper tray). Quality specifies options such as resolution or color.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      75,
      92,
      96,
      74,
      90
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 494,
    "question": "A user is taking call on their smartphone with a Bluetooth wireless headset. Which type of network have they created?",
    "choice_a": "PAN",
    "choice_b": "LAN",
    "choice_c": "MAN",
    "choice_d": "WLAN",
    "correct_answer": "A",
    "explanation": "The user has created a personal area network (PAN), which is used to describe Bluetooth networks. A local area network (LAN) is a computer network typically in an office or a home. Metropolitan area networks (MANs) span a city or a campus. A wireless local area network (WLAN) uses the 802.3 networking standards.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      99,
      145,
      102,
      101
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 495,
    "question": "Which of the following are connectors used with optical cables? (Choose all that apply.)",
    "choice_a": "ST",
    "choice_b": "LC",
    "choice_c": "RJ11",
    "choice_d": "F-type",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "Fiber-optic cables can use straight tip (ST), subscriber connector (SC), or Lucent connector (LC) connectors. RJ11 and F-type connectors are used with copper cable. There is no OC connector.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      113,
      116,
      110,
      112,
      147
    ],
    "source": "330034_Vol1_PT3",
    "choice_e": "SC",
    "choice_f": "OC"
  },
  {
    "id": 496,
    "question": "You need to create an Ethernet patch cable, and one end is configured as a T568A cable. How does the other end need to be configured?",
    "choice_a": "T568B",
    "choice_b": "T568A",
    "choice_c": "RJ45",
    "choice_d": "F-type",
    "correct_answer": "B",
    "explanation": "For a patch cable, both ends need to be configured identically. A crossover cable will use the T568A configuration at one end and T568B at the other end. RJ45 is a UTP connector type, and F-type is a coaxial connector type.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      112,
      116,
      115,
      108,
      146
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 497,
    "question": "Fire code regulations in your area require that you use network cables that are fire-resistant. What type of cables will you need to use?",
    "choice_a": "Coaxial",
    "choice_b": "Fiber-optic",
    "choice_c": "Plenum",
    "choice_d": "PVC",
    "correct_answer": "C",
    "explanation": "For areas where a cable must be fire retardant, such as in a drop ceiling, you must run plenum-grade cable. Plenum refers to the coating on the sleeve of the cable, not the media (copper or fiber) within the cable itself. PVC is the other type of coating typically found on network cables, but it produces poisonous gas when burned.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      110,
      113,
      116,
      146,
      148
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 498,
    "question": "Which of the following is an example of a MAC address?",
    "choice_a": "40-61-86-E4-5A-9B",
    "choice_b": "192.168.1.100",
    "choice_c": "2600:2b00:7994:b300:5129:9619:d2d3:72ec",
    "choice_d": "00101011 10111010 11101100 01000001",
    "correct_answer": "A",
    "explanation": "A media access control (MAC) address is a 48-bit hexadecimal address. 40-61-86-E4-5A-9B is the only address that fits this format. 192.168.1.100 is an IPv4 address. 2600:2b00:7994:b300:5129:9619:d2d3:72ec is an IPv6 address. 00101011 10111010 11101100 01000001 is 32 bits written in binary and would likely be some form of IPv4 notation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      118,
      122,
      117,
      114
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 499,
    "question": "Which of the following is the loopback address in IPv6?",
    "choice_a": "::1/128",
    "choice_b": "2000::/3",
    "choice_c": "ff00::/8",
    "choice_d": "fe80::/10",
    "correct_answer": "A",
    "explanation": "The loopback address in IPv6 is ::1/128. 2000::/3 is for global (Internet) addresses. ff00::/8 is reserved for multicasts, and fe80::/10 is link-local.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      118,
      122,
      123,
      119,
      106
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 500,
    "question": "Which protocol is designed to share files and printers between computers, regardless of the operating system that they run?",
    "choice_a": "SMB",
    "choice_b": "TFTP",
    "choice_c": "CIFS",
    "choice_d": "LDAP",
    "correct_answer": "C",
    "explanation": "Common Internet File System (CIFS) was developed by Microsoft as an enhancement to SMB and is designed to share files and printers between computers regardless of their operating system. Server Message Block (SMB) is also for sharing files and printers, but it\u2019s primarily used by Microsoft systems. Trivial File Transfer Protocol (TFTP) is for transferring files or sending configuration updates to networking devices. Lightweight Directory Access Protocol (LDAP) can store information such as the location of networked printers\u2014so it may help users find them\u2014but it\u2019s not used for sharing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      215,
      103,
      119,
      128
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 501,
    "question": "By default, on which port does Telnet run?",
    "choice_a": "110",
    "choice_b": "80",
    "choice_c": "53",
    "choice_d": "23",
    "correct_answer": "D",
    "explanation": "Telnet uses port 23 by default. POP3 uses port 110, HTTP uses port 80 and DNS uses port 53.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      121,
      119,
      131
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 502,
    "question": "You have blocked port 25 on your firewall. Based on this action, which of the following may be true?",
    "choice_a": "Clients on your network will not be able to access web pages.",
    "choice_b": "Clients on your network will not be able to send email.",
    "choice_c": "Clients on your network will not be able to retrieve email unless their email client supports POP3.",
    "choice_d": "Clients on your network will not be able to retrieve email unless their email client supports IMAP.",
    "correct_answer": "B",
    "explanation": "Port 25 is SMTP, which is used for sending email. POP3 (port 110) and IMAP (port 143) are used to retrieve email. Port 80 is used for Internet (HTTP) access.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      155,
      119,
      106
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 503,
    "question": "You are troubleshooting a client computer and discover it has an IP address of 169.254.10.25 with a subnet mask of 255.255.0.0. What does this indicate?",
    "choice_a": "Nothing; you need more information.",
    "choice_b": "The DNS server has malfunctioned.",
    "choice_c": "The client\u2019s address has been manually configured.",
    "choice_d": "The client was unable to reach the DHCP server.",
    "correct_answer": "D",
    "explanation": "Automatic Private IP Addressing (APIPA) addresses are in the 169.254.0.0 network. The fact that this client has an address in that range means that it was unable to obtain a lease from the DHCP server, and configured itself with APIPA.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      124,
      122,
      118
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 504,
    "question": "Which of the following is an advantage of using UDP instead of TCP?",
    "choice_a": "UDP guarantees packet delivery.",
    "choice_b": "UDP is faster.",
    "choice_c": "UDP can make use of the ICMP protocol.",
    "choice_d": "UDP is routable on the Internet.",
    "correct_answer": "B",
    "explanation": "UDP is connectionless and does not send or wait for packet receipt acknowledgments. Therefore, it is a little faster than TCP. Both TCP and UDP can use ICMP and are routable on the Internet.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      119,
      117,
      118,
      120,
      132
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 505,
    "question": "Which ports does DHCP use?",
    "choice_a": "20 and 21",
    "choice_b": "80 and 443",
    "choice_c": "67 and 68",
    "choice_d": "53 and 54",
    "correct_answer": "C",
    "explanation": "DHCP uses UDP ports 67 and 68. FTP uses TCP ports 20 and 21. Ports 80 and 443 are used by HTTP and HTTPS, respectively. Port 53 is used by DNS.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      128,
      121,
      119,
      120,
      132
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 506,
    "question": "A RADIUS server is an example of what type of server?",
    "choice_a": "DNS",
    "choice_b": "Email",
    "choice_c": "Proxy",
    "choice_d": "Authentication",
    "correct_answer": "D",
    "explanation": "Remote Authentication Dial-In User Service (RADIUS) servers are authentication servers. They do not provide DNS, email, or proxy services.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      153,
      127,
      121,
      104
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 507,
    "question": "Which of the following security frameworks helps eliminate email spam by validating the sending email server using a public-private key pair?",
    "choice_a": "SCADA",
    "choice_b": "DKIM",
    "choice_c": "SPF",
    "choice_d": "DMARC",
    "correct_answer": "B",
    "explanation": "Sender Policy Framework (SPF) validates email servers by verifying their IP addresses. DMARC is a decision framework that tells an inbound email server what to do with email marked as spam.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      120,
      126,
      117,
      131
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 508,
    "question": "You are giving training about reading syslog messages. Which of the following is <i>not</i> a component of syslog messages?",
    "choice_a": "Facility code",
    "choice_b": "Severity level",
    "choice_c": "Device code",
    "choice_d": "Text description",
    "correct_answer": "C",
    "explanation": "Syslog messages consists of a facility code (which identifies the type of device), a severity level, and a text description. The device is identified by the facility code.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      131,
      119,
      120,
      106
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 509,
    "question": "What should be incorporated into a DHCP scope if the addresses in the range are manually configured by the administrator?",
    "choice_a": "Exclusions",
    "choice_b": "Reservations",
    "choice_c": "Leases",
    "choice_d": "Scope options",
    "correct_answer": "A",
    "explanation": "An exclusion tells the DHCP server to not assign that IP address. This can be used if the addresses in the scope are otherwise manually assigned to a device by the network administrator. Reservations will assign an address to a device based on its MAC address. Leases are the length of time an address is assigned. Scope options give out additional configuration information such as a DNS server address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      128,
      122,
      123
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 510,
    "question": "Which of the following legacy Wi-Fi standards is backward compatible with both 802.11a and 802.11b?",
    "choice_a": "802.11g",
    "choice_b": "802.11n",
    "choice_c": "802.11i",
    "choice_d": "None of the above",
    "correct_answer": "B",
    "explanation": "The 802.11n standard utilizes both the 2.4 GHz and 5 GHz spectrums, and is backward compatible with both 802.11a (5 GHz) and 802.11b (2.4 GHz). 802.11g operates at 2.4 GHz and is only backward compatible with 802.11b. 802.11i is a security specification.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      138,
      140,
      142,
      143
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 511,
    "question": "What is the term that describes when packets meet the criteria of a firewall\u2019s ACL and are passed through?",
    "choice_a": "Port forwarding",
    "choice_b": "Port assignment",
    "choice_c": "Port triggering",
    "choice_d": "Rule propagation",
    "correct_answer": "A",
    "explanation": "Port forwarding is when a packet meets the ACL criteria and is passed through the firewall. Port triggering is an automated form of port forwarding.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      155,
      137,
      124,
      114,
      131
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 512,
    "question": "You need to configure a firewall to deny access to all computers except for about 25 clients. What should you use to do this?",
    "choice_a": "Block list",
    "choice_b": "MAC filtering",
    "choice_c": "Port forwarding",
    "choice_d": "Allow list",
    "correct_answer": "D",
    "explanation": "An allow list denies access to all computers except for those listed on the allow list. A block list allows access to everyone (default allow) except those on the block list. MAC filtering could possibly work, but it\u2019s less secure than block lists or allow lists because MAC addresses can be easily spoofed.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      155,
      131,
      108,
      135,
      125
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 513,
    "question": "What is the name of the service that translates between public IP addresses and private, nonroutable IP addresses?",
    "choice_a": "DNS",
    "choice_b": "ARP",
    "choice_c": "NAT",
    "choice_d": "APIPA",
    "correct_answer": "C",
    "explanation": "Network Address Translation (NAT) translates between public and private IP addresses. DNS resolves hostnames to IP addresses. ARP resolves IP addresses to MAC addresses. APIPA is an automatic IP configuration mechanism if a DHCP server is unavailable.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      155,
      118,
      121,
      123
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 514,
    "question": "Which wireless encryption protocol uses AES-CCMP?",
    "choice_a": "NAT",
    "choice_b": "WPA",
    "choice_c": "WPA2",
    "choice_d": "TKIP",
    "correct_answer": "C",
    "explanation": "The most advanced wireless security protocol listed is WPA2, which uses AES-CCMP. WPA3 uses it as well. NAT is Network Address Translation, which translates private IP addresses into public ones. WPA is an inferior protocol to WPA2 and does not support it. TKIP was a predecessor to AES and is used by WPA.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      153,
      107,
      152,
      102,
      154
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 515,
    "question": "Which wireless networking technologies operate in the 13.56 MHz range? (Choose two.)",
    "choice_a": "LTE",
    "choice_b": "NFC",
    "choice_c": "RFID",
    "choice_d": "Bluetooth",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "NFC operates at 13.56 MHz. Radio frequency identification (RFID) can operate in three frequency bands: 125 kHz to 134 kHz, 13.56 MHz, or 856 MHz to 960 MHz. Bluetooth is 2.4 GHz, and LTE is between 600 MHz and 6 GHz.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      145,
      151,
      107,
      99
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 516,
    "question": "Which of the following protocols <i>cannot</i> be used to retrieve mail on a mobile device from a mail server? (Choose all that apply.)",
    "choice_a": "IMAP4",
    "choice_b": "POP3",
    "choice_c": "SMTP",
    "choice_d": "GPS",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "SMTP is for sending mail, not retrieving it. GPS is a location service. The two protocols used to retrieve email are IMAP (the current version is IMAPv4 or IMAP4) and POP3.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      170,
      172,
      157,
      159,
      162
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 517,
    "question": "Which type of location service provides the greatest level of accuracy, when available?",
    "choice_a": "GPS",
    "choice_b": "Bluetooth",
    "choice_c": "Cellular",
    "choice_d": "NFC",
    "correct_answer": "B",
    "explanation": "GPS, Bluetooth, cellular, and Wi-Fi can all be used for location services. NFC cannot. Bluetooth can provide greater accuracy than GPS or cellular.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      166,
      165,
      159,
      162,
      157
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 518,
    "question": "What can a user do to download data onto their mobile device if they have reached their data cap?",
    "choice_a": "Reset their cellular connection.",
    "choice_b": "Configure their device to accept policy enforcement.",
    "choice_c": "Configure their device to deny policy enforcement.",
    "choice_d": "Use a Wi-Fi connection.",
    "correct_answer": "D",
    "explanation": "Data caps may apply to cellular connections, depending on the cellular service agreement. Wi-Fi downloading will be free, if the mobile device is on a network. Policy enforcement has nothing to do with data caps, nor can a user choose to have their device accept or deny policy enforcement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      163,
      171,
      162,
      157,
      159
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 519,
    "question": "By default, which of the following are connection methods that allow the connection of an iPhone to a PC for synchronization? (Choose two.)",
    "choice_a": "Wi-Fi",
    "choice_b": "USB",
    "choice_c": "Bluetooth",
    "choice_d": "Ethernet",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Synchronization of an iOS device can occur over wired USB connections or over Wi-Fi connections, not Bluetooth or Ethernet.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      171,
      172,
      159,
      162,
      164
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 520,
    "question": "You have been asked to configure client-side virtualization on a friend\u2019s workstation. They are concerned that their computer will not be able to run Windows, Linux, and macOS at the same time. What is your response?",
    "choice_a": "It can\u2019t run all three OSs at once.",
    "choice_b": "It can run all three, provided that it has sufficient resources to support all three.",
    "choice_c": "It can run all three, but it requires the installation of multiple hypervisors.",
    "choice_d": "It can run all three, but it requires the use of a Type 1 hypervisor.",
    "correct_answer": "B",
    "explanation": "As long as the computer has sufficient resources to support the host OS and guest OSs, it can run as many as the user would like. Only one hypervisor is needed, and it can manage multiple virtual OSs.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      174,
      178,
      176,
      175,
      179
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 521,
    "question": "Which of the following provides only hardware such as storage space and processing power?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "DaaS",
    "correct_answer": "A",
    "explanation": "Infrastructure as a service (IaaS) provides hardware and only hardware (or infrastructure). Software as a service (SaaS) and platform as a service (PaaS) may also include hardware, but they also include software development tools (PaaS) and apps (SaaS). There is no DaaS in the A+ exam objectives, although that usually stands for data as a service, which is a data management service, or desktop as a service.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      182,
      180,
      183,
      178,
      177
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 522,
    "question": "Which of the following types of clouds provides the highest level of global scalability?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Hybrid",
    "choice_d": "Community",
    "correct_answer": "A",
    "explanation": "Public clouds offer the best in scalability, reliability, flexibility, geographical independence, and cost effectiveness. All resources are owned and managed by a CSP, and the client can get more resources quickly as needed. Private clouds have the least scalability because only one company owns them. Hybrid is a mix of public and private, and community clouds are shared between companies which can limit their scalability if one of the parties does not want to invest more.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      181,
      180,
      183,
      182,
      184
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 523,
    "question": "Which of the following is true for the network requirements of virtualized computers that want to participate on a network with computers that are not virtualized?",
    "choice_a": "Each virtualized compuer needs a virtual NIC and a physical NIC.",
    "choice_b": "Each virtualized compuer needs a physical NIC, but there is no virtual NIC requirement.",
    "choice_c": "Each virtualized computer needs a virtual NIC, but there is no physical NIC requirement.",
    "choice_d": "Each virtualized computer needs a virtual NIC, but only one physical NIC is required.",
    "correct_answer": "D",
    "explanation": "Virtual computers will be assigned to a virtual NIC. That virtual NIC will be linked to a physical NIC. The physical NIC can be shared among virtual NICs, but of course if there are multiple computers trying to communicate using the same NIC, there may be slow network performance issues.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      178,
      174,
      176,
      179,
      175
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 524,
    "question": "An administrator wants to create a virtual machine to act as a test area for new server feature deployments. What type of environment are they seeking to create?",
    "choice_a": "Legacy software",
    "choice_b": "Cross-platform virtualization",
    "choice_c": "Containers",
    "choice_d": "Sandbox",
    "correct_answer": "D",
    "explanation": "A sandbox is a temporary, isolated desktop environment, that can be used to test changes to an app or network. Legacy software is outdated software, and cross-platform virtualization would involve multiple OSs. Containers are used for software virtualization.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      175,
      174,
      177,
      179,
      178
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 525,
    "question": "You suspect that there is a problem with a customer\u2019s USB ports. Which of the following devices is used to test a USB port?",
    "choice_a": "A loopback plug",
    "choice_b": "A USB reflector",
    "choice_c": "A toner probe",
    "choice_d": "A cable tester",
    "correct_answer": "A",
    "explanation": "Various versions of loopback connectors are used to test ports, such as serial and network interfaces, and they are often used as part of the troubleshooting process. There is no such thing as a USB reflector. A toner probe helps identify the other end of the same cable, and a cable tester certifies cables for their intended purpose.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      116,
      112,
      110,
      113,
      106
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 526,
    "question": "When a laptop boots up, it does not appear to complete the POST routine. Which device can be used to help troubleshoot the problem?",
    "choice_a": "POST master",
    "choice_b": "POST card",
    "choice_c": "BIOS diagnostics",
    "choice_d": "BIOS investigator",
    "correct_answer": "B",
    "explanation": "If a system will not complete the POST routine, you can use a POST card (in this case, a USB one) to help determine what the issue is. There are no POST master, BIOS diagnostics, or BIOS investigator devices.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      196,
      195,
      188,
      190,
      202
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 527,
    "question": "The built-in network card on a user\u2019s laptop isn\u2019t working. What things should you have them check first? (Choose two.)",
    "choice_a": "See if there are any connectivity lights.",
    "choice_b": "Make sure the network card switch didn\u2019t get turned off accidentally.",
    "choice_c": "Plug the network card into a cable and see if it works.",
    "choice_d": "Check their TCP/IP settings to make sure they\u2019re getting an IP address from a DHCP server.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The first two things to check would be to see if there are any lights, and to ensure that the card didn\u2019t get turned off on accident. Those are the easy ones. If the card appears to be on, then you can try to plug it in and see if it works, if they have a cable.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      229,
      190,
      188,
      191,
      216
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 528,
    "question": "You are installing a new wireless router and want to see how far the signal reliably travels. Which tool should you use for this purpose?",
    "choice_a": "Loopback plug",
    "choice_b": "Punchdown tool",
    "choice_c": "Wi-Fi analyzer",
    "choice_d": "Toner and probe",
    "correct_answer": "C",
    "explanation": "A Wi-Fi analyzer is the appropriate tool to test wireless signals. A loopback plug is for testing the ability of a network adapter to send and receive. A punchdown tool is for connecting wires to a 110-block, and a tone generator and probe is used to trace a cable from one location to another.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      156,
      138,
      139,
      154,
      141
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 529,
    "question": "What component starting to fail will most likely manifest as a low IOPS?",
    "choice_a": "SSD",
    "choice_b": "CPU",
    "choice_c": "PSU",
    "choice_d": "Motherboard",
    "correct_answer": "A",
    "explanation": "Input/output operations per second (IOPS) is associated with hard drive performance. If an SSD is starting to fail, it may experience low IOPS.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      206,
      207,
      200,
      203,
      194
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 530,
    "question": "You just make a new UTP network cable. What is the next tool you should use before installing it?",
    "choice_a": "Network tap",
    "choice_b": "Punchdown tool",
    "choice_c": "Cable tester",
    "choice_d": "Crimper",
    "correct_answer": "C",
    "explanation": "After creating a cable, you should make sure it works by using a cable tester. A network tap monitors network traffic. A punchdown tool connects wires to a frame such as a 110-block. Crimpers put connectors onto the ends of cables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      116,
      146,
      110,
      109
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 531,
    "question": "You are working on a laser printer. The client explains that the toner is not clearly pressed on the paper or staying on the paper. Which of the following components might you suspect as the cause of the problem?",
    "choice_a": "Transfer corona",
    "choice_b": "Fuser",
    "choice_c": "Printer controller circuitry",
    "choice_d": "Paper transport assembly",
    "correct_answer": "B",
    "explanation": "The fuser is responsible for permanently pressing the toner onto the paper. The fuser assembly presses and melts the toner right into the paper. The transfer corona transfers the toner from the drum to the paper. The printer controller circuitry converts signals from the PC into signals for the various printer assemblies. The paper transport assembly controls the movement of the paper through the printer.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      239,
      238,
      236,
      235,
      190
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 532,
    "question": "You suspect that there is a problem with a customer\u2019s USB port on their laptop. You check the OS settings and the USB port is enabled. What will resolve the problem?",
    "choice_a": "Replace the laptop.",
    "choice_b": "Get a USB hub for the laptop.",
    "choice_c": "Reboot the laptop.",
    "choice_d": "Configure the USB port to support Ultra High Speed.",
    "correct_answer": "A",
    "explanation": "If the USB port on a laptop doesn\u2019t work and it\u2019s properly enabled, the only thing you can do is replace the port (if possible) or the laptop itself.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      230,
      190,
      188,
      227,
      196
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 533,
    "question": "You are sending print jobs to the printer, but nothing is printing. The printer is connected properly and online. What should you do?",
    "choice_a": "Delete and reinstall the printer.",
    "choice_b": "Delete and reinstall Windows.",
    "choice_c": "Reboot the printer.",
    "choice_d": "Stop and restart the print spooler.",
    "correct_answer": "D",
    "explanation": "If print jobs are seemingly getting \u201cstuck\u201d in the printer queue, you should stop and restart the print spooler service. Deleting and reinstalling is not necessary, and rebooting the printer won\u2019t likely resolve print queue issues on the print server.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      240,
      242,
      188,
      190,
      237
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 534,
    "question": "You believe your laser printer has a power issue. Using a multimeter, what reading should you get from pin 9?",
    "choice_a": "+24V",
    "choice_b": "\u201324V",
    "choice_c": "+5V",
    "choice_d": "\u20135V",
    "correct_answer": "A",
    "explanation": "Pin 9 on a laser printer should read +24V. Pin 1 is +5V, and pin 5 is \u20135V.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      237,
      201,
      238,
      239,
      234
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 535,
    "question": "A user reports that their mouse cursor frequently moves up and to the left on their laptop screen, even if they aren\u2019t touching the mouse or the keyboard. What is the most likely cause of the problem?",
    "choice_a": "The point stick",
    "choice_b": "The touchpad",
    "choice_c": "The mouse driver",
    "choice_d": "The display unit",
    "correct_answer": "A",
    "explanation": "This is called pointer drift, and it has to be a problem with the point stick. Have the user try moving the point stick around and seeing if it will re-center itself. Rebooting may also help. If not, then the point stick may need to be replaced. Touchpad mouse cursor issues often involve the cursor jumping from one part of the screen to another. This problem is not caused by the mouse driver or display unit.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      227,
      189,
      190,
      188,
      191
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 536,
    "question": "What are the most common causes of crinkled paper coming out of a laser printer? (Choose all that apply.)",
    "choice_a": "The printer is out of toner.",
    "choice_b": "The printer\u2019s gears are stripped.",
    "choice_c": "The printer has an obstructed paper path.",
    "choice_d": "The printer overheated.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The printer is probably obstructed by something, or its gears have been stripped by paper feeding incorrectly. Obstructions are usually caused by paper from a previous jam. When cleaning out a paper jam, make sure you get all the paper.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      239,
      234,
      236,
      237,
      190
    ],
    "source": "330034_Vol1_PT3"
  },
  {
    "id": 537,
    "question": "Which component is responsible for managing POST?",
    "choice_a": "CPU",
    "choice_b": "PSU",
    "choice_c": "BIOS",
    "choice_d": "HDD",
    "correct_answer": "C",
    "explanation": "The BIOS begins and manages the execution of the power-on self-test (POST) when the computer performs a cold boot.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      8,
      3,
      1,
      43
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 538,
    "question": "You need to replace faulty RAM in a desktop PC. The motherboard documentation says the motherboard has DDR4 slots. Which type of RAM can you replace the faulty RAM with?",
    "choice_a": "DDR3 or DDR4",
    "choice_b": "DDR4 only",
    "choice_c": "DDR4 or DDR5",
    "choice_d": "Any DDR as long it has the same ECC configuration",
    "correct_answer": "B",
    "explanation": "Motherboards will support only one type of RAM. If it\u2019s a DDR4 motherboard, you must use DDR4.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      16,
      18,
      26,
      6,
      15
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 539,
    "question": "On a motherboard, where will the CPU fan typically plug into to receive power?",
    "choice_a": "Header",
    "choice_b": "PCI",
    "choice_c": "PCIe",
    "choice_d": "SATA",
    "correct_answer": "A",
    "explanation": "CPU fans will typically plug into a 3-pin or 4-pin header on the motherboard. PCI and PCIe are for expansion cards. SATA is for hard drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      23,
      22,
      21,
      43,
      44
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 540,
    "question": "You are troubleshooting a desktop computer that keeps \u201cforgetting\u201d the boot sequence of devices it is supposed to boot from. After you reset it in BIOS, power off, and power back on, the incorrect setting is back. What should you try first to resolve the problem?",
    "choice_a": "Flash the system BIOS.",
    "choice_b": "Reseat the cables for the SSD boot device.",
    "choice_c": "Unplug and reseat the CMOS chip.",
    "choice_d": "Replace the CMOS battery.",
    "correct_answer": "D",
    "explanation": "The CMOS battery gives the BIOS enough power to store system settings such as the boot sequence when the computer is powered off. Replacing the battery will likely resolve the problem.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      8,
      5,
      43,
      41,
      7
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 541,
    "question": "Which of these is not a stand-alone motherboard form factor?",
    "choice_a": "Mini-ITX",
    "choice_b": "ITX",
    "choice_c": "ATX",
    "choice_d": "BTX",
    "correct_answer": "B",
    "explanation": "The ITX \u201cform factor\u201d is really a family of form factors, comprising mini-ITX, nano-ITX, pico-ITX, and mobile-ITX.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      3,
      2,
      11,
      9
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 542,
    "question": "Where would an administrator go to disable the USB ports on a laptop computer?",
    "choice_a": "TPM",
    "choice_b": "HSM",
    "choice_c": "ARM",
    "choice_d": "UEFI",
    "correct_answer": "D",
    "explanation": "USB ports can be physically disabled in the UEFI. TPM and HSM are for encryption. ARM is a type of CPU.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      7,
      30,
      38,
      10
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 543,
    "question": "You have been asked to configure a RAID array for a client. Which of the following standards only require two drives to set up? (Choose all that apply.)",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 6",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "RAID 0 is disk striping, and RAID 1 is disk mirroring. Each requires just two drives to set up. RAID 5 requires a minimum of three drives, and RAID 6 and RAID 10 require at least four.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      35,
      44,
      43,
      41
    ],
    "source": "330034_Vol1_PT4",
    "choice_e": "RAID 10"
  },
  {
    "id": 544,
    "question": "A client is looking for a new energy-efficient power supply. Which standard should you tell them to look for when purchasing a new one, to give them the most energy-efficient model?",
    "choice_a": "70 PLUS",
    "choice_b": "80 PLUS",
    "choice_c": "85 PLUS",
    "choice_d": "90 PLUS",
    "correct_answer": "B",
    "explanation": "The 80 PLUS rating is an industry standard for energy efficiency. There are no 70 PLUS, 85 PLUS, or 90 PLUS power supply standards (although 80 PLUS Titanium is over 90 percent efficient at all load levels).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      47,
      45,
      41,
      42,
      43
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 545,
    "question": "You are moving desktop computers between two countries. The power supplies have manual voltage selectors. When should the voltage selector switch on a power supply be set to the higher of the two settings?",
    "choice_a": "When using the computer system in Europe",
    "choice_b": "When plugging the computer system into the same outlet designed for a clothes dryer or range",
    "choice_c": "When overclocking the CPU",
    "choice_d": "When using dual PCIe graphics adapters",
    "correct_answer": "A",
    "explanation": "Setting the voltage selector switch to the higher of the two selections, usually 220, 230, or 240 (VAC), is necessary when using the computer in a country that has a power grid that supplies such a voltage with a frequency of 50Hz.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      41,
      47,
      43,
      44
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 546,
    "question": "You have just installed a new power supply. It has a 24-pin power connector coming from it. Which component should that be plugged into?",
    "choice_a": "SATA SSD",
    "choice_b": "PCIe video card",
    "choice_c": "SAS SSD",
    "choice_d": "Motherboard",
    "correct_answer": "D",
    "explanation": "A 24-pin power connector is an ATX connector for a motherboard. SATA and SAS drives have 15-pin power connectors, and PCIe video cards use 6-pin or 8-pin PCIe connectors.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      43,
      45,
      41,
      44,
      27
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 547,
    "question": "When choosing a storage solution, which of the following is not an advantage of SSD over HDD?",
    "choice_a": "Faster startup times",
    "choice_b": "Lower cost per gigabyte",
    "choice_c": "Lower power consumption",
    "choice_d": "Silent operation",
    "correct_answer": "B",
    "explanation": "SSDs have many advantages over HDDs, including faster startup and read times, less power consumption, silent operation, and being less susceptible to damage from shock. They are most expensive per gigabyte, however.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      35,
      36,
      4,
      38
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 548,
    "question": "A client\u2019s office experiences frequent power outages due to bad weather. They want to protect their desktop computer so that when the power goes out, it does not abruptly shut down. Which solution is best for them?",
    "choice_a": "A modular power supply",
    "choice_b": "A UPS",
    "choice_c": "A redundant power supply",
    "choice_d": "An energy efficient power supply",
    "correct_answer": "B",
    "explanation": "A uninterruptible power supply (UPS) is a battery backup system that can help attached devices maintain power in the event of a power outage. Modular power supplies have removable power cords for internal components. Redundant power supplies will help if one power supply fails, but not if there is a power outage. Energy efficiency will not help if there is no energy.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      46,
      47,
      45,
      41,
      43
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 549,
    "question": "When installing a new M.2 hard drive into a desktop computer, which of the following do you need to be sure to connect?",
    "choice_a": "The power connector.",
    "choice_b": "The data cable.",
    "choice_c": "The power connector and data cable.",
    "choice_d": "Neither a power connector nor a data cable are required. The drive will get power and data from the M.2 port.",
    "correct_answer": "D",
    "explanation": "M.2 hard drives get power and data from the connector. They do not require the installation of separate power and data connectors to function properly.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      4,
      40,
      35,
      34
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 550,
    "question": "Which of the following best describes the job performed by an inverter?",
    "choice_a": "It converts DC power to AC power for the backlight.",
    "choice_b": "It converts AC power to DC power for the backlight.",
    "choice_c": "It provides illumination for LCD displays.",
    "choice_d": "It provides illumination for OLED displays.",
    "correct_answer": "A",
    "explanation": "The inverter takes DC power from the power supply and converts it into high-frequency power needed by the backlight in an LCD display.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      49,
      41,
      48,
      78,
      76
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 551,
    "question": "You are purchasing a new monitor, and one claims to have the highest PPI available. Which attribute is this referring to?",
    "choice_a": "Screen resolution",
    "choice_b": "Refresh rate",
    "choice_c": "Pixel density",
    "choice_d": "Color gamut",
    "correct_answer": "C",
    "explanation": "Pixels per inch (PPI) is a measure of pixel density. This is not to be confused with screen resolution, which refers to the number of pixels across the entire display.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      51,
      53,
      48,
      52,
      60
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 552,
    "question": "A user is unhappy because when playing live-action video games, the screen often becomes blurry. They are convinced that if the screen never became blurry, they could be a champion gamer. What should they do to resolve the issue?",
    "choice_a": "Get a display with better color gamut.",
    "choice_b": "Get a display with higher refresh rates.",
    "choice_c": "Get a display with higher screen resolution.",
    "choice_d": "Update the video card driver.",
    "correct_answer": "B",
    "explanation": "Higher refresh rates mean that the display will re-draw the screen image faster, resulting in less blurry images for fast-action content such as video games and live sports. A higher refresh rate is called for in this case.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      50,
      53,
      48,
      49,
      52
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 553,
    "question": "Which video technology supports both analog and digital signals, each requiring a cable with different connectors from the other?",
    "choice_a": "VGA",
    "choice_b": "HDMI",
    "choice_c": "DisplayPort",
    "choice_d": "DVI",
    "correct_answer": "D",
    "explanation": "DVI cables and interfaces are available in analog and digital varieties. The two are not compatible or convertible. VGA is analog. HDMI and DisplayPort are always digital.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      61,
      62,
      63,
      59
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 554,
    "question": "You have a monitor with a DVI-I connector, but the video card in the computer only supports HDMI. Which of the following statements is true?",
    "choice_a": "DVI-I and HDMI are electrically incompatible. This monitor will not work with the motherboard.",
    "choice_b": "DVI-I and HDMI use the same connector, so the monitor will work fine with the motherboard.",
    "choice_c": "DVI-I and HDMI are electrically incompatible. Use a DVI-I to DVI-D adapter, and then a DVI-D to HDMI adapter to connect the monitor to the computer.",
    "choice_d": "Use a DVI-I to HDMI adapter to connect the monitor to the computer.",
    "correct_answer": "D",
    "explanation": "HDMI is electrically compatible with both DVI-I and DVI-D. Use a DVI to HDMI adapter to make the connection work. HDMI and DVI use different connectors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      62,
      63,
      61,
      27
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 555,
    "question": "A user just configured their display to an unsupported refresh rate in Windows 11 and now the image on the screen is flashing off and on. What should they do?",
    "choice_a": "Immediately turn the computer off.",
    "choice_b": "Reinstall the video card driver.",
    "choice_c": "Press the reset button on the inverter.",
    "choice_d": "Wait 15 seconds.",
    "correct_answer": "D",
    "explanation": "Wait 15 seconds, and the computer will revert back to the previous display settings, which should resolve the issue. There is no need to reboot or reinstall a driver. There is no reset button on an inverter.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      50,
      53,
      31,
      52,
      8
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 556,
    "question": "You need to leave your laptop in an unsecured office. What should you use to keep it from being stolen?",
    "choice_a": "Screen lock",
    "choice_b": "Cable lock",
    "choice_c": "Bicycle lock",
    "choice_d": "GPS tracking",
    "correct_answer": "B",
    "explanation": "A cable lock (or physical laptop lock) can be used to secure your laptop to a desk to prevent its theft. There is no screen lock\u2014using a screensaver password can help secure your system but not from physical theft. A bicycle lock isn\u2019t designed to secure a laptop. GPS tracking can help locate a stolen laptop, but not prevent its theft.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      64,
      72,
      157,
      173
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 557,
    "question": "You are replacing a laptop display. Which of the following components is least likely to be found in the laptop display?",
    "choice_a": "Inverter",
    "choice_b": "Webcam",
    "choice_c": "Microphone",
    "choice_d": "DC jack",
    "correct_answer": "D",
    "explanation": "Laptop displays will often have the Wi-Fi antenna, webcam, microphone, and inverter in them, and also possibly a digitizer. A DC jack is for a DC power source, such as that found within cars or on airplanes, and is not located in the display.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      66,
      64,
      65,
      67,
      71
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 558,
    "question": "You are enabling advanced security for all laptop users and require them to use biometrics to log in. Which of the following would qualify for the new security measures? (Choose all that apply.)",
    "choice_a": "Fingerprint",
    "choice_b": "Employee ID with picture",
    "choice_c": "Facial recognition",
    "choice_d": "Retinal scan",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Biometrics requires the use of a body part to log in. Examples can include fingerprints, facial recognition, retinal scans, or voice recognition. An employee ID, even with a picture, is not considered biometrics.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      95,
      5,
      8,
      94
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 559,
    "question": "One of your users spilled soda on his laptop. While the laptop still appears to work relatively well, many of the keys stick. What is the best solution to the problem?",
    "choice_a": "Replace the laptop.",
    "choice_b": "Replace the laptop keyboard.",
    "choice_c": "Connect an external USB keyboard.",
    "choice_d": "Spray the laptop with demineralized water.",
    "correct_answer": "C",
    "explanation": "If the laptop seems to work, there is no sense in replacing it. Have the user connect an external USB keyboard to avoid the problem of sticky keys.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      57,
      56,
      58,
      63,
      38
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 560,
    "question": "Which of the following laptop accessories provide output? (Choose all that apply.)",
    "choice_a": "Stylus",
    "choice_b": "Headsets",
    "choice_c": "Speakers",
    "choice_d": "Webcam",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Both headsets and speakers produce audio output. A stylus is for tactile input, and a webcam is for video input.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      55,
      28,
      60,
      61,
      63
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 561,
    "question": "Which device in an inkjet printer contains the printhead?",
    "choice_a": "Ink cartridge",
    "choice_b": "Toner cartridge",
    "choice_c": "Daisy wheel",
    "choice_d": "Paper tray",
    "correct_answer": "A",
    "explanation": "In an inkjet printer, the ink cartridge is the actual printhead. This is where the ink is expelled to form letters or graphics. Toner cartridges are used by laser printers to store toner. A daisy wheel is the device that impacts the letters on the paper in a daisy-wheel printer. Paper trays are the storage bins in laser printers and inkjet printers that allow the pickup rollers to feed the paper into the printer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      74,
      96,
      76,
      77,
      73
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 562,
    "question": "What type of printer uses special waxy paper that gets darker, exposing an image, as heat passes over it?",
    "choice_a": "Thermal",
    "choice_b": "Dye sublimation",
    "choice_c": "Heated",
    "choice_d": "Radiation",
    "correct_answer": "A",
    "explanation": "A thermal printer uses special waxy paper that darkens when exposed to heat. A dye sublimation printer (not covered in the chapter) uses heat to transfer an image from paper to material such as fabric or ceramic. There are no heated or radiation printers. The most popular use of this was in older fax machines. This technology is uncommon today.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81,
      73,
      74,
      78,
      96
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 563,
    "question": "You are installing a printer for a medical firm. On this printer, they will print carbonless three-part forms. One form will go in the patient\u2019s file, one to the insurance company, and one will be mailed to the patient. Which type of printer would you recommend they use?",
    "choice_a": "Thermal printer",
    "choice_b": "Impact printer",
    "choice_c": "Inkjet printer",
    "choice_d": "Laser printer",
    "correct_answer": "B",
    "explanation": "In a situation where someone is using a multipart form, a printer that makes an impact on the paper is required. None of the other printers will produce images on the second and third pages of three-part forms.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      73,
      74,
      96,
      75,
      76
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 564,
    "question": "You are troubleshooting a laser printer that keeps jamming. When you talk to the printer manufacturer\u2019s support reps, they ask what caliper of paper you are using. What are they referring to?",
    "choice_a": "The length of the paper",
    "choice_b": "The smoothness of the paper",
    "choice_c": "The thickness of the paper",
    "choice_d": "The width of the paper",
    "correct_answer": "C",
    "explanation": "Caliper refers to the thickness of the paper.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      96,
      78,
      75,
      73,
      89
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 565,
    "question": "A technician is preparing to perform laser printer maintenance. Which of the following should he consider?",
    "choice_a": "Replace paper, clean heating element, remove debris",
    "choice_b": "Replace ribbon, replace printhead, replace paper",
    "choice_c": "Replace toner, apply maintenance kit, calibrate, clean",
    "choice_d": "Clean printheads, replace cartridges, calibrate, clear jams",
    "correct_answer": "C",
    "explanation": "Laser printer maintenance includes replace toner, apply maintenance kit, calibrate, clean. Inkjet printer maintenance includes clean printheads, replace cartridges, calibrate, clear jams. Thermal printer maintenance includes replace paper, clean heating element, remove debris. Impact printer maintenance includes replace ribbon, replace printhead, replace paper.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      96,
      77,
      79,
      78,
      80
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 566,
    "question": "Which of the following are options for where to save or send a scanned document from an MFD? (Choose all that apply.)",
    "choice_a": "Cloud",
    "choice_b": "Email",
    "choice_c": "Network folder",
    "choice_d": "MFD\u2019s local memory",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Scanned documents can be emailed or saved to the cloud or a network folder. Most MFDs do not allow for the saving of scanned documents on the local device.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      95,
      93,
      90,
      89,
      94
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 567,
    "question": "Your manager has asked you to allow employees to log in to printers using their company-issued employee ID. Once they are logged in, print jobs need to be tracked. Which of the following processes will you implement?",
    "choice_a": "Audit logs",
    "choice_b": "Badging",
    "choice_c": "User authentication",
    "choice_d": "Secured prints",
    "correct_answer": "A",
    "explanation": "Audit logs will track print jobs and the users who printed them. User authentication is where a user is required to log into the printer. This can be done via badging\u2014or swiping an employee badge on a badge reader on the printer\u2014or by manually entering credentials. Secured prints is when a print job is held until a user authenticates at the printer and tells it to start printing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      90,
      95,
      31
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 568,
    "question": "A user is printing to a MFD. They are trying to print in color but the output is always in grayscale. The MFD is capable of color printing. Which configuration option most likely needs to be changed?",
    "choice_a": "Orientation",
    "choice_b": "Tray settings",
    "choice_c": "Duplex",
    "choice_d": "Quality",
    "correct_answer": "D",
    "explanation": "Quality specifies options such as resolution or color. Duplex is the option for printing on both sides of the paper. Orientation specifies portrait or landscape. Tray settings let users choose different types of paper. Quality specifies options such as resolution or color.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      76,
      90,
      93,
      94
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 569,
    "question": "Your manager has asked you to create two crossover cables to replace two patch cables that were inadvertently installed. Which two connections will the crossover cables be used for? (Choose two.)",
    "choice_a": "Computer to switch",
    "choice_b": "Switch to switch",
    "choice_c": "Computer to router",
    "choice_d": "Computer to hub",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Patch cables are used to connect computers to switches and hubs. If a computer needs to be connected directly to a router, use a crossover cable. Switch-to-switch, hub-to-hub, and hub-to-switch connections need crossover cables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      114,
      108,
      99,
      106
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 570,
    "question": "What technology allows for network devices to be placed in locations where there are no electrical outlets?",
    "choice_a": "Switch",
    "choice_b": "Power over Ethernet",
    "choice_c": "Ethernet over Power",
    "choice_d": "Repeater/extender",
    "correct_answer": "B",
    "explanation": "Power over Ethernet (PoE) allows electrical power to be supplied via network cables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      114,
      108,
      117,
      106
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 571,
    "question": "You need to install a network segment that can run several kilometers without any signal regeneration. Which of the following would you select?",
    "choice_a": "Unshielded twisted pair cabling",
    "choice_b": "Coaxial cabling",
    "choice_c": "Fiber-optic cabling",
    "choice_d": "Shielded twisted pair cabling",
    "correct_answer": "C",
    "explanation": "Fiber-optic cable can span distances of several kilometers, because it has much lower crosstalk and interference in comparison to standard copper cables.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      113,
      111,
      146,
      110,
      148
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 572,
    "question": "A network that is confined to a college campus is defined as what?",
    "choice_a": "MAN",
    "choice_b": "LAN",
    "choice_c": "WAN",
    "choice_d": "PAN",
    "correct_answer": "A",
    "explanation": "A network that spans a college campus or a metropolitan area is known as a metropolitan area network (MAN). A LAN is a small-scale local area network, and a wide area network (WAN) is multiple LANs connected together. A personal area network (PAN) is for a very small-scale network, such as one designed for one person.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      99,
      101,
      100,
      102,
      98
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 573,
    "question": "Which of the following network devices use Layer 2 addresses to make traffic management decisions?",
    "choice_a": "Router",
    "choice_b": "Switch",
    "choice_c": "NIC",
    "choice_d": "Firewall",
    "correct_answer": "B",
    "explanation": "Switches work at Layer 2 of the OSI model and therefore use MAC addresses to make decisions on where to send traffic. Routers work at Layer 3 and use IP addresses. NICs just send and receive traffic regardless of the address. Firewalls monitor network traffic at higher layers of the OSI model.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      106,
      108,
      117,
      125
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 574,
    "question": "You are administering a system that has been locked down for security reasons. You notice that among all of the other ports, port 21 has been disabled. What service is associated with port 21?",
    "choice_a": "Telnet",
    "choice_b": "FTP",
    "choice_c": "HTTP",
    "choice_d": "HTTPS",
    "correct_answer": "B",
    "explanation": "FTP uses ports 20 and 21, Telnet uses port 23, HTTP uses port 80 and HTTPS uses port 443.<br>SMTP uses port 25.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      120,
      121,
      119,
      128,
      117
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 575,
    "question": "You have blocked port 143 on your firewall. Based on this action, which of the following may be true?",
    "choice_a": "Clients on your network will not be able to access web pages.",
    "choice_b": "Clients on your network will not be able to send email.",
    "choice_c": "Clients on your network will not be able to retrieve email unless their email client supports POP3.",
    "choice_d": "Clients on your network will not be able to retrieve email unless their email client supports IMAP4.",
    "correct_answer": "C",
    "explanation": "If you have blocked port 143, IMAP4 clients will not function. So, clients on your network will not be able to retrieve email unless their email client supports POP3 (port 110). Port 80 is used for Internet (HTTP) access. Port 25 is used for SMTP, which is used for sending email.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      155,
      117,
      106
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 576,
    "question": "Which of the following protocols can be used by a client to retrieve email from an email server? (Choose all that apply.)",
    "choice_a": "POP3",
    "choice_b": "SMTP",
    "choice_c": "IMAP4",
    "choice_d": "FTP",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The IMAP4 (port 143) and POP3 (port 110) protocols can be used to retrieve email from mail servers. SMTP (port 25) is used for sending email to an email server. FTP (ports 20 and 21) is used for file transfers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      128,
      106,
      117
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 577,
    "question": "The _______ protocol within TCP/IP is responsible for network addressing.",
    "choice_a": "ARP",
    "choice_b": "UDP",
    "choice_c": "IP",
    "choice_d": "TCP",
    "correct_answer": "C",
    "explanation": "The Internet Protocol (IP) is responsible for network addressing as part of the TCP/IP suite. Address Resolution Protocol (ARP) resolves IP addresses to MAC addresses. UDP and TCP provide connectionless and connection-oriented delivery, respectively.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      118,
      122,
      123,
      117,
      114
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 578,
    "question": "Which of the following is an IPv6 multicast address?",
    "choice_a": "::1/128",
    "choice_b": "2000::/3",
    "choice_c": "ff00::/8",
    "choice_d": "fe80::/10",
    "correct_answer": "C",
    "explanation": "Multicast addresses in IPv6 start with ff00. The ::1 address is the loopback address, global addresses start with 2000, and link-local (APIPA) addresses start with fe80.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      123,
      118,
      121,
      106
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 579,
    "question": "What is the function of ICMP in the TCP/IP protocol suite?",
    "choice_a": "Delivering error messages",
    "choice_b": "Resolving IP addresses to MAC addresses",
    "choice_c": "Resolving IP addresses to hostnames",
    "choice_d": "Sending email",
    "correct_answer": "A",
    "explanation": "The Internet Control Message Protocol (ICMP) is responsible for delivering error messages. It\u2019s used by the <code>ping</code> command. ARP resolves IP addresses to MAC addresses. DNS resolves hostnames to IP addresses. SMTP sends email, and POP3 and IMAP4 receive email.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      118,
      117,
      119,
      120,
      121
    ],
    "source": "330034_Vol1_PT4",
    "choice_e": "Receiving email"
  },
  {
    "id": 580,
    "question": "Your company has decided to host its own web server. With that decision, how many DNS server(s) is the company expected to maintain?",
    "choice_a": "Zero",
    "choice_b": "One",
    "choice_c": "Two",
    "choice_d": "Four",
    "correct_answer": "C",
    "explanation": "When managing DNS for its own website, a company is expected to maintain a minimum of two DNS servers for redundancy.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      121,
      137,
      130,
      102
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 581,
    "question": "Which protocols and associated ports are most commonly used to download email from mail servers?",
    "choice_a": "POP3 (110) and IMAP4 (143)",
    "choice_b": "POP3 (143) and IMAP4 (110)",
    "choice_c": "SMTP (25) and IMAP4 (143)",
    "choice_d": "SMTP (143) and IMAP4 (110)",
    "correct_answer": "A",
    "explanation": "POP3 (110) and IMAP4 (143) are pull protocols that download (receive) mail from mail servers. SMTP (25) is used to upload (send) mail to mail servers, and to transfer mail between servers. It\u2019s a push protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      119,
      117,
      106
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 582,
    "question": "Which of the following security frameworks tells an email server how to handle an email that has been marked as potential spam?",
    "choice_a": "SCADA",
    "choice_b": "DKIM",
    "choice_c": "SPF",
    "choice_d": "DMARC",
    "correct_answer": "D",
    "explanation": "Domain-Based Message Authentication, Reporting, and Conformance (DMARC) is a decision framework that tells an inbound email server what to do with email marked as spam. SCADA refers to legacy hardware and software systems.<br>DomainKeys Identified Mail (DKIM) validates with a public-private key pair. Sender Policy Framework (SPF) validates email servers by verifying their IP addresses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      120,
      136,
      135,
      155
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 583,
    "question": "Which of the following types of servers would be responsible for managing MFA on your network?",
    "choice_a": "Mail server",
    "choice_b": "Syslog",
    "choice_c": "AAA server",
    "choice_d": "UTM",
    "correct_answer": "C",
    "explanation": "An authentication, authorization, and accounting (AAA) server is a security device that would be responsible for managing multifactor authentication (MFA). Mail servers send and receive email. Syslog records error messages from devices. Unified threat management (UTM) will help thwart hackers and malicious data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      132,
      153,
      127,
      129
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 584,
    "question": "Which of the following DNS record types is used for the second name assigned to a host within a zone file?",
    "choice_a": "A",
    "choice_b": "AA",
    "choice_c": "AAAA",
    "choice_d": "CNAME",
    "correct_answer": "D",
    "explanation": "A canonical name (CNAME) record allows for multiple names to be assigned to the same host or address within a zone file. An A record is for IPv4 hosts, and an AAAA record is for IPv6 hosts. There is no AA record in DNS.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      129,
      121,
      128,
      106,
      119
    ],
    "source": "330034_Vol1_PT4",
    "choice_e": "TXT"
  },
  {
    "id": 585,
    "question": "Which service is designed to allow wireless-aware client computers and devices to automatically join a wireless network and discover other devices?",
    "choice_a": "MAC filtering",
    "choice_b": "AES",
    "choice_c": "CCMP",
    "choice_d": "UPnP",
    "correct_answer": "D",
    "explanation": "Universal Plug and Play (UPnP) is designed to allow wireless-aware devices automatically connect to a network, declare themselves to other devices, and discover other devices on the network. MAC filtering controls access based on hardware (MAC) addresses. AES and CCMP are encryption standards.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      152,
      141,
      143,
      107
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 586,
    "question": "In the 2.4 GHz spectrum, how many nonoverlapping communications channels are there?",
    "choice_a": "1",
    "choice_b": "3",
    "choice_c": "6",
    "choice_d": "11",
    "correct_answer": "B",
    "explanation": "In the 2.4 GHz spectrum, there are three nonoverlapping channels. They are 1, 6, and 11.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      154,
      138,
      141,
      140
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 587,
    "question": "Which wireless networking frequencies have 40 or more 20 MHz channels available for data transmission? (Choose all that apply.)",
    "choice_a": "2.4 GHz",
    "choice_b": "4.2 GHz",
    "choice_c": "5 GHz",
    "choice_d": "6 GHz",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "5 GHz has 40-45 20 MHz channels, and 6 GHz has 59 channels. 2.4 GHz has only 14. The 4.2 GHz band is not used for wireless networking.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      138,
      141,
      142,
      143,
      144
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 588,
    "question": "Which Internet connection types require line of sight? (Choose two.)",
    "choice_a": "Cellular",
    "choice_b": "DSL",
    "choice_c": "WISP",
    "choice_d": "Satellite",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "WISP and satellite require line of sight. Cellular does not. DSL is a wired Internet connection type.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      143,
      151,
      147,
      148
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 589,
    "question": "What is the maximum indoor range of 802.11ax?",
    "choice_a": "10m",
    "choice_b": "30m",
    "choice_c": "60m",
    "choice_d": "120m",
    "correct_answer": "B",
    "explanation": "802.11ax has a maximum indoor range of about 30 meters, and a maximum outdoor range of about 120 meters.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      142,
      141,
      99,
      106
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 590,
    "question": "Which Wi-Fi standard was the first that was able to change the color of a frequency it was operating on to avoid communication interference?",
    "choice_a": "Wi-Fi 4",
    "choice_b": "Wi-Fi 5",
    "choice_c": "Wi-Fi 6",
    "choice_d": "Wi-Fi 7",
    "correct_answer": "C",
    "explanation": "Wi-Fi 6 (802.11ax) introduced BSS coloring. It allowed a WAP to change the color of the channels it communicated on to avoid interference with other wireless networks.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      143,
      141,
      140,
      142,
      154
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 591,
    "question": "Which of the following should be done immediately before entering the code to pair a mobile device to another device?",
    "choice_a": "Find the other device for pairing.",
    "choice_b": "Power-cycle the mobile device.",
    "choice_c": "Enter the code on the other device.",
    "choice_d": "Turn off Wi-Fi on the mobile device.",
    "correct_answer": "A",
    "explanation": "The code needs to be entered on the mobile device, not the other device, <i>after</i> allowing the mobile device to find the other device. Leaving Wi-Fi on and not power cycling should be fine.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      159,
      162,
      157,
      160,
      167
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 592,
    "question": "You are configuring a mobile device to use POP3. Which of the following statements about POP3 is true?",
    "choice_a": "POP3 over TLS uses TCP port 995, and POP3 over SSL uses TCP port 993.",
    "choice_b": "POP3 uses TCP port 587.",
    "choice_c": "POP3 uses TCP port 110.",
    "choice_d": "POP3 uses TCP port 465.",
    "correct_answer": "C",
    "explanation": "POP3 uses TCP port 110, and secure POP3 uses port 995 with SSL/TLS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      170,
      164,
      162,
      157,
      159
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 593,
    "question": "You are configuring a mobile device to use secure versions of common email protocols. Specifically, the mobile device will use IMAP4 and SMTP over SSL. Which of the following statements is true?",
    "choice_a": "The device will use ports 465 and 993.",
    "choice_b": "The device will use ports 587 and 993.",
    "choice_c": "The device will use ports 465 and 995.",
    "choice_d": "The device will use ports 587 and 995.",
    "correct_answer": "A",
    "explanation": "Secure SMTP with SSL uses port 465, and IMAP4 over SSL/TLS uses port 993. SMTP over TLS uses port 587 and POP3 over SSL/TLS uses port 995.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      170,
      164,
      162,
      157,
      159
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 594,
    "question": "Why might you connect a mobile device to a Wi-Fi network? (Choose two.)",
    "choice_a": "An ad hoc connection between the device and a computer is the only way the two can connect.",
    "choice_b": "The device has no Bluetooth capability.",
    "choice_c": "Wi-Fi is always faster than USB.",
    "choice_d": "To save money.",
    "correct_answer": [
      "D",
      "E"
    ],
    "explanation": "Connecting to a Wi-Fi network saves the cost of sending data over the cellular network. Some devices, such as iPhones, can synchronize to a computer when they are plugged into power and on the same Wi-Fi network as the computer. The devices can probably connect using USB, which is usually faster than Wi-Fi, or Bluetooth, which is not as fast as Wi-Fi.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      162,
      171,
      172,
      157,
      163
    ],
    "source": "330034_Vol1_PT4",
    "choice_e": "To synchronize it."
  },
  {
    "id": 595,
    "question": "Which of the following provides runtime environments for software developers? (Choose two.)",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "FaaS",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Platform as a service (PaaS) and software as a service (SaaS) are the two levels that provide runtime environments for software developers. Infrastructure as a service (IaaS) does not. There is no FaaS in the A+ exam objectives.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      182,
      180,
      183,
      186,
      185
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 596,
    "question": "What is the name of the combined hardware and software needed to create a virtual environment?",
    "choice_a": "Container",
    "choice_b": "Type 1 hypervisor",
    "choice_c": "Type 2 hypervisor",
    "choice_d": "VDI",
    "correct_answer": "D",
    "explanation": "The virtual desktop infrastructure (VDI) is the hardware and software needed to create a virtual environment. Hypervisors are the software packages that create and manage virtual environments. Containers are used for software virtualization.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      176,
      178,
      174,
      177,
      179
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 597,
    "question": "Which of the following is a limitation of using containers?",
    "choice_a": "They don\u2019t virtualize hardware.",
    "choice_b": "They are large and slow to deploy.",
    "choice_c": "They don\u2019t contain an app\u2019s depenencies.",
    "choice_d": "They are limited to the client OS on which they were created.",
    "correct_answer": "A",
    "explanation": "Containers virtualize an application and its needed OS files (called dependencies) to run properly. They are small and quickly deployed, and can run on multiple OSs.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      177,
      174,
      175,
      178,
      179
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 598,
    "question": "A network administrator wants to set up a private cloud on a corporate network. Which of the following is an advantage to setting up a private cloud?",
    "choice_a": "Lower cost of hardware",
    "choice_b": "Best scalability among cloud types",
    "choice_c": "Internally managed security",
    "choice_d": "Best file synchronization ability among cloud types",
    "correct_answer": "C",
    "explanation": "The biggest benefit of running a private cloud is that all security is managed internally, and not trusted to another company. It will cost more than a public cloud because of hardware investments, and it\u2019s not as scalable as public clouds are. All cloud types inherently have similar file synchronization abilities.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      181,
      180,
      179,
      183,
      182
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 599,
    "question": "Your company\u2019s accounting department uses software that is over 20 years old and is no longer supported by the vendor. You need to continue to run it on the network, however. Which purpose of virtual machines does this situation fall into?",
    "choice_a": "Sandbox",
    "choice_b": "Legacy software",
    "choice_c": "Cross-platform virtualization",
    "choice_d": "Test development",
    "correct_answer": "B",
    "explanation": "Old apps are called legacy apps or legacy software. Virtual machines can be used to emulate an older OS that the software might need in order to run properly, or a VM can be used to isolate the legacy software from other apps on the network. Sandbox and test development are both testing platforms for new software or OS changes. Cross-platform virtualization involves multiple operating systems.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      175,
      174,
      179,
      178,
      176
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 600,
    "question": "A laptop user is having difficulty connecting to local network resources. Which elements are required to communicate on a TCP/IPv4 network? (Choose all that apply.)",
    "choice_a": "IP address",
    "choice_b": "Subnet mask",
    "choice_c": "Default gateway",
    "choice_d": "DNS server",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "To communicate on a TCP/IPv4 network, you are required to have a unique IP address and a valid subnet mask. A default gateway and a DNS server are optional.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      121,
      130,
      118,
      117
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 601,
    "question": "You are troubleshooting a desktop computer that is experiencing intermittent system lockups. Which of the following would be a good next step to resolve the issue?",
    "choice_a": "Replace the motherboard, CPU, and RAM to see if it resolves the issue.",
    "choice_b": "Replace the motherboard and RAM to see if it resolves the issue.",
    "choice_c": "Replace the motherboard and CPU to see if it resolves the issue.",
    "choice_d": "Replace the RAM to see if it resolves the issue.",
    "correct_answer": "D",
    "explanation": "System lockups can be caused by any number of failing components. RAM, the CPU, and the motherboard could all be culprits. When troubleshooting, it\u2019s best to make one change at a time to attempt to resolve the issue. In this case, just replace one component at a time to see if it resolves the problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      190,
      188,
      199,
      194,
      189
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 602,
    "question": "Every time you turn a desktop computer on, it makes a grinding noise. Which of the following components is most likely causing the problem?",
    "choice_a": "SSD",
    "choice_b": "CPU",
    "choice_c": "PSU",
    "choice_d": "RAM",
    "correct_answer": "C",
    "explanation": "A grinding noise can only be made by a component that has moving parts. SSDs, CPUs, and RAM do not have any moving parts, so the only possible answer is the power supply unit (PSU).",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      193,
      203,
      190,
      188,
      194
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 603,
    "question": "After physical installation of a new hard drive, you notice the drive is not recognized at any point during boot nor in the operating system. What should you do first to get the drive recognized by the computer?",
    "choice_a": "Format the drive.",
    "choice_b": "Run the BIOS/UEFI configuration utility.",
    "choice_c": "Partition the drive.",
    "choice_d": "Run Disk Management.",
    "correct_answer": "B",
    "explanation": "A drive that is not recognized at all indicates that the BIOS/UEFI is not aware of its existence. Very often editing the configuration settings in the BIOS/UEFI is necessary to get a new hard drive recognized by the system. This does not mean changing the boot order, but instead changing the drive\u2019s position in the BIOS/UEFI from Disabled to Auto or Enabled. Partitioning and formatting is not possible until the physical drive\u2019s existence is recognized. Disk Management will not show the drive until the BIOS/UEFI recognizes it.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      195,
      204,
      205,
      188,
      196
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 604,
    "question": "While monitoring network traffic, you notice that the delay between your workstation and the server is higher than normal. It will spike and then come back down only to spike again a few seconds later. What is this an example of?",
    "choice_a": "Jitter",
    "choice_b": "Limited connectivity",
    "choice_c": "Port flapping",
    "choice_d": "High latency",
    "correct_answer": "A",
    "explanation": "Latency is the measure of delay. While this computer is experiencing some high latency, the bouncing back and forth between low and high latency is called jitter. It may cause limited connectivity. Port flapping is when a port on a router repeatedly opens and closes.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      214,
      212,
      216,
      210,
      213
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 605,
    "question": "A technician needs to put the connector onto a Cat 8 cable. Which tool should they use?",
    "choice_a": "Crimper",
    "choice_b": "Cable stripper",
    "choice_c": "Punchdown tool",
    "choice_d": "Network tap",
    "correct_answer": "A",
    "explanation": "A crimper is used to put connectors onto the ends of cables. A cable stripper can cut and strip cables but not fasten connectors. A punchdown tool is used to connect wires to a frame such as a 110-block. A network tap monitors network traffic without interfering with it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      116,
      111,
      110,
      113
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 606,
    "question": "You have a laptop that doesn\u2019t have any video. Its power lights are on. You plug in a known working external monitor and toggle the LCD cutoff switch, and there is no video on the external monitor either. What most likely needs to happen?",
    "choice_a": "You need to reinstall the video driver.",
    "choice_b": "You need to replace the LCD screen.",
    "choice_c": "You need to try a second external monitor.",
    "choice_d": "You need to service the laptop\u2019s video card.",
    "correct_answer": "D",
    "explanation": "If you\u2019re not getting video on the external monitor or the LCD screen, it\u2019s likely a problem with the video card. You can\u2019t reinstall the video driver because you can\u2019t see. Replacing the screen or trying another monitor won\u2019t likely help. It looks like the video card needs to be replaced, and in most cases this will mean replacing the entire motherboard.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      202,
      218,
      196,
      190,
      188
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 607,
    "question": "You are troubleshooting an inkjet printer. The printer has poor print quality. Some images are missing a color and others appear smeared. Which device in an inkjet printer contains the printhead?",
    "choice_a": "Ink cartridge",
    "choice_b": "Toner cartridge",
    "choice_c": "Daisy wheel",
    "choice_d": "Paper tray",
    "correct_answer": "A",
    "explanation": "In an inkjet printer, the ink cartridge is the actual printhead. This is where the ink is expelled to form letters or graphics. Toner cartridges are used by laser printers to store toner. A daisy wheel is used in impact printers, not inkjet ones. Paper trays are the storage bins in laser printers and bubble-jet printers that allow the pickup rollers to feed the paper into the printer.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      235,
      236,
      234,
      238,
      239
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 608,
    "question": "What is the result of an absent or broken static-eliminator strip in an HP LaserJet printer?",
    "choice_a": "Nothing. Both printers will continue to function normally.",
    "choice_b": "Nothing will happen in EP process printers, but HP LaserJet printers will flash a <code>\u2013671 error</code> message.",
    "choice_c": "Nothing will happen in HP LaserJet printers, but EP process printers will flash a <code>\u2013671 error</code> message.",
    "choice_d": "Paper jams may occur in both types of printers because the paper may curl around the photosensitive drum.",
    "correct_answer": "D",
    "explanation": "If the static-eliminator strip is absent (or broken) in either an EP process or HP LaserJet printer, the paper will maintain its positive charge. Should this occur, paper jams may result due to the paper curling around the photosensitive drum.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      238,
      239,
      240,
      236,
      190
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 609,
    "question": "You need to open the case of a mobile device to replace a battery. Which of the following is not part of the disassembling process for proper reassembly?",
    "choice_a": "Use appropriate hand tools.",
    "choice_b": "Document and label cable and screw locations.",
    "choice_c": "Leave the device plugged into its charger.",
    "choice_d": "Refer to manufacturer resources.",
    "correct_answer": "C",
    "explanation": "Leaving the device plugged in is not part of the disassembly process for proper reassembly. The four parts are document and label cable and screw locations, organize parts, refer to manufacturer resources, and use appropriate hand tools.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      230,
      225,
      197,
      188,
      190
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 610,
    "question": "A user calls to report that the icons and images on their screen are very large, and only a few fit on the screen. What should you have them do to resolve this issue?",
    "choice_a": "Change the screen resolution.",
    "choice_b": "Reinstall the video driver.",
    "choice_c": "Try a different monitor.",
    "choice_d": "Reboot the computer.",
    "correct_answer": "A",
    "explanation": "Oversized images and icons are most likely caused by the video resolution being set too low. Change it and it should fix the problem. Rebooting most likely will not help, nor will trying a different monitor or reinstalling the video driver.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      220,
      224,
      190,
      188,
      191
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 611,
    "question": "A user\u2019s mobile device is always becoming hot to the touch. After they turn it off, let it cool down, and power it back on, it will be hot within two minutes. What is the best solution to this problem?",
    "choice_a": "Reset the device to factory settings.",
    "choice_b": "Let the battery completely drain, and then recharge it.",
    "choice_c": "Replace the battery.",
    "choice_d": "Use the battery calibration utility.",
    "correct_answer": "C",
    "explanation": "If the device is persistently overheating, the best solution is to replace the battery. Resetting to factory settings, letting the battery completely drain, or calibrating the battery will not help an overheating battery.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      226,
      225,
      233,
      194,
      188
    ],
    "source": "330034_Vol1_PT4"
  },
  {
    "id": 612,
    "question": "You have been asked to purchase a new camera for the company photographer. Some of the cameras are marketed as \u201csmart\u201d cameras. What key feature does this likely mean the camera includes?",
    "choice_a": "Wi-Fi",
    "choice_b": "RJ-45",
    "choice_c": "Separate video processor",
    "choice_d": "Internal hard drive",
    "correct_answer": "A",
    "explanation": "Smart cameras are those that have special features such as built-in wireless network connectivity for easy picture and video transfers, high-definition video recording, motion detection, and real-time alerts. Many will include Wi-Fi, Bluetooth, and Near-Field Communication (NFC) connection types. Smart cameras, such as security cameras, can also connect via Wi-Fi to your network and the Internet, and can thus be accessed and controlled by a cellphone.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      162,
      157,
      159,
      164,
      173
    ],
    "source": "9781394330348"
  },
  {
    "id": 613,
    "question": "Your client is a manager at a construction site. They often walk around with a tablet computer, making notes with their finger on the screen as they see issues that need to be addressed. They have been having some trouble getting the computer to recognize what they are writing because their fingers are large and often dirty from working. What is the most cost-effective solution you can suggest that they purchase to make the job easier?",
    "choice_a": "Stylus",
    "choice_b": "Trackpad",
    "choice_c": "Digitizer",
    "choice_d": "Special gloves",
    "correct_answer": "A",
    "explanation": "A stylus often looks like a small pencil and is used for input on a digitizer or touchscreen. Compatibility is important, as not all styluses will work with all screens. Trackpads, although they can be purchased as an add-on, are generally built into laptop keyboards and wouldn\u2019t help in this situation. A digitizer is a screen designed to accept drawing from a hand or stylus, and special gloves may help, but again, they don\u2019t solve the problem of large hands and only work on certain types of screens.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      66,
      65,
      64,
      71
    ],
    "source": "9781394330348"
  },
  {
    "id": 614,
    "question": "Your friend works for a popular rideshare service. Their phone interacts with the service and the passenger so that both know how far away the driver is. What technology needs to be enabled on a cellphone to track where they are?",
    "choice_a": "GPS",
    "choice_b": "MDM",
    "choice_c": "Location Services",
    "choice_d": "MAM",
    "correct_answer": "C",
    "explanation": "Rideshare services often require that cellular Location Services be enabled on the driver and passenger phones so they can locate each other, and to provide the driver with directions to the pick-up and drop-off locations. Location services on a cellphone might use cell towers, Global Positioning System (GPS), Bluetooth, or Wi-Fi to find the phone\u2019s exact location. This is a common way for devices to provide turn-by-turn directions. Mobile Device Management (MDM) and Mobile Application Management (MAM) are methods of managing data security in a corporate environment.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      167,
      166,
      165,
      157,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 615,
    "question": "Your company is concerned about how laptops and other remote devices can be secured when they are used by employees at home or on the road. Which of the following can be used to enforce policies and remove corporate applications remotely? (Choose two.)",
    "choice_a": "GSM",
    "choice_b": "CDMA",
    "choice_c": "MAM",
    "choice_d": "MDM",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Mobile Application Management (MAM) protects corporate data while being used on employee\u2019s personal devices. For example, it can force employees to save all work files in the company\u2019s OneDrive cloud storage, encrypt files and delete them after a period of time, and restrict employees from downloading company content. It can even delete company files when a device has become inactive. Mobile Device Management (MDM) systems can be used to remotely wipe data from a device and restore it to factory settings. Global System for Mobile Communications (GSM) and Code-Division Multiple Access (CDMA) are cellular technology communication systems.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      168,
      169,
      158,
      157,
      172
    ],
    "source": "9781394330348"
  },
  {
    "id": 616,
    "question": "You\u2019re at a friend\u2019s house and want to use their Wi-Fi with your iPhone. You go into Settings, then Wi-Fi, but don\u2019t see their network in your available list. Which of the following will you ask them to do? (Choose two.)",
    "choice_a": "Provide their security type and password.",
    "choice_b": "Add your IP address to their network.",
    "choice_c": "Provide the name of their network.",
    "choice_d": "Add your MAC address to their router.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "If the name of their network doesn\u2019t pop up for you, click on Other Network and type in the network name they give you. You\u2019ll also need to know if it uses WPA2, WPA3, or another wireless encryption protocol, and the password that will allow you on to their network. Your device will be given an IP address by their network, and while it\u2019s possible that they have their router locked down by a Media Access Control (MAC) number, most people don\u2019t have that level of security established on their home network\u2019s router.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      162,
      157,
      159,
      170,
      172
    ],
    "source": "9781394330348"
  },
  {
    "id": 617,
    "question": "Your friend\u2019s iPhone 13 will no longer charge. They have tried replacing the charging block and cable with compatible ones, cleaning the charging port, and testing the wall outlet. What should be done next?",
    "choice_a": "Purchase a new phone.",
    "choice_b": "Purchase a new battery.",
    "choice_c": "Take the phone to a repair shop.",
    "choice_d": "Use a wireless charging pad.",
    "correct_answer": "C",
    "explanation": "While it\u2019s possible that the phone could be charged with a charging pad, most often phones won\u2019t charge because the battery is worn out and needs replacing. Also, according to the Apple Support website, if a phone won\u2019t charge after checking the simple things, it likely needs servicing. Your friend should take their phone to a service center. They might be able replace the battery or fix problems they find with the phone\u2019s connector.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      64,
      72,
      157,
      169,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 618,
    "question": "Your customer brought you a laptop with an internal battery that will no longer charge. You have told them that replacing the battery will be no problem at all. Which of the following will you need to do first?",
    "choice_a": "Remove the back cover.",
    "choice_b": "Remove the keyboard.",
    "choice_c": "Disconnect the external power.",
    "choice_d": "Disconnect the LCD panel.",
    "correct_answer": "C",
    "explanation": "You should always disconnect the external power before working on any computer system. Legacy laptops may have a battery that is removable and replaceable, by sliding a connector or removing a few screws from the back of the case, but you might not be able to find a compatible replacement. Modern laptops have internal batteries. Before removing the back (bottom) cover of the laptop to gain access to the battery, you must disconnect the power to avoid getting shocked or damaging the laptop. You\u2019ll also want to be certain that you can purchase a compatible battery both in features and size/shape. Most do not require you to remove the keyboard or Liquid Crystal Display (LCD) panel to reach the battery, but again before doing either of those, research the laptop and disconnect the power.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      71,
      65,
      64,
      66,
      68
    ],
    "source": "9781394330348"
  },
  {
    "id": 619,
    "question": "A coworker is having a problem with their laptop and has asked you to fix it. When an external keyboard is plugged in, the laptop works just fine, but without it, strange characters appear on the screen when typing. Which of the following are likely causes? (Choose two.)",
    "choice_a": "The driver is corrupted and needs to be updated/replaced.",
    "choice_b": "The ribbon cable connecting the keyboard to the motherboard is partially disconnected and needs to be reseated.",
    "choice_c": "The operating system needs to be reinstalled.",
    "choice_d": "There is debris under the keys.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Corrupted drivers and loose cables can cause all sorts of interesting output. Strange characters on the screen don\u2019t necessarily mean that the laptop needs to be replaced, and users should be discouraged from eating cookies or toast (or anything) over their laptops. Fine crumbs or other debris can cause keys to stick, but that likely wouldn\u2019t cause the type of problem that this user is experiencing. Oftentimes, a laptop keyboard can be replaced fairly easily, assuming a compatible one can be found. But in this case, the problem is most likely caused by a loose ribbon cable connecting the keyboard to the motherboard, or a corrupted driver.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      70,
      64,
      65,
      67,
      66
    ],
    "source": "9781394330348"
  },
  {
    "id": 620,
    "question": "You\u2019re working as the IT support person at an accounting firm. One of the accountants dropped their laptop, and the number 5 key is broke-off. This is a critical problem for an accountant. What is the most cost-effective way to get them up and running again?",
    "choice_a": "Replace the laptop with a new one.",
    "choice_b": "Replace the entire laptop keyboard.",
    "choice_c": "Replace the missing key.",
    "choice_d": "Give them a desktop computer to use.",
    "correct_answer": "C",
    "explanation": "Individual keys can be replaced on a laptop. If your company uses many of the same model of laptop, keeping one or two nonfunctioning ones in stock for parts is helpful. If a key is not readily available, they can be purchased from third-party vendors for much less than an entire keyboard. When ordering, ensure that it has the right type of clips, hinges, and possibly cup for the model being replaced. In the short term and as a quick fix, an inexpensive Universal Serial Bus (USB)-connected keypad might suffice.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      70,
      65,
      64,
      71,
      68
    ],
    "source": "9781394330348"
  },
  {
    "id": 621,
    "question": "Your client is frustrated that their Bluetooth earpiece, which was working yesterday, is no longer working, and they\u2019ve asked for your help. What is the most likely source of the problem?",
    "choice_a": "The earpiece has paired to a different device.",
    "choice_b": "The earpiece is broken.",
    "choice_c": "The Wi-Fi signal is weak.",
    "choice_d": "Bluetooth connectivity was lost.",
    "correct_answer": "D",
    "explanation": "It\u2019s most likely that Bluetooth connectivity was lost between the earpiece and the once-paired device, probably a phone. Examine the phone and troubleshoot connectivity between the phone and the earpiece. Paring the earpiece to a different device would have required action on the part of the client, and a weak Wi-Fi signal wouldn\u2019t affect Bluetooth. It is possible that the earpiece is broken, but far more likely that they simply lost connectivity.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      159,
      162,
      157,
      166,
      167
    ],
    "source": "9781394330348"
  },
  {
    "id": 622,
    "question": "Your boss has asked you to maximize the RAM in their laptop computer. You check the specifications and discover that the maximum system RAM is 32 GB of DDR5 RAM. The laptop currently has 16 GB of onboard RAM and one empty slot. Which of the following RAM modules should you purchase?",
    "choice_a": "One 16 GB SODIMM",
    "choice_b": "One 32 GB SODIMM",
    "choice_c": "One 16 GB DIMM",
    "choice_d": "One 32 GB DIMM",
    "correct_answer": "A",
    "explanation": "You should always check the device\u2019s documentationbeforepurchasing components to ensure compatibility. In a laptop, Random Access Memory (RAM) is often soldered directly onto the motherboard (onboard) and isn\u2019t meant to be replaced by most users. Because the maximum system RAM is 32 GB, you would need one 16 GB RAM module to bring it up to that total. Small Outline Dual Inline Memory Modules (SODIMMs) are the type of RAM module used in devices like laptops and sometimes printers. Dual Inline Memory Modules (DIMMs) are used in desktop computers.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      68,
      64,
      65,
      67,
      71
    ],
    "source": "9781394330348"
  },
  {
    "id": 623,
    "question": "A friend is trying to install an update on their iPad, but they\u2019re receiving a message about insufficient space. They want to know if you can upgrade their storage. What will you tell them?",
    "choice_a": "Sure, bring it over later today.",
    "choice_b": "Storage can\u2019t be upgraded. You\u2019ll need to buy a new iPad.",
    "choice_c": "Storage can\u2019t be upgraded, but you might be able to offload some apps that you no longer use.",
    "choice_d": "Just purchase more space on iCloud; it\u2019s the same thing.",
    "correct_answer": "C",
    "explanation": "The short answer is that no, storage on an iPhone, iPad, iPod, or almost any small device usually can\u2019t be upgraded. When you buy one of these devices, it\u2019s best to buy a device with as much storage as you can afford. Attaching the device to your PC and doing the upgrade there may work. If not, you may not have to buy a new iPad, but before you do, check to see if you have some data that you no longer need like messages from years ago, or if you have some apps that you no longer use and can delete to free up some space You should be able todownload them again later onto a new device. iCloud is storage in the cloud, and not the same as storage on your device; however, you could store photos in iCloud Photos or use Messages in iCloud to save space on the device.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      171,
      173,
      172,
      163,
      159
    ],
    "source": "9781394330348"
  },
  {
    "id": 624,
    "question": "You need to replace a failed Serial Advanced Technology Attachment (SATA) hard drive on a 10-year-old laptop. The user has asked that the new drive be as fast as possible, regardless of disk space or cost. What type of drive should you install?",
    "choice_a": "SSD",
    "choice_b": "Magnetic",
    "choice_c": "Hybrid",
    "choice_d": "HDD",
    "correct_answer": "A",
    "explanation": "A Solid-State Drive (SSD) uses the same memory technology found in other forms of flash memory. They are much faster than traditional magnetic drives or hybrid drives but generally don\u2019t have as much capacity for the same price. An Nonvolatile Memory express (NVMe) drive is newer solid-state technology and would have to be supported by the laptop. It also uses a different connector. Note: Some people mistakenly call a storage drive a \u201chard drive,\u201d regardless of whether it\u2019s an SSD, NVMe, or legacy magnetic hard disk drive (HDD).",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      69,
      71,
      64,
      72,
      65
    ],
    "source": "9781394330348"
  },
  {
    "id": 625,
    "question": "You need to replace a failed hard drive in a user\u2019s laptop, and it\u2019s a model with which you are unfamiliar. You look at the bottom of the laptop and see no obvious entrance points. Which component will you most likely need to remove to access the hard drive bay?",
    "choice_a": "Wi-Fi card",
    "choice_b": "Battery",
    "choice_c": "System board",
    "choice_d": "Keyboard",
    "correct_answer": "D",
    "explanation": "As a rule of thumb, either you can access components from the bottom of a laptop, such as the memory and Wi-Fi card, or you\u2019re going to need to remove the keyboard to access the components from the top.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      72,
      69,
      70,
      65,
      64
    ],
    "source": "9781394330348"
  },
  {
    "id": 626,
    "question": "Which mobile connection type enables you to share your cellular Internet connection with a Wi-Fi-enabled device?",
    "choice_a": "Hotspot",
    "choice_b": "NFC",
    "choice_c": "Bluetooth",
    "choice_d": "RFID",
    "correct_answer": "A",
    "explanation": "If you have a cellular-enabled device such as a smartphone, you might be able to turn that phone into a mobile hotspot. By doing so, you can share your cellular Internet connection with Wi-Fi\u2013enabled devices, such as laptops and tablets. Near-Field Communication (NFC) devices can communicate and send data and files, but only if they are within inches of each other. Bluetooth is a common wireless technology for connecting devices, such as keyboards and headsets to a computer, and Radio Frequency Identification (RFID) is a technology that enables information from a wireless tag to be accessed by a reader. Retail theft prevention systems often use RFID, and they may be used in industry for tracking assets and inventory.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      157,
      158,
      159,
      162,
      163
    ],
    "source": "9781394330348"
  },
  {
    "id": 627,
    "question": "Which cellular communication technology is known as LTE?",
    "choice_a": "Wi-Fi 6",
    "choice_b": "3G",
    "choice_c": "4G",
    "choice_d": "5G",
    "correct_answer": "C",
    "explanation": "The fourth generation of cellular services (4G) is also known as Long-Term Evolution (LTE). Introduced in the 2000s, it boasted downstream rates as fast as 53.3 Mbps. Prior to that, 2G came out in 1991 and added text-based short messaging services (SMS). Released in 2001, 3G transmits up to 7.2 Mbps. Still being implemented, 5G employs the use of different software and radio transmitters, is backward compatible, and is estimated to be able to reach transmission rates of 20 Gbps.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      158,
      157,
      163,
      159,
      166
    ],
    "source": "9781394330348"
  },
  {
    "id": 628,
    "question": "Your friend wants to be able to use their phone to pay for purchases at a popular coffee shop. They noticed that the phone needs to be about 4 inches from the coffee shop\u2019s reader. What radio-wave communication type do you need to configure for your friend?",
    "choice_a": "NFC",
    "choice_b": "Wi-Fi",
    "choice_c": "Hotspot",
    "choice_d": "Bluetooth",
    "correct_answer": "A",
    "explanation": "Near-Field Communication (NFC) is a wireless technology that uses Radio Frequency (RF) signals with limited range, about 4 inches (10 cm). NFC readers are the active components used in NFC transactions. They have the ability to read (and some can write) tags and communicate directly with other devices. NFC technology is most often used in smartphones for payment services; however, some smartphones (Androids and iPhone 7 or newer) can also write to NFC tags. Bluetooth and Wi-Fi have greater ranges, and a hotspot enables a user to allow another device to use the Internet by accessing the hotspot\u2019s connection.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      157,
      162,
      159,
      158,
      164
    ],
    "source": "9781394330348"
  },
  {
    "id": 629,
    "question": "You\u2019re working from a home office and need to be able to type on your keyboard while talking with clients, so you purchase a wireless headset. What wireless technology will you need to enable on your laptop, to ensure that the headset and laptop can communicate with each other?",
    "choice_a": "Wi-Fi",
    "choice_b": "Hotspot",
    "choice_c": "Bluetooth",
    "choice_d": "NFC",
    "correct_answer": "C",
    "explanation": "Headsets are used for hands-free phone conversations and listening to music. Headsets can either plug into the speaker/headphone jack or be wireless. Most wireless headsets are Bluetooth. Wi-Fi is for connecting to Wireless Local Area Networks (WLANs). A hotspot enables a user to allow another device to use the Internet by accessing the hotspot device\u2019s Internet connection. Near-Field Communication (NFC) only works over truly short distances; about 4 inches (10 cm).",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      159,
      162,
      157,
      70,
      71
    ],
    "source": "9781394330348"
  },
  {
    "id": 630,
    "question": "You are wearing your smartwatch, which enables you to make payments as you would when using a credit or debit card. What type of connection technology does this service use?",
    "choice_a": "Bluetooth",
    "choice_b": "NFC",
    "choice_c": "Wi-Fi",
    "choice_d": "Hotspot",
    "correct_answer": "B",
    "explanation": "Near-Field Communication (NFC) is a wireless technology that uses Radio Frequency (RF) signals with limited range, about 4 inches (10 cm). NFC can operate in card emulationmode, which lets the device act as a smartcard. This is useful for making payments at the site of a merchant who uses NFC. Bluetooth is a popular protocol for Personal Area Networks (PANs), such as a laptop and headset or speakers. Wi-Fi is used for Wireless Local Area Networks (WLANs). Hotspots enable users to allow another device to use their Internet by accessing the hotspot device\u2019s Internet connection.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      159,
      162,
      157,
      166,
      164
    ],
    "source": "9781394330348"
  },
  {
    "id": 631,
    "question": "You\u2019re upgrading the Wi-Fi card in a manager\u2019s laptop and notice that the antenna cable is frayed, so you need to replace it. What will you likely need to do to replace the antenna?",
    "choice_a": "Wrap the antenna with electrical tape.",
    "choice_b": "Open the display to replace the cable.",
    "choice_c": "Attach a dongle for the new cable.",
    "choice_d": "Just install the new card, because the antenna is part of the card.",
    "correct_answer": "B",
    "explanation": "Often in laptops, the antenna is housed in the laptop\u2019s display area. You would most likely need to separate the display from the laptop\u2019s motherboard section to open the display and replace the antenna cable. It will also likely have two different parts, a right and a left antenna, so make sure you choose the correct one.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      66,
      65,
      64,
      71,
      67
    ],
    "source": "9781394330348"
  },
  {
    "id": 632,
    "question": "Your boss has asked you to make sure that each of the company\u2019s laptops has a biometric scanner as an extra measure of security. Which of the following are biometric device technologies that are commonly found and can be configured on laptops? (Choose two.)",
    "choice_a": "ID card scanner",
    "choice_b": "Face ID",
    "choice_c": "Fingerprint reader",
    "choice_d": "Retina scanner",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Biometrics use parts of your body to identify you. An ID card is not biometric. Retina scanners are used in some secure environments but are not commonly found on laptops, yet facial recognition like Apple\u2019s Face ID and Windows Hello are on most modern laptops. Fingerprint readers can be found on many laptops or can be easily added.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      66,
      64,
      71,
      68
    ],
    "source": "9781394330348"
  },
  {
    "id": 633,
    "question": "Your company is producing posters for an upcoming public relations campaign. The project leader wants to embed information into an NFC Type 4 tag in the poster. How much information can this tag hold?",
    "choice_a": "16 KB",
    "choice_b": "32 KB",
    "choice_c": "1.4 MB",
    "choice_d": "2.4 MB",
    "correct_answer": "B",
    "explanation": "Near-Field Communication (NFC) is a wireless technology that uses Radio Frequency (RF) signals with limited range, about 4 inches (10 cm). To read an NFC tag in a poster, you must move your phone close to the tag. The phone generates a small RF field that powers the tag, and data can then be read from the tag. There are five types of tags that vary in speed, from 106 kbps to 2424 kbps, and in maximum capacities, from 2 KB to 32 KB. Type 4 holds the most data but is slower than Type 3.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      64,
      72,
      157,
      169,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 634,
    "question": "Your customer has an iPhone 8 and wants to read and write NFC tags with it. What advice will you give them? (Choose two.)",
    "choice_a": "Their iPhone will only work with Apple Pay.",
    "choice_b": "They need to upgrade to an iPhone X to write NFC tags.",
    "choice_c": "With iOS 13 or better on their device, they\u2019ll be able to read and write NFC tags using a third-party app.",
    "choice_d": "iPhone 12 and iPhone 13 can read NFC tags simply by holding the phone over the tag.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "In devices prior to the iPhone 7, the only Near-Field Communication (NFC) capability is the ability to use Apple Pay; however, with iPhone 7 and newer devices, a third-party app can be used to read and write NFC tags. iPhone 12 and newer devices can natively read NFC tags.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      173,
      64,
      72,
      157,
      173
    ],
    "source": "9781394330348"
  },
  {
    "id": 635,
    "question": "You\u2019ve been asked by the company president what can be done with NFC, in addition to paying for coffee. What will you tell them? (Choose three.)",
    "choice_a": "Securely share data with someone you\u2019re having lunch with.",
    "choice_b": "Beam data to someone 10 feet away.",
    "choice_c": "Transfer files, photos, and videos.",
    "choice_d": "Add information or URLs to business cards, making it easier for customers to learn about your products or services.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Near-Field Communication (NFC) can do so much more than just pay for your coffee. In addition to securely sharing data, transferring files, photos, and video, and adding information to business cards, NFC tags can be set up to automate tasks instead of manually changing settings, such as silencing an alarm or logging into a PC. In some places, they can enable your phone to be your bus pass. They\u2019re considered secure for communication because of the short distance between devices. NFC tags are passive devices that require the power of a very close NFC reader to transfer information. An NFC tag alone is unable to beam data anywhere, and with a reader the distance is measured in inches, not feet.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      64,
      72,
      157,
      172,
      173
    ],
    "source": "9781394330348"
  },
  {
    "id": 636,
    "question": "Which two components of a laptop or other mobile device are the most useful when making a videoconference call? (Choose two.)",
    "choice_a": "Digitizer",
    "choice_b": "Webcam",
    "choice_c": "Microphone/speaker",
    "choice_d": "Number pad",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Webcams are nearly universal on laptops. The most common placement is right above the laptop\u2019s display. Microphones are also often built into the display, next to the webcam. Both laptops and mobile devices such as smartphones and tablets are used for videoconferencing. Desktop computers can be used for videoconferencing too, but usually require adding a webcam and microphone. A digitizer converts touch input into digital format, and a number pad can connect wirelessly or via Universal Serial Bus (USB) and enables the user to enter numbers separately from the laptop\u2019s keyboard.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      66,
      70,
      64,
      65,
      71
    ],
    "source": "9781394330348"
  },
  {
    "id": 637,
    "question": "Of the following laptop components, which one is least likely to be built into the display?",
    "choice_a": "Wi-Fi antenna",
    "choice_b": "Speakers",
    "choice_c": "Webcam",
    "choice_d": "Digitizer",
    "correct_answer": "B",
    "explanation": "Common components to include in the display are the screen, Wi-Fi antenna, webcam, microphone, inverter, and digitizer. Speakers are often near the keyboard on a laptop; however, some desktop displays have built-in speakers.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      66,
      64,
      70,
      65,
      71
    ],
    "source": "9781394330348"
  },
  {
    "id": 638,
    "question": "What types of networking will smart cameras most often have built into them? (Choose two.)",
    "choice_a": "Bluetooth",
    "choice_b": "IrDA",
    "choice_c": "RJ-45",
    "choice_d": "Wi-Fi",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Smart cameras have built-in wireless network connectivity for easy picture and video transfers. Many include Wi-Fi, Bluetooth, and NFC. Infrared Data Association (IrDA) transmission uses infrared light for communication and is not popular, and Registered Jack (RJ) RJ-45 is a type of networking connector.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      162,
      159,
      157,
      166,
      164
    ],
    "source": "9781394330348"
  },
  {
    "id": 639,
    "question": "What component or characteristic on most mobile phones has its ability measured in megapixels?",
    "choice_a": "Brightness",
    "choice_b": "Contrast",
    "choice_c": "Camera",
    "choice_d": "Digitizer",
    "correct_answer": "C",
    "explanation": "Megapixels are a measure of how many unique points a digital camera is capable of storing. It\u2019s more a measure of detail than quality, but for most of us it\u2019s a quick way to compare a smartphone\u2019s photographic capabilities. Brightness and contrast are settings that affect the display, whereas the digitizer accepts analog input and converts it into digital format.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      66,
      160,
      159,
      158,
      157
    ],
    "source": "9781394330348"
  },
  {
    "id": 640,
    "question": "One of your coworkers has purchased an external Bluetooth trackpad to use with their tablet. They\u2019ve turned to you, the company IT person, to install and configure it for them. What actions do you need to take? (Choose two.)",
    "choice_a": "Plug the device into the tablet\u2019s USB port.",
    "choice_b": "Install the trackpad\u2019s drivers.",
    "choice_c": "Put the device in pairing mode, open Settings > Bluetooth and Devices, and then tap the trackpad or choose Add Device.",
    "choice_d": "Go to Settings to configure the trackpad\u2019s speed and scrolling features.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Configuring a new Bluetooth trackpad is a fairly simple procedure. You first need to pair the device with the tablet, then configure it for speed, clicking, and such. The CompTIA A+ objectives list the steps for connecting Bluetooth devices as follows: <ul><li>Enable Bluetooth.</li><li>Enable pairing.</li><li>Find a device for pairing.</li><li>Enter the appropriate PIN code.</li><li>Test connectivity.</li></ul>",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      70,
      159,
      162,
      164,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 641,
    "question": "What type of connection are you using if you use a USB cable to connect your laptop to your cellphone to use the cellular wireless connection from the laptop?",
    "choice_a": "Hotspot",
    "choice_b": "Tethering",
    "choice_c": "USB networking",
    "choice_d": "Phoning",
    "correct_answer": "B",
    "explanation": "Tethering is connecting a device to a mobile hotspot. The term used to be reserved only for when you were connected via Universal Serial Bus (USB) cable, as opposed to connecting via wireless. Some devices will not function as a mobile hotspot but will enable you to tether a mobile device to it with a USB cable, so that the mobile device can share the cellular Internet connection.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      159,
      162,
      163,
      164
    ],
    "source": "9781394330348"
  },
  {
    "id": 642,
    "question": "The company president misplaced their charging cable for their iPhone 14. You tell them it\u2019s no problem and then hand them a new one. What type of connector does this iPhone use for charging?",
    "choice_a": "Thunderbolt",
    "choice_b": "Lightning",
    "choice_c": "ApplePower",
    "choice_d": "USB-C",
    "correct_answer": "B",
    "explanation": "The iPhone 14 series uses the proprietary connector called the Lightning connector. They can also use a compatible wireless charging pad. iPhone 15 and later use a Universal Serial Bus-C (USB-C) port.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      64,
      72,
      157,
      173,
      157
    ],
    "source": "9781394330348"
  },
  {
    "id": 643,
    "question": "What type of mobile device connector is shown here?<img src=\"/question_assets/220-1201/c01f001.png\" alt=\"Close-up view of a charging cable with U S B connector.\"/>\n\n<figcaption>Close-up view of a charging cable with U S B connector.</figcaption>",
    "choice_a": "USB-C",
    "choice_b": "Lightning",
    "choice_c": "MicroUSB",
    "choice_d": "Thunderbolt",
    "correct_answer": "B",
    "explanation": "The connector shown is the Apple Lightning connector used by iPhones since the iPhone 5. Apple began using Universal Serial Bus-C (USB-C) in its iPhones with the release of the iPhone 15 and iPhone 15 Pro on September 22, 2023, after 11 years of using the Lightning connector in earlier iPhones.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      161,
      160,
      159,
      157,
      158
    ],
    "source": "9781394330348"
  },
  {
    "id": 644,
    "question": "Your significant other just purchased a new car and wants you to configure their cellphone to work through the car using voice commands. You must initiate pairing on the phone and choose to search for pairing devices on the car. What protocol is being used by the car and the device?",
    "choice_a": "802.11a",
    "choice_b": "Lightning",
    "choice_c": "Bluetooth",
    "choice_d": "Wi-Fi Enabled",
    "correct_answer": "C",
    "explanation": "To connect Bluetooth devices, a user must initiate the pairing process on both devices. Bluetooth is used to create a personal area network (PAN), also known as a piconet. The range for a Bluetooth network is only about 30 feet. 802.11a is a legacy Wi-Fi standard; Lightning is a type of Apple connector for older devices; and Wi-Fi enabled refers to a device that uses a Wi-Fi connection. The CompTIA A+ objectives list the steps for connecting Bluetooth devices as follows:<ul><li>Enable Bluetooth.</li><li>Enable pairing.</li><li>Find a device for pairing.</li><li>Enter the appropriate PIN code.</li><li>Test connectivity.</li></ul>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      162,
      157,
      160,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 645,
    "question": "A laptop user wants to have a full-sized display and keyboard as well as an external hard drive and speakers available to them at their desk. Which accessory can they purchase to avoid plugging each of these devices separately into their laptop every time they return to the desk? (Choose two.)",
    "choice_a": "KVM switch",
    "choice_b": "Port replicator",
    "choice_c": "Desktop station",
    "choice_d": "Docking station",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "A docking station often replicates the functions of the ports on the back of a laptop, so that peripherals that don\u2019t travel with the laptop, such as displays, keyboards, printers, and so on, can remain connected to the dock and don\u2019t all have to be unplugged physically every time the laptop is removed. Docking stations effectively turn a laptop computer into a desktop computer, and the docking station may offer its own devices, such as an optical drive and speakers. It may have a generic connector such as Universal Serial Bus-C (USB-C) or a proprietary connector. Docking station can also refer to a charging cradle for a smartphone or tablet to plug in vertically that provides other functions such as built-in speakers for music playback or a clock. This differs from a port replicator, whose main function is to let the user connect several devices at once and doesn\u2019t require the laptop to be connected to offer that connectivity between the devices. A KVM switch enables you to use one keyboard, video device, and mouse (hence the name, KVM) with two or more system units.Desktop stationis not an actual technical term.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      64,
      70,
      71,
      66,
      68
    ],
    "source": "9781394330348"
  },
  {
    "id": 646,
    "question": "A user needs ports for external devices in addition to what their laptop has available. The user would like these devices to have connectivity with each other even when the laptop isn\u2019t there. Which of the following will provide that option?",
    "choice_a": "Docking station",
    "choice_b": "Port replicator",
    "choice_c": "KVM switch",
    "choice_d": "Docking port",
    "correct_answer": "B",
    "explanation": "A port replicator is an attachment that provides the same ports as, or additional ports to, a laptop. The devices can communicate with each other via the port replicator regardless of the laptop\u2019s location. Whereas a docking station may (or may not) be a proprietary device, a port replicator is not proprietary and will generally provide a connection to the external devices via a Universal Serial Bus (USB) or similar port. A KVM switch enables you to use one keyboard, video device, and mouse (hence the name, KVM) with two or more system units.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      64,
      71,
      70,
      68,
      69
    ],
    "source": "9781394330348"
  },
  {
    "id": 647,
    "question": "You\u2019ve been handed a device to install. The cable looks like the one shown here. What type of connector does this device use?<img src=\"/question_assets/220-1201/c01f002.png\" alt=\"Close-up view of U S B cable connector.\"/>\n\n<figcaption>Close-up view of U S B cable connector.</figcaption>",
    "choice_a": "USB-C",
    "choice_b": "MiniUSB",
    "choice_c": "MicroUSB",
    "choice_d": "Thunderbolt 3",
    "correct_answer": "C",
    "explanation": "There are several different types of Universal Serial Bus (USB) connectors. The one shown here is a MicroUSB.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      64,
      72,
      157,
      173,
      71
    ],
    "source": "9781394330348"
  },
  {
    "id": 648,
    "question": "You\u2019re configuring a new laptop for a user. What devices can you plug into the port shown here? (Choose two.)<img src=\"/question_assets/220-1201/c01f003.png\" alt=\"Close-up view of a device panel with a Micro-U S B port below two electrical connectors.\"/>\n\n<figcaption>Close-up view of a device panel with a Micro-U S B port below two electrical connectors.</figcaption>",
    "choice_a": "Speaker",
    "choice_b": "Headset",
    "choice_c": "Webcam",
    "choice_d": "Stylus",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "This is an audio output port and can be used to connect either speakers or a headset. Audio output ports are usually color-coded green. A microphone can use a port that looks the same but is color-coded pink.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      64,
      70,
      66,
      65,
      71
    ],
    "source": "9781394330348"
  },
  {
    "id": 649,
    "question": "A technician has a failed Lenovo laptop and suspects the motherboard is bad. They have several other laptops available from which they can harvest parts. Which of the following statements is most likely true regarding the replacement motherboard that is selected?",
    "choice_a": "The motherboard is not replaceable.",
    "choice_b": "Any laptop motherboard will work.",
    "choice_c": "A motherboard from any other Lenovo laptop will work.",
    "choice_d": "Only a motherboard from that same model of Lenovo laptop will work.",
    "correct_answer": "D",
    "explanation": "Laptop motherboards are nearly always proprietary, meaning they are not interchangeable between manufacturers or even between models from the same manufacturer. When a laptop motherboard needs to be replaced, you most likely need a laptop motherboard from the same laptop make and model.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      67,
      64,
      65,
      71,
      68
    ],
    "source": "9781394330348"
  },
  {
    "id": 650,
    "question": "You will be traveling to another country for work and will have a 10-hour airplane flight. You need to work on your laptop while flying, but your battery won\u2019t last that long. What should you have on hand to enable you to use the auxiliary power outlets on the airplane?",
    "choice_a": "AC adapter",
    "choice_b": "DC adapter",
    "choice_c": "Power inverter",
    "choice_d": "Docking station",
    "correct_answer": "B",
    "explanation": "A Direct Current (DC) power adapter enables a user to plug the laptop into the DC power source (usually called an auxiliary power outlet) inside a car or on an airplane. Alternating Current (AC) power adapters are for plugging into standard wall outlets. Some airplanes now provide AC power outlets to their passengers as well. Check availability with the airline before your flight.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      71,
      159,
      162,
      157,
      163
    ],
    "source": "9781394330348"
  },
  {
    "id": 651,
    "question": "The AC adapter for your laptop is not working properly, and you are searching for a replacement. Which two factors are most important when selecting a new AC adapter? (Choose two.)",
    "choice_a": "Polarity",
    "choice_b": "Same wattage as the original",
    "choice_c": "Brand of the adapter",
    "choice_d": "Size of the adapter\u2019s transformer",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "You should choose an Alternating Current (AC) adapter rated for the same wattage as the original. You must also pay special attention to the voltage and polarity of the plug that interfaces with the laptop. If the laptop requires the positive lead to be the center conductor, for instance, then you must take care not to reverse the polarity. It\u2019s best to find one that advertises compatibility with the device it will be charging.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      71,
      65,
      64,
      68,
      69
    ],
    "source": "9781394330348"
  },
  {
    "id": 652,
    "question": "How do modern docking stations connect to laptops? (Choose two.)",
    "choice_a": "USB 2",
    "choice_b": "USB-C",
    "choice_c": "Thunderbolt 3 or 4",
    "choice_d": "HDMI",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Legacy docking stations have a proprietary port that aligns with a connector, usually on the bottom or back of a laptop. The docking stations are proprietary, meaning they can only work with specific equipment. Modern docking stations connect with the fast Universal Serial Bus-C (USB-C) or Thunderbolt ports, and sometimes Universal Serial Bus-A (USB-A) ports. They often supply their own power and can make a laptop seem like a desktop by plugging in one cable that connects the laptop to multiple displays, gigabit Ethernet, audio, or almost any other port type. Docking station can also refer to a charging cradle for a smartphone or tablet to plug in vertically that provides other functions such as built-in speakers for music playback or a clock.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      71,
      67,
      68,
      69
    ],
    "source": "9781394330348"
  },
  {
    "id": 653,
    "question": "You have enabled the GPS service in your tablet. What is the minimum number of GPS satellites your tablet needs to be in contact with to determine its location?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "C",
    "explanation": "Global Positioning Systems (GPS) systems were designed to require multiple satellites. Receivers use a process called triangulation, which they use to calculate the distance between themselves and the satellites (based on the time it takes to receive a signal) to determine their location. They require input from four satellites to provide location and elevation or three to provide location.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      165,
      166,
      167,
      159,
      157
    ],
    "source": "9781394330348"
  },
  {
    "id": 654,
    "question": "A technician needs to replace a failed laptop hard drive. Which of the following form factors could the laptop require? (Choose two.)",
    "choice_a": "M.2",
    "choice_b": "2.0-inch",
    "choice_c": "2.5-inch",
    "choice_d": "3.5-inch",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "An older laptop hard drive will usually be a Solid-State Drive (SSD) in the 2.5-inch form factor. Modern laptops most likely use either mSATA or M.2 drives, which are thinner than a RAM module and much smaller. Desktop computers have historically used 3.5-inch hard drives but most also support 2.5-inch or M.2 drives.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      69,
      64,
      71,
      72,
      68
    ],
    "source": "9781394330348"
  },
  {
    "id": 655,
    "question": "You were given an older laptop, which has 4 GB of system RAM and an integrated video card. The default setting specifies 512 MB of video memory. How much RAM is available for the processor to use?",
    "choice_a": "4 GB",
    "choice_b": "3.5 GB",
    "choice_c": "3 GB",
    "choice_d": "It\u2019s variable",
    "correct_answer": "B",
    "explanation": "Many laptops use shared video memory, meaning that system Random Access Memory (RAM) is divided up for use between the processor and the video card. On these types of systems, the amount of RAM available for video is configured in the Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI). Anything reserved for the video card is unavailable to the processor. In this case, subtracting half a gigabyte from 4 GB leaves the Central Processing Unit (CPU) with 3.5 GB.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      67,
      68,
      64,
      71,
      65
    ],
    "source": "9781394330348"
  },
  {
    "id": 656,
    "question": "Oculus, Samsung, and HTC are manufacturers of what specific type of wearable technology devices?",
    "choice_a": "Smart glasses",
    "choice_b": "Smart headsets",
    "choice_c": "Smart watches",
    "choice_d": "VR/AR headsets",
    "correct_answer": "D",
    "explanation": "Oculus VR specializes in Virtual Reality and Augmented Reality (VR/AR) headsets. Samsung and HTC, while manufacturing smartphones, also produce VR/AR headsets.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      64,
      72,
      157,
      173
    ],
    "source": "9781394330348"
  },
  {
    "id": 657,
    "question": "What type of connectors are the two shown in the center here?<img src=\"/question_assets/220-1201/c01f004.png\" alt=\"Close-up view of a row of computer ports including MagSafe 2 power port, two Thunderbolt 2 ports, and a U S B 3 port, on a laptop.\"/>\n\n<figcaption>Close-up view of a row of computer ports including MagSafe 2 power port, two Thunderbolt 2 ports, and a U S B 3 port, on a laptop.</figcaption>",
    "choice_a": "Lightning",
    "choice_b": "Thunderbolt",
    "choice_c": "DisplayPort",
    "choice_d": "PCIe x 1",
    "correct_answer": "B",
    "explanation": "The two center connectors are Thunderbolt connectors. They have the characteristic lightning bolt icon. Thunderbolt is an offshoot of DisplayPort technology and supports many types of peripherals.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      64,
      65,
      71,
      66,
      70
    ],
    "source": "9781394330348"
  },
  {
    "id": 658,
    "question": "What type of device could use a Lightning connector to charge and transfer data?",
    "choice_a": "Samsung smartphone",
    "choice_b": "Fitbit watch",
    "choice_c": "Intel-based laptop",
    "choice_d": "Apple iPhone",
    "correct_answer": "D",
    "explanation": "iPhones from the iPhone 5 to iPhone 14 have used a proprietary connector called the Lightning connector. iPhone 15 and later use a Universal Serial Bus-C (USB-C) power connector. Samsung smartphones and Fitbit watches most likely use a USB-C cable, whereas Intel-based laptops use a variety of charging jacks, depending on the device.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      160,
      161,
      159,
      162,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 659,
    "question": "What is the likely type of Wi-Fi antenna connector you will find as an external connector on a laptop?",
    "choice_a": "SMA-female-RP",
    "choice_b": "N-male",
    "choice_c": "SMA-male-RP",
    "choice_d": "N-female",
    "correct_answer": "A",
    "explanation": "The overwhelming majority of Wi-Fi antenna connectors for indoor-rated antennas found on laptops are type SubMiniature version A (SMA). The SMA-female connector is on the device. What makes a connector \u201cmale\u201d is the center pin and threads on the inside, while a \u201cfemale\u201d connector has a receptor for the pin and threads on the outside. Reverse Polarity (RP) means that the pin and receptor are in opposite positions with regard to connector gender, while the outside housing remains the same. SMA-RP and SMA are, therefore, not compatible with each other. N-type connectors look similar but are weatherproof and larger than SMA connectors.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      66,
      64,
      71,
      65,
      67
    ],
    "source": "9781394330348"
  },
  {
    "id": 660,
    "question": "After enabling your device for communication using the IEEE 802.15.1 standard, what is the next step?",
    "choice_a": "Enter the PIN code.",
    "choice_b": "Find a device for pairing.",
    "choice_c": "Enable pairing.",
    "choice_d": "Open port 802.15.1.",
    "correct_answer": "C",
    "explanation": "The Institute of Electrical and Electronics Engineers (IEEE) standard 802.15.1 is commonly known as Bluetooth. The CompTIA A+ objectives list the steps for connecting Bluetooth devices as follows: <ul><li>Enable Bluetooth.</li><li>Enable pairing.</li><li>Find a device for pairing.</li><li>Enter the appropriate PIN code.</li><li>Test connectivity.</li></ul>Not all Bluetooth devices require entering a pin. Opening a port is done on a router to enable a particular type of traffic to pass through the router to a connected network.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      159,
      162,
      157,
      164,
      172
    ],
    "source": "9781394330348"
  },
  {
    "id": 661,
    "question": "You\u2019ve enabled Bluetooth on your new headset and laptop, and enabled pairing on both. They have discovered each other, so what is the typical next step?",
    "choice_a": "Pressing and holding a Bluetooth button",
    "choice_b": "Entering the Bluetooth password",
    "choice_c": "Entering the Bluetooth PIN code",
    "choice_d": "Exiting out of any running Bluetooth applications",
    "correct_answer": "C",
    "explanation": "When pairing two Bluetooth devices, depending on the security settings, it is sometimes necessary to enter a Bluetooth Personal Identification Number (PIN) code. In security configuration menus, the PIN is sometimes referred to as the Bluetooth passcode or passkey. The CompTIA A+ objectives list the steps for connecting Bluetooth devices as follows: <ul><li>Enable Bluetooth.</li><li>Enable pairing.</li><li>Find a device for pairing.</li><li>Enter the appropriate PIN code.</li><li>Test connectivity.</li></ul>",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      159,
      162,
      164,
      157,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 662,
    "question": "What service is built into Apple-developed devices and permits users and subscribers to store documents, media, and contact information in a remote location?",
    "choice_a": "iStore",
    "choice_b": "OneDrive",
    "choice_c": "iCloud",
    "choice_d": "CloudOnline",
    "correct_answer": "C",
    "explanation": "Apple\u2019s cloud service, called iCloud, is for users and subscribers to store their media, contacts, and so on. OneDrive is Microsoft\u2019s online cloud user storage.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      173,
      172,
      171,
      159,
      160
    ],
    "source": "9781394330348"
  },
  {
    "id": 663,
    "question": "Which configuration settings are commonly used when setting up email from an online provider on a device?",
    "choice_a": "Active Directory domain name",
    "choice_b": "Port and TLS settings",
    "choice_c": "Email server name",
    "choice_d": "Username and password",
    "correct_answer": "D",
    "explanation": "If you use a common email provider such as Google, Yahoo, Outlook, or iCloud, then setting up email on a device should be simple. Often, all you need is your username and password. If you\u2019re setting up a corporate account or if you must manually configure email, then you\u2019ll need more information, such as whether it\u2019s using Internet Messaging Access Protocol (IMAP) or Portable Office Protocol (POP3) and the server names for sending and receiving email. You may also need the port number and security settings.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      170,
      172,
      162,
      164,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 664,
    "question": "Which number that is a part of the GSM system is hardcoded into the phone and identifies your physical phone hardware to the cellular tower?",
    "choice_a": "PRI",
    "choice_b": "IMSI",
    "choice_c": "IMEI",
    "choice_d": "MAC",
    "correct_answer": "C",
    "explanation": "The International Mobile Equipment Identity (IMEI) is a unique number assigned to the physical phone. This unique identifier is hardcoded into the device. The Primary Rate Interface or Product Release Instructions (PRI) describe how your device connects to the network. An International Mobile Subscriber Identity (IMSI) number uniquely identifies the account holder, and a Media Access Control (MAC) address uniquely identifies a network interface card.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      161,
      158,
      160,
      157,
      159
    ],
    "source": "9781394330348"
  },
  {
    "id": 665,
    "question": "Which unique component identifies you as a user and is coded into a phone by the user or service provider?",
    "choice_a": "IMSI",
    "choice_b": "eSIM",
    "choice_c": "IMEI2",
    "choice_d": "SIM",
    "correct_answer": "B",
    "explanation": "A cellphone\u2019s Electronic Subscriber Identification Module (eSIM) identifies a person on a cellular number and can be transferred from one phone to another. eSIMs have largely replaced physical SIM cards. The International Mobile Subscriber Identity (IMSI) is a unique number that identifies you, the user, to the cellular service. The International Mobile Equipment Identity (IMEI) is a unique number assigned to the physical phone. A phone mayhave more than one IMEI (IMEI2), which enables the user to install more than one SIM/eSIM and use more than one phone number on a cellphone.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      161,
      160,
      158,
      159,
      157
    ],
    "source": "9781394330348"
  },
  {
    "id": 666,
    "question": "What best practice can save someone from losing data, such as calendar entries and contacts on their mobile device, if their device is lost?",
    "choice_a": "Synchronization",
    "choice_b": "VPN",
    "choice_c": "Encryption",
    "choice_d": "Updating",
    "correct_answer": "A",
    "explanation": "Synchronization means to duplicate or back up data from a device. Synchronization can be done to the local desktop, to the cloud service off-premises, or even to an automobile. A virtual private network (VPN) uses encryption protocols to safeguard communications across a shared transmission medium (like the Internet) and mimics the network connection you would have if you were in the same building as your server. Encryption is using algorithms to change data, so that it can\u2019t be read by unauthorized people or devices, thus protecting your data and logins. Updating is a generic term for modernizing and adding features to something.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      171,
      172,
      173,
      164,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 667,
    "question": "A user wants their calendars to be readily available on multiple devices, including their laptop, desktop, and cellphone. What is the best option?",
    "choice_a": "Email appointments to self.",
    "choice_b": "Send links to a URL-shortening service.",
    "choice_c": "Synchronize calendars.",
    "choice_d": "Synchronize bookmarks.",
    "correct_answer": "C",
    "explanation": "When you synchronize calendars between devices, appointments and entries are copied and readily available on each device. Synchronization can be accomplished in multiple ways, depending on the service or third-party software being used. The same synchronization can be done for several media types, such as videos, music, pictures, and documents.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      171,
      172,
      173,
      162,
      164
    ],
    "source": "9781394330348"
  },
  {
    "id": 668,
    "question": "When two parents want to share appointment dates and times between their devices, what is their best option?",
    "choice_a": "Synchronize their calendars.",
    "choice_b": "Share calendar passwords.",
    "choice_c": "Text the calendar data to each other.",
    "choice_d": "Email calendar invites to each other.",
    "correct_answer": "A",
    "explanation": "Synchronizing calendars between devices and users is an easy and reliable option for ensuring that all parties have the same information. Passwords should never be shared.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      172,
      171,
      162,
      173,
      159
    ],
    "source": "9781394330348"
  },
  {
    "id": 669,
    "question": "Your user needs to synchronize their contact list between their work computer and their smartphone. What Windows app is used to synchronize data between a user\u2019s mobile devices like smartphones and their desktop computers?",
    "choice_a": "MSync",
    "choice_b": "ActiveSync",
    "choice_c": "SyncTime",
    "choice_d": "Timewarp",
    "correct_answer": "B",
    "explanation": "ActiveSync was developed by Microsoft to make synchronization of data easier and enables users to access their data even when they\u2019re not online. The other options are not part of the CompTIA A+ objectives, but for the curious: MSync is an internal working of the operating system that synchronizes memory and storage. SyncTime is a third-party application, and Timewarp is a name given to several software utilities, a song, and at least one event venue.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      171,
      172,
      157,
      159,
      160
    ],
    "source": "9781394330348"
  },
  {
    "id": 670,
    "question": "You\u2019re installing Bluetooth speakers in a conference room and just entered the PIN to connect the two devices. What is your next step?",
    "choice_a": "Enable pairing.",
    "choice_b": "Search for the Bluetooth device.",
    "choice_c": "Enable Bluetooth.",
    "choice_d": "Test connectivity.",
    "correct_answer": "D",
    "explanation": "As with any device installation in IT, the last step is to verify that the device works as intended. The CompTIA A+ objectives list the steps for connecting Bluetooth devices as follows:<ul><li>Enable Bluetooth.</li><li>Enable pairing.</li><li>Find a device for pairing.</li><li>Enter the appropriate PIN code.</li><li>Test connectivity.</li></ul>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      162,
      164,
      157,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 671,
    "question": "The owner of a company that provides transportation from an airport to various hotels wants to employ software that will tell them where every vehicle is at all times. All the vehicles use satellite-based navigation systems. What technology is most likely being used to track where they are?",
    "choice_a": "GPS",
    "choice_b": "MDM",
    "choice_c": "Cellular location services",
    "choice_d": "MAM",
    "correct_answer": "A",
    "explanation": "Any device that has a Global Positioning System (GPS) receiver has the ability to ping satellites, which will correspond with at least two others to triangulate the position of the device, and they are quite accurate. (A fourth satellite is needed to determine elevation.) This is a common way for devices to provide turn-by-turn directions. While cellular location services work the same way, that wouldn\u2019t be the answer unless the vehicle has its own cellular service. Mobile Device Management (MDM) and Mobile Application Management (MAM) are methods of data security in a corporate environment.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      165,
      166,
      168,
      169,
      157
    ],
    "source": "9781394330348"
  },
  {
    "id": 672,
    "question": "You\u2019re going hiking this weekend in unfamiliar territory and have installed an application on your phone to show you where you are on the map in relation to the trails and surrounding areas. What two types of location technology might this app use? (Choose two.)",
    "choice_a": "GPS",
    "choice_b": "MDM",
    "choice_c": "Cellular location services",
    "choice_d": "RFID",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Both Global Positioning System (GPS) and cellular location services can be used to pinpoint the location of any device on Earth that has a GPS receiver or cellular service. GPS finds your location by pinging satellites, whereas cellular location services use three or morecellphone towers in a process called triangulation to determine your location. (A fourth tower is needed to determine elevation.) Mobile Application Management (MDM) is a type of data security for mobile devices, and Radio Frequency Identification (RFID) is often used for inventory management.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      165,
      166,
      167,
      158,
      157
    ],
    "source": "9781394330348"
  },
  {
    "id": 673,
    "question": "You\u2019re at home binging on a popular Internet movie service and suddenly notice that the spinning wheel is showing up often, taking more time to download the movie than normal. What is likely the problem?",
    "choice_a": "Your router needs to be reset.",
    "choice_b": "You have reached your data cap.",
    "choice_c": "Your laptop is overheating.",
    "choice_d": "The service is overwhelmed with requests.",
    "correct_answer": "B",
    "explanation": "While it\u2019s possible that the server has too many requests, the more likely culprit to your slow downloads is that you\u2019ve reached your Internet service\u2019s data cap, and your service has slowed. This can happen whether it\u2019s home service or cellphone service. Some services may cut you off completely, and others merely send you a text message stating you\u2019ve reached your limit, so they\u2019ll be slowing your connection or billing you more. If the router needed to be reset, the symptoms would be different. If the laptop was overheating, it would most likely shut down.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      163,
      171,
      157,
      158,
      159
    ],
    "source": "9781394330348"
  },
  {
    "id": 674,
    "question": "The executives at your company are concerned about employees using their personal devices for work. They worry that someone may leave and take proprietary information with them. You calm their fears by telling them that there are settings in place on the Bring Your Own Device (BYOD) policy that protect company data accessed by employees. What are those settings called? (Choose two.)",
    "choice_a": "MAM",
    "choice_b": "MDM",
    "choice_c": "GSM",
    "choice_d": "CDMA",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Mobile Application Management (MAM) protects corporate data while being used on employee\u2019s personal devices. It can force employees to save all work files in the company\u2019s OneDrive, encrypt files and delete them after a period of time, and restrict employees from downloading company content. It can even delete company files when a device has become inactive. Mobile Device Management (MDM) systems can be used to wipe data from a device and restore it to factory settings. Global Systems for Mobile Communication (GSM) and Code-Division Multiple Access (CDMA) are cellular communication technology systems.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      168,
      169,
      172,
      173,
      157
    ],
    "source": "9781394330348"
  },
  {
    "id": 675,
    "question": "Which cellular communication technology is projected to be able to reach transmission rates up to 20 Gbps?",
    "choice_a": "3G",
    "choice_b": "4G",
    "choice_c": "5G",
    "choice_d": "Wi-Fi 6",
    "correct_answer": "C",
    "explanation": "5G, which is still being implemented, employs the use of different software and radio transmitters, and is backward compatible. It\u2019s estimated that it will be able to reach transmission rates of 20 Gbps. The fourth generation of cellular services (4G) is also known as Long-Term Evolution (LTE). It was introduced in the 2000s. It boasted downstream rates as fast as 53.3 Mbps. Prior to that, 2G came out in 1991 and added text-based Short Messaging Service (SMS). 3G was released in 2001 and transmits up to 7.2 Mbps. Wi-Fi 6 is not a cellular communication technology.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      158,
      157,
      163,
      159,
      160
    ],
    "source": "9781394330348"
  },
  {
    "id": 676,
    "question": "An employee will be using their own device to work on company projects while they are at home. What are your two most likely options for providing access to corporate applications? (Choose two.)",
    "choice_a": "Install a corporate-licensed copy on their device that is managed remotely by MDM or MAM software.",
    "choice_b": "Purchase a single-user license for the software to install on their device.",
    "choice_c": "Provide cloud access to the application.",
    "choice_d": "Force them to use a corporate-owned device.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "While any of the given options are possible, the two most likely are to provide cloud access to the application, or \u201cto install the software on their device and manage it remotely using Mobile Device Management (MDM) or Mobile Application Management (MAM) software.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      168,
      169,
      173,
      164,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 677,
    "question": "You are installing a fiber-optic cable between two buildings. To install the cable, you must run it through a conduit between the buildings, and access to the conduit is not easy. Before you run the cable, you want to ensure that it\u2019s working properly. Which tool should you use?",
    "choice_a": "Cable tester",
    "choice_b": "Multimeter",
    "choice_c": "Loopback plug",
    "choice_d": "Tone generator and probe",
    "correct_answer": "A",
    "explanation": "Cable testers are indispensable tools for any network technician. Usually, you use a cable tester before you install a cable to verify it works. Of course, you can test them after they\u2019ve been run as well, such as when a cable is run from a wiring closet to a work area. Multimeters are used to test power supplies and wall outlets. Loopback plugs are used to testnetwork interface cards, and a tone generator and probe are used to locate a wire among other wires. The tools are (of course) different for twisted pair or fiber-optic cables, to accommodate the different connections. The tool for testing fiber-optic cables is called an Optical Time Domain Reflectometer (OTDR).",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      113,
      116,
      111,
      110,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 678,
    "question": "Which TCP/IP protocol, designed to download email, enables multiple clients to be simultaneously connected to the same mailbox?",
    "choice_a": "SMTP",
    "choice_b": "POP3",
    "choice_c": "IMAP",
    "choice_d": "SMB",
    "correct_answer": "C",
    "explanation": "Internet Message Access Protocol (IMAP) is a secure protocol designed to download email. It has several advantages over the older Post Office Protocol 3 (POP3). First, IMAP4 works in connected and disconnected modes. Second, it lets you store the email on the server, as opposed to POP3, which requires you to download it. Third, IMAP4 enables multiple clients to be simultaneously connected to the same inbox. Simple Mail Transfer Protocol (SMTP) is used for sending mail, and Server Message Block (SMB) is used when sharing files across a network.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      120,
      119,
      128,
      106,
      114
    ],
    "source": "9781394330348"
  },
  {
    "id": 679,
    "question": "You are using your laptop on the company network. In your web browser, you type inwww.google.comand press Enter. The computer cannot find Google. You open the browser on your phone, and using your cellular connection, you can open Google without a problem. Your laptop finds internal servers and can print without any issues. What is the most likely reason you can\u2019t open Google?",
    "choice_a": "DNS server problem",
    "choice_b": "DHCP server problem",
    "choice_c": "Missing subnet mask",
    "choice_d": "Duplicate IP address",
    "correct_answer": "A",
    "explanation": "The Domain Name System (DNS) server is responsible for resolving hostnames, such aswww.google.com, to IP addresses to enable communication. If it\u2019s not working properly or you can\u2019t connect to it, you won\u2019t be able to browse the Internet using human-friendly website names. Dynamic Host Configuration Protocol (DHCP) is used to assign IP addresses to network clients. The subnet mask might be incorrect, but it wouldn\u2019t likely be missing, and a duplicate IP address would provide an error message stating so.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      129,
      121,
      130,
      118,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 680,
    "question": "Which one of the following TCP/IP protocols was designed as a replacement for Telnet?",
    "choice_a": "SMB",
    "choice_b": "SSH",
    "choice_c": "SFTP",
    "choice_d": "FTPS",
    "correct_answer": "B",
    "explanation": "Secure Shell (SSH) can be used to set up a secure session over port 22 for remote logins, or for remotely executing programs and transferring files. Because it\u2019s secure, it was originally designed to be a replacement for the unsecuretelnetcommand. SSH and Telnet are both the name of the respective protocols, and the commands used. The Server Message Block (SMB) protocol, File Transfer Protocol (FTP), and FTP Secure (FTPS) protocols are used to share files across a network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      128,
      106,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 681,
    "question": "What feature of 802.11ac, 802.11ax, and 802.11be enables them to effectively double their available bandwidth?",
    "choice_a": "QoS",
    "choice_b": "QAM",
    "choice_c": "PoE",
    "choice_d": "EoP",
    "correct_answer": "B",
    "explanation": "Quadrature Amplitude Modulation (QAM) is a process that combines two AM channels into one, effectively doubling the bandwidth of modern Wi-Fi protocols. Quality of Service (QoS) is configured to give priority to a user or application. Power over Ethernet (PoE) provides electrical power over Ethernet cables and Ethernet over Power (EoP) enables a user to enlist already established electrical cables to carry Ethernet signals; it requires the use of special adapters that plug into regular power outlets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      142,
      140,
      138,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 682,
    "question": "Which of the following TCP/IP protocols is connection-oriented and attempts to guarantee packet delivery?",
    "choice_a": "IP",
    "choice_b": "TCP",
    "choice_c": "UDP",
    "choice_d": "ICMP",
    "correct_answer": "B",
    "explanation": "Transmission Control Protocol (TCP) guarantees packet delivery through the use of a virtual circuit and data acknowledgments, whereas User Datagram Protocol (UDP) does not. Because of this, TCP is often referred to as being connection-oriented, whereas UDP is connectionless. Internet Protocol (IP) is used to get packets to their destination across the Internet, and Internet Control Message Protocol (ICMP) is used by connectivity devices to diagnose problems and send messages.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      118,
      106,
      117,
      120
    ],
    "source": "9781394330348"
  },
  {
    "id": 683,
    "question": "Which TCP/IP protocol enables a user to log in to a remote computer and manage files as if they were logged in locally?",
    "choice_a": "FTP",
    "choice_b": "SFTP",
    "choice_c": "SMB",
    "choice_d": "RDP",
    "correct_answer": "D",
    "explanation": "Remote Desktop Protocol (RDP) is a replacement for the older Terminal Services, which used the Telnet protocol. Terminal services and the Telnet protocol are not secure. (They\u2019re depreciated.) RDP, as its name implies, lets users log into a local machine and use a remote machine almost as if they were sitting at it. RDP uses port 3389. File Transfer Protocol (FTP), Secure FTP (SFTP)\u2014also called Secure Shell (SSH) FTP\u2014and Server Message Block (SMB) are all protocols that are used for sharing files across a network.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      120,
      128,
      119,
      121,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 684,
    "question": "Which of the following Wi-Fi standards is the fastest, operating in both the 2.4 and 5 GHz frequencies?",
    "choice_a": "802.11a",
    "choice_b": "802.11ac",
    "choice_c": "802.11ax",
    "choice_d": "802.11n",
    "correct_answer": "C",
    "explanation": "802.11ax (Wi-Fi 6) is considered a replacement for 802.11ac (Wi-Fi 5). 802.11ac operates in the 5 GHz frequency, while 802.11ax can operate between 1 and 7.125 GHz frequencies, encompassing the 2.4 GHz and 5 GHz bands. 802.11ac can send data at over 1 Gbps, while 802.11ax can be several times faster. 802.11a was adopted in 1999. It operates at 54 Mbps in the 5 GHz frequency band. 802.11n was adopted in 2008. It operates at 600 Mbps in both the 2.4 GHz and 5 GHz ranges.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      141,
      142,
      138,
      140
    ],
    "source": "9781394330348"
  },
  {
    "id": 685,
    "question": "Bob has a device that operates at 5 GHz. He is unable to connect his device to a LAN that he hasn\u2019t accessed before, although he has verified that he has the correct password. What type of network might pose this problem?",
    "choice_a": "802.11g",
    "choice_b": "802.11n",
    "choice_c": "802.11ac",
    "choice_d": "802.11ax",
    "correct_answer": "A",
    "explanation": "If Bob is trying to connect to an 802.11g network, his device will not be able to connect because 802.11g operates on the 2.4 GHz frequency only. 802.11n and 802.11ax both operate on 2.4 GHz and 5 GHz. 802.11ac operates only on the 5 GHz frequency.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      138,
      143,
      142,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 686,
    "question": "Which TCP/IP protocol is used to provide shared access to files and printers on the network?",
    "choice_a": "FTP",
    "choice_b": "SSH",
    "choice_c": "SMB",
    "choice_d": "SMTP",
    "correct_answer": "C",
    "explanation": "Server Message Block (SMB) is a protocol used to provide shared access to files, printers, and other network resources. In a way, it functions a bit like File Transfer Protocol (FTP) with a few more options, such as the ability to connect to printers and ports, and SMB offers more management commands. Secure Shell (SSH) uses encryption to create a secure contact between two computers, and Simple Mail Transfer Protocol (SMTP) is used for sending email.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      215,
      103,
      128,
      119
    ],
    "source": "9781394330348"
  },
  {
    "id": 687,
    "question": "Which deprecated protocol enables a user to log in to another machine and \u201csee\u201d the remote computer in a window on their screen?",
    "choice_a": "SSH",
    "choice_b": "FTP",
    "choice_c": "Telnet",
    "choice_d": "SMTP",
    "correct_answer": "C",
    "explanation": "Telnet lets users log into another machine and \u201csee\u201d the remote computer in a window on their screen. Although this vision is text only, users can manage files on that remote machine just as if they were logged in locally. Telnet uses port 23. Telnet has been largely replaced by Secure Shell (SSH), and SSH (over port 22) is more secure than Telnet. Port 21 is used by File Transfer Protocol (FTP) and port 25 is used by Simple Mail Transfer Protocol (SMTP).",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      120,
      128,
      119,
      121,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 688,
    "question": "You have just installed a wireless 802.11ac network for a client. The IT manager is concerned about competitors intercepting the wireless signal from outside the building. Which tool is designed to test how far your wireless signal travels?",
    "choice_a": "Tone generator and probe",
    "choice_b": "Protocol analyzer",
    "choice_c": "Packet sniffer",
    "choice_d": "Wi-Fi analyzer",
    "correct_answer": "D",
    "explanation": "A wireless locator, or a Wi-Fi analyzer, can be either a handheld hardware device or specialized software that is installed on a laptop, smartphone, or other mobile device, and whose purpose it is to detect and analyze Wi-Fi signals. It can detect where signals are strong or weak, to determine whether there are potential security issues. A tone generator and probe are used for locating a wire. Protocol analyzers and packet sniffers are tools for capturing and analyzing network traffic.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      138,
      152,
      153,
      154
    ],
    "source": "9781394330348"
  },
  {
    "id": 689,
    "question": "Some of your network users are concerned about submitting confidential information to an online website. What should you tell them?",
    "choice_a": "It\u2019s fine, because all Internet traffic is encrypted.",
    "choice_b": "If the website address starts withTLS://, it should be OK to submit confidential information to a trusted site.",
    "choice_c": "If the website address starts withHTTPS://, it should be OK to submit confidential information to a trusted site.",
    "choice_d": "Don\u2019t ever submit confidential information to any online website.",
    "correct_answer": "C",
    "explanation": "Internet traffic is not encrypted by default. Websites that are secure and encrypt their transmissions will start withHTTPS://rather thanHTTP://. These sites can be trusted to encrypt the data, and their identity is verified.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      126,
      120,
      135,
      106,
      124
    ],
    "source": "9781394330348"
  },
  {
    "id": 690,
    "question": "Which of these standards operate in the 2.4, 5, and 6 GHz frequencies? (Choose two.)",
    "choice_a": "802.11ac",
    "choice_b": "802.11ax",
    "choice_c": "802.11g",
    "choice_d": "802.11be",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "802.11ac operates in the 5 GHz frequency only. 802.11g is only 2.4 GHz. 802.11n and 802.11ax (Wi-Fi 6) operate in both 2.4 GHz and 5 GHz frequencies; however, the 802.11ax extended (Wi-Fi 6E) is an enhanced version of 802.11ax that operates in the 6 GHz frequency. 802.11be operates in the 2.4, 5, and 6 GHz frequencies. You might find it helpful to create a chart of standards, speeds, and frequencies to study for the exam.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      143,
      142,
      141,
      145
    ],
    "source": "9781394330348"
  },
  {
    "id": 691,
    "question": "Which type of IPv6 address identifies a single node on the network?",
    "choice_a": "Multicast",
    "choice_b": "Anycast",
    "choice_c": "Unicast",
    "choice_d": "Localcast",
    "correct_answer": "C",
    "explanation": "There are three types of addresses in IPv6: unicast, anycast, and multicast. A unicast address identifies a single node on the network. An anycast address refers to one that has been assigned to multiple nodes, and a packet will be delivered to one of them. A multicast address is one that identifies multiple hosts, and a packet will be sent to all of them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      117,
      118,
      99,
      125
    ],
    "source": "9781394330348"
  },
  {
    "id": 692,
    "question": "What type of network covers large geographical areas and may support thousands of users, often using lines owned by other entities?",
    "choice_a": "LAN",
    "choice_b": "WAN",
    "choice_c": "PAN",
    "choice_d": "MAN",
    "correct_answer": "B",
    "explanation": "A Wide Area Network (WAN) covers large geographical areas and often supports thousands of users. A WAN can connect different locations of a single company, or a WAN may connect several companies together to share information. WAN lines are often leasedfrom a WAN provider. The Internet is considered a very large WAN. A Local Area Network (LAN) covers a relatively small area such as a home or business. A Personal Area Network (PAN) is typically used by one person and is comprised of their computer and its Bluetooth devices. A Metropolitan Area Network (MAN) is similar to a WAN, but the area covered is much smaller, such as a university or a city.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      99,
      101,
      102,
      114,
      124
    ],
    "source": "9781394330348"
  },
  {
    "id": 693,
    "question": "Which TCP/IP protocol, developed by Microsoft, uses port 3389 to connect to a remote computer?",
    "choice_a": "RDP",
    "choice_b": "SMB",
    "choice_c": "CIFS",
    "choice_d": "Telnet",
    "correct_answer": "A",
    "explanation": "Developed by Microsoft, the Remote Desktop Protocol (RDP) enables users to connect to remote computers and run programs on them as if they were sitting at the computer. It uses port 3389. A port is associated with a specific protocol and must be \u201copened\u201d on a router to enable traffic from the program or protocol to enter the LAN. The combination of an IP address and a port is considered a socket. The IP address gets the data to the right destination, and the port number tells the transmission layer of the Open Systems Interconnection (OSI) model to which application the data is to be sent. Server Message Block (SMB) and Common Internet File System (CIFS) are used to share files across a network. Telnet (port 23) is an unsecure protocol that has been largely replaced with Secure Shell (SSH) protocol. SSH uses port 22.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      120,
      119,
      106,
      155
    ],
    "source": "9781394330348"
  },
  {
    "id": 694,
    "question": "What port does the SSH protocol use?",
    "choice_a": "21",
    "choice_b": "22",
    "choice_c": "23",
    "choice_d": "25",
    "correct_answer": "B",
    "explanation": "Secure Shell (SSH) can be used to set up a secure session for remote logins, or for remotely executing programs and transferring files. SSH uses port 22. SSH has largely replaced the unsecured Telnet, which uses port 23. Port 21 is used by File Transfer Protocol (FTP) and port 25 is used by Simple Mail Transfer Protocol (SMTP.).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      119,
      117,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 695,
    "question": "Which of the following IP addresses is not routable on the Internet?",
    "choice_a": "10.1.1.1",
    "choice_b": "11.1.1.1",
    "choice_c": "12.1.1.1",
    "choice_d": "13.1.1.1",
    "correct_answer": "A",
    "explanation": "10.1.1.1 is a private IP address, and therefore not routable on the Internet. Private IP addresses can only be used on the LAN side of a router. The other answer options are all routable. IPv4 network numbers were arranged in classes, and classes A, B, and C each have their own private range. The private IP address range for class A networks is 10.0.0.0/8. The /8 means that the first 8 bits of the subnet mask denote the network number. Expressing a subnet mask this way is known as CIDR (pronounced cider) notation. CIDR stands for classless inter-domain routing. While the term CIDR doesn\u2019t appear on the objectives for this CompTIA A+ exam, you may still run into it while working in IT.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      123,
      122,
      114,
      121
    ],
    "source": "9781394330348"
  },
  {
    "id": 696,
    "question": "Which network connectivity device does not forward broadcast messages, thereby creating multiple broadcast domains?",
    "choice_a": "Hub",
    "choice_b": "Switch",
    "choice_c": "Bridge",
    "choice_d": "Router",
    "correct_answer": "D",
    "explanation": "One of the key features of routers is that they break up broadcast domains. Broadcast traffic from one port of the router will not get passed to the other ports, which greatly reduces network traffic. Bridges, hubs, and switches will all forward broadcast packets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      125,
      106,
      99,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 697,
    "question": "What type of address does a router use to get data to its destination?",
    "choice_a": "IP",
    "choice_b": "MAC",
    "choice_c": "Memory",
    "choice_d": "Loopback",
    "correct_answer": "A",
    "explanation": "Routers are Open Systems Interconnection (OSI) model layer 3 (Network layer) devices. They keep a chart containing the IP address of the device connected to each port, whether that device is a computer or another router\u2019s external address. A Media Access Control (MAC) address is the address of a Network Interface Card (NIC). Memory addresses identify where information is stored, and a loopback address is used to test Transmission Control Protocol/Internet Protocol (TCP/IP) on the local host. The loopback address for IPv4 is 127.0.0.1, and for IPv6 it is::1.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      106,
      114,
      118,
      122,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 698,
    "question": "You have a desktop computer that is behaving erratically on the network. The wired connection will often disconnect without warning. Which tool should you use to troubleshoot the network adapter?",
    "choice_a": "Multimeter",
    "choice_b": "Tone generator and probe",
    "choice_c": "Loopback plug",
    "choice_d": "Cable tester",
    "correct_answer": "C",
    "explanation": "A loopback plug is for testing the ability of a network adapter to send and receive. The plug gets plugged into the Network Interface Card (NIC), and then a loopback test is performed using troubleshooting software. You can then tell whether the card is working properly. Multimeters are used for testing power supplies and wall outlets, a tone generator and probe help the technician to find a specific wire, and a cable tester checks that anEthernet wire was configured correctly, and that it can make an end-to-end connection. If the NIC tests fine, the next step might be testing the cable.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      109,
      110,
      106,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 699,
    "question": "You are a network administrator. Currently, there is no wireless access to the business network, but the company is purchasing tablets and wireless printers so employees can work as they move around the facility. What name is given to the network created when you install a device to create network access for the wireless devices?",
    "choice_a": "WLAN",
    "choice_b": "Proxy",
    "choice_c": "WAP",
    "choice_d": "An NFC hub",
    "correct_answer": "A",
    "explanation": "A Wireless Local Area Network (WLAN) is created when a device, such as a Wireless Access Point (WAP), is installed to connect devices via radio waves instead of cables. A proxy is a device that sits between the user and a remote host (usually the Internet). The proxy can filter traffic and provide load balancing. A Near-Field Communication (NFC) hub isn\u2019t an actual term, although NFC capabilities may be part of devices such as a home automation hub.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      102,
      99,
      107,
      152,
      154
    ],
    "source": "9781394330348"
  },
  {
    "id": 700,
    "question": "You want to ensure that client computers can download email from external email servers regardless of the protocol their email client uses. Which ports do you open on the firewall to enable this? (Choose two.)",
    "choice_a": "23",
    "choice_b": "25",
    "choice_c": "110",
    "choice_d": "143",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Simple Mail Transfer Protocol (SMTP, port 25), Post Office Protocol 3 (POP3, port 110), and Internet Message Access Protocol (IMAP, port 143) are all email protocols. SMTP is for sending email. POP3 and IMAP are for downloading (i.e., receiving) email. Port 23 is used by Telnet. Choice B is incorrect because the question specifically asks about downloading (not sending) email, and yes, some of the CompTIA questions are this particular.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      120,
      128,
      155,
      106,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 701,
    "question": "You manage a network consisting of 500 nodes. Manually configuring the IP addresses of these computers and devices by yourself would be a daunting task. What can you do instead?",
    "choice_a": "Ask the human resources department to hire help.",
    "choice_b": "Keep detailed records and configure them yourself.",
    "choice_c": "Assign static IP addresses.",
    "choice_d": "Assign dynamic IP addresses.",
    "correct_answer": "D",
    "explanation": "Dynamic IP addressing makes the work of configuring computers on a network much easier. With dynamic IP addressing, the IP addresses are assigned by a Dynamic Host Configuration Protocol (DHCP) server. IP address assignments may change as computers are added to and removed from the network, or even when one hasn\u2019t been turned on in some time based on the IP address lease duration. A single IT technician may be responsible for keeping hundreds of PCs working. You should always keep detailed records of any computers that have been assigned static IP addresses and ensure that they are not in the address pool to be assigned.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      122,
      128,
      103
    ],
    "source": "9781394330348"
  },
  {
    "id": 702,
    "question": "Which networking device is capable of reading IP addresses and forwarding packets based on the destination IP address?",
    "choice_a": "Hub",
    "choice_b": "Switch",
    "choice_c": "NIC",
    "choice_d": "Router",
    "correct_answer": "D",
    "explanation": "Routers operate at the Network layer (Layer 3) of the Open Systems Interconnection (OSI) model. Because of this, they make their decisions on what to do with traffic based on logical addresses, such as an Internet Protocol (IP) address. Switches use Media Access Control (MAC) addresses and are OSI Layer 2 devices. Hubs and Network Interface Cards (NICs) operate primarily at the Physical layer (Layer 1). They are largely unaware of addresses when sending packets.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      114,
      106,
      117,
      108,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 703,
    "question": "Which network device is designed to be a security guard, blocking malicious data from entering your network?",
    "choice_a": "PoE injector",
    "choice_b": "EoP device",
    "choice_c": "Firewall",
    "choice_d": "Router",
    "correct_answer": "C",
    "explanation": "A firewall is a hardware or software solution that serves as your network\u2019s security guard. Firewalls can protect you in two ways: they protect your network resources from hackers lurking in the dark corners of the Internet, and they can simultaneously prevent computers on your network from accessing undesirable content on the Internet or sending out data that they shouldn\u2019t. PoE stands for Power over Ethernet, while EoP stands for Ethernet over Power. Neither has to do with protection. While a router may incorporate a firewall, it is not, by itself, a firewall. Routers are responsible for communications with other networks or broadcast domains. A firewall may be a discrete physical network appliance or software incorporated into another device like a router.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      155,
      137,
      114,
      135,
      125
    ],
    "source": "9781394330348"
  },
  {
    "id": 704,
    "question": "You are manually configuring TCP/IP hosts on the network. Which configuration parameter specifies the internal address of the router that enables Internet access?",
    "choice_a": "Subnet mask",
    "choice_b": "DHCP server",
    "choice_c": "DNS server",
    "choice_d": "Gateway",
    "correct_answer": "D",
    "explanation": "The default gateway is the address to the network\u2019s router on the Local Area Network (LAN) side of the router. The router enables the host to communicate with hosts that are not on the local network. The default gateway is also called the router\u2019s internal address. Theipconfig /allcommand can be used to see the default gateway address that the local computer is currently configured to use. The router will also have an external address, whichis used to communicate with networks outside the LAN. Virtually all modern routers use a process called Network Address Translation (NAT), which will substitute the router\u2019s external address for a host\u2019s IP address when requesting information from a remote network. The router knows which host requested the information and will pass it on to the correct host when it is received. This is one of the ways that the router protects the local hosts from the outside world.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      114,
      155,
      130,
      122
    ],
    "source": "9781394330348"
  },
  {
    "id": 705,
    "question": "Which of the following devices will be found in a telecommunications room and provides a means to congregate horizontal wiring, terminating each run in a female port?",
    "choice_a": "Patch panel",
    "choice_b": "Multiplexer",
    "choice_c": "Rack U",
    "choice_d": "Demarcation point",
    "correct_answer": "A",
    "explanation": "A patch panel can be found in a telecommunications room (also called a wiring closet), and it is usually mounted in a networking rack. On the back are connections into which a technician will \u201cpunch down\u201d wires. On the front is a female port, usually an RJ-45 type. A multiplexer is a device that aggregates several connections into one. A rack U is simply a measurement of the height of a device mounted into a rack (i.e., my patch panel is 4U). Each U is equal to 1.75 inches. The demarcation point is where responsibility for a network changes from the ISP to its customer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      114,
      105,
      108,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 706,
    "question": "What type of network is most commonly associated with Bluetooth devices, such as wireless keyboards, mice, and headphones, and covers a small area?",
    "choice_a": "LAN",
    "choice_b": "WAN",
    "choice_c": "PAN",
    "choice_d": "MAN",
    "correct_answer": "C",
    "explanation": "A Personal Area Network (PAN) is a small-scale network designed around one person within a limited boundary area. The term generally refers to networks that use Bluetooth technology. A Local Area Network (LAN) covers a larger area, such as a house or perhaps one floor of a building, and likely uses the Ethernet protocol. A Metropolitan Area Network (MAN) covers a larger area, such as a city or university campus; and a Wide Area Network (WAN) covers a very large geographic area, such as one connecting distant cities or different countries.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      99,
      145,
      102,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 707,
    "question": "When troubleshooting a network connectivity issue, you discover that the local computer has an IPv4 address of 169.254.2.2. What do you immediately know about this local computer? (Choose two.)",
    "choice_a": "It is using an APIPA address.",
    "choice_b": "It can\u2019t find a DHCP server.",
    "choice_c": "It isn\u2019t on the network.",
    "choice_d": "It has an invalid IP address.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The 169.254.0.0/16 range in IPv4 is the Automatic Private IP Addressing (APIPA) range. APIPA comes into play when the host is unable to locate a Dynamic Host Configuration Protocol (DHCP) server, and the network connection is configured to acquire an IP address dynamically. Because the computer is unable to get a dynamic IP address from the DHCP server, the operating system automatically assigns a random IP address in the APIPA range.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      124,
      122,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 708,
    "question": "Which of the following IPv6 addresses is automatically assigned by the host when it boots and is only usable on the broadcast domain in which it exists?",
    "choice_a": "2000::/3",
    "choice_b": "FC00::/7",
    "choice_c": "FE80::/10",
    "choice_d": "FF00::/8",
    "correct_answer": "C",
    "explanation": "An IPv6 address in the FE80::/10 range is called a link-local address and is similar to an IPv4 Automatic Private IP Addressing (APIPA) address. (The 169.254.0.0/16 range in IPv4 is the APIPA range, used for automatic configuration if the host can\u2019t locate a Dynamic Host Configuration Protocol [DHCP] server.) Link-local addresses are generated by the PC when it boots up. Packets using a link-local address cannot be forwarded by a router.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      121,
      124,
      130,
      118,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 709,
    "question": "You need to configure a wireless router for an office network. The office manager wants new devices to be able to automatically join the network and announce their presence to other networked devices. Which service should you enable to allow for this?",
    "choice_a": "DHCP",
    "choice_b": "NAT",
    "choice_c": "QoS",
    "choice_d": "UPnP",
    "correct_answer": "D",
    "explanation": "Universal Plug and Play (UPnP) is a standard designed to simplify the process of connecting devices to a network and to enable those devices to automatically announce their presence to other devices on the network. In a truly secure environment, UPnP would be disabled, but it is often left enabled on home networks. Although not listed as an objective, it is in the Acronym list for the CompTIA A+ exam. Dynamic Host Configuration Protocol (DHCP) automatically assigns an IP address to a device when it is powered on, attached to a network, and configured to obtain an address dynamically. Network Address Translation (NAT) is a feature of routers used to hide the IP addresses of computers on the local network side of the router from the other networks and computers on the outside of the network. Quality of Service (QoS) can be configured to give desired devices preference over others for using network bandwidth.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      155,
      130,
      114,
      121,
      156
    ],
    "source": "9781394330348"
  },
  {
    "id": 710,
    "question": "You are troubleshooting a computer with only one IPv6 address, which is in the FE80::/10 range. Which of the following statements are true? (Choose two.)",
    "choice_a": "The computer will not be able to get on the Internet using that IP address.",
    "choice_b": "The computer will be able to get on the Internet using that IP address.",
    "choice_c": "The computer is configured with a link-local unicast address.",
    "choice_d": "The computer is configured with a global unicast address.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Addresses in the FE80::/10 range are link-local unicast addresses. A link-local address is assigned to each IPv6 interface but is not routable on the Internet. If this is the only address the host has, it will not be able to get on the Internet.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      122,
      123,
      124,
      118,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 711,
    "question": "You have set up your web server to function as an FTP server as well. Users on the Internet complain that they are not able to access the server using FTP clients. What port should they be trying to access the server on?",
    "choice_a": "21",
    "choice_b": "22",
    "choice_c": "23",
    "choice_d": "80",
    "correct_answer": "A",
    "explanation": "The File Transfer Protocol (FTP) is optimized for downloading files from servers. It uses port 21. Secure Shell (SSH) uses port 22, Telnet uses port 23, and Hypertext Transfer Protocol (HTTP) uses port 80.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      117,
      155,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 712,
    "question": "Which TCP/IP protocol enables you to access data such as employee phone numbers and email addresses that are stored within an information directory?",
    "choice_a": "SNMP",
    "choice_b": "SMTP",
    "choice_c": "CIFS",
    "choice_d": "LDAP",
    "correct_answer": "D",
    "explanation": "The Lightweight Directory Access Protocol (LDAP) is a directory services protocol based on the X.500 standard. LDAP is designed to access information stored in an information directory typically known as an LDAP directory or LDAP database. This often includes employee phone numbers and email addresses. Simple Network Management Protocol (SNMP) is used in network monitoring, Simple Mail Transfer Protocol (SMTP) is used in sending email, and Common Internet File System (CIFS) is a file system for providing shared access between diverse clients.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      131,
      129,
      114
    ],
    "source": "9781394330348"
  },
  {
    "id": 713,
    "question": "What port is associated with the LDAP protocol?",
    "choice_a": "22",
    "choice_b": "139",
    "choice_c": "389",
    "choice_d": "3389",
    "correct_answer": "C",
    "explanation": "Lightweight Directory Access Protocol (LDAP) is designed to access information stored in an information directory typically known as an LDAP directory or LDAP database. LDAP uses port 389. Port 22 is used by Secure Shell (SSH), 139 is used by NetBIOS, and 3389 is used by Remote Desktop Protocol (RDP).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      120,
      121,
      119,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 714,
    "question": "You are configuring network hosts with static IP addresses. You have chosen to use a class B network address. What is the default subnet mask that you should configure on the hosts?",
    "choice_a": "255.0.0.0",
    "choice_b": "255.255.0.0",
    "choice_c": "255.255.255.0",
    "choice_d": "255.255.255.255",
    "correct_answer": "B",
    "explanation": "The default subnet mask for class B networks is 255.255.0.0, or written in shorthand, /16. The default subnet mask for class A networks is 255.0.0.0, or written in shorthand /8, and for class C it is 255.255.255.0, or written in shorthand /24. 255.255.255.255 is an IPv4 broadcast address. As a subnet mask, it is represented as a /32 (in shorthand) in the Classless Inter-Domain Routing (CIDR) notation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      123,
      122,
      124,
      121,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 715,
    "question": "You are installing a new network and working in a telecommunications room. You need to attach several network cables to a 110 block. Which tool should you use to perform this task?",
    "choice_a": "Crimper",
    "choice_b": "Cable stripper",
    "choice_c": "Cable tester",
    "choice_d": "Punchdown tool",
    "correct_answer": "D",
    "explanation": "If you\u2019re working on a larger network installation, you might use a punchdown tool. It\u2019s not a testing tool, but one that enables you to connect (i.e., punch down) the exposed ends of a twisted pair wire into wiring harnesses, such as a 110 block or patch panel. A crimper is used to connect wires to an RJ-45 connector, a cable striper removes the outer cover from wires, and a cable tester is used to verify the integrity of a cable.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      116,
      111,
      113,
      146
    ],
    "source": "9781394330348"
  },
  {
    "id": 716,
    "question": "Which of the following Internet connection types offers the fastest download speeds?",
    "choice_a": "Cable",
    "choice_b": "DSL",
    "choice_c": "Fiber-optic",
    "choice_d": "Satellite",
    "correct_answer": "C",
    "explanation": "Fiber-optic broadband Internet offers fast speeds (often in the 1\u20132 Gbps range) but is also the most expensive. Cable may have download speeds up to 1 Gbps (typically 10 to 500 Mbps), but upload speeds are typically only around 5 to 50 Mbps, while fiber-optic upload speeds may be in the 1 Gbps range. Digital Subscriber lines (DSL) use Plain Old Telephone Service (POTS) lines and are slow. Satellite networks can be faster than DSL, but they still only offer speeds up to about 150 Mbps. (Yes, POTS is an actual technical term.).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      148,
      147,
      150,
      151
    ],
    "source": "9781394330348"
  },
  {
    "id": 717,
    "question": "Which of the following are public IPv4 addresses? (Choose two.)",
    "choice_a": "69.252.80.71",
    "choice_b": "144.160.155.40",
    "choice_c": "172.20.10.11",
    "choice_d": "169.254.1.100",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "69.252.80.71 and 144.160.155.40 are both routable numbers, and therefore, public. IPv4 specifies private (non-routable) IP address ranges for each class as follows: Class A: 10.0.0.0 to 10.255.255.255, Class B: 172.16.0.0 to 172.31.255.255, and Class C: 192.168.0.0. to 192.168.255.255. Other non-routable numbers are 127.0.0.1, which is the loopback address; and 169.254.0.0 to 169.254.255.255, which is the Automatic Private IP Addressing (APIPA) range. Class A addresses have a first octet from 0 to 127. Class B\u2019s first octet ranges from 128 to 191. Class C\u2019s first octet ranges from 192 to 223. Numbers above Class C are reserved. You might find it helpful to put this information into a chart to study for the CompTIA A+ exam.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      124,
      123,
      122,
      118,
      155
    ],
    "source": "9781394330348"
  },
  {
    "id": 718,
    "question": "Which TCP/IP protocol uses port 445?",
    "choice_a": "FTP",
    "choice_b": "SSH",
    "choice_c": "SMB",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "Server Message Block (SMB) is a protocol used to provide shared access to files, printers, and other network resources. It originally ran on NetBIOS over User Datagram Protocol (UDP) using ports 137/138 and over Transmission Control Protocol (TCP) using ports 137 and 139, but it is now part of the Transmission Control Protocol/Internet Protocol (TCP/IP) stack and uses port 445. Running on NetBIOS enabled SMB to facilitate file sharing on a single network, while being part of TCP/IP enables it to facilitate file sharing across the Internet. By itself, SMB is not secure, so it needs other network appliances or software to secure the data being sent over its port(s). File Transfer Protocol (FTP) uses ports 20/21, Secure Shell (SSH) uses port 22, and Simple Network Management Protocol (SNMP) uses port 161/162.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      119,
      120,
      103,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 719,
    "question": "What rendition of SMB was used by Windows servers and NAS servers but is no longer often used?",
    "choice_a": "CIFS",
    "choice_b": "Samba",
    "choice_c": "NFS",
    "choice_d": "SMB3",
    "correct_answer": "A",
    "explanation": "All the answer choices are communications protocols for sharing resources. The Common Internet File System (CIFS) is Microsoft\u2019s version of Server Message Block (SMB). Once upon a time, CIFS was used extensively for file sharing over a network, but it has since fallen out of favor. While CIFS and SMB both facilitate file sharing, SMB does it better and has other features as well. Samba and Network File System (NFS) facilitate sharing files between clients and servers in Linux distributions. Samba allows mixed environments with both Windows and Linux machines to share files. NFS does not.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      215,
      117,
      98,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 720,
    "question": "For IPv6, which of the following statements are true? (Choose two.)",
    "choice_a": "Each IPv6 interface can have only one address.",
    "choice_b": "Each IPv6 interface is required to have a link-local address.",
    "choice_c": "IPv6 addresses are incompatible with IPv4 networks.",
    "choice_d": "IPv6 does not use broadcasts.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Each IPv6 interface can, and often does, have multiple addresses assigned to it. IPv6 is backward compatible with IPv4, by using tunneling, dual stack, or translation. IPv6 uses multicast addresses in place of broadcast addresses, and a link-local address is established either automatically when a computer boots up or by manually configuring it, but either way the link-local address must be present.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      123,
      118,
      121,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 721,
    "question": "In a DNS system, what type of record is used to resolve the domain name to IPv4 addresses?",
    "choice_a": "An A address",
    "choice_b": "An AAAA address",
    "choice_c": "A MAC address",
    "choice_d": "An MX address",
    "correct_answer": "A",
    "explanation": "The Domain Name System (DNS) uses two types of records to resolve domain names to IP addresses. Type A records resolve the domain name to IPv4 addresses. Type AAAA records resolve domain names to IPv6 addresses. A Media Access Control (MAC) address is the physical address assigned to a Network Interface Card (NIC). An Mail Exchange (MX) address is used to specify multiple mail servers for load-balancing purposes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      121,
      122,
      118,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 722,
    "question": "What type of entry in DNS can be used to store bits of information like a verification line for the domain or information on updates?",
    "choice_a": "A",
    "choice_b": "TXT",
    "choice_c": "CNAME",
    "choice_d": "MX",
    "correct_answer": "B",
    "explanation": "The Domain Name System (DNS) can use an entry in the TXT field to store bits of information for various purposes. A records are used for IPv4 address resolution, and AAAA records are for IPv6 resolution. The canonical name (CNAME) record is used as an alias so that when one domain name is entered, the record points to a different domain. It\u2019s often used for subdomains or when a domain name has migrated to a new domain, effectively sending multiple domain names to the same IP address. Mail Exchange (MX) records identify multiple email servers to use for load balancing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      121,
      128,
      120,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 723,
    "question": "Which of the following IPv6 addresses is equivalent to 127.0.0.1 in IPv4?",
    "choice_a": "::0",
    "choice_b": "::1",
    "choice_c": "::127",
    "choice_d": "2000::/3",
    "correct_answer": "B",
    "explanation": "127.0.0.1 is the IPv4 loopback address, and it is used to ping the local network interface. The IPv6 equivalent is::1.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      123,
      118,
      121,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 724,
    "question": "You are asked to perform consulting work for a medium-sized company that is having network connectivity issues. When you examine the patch panel, you notice that none of the dozens of UTP cables are labeled. Which tool can you use to identify which cable goes to which workstation?",
    "choice_a": "Cable tester",
    "choice_b": "Loopback plug",
    "choice_c": "Punchdown tool",
    "choice_d": "Toner probe",
    "correct_answer": "D",
    "explanation": "If you need to trace a wire in a wall from one location to another, a tone generator and probe (also called a toner probe) is the right tool to use. It consists of two pieces: a tone generator and a probe. To use it, attach one end to one end of the cable, such as the end at the computer. Then, go to the patch panel with the other end of the probe to locate the cable. These tools are lifesavers when the cables are not properly labeled. A cable tester is used to confirm the integrity of a cable and verify that it is wired correctly. A loopback plug is usedto test a Network Interface Card (NIC), and a punchdown tool is used to terminate wires into a patch panel.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      116,
      111,
      146,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 725,
    "question": "Which TCP/IP protocol is responsible for dynamically assigning IP addresses to client computers?",
    "choice_a": "DNS",
    "choice_b": "DHCP",
    "choice_c": "RDP",
    "choice_d": "LDAP",
    "correct_answer": "B",
    "explanation": "Dynamic Host Configuration Protocol (DHCP) dynamically assigns IP addresses and other IP configuration information to network clients. The Domain Name System (DNS) translates human-readable names to their associated IP addresses; Remote Desktop Protocol (RDP) enables a user to access a computer remotely as if they were sitting at the target computer; and Lightweight Directory Access Protocol (LDAP) is used for retrieving information from a database.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      128,
      118,
      119
    ],
    "source": "9781394330348"
  },
  {
    "id": 726,
    "question": "Which networking device has multiple ports, each of which is its own collision domain, and uses the MAC address in the header of an incoming packet to determine which port the packet gets sent to?",
    "choice_a": "WAP",
    "choice_b": "Switch",
    "choice_c": "Bridge",
    "choice_d": "Router",
    "correct_answer": "B",
    "explanation": "Switches provide centralized connectivity for a Local Area Network (LAN). Switches examine the header of incoming packets and forward each only to the port whose associated Media Access Control (MAC) address matches the receiving MAC address in the header. A Wireless Access Point (WAP) is used to connect a wireless network to a wired one. Bridges are used to connect different networks to work as one, and routers are used to forward packets from one network to others.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      108,
      107,
      106,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 727,
    "question": "Which TCP/IP port will an email client use to push email to its email server?",
    "choice_a": "23",
    "choice_b": "25",
    "choice_c": "110",
    "choice_d": "143",
    "correct_answer": "B",
    "explanation": "Email is pushed from clients to servers using the Simple Mail Transfer Protocol (SMTP). SMTP uses port 25. When trying to remember if SMTP is sending or receiving email, think S for Send. Port 23 is used by Telnet, now considered insecure and obsolete. (Depreciated.) Port 110 is used by Post Office Protocol 3 (POP3), and port 143 is used by Internet Mail Access Protocol (IMAP), both of which are used to retrieve email.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      119,
      106,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 728,
    "question": "A technician is going to set up a Wi-Fi network using a standard omnidirectional antenna. Because of the building configuration, transmitting signals for the greatest distance is the technician\u2019s primary criterion. Which standard should they choose?",
    "choice_a": "802.11a",
    "choice_b": "802.11g",
    "choice_c": "802.11n",
    "choice_d": "802.11ac",
    "correct_answer": "C",
    "explanation": "Of the Wi-Fi standards listed, 802.11n has the longest range by default, at roughly 70 meters indoors and 250 meters outdoors. 802.11ac is newer and faster than 802.11n, but it transmits exclusively in the 5 GHz range, which restricts its functional distance to roughly 35 meters indoors, depending on the devices being used. 802.11a, which is legacy and uses the 5 GHz frequency range, could only send a signal about 30 meters; and 802.11g, which is also legacy but uses the 2.4 GHz frequency range, could only send a signal about 50 meters.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      138,
      142,
      139,
      143
    ],
    "source": "9781394330348"
  },
  {
    "id": 729,
    "question": "You are troubleshooting an intermittently failing Cat 6 network connection. You suspect that there is a short in the connection. Which tool can you use to determine this?",
    "choice_a": "Toner probe",
    "choice_b": "Loopback plug",
    "choice_c": "Cable tester",
    "choice_d": "Crimper",
    "correct_answer": "C",
    "explanation": "A cable tester typically uses lights to indicate that the cable is working correctly, and if there is a short, then the indicators for two wires would light up at the same time. Cable testers can range from basic ones, which cost only a few dollars, to very sophisticated ones that cost hundreds of dollars. Some of the better ones can tell you how many feet from you the problem in the cable occurs. A tone generator and probe are used to trace a wire or find a specific wire from a group; a loopback plug is used to test a Network Interface Card (NIC); and a crimper attaches a network wire to its terminator, usually an RJ-45 plug.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      111,
      112,
      108,
      116,
      109
    ],
    "source": "9781394330348"
  },
  {
    "id": 730,
    "question": "What marks the boundary of an IPv4 broadcast domain?",
    "choice_a": "Ethernet extender",
    "choice_b": "Switch",
    "choice_c": "Router",
    "choice_d": "Modem",
    "correct_answer": "C",
    "explanation": "A router will not forward any broadcast packet; therefore, a router is the boundary of an IPv4 broadcast domain. An Ethernet extender is a device that regenerates the signal on an Ethernet cable, enabling the user to extend the network beyond 100 meters. Switches will send broadcast packets out of every port, but otherwise will send packets to a specific port based on the Media Access Control (MAC) address. A modem (modulator/demodulator) converts signals from one type to another, such as from an analog signal to a digital one.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      125,
      106,
      122,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 731,
    "question": "Which DNS feature uses public and private keys to verify that an email originated from where it claims?",
    "choice_a": "DKIM",
    "choice_b": "SPF",
    "choice_c": "DMARC",
    "choice_d": "AAAA",
    "correct_answer": "A",
    "explanation": "Domain Keys Identified Mail (DKIM) is a method of authentication that uses public and private keys and the information to verify that the user sending an email did indeed send it from where they claim to have, and that it hasn\u2019t been tampered with along the way. It helpsprevent spoofing of an email address. Sender Policy Framework (SPF) is also a technique to prevent email address spoofing. It is done using a TXT entry in a domain\u2019s Domain Name System (DNS) service. Domain-based Message Authentication, Reporting, and Conformance (DMARC) uses SPF or DKIM, and in addition requires that the sender\u2019s domain is the same as the DNS domain name. Domain administrators can specify to quarantine or reject emails that fail DMARC. To use DMARC, a DMARC record must exist in the DNS. An AAAA entry is used to resolve IPv6 addresses to domain names.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      121,
      120,
      131,
      128
    ],
    "source": "9781394330348"
  },
  {
    "id": 732,
    "question": "Which Internet connection type, once popular for home use, offers asymmetrical download and upload speeds and is implemented over common phone lines?",
    "choice_a": "POTS",
    "choice_b": "Cable",
    "choice_c": "DSL",
    "choice_d": "ISDN",
    "correct_answer": "C",
    "explanation": "Although Digital Subscriber Line (DSL) is being dropped by some providers in favor of fiber-optic lines, it is still a viable Internet connectivity solution in rural areas where fiber has not yet reached. DSL utilizes existing phone lines and provides fairly reliable access while carrying voice and data on the same lines. Most DSL subscriptions are asymmetrical, meaning they offer faster download speeds than upload speeds. POTS stands for Plain Old Telephone Service, an acronym from the dial-up days. Cable connectivity is provided by cable TV companies. ISDN is Integrated Services Digital Network, a now obsolete technology that enabled voice and data communication on the same existing telephone lines, similar to DSL.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      147,
      148,
      150,
      151,
      112
    ],
    "source": "9781394330348"
  },
  {
    "id": 733,
    "question": "You are installing an 802.11n Wi-Fi network with five wireless access points. The access points are placed so their ranges overlap. To avoid communications issues, which principle should you follow when configuring them?",
    "choice_a": "Configure all access points to use the same channel.",
    "choice_b": "Configure all access points to use adjacent channels.",
    "choice_c": "Configure all access points to use nonoverlapping channels.",
    "choice_d": "Channel configuration will not cause communications issues.",
    "correct_answer": "C",
    "explanation": "When setting up multiple wireless access points, it\u2019s good practice to have theirrangesoverlap to ensure that there is no loss of communication when roaming in the network\u2019s area. However, to avoid problems, it\u2019s best to set up the access points with nonoverlappingchannels. This way, the overlapping ranges ensure continuous signal coverage, while the nonoverlapping channels avoid interference from one WAP to another in the overlapping areas.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      154,
      139,
      138,
      141,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 734,
    "question": "You need to configure email settings for use with IMAP. Which port will you be configuring?",
    "choice_a": "25",
    "choice_b": "80",
    "choice_c": "110",
    "choice_d": "143",
    "correct_answer": "D",
    "explanation": "Internet Mail Access Protocol (IMAP) is used to download mail via port 143. Port 80 is for unsecured web page traffic. Ports 25 and 110 are email ports, but they are associated with Simple Mail Transfer Protocol (SMTP) and Post Office Protocol 3 (POP3), respectively.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      121,
      119,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 735,
    "question": "Which of the following technologies will enable you to install networking devices that need power to function, in a location that has no power outlets?",
    "choice_a": "EoP",
    "choice_b": "PoE",
    "choice_c": "WAP",
    "choice_d": "Hub",
    "correct_answer": "B",
    "explanation": "Power over Ethernet (PoE) enables placement of equipment in areas that otherwise would not be able to accept it. Only four of the eight wires in twisted pair wiring (pins 1, 2, 3, and 6) are used for communication. The power is sent over the wires that are not used in communication. If the devices on both ends don\u2019t support PoE, then an injector can be used to add power to the line on the way to its destination. Compatibility is important, and there are limits to the amount of power that can be transmitted this way. Ethernet over Power (EoP) is not in the CompTIA A+ objectives, but it uses special devices to send Ethernet communications over existing wiring, such as in a historical building where running new network wires may be impractical or impossible. A Wireless Access Point (WAP) is a device used to connect wireless devices to a wired network or to each other. Some WAPs support PoE. A hub is a very simple network connectivity device.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      114,
      112,
      107,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 736,
    "question": "You have been asked to install a Wi-Fi network in a building approximately 100 meters long and 25 meters wide. Because of cost considerations, you will be using 802.11ac. At a minimum, how many wireless access points will you need?",
    "choice_a": "Two",
    "choice_b": "Three",
    "choice_c": "Four",
    "choice_d": "Six",
    "correct_answer": "B",
    "explanation": "The 802.11ac standard has an indoor range of approximately 35 meters. At a minimum, you will need three access points. Depending on coverage and indoor interference, such as thick walls, you might need more, though.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      142,
      138,
      154,
      139,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 737,
    "question": "What two tools do you need to connect an RJ-45 connector to an appropriate cable? (Choose two.)",
    "choice_a": "Punchdown tool",
    "choice_b": "Network tap",
    "choice_c": "Crimper",
    "choice_d": "Cable stripper",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The crimper and cable stripper are both needed to add an RJ-45 connector to the end of a twisted pair cable. Often, both tools are included in one. The cable stripper removes the outer insulation from the group of wires, so they can be individually inserted into the RJ-45 jack. Once properly inserted, the crimping tool is used to force metal teeth into each wire, so an electrical connection can be made.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      111,
      116,
      108,
      146
    ],
    "source": "9781394330348"
  },
  {
    "id": 738,
    "question": "What feature of DNS requires that a sender\u2019s email be from the same domain as the DNS domain and can be set to reject any email that isn\u2019t?",
    "choice_a": "DKIM",
    "choice_b": "SPF",
    "choice_c": "DMARC",
    "choice_d": "A",
    "correct_answer": "C",
    "explanation": "Domain-based Message Authentication, Reporting, and Conformance (DMARC) uses Sender Policy Framework (SPF) or Domain Keys Identified Mail (DKIM), and in addition requires that the sender\u2019s domain is the same as the Domain Name System (DNS) domain name. Domain administrators can specify to quarantine or reject emails that fail DMARC. To use DMARC, a DMARC record must exist in the DNS. DKIM is a method of authentication that uses public and private keys and the information to verify that the user sending an email did indeed send it from where they claim to have, and that it hasn\u2019t been tampered with along the way. It helps prevent email address spoofing. SPF is also a technique to prevent email address spoofing. It is done using a TXT entry in a domain\u2019s DNS service. An A entry is used to resolve IPv4 addresses to domain names.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      129,
      120,
      131,
      128
    ],
    "source": "9781394330348"
  },
  {
    "id": 739,
    "question": "You need to install a wireless access point in a drop ceiling where there is no access to a power source. Which technology will enable you to get power to that device?",
    "choice_a": "EoP",
    "choice_b": "PoE",
    "choice_c": "Hub",
    "choice_d": "Repeater/extender",
    "correct_answer": "B",
    "explanation": "Power over Ethernet (PoE) enables you to power an Ethernet device (such as a switch) through one of the Ethernet ports. For it to work, the access point and the device it plugs into both need to support PoE. Further, the access point and device need to be compatible. Ethernet over Power (EoP), while not on the current A+ objectives, is a technology that enables the user to transmit Ethernet signals over existing power lines. This can be useful in a place where running Ethernet wires is impossible, but more often Wi-Fi is used in those situations instead. A hub can be used to regenerate a signal, but it also needs a power source and is not a Wireless Access Point (WAP). A repeater/extender is essentially the same as a hub. It requires power to regenerate a signal and send it on its way.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      102,
      154,
      107,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 740,
    "question": "Which of the following IP addresses is not a private address and therefore is routable on the Internet?",
    "choice_a": "10.1.2.3",
    "choice_b": "172.18.31.54",
    "choice_c": "172.168.38.155",
    "choice_d": "192.168.38.155",
    "correct_answer": "C",
    "explanation": "The private IP address ranges are 10.0.0.0 to 10.255.255.254, 172.16.0.0 to 172.16.32.254, and 192.168.0.0 to 192.168.255.254. The address 172.168.38.155 is outside the private IP address range and is a public (routable) address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      122,
      123,
      155,
      121
    ],
    "source": "9781394330348"
  },
  {
    "id": 741,
    "question": "You have two servers and a printer, which you want to use IP addresses that are in the beginning of your IP address range. What do you need to configure in the DHCP server?",
    "choice_a": "Leases",
    "choice_b": "Scope",
    "choice_c": "Reservations",
    "choice_d": "Exclusions",
    "correct_answer": "D",
    "explanation": "An exclusion prevents the Dynamic Host Configuration Protocol (DHCP) server from assigning IP addresses that are included in the exclusion range. This differs from a reservation, in that a reservation assigns a specific IP address to a specific Media Access Control (MAC) address. A lease is the period of time that an IP address is assigned to a node, and the scope is the range of IP addresses that can be assigned by a DHCP server. Each of these four options is part of preventing duplicate IP addresses on a network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      128,
      122,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 742,
    "question": "If you are connecting to a website that encrypts its connection using TLS, on what port does that traffic travel?",
    "choice_a": "21",
    "choice_b": "80",
    "choice_c": "143",
    "choice_d": "443",
    "correct_answer": "D",
    "explanation": "To encrypt traffic between a web server and client securely, Hypertext Transfer Protocol Secure (HTTPS) can be used. HTTPS connections are secured using either Secure Sockets Layer (SSL) or Transport Layer Security (TLS). HTTPS uses port 443. Port 21 is used by File Transfer Protocol (FTP), port 80 is used by Hypertext Transfer Protocol (HTTP), and port 143 is used by Internet Mail Access Protocol (IMAP).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      120,
      128,
      126,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 743,
    "question": "Your network is currently running a mix of 802.11b and 802.11g devices. At the end of the year, you have remaining budget funds to upgrade some, but not all, of the wireless infrastructure. You want to upgrade to the newest technology possible but still maintain backward compatibility. Which standard should you choose?",
    "choice_a": "802.11g",
    "choice_b": "802.11ac",
    "choice_c": "802.11ax",
    "choice_d": "802.11be",
    "correct_answer": "D",
    "explanation": "802.11b/g transmit in the 2.4 GHz frequency, as does 802.11n, so they are compatible. The newer 802.11ac is a 5 GHz standard, and therefore, is not backward compatible with 802.11b/g. 802.11ax transmits in both the 2.4 GHz and 5 GHz frequencies, up to 7 GHz. 802.11be is the newest of these standards and is backward compatible. However, be aware that using the older standards with newer ones may degrade the network speed.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      141,
      138,
      142,
      107,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 744,
    "question": "What type of network spans multiple buildings or offices, possibly even crossing roads, but is confined to a relatively small geographical area?",
    "choice_a": "LAN",
    "choice_b": "WAN",
    "choice_c": "PAN",
    "choice_d": "MAN",
    "correct_answer": "D",
    "explanation": "Networks that are larger than a Local Area Network (LAN) but confined to a relatively small geographical area are Metropolitan Area Networks (MANs). A MAN is generallydefined as a network that spans a city or a large campus. A Personal Area Network (PAN) is the smallest type of network, and a Wide Area Network (WAN) is the largest type of network. A WAN can connect far away cities or even other countries.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      99,
      101,
      100,
      98,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 745,
    "question": "Which of the following shorthand notations corresponds to the CIDR subnet mask 255.255.224.0?",
    "choice_a": "/19",
    "choice_b": "/20",
    "choice_c": "/21",
    "choice_d": "/22",
    "correct_answer": "A",
    "explanation": "A subnet mask of 255.255.224.0 has eight bits in each of the first two octets set to on, and it has three bits in the third octet on. Therefore, it corresponds to /19 in Classless Inter-Domain Routing (CIDR) shorthand. In the binary number system (base two), each bit has two possible values: 0 or 1. Each bit in an octet, going from right to left, increments by an exponent of two, making the bits of the octets worth the decimal values as follows: | 128 |64 |32 |16 | 8 | 4 | 2 | 1 |. Bits for the subnet mask are always used from left to right, so one bit is equal to a decimal value of 128. Two bits is equal to a decimal value of 192 (128 + 64). Three bits is equal to a decimal value of 224 (128 + 64 + 32), and so on. When all eight bits of the octet are used for the subnet mask, the equivalent decimal value is 255. For this example, the first two octets (eight bits each) are completely on, and in the third octet, only three bits are on, making a total of 19 bits in the subnet mask turned on to indicate the network number (8 + 8 + 3 = 19).",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      122,
      123,
      124,
      125,
      130
    ],
    "source": "9781394330348"
  },
  {
    "id": 746,
    "question": "You are configuring hosts on a network running IPv4. Which elements are required for the computer to connect to the network?",
    "choice_a": "IP address",
    "choice_b": "IP address and subnet mask",
    "choice_c": "IP address, subnet mask, and default gateway",
    "choice_d": "IP address, subnet mask, default gateway, and DNS server address",
    "correct_answer": "B",
    "explanation": "To communicate on an IPv4 network, a host must be configured with a valid IP address and a subnet mask. A default gateway is needed only if the host is connecting to a remote network. Domain Name System (DNS) server settings are optional but useful, because they resolve hostnames to IP addresses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      124,
      121,
      130,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 747,
    "question": "You work at a tech support company, and a customer calls, reporting that they received an error\u2014something about a duplicate IP address. Why are they getting this message? (Choose two.)",
    "choice_a": "All hosts on a network must have a unique IP address.",
    "choice_b": "A PC is manually configured with an IP that is in the DHCP scope.",
    "choice_c": "A PC is manually configured with an IP that is not in the DHCP scope.",
    "choice_d": "None of the PCs have been manually configured.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "No two nodes on any network, whether IPv4 or IPv6, can have the same IP address, because the host portion (or interface ID) of the IP address is what identifies the individual computer on the network. If any of the machines on the network have been manually configured, which is generally done with servers, and the remainder of the computers are configured to use Dynamic Host Configuration Protocol (DHCP), you will need to ensure that the manually configured numbers are outside of the DHCP scope (the numbers the DHCP server will automatically assign) but within the bounds of the network. For example, in an IPv4 network, if the network number is 200.100.1.0, the router, which is also acting as a default gateway, might be assigned 200.100.1.1, and numbers from 200.100.1.2 through 200.100.1.20 could be reserved for static configuration on devices that need an IP address that does not change. The DHCP scope would need tonotinclude those numbers. If the network needed an available 180 IP addresses, then 200.100.1.21 to 200.100.1.200 could be safely assigned to the DHCP scope, avoiding any IP address duplication.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      122,
      121,
      123,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 748,
    "question": "You\u2019re setting up a network for a customer. The network uses a DHCP server, but the customer needs an IP address for their print server that does not change. What are two possible solutions? (Choose two.)",
    "choice_a": "Let the DHCP server assign a number, because once assigned, it will not change.",
    "choice_b": "Manually configure the print server to have a static IP address.",
    "choice_c": "Configure a reserved IP address on the DHCP server for the print server.",
    "choice_d": "Static and dynamic IP addresses can\u2019t exist on the same network. You\u2019ll have to manually configure everything.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Certain devices on a network, such as printers and servers, should have an IP address that doesn\u2019t change (static), so the other nodes on the network can always find the device. Answer A is incorrect, because if the Dynamic Host Configuration Protocol (DHCP) lease on the IP address expires, the print server would be assigned a different IP address the next time it logs in. A static IP could be configured on the printer server, or the IP address could be configured as reserved on the DHCP server for that print server. Either choice would work. Static and dynamic IP addresses almost always exist on the same network, because each is needed to have a network that runs smoothly.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      122,
      129,
      103
    ],
    "source": "9781394330348"
  },
  {
    "id": 749,
    "question": "Telnet is a depreciated protocol that enables remote viewing of a computer\u2019s desktop. What is Telnet\u2019s port number?",
    "choice_a": "20",
    "choice_b": "22",
    "choice_c": "23",
    "choice_d": "25",
    "correct_answer": "C",
    "explanation": "Telnet operates on port 23. Ports 20 and 21 are for File Transfer Protocol (FTP), port 22 is used by Secure Shell (SSH), and port 25 is used by Simple Mail Transfer Protocol (SMTP).",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      120,
      128,
      119,
      117,
      126
    ],
    "source": "9781394330348"
  },
  {
    "id": 750,
    "question": "Which port is used by the DNS protocol?",
    "choice_a": "53",
    "choice_b": "67/68",
    "choice_c": "110",
    "choice_d": "137",
    "correct_answer": "A",
    "explanation": "The Domain Name System (DNS) uses port 53 to communicate. Ports 67/68 are used by Dynamic Host Configuration Protocol (DHCP). Port 110 is used by Post Office Protocol 3 (POP3), and port 137 is used by Network Basic Input/Output System (NetBIOS).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      128,
      129,
      119,
      130
    ],
    "source": "9781394330348"
  },
  {
    "id": 751,
    "question": "Because of a recent security breach, your IT team shut down several ports on the external firewall. Now, users can\u2019t get to websites by using their URLs, but they can get there by using IP addresses. What port(s) does the IT team need to open back to enable Internet access via URLs?",
    "choice_a": "20/21",
    "choice_b": "53",
    "choice_c": "67/68",
    "choice_d": "80",
    "correct_answer": "B",
    "explanation": "Clients are unable to reach the Domain Name System (DNS) server, which resolves hostnames (or Uniform Resource Locators [URLs]) to IP addresses. DNS uses port 53. Ports 20 and 21 are used for File Transfer Protocol (FTP). Ports 67 and 68 are used by Dynamic Host Configuration Protocol (DHCP). Port 80 is used for Hypertext Transfer Protocol (HTTP), and port 443 is HTTP Secured (HTTPS).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      128,
      129,
      119,
      155
    ],
    "source": "9781394330348"
  },
  {
    "id": 752,
    "question": "All your network hosts are configured to use DHCP. Which IP address would indicate that a host has been unable to locate a DHCP server?",
    "choice_a": "192.168.1.1",
    "choice_b": "10.1.1.1",
    "choice_c": "172.16.1.1",
    "choice_d": "169.254.1.1",
    "correct_answer": "D",
    "explanation": "Automatic Private IP Addressing (APIPA) is a Transmission Control Protocol/Internet Protocol (TCP/IP) standard used to automatically configure IP-based hosts that are unable to reach a Dynamic Host Configuration Protocol (DHCP) server. APIPA addresses are in the 169.254.0.0/16 range. If you see a computer that has an IP address beginning with 169.254, you know that it has configured itself.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      122,
      124,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 753,
    "question": "You have reason to believe that several network users are actively browsing prohibited content on unsecured Internet sites. Which port can you disable on the firewall to immediately stop access to these websites?",
    "choice_a": "53",
    "choice_b": "67",
    "choice_c": "80",
    "choice_d": "443",
    "correct_answer": "C",
    "explanation": "Unsecured websites are accessed on port 80, which is the port that Hypertext Transfer Protocol (HTTP) uses. Shut it down, and no one will be able to access websites, except secure sites that use HTTPS, which is on port 443.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      120,
      155,
      106,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 754,
    "question": "Which TCP/IP protocol is designed to help resolve hostnames to IP addresses?",
    "choice_a": "ARP",
    "choice_b": "RARP",
    "choice_c": "DHCP",
    "choice_d": "DNS",
    "correct_answer": "D",
    "explanation": "The Domain Name System (DNS) is responsible for resolving hostnames to IP addresses. This is used billions of times daily on the Internet; when someone types in a website name, such aswww.sybex.com, DNS will resolve that to an IP address to enable communication. Address Resolution Protocol (ARP) maps Internet addresses to hardware addresses. Reverse ARP (RAPR) does the opposite, and Dynamic Host Configuration Protocol (DHCP) assigns IP addresses to hosts automatically.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      121,
      118,
      117,
      122
    ],
    "source": "9781394330348"
  },
  {
    "id": 755,
    "question": "You need to install an Internet connection for a forest ranger outlook tower located far from electrical lines. Which option would be best for broadband Internet access?",
    "choice_a": "Cable",
    "choice_b": "DSL",
    "choice_c": "Fiber",
    "choice_d": "Satellite",
    "correct_answer": "D",
    "explanation": "Satellite Internet is the best solution for this scenario. Instead of a physical connection, it uses a satellite dish to receive data from an orbiting satellite and relay station that is connected to the Internet. Because it requires a clear line of sight between the transmitter and receiver, it can be referred to as \u201cline-of-sight\u201d wireless. Mobile hotspot (cellular) devices are also an option; however, they depend on a strong cellular signal. For an installation far from civilization (and cell towers), satellite may be the only option. Cable, DSL, and fiber rely on lines that would not run as far as a forest ranger lookout tower.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      151,
      148,
      147,
      149
    ],
    "source": "9781394330348"
  },
  {
    "id": 756,
    "question": "Your customer will be moving their small office to a remote mountain village where there is no cable Internet access. They have heard that there is a wireless option available in the area, which is faster than satellite but requires an antenna and line-of-sight to a tower. What option have they heard about?",
    "choice_a": "Satellite",
    "choice_b": "DSL",
    "choice_c": "WISP",
    "choice_d": "Cellular hotspot",
    "correct_answer": "C",
    "explanation": "Wireless Internet Service Providers (WISPs) use fixed wireless technology, which requires antennas to send radio waves between your location and a fixed hub on a tower or other tall structure like a cellular tower, water tower, or tall building. Download speeds can be up to 1 Gbps or more, although they\u2019re often less for residential service. Satellite is an option in very remote areas but it has the latency caused by the signal traveling hundreds to thousands of miles between the client sending a request to the satellite, then the Internet, and back again. Digital Subscriber Line (DSL) uses telephone lines to create an Internet connection; however, many carriers no longer offer DSL. A cellular hotspot can be used in many remote locations but depends on a connection to a cellular tower. Satellite has a much broader availability than cellular service.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      150,
      147,
      148,
      149
    ],
    "source": "9781394330348"
  },
  {
    "id": 757,
    "question": "Which TCP/IP host-to-host protocol makes its best effort to deliver data but does not guarantee it?",
    "choice_a": "IP",
    "choice_b": "TCP",
    "choice_c": "UDP",
    "choice_d": "ICMP",
    "correct_answer": "C",
    "explanation": "The two host-to-host protocols are Transmission Control Protocol (TCP) and User Datagram Protocol (UDP). TCP guarantees packet delivery through the use of a virtual circuit and data acknowledgments, while UDP does not. Because of this, TCP is often referredto as connection oriented, whereas UDP is connectionless. Internet Protocol (IP) and Internet Control Message Protocol (ICMP) are not considered host-to-host protocols.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      117,
      118,
      106,
      120
    ],
    "source": "9781394330348"
  },
  {
    "id": 758,
    "question": "What type of network is typically defined as being contained within a single office or building?",
    "choice_a": "LAN",
    "choice_b": "WAN",
    "choice_c": "PAN",
    "choice_d": "MAN",
    "correct_answer": "A",
    "explanation": "A Local Area Network (LAN) is often defined as being contained in a single building, office, or home. The types of networks based loosely on geography, from smallest to largest are Personal Area Network (PAN), LAN, Metropolitan Area Network (MAN), and Wide Area Network (WAN).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      99,
      102,
      100,
      101,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 759,
    "question": "You are installing a wireless network for a small company. The management wants to have 1 Gbps or better wireless transmission rates. Which of the following standards will enable you to provide this? (Choose two.)",
    "choice_a": "802.11n",
    "choice_b": "802.11ax",
    "choice_c": "802.11b",
    "choice_d": "802.11be",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "802.11a and 802.11g provide throughput that is only 54 Mbps, and 802.11b was a whopping 11 Mbps. 802.11n (Wi-Fi 4), which is better, provides throughput over 100 Mbps (theoretically up to 300 Mbps). However, 802.11ac (Wi-Fi 5) boasts throughputs of over 1 Gbps, while 802.11ax (Wi-Fi 6 and 6E) and 802.11be (Wi-Fi 7) have far surpassed these standards with throughputs of multiple Gbps.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      142,
      143,
      144,
      141,
      138
    ],
    "source": "9781394330348"
  },
  {
    "id": 760,
    "question": "Which of these standards operate in both the 2.4 and 5 GHz frequencies? (Choose two.)",
    "choice_a": "802.11ac",
    "choice_b": "802.11ax",
    "choice_c": "802.11g",
    "choice_d": "802.11n",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "802.11ac operates in the 5 GHz frequency only. 802.11g is only 2.4 GHz. 802.11ax and 802.11n operate in both frequencies.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      141,
      143,
      138,
      107,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 761,
    "question": "What legacy network protocol enables NetBIOS-dependent computer applications to communicate over TCP/IP?",
    "choice_a": "TFTP",
    "choice_b": "HTTPS",
    "choice_c": "NetBT",
    "choice_d": "BGP",
    "correct_answer": "C",
    "explanation": "NetBIOS over TCP/IP (NetBT) is for older applications still reliant on Network Basic Input/Output System (NetBIOS), the legacy network protocol intended for very small networks. NetBT lets such applications communicate over Transmission Control Protocol/Internet Protocol (TCP/IP). Trivial File Transfer Protocol (TFTP) is a basic connectionless protocol that enables file transfer functions without user interaction. Hypertext Transfer Protocol Secure (HTTPS) is a secure connection-oriented protocol that runs over port 443. Border Gateway Protocol (BGP) is an Internet Engineering Task Force (IETF) standard that enables routers to share information enabling communication across the Internet.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      120,
      121,
      117,
      106,
      136
    ],
    "source": "9781394330348"
  },
  {
    "id": 762,
    "question": "Which of the following features does not require a managed network switch?",
    "choice_a": "Priority of traffic",
    "choice_b": "VLAN configuration",
    "choice_c": "Direct packets out the proper port",
    "choice_d": "Port mirroring",
    "correct_answer": "C",
    "explanation": "An unmanaged switch will simply perform the basic task a switch should do: Direct network traffic out the correct destination port. Prioritizing traffic, configuring Virtual Local Area Networks (VLANs), and mirroring ports are all jobs that are done using managed switches.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      125,
      115,
      99,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 763,
    "question": "In the United States, what groups are responsible for approving wireless channel uses? (Choose two.)",
    "choice_a": "OSHA",
    "choice_b": "FCC",
    "choice_c": "IANA",
    "choice_d": "IEEE",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "In the United States, the Federal Communications Commission (FCC) and the Institute of Electrical and Electronics Engineers (IEEE) are the authorities that approve channel uses. The Occupational Safety and Health Administration (OSHA) sets rules for safe workplaces, and the Internet Assigned Numbers Authority (IANA), as the name implies, is responsible for doling out IP addresses to ISPs and other large organizations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      138,
      139,
      154,
      141
    ],
    "source": "9781394330348"
  },
  {
    "id": 764,
    "question": "What port(s) does DHCP use?",
    "choice_a": "67/68",
    "choice_b": "137\u2013139",
    "choice_c": "80",
    "choice_d": "445",
    "correct_answer": "A",
    "explanation": "DHCP uses ports 67/68. Ports 137\u2013139 are for Network Basic Input/Output System (NetBIOS)/NetBIOS over TCP/IP (NetBT). Port 80 is for Hypertext Transfer Protocol (HTTP), and port 445 is for Server Message Block (SMB).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      121,
      119,
      130,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 765,
    "question": "What is the maximum distance allowed between a PoE injector and the PoE compatible Ethernet device running on a 1000BaseT network?",
    "choice_a": "50 meters",
    "choice_b": "100 meters",
    "choice_c": "250 meters",
    "choice_d": "450 meters",
    "correct_answer": "B",
    "explanation": "The distance for Power over Ethernet (PoE) is limited by the maximum distance set by the Ethernet cabling: 100 meters (328 feet). The power injector, the device that sources the electrical power to certain wires in the cable, can be as much as 100 meters from the powered device. The injector also needs to have sufficient power to match device needs, and devices must be compatible. PoE devices such as powered switches can provide a few watts or well over 100 watts, depending on the device.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      111,
      108,
      107,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 766,
    "question": "Which of the following protocols uses ports 137\u2013139?",
    "choice_a": "DNS",
    "choice_b": "SMB",
    "choice_c": "NetBT",
    "choice_d": "SSH",
    "correct_answer": "C",
    "explanation": "NetBIOS over TCP/IP (NetBT) is an older protocol for applications that still rely on NetBIOS. It uses ports 137 through 139, and it\u2019s still on the CompTIA A+ certification objectives. Domain Name System (DNS) uses port 53, Server Message Block (SMB) uses port 445, and Secure Shell (SSH) uses port 22.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      120,
      121,
      119,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 767,
    "question": "When setting up a SOHO network, how do the end-user devices know what IP address they need to use to connect with the network? (Choose two.)",
    "choice_a": "The network switch broadcasts configuration settings.",
    "choice_b": "Devices utilize ARP.",
    "choice_c": "The NIC is configured with a static address.",
    "choice_d": "The NIC is configured to receive a DHCP address.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The end-user devices on a Small Office Home Office (SOHO) are configured to at least request a Dynamic Host Connection Protocol (DHCP)-assigned IP address from the DHCP server, or they are preconfigured with a static IP, gateway, subnet mask, and Domain Name Server (DNS) information. Switches do not broadcast configuration settings, although a router may also serve as a DHCP server. Address Resolution Protocol (ARP) associates IP addresses with Media Access Control (MAC) addresses to facilitate communications on a Local Area Network (LAN).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      156,
      118,
      122
    ],
    "source": "9781394330348"
  },
  {
    "id": 768,
    "question": "You\u2019ve been asked to set up a wireless network for a SOHO that will only enable five specific devices to connect. How do you accomplish this based on each device\u2019s NIC?",
    "choice_a": "Disable the router\u2019s SSID.",
    "choice_b": "Configure port forwarding.",
    "choice_c": "Set a DHCP scope with only five addresses.",
    "choice_d": "Configure MAC address filtering.",
    "correct_answer": "D",
    "explanation": "Media Access Control (MAC) address filtering uses the physical address of a Network Internet Card (NIC) to determine whether or not to enable a device to connect to the router. Disabling the Service Set Identifier (SSID) will hide the network from neighbors, but not keep them from connecting if they discover the network. Port forwarding redirects requests for a specific port to a specific device on the network. The Dynamic Host Connection Protocol (DHCP) scope can be configured to only enable five machines to connect, but it may not be the \u201cright\u201d five machines.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      156,
      155,
      114,
      130
    ],
    "source": "9781394330348"
  },
  {
    "id": 769,
    "question": "What is the most likely way for a homeowner\u2019s IoT devices to connect to their wireless network using a dynamic address assigned by a server?",
    "choice_a": "DNS",
    "choice_b": "AD",
    "choice_c": "SSO",
    "choice_d": "DHCP",
    "correct_answer": "D",
    "explanation": "Unless an Internet of Things (IoT) device possesses an end-user accessible management interface, that device will likely connect at least initially using Dynamic Host Configuration Protocol (DHCP) to obtain an IP address. Domain Name System (DNS) resolves names likeWiley.comto an IP address. Active Directory (AD) is a Microsoft client/server security solution, and Single Sign-On (SSO) enables a user to enter their credentials once to access several resources.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      129,
      152,
      156
    ],
    "source": "9781394330348"
  },
  {
    "id": 770,
    "question": "What type of radio wave communication technology is being used at a fast-food restaurant when a customer places their phone next to a device to pay for their purchase?",
    "choice_a": "RFID",
    "choice_b": "NFC",
    "choice_c": "Wi-Fi",
    "choice_d": "HAV",
    "correct_answer": "B",
    "explanation": "Near-Field Communication (NFC) protocol requires devices to be within about 10 centimeters of each other to transmit data. In this case, the devices are working in card emulation mode, but NFC can also be used to transmit between two like devices such as two cellphones, or to read a smart tag. Radio Frequency Identification (RFID) is another technology that uses radio waves to transfer information. Wi-Fi is 802.11-based wireless networking, and Hardware Assisted Virtualization (HAV) is a technology that enables the Virtual Machine (VM) more direct access to the physical processor\u2019s capabilities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      145,
      138,
      140,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 771,
    "question": "What communication technology enables low-power passive reading of a small tag or patch on an object that may be a few feet to dozens of feet away?",
    "choice_a": "RFID",
    "choice_b": "NFC",
    "choice_c": "Wi-Fi",
    "choice_d": "RFI",
    "correct_answer": "A",
    "explanation": "Radio Frequency Identification (RFID) can be implemented to detect and read a \u201cpassive\u201d (no power) tag, which is essentially an antenna as it passes within a few feet in range. RFID tags are often used in industry and retail for inventory tracking. The distance for RFID implementation depends on the size and polarization of the antenna, the frequency, and the power used, among other features. Near-Field Communication (NFC) requires a distance of only a few centimeters. Wi-Fi is 802.11-based wireless networking. Radio Frequency Interference (RFI) is a nuisance that can disrupt network communications.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      145,
      138,
      141,
      142,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 772,
    "question": "What type of server provides Internet access to company-provided information, such as how to contact a company, products or services for sale, and other information?",
    "choice_a": "FTP server",
    "choice_b": "Proxy server",
    "choice_c": "File server",
    "choice_d": "Web server",
    "correct_answer": "D",
    "explanation": "A web server consists of hardware and software used to provide information to clients via the Internet (or a company intranet). The main protocols for web servers are Hypertext Transfer Protocol (HTTP) and Hypertext Transfer Protocol Secure (HTTPS); however, they can use other protocols as well. File Transfer Protocol (FTP) servers are used fordownloading files quickly, and while they may have a Graphical User Interface (GUI), they have much less overhead than a web server. Proxy servers are a security measure between an internal user and the web and are used to monitor and filter information going into or out of a network. File servers are often used on a Local Area Network (LAN) to provide access to the same files by multiple users.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      120,
      135,
      133,
      129
    ],
    "source": "9781394330348"
  },
  {
    "id": 773,
    "question": "A friend is showing you how they can control their home\u2019s thermostat from their cellphone while at work. What type of device do they have at home?",
    "choice_a": "IoT",
    "choice_b": "SQL",
    "choice_c": "DoS",
    "choice_d": "EFS",
    "correct_answer": "A",
    "explanation": "Internet of Things (IoT) devices enable a multitude of personal and industrial devices to connect and communicate over the Internet. Structured Query Language (SQL) is a method of retrieving information from a database. Denial of Service (DoS) is a type of network attack, and Encrypting File System (EFS) enables the user to encrypt individual files, folders, or volumes.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      100,
      99,
      117,
      121,
      145
    ],
    "source": "9781394330348"
  },
  {
    "id": 774,
    "question": "What server would function as a central repository of documents and provide network shared file storage for internal users?",
    "choice_a": "FTP server",
    "choice_b": "Proxy server",
    "choice_c": "Fileshare",
    "choice_d": "Web server",
    "correct_answer": "C",
    "explanation": "A fileshare server is a centralized repository for users, typically company employees. File Transfer Protocol (FTP) servers are used for downloading files quickly, and while they may have a Graphical User Interface (GUI), they have much less overhead than a web server. Proxy servers are a security measure between an internal user and the web and are used to filter information going into or out of a network, while web servers may provide information about a company or its products to the general public.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      135,
      215,
      102,
      146
    ],
    "source": "9781394330348"
  },
  {
    "id": 775,
    "question": "You work as a network administrator for a school district. The district is required to provide access to the Internet for students but also required to protect the network and the students from malicious network traffic and inappropriate websites. What type of server do you need to configure?",
    "choice_a": "FTP server",
    "choice_b": "Proxy server",
    "choice_c": "File server",
    "choice_d": "Web server",
    "correct_answer": "B",
    "explanation": "Proxy servers act as a gateway through which Internet access requests are handled, monitored, and, if need be, filtered. File Transfer Protocol (FTP) servers are used for downloading files quickly, and while they may have a graphical user interface (GUI), they have much less overhead than a web server. File servers are often used on a Local Area Network (LAN) to provide access to the same files by multiple users, while web servers may provide information about a company or its products to the general public.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      135,
      137,
      155,
      131,
      129
    ],
    "source": "9781394330348"
  },
  {
    "id": 776,
    "question": "What type of server can host files for easy access and fast downloading across the Internet, like how a web server serves web pages?",
    "choice_a": "FTP server",
    "choice_b": "Proxy server",
    "choice_c": "File server",
    "choice_d": "DNS server",
    "correct_answer": "A",
    "explanation": "As a type of fileshare, the File Transfer Protocol (FTP) server hosts files for easy access, enabling users to browse it and download and upload files. Typically, the bandwidth overhead is less in an FTP server than it would be in a Web server. Proxy servers monitor and filter traffic into and out of a network. File servers are a repository of files accessed by multiple users on a network. A Domain Name System (DNS) server resolves human-readable names such asWiley.comto an IP address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      129,
      135,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 777,
    "question": "You\u2019re a network administrator and just added a device to your network that enables multiple users to access several printers. What have you attached to the network?",
    "choice_a": "Syslog server",
    "choice_b": "DNS server",
    "choice_c": "Print server",
    "choice_d": "Authentication server",
    "correct_answer": "C",
    "explanation": "A print server can be either a physical device or software configured on a computer. The print server provides centralized availability of print services to authorized users on the network. It accepts print jobs, and the documents are printed according to the order of receipt or some configured priority. A syslog server gathers and logs event information from devices on a network, creating a central repository for a network administrator to monitor and respond to events. A Domain Name System (DNS) server resolves domain names to IP addresses, and an authentication server verifies identity before enabling access to a network.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      102,
      103,
      129,
      130,
      131
    ],
    "source": "9781394330348"
  },
  {
    "id": 778,
    "question": "What server is used to resolve domain names to IP addresses to facilitate web browsing or locating a directory resource on the network?",
    "choice_a": "Syslog server",
    "choice_b": "DNS server",
    "choice_c": "Print server",
    "choice_d": "Authentication server",
    "correct_answer": "B",
    "explanation": "If a user typeswww.sybex.cominto a web browser, the Domain Name System (DNS) server will resolve the domain name to an IP address. Similarly, DNS servers will resolve a Fully Qualified Domain Name (FQDN) network directory resource on the network to make locating that resource possible. Syslog servers provide a repository of events on the network to aid in network management. Print servers provide and manage access to one or more printers by multiple users on a network, and an authentication server verifies identity before granting access to resources on a network.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      129,
      121,
      132,
      130,
      131
    ],
    "source": "9781394330348"
  },
  {
    "id": 779,
    "question": "What server is accessed each time it\u2019s necessary to challenge and validate a user\u2019s credentials, enabling the user to access a network resource?",
    "choice_a": "Syslog",
    "choice_b": "DNS",
    "choice_c": "Print",
    "choice_d": "AAA",
    "correct_answer": "D",
    "explanation": "The Authentication, Authorization, and Accounting (AAA) server facilitates the challenge/response service for validating someone\u2019s credentials. Syslog servers provide a repository of events on the network to aid in network management. Domain Name System (DNS) servers resolve Uniform Resource Locators (URLs) to IP addresses, and print servers provide and manage access to one or more printers by multiple users on a network.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      131,
      132,
      129,
      121,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 780,
    "question": "What type of server can collect and journal all the system-generated messages produced by servers and network devices?",
    "choice_a": "Syslog",
    "choice_b": "DNS",
    "choice_c": "Print",
    "choice_d": "AAA",
    "correct_answer": "A",
    "explanation": "The Syslog server operates with the Syslog protocol, which is used by many different operating systems and devices. These system-generated messages vary from the mundane \u201cSystem started\u201d to critical alerts. Domain Name System (DNS) servers resolve domain names to IP addresses. Print servers facilitate and manage printing by multiple users to one or more printers on a network, and Authentication, Authorization, and Accounting (AAA) servers verify identity before granting access to a resource.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      129,
      130,
      131,
      119
    ],
    "source": "9781394330348"
  },
  {
    "id": 781,
    "question": "You\u2019re configuring your phone to download email from and upload it to your company\u2019s server. What type of server are you configuring your phone to use?",
    "choice_a": "Web",
    "choice_b": "AAA",
    "choice_c": "Mail",
    "choice_d": "FTP",
    "correct_answer": "C",
    "explanation": "Mail servers are used to send, receive, and sometimes store and manage emails. They operate on ports 25, 110, and 143. Often, devices will need to be configured with the name or IP of the server and the proper protocol or port for sending and receiving email. Web servers provide web pages over the Internet. Authentication, Authorization, and Accounting (AAA) servers verify identity before enabling access to resources; and File Transfer Protocol (FTP) servers are used to quickly locate, download, and upload files.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      121,
      119,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 782,
    "question": "Which of the following are connection-oriented protocols? (Choose two.)",
    "choice_a": "DHCP",
    "choice_b": "TFTP",
    "choice_c": "HTTPS",
    "choice_d": "SSH",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Connection-oriented protocols work over Transmission Control Protocol (TCP), which guarantees delivery of packets. This guarantee requires greater resources than User Datagram Protocol (UDP), which is connectionless, therefore not requiring that a packet be resent if it\u2019s not received. Hypertext Transfer Protocol Secure (HTTPS) and Secure Shell (SSH) are connection-oriented protocols while Trivial File Transfer Protocol (TFTP) and Dynamic Host Configuration Protocol (DHCP) are connectionless protocols.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      119,
      120,
      128,
      130,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 783,
    "question": "What type of service will you install for a company that wants to monitor network traffic and host system behavior so the service can identify suspect activity? (Choose two.)",
    "choice_a": "Proxy server",
    "choice_b": "IDS",
    "choice_c": "UTM",
    "choice_d": "ATM",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "An Intrusion Detection System (IDS) is a component of a Unified Threat Management (UTM) system. The IDS will monitor and alert you of suspect behavior. It can be a network-based device or host-based, meaning it runs as a process in the background. UTM provides multiple security features on a single appliance. Proxy servers are used to control traffic into and out of a network. Asynchronous Transfer Mode (ATM) has to do with transferring different types of traffic (i.e., voice and data) over the same communication lines at the same time.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      136,
      135,
      132,
      106,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 784,
    "question": "What is the primary difference between IDS and IPS?",
    "choice_a": "IDS works on both a host and a network.",
    "choice_b": "IDS will not actively alert on suspect activity.",
    "choice_c": "IPS works in pairs.",
    "choice_d": "IPS will actively react to suspect activity.",
    "correct_answer": "D",
    "explanation": "The Intrusion Detection System (IDS) will alert on suspect activity but will not react or actively attempt to block the activity. The Intrusion Prevention System (IPS), however, should attempt to block the activity. Both IDS and IPS can be parts of a Unified Threat Management (UTM) system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      135,
      137,
      106,
      132
    ],
    "source": "9781394330348"
  },
  {
    "id": 785,
    "question": "Managing security on your growing network has become difficult, so you ask your peers what they are doing to manage their networks. They recommend a device that will enable you to manage your security in one place. What have they recommended?",
    "choice_a": "IDS",
    "choice_b": "IPS",
    "choice_c": "UTM",
    "choice_d": "UTP",
    "correct_answer": "C",
    "explanation": "Unified Threat Management (UTM) systems can be hardware networking devices, virtual devices, or an off-premises service. UTM\u2019s role is to combine several security features and services into a single device enabling for easier management and compatibility. An Intrusion Detection System (IDS) will only notify an admin if a threat is detected; it doesn\u2019t take action against the threat. Intrusion Protection Systems (IPSs) will detect and respond to security threats. An Unshielded Twisted Pair (UTP) is a type of network cabling.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      155,
      131,
      135,
      126,
      125
    ],
    "source": "9781394330348"
  },
  {
    "id": 786,
    "question": "What wireless frequency is used by the Bluetooth protocol?",
    "choice_a": "2.4 GHz",
    "choice_b": "5 GHz",
    "choice_c": "6 GHz",
    "choice_d": "60 GHz",
    "correct_answer": "A",
    "explanation": "Bluetooth uses the 2.4 GHz frequency. Within that frequency band (2.4\u20132.48 GHz), it will occupy a 1 MHz-wide channel. It also uses a feature called frequency hopping tochange to a different channel within that band multiple times per second to avoid interference. All the frequencies listed (2.4, 5, 6, and 60 GHz) are used by 802.11 (wireless) networks.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      145,
      100,
      140,
      138,
      141
    ],
    "source": "9781394330348"
  },
  {
    "id": 787,
    "question": "Your cousin is a nature photographer, traveling the country and living in their Class A motorhome. Much of the time, their motorhome is parked in a national park, but seldom is Wi-Fi available. Your cousin uploads photos from their camera to a laptop, modifies them, and needs to upload them to their publisher, various magazines, and their website on a regular basis. What is a viable networking option for your cousin?",
    "choice_a": "Satellite",
    "choice_b": "Cellular",
    "choice_c": "WISP",
    "choice_d": "DSL",
    "correct_answer": "B",
    "explanation": "Cellular is the only type of network connection that enables the type of mobility that this photographer needs. A cellular hotspot device from a mobile provider would work well. Satellite would require repositioning of the dish on a regular basis and may not work well because of obstructions. A Wireless Internet Service Provider (WISP) requires being within a few miles of a tower and line-of-site between the antenna and tower, so that wouldn\u2019t work well either. A Digital Subscriber Line (DSL) requires a stationary phone line.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      151,
      150,
      99,
      148,
      138
    ],
    "source": "9781394330348"
  },
  {
    "id": 788,
    "question": "Based on the illustration shown, what is the device labeled A?<img src=\"/question_assets/220-1201/c02f001.png\" alt=\"Illustration of a cable Internet service provider connecting to a house with an unnamed element labeled A, a router, and 3 P C's.\"/>\n\n<figcaption>Illustration of a cable Internet service provider connecting to a house with an unnamed element labeled A, a router, and 3 P C's.</figcaption>",
    "choice_a": "Switch",
    "choice_b": "Hub",
    "choice_c": "Cable modem",
    "choice_d": "Cable multiplexer",
    "correct_answer": "C",
    "explanation": "Cable Internet service requires a cable modem to separate the Internet signal from TV channels, and to convert the signal into one that your computer can use. A switch is used on a Local Area Network (LAN) as a central connection point. A hub for networking is an obsolete device that would send any signal it received out of all its ports. A cable multiplexer connects several signals into one for transmission over a cable, such as input from multiple security cameras.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      156,
      148,
      114,
      110,
      116
    ],
    "source": "9781394330348"
  },
  {
    "id": 789,
    "question": "What is the device in the image used for?<img src=\"/question_assets/220-1201/c02f002.png\" alt=\"Paladin Tools Data and Link I D Cable-Check tester with a remote unit.\"/>\n\n<figcaption>Paladin Tools Data and Link I D Cable-Check tester with a remote unit.</figcaption>",
    "choice_a": "It multiplexes several signals into one.",
    "choice_b": "It\u2019s a network cable tester.",
    "choice_c": "It\u2019s for attaching RJ-45 connectors to cable.",
    "choice_d": "It\u2019s for testing Wi-Fi signal strength.",
    "correct_answer": "B",
    "explanation": "This device is for testing network cables that are terminated with an RJ-45 connector. A multiplexer combines several signals into one. A striper/crimper tool is used to connect RJ-45 connectors to Shielded Twisted Pair (STP) or Unshielded Twisted Pair (UTP) copper cables, and a Wi-Fi analyzer is used for determining Wi-Fi signal strength. It can be an app on a smartphone or a separate device.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      116,
      108,
      111,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 790,
    "question": "You\u2019re considering a Bluetooth 5.0 headset. What is the maximum distance that headset can reach?",
    "choice_a": "1 meter",
    "choice_b": "10 meters",
    "choice_c": "100 meters",
    "choice_d": "200+ meters",
    "correct_answer": "D",
    "explanation": "Bluetooth 5.0 is capable of reaching a distance of 240 meters and has been around since 2016, with incremental changes (5.1, 5.2, etc.) over the years.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      145,
      100,
      99,
      141,
      142
    ],
    "source": "9781394330348"
  },
  {
    "id": 791,
    "question": "Last weekend, you configured, installed, and booted several new computers to be added to your company\u2019s network, ready for Monday morning. On Monday morning, as the company\u2019s employees sit down to work, they let you know that they cannot log in. Their desktops don\u2019t seem to want to connect to the network. You investigate and find that each faulty workstation has a 169.254.x.x IP address. What might you look at next?",
    "choice_a": "DHCP scope",
    "choice_b": "LAN connector broken",
    "choice_c": "Windows patch unable to install",
    "choice_d": "Corrupted registry",
    "correct_answer": "A",
    "explanation": "With many new systems added and already booted, it is likely that the Dynamic Host Configuration Protocol (DHCP) scope, which is a valid range of IP addresses available to client-based systems on a particular subnet, is now too small for the number of systems requesting IP addresses. Expand the DHCP scope to solve the problem.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      130,
      121,
      124,
      122,
      128
    ],
    "source": "9781394330348"
  },
  {
    "id": 792,
    "question": "Which network segmentation technique reduces broadcast domains and provides a layer of security between users on the same network?",
    "choice_a": "VPN",
    "choice_b": "VLAN",
    "choice_c": "UPS",
    "choice_d": "SQL",
    "correct_answer": "B",
    "explanation": "Virtual Local Area Networks (VLANs) will segment your network into smaller broadcast domains. Multiple VLANs can exist on the same physical switch. Traffic is isolated to only the paths determined by how you configured VLANs on your managed switches. A Virtual Private Network (VPN) uses tunneling protocols to secure a private connection across a public network. Uninterruptable Power Supply (UPS) is a battery backup with other features that is used to maintain power to a device when the grid power goes down, and Structured Query Language (SQL) is used to retrieve information from a database.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      114,
      106,
      126,
      137
    ],
    "source": "9781394330348"
  },
  {
    "id": 793,
    "question": "One of your network users must work remotely from their office on an extremely confidential project. Their team is concerned about security, so they call you, the IT department head, to see what can be done. What will you set up between this network user and the company server so that the communications are secure?",
    "choice_a": "VPN",
    "choice_b": "SDN",
    "choice_c": "VLAN",
    "choice_d": "SRAM",
    "correct_answer": "A",
    "explanation": "A Virtual Private Network (VPN) uses encryption to secure a transmission across a public network. Software Defined Networking (SDN) is a network architecture designed to make managing a network easier and more flexible. A Virtual LAN (VLAN) separates a Local Area Network (LAN) into separate broadcast domains for security purposes. Static Random Access Memory (SRAM) is often found in processor cache.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      126,
      127,
      125,
      155,
      114
    ],
    "source": "9781394330348"
  },
  {
    "id": 794,
    "question": "Which of the following components is not typically found in a wireless LAN (WLAN)?",
    "choice_a": "WLAN router",
    "choice_b": "WLAN gateway",
    "choice_c": "WLAN server",
    "choice_d": "WLAN client",
    "correct_answer": "C",
    "explanation": "Wireless Local Area Network (WLAN) networks commonly have three types of nodes: a client, router, and gateway. They typically don\u2019t include a server and often are fluid innature, where devices come and go as needed. They may include a printer. A WLAN can be used to connect wireless users to a wired network via a wireless access point (WAP), which often has a wired connection to the network and provides wireless network capabilities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      99,
      102,
      154,
      152,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 795,
    "question": "You need to configure dynamic IP addressing on your network to cut down on management time. How can you do this? (Choose two.)",
    "choice_a": "Enable DHCP settings on the router.",
    "choice_b": "Configure each NIC to obtain an IP address automatically.",
    "choice_c": "Configure each NIC to a specific IP address.",
    "choice_d": "Configure each NIC to obtain DNS server addresses automatically.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "A Network Interface Card (NIC) can be configured either with a specific (static) IP address, or to obtain an IP address from an available Dynamic Host Configuration Protocol (DHCP) server. Many routers have the capability to provide DHCP services. When a device with a properly configured NIC attempts to join a network, a request for an IP address will be sent to the DHCP server, and the DHCP server will lease an IP address to that device, if one is available.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      130,
      108,
      109,
      156
    ],
    "source": "9781394330348"
  },
  {
    "id": 796,
    "question": "Your network admin needs to add a computer with a routable address to an IPv6 subnet. Which of the following IPv6 addresses is on the same subnet as 2601:0:0:1f:1a:308c:2acb:fee2?",
    "choice_a": "2601::of:308c:47:4321",
    "choice_b": "2601::1f:ab:cd:123:4a",
    "choice_c": "fe80:ab:bc:1f:1a:308c:2abc:fee5",
    "choice_d": "2601:0:0:1x::2acb:ac01",
    "correct_answer": "B",
    "explanation": "Option 2601::1f:ab:cd:123:4a, and the address in the question, both have a subnet of 1f. IPv6 addresses consist of 128 bits, divided by colons (:) into eight hextets. Therefore, each hextet represents 16 bits. Leading zeros can be omitted, and in one place in each address, consecutive groups of zeros can be omitted, represented by double colons (::). The last 64 bits (four hextets) of an IPv6 address are the Interface ID, identifying the unique computer that the address is assigned to. The first 64 bits are called the prefix. Internet Service Providers (ISPs) and very large organizations are assigned /48 prefixes. The next 16 bits (the fourth hextet) are used to define subnets. 2601::of:308c:47:4321 has a fourth hextet of 0. fe80:ab:bc:0f:1a:308c:2abc:fee5 is a link-local address, so it isn\u2019t routable. 2601:0:0:0x::2acb:ac01 is an invalid number because hex numbers only go to letter f.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      122,
      123,
      118,
      124,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 797,
    "question": "Which of the following is a PoE standard?",
    "choice_a": "802.3bt",
    "choice_b": "802.3b",
    "choice_c": "802.11",
    "choice_d": "802.11ax",
    "correct_answer": "A",
    "explanation": "The Power over Ethernet (PoE) Standards are the Institute of Electrical and Electronics Engineers (IEEE) 802.3af (PoE), 802.3at (PoE+), and 802.3bt (PoE++). A main difference between the standards is how much power per port can be provided. 802.3af can supply up to 15.4 watts per port, 802.3at can provide up to 30 watts per port, and 802.3bt can provide 60 watts (Type 3) or 100 watts (Type 4). The power that actually reaches the devices is less due to voltage loss over distance (attenuation). 802.3b is a legacy broadband Ethernet standard. 802.11 and 802.11ax are Wi-Fi standards.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      107,
      108,
      111,
      112
    ],
    "source": "9781394330348"
  },
  {
    "id": 798,
    "question": "Your friend has purchased a PoE device for their home. It is a Type 2 device. Which of the following PoE switches will be compatible with this device? (Choose two.)",
    "choice_a": "802.3af-compliant switch",
    "choice_b": "802.3at-compliant switch",
    "choice_c": "802.3bt-compliant switch",
    "choice_d": "802.11b-compliant switch",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Power over Ethernet (PoE) devices providing power are backward compatible with older devices, meaning that while 802.3bt is rated at 60W for Type 3 and 100W for Type 4, an 802.3bt device will work with an 802.3at (Type 2) device. 802.3af would not provide enough power for your friend\u2019s device. 802.11b is a Wi-Fi standard, not a PoE standard.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      114,
      107,
      141,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 799,
    "question": "Which of the following is true of an ONT? (Choose two.)",
    "choice_a": "It stands for Optical Network Terminator.",
    "choice_b": "It converts fiber-optic light signals to electrical (Ethernet) signals.",
    "choice_c": "It is end-user installed.",
    "choice_d": "It requires external power to work properly.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "An Optical Network Terminal (ONT) is installed by a fiber-optic Internet Service Provider (ISP) and is typically a small box on an outside wall. The terminal is a transducer, converting between copper/electrical signals and fiber-optic/light signals. It does require power, and the terminal may have an indicator light to signal whether it is receiving power.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      113,
      108,
      106,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 800,
    "question": "Networking technologies have a group of frequencies they can operate on: for example, in what is called the 5 GHz band, the frequency can be anywhere between 5.15 GHz (5.15 billion cycles per second) and 5.85 GHz (5.85 billion cycles per second). That band is further divided into specific groups of frequencies, such as 5.17 to 5.19 GHz. What names are given to those smaller groups of frequencies? (Choose two.)",
    "choice_a": "Range",
    "choice_b": "Channel",
    "choice_c": "Band",
    "choice_d": "Multiplexer",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Each frequency\u2014such as 2.4 GHz, 5.0 GHz, and 6 GHz\u2014is divided into sections. Each section, called a channel, has a range of frequencies associated with it. For example, the frequency range 5.17 to 5.19 GHz has a base frequency of 5.18 and is identified as Channel 36. The different channels enable users to choose a less crowded range to avoid network interference.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      154,
      139,
      142,
      141
    ],
    "source": "9781394330348"
  },
  {
    "id": 801,
    "question": "Which type of WISP radio frequencies have the advantages of no fees, less expensive equipment, and a wide pool of practical knowledge so help is easier to find?",
    "choice_a": "Licensed",
    "choice_b": "Unlicensed",
    "choice_c": "Limited",
    "choice_d": "Unlimited",
    "correct_answer": "B",
    "explanation": "Frequencies for Wireless Internet Service Providers (WISP) can be licensed or unlicensed. (The Federal Communications Commission [FCC] is the licensing body.) Most WISPs use unlicensed frequencies because they are free.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      102,
      138,
      141,
      152,
      154
    ],
    "source": "9781394330348"
  },
  {
    "id": 802,
    "question": "You are working with your customer, a doctor\u2019s office, to develop a network that will enable the doctor\u2019s staff to work with their tablet PCs in any room of the office without having to worry about network cabling. What type of network will you establish for the doctor\u2019s office?",
    "choice_a": "LAN",
    "choice_b": "VLAN",
    "choice_c": "WLAN",
    "choice_d": "WAN",
    "correct_answer": "C",
    "explanation": "A Wireless LAN (WLAN) is the best solution for this office. It is a group of devices in the same location that communicate via radio waves instead of cables. WLANS can have multiple Wireless Access Points (WAPs), preferably overlapping so users won\u2019t experience signal drop. Wi-Fi is a type of WLAN. A Local Area Network (LAN) is incorrect, because it would require disconnecting and reconnecting cables in each room. A Virtual LAN (VLAN) is established using security protocols to segregate a network. Wide Area Network (WAN) is incorrect, because this is a network in a single office, and a WAN connects geographically distant computers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      99,
      102,
      139,
      154,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 803,
    "question": "Which of the following is a network of storage devices that a server can access as if it were a locally connected drive?",
    "choice_a": "NAS",
    "choice_b": "SAS",
    "choice_c": "SAN",
    "choice_d": "WAN",
    "correct_answer": "C",
    "explanation": "A Storage Area Network (SAN) is a high-speed network whose purpose is to provide fast access by servers to storage. Network Attached Storage (NAS) differs from a SAN in that it is not a separate high-speed network, but a single storage device attached to a Local Area Network (LAN). Serial Attached SCSI (SAS) is a technology for connecting a computer and a storage device. It can be used to create a SAN or NAS. A Wide Area Network (WAN) consists of connected computing devices that are widely geographically dispersed, such as the Internet.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      101,
      99,
      103,
      114,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 804,
    "question": "Which of the following are true of a network TAP? (Choose two.)",
    "choice_a": "TAP stands for Terminal Access Point.",
    "choice_b": "It is solely used by hackers to intercept packets.",
    "choice_c": "It is part of a router.",
    "choice_d": "It enables network admins to monitor network traffic.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A network Terminal Access Point (TAP) connects to a network in an area of concern and creates a copy of traffic, sending it on to monitoring devices. It can be an integral part of network management. TAPs can be active or passive. Passive TAPs do not require power or management, but active TAPs do. Although it sounds like something a hacker would use, they typically don\u2019t. A TAP is a separate hardware device, not part of a router.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      106,
      155,
      135,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 805,
    "question": "What software runs on a machine where data files to be accessed are housed and where that software controls access to those files as requested by a client?",
    "choice_a": "CAL",
    "choice_b": "Fileshare server",
    "choice_c": "Fileshare client",
    "choice_d": "SAN",
    "correct_answer": "B",
    "explanation": "A fileshare server software handles requests from fileshare clients for access to data stored on the server. The fileshare server resides on the same machine as the data. A Client Access License (CAL) is a license enabling one machine to connect to a server, and a Storage Area Network (SAN) is a separate network of storage devices that provides storage for users and servers.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      103,
      215,
      133,
      99,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 806,
    "question": "A friend is having some issues with the wireless network in their apartment. It\u2019s dropping the connection or running very slowly. What tool can be used to determine the best channel to use?",
    "choice_a": "WAP",
    "choice_b": "Wi-Fi analyzer",
    "choice_c": "Toner probe",
    "choice_d": "Cable tester",
    "correct_answer": "B",
    "explanation": "A Wireless Access Point (WAP) provides Wireless Local Area Network (WLAN) connectivity but may not help with the problems on this network. Your friend needs to determine what wireless channel has the least traffic, and then configure their Wi-Fi to use that channel. For that they need a Wi-Fi analyzer, which can be a separate device or as simple as an app on a smartphone. A toner probe is used to figure out which network cable is connected when they are not labeled, and a cable tester determines if the cable\u2019s wires are connected properly.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      154,
      138,
      152,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 807,
    "question": "In the United States, the Federal Communications Commission (FCC) imposes rules that govern radio communications. What is the maximum EIRP (watts) that can be transmitted in the 2.4 GHz band for a point-to-multipoint WISP connection?",
    "choice_a": "2 watts",
    "choice_b": "4 watts",
    "choice_c": "158 watts",
    "choice_d": "125 mw",
    "correct_answer": "B",
    "explanation": "Wireless Internet Service Providers (WISPs) that are operating in the 2.4 GHz band are limited to 4 watts of Effective Isotropic Radiated Power (EIRP) for their point-to-multipointconnections. Their point-to-point connections vary between 4 watts and 158 watts for the 2.4 GHz band. The maximum EIRP for the 5 GHz bands is 125 mw.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      138,
      139,
      102,
      99,
      145
    ],
    "source": "9781394330348"
  },
  {
    "id": 808,
    "question": "Which Wi-Fi channel range does not require that your router has DFS and TPC built in?",
    "choice_a": "Channels 36 to 48",
    "choice_b": "Channels 52 to 64",
    "choice_c": "Channels 100 to 144",
    "choice_d": "Channels 149 to 165",
    "correct_answer": "A",
    "explanation": "Channels 36 to 48 are set aside for domestic use. All channels above that require a router to have Dynamic Frequency Selection (DFS) and Transmit Power Control (TPC). DFS will automatically switch to a different channel when weather radar and radar system signals are detected. TPC can be used to force clients to transmit using lower power, so they won\u2019t interfere with nearby users or access points on the same channel. Channel 165 is set aside for Industrial, Scientific, and Medical (ISM) use. In the United States, the Federal Communications Commission (FCC) and Institute of Electrical and Electronics Engineers (IEEE) are the authorities that approve channel uses.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      142,
      138,
      140,
      141,
      153
    ],
    "source": "9781394330348"
  },
  {
    "id": 809,
    "question": "Which broadband network communications technology became more competitive with other types of service when, in 2021, the FCC ruled to include it in the OTARD rule, which protects the rights of those organizations to place antennas where they are needed?",
    "choice_a": "Fios",
    "choice_b": "WISPs",
    "choice_c": "DSL",
    "choice_d": "Satellite",
    "correct_answer": "B",
    "explanation": "The Federal Communications Commission\u2019s (FCC\u2019s) Over-The-Air-Reception-Devices (OTARD) ruling was expanded to include long-range fixed wireless network hubs and relay antennas, and the customer\u2019s right to place antennas of certain sizes on their premises, putting Wireless Internet Service Providers (WISPs) on a more equal footing with satellite and cellular providers. Fios is a Fiber-optic service, and DSL is Digital Subscriber Line, a type of antiquated Internet access that uses Plain Old Telephone Service (POTS) lines.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      151,
      150,
      148,
      147,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 810,
    "question": "What is the host number in an IP address of 192.168.2.200 and a subnet mask of 255.255.255.0?",
    "choice_a": "192.168",
    "choice_b": "192.168.2",
    "choice_c": "2.200",
    "choice_d": "200",
    "correct_answer": "D",
    "explanation": "When an IP address and subnet mask are converted to the binary numbers that the computer sees and there is a 1 in the subnet mask, it tells the computer that the corresponding bit in the IP address is part of the network number. Wherever there is a 0 in the subnet mask, the corresponding bit in the IP address is part of the host number. The address in the question 192.168.2.200/24 is a class C private address, where, in the subnet mask, the first three octets (24 bits) are all 1s, and numbers in the last octet (8 bits) are all 0s. So, the first three decimal numbers of the IP address, which are expressed in dotted decimal notation, are the network number (192.168.2), and the last octet (.200) is the host (individual computer) address. Network numbers will always go from left to right, with no breaks between.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      123,
      124,
      121,
      114
    ],
    "source": "9781394330348"
  },
  {
    "id": 811,
    "question": "What are the three As employed by authentication servers?",
    "choice_a": "Authentication, Activation, Acceptance",
    "choice_b": "Authorization, Access, Allocation",
    "choice_c": "Accept, Access, Accounting",
    "choice_d": "Authentication, Authorization, Accounting",
    "correct_answer": "D",
    "explanation": "Authentication servers provide the Authentication, Authorization, and Accounting (AAA) framework for security. Authentication requires that an entity prove who they are before gaining access. Authorization grants the authenticated user access to resources. Accounting tracks and logs user activity.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      126,
      120,
      132,
      125
    ],
    "source": "9781394330348"
  },
  {
    "id": 812,
    "question": "Which Internet appliance is used to distribute incoming traffic over resources such as multiple web servers?",
    "choice_a": "Proxy server",
    "choice_b": "Spam gateway",
    "choice_c": "Load balancer",
    "choice_d": "UTM device",
    "correct_answer": "C",
    "explanation": "Load balancers do as their name implies. Rather than enable all incoming traffic on a port to go to one server or device, the traffic is distributed among devices. Proxy servers monitor incoming and outgoing packets, filtering them out based on specified criteria. Some proxy servers may include a load balancer, however, the device defined in the question is a load balancer, not a proxy server. Spam gateways don\u2019t allow spam in, rather they are used to filter it out. Unified Threat Management (UTM) can employ an appliance or be software-driven, or even be provided by an outside service that monitors and manages malicious activities against a network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      135,
      155,
      114,
      136
    ],
    "source": "9781394330348"
  },
  {
    "id": 813,
    "question": "What type of system, consisting of both hardware and software, is used to control and monitor industrial machines and processes?",
    "choice_a": "SCADA",
    "choice_b": "IrDA",
    "choice_c": "UTM",
    "choice_d": "RADIUS",
    "correct_answer": "A",
    "explanation": "Supervisory Control and Data Acquisition (SCADA) systems are comprised of both hardware and software to control and monitor industrial machines and processes. Hardware is used to gather information, which is sent to a computer running software that analyzes the data and logs events. SCADA can also initiate alarms when specified conditions exist. Infrared Data Association (IrDA) standards specify network communications thatwork via infrared light. Unified Threat Management (UTM) is an appliance, software, or service that combines all malware security in one place. Remote Authentication Dial-In User Service (RADIUS) is a protocol for authentication servers that encrypts transmissions between the client and server.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      136,
      131,
      135,
      114,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 814,
    "question": "Your friend owns a restaurant and provides free Wi-Fi to their clientele. Lately, they have been receiving complaints that the Wi-Fi isn\u2019t working. It seems to work for customers already connected but not for people trying to connect. What can be configured on the router to release an IP address and make it available for other users after a couple of hours?",
    "choice_a": "MAC address filtering",
    "choice_b": "Port forwarding",
    "choice_c": "DHCP lease duration",
    "choice_d": "SSID broadcast",
    "correct_answer": "C",
    "explanation": "A Dynamic Host Configuration Protocol (DHCP) server will \u201clease\u201d an IP address to a client for a specified period of time. The default is usually 24 hours. In a Small Office, Home Office (SOHO) network where there are seldom new users, the lease time could be longer, but in a restaurant where many people come and go each hour, the DHCP scope might not have enough addresses to accommodate that many users. Setting the lease time to a shorter duration will release the IP address and make it available for a new user. Media Access Control (MAC) address filtering only enables connection from computers with specific MAC addresses and would greatly limit connectivity. Port forwarding sends traffic for a specific port to a specified computer on the network. The Service Set Identifier (SSID) is the wireless network name and can be broadcast so it is easily found or can be hidden.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      114,
      108,
      155
    ],
    "source": "9781394330348"
  },
  {
    "id": 815,
    "question": "What type of address is known as a DNS AAAA address?",
    "choice_a": "IPv4",
    "choice_b": "IPv6",
    "choice_c": "MAC",
    "choice_d": "Physical",
    "correct_answer": "B",
    "explanation": "The Domain Name System (DNS) uses two types of records to resolve domain names to IP addresses. Type A records resolve the domain name to IPv4 addresses. Type AAAA records resolve domain names to IPv6 addresses. Media Access Control (MAC) and physical addresses are two names for the Network Interface Card (NIC) address.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      129,
      121,
      122,
      123,
      124
    ],
    "source": "9781394330348"
  },
  {
    "id": 816,
    "question": "What type of entry in a DNS record can be used for load-balancing incoming mail?",
    "choice_a": "MX",
    "choice_b": "DX",
    "choice_c": "AAAA",
    "choice_d": "TXT",
    "correct_answer": "A",
    "explanation": "Multiple Mail Exchange (MX) records can be set up for a domain to specify different mail servers for load balancing. Direct Connect (DX) is an Amazon Web Services (AWS)-dedicated connection between clients and AWS. AAAA signifies an IPv6 address in a Domain Name System (DNS) record, and TXT DNS records let an administrator specify text in their DNS record. These text records can be used to prevent email spam.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      120,
      128,
      134,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 817,
    "question": "What type of DNS technique contains a list of users (i.e., IP addresses) that are authorized to send email on behalf of a domain?",
    "choice_a": "DKIM",
    "choice_b": "SPF",
    "choice_c": "DMARC",
    "choice_d": "A",
    "correct_answer": "B",
    "explanation": "Sender Policy Framework (SPF) is a technique to prevent email address spoofing. It is done using a TXT entry in a domain\u2019s Domain Name System (DNS) service. DomainKeys Identified Mail (DKIM) performs a similar function but uses a digital signature. Domain-based Message Authentication, Reporting, and Conformance (DMARC) uses Sender Policy Framework (SPF) or DKIM, and in addition requires that the sender\u2019s domain is the same as the DNS domain name. Domain administrators can specify to quarantine or reject emails that fail DMARC. To use DMARC, a DMARC record must exist in the DNS.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      129,
      121,
      120,
      131,
      126
    ],
    "source": "9781394330348"
  },
  {
    "id": 818,
    "question": "What is the interface ID of the IP address 2001::1a3:f1a:308:833?",
    "choice_a": "2001:0:0:0:",
    "choice_b": "2001",
    "choice_c": "1a3:f1a:308:833",
    "choice_d": "833",
    "correct_answer": "C",
    "explanation": "This is an IPv6 address. It is 128 bits long, and the last 64 bits are the interface ID, which identifies the individual computer. Because there are eight groups of hex numbers, it means the rightmost four groups are the interface ID. Any leading zeros in an IPv6 address can be omitted, and the:: can be used once in an address to replace consecutive groups of all zeros, so this number, fully expanded, would be 2001:0000:0000:0000:01a3:0f1a:0308:0833. The interface ID is, therefore, 1a3:f1a:308:833. The leftmost three sections identify the network, and the fourth identifies the subnet. In this example, 2001:0:0 is the site prefix, and 0 is the subnet ID. IPv6 addresses do not need a subnet mask like IPv4 addresses do.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      118,
      121,
      106,
      124
    ],
    "source": "9781394330348"
  },
  {
    "id": 819,
    "question": "Which two terms identify an ISP that uses point-to-point millimeter-wave or microwave links as the backbone between its towers while using point-to-multipoint wireless connections to provide Internet access between its towers and its customers? (Choose two.)",
    "choice_a": "WISP",
    "choice_b": "Multimode",
    "choice_c": "Demarcation point",
    "choice_d": "Long-range fixed wireless",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "For decades, Wireless Internet Service Providers (WISPs) have been established by groups of individuals or small companies to provide Internet access to areas where it is not profitable for large commercial Internet providers to run, such as very rural areas. They are also called long-range fixed wireless providers. In 1992, the first one was established in the Midwestern United States. Now, there are thousands of them worldwide. In some areas ofthe world where there is little or no wired infrastructure, WISPs are the only way that people can get Internet connectivity. A WISP connects to the Internet using either leased lines or microwaves, generally uses point-to-point microwaves between its towers, and point-to-multipoint connections between the final tower and users. Multimode is a type of fiber-optic cable that can carry more than one signal and a demarcation point is the place in a customer premises where the responsibility for the network changes from the Internet Service Provider (ISP) to the customer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      148,
      150,
      102,
      113
    ],
    "source": "9781394330348"
  },
  {
    "id": 820,
    "question": "Your friend is again considering the network configuration in their apartment. They\u2019ve asked you to explain the difference between channels on the 2.4 and 5 GHz networks that are available on their Internet connection. What will you tell them? (Choose two.)",
    "choice_a": "If they are using the 2.4 GHz network, they should choose Channel 1, 6, or 11 because they don\u2019t overlap each other.",
    "choice_b": "The 5 GHz network channels provide greater bandwidth, so data could be transferred faster, but they may have more interference with their neighbors.",
    "choice_c": "The 5 GHz frequency is considered obsolete, so the 2.4 GHz frequency should be used.",
    "choice_d": "All the 5 GHz frequencies overlap, so there will be greater interference.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "It\u2019s true that Channels 1, 6, and 11 are the only ones that don\u2019t overlap in a 2.4 GHz network. It\u2019s also true that each channel in a 2.4 GHz network is only about 5 MHz wide, while in a 5 GHz network the minimum channel width is 20 MHz, but it can be configured to use 40 MHz or 80 MHz by combining channels. The 2.4 GHz frequency supports older devices; the 5 GHz frequency is newer. While 2.4 GHz channels overlap except for 1, 6, and 11, 5 GHz channels don\u2019t overlap. Your friend needs to choose a frequency and channel that are compatible with their devices, but the router may automatically configure the channel if using the 5 GHz frequency.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      139,
      142,
      154,
      141
    ],
    "source": "9781394330348"
  },
  {
    "id": 821,
    "question": "What type of server is used to synchronize the time on various network devices?",
    "choice_a": "SQL",
    "choice_b": "Fileshare",
    "choice_c": "DHCP",
    "choice_d": "NTP",
    "correct_answer": "D",
    "explanation": "A Network Time Protocol (NTP) server uses a source like an atomic clock to provide an accurate time, which is used to update devices and enables devices on a network to synchronize with each other. Structured Query Language (SQL) servers are used with databases. Fileshare servers enable easy sharing of files between users and Dynamic Host Configuration Protocol (DHCP) servers lease IP addresses to devices on a network.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      128,
      121,
      130,
      129,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 822,
    "question": "What does an SQL server do?",
    "choice_a": "Provide access to databases.",
    "choice_b": "Provide file downloads to users.",
    "choice_c": "Assign IP addresses to network devices.",
    "choice_d": "Synchronize time between devices.",
    "correct_answer": "A",
    "explanation": "Structured Query Language (SQL) servers are used to store and provide access to databases. A Network Time Protocol (NTP) server uses a source like an atomic clock to provide an accurate time, which is used to update devices, and enables devices on a network to synchronize with each other. Fileshare servers enable easy sharing of files between users and Dynamic Host Configuration Protocol (DHCP) servers lease IP addresses to devices on a network.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      133,
      129,
      130,
      121,
      128
    ],
    "source": "9781394330348"
  },
  {
    "id": 823,
    "question": "What is the job of a spam gateway?",
    "choice_a": "Permit spam in.",
    "choice_b": "Keep spam out.",
    "choice_c": "Filter network packets.",
    "choice_d": "Provide multiple resources for mitigating malware.",
    "correct_answer": "B",
    "explanation": "Unlike a default gateway, spam gateways don\u2019t permit spam in, rather they are used to filter it out. Proxy servers monitor incoming and outgoing packets, filtering them out based on specified criteria. Some proxy servers may include other services such as a load balancer. Unified Threat Management (UTM) systems use multiple methods that can employ an appliance or software or even an outside service to monitor and manage malicious activities against a network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      135,
      134,
      117,
      119,
      121
    ],
    "source": "9781394330348"
  },
  {
    "id": 824,
    "question": "Of the following fiber connectors, which are used for duplex (two strands instead of one)? (Choose two.)",
    "choice_a": "ST",
    "choice_b": "SC",
    "choice_c": "FC",
    "choice_d": "LC",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Both Subscriber Connectors (SC) and Lucent Connectors (LC) are square and can be purchased as single or duplex connectors. SC is square and is a push/pull design. LC connectors are smaller at 1.25 mm and have a latching mechanism to keep them in place, making them good for rack-mount use. Straight Tip (ST) connectors have a bayonet connection. Fiber Channel (FC) connectors have a ferrule core and a threaded coupling. SC, FC, and ST connectors are 2.5 mm. There are other connectors on the market but not on the A+ exam.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      97,
      2
    ],
    "source": "9781394330348"
  },
  {
    "id": 825,
    "question": "What twisted pair connectors are commonly used with telephone wire?",
    "choice_a": "RJ-45",
    "choice_b": "Coaxial",
    "choice_c": "RJ-11",
    "choice_d": "FC",
    "correct_answer": "C",
    "explanation": "RJ-11 accommodates two pair of wires and is the standard for household- or office-wired telephone connections. RJ-45 is the four-pair connector used for twisted pair Ethernet. Coaxial cable is a type of network cable and has a Bayonet Neill-Concelman (BNC) connector (with a locking mechanism) or an F-type connector. Fiber Channel (FC) connectors are a type of fiber-optic connector.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      63,
      60,
      61,
      55,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 826,
    "question": "Using the T568B wiring standard on both ends of a cable would produce what type of network cable?",
    "choice_a": "T568B on both ends is not a working network cable.",
    "choice_b": "T568B is a telephone-wiring standard.",
    "choice_c": "T568B on both ends is a crossover network cable.",
    "choice_d": "T568B on both ends is a straight-through network cable.",
    "correct_answer": "D",
    "explanation": "A cable with the same T568 standard on both ends is a straight-through network cable. These are used for patch cables and network drops. If you have a T568A on one end and a T568B on the other, that\u2019s a crossover cable.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      29,
      63,
      90,
      95,
      94
    ],
    "source": "9781394330348"
  },
  {
    "id": 827,
    "question": "You\u2019re looking at a connector that has eight wires with colors in the order of green stripe, green, orange stripe, blue, blue stripe, orange, brown stripe, and brown. What type of cable do you have?",
    "choice_a": "Twisted pair, T568A standard",
    "choice_b": "Twisted pair, T568B standard",
    "choice_c": "LC",
    "choice_d": "SC",
    "correct_answer": "A",
    "explanation": "The color code listed is the T568A standard. In the T568B standard, the orange and green colors are opposite. Lucent Connectors (LC) and Subscriber Connectors (SC) are fiber-optic connectors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      63,
      60,
      56,
      61,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 828,
    "question": "You need to install a memory upgrade in a laptop computer. The computer\u2019s documentation says that the laptop uses DDR4 SODIMMs. How many pins will be on the SODIMM?",
    "choice_a": "262",
    "choice_b": "200",
    "choice_c": "204",
    "choice_d": "260",
    "correct_answer": "D",
    "explanation": "Double Data Rate 4 (DDR4) Small Outline Dual In-line Memory Modules (SODIMMs) have 260 pins, Double Data Rate 3 (DDR3) SODIMMs have 204 pins, and Double Data Rate 5 (DDR5) SODIMMs have 262 pins.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      18,
      16,
      26,
      6,
      15
    ],
    "source": "9781394330348"
  },
  {
    "id": 829,
    "question": "The most common RAM slots used in desktop and laptop computers, respectively, are what?",
    "choice_a": "SODIMM and DIMM",
    "choice_b": "Micro-DIMM and DIMM",
    "choice_c": "DIMM and Mini-DIMM",
    "choice_d": "DIMM and SODIMM",
    "correct_answer": "D",
    "explanation": "The type of Random Access Memory (RAM) modules used by desktop computers are Dual Inline Memory Modules (DIMMs), and laptops most commonly use Small Outline DIMMs (SODIMMs). Another potential laptop memory form factor is the Micro-DIMM, which is used in super-lightweight laptop computers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      18,
      6,
      9,
      20,
      16
    ],
    "source": "9781394330348"
  },
  {
    "id": 830,
    "question": "Which laptop expansion port was designed as an industry standard to replace VGA and DVI ports and is backward compatible with both standards?",
    "choice_a": "DisplayPort",
    "choice_b": "VideoPort",
    "choice_c": "Thunderbolt",
    "choice_d": "HDMI",
    "correct_answer": "A",
    "explanation": "The Video Electronics Standards Association (VESA) introduced DisplayPort technology in 2008. It was designed to be an industry standard and to replace Video Graphics Array (VGA) and Digital Video Interface (DVI) connections. It\u2019s also backward compatible with VGA and DVI by using adapters. A DisplayPort connection is intended for video devices only, but like High-Definition Multimedia Interface (HDMI) and Universal Serial Bus (USB), it can transmit audio and video simultaneously.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      62,
      63,
      59,
      60,
      61
    ],
    "source": "9781394330348"
  },
  {
    "id": 831,
    "question": "You have a MacBook Pro computer with a Thunderbolt 4 port. What is the maximum throughput of a device plugged into this port?",
    "choice_a": "5 Gbps",
    "choice_b": "10 Gbps",
    "choice_c": "20 Gbps",
    "choice_d": "40 Gbps",
    "correct_answer": "D",
    "explanation": "The first version of Thunderbolt supported 10 Gbps data rates, which is fast. Thunderbolt 2.0 joins two 10 Gbps channels together for 20 Gbps throughput. But Thunderbolt 3 and Thunderbolt 4 provide 40 Gbps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      56,
      63,
      2,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 832,
    "question": "Which motherboard form factor measures 4.7\u2033 \u00d7 4.7\u2033?",
    "choice_a": "Mini-ITX",
    "choice_b": "Nano-ITX",
    "choice_c": "Pico-ITX",
    "choice_d": "Mobile-ITX",
    "correct_answer": "B",
    "explanation": "Nano-ITX motherboards are 4.7-inch square, a Mini-ITX motherboard is 6.7-inch square, pico-ITX motherboards are 3.9 \u00d7 2.8 inches, and mobile-ITX motherboards are 2.4-inch square.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      9,
      11,
      3,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 833,
    "question": "What term do technicians use to refer to the size and specific placement of components on a circuit board?",
    "choice_a": "ATX",
    "choice_b": "Array",
    "choice_c": "Orientation",
    "choice_d": "Form factor",
    "correct_answer": "D",
    "explanation": "The form factor of something defines its size, placement of components and connectors, as well as to what it can be attached. Many devices have form factors, such as Central Processing Unit (CPU) sockets, motherboards, and Random Access Memory (RAM) modules. ATX is a type of form factor. An array is a group of something such as a hard drive array, and orientation refers to the positioning of a connector.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      11,
      18,
      36,
      9
    ],
    "source": "9781394330348"
  },
  {
    "id": 834,
    "question": "You have been asked to design a new network for a client and will be using fiber-optic cable. Which type of optical cable is more expensive but can send a signal over a much greater distance?",
    "choice_a": "Multimode",
    "choice_b": "Single mode",
    "choice_c": "Cat 7",
    "choice_d": "RG6",
    "correct_answer": "B",
    "explanation": "Single-mode fiber-optic cable can send a reliable signal over a much greater distance (up to hundreds of km, depending on the cable\u2019s dispersion rate and attenuation) than Multimode Fiber (MMF), but on the downside, it is more expensive. Cat 7 is a type of shielded twisted pair copper cable that is not sanctioned by the Institute of Electrical and Electronics Engineers (IEEE). RG6 is coaxial cable often used in cable Internet services.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      60,
      62,
      63,
      35,
      39
    ],
    "source": "9781394330348"
  },
  {
    "id": 835,
    "question": "You need to update a twisted pair cable that runs between two networking closets. The total distance is only 20 meters, and it must run at 10 Gbps. What is the lowest category of cable that you can replace it with?",
    "choice_a": "Cat 6",
    "choice_b": "Cat 6a",
    "choice_c": "Cat 7",
    "choice_d": "Cat 8",
    "correct_answer": "A",
    "explanation": "Category 6 cable will work for the implementation described. It is capable of 10 Gbps but only for a distance of 55 meters. Category 6a can go 100 meters at 10 Gbps. Cat 7 is not an Institute of Electronical and Electronics Engineer (IEEE) standard, nor is it approved by Telecommunications Industry Association/Electronic Industries Alliance (TIA/EIA), and it doesn\u2019t use a standard RJ-45 connector. Cat 8 is IEEE-approved; it can support 10 Gbps over 100 meters and can support 40 Gbps but only over very short distances, which makes it good for things like a Storage Area Network (SAN).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      63,
      57,
      60,
      2
    ],
    "source": "9781394330348"
  },
  {
    "id": 836,
    "question": "A technician is considering whether to buy a new LCD. Which type of LCD has faster response times than the others?",
    "choice_a": "TN",
    "choice_b": "VA",
    "choice_c": "IPS",
    "choice_d": "OLED",
    "correct_answer": "A",
    "explanation": "Twisted Nematic (TN) Liquid Crystal Displays (LCDs) have the fastest response times. The In-Plane Switching (IPS) display type is quick enough for someone interested in gaming. Vertical Alignment (VA) displays are slower than IPS displays. An Organic Light-Emitting Diode (OLED) is not a type of LCD.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      48,
      49,
      50,
      51,
      52
    ],
    "source": "9781394330348"
  },
  {
    "id": 837,
    "question": "What encryption device is a part of a computer system, can be either hardware or software, and will encrypt all data on a specific device so it can\u2019t be accessed unless it is present?",
    "choice_a": "HSM",
    "choice_b": "BIOS",
    "choice_c": "ITX",
    "choice_d": "TPM",
    "correct_answer": "D",
    "explanation": "The Hardware Security Module (HSM) and Trusted Platform Module (TPM) both encrypt data. The TPM, which can be hardware or software, is integrated into a motherboard for protecting a specific device, whereas the HSM is a piece of removable hardware used to hold encryption keys for a system. An HSM would more likely be found in an enterprise setting. The Basic Input/Output System (BIOS), or Unified Extensible Firmware Interface (UEFI), is the program the Central Processing Unit (CPU) uses to start up the system after being powered on. Information Technology Extended (ITX) is a motherboard form factor.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      1,
      11,
      6,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 838,
    "question": "You need to share printers on your network with multiple client operating systems, such as Windows, macOS, and Linux. Which of the following services will best meet your needs?",
    "choice_a": "Bonjour",
    "choice_b": "Cloud printing",
    "choice_c": "TCP printing",
    "choice_d": "Virtual printing",
    "correct_answer": "C",
    "explanation": "Transmission Control Protocol (TCP) printing enables clients with different Operating Systems (OSs) to send jobs directly to printers without worrying about intra-OS conflicts. Bonjour is an Apple service and cloud printing is printing over the Internet and doesn\u2019t affect the issue being addressed. Virtual printing enables device users to print output to documents like PDF files. Whenever sharing printers for remote printing, be sure to set proper user authentication on the print device.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      93,
      92,
      94,
      90,
      95
    ],
    "source": "9781394330348"
  },
  {
    "id": 839,
    "question": "Which one of the following connector types are you most likely to find on the end of a Cat 6a cable?",
    "choice_a": "RJ-11",
    "choice_b": "RJ-45",
    "choice_c": "BNC",
    "choice_d": "SATA",
    "correct_answer": "B",
    "explanation": "A Cat 6a cable is a twisted pair network cable, and you are most likely to find an RJ-45 connector at the end of it. RJ-11 connectors are used in analog phone lines. Bayonet Neill-Concelman (BNC) connectors are network connectors but are used with coaxial cable. Serial Advanced Technology Attachment (SATA) connectors are used with hard drives.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      29,
      63,
      4,
      62,
      60
    ],
    "source": "9781394330348"
  },
  {
    "id": 840,
    "question": "What type of printer technology uses a roll of paper as opposed to individual sheets?",
    "choice_a": "Inkjet",
    "choice_b": "Thermal",
    "choice_c": "Laser",
    "choice_d": "Fax machine",
    "correct_answer": "B",
    "explanation": "Thermal printers use a roll of special thermal paper as opposed to individual sheets. Impact printers may also use rolls of paper but with tractor-feed holes on the sides. Impact printers generally use multipart forms, because printing on multiple copies at once is their unique ability. Inkjet and laser printers, as well as fax machines, typically use individual sheets of paper.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81,
      73,
      74,
      79,
      77
    ],
    "source": "9781394330348"
  },
  {
    "id": 841,
    "question": "Which of the following types of printers does not require the replacement of some sort of ink or toner?",
    "choice_a": "Laser",
    "choice_b": "Thermal",
    "choice_c": "Impact",
    "choice_d": "Inkjet",
    "correct_answer": "B",
    "explanation": "Laser printers need toner cartridges, impact printers need ink ribbons, and inkjet printers use ink cartridges. Thermal printers apply heat to special thermal paper to produce images.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81,
      77,
      73,
      74,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 842,
    "question": "You are working on repairing a defective laser printer. Which of the following is a true statement regarding the imaging drum in a laser printer?",
    "choice_a": "It can hold a high negative charge only when it\u2019s not exposed to light.",
    "choice_b": "It can hold a high negative charge only when it\u2019s exposed to light.",
    "choice_c": "It can hold a high negative charge regardless of light exposure.",
    "choice_d": "It is not required to hold a charge.",
    "correct_answer": "A",
    "explanation": "An imaging drum is a photosensitive drum that can hold a high negative charge if it\u2019s not exposed to light. It is dark inside an electrophotographic (EP) printer, except when the laser scanning assembly shines on particular areas of the photosensitive drum, reducing the high negative charge to a much lower negative charge. Toner itself is negatively charged and repelled by the highly negatively charged areas but attracted to the areas with a very low charge. The use of varying negative charges is what facilitates the printing process. When replacing a photosensitive drum, it\u2019s best to avoid exposing it to light.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      77,
      80,
      79,
      78,
      81
    ],
    "source": "9781394330348"
  },
  {
    "id": 843,
    "question": "What are the dimensions of a Mini-ITX motherboard?",
    "choice_a": "12\u2033 \u00d7 9.6\u2033",
    "choice_b": "9.6\u2033 \u00d7 9.6\u2033",
    "choice_c": "6.7\u2033 \u00d7 6.7\u2033",
    "choice_d": "3.9\u2033 \u00d7 2.8\u2033",
    "correct_answer": "C",
    "explanation": "Information Technology eXtended (ITX) motherboards are available in various sizes. The Mini-ITX standard boards are 6.7-inch square (or more precisely, 6.69-inch square). Advanced Technology eXtended (ATX) motherboards are 12\u2033 \u00d7 9.6\u2033. A micro-ATX motherboard is 9.6-inch square, Pico-ITX motherboards are 3.9\u2033 \u00d7 2.8\u2033, while Nano-ITX motherboards are 12cm \u00d7 12cm (about 4.7-inch square).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      2,
      6,
      43,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 844,
    "question": "When discussing video displays, what is the term used to describe the number of pixels that can be displayed by a device, width by height?",
    "choice_a": "Refresh rate",
    "choice_b": "Pixel density",
    "choice_c": "Aspect ratio",
    "choice_d": "Resolution",
    "correct_answer": "D",
    "explanation": "Resolution is the number of pixels that a given device is capable of displaying, and is expressed as two numbers, such as 1366 \u00d7 768. Refresh rate determines how many times per second the screen can be redrawn. Pixel density is a measure of how many pixels a device can display in a specified space, such as Pixels Per Inch (PPI). A larger display with the same resolution will have a lower pixel density. Aspect ratio defines the relationship between the dimensions (width \u00d7 height) of a display or image. For example, a screen that has a maximum resolution of 1366 \u00d7 768 has an aspect ratio of 16:9. For every 9 pixels in height, there are 16 pixels in width.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      51,
      53,
      49,
      48,
      50
    ],
    "source": "9781394330348"
  },
  {
    "id": 845,
    "question": "You have three hard disks, each 1 TB in size. After installing them as a RAID-5 array in a computer, how much usable storage space will you have?",
    "choice_a": "1.5 TB",
    "choice_b": "2 TB",
    "choice_c": "2.5 TB",
    "choice_d": "3 TB",
    "correct_answer": "B",
    "explanation": "In a Redundant Array of Independent Disk-5 (RAID-5) array, each stripe places data on n\u20131 disks, and parity computed from the data is placed on the remaining disk. The parity is interleaved across all the drives in the array, so that neighboring stripes have parity on different disks. Said differently, you lose the equivalent of one hard disk worth of storage to hold the parity information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      33,
      40,
      35,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 846,
    "question": "What hardware device is used to store encryption keys, making them safer because they are never directly loaded into a server\u2019s memory?",
    "choice_a": "HSM",
    "choice_b": "BIOS",
    "choice_c": "ITX",
    "choice_d": "TPM",
    "correct_answer": "A",
    "explanation": "The Hardware Security Module (HSM) is a piece of hardware that can be removed and is used to hold encryption keys for a system. It differs from Trusted Platform Module (TPM) implementations in that TPM is a chip (or added card) on the motherboard and not a separate piece of hardware. A TPM can also be software and is used to encrypt hard drives. The Basic Input/Output System (BIOS) or Unified Extensible Firmware Interface (UEFI) is the program the Central Processing Unit (CPU) uses to start up the system after being powered on. Information Technology eXtended (ITX) is a motherboard form factor.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      14,
      9,
      6,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 847,
    "question": "You need to enable clients to scan documents and place them in network accessible storage, regardless of the MFD\u2019s location worldwide. Which service will best suit your needs?",
    "choice_a": "Bonjour",
    "choice_b": "TCP printing",
    "choice_c": "Virtual printing",
    "choice_d": "Cloud services",
    "correct_answer": "D",
    "explanation": "Many modern Multifunction Devices (MFDs) have the ability to connect to the cloud, then email and/or store scanned documents and images directly from the device withoutrequiring a connected PC. The documents are made accessible worldwide via services such as Dropbox, Evernote, or Google Drive. Bonjour is an Apple printing technology. Although TCP is used in many applications and processes, TCP printing means specifically locating a printer based on its TCP/IP address by configuring that address into the settings. It\u2019s not the same as cloud printing. Virtual printing enables a user to print to a file like a PDF instead of to a physical printer.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      95,
      90,
      94,
      89,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 848,
    "question": "What is the most important consideration when installing a network-connected multifunction device that is capable of directly scanning to email?",
    "choice_a": "Print quality",
    "choice_b": "Duplexing",
    "choice_c": "Security",
    "choice_d": "Speed",
    "correct_answer": "C",
    "explanation": "The ability of multifunction devices to email and scan without a PC means that these devices need to be hardened the same way any other device with a network connection needs to be. Secure protocols must be present to protect sensitive corporate information. Duplexing means printing on both sides of a paper.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      95,
      90,
      92,
      5,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 849,
    "question": "What protocol is often used when scanning documents from a large multifunction device and sending them to the corporate server?",
    "choice_a": "TPM",
    "choice_b": "HSM",
    "choice_c": "SNMP",
    "choice_d": "SMB",
    "correct_answer": "D",
    "explanation": "Server Message Block (SMB) is the secure protocol used when scanning documents from a multifunction device to a server. Trusted Platform Module (TPM) and Hardware Security Module (HSM) are security encryption devices, not protocols. Simple Network Management Protocol (SNMP) is used to gather information from managed switches and other devices across a network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      95,
      92,
      29,
      5,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 850,
    "question": "What features are included in modern networked MFDs? (Choose all that apply.)",
    "choice_a": "Email",
    "choice_b": "Scanning",
    "choice_c": "Printing",
    "choice_d": "Faxing",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "While faxing isn\u2019t used as much as it once was, it is still a feature available on some Multifunction Devices (MFDs). Email, scanning, and printing are also common features.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      95,
      92,
      90,
      93,
      76
    ],
    "source": "9781394330348"
  },
  {
    "id": 851,
    "question": "Which of the following connectors transmit analog signals? (Choose two.)",
    "choice_a": "VGA",
    "choice_b": "RJ-45",
    "choice_c": "RJ-11",
    "choice_d": "HDMI",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Video Graphics Array (VGA) is an analog video connector, and Registered Jack-11 (RJ-11) connectors are used with traditional analog phone lines and modems. Modems receive a digital signal from a computer, then modulate that signal to analog to transmit over analog lines. On the other end, they demodulate the signal into a digital one again, which a computer or other digital device can understand. RJ-45 connectors are used in networking, and High-Definition Multimedia Interface (HDMI) connections carry digital audio and video signals.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      63,
      61,
      29,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 852,
    "question": "Your partner wants to know what this port is on the back of their computer. What will you tell them?<img src=\"/question_assets/220-1201/c03f004.png\" alt=\"Illustration of a rectangular port structure with internal pins.\"/>\n\n<figcaption>Illustration of a rectangular port structure with internal pins.</figcaption>",
    "choice_a": "eSATA",
    "choice_b": "DisplayPort",
    "choice_c": "DVI port",
    "choice_d": "HDMI port",
    "correct_answer": "B",
    "explanation": "The port shown is a DisplayPort. There is also a mini-DisplayPort, which is simply a smaller version of the DisplayPort. But the port in the image is a full-size DisplayPort. External Serial Advanced Technology Attachment (eSATA) ports provide an external connection for a SATA device. Digital Visual Interface (DVI) connections transmit digital video signals and High-Definition Multimedia Interface (HDMI) connectors provide digital connections for video and audio transmission.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      63,
      60,
      61,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 853,
    "question": "You have a motherboard that supports up-plugging. Which of the following statements regarding PCIe are true? (Choose two.)",
    "choice_a": "You can put an x1 card into an x8 slot.",
    "choice_b": "You can put an x8 card into an x16 slot.",
    "choice_c": "You can put an x8 card into an x1 slot.",
    "choice_d": "You can put an x16 card into an x8 slot.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "With up-plugging, you can put a smaller Peripheral Component Interconnect Express (PCIe) card into a larger slot, even though it does not fill it up completely. For example, you can insert an x8 card into an x16 slot. The x8 card won\u2019t completely fill the slot, but it will work at x8 speeds. It\u2019s important to note that a motherboard doesn\u2019t necessarily support this feature, so if you plan to use a smaller card in a larger PCIe slot, ensure the motherboard supports up-plugging, or the card will run at 1x speed.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      2,
      30,
      27,
      35,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 854,
    "question": "A technician needs to increase the fault tolerance of their computer\u2019s storage system, and they have two hard drives available. Which of the following options is their best choice?",
    "choice_a": "Install both drives and configure them as separate volumes.",
    "choice_b": "Install both drives and implement RAID-0.",
    "choice_c": "Install both drives and implement RAID-1.",
    "choice_d": "Install both drives and implement RAID-5.",
    "correct_answer": "C",
    "explanation": "Redundant Array of Independent Disks-1 (RAID-1) provides disk mirroring\u2014it writes data simultaneously to both drives. If one drive fails, the other drive still has a working copy of the data. RAID-0 is disk striping and does not provide fault tolerance. RAID-5 is striping with parity and provides speed and fault tolerance, but it requires a minimum of three hard disks to function.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      33,
      4,
      46,
      39
    ],
    "source": "9781394330348"
  },
  {
    "id": 855,
    "question": "Your friend is an artist and wants an LCD monitor with the best image depth and contrast. Which of the following should they choose?",
    "choice_a": "OLED",
    "choice_b": "VA",
    "choice_c": "IPS",
    "choice_d": "TN",
    "correct_answer": "B",
    "explanation": "They should choose a Vertical Alignment (VA) Liquid Crystal Display (LCD) monitor. There are three types of LCD technologies listed in the A+ exam objectives: TN, IPS, and VA. Twisted nematic (TN) was developed first and uses less power compared to the other two. The issue with TN LCD screens is that when you begin viewing them at wider angles, the picture quality greatly suffers. In-Plane Switching (IPS) LCD displays provide better color representation as well as wider-angle viewing, but they tend to be a bit more expensive and have somewhat slower response times. Vertical Alignment (VA) LCD displays have slower response times than either IPS or TN; however, they have the best contrast and image depth. Organic Light-Emitting Diode (OLED) displays use organic materials to create light and color. They are not a type of LCD display. There are also micro-LED and mini-LED displays.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      48,
      49,
      53,
      50,
      60
    ],
    "source": "9781394330348"
  },
  {
    "id": 856,
    "question": "Which type of smartphone display has fewer layers, thereby providing more flexibility, a better viewing angle, and excellent color as compared to other technologies?",
    "choice_a": "IPS",
    "choice_b": "OLED",
    "choice_c": "LED",
    "choice_d": "TN",
    "correct_answer": "B",
    "explanation": "Many newer smartphones boast Organic Light-Emitting Diode (OLED) displays due to their light weight, flexibility, color depth, and wider viewing angle. In-Plane Switching (IPS) is a popular type of LCD that requires backlighting to display the image. Twisted Nematic (TN) was the first Liquid Crystal Display (LCD) technology developed. It uses less power and has a limited viewing angle but supports very fast refresh rates. All modern LCD displays use Light-Emitting Diodes (LEDs) for backlighting, instead of Cold Cathode Fluorescent Lamps (CCFLs). OLED displays don\u2019t need a backlight because their carbon-based material can emit light and color.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      49,
      48,
      53,
      51,
      50
    ],
    "source": "9781394330348"
  },
  {
    "id": 857,
    "question": "The motherboard in your desktop computer supports dual-channel memory. Which of the following statements regarding RAM in this motherboard are true? (Choose two.)",
    "choice_a": "The RAM will work only if it\u2019s installed in pairs.",
    "choice_b": "The RAM will work only if it\u2019s installed in pairs or if one double-sided RAM module is used.",
    "choice_c": "The RAM will work if only one module is installed but not in dual-channel mode.",
    "choice_d": "The RAM will work in dual-channel mode if two identical modules are installed.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "With most dual-channel motherboards, Random Access Memory (RAM) will work just fine if one module is installed. However, you will get better performance if you fill the entire bank. If there is only one RAM module installed in one channel, then you can\u2019t possibly take advantage of the dual-channel architecture.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      15,
      6,
      18,
      19,
      16
    ],
    "source": "9781394330348"
  },
  {
    "id": 858,
    "question": "A customer wants you to upgrade their motherboard so that they can have the fastest video connection possible. They want to know how fast PCIe 4 is. What will you tell them the data rate of a single lane of PCIe 4 is?",
    "choice_a": "250 MBps",
    "choice_b": "500 MBps",
    "choice_c": "1 GBps",
    "choice_d": "2 GBps",
    "correct_answer": "D",
    "explanation": "There are six major versions of Peripheral Component Internet Express (PCIe) currently specified: 1.x, 2.x, 3.0, 4.0, 5.0, and 6.0. Each version doubles the data transfer rate of the version before. In each version, a single bidirectional lane operates at a data rate of 250 Megabytes per second (MBps), 500 MBps, approximately 1 Gigabyte per second (GBps), roughly 2 GBps, nearly 4 GBps for version 5.0, and nearly 8 GBps in version 6.0. In any version of PCIe, there can be up to 16 lanes, so, in theory, a PCIe 4.0 x16 connector could transfer nearly 32 GB/s (1.969 GB/s per lane, multiplied by16 lanes). You might find it helpful in your studies to locate or create a chart of the different versions and bandwidth for x1, x4, x8 and x16. You may also see the speed expressed in mega transfers per second (MT/s) or giga transfers per second (GT/s).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      27,
      35,
      56,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 859,
    "question": "A technician needs to replace a failed power supply in a desktop computer. When choosing a replacement power supply, which two specifications are most important to consider? (Choose two.)",
    "choice_a": "Wattage",
    "choice_b": "Multiple rail",
    "choice_c": "Dual voltage options",
    "choice_d": "Number and type of connectors",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "When installing or replacing a power supply, always ensure that it has enough wattage to power the computer\u2019s components. In addition, it must have enough of the right connectors to connect to all the components that require their own power. Multiple rail and dual voltage are optional features.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      43,
      44,
      41,
      45,
      47
    ],
    "source": "9781394330348"
  },
  {
    "id": 860,
    "question": "You\u2019ve been asked to replace the old magnetic hard drive in your manager\u2019s laptop with a high-speed, high-capacity drive. What are the most common issues associated with this request? (Choose two.)",
    "choice_a": "Increased battery usage",
    "choice_b": "Increased heat production",
    "choice_c": "Decreased component life span",
    "choice_d": "Decreased space for other peripherals",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Faster hard drives transfer more data than slower hard drives, but there is no specific correlation between hard drive speed and its life span. The downsides to having faster hard drives can be increased battery usage and heat production.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      33,
      25,
      44,
      34,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 861,
    "question": "You have a motherboard with a white expansion slot, which has a divider closer to the center of the motherboard than the outside, and looks like the three shown here. What type of expansion slot is this?<img src=\"/question_assets/220-1201/c03f005.png\" alt=\"Close-up of a computer motherboard with three white P C I slots and connectors.\"/>\n\n<figcaption>Close-up of a computer motherboard with three white P C I slots and connectors.</figcaption>",
    "choice_a": "PCIe x1",
    "choice_b": "SATA",
    "choice_c": "PCI",
    "choice_d": "eSATA",
    "correct_answer": "C",
    "explanation": "The slot described is a Peripheral Component Interconnect (PCI) slot. It used a 32-bit or 64-bit bus. The first version was released in 1992, and they remained popular until Peripheral Component Interconnect Express (PCIe) was developed. Some motherboards have PCI and PCIe slots on them. PCI and PCIe are not physically compatible. Serial Advanced Technology Attachment (SATA) is a type of hard drive connection, while External Serial Advanced Technology Attachment (eSATA) is a specific type of connector, with a shape slightly different from SATA, which provides a SATA technology connection on the outside of a case.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      4,
      30,
      43,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 862,
    "question": "A designer from the corporate office is visiting your field office. They try to print from their MacBook Pro to a networked printer, but it does not work. Local users in the office are able to print to the device using their Windows computers. What would most likely solve the problem?",
    "choice_a": "Select the Enable Mac Printing option in the print server configuration settings.",
    "choice_b": "Select the Enable Bonjour option in the print server configuration settings.",
    "choice_c": "Install a macOS printer driver on the print server.",
    "choice_d": "Stop and restart the print spooler service.",
    "correct_answer": "C",
    "explanation": "Print servers need to have the appropriate drivers for the printer model and all operating systems that will be clients. It\u2019s possible that this print server does not have the macOS driver installed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      91,
      90,
      93,
      92,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 863,
    "question": "A user whom you support needs to replace a cable. What type of peripheral connector, shown here, will you be looking for?<img src=\"/question_assets/220-1201/c03f006.png\" alt=\"Close-up of U S B cable connector.\"/>\n\n<figcaption>Close-up of U S B cable connector.</figcaption>",
    "choice_a": "USB Type A",
    "choice_b": "USB Type B",
    "choice_c": "USB Standard mini-B",
    "choice_d": "Thunderbolt",
    "correct_answer": "B",
    "explanation": "The connector shown is USB Type B. It will plug into the Universal Serial Bus (USB) peripheral device and is commonly used by printers. USB type A typically plugs into a printer port. USB mini-B is a smaller version of the USB B connector, and a Thunderbolt connector looks like a USB-C connector.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      63,
      90,
      30,
      59
    ],
    "source": "9781394330348"
  },
  {
    "id": 864,
    "question": "Which of the following are advantages of using a CPU liquid cooling system over an air-based system? (Choose two.)",
    "choice_a": "Easier to install and maintain",
    "choice_b": "More efficient",
    "choice_c": "Quieter",
    "choice_d": "Safer for internal components",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Liquid cooling systems are generally quieter than air-based systems that use fans, and they are more efficient at cooling the processor. However, they are more complex to install, and if the liquid were to leak out, it could cause damage to internal components.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      24,
      22,
      21,
      25,
      49
    ],
    "source": "9781394330348"
  },
  {
    "id": 865,
    "question": "You need to perform preventive maintenance on an impact printer. What area should you examine that you would not need to examine on an inkjet printer?",
    "choice_a": "Printhead",
    "choice_b": "Ink cartridges",
    "choice_c": "Output tray",
    "choice_d": "Tractor-feed mechanism",
    "correct_answer": "D",
    "explanation": "Impact printers most often use tractor-feed mechanisms to load the paper, and they can wear down or get bogged down by paper debris. Printheads are found on both inkjet and impact printers, although they are very different from one device to the other. Ink cartridges provide the color on ink jet printers, and the output trays found on inkjet printers are not needed with impact printers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      73,
      96,
      74,
      75,
      78
    ],
    "source": "9781394330348"
  },
  {
    "id": 866,
    "question": "Which expansion bus technology uses lanes, which are switched point-to-point signal paths between two components?",
    "choice_a": "PCI",
    "choice_b": "PCI-X",
    "choice_c": "PCIe",
    "choice_d": "Mini-PCI",
    "correct_answer": "C",
    "explanation": "Peripheral Component Interconnect Express (PCIe) uses lanes. Each lane between any two intercommunicating devices consists of a separate pair of wires\u2014one for each direction of traffic\u2014that dramatically increases speed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      30,
      35,
      27,
      32
    ],
    "source": "9781394330348"
  },
  {
    "id": 867,
    "question": "A large display with a wide viewing angle is needed for a small conference room. Which type of LCD would be best?",
    "choice_a": "VA",
    "choice_b": "IPS",
    "choice_c": "LED",
    "choice_d": "OLED",
    "correct_answer": "B",
    "explanation": "Of the Liquid Crystal Display (LCD) choices given, In-Plane Switching (IPS) has the better viewing angle. Liquid Crystal Displays (LCDs) can be Twisted Nematic (TN), IPS, or Vertical Alignment (VA). VA has a greater contrast ratio, but it has a narrower viewing angle than IPS. Light-Emitting Diode (LED) refers to a type of backlighting, and Organic Light-Emitting Diode (OLED) displays are not a type of LCD.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      48,
      49,
      51,
      50,
      52
    ],
    "source": "9781394330348"
  },
  {
    "id": 868,
    "question": "You\u2019re considering purchasing a new display. Which of the following display lighting technologies can produce a million-to-one contrast ratio, in addition to providing excellent picture quality and no burn-in?",
    "choice_a": "IPS",
    "choice_b": "OLED",
    "choice_c": "mini-LED",
    "choice_d": "VA",
    "correct_answer": "C",
    "explanation": "All modern Liquid Crystal Displays (LCDs) are illuminated by Light Emitting Diodes (LEDs). Mini-LED displays use very tiny LEDs to provide backlight to LCD displays. Their contrast is close to what Organic Light-Emitting Diode (OLED) displays produce; however, the mini-LED displays are not prone to burn-in, while the OLED displays are. Mini-LED displays generally have a greater lifespan than OLED displays, which produce light by applying electricity to organic material, causing it to glow. OLEDs are not a type of LCD display. Twisted Nematic (TN), Vertical Alignment (VA), and In-Plane Switching (IPS) are methods used to manipulate the liquid crystals in an LCD display.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      49,
      48,
      53,
      50,
      52
    ],
    "source": "9781394330348"
  },
  {
    "id": 869,
    "question": "Your motherboard has three PCIe x16 v 4.0 slots and does not support up-plugging for PCIe adapter cards. Which of the following statements is true?",
    "choice_a": "You can\u2019t put an x8 card into an x16 slot.",
    "choice_b": "You can put an x8 card into an x16 slot, but it will run at x1 speed.",
    "choice_c": "You can put an x8 card into an x16 slot, and it will run at x8 speed.",
    "choice_d": "You can put an x8 card into an x16 slot, and it will run at x16 speed.",
    "correct_answer": "B",
    "explanation": "The x8 card won\u2019t completely fill the x16 slot, but it will work at x8 speeds, if up-plugging is supported by the motherboard. Otherwise, the specification requires up-plugged devices to operate at only the x1 rate.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      27,
      30,
      35,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 870,
    "question": "Which system component enables the use of Secure Boot technology?",
    "choice_a": "BIOS",
    "choice_b": "UEFI",
    "choice_c": "AMI",
    "choice_d": "SATA",
    "correct_answer": "B",
    "explanation": "Secure Boot is an option enabled in system firmware. Basic Input/Output System (BIOS) is not technically advanced enough to manage Secure Boot, but its successor, Unified Extensible Firmware Interface (UEFI), is. AMI (formerly American Megatrends) is a BIOS manufacturer, and Serial Advanced Technology Attachment (SATA) is a type of hard drive technology.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      5,
      13,
      2,
      7,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 871,
    "question": "Motherboard documentation for a desktop computer mentions 240-pin DIMM slots. What type of DIMM is used on this motherboard?",
    "choice_a": "DDR3",
    "choice_b": "DDR4",
    "choice_c": "DDR5",
    "choice_d": "SODIMM",
    "correct_answer": "A",
    "explanation": "Double Data Rate 3 (DDR3) Dual In-Line Memory Modules (DIMMs) have 240 pins. DDR4 and DDR5 DIMMs have 288 pins, but they are not interchangeable and have notches (module keys) in different locations to prevent installing the incorrect modules into a motherboard. Small Outline DIMMS (SODIMMs) are laptop Random Access Memory (RAM), not desktop RAM.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      16,
      18,
      26,
      6,
      15
    ],
    "source": "9781394330348"
  },
  {
    "id": 872,
    "question": "DDR4 and DDR5 DIMMs have the same number of pins. How can you tell the difference between the two?",
    "choice_a": "Placement of the module key (notch).",
    "choice_b": "Color of the module.",
    "choice_c": "Size of the module.",
    "choice_d": "DDR5 have heat sinks; DDR4 don\u2019t.",
    "correct_answer": "A",
    "explanation": "The module key, also called a notch, on a Double Data Rate 5 (DDR5) Dual In-Line Memory Modules (DIMMs) is at the center of the module, whereas the Double Data Rate 4 (DDR4) DIMM is slightly off center. Both are sold with heat sinks attached and come in multiple colors. Physically, they\u2019re the same size.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      18,
      16,
      6,
      25,
      15
    ],
    "source": "9781394330348"
  },
  {
    "id": 873,
    "question": "Which CPU technology facilitates the assignment of two logical cores for every physical core present?",
    "choice_a": "Multicore",
    "choice_b": "32-bit vs. 64-bit",
    "choice_c": "Integrated GPU",
    "choice_d": "Multithreading",
    "correct_answer": "D",
    "explanation": "Multithreading is a feature of processors that divides physical processor cores into logical cores, and software processes into multiple threads that can run concurrently on those logical cores. As a result, the operating system (OS) can schedule two processes at the same time on each physical core. Intel\u2019s implementation of multithreading is called hyperthreading. Multicore means that there are two or more cores on a processor die, each with two logical cores called arithmetic logic units. 32-bit and 64-bit refer to the width of the data bus, and an integrated Graphics Processing Unit (GPU) means that the processor contains the graphics processor so a separate GPU isn\u2019t required.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      12,
      13,
      3,
      10,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 874,
    "question": "You are adding paper to a printer that uses tractor-feed paper, which requires lining up the holes in the paper with the pins on the paper-forwarding mechanism. What type of printer are you maintaining?",
    "choice_a": "Impact",
    "choice_b": "Thermal",
    "choice_c": "Laser",
    "choice_d": "Inkjet",
    "correct_answer": "A",
    "explanation": "An impact printer typically requires paper that always feeds at a consistent rate. To achieve this, the paper has holes on the outside edges and is fed into the printer using a tractor-feed mechanism. Thermal printers use special thermal paper that is heated to create images, whereas laser printers use the electrophotographic process. Inkjet printers spray drops of ink onto paper.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      73,
      81,
      74,
      80,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 875,
    "question": "Which motherboard form factor is common in desktop computers and measures 12\u2033 \u00d7 9.6\u2033?",
    "choice_a": "ATX",
    "choice_b": "MicroATX",
    "choice_c": "Mini-ITX",
    "choice_d": "ITX",
    "correct_answer": "A",
    "explanation": "Advanced Technology eXtended (ATX) motherboards are common in desktop computers and measure 12\u2033 \u00d7 9.6\u2033. They are the largest motherboards commonly used in personal computers today.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      9,
      11,
      7,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 876,
    "question": "An inkjet printer doesn\u2019t seem to be moving the printhead to the right area. Which two of the following could be keeping the printhead from moving and need to be replaced or removed? (Choose two.)",
    "choice_a": "Debris in the printer",
    "choice_b": "The roller",
    "choice_c": "The feeder",
    "choice_d": "The carriage motor or belt",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "If the printhead isn\u2019t moving, either the mechanism that moves it or debris in its path could be causing the problem. The motor, which makes the printhead carriage move, is also often called the carriage motor or carriage stepper motor. It has a belt attached to it\u2014the carriage belt\u2014that moves the printhead carriage back and forth. Sometimes, these need to be replaced. Debris in the printer could also prevent the printhead from moving and needs to be removed. Note that in some inkjet printers the ink cartridge contains the printhead, while in others it is a separate component. The feeder is the mechanism that pulls paper into and through the printer. The rollers, sometimes called pickup rollers because they literally pick up a sheet of paper, are part of the feeding mechanism.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      74,
      76,
      96,
      97,
      75
    ],
    "source": "9781394330348"
  },
  {
    "id": 877,
    "question": "You need to configure Hyper-V on one of your Windows-based desktop computers with an Intel processor. Which of the following must be true? (Choose three.)",
    "choice_a": "The CPU must have SLAT.",
    "choice_b": "The CPU must have Intel VR.",
    "choice_c": "The processor must be 64-bit.",
    "choice_d": "You need to enable virtualization in the BIOS/UEFI.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The Central Processing Unit (CPU) must support Virtual Machine (VM) Display Mode Extension; on an Intel processor, it\u2019s called Virtualization Technology (Intel VT). The processor must be 64-bit and have Second-Level Address Translation (SLAT). Virtualization also requires the Windows Pro edition or better. Virtualization must be enabled in the Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI), which may be found under different names, depending on the motherboard manufacturer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      13,
      19,
      9,
      6,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 878,
    "question": "An analog LCD is most likely to have what type of connector?",
    "choice_a": "DisplayPort",
    "choice_b": "RCA",
    "choice_c": "VGA",
    "choice_d": "BNC",
    "correct_answer": "C",
    "explanation": "The most common analog video connector is a Video Graphics Array (VGA) connector. It is usually blue in color, arranged in a D shape, with 15 pins arranged in three rows. There are also analog Digital Visual Interface (DVI-A) connectors. DIV Integrated (DVI-I) connectors can be used in either digital or analog implementations. DisplayPort is a digital connector. Radio Corporation of America (RCA) provides an analog audio connection, and Bayonet Neill-Concelman (BNC) connectors are used for analog or digital connections, but are generally used for broadband connections, not to connect a display and a computer.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      60,
      63,
      48,
      51,
      49
    ],
    "source": "9781394330348"
  },
  {
    "id": 879,
    "question": "You have a peripheral that needs a data speed of 20 Gbps and 9 W of power to be supplied by the connection to the PC. Which PC peripheral connection type is it most likely to use?",
    "choice_a": "Thunderbolt",
    "choice_b": "USB 3.0",
    "choice_c": "eSATA",
    "choice_d": "DisplayPort",
    "correct_answer": "A",
    "explanation": "Thunderbolt v1 and v2 both provide 20 Gigabits per second (Gbps) of data bandwidth. Thunderbolt 3 doubles the data rate to 40 Gbps. Thunderbolt 3 and Thunderbolt 4 can also provide the power the device needs. Universal Serial Bus (USB) 3.0 can only provide about 5 W of power and is much slower, at 5 Gbps. External Serial Advanced Technology Attachment (eSATA) is also slower and doesn\u2019t provide power, although Power over eSATA (eSATAp) does. DisplayPort is also slower and provides no power, unless it\u2019s DisplayPort over USB.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      59,
      56,
      62,
      30,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 880,
    "question": "You have recently purchased a laptop computer with a touchscreen. It enables you to draw images on the screen and save them on your computer. Which device is responsible for converting the input into the image that you see and save?",
    "choice_a": "Inverter",
    "choice_b": "Touchpad",
    "choice_c": "Digitizer",
    "choice_d": "Touchscreen",
    "correct_answer": "C",
    "explanation": "A digitizer is a device that can be written or drawn on, and the content will be converted from analog input to digital images on the computer. Digitizers take input from a user\u2019s finger or a writing utensil like a stylus. Touchscreen devices and touchpads have a digitizer built into them. An inverter changes Direct Current (DC) to Alternating Current (AC) and is needed for some types of backlighting.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      54,
      48,
      60,
      61,
      53
    ],
    "source": "9781394330348"
  },
  {
    "id": 881,
    "question": "What are the two power requirements that a PCI expansion bus may have in a desktop computer? (Choose two.)",
    "choice_a": "1.7 V",
    "choice_b": "3.3 V",
    "choice_c": "5 V",
    "choice_d": "6.6 V",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Peripheral Component Interconnect (PCI) slots and adapters are manufactured in 3.3 V and 5 V versions. Adapters are keyed to fit in a slot based on their voltage requirements. Universal adapters are keyed to fit in slots based on either of the two voltages. PCI has largely been replaced by Peripheral Component Interconnect Express (PCIe), but there are still implementations of it, and it is still on the CompTIA A+ exam objectives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      43,
      41,
      44,
      45
    ],
    "source": "9781394330348"
  },
  {
    "id": 882,
    "question": "Which of the following is a standard for a secure cryptoprocessor that can secure hardware (and the system boot process) using cryptographic keys?",
    "choice_a": "TPM",
    "choice_b": "LoJack",
    "choice_c": "Secure Boot",
    "choice_d": "BitLocker",
    "correct_answer": "A",
    "explanation": "Trusted Platform Module (TPM) is an international standard for a dedicated security coprocessor, or cryptoprocessor. Coupled with a Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI), it can be configured to boot the system only after authenticating the boot device. LoJack is a feature for locating stolen or missing devices, Secure Boot is designed to prevent malicious software from loading before a PC boots, and BitLocker is a feature of Windows Pro and higher editions that is used to encrypt entire storage drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      13,
      6,
      4,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 883,
    "question": "Which device, whether external or a component of a laptop, can take input from a stylus or your finger, depending on the sensor type, and convert it to mouse movements on a screen?",
    "choice_a": "Rectifier",
    "choice_b": "Touchscreen",
    "choice_c": "Digitizer",
    "choice_d": "Inverter",
    "correct_answer": "B",
    "explanation": "Touchscreens, touchpads, and digitizer tablets and drawing pads convert your finger or stylus movements on the device to mouse movements on the display. Touchscreens incorporate a digitizer, but a digitizer can also be a separate device which looks like a tablet but is used specifically to interpret hand drawing of images or text. A rectifier is a device that converts Alternating Current (AC) to Direct Current (DC) and can be found in a power supply. An inverter converts DC to AC and can be found in some displays.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      54,
      56,
      51,
      48,
      49
    ],
    "source": "9781394330348"
  },
  {
    "id": 884,
    "question": "What type of power connector is shown here?<img src=\"/question_assets/220-1201/c03f007.png\" alt=\"Close-up of computer power cable with multiple connectors.\"/>\n\n<figcaption>Close-up of computer power cable with multiple connectors.</figcaption>",
    "choice_a": "P1",
    "choice_b": "SATA",
    "choice_c": "PCIe",
    "choice_d": "ATX",
    "correct_answer": "C",
    "explanation": "This is an eight-pin Peripheral Component Interconnect Express (PCIe) power connector. They also come in six-pin configurations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      43,
      44,
      45,
      41,
      35
    ],
    "source": "9781394330348"
  },
  {
    "id": 885,
    "question": "A technician has installed a printer driver on a Windows client computer. What is the best next step the technician can take to ensure that the printer is installed properly?",
    "choice_a": "Ping the printer\u2019s IP address.",
    "choice_b": "Check the printer status and ensure that it says \u201cReady.\u201d",
    "choice_c": "Stop and restart the spooler service.",
    "choice_d": "Print a test page.",
    "correct_answer": "D",
    "explanation": "After installing a new printer, it\u2019s good practice to print a test page to ensure functionality.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      91,
      89,
      90,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 886,
    "question": "You just replaced the toner cartridge on the laser printer in your office. Now you\u2019re getting an error message displayed on the screen. What should you try first?",
    "choice_a": "Call the printer company\u2019s tech support.",
    "choice_b": "Remove and reinsert the toner cartridge.",
    "choice_c": "Install a maintenance kit.",
    "choice_d": "Replace the printer.",
    "correct_answer": "B",
    "explanation": "Whenever you\u2019ve just replaced something and an error message pops up, it\u2019s a fairly safe assumption that it had something to do with what you just replaced. A toner cartridge that isn\u2019t seated properly can cause an error message. Reseat it and the error might go away.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      96,
      89,
      77,
      79,
      92
    ],
    "source": "9781394330348"
  },
  {
    "id": 887,
    "question": "You have been asked to install and configure a RAID-10 storage array for a computer. What is the minimum number of hard disks required for this configuration?",
    "choice_a": "Two",
    "choice_b": "Three",
    "choice_c": "Four",
    "choice_d": "Five",
    "correct_answer": "C",
    "explanation": "Redundant Array of Independent Disks-10 (RAID-10, also known as RAID-1+0) provides fault tolerance by adding a mirror (RAID-1) to a striped set (RAID-0). The striped set has a minimum of two drives and the mirror requires two more drives, one to mirror each drive of the striped set, for a total of four drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      33,
      4,
      25,
      44
    ],
    "source": "9781394330348"
  },
  {
    "id": 888,
    "question": "A graphic designer in your office needs two displays to do their work. Which of the following could you install to set up their desktop computer for this configuration? (Choose two.)",
    "choice_a": "A video splitter",
    "choice_b": "A second video driver",
    "choice_c": "A second video card",
    "choice_d": "An adapter with two outputs",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "To use a second display on a desktop computer, you need to install a second video adapter or have one video adapter with two display interfaces. Laptops often have an external display interface and are capable of providing video to the built-in screen and an external display at the same time.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      27,
      52,
      60,
      62,
      59
    ],
    "source": "9781394330348"
  },
  {
    "id": 889,
    "question": "You have a motherboard designed to hold DDR3 1600 memory. What will happen if you attempt to install DDR4 2400 memory into the motherboard?",
    "choice_a": "It won\u2019t fit.",
    "choice_b": "It will operate at 667 MHz.",
    "choice_c": "It will operate at 1133 MHz.",
    "choice_d": "It will operate at 1600 MHz.",
    "correct_answer": "A",
    "explanation": "Double Data Rate 3 (DDR3) and Double Data Rate 4 (DDR4) memory slots are both keyed, but the keys are in different places. DDR3 has 240 pins, and DDR4 has 288 pins. Therefore, the memory will not fit into the slots on the motherboard.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      16,
      18,
      26,
      6,
      19
    ],
    "source": "9781394330348"
  },
  {
    "id": 890,
    "question": "Which display component is capable of discharging energy and causing severe injuries to technicians?",
    "choice_a": "Touchscreen",
    "choice_b": "Backlight",
    "choice_c": "Inverter",
    "choice_d": "LCD",
    "correct_answer": "C",
    "explanation": "The job of the inverter is to store and convert energy from Direct Current (DC) to Alternating Current (AC). Inverters have the potential to discharge that energy and can be dangerous to technicians, so be careful when working with them. A backlight provides light that shines through the Liquid Crystal Display (LCD) to create pictures on the screen. Light Emitting Diode (LED) displays don\u2019t need an inverter because they use DC, not AC, and the laptop will already have DC power running through it.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      48,
      49,
      50,
      51,
      52
    ],
    "source": "9781394330348"
  },
  {
    "id": 891,
    "question": "One of your users needs to print several copies of a 20-page document. They want to ensure that the document\u2019s pages are printed on both sides of the paper to conserve paper. Which option do they need to set properly in their printer configuration settings?",
    "choice_a": "Duplexing",
    "choice_b": "Collating",
    "choice_c": "Print Quality",
    "choice_d": "Orientation",
    "correct_answer": "A",
    "explanation": "Duplexing is printing on the front and back. Other common options or settings include orientation (i.e., portrait or landscape), collating (i.e., printing pages in sets such as 1, 2, 3, 1, 2, 3), and print quality (e.g., draft or high resolution).",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      75,
      92,
      74,
      90,
      94
    ],
    "source": "9781394330348"
  },
  {
    "id": 892,
    "question": "A technician needs to install an optical disk system with the capacity to burn disks, storing about 60 GB of data at one time. What is the minimum technology required to get over this threshold?",
    "choice_a": "DVD-10",
    "choice_b": "DVD-18",
    "choice_c": "Triple BDXL",
    "choice_d": "Quad BDXL",
    "correct_answer": "C",
    "explanation": "A Blu-ray Disc Extra Large (BDXL) can store up to 128 GB of data (Quad BDXL), although most for sale boast only 100 GB of storage (Triple BDXL). Blu-ray is the latest rendition of optical discs, but Digital Versatile Discs (DVDs) are still available and come in Single Layer (SL), Dual Layer (DL), Single Side (SS), and Dual Side (DS) formats. DVD-18 (DS, DL) hold approximately 16 GB of data. DVD-10 (DS, SL) can hold approximately 9 GB, and DVD-9 (SS, DL) can hold approximately 8 GB of storage. DVD-9 and DVD-10 can be Digital Versatile Disc Recordable (DVD+R) or DVD-R formats, but DVD-18 can only be the DVD+R format.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      39,
      38,
      44,
      4,
      35
    ],
    "source": "9781394330348"
  },
  {
    "id": 893,
    "question": "It appears that the feeder mechanism in your inkjet printer isn\u2019t working because paper is not being fed into the printer. Which of the following might be causing this? (Choose two.)",
    "choice_a": "Excessive humidity",
    "choice_b": "Faulty printhead",
    "choice_c": "Width guide too tight",
    "choice_d": "Faulty toner cartridge",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The feeder is the part of the printer that pulls paper through the printer. In an inkjet printer, the paper is usually inserted either in a tray at the top back of the printer, or in a tray on the bottom of the printer. Unfortunately, there are many reasons why the feeder isn\u2019tpulling paper into the printer, including using the wrong paper, having incorrect paper settings in the driver, the tray isn\u2019t fully inserted, the pickup rollers are dirty, the paper isn\u2019t inserted into the tray correctly, the paper guide is missing, the width guide is too tight, there is too much or too little paper in the tray, and using two different kinds of paper in the same tray or reusing paper that has been printed on or is dirty. A problem with the printhead isn\u2019t likely to cause paper not to feed, and a toner cartridge is part of a laser printer, not an inkjet printer.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      75,
      74,
      96,
      92,
      91
    ],
    "source": "9781394330348"
  },
  {
    "id": 894,
    "question": "You have been asked to purchase new RAM for three workstations. The workstations call for DDR4 3600 chips. What throughput will these modules support?",
    "choice_a": "450 Mbps",
    "choice_b": "1800 Mbps",
    "choice_c": "3600 Mbps",
    "choice_d": "28,800 Mbps",
    "correct_answer": "D",
    "explanation": "The number designation of 3600 in Double Data Rate 4 (DDR4) 3600 indicates the bus speed of 3,600 Megahertz (MHz). To find the throughput, multiply the bus speed by 8. DDR4 3600, therefore, is the same as PC4 28,800, with a peak transfer rate of 28,800 Megabits per second (Mbps). (3,600,000 cycles per second x8 = 28,800,000 bits per second. Divide by 1,000 to get Mbps = 28,800.).",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      17,
      16,
      14,
      6,
      20
    ],
    "source": "9781394330348"
  },
  {
    "id": 895,
    "question": "A technician needs to purchase new RAM for a motherboard. The motherboard specifications call for 5200 MHz DDR5 RAM. The supplier only shows a PC rating for RAM. Which RAM modules should the technician use?",
    "choice_a": "PC 5200",
    "choice_b": "PC 41600",
    "choice_c": "PC5 41600",
    "choice_d": "PC5 5200",
    "correct_answer": "C",
    "explanation": "Multiply the 5,200-bus speed by eight to get the bits per second that can be transferred in and out of the RAM module. The PC5 designation means that it is Double Data Rate 5 (DDR5), and the 41,600 means that it can (theoretically) transfer 41,600 Mbps (Megabits per second).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      17,
      16,
      26,
      6,
      15
    ],
    "source": "9781394330348"
  },
  {
    "id": 896,
    "question": "On your network, users want to print easily from their iPads and iPhones. Which service supports this?",
    "choice_a": "Bonjour",
    "choice_b": "AirPrint",
    "choice_c": "TCP printing",
    "choice_d": "Virtual printing",
    "correct_answer": "B",
    "explanation": "iPads and iPhones can automatically detect AirPrint-enabled printers on their local network and print to them without requiring the installation of a driver. Bonjour is a service that works with both Macs and Windows devices but requires some configuration. Although Transmission Control Protocol (TCP) is used in many applications and devices, TCP printing is different. In TCP printing, a printer in the Operating System (OS) is configured to use an Internet Protocol (IP) address to connect to a printer. Virtual printing sends the output to something else, such as a PDF file.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      93,
      95,
      94,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 897,
    "question": "You have a new computer that needs to communicate with other computers on a wireless network. What type of expansion card do you need to install?",
    "choice_a": "WAP",
    "choice_b": "NIC",
    "choice_c": "KVM",
    "choice_d": "WPA",
    "correct_answer": "B",
    "explanation": "To communicate with other computers on a network, you need a Network Interface Card (NIC). A Wireless Access Point (WAP) is a wireless hub that many wireless devices communicate with, and Wi-Fi Protected Access (WPA) is a wireless security standard. A Keyboard, Video, Mouse (KVM) switch enables you to have multiple systems attached to the same keyboard, video, and mouse. Other types of expansion cards (that could use the same slot as a NIC) include, but are not limited to, video cards, sound cards, storage cards, TV tuner cards, and riser cards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      2,
      30,
      27,
      28
    ],
    "source": "9781394330348"
  },
  {
    "id": 898,
    "question": "When printing, which component is responsible for converting the data being printed into the format that the printer can understand?",
    "choice_a": "PDL",
    "choice_b": "Printer driver",
    "choice_c": "Print queue",
    "choice_d": "Print spooler",
    "correct_answer": "B",
    "explanation": "The printer driver uses a Page Description Language (PDL), which specifies the printed page layout, to convert the data being printed into a format that the printer can understand. The driver ensures that the printer is ready to print and ensures that the OS sends information in the correct format. The print queue holds print jobs that are waiting to be printed and the print spooler manages the printing process, including locating the right printer driver.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      91,
      92,
      31,
      76,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 899,
    "question": "You\u2019re installing a new printer and notice that the manufacturer has provided two drivers with the printer. One is a PostScript driver, and the other is a PCL driver. The user will mainly be printing graphics. Which driver should you install?",
    "choice_a": "Permit Windows to install its default driver.",
    "choice_b": "Install the PCL driver.",
    "choice_c": "Install the PostScript driver.",
    "choice_d": "Either driver will work equally well.",
    "correct_answer": "C",
    "explanation": "Windows comes with many drivers for different devices, but if the manufacturer has provided a specific printer driver, it\u2019s often best to install that printer driver first, and then connect the device. In this case, the user will be printing mostly graphics, so the PostScript driver will provide better printing for them. PostScript drivers are not dependent on the hardware, so the printed graphic will look the same, regardless of what device it is printed on.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      91,
      89,
      96,
      92,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 900,
    "question": "What type of printer driver is best to use if you will be printing mostly documents and want to have the PC released to do other jobs more quickly?",
    "choice_a": "Permit Windows to install its default driver.",
    "choice_b": "Install the PCL driver.",
    "choice_c": "Install the PostScript driver.",
    "choice_d": "Driver choice won\u2019t have an effect.",
    "correct_answer": "B",
    "explanation": "Printer Control Language (PCL) drivers depend on the printer hardware to create some of the effects, such as filling in areas and making underlines. The PC releases the print job to the printer to finish, making the PC and application available to the user more quickly.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      91,
      92,
      96,
      31,
      89
    ],
    "source": "9781394330348"
  },
  {
    "id": 901,
    "question": "You notice that a fan on a power supply has stopped turning, and you will need to replace it. Which of the following statements best describes the function of a typical power supply fan?",
    "choice_a": "It cools the power supply by blowing in air from outside the case.",
    "choice_b": "It cools the power supply by blowing hot air out the back of the power supply.",
    "choice_c": "It cools the computer by blowing in air from outside the case, through the power supply, and into the computer.",
    "choice_d": "It cools the computer by pulling hot air from inside the case, through the power supply, and blowing it out the back of the power supply, which in turn draws cooler air in through vents in the case.",
    "correct_answer": "D",
    "explanation": "The power supply fan is used to cool the power supply and the inside of the computer case. This fan draws air from inside the case into vents in the power supply. This action pulls hot air through the power supply, so that it can be blown out of the case, which also causes cooler air to be drawn in through vents in the case.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      21,
      47,
      23,
      7,
      45
    ],
    "source": "9781394330348"
  },
  {
    "id": 902,
    "question": "A technician needs to install a new hard drive for their client. Access speed is far more important to this client than disk space. What type of hard drive is best suited for this client?",
    "choice_a": "SSD",
    "choice_b": "HDD",
    "choice_c": "SD",
    "choice_d": "BD-R",
    "correct_answer": "A",
    "explanation": "A Solid-State Drive (SSD) is the best choice for a hard drive when access speed is the most important characteristic. A conventional magnetic Hard Disk Drive (HDD) is slower. Secure Digital (SD) is a memory card format, not a hard drive type. Blu-ray Disk Recordable (BD-R) is a Blu-ray (optical) disk format.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      33,
      36,
      38,
      39
    ],
    "source": "9781394330348"
  },
  {
    "id": 903,
    "question": "What is the maximum data rate for a USB 3.0 connection?",
    "choice_a": "12 Mbps",
    "choice_b": "480 Mbps",
    "choice_c": "5 Gbps",
    "choice_d": "10 Gbps",
    "correct_answer": "C",
    "explanation": "Universal Serial Bus (USB) 3.0 supports 5 Gigabits per second (Gbps), USB 1.0 supports 12 Megabits per second (Mbps), USB 2.0 supports 480 Mbps, and USB 3.1 Gen 2 supports 10 Gbps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      57,
      30,
      59,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 904,
    "question": "A technician has been asked to install and configure a RAID-10 array in a working computer that contains one hard drive. How many additional hard drives, at a minimum, do they need to bring to the job?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "C",
    "explanation": "With Redundant Array of Independent Disks 10 (RAID-10), drives are set up as mirrors, then those mirrors are striped. A minimum of two drives are needed to create a mirror, then another two to stripe the data, for a total of four drives. The computer already has one drive in it. That drive would be mirrored, then striped, so three more drives are needed. RAID-10 provides both extra speed and fault tolerance.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      37,
      33,
      44,
      41,
      45
    ],
    "source": "9781394330348"
  },
  {
    "id": 905,
    "question": "You\u2019ve been tasked with making a system faster, so you implement a RAID solution that does only that. What level of RAID will you implement?",
    "choice_a": "RAID-0",
    "choice_b": "RAID-1",
    "choice_c": "RAID-5",
    "choice_d": "RAID-10",
    "correct_answer": "A",
    "explanation": "Redundant Array of Independent Disks-0 (RAID-0), also known as disk striping, uses a minimum of two drives to write different bits of data to each drive at the same time to improve speed, but it doesn\u2019t offer any fault tolerance. Redundant Array of Independent Disks-1 (RAID-1) is disk mirroring, which provides some fault tolerance but no speed improvement. Redundant Array of Independent Disks-5 (RAID-5) and Redundant Array of Independent Disks-10 (RAID-10) improve both speed and fault tolerance.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      37,
      33,
      34,
      35,
      45
    ],
    "source": "9781394330348"
  },
  {
    "id": 906,
    "question": "Which CPU architecture term describes a CPU with multiple physical processor dies in the same package?",
    "choice_a": "Multicore",
    "choice_b": "64-bit",
    "choice_c": "Integrated GPU",
    "choice_d": "Multiprocessor",
    "correct_answer": "A",
    "explanation": "A processor that exhibits a multicore architecture has multiple and completely separate processor dies in the same package. The operating system and applications see multiple processors in the same way that they see multiple processors in separate sockets. 64-bit refers to the width of the data bus. An integrated Graphics Processor Unit (GPU) means that the graphics processor is also on the Central Processing Unit (CPU) package, and multiprocessor refers to more than one physical socket on a motherboard.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      12,
      11,
      3,
      27,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 907,
    "question": "Which of the following optical disk standards provides the highest capacity?",
    "choice_a": "DVD-R SS, SL",
    "choice_b": "DVD-R DS, SL",
    "choice_c": "DVD-R SS, DL",
    "choice_d": "DVD-R SS, TL",
    "correct_answer": "B",
    "explanation": "All are Digital Video Disc (DVD) technologies. A Single-Sided, Single-Layer (SS, SL) DVD provides about 4.7 GB of storage. A Dual-Sided (DS) disk will double that capacity to 9.4 GB. Adding a second layer, or Dual-Layer (DL), adds more capacity, but the technology does not double the capacity of a single layer. A Single-Sided, Dual-Layer (SS, DL) disk has capacity of about 8.5 GB. There is no Digital Video Disc Recordable Single-Sided (DVD-R SS), Digital Video Disc Recordable Transport Layer (TL), but a Digital Video Disc Recordable Dual-Sided, Dual Layer (DVD+R DS, DL) holds nearly 17 GB of data. The -R refers to the encoding scheme. There is also a +R format. There are also number designations to identify how many sides and layers a DVD has. DVD-9 is single-side, dual-layer; DVD-10 is dual-side, single-layer; and DVD-18 is dual-side, dual-layer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      39,
      35,
      37,
      4,
      33
    ],
    "source": "9781394330348"
  },
  {
    "id": 908,
    "question": "Your company recently shipped five desktop computers from Germany to the United States. After switching the power cord to an American-style plug, you try to power one on, and it doesn\u2019t work. You try the others, and none of them power on either. What is the most likely cause?",
    "choice_a": "All the computers were damaged during shipping.",
    "choice_b": "German power supplies work only with German power cords.",
    "choice_c": "The power supplies won\u2019t work because they expect 50 Hz frequency from the wall outlet, and the US standard is 60 Hz.",
    "choice_d": "The power supply voltage switch needs to be moved from 220 to 120.",
    "correct_answer": "D",
    "explanation": "Many power supplies have a two-position slider switch called a dual voltage switch. It can be set for 110\u2013120 V or 220\u2013240 V, depending on the local power specifications. Keep in mind that the computer may be damaged if the power supply isn\u2019t set to the correct voltage before the computer is powered on.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      42,
      41,
      43,
      44,
      47
    ],
    "source": "9781394330348"
  },
  {
    "id": 909,
    "question": "What are the dimensions of a mobile-ITX motherboard?",
    "choice_a": "9.6\u2033 \u00d7 9.6\u2033",
    "choice_b": "6.7\u2033 \u00d7 6.7\u2033",
    "choice_c": "3.9\u2033 \u00d7 2.8\u2033",
    "choice_d": "2.4\u2033 \u00d7 2.4\u2033",
    "correct_answer": "D",
    "explanation": "Mobile-Information Technology Extended (Mobile-ITX) motherboards are 2.4-inch square. Micro-Advanced Technology Extended (MicroATX) motherboards are 9.6-inch square, Mini- Information Technology Extended (Mini-ITX) motherboards are 6.7-inch square, and Pico-Information Technology Extended (Pico-ITX) motherboards are 3.9\u2033 \u00d7 2.8\u2033.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      9,
      11,
      3,
      19,
      2
    ],
    "source": "9781394330348"
  },
  {
    "id": 910,
    "question": "Which of the following printer types is an impact printer?",
    "choice_a": "Laser",
    "choice_b": "Inkjet",
    "choice_c": "Dot-matrix",
    "choice_d": "Thermal",
    "correct_answer": "C",
    "explanation": "Dot-matrix printers use printheads that strike an ink ribbon, which presses up against the paper to make an image. Therefore, they are impact printers. Laser printers use a photosensitive drum to create the image, inkjet printers use an ink reservoir (cartridge) and spray nozzles to produce an image on paper using dots of ink, and thermal printers use heat to produce an image on special thermal (heat-sensitive) paper.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      73,
      80,
      74,
      81,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 911,
    "question": "Which two of the CPUs listed here are Intel processors? (Choose two.)",
    "choice_a": "Xeon Silver",
    "choice_b": "Epyc 9004",
    "choice_c": "Core i9",
    "choice_d": "Ryzen Threadripper Pro",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The Epyc and Ryzen processors are made by Advanced Micro Devices (AMD), while the Core series and Xeon processors are made by Intel.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      3,
      11,
      13,
      10,
      16
    ],
    "source": "9781394330348"
  },
  {
    "id": 912,
    "question": "You are discussing data storage needs with a client who is a videographer and media producer. They need to store dozens of large files and need immediate access to them for editing. What is the most appropriate storage technology for them to use?",
    "choice_a": "NAS",
    "choice_b": "SSD",
    "choice_c": "SD",
    "choice_d": "BD-R",
    "correct_answer": "B",
    "explanation": "A Solid-State Drive (SSD) will provide them with the highest capacity of the four options and give them immediate access. Network Attached Storage (NAS) speaks to its connection and availability, not capacity. If the client required file sharing as well, then using a NAS would be the proper choice. Secure Digital (SD) is a memory card format and does not offer the capacity or immediacy they need. Blu-ray disk (BD-R) has good storage capabilities but not the immediacy for editing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      35,
      38,
      39,
      33
    ],
    "source": "9781394330348"
  },
  {
    "id": 913,
    "question": "You are searching for a new display on the Internet and find a used digital LCD for sale. What are the two most likely types of connectors you will find on this display? (Choose two.)",
    "choice_a": "DVI-A",
    "choice_b": "DVI-D",
    "choice_c": "HDMI",
    "choice_d": "VGA",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Digital displays will have a digital interface, such as Digital Video Interface-Digital (DVI-D), High-Definition Multimedia Interface (HDMI), or mini- High-Definition Multimedia Interface (mini-HDMI). Digital Video Interface-Integrated (DVI-A) and Video Graphics Array (VGA) are analog, not digital.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      61,
      62,
      63,
      48
    ],
    "source": "9781394330348"
  },
  {
    "id": 914,
    "question": "Which of the following are typical formats supported by virtual printing? (Choose three.)",
    "choice_a": "Print to PDF",
    "choice_b": "Print to XPS",
    "choice_c": "Print to DOC",
    "choice_d": "Print to image",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The four virtual printing options are print to file, print to Portable Document Format (PDF), print to XML Paper Specification (XPS), and print to image.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      90,
      74,
      76,
      78
    ],
    "source": "9781394330348"
  },
  {
    "id": 915,
    "question": "A PCIe x1 v 3.0 lane provides how much data throughput?",
    "choice_a": "250 MBps",
    "choice_b": "500 MBps",
    "choice_c": "1 GBps",
    "choice_d": "2 GBps",
    "correct_answer": "C",
    "explanation": "There are six major versions of Peripheral Component Interconnect Express (PCIe) currently specified: 1.x, 2.x, 3.0, 4.0, 5.0, and 6.0. Each version doubles the data transfer rate of the version before. In each version, a single bidirectional lane operates at a data rate of 250 Megabytes per second (MBps), 500 MBps, approximately 1 Gigabyte per second (GBps), roughly 2 GBps, nearly 4 GBps for version 5.0, and nearly 8 GBps for version 6.0.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      30,
      27,
      35,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 916,
    "question": "Which display type enables a user to complete tasks on their computer without the use of a keyboard?",
    "choice_a": "Touchscreen",
    "choice_b": "Touchpad",
    "choice_c": "Inverter",
    "choice_d": "LCD",
    "correct_answer": "A",
    "explanation": "Many displays are touchscreens, which convert a user\u2019s finger movements to mouse movements on the screen. A touchpad does the same but is not a type of display. (Yes, watch for tricky questions like this on the exam.) An inverter is a part of many displays, and its jobis to store and convert energy from Direct Current (DC) to Alternating Current (AC). Inverters have the potential to discharge that energy and can be dangerous to technicians, so be careful when working with them. A Liquid Crystal Display (LCD) is a type of display but not necessarily a touchscreen.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      54,
      48,
      49,
      53,
      52
    ],
    "source": "9781394330348"
  },
  {
    "id": 917,
    "question": "Which CPU socket is capable of supporting Intel Core Ultra 9 processors?",
    "choice_a": "PGA 132",
    "choice_b": "LGA 1851",
    "choice_c": "AM5",
    "choice_d": "TR4",
    "correct_answer": "B",
    "explanation": "Land Grid Array (LGA) sockets support modern Intel processors. The Pin Grid Array (PGA) 132 socket was the first Intel socket. AM and TR socket series are for Advanced Micro Devices (AMD) processors. Tip: You probably can\u2019t memorize all the processors and sockets, so ensure that you can identify the families that belong to AMD or Intel.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      3,
      11,
      9,
      12,
      10
    ],
    "source": "9781394330348"
  },
  {
    "id": 918,
    "question": "You are installing two new RAM modules into a dual-channel motherboard and want it to work in dual channel mode. Which of the following is true?",
    "choice_a": "Both RAM modules need to have the same parameters.",
    "choice_b": "The RAM modules can be different sizes but must be the same speed.",
    "choice_c": "The RAM modules can be different speeds but must be the same size.",
    "choice_d": "The RAM modules can have different speeds and sizes, as long as they are the same type.",
    "correct_answer": "A",
    "explanation": "When installing dual-channel Random Access Memory (RAM), be sure that the RAM modules have the same parameters. In some cases, you might even need to make sure they come from the same manufacturer. RAM for channeled motherboards is often sold in packs, such as a pack of two RAM modules for dual-channel motherboards, three modules for triple-channel motherboards, and four modules for quad-channel motherboards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      15,
      6,
      26,
      18,
      16
    ],
    "source": "9781394330348"
  },
  {
    "id": 919,
    "question": "You\u2019re comparing two displays with the same resolution. One is 27 inches, and the other is 36 inches. Because they have the same resolution, what would be a way to compare the number of dots of color that will be displayed on each?",
    "choice_a": "Refresh rate",
    "choice_b": "Pixel density",
    "choice_c": "Aspect ratio",
    "choice_d": "Density independence",
    "correct_answer": "B",
    "explanation": "Pixel density is a measure of how many pixels a device can display in a specified space, such as Pixels Per Inch (PPI). A larger display with the same resolution will have a lower pixel density. Refresh rate determines how many times per second the screen can be redrawn. Aspect ratio defines the relationship between the dimensions (width \u00d7 height) of a display or image. For example, a screen that has a maximum resolution of 1366 \u00d7 768 has an aspect ratio of 16:9. For every 9 pixels in height, there are 16 pixels in width. Density independence refers to the ability of an image or font to be displayed the same, regardless of the display it is shown on. Resolution is the number of pixels that a given device can display, expressed as two numbers such as 1366 \u00d7 768.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      51,
      53,
      50,
      49,
      48
    ],
    "source": "9781394330348"
  },
  {
    "id": 920,
    "question": "A gamer friend is complaining that their screen seems to react slowly to what they\u2019re doing in their game. They want to get a new display. What would you suggest they make sure has a higher number than their present screen to address the performance issue?",
    "choice_a": "Refresh rate",
    "choice_b": "Pixel density",
    "choice_c": "Aspect ratio",
    "choice_d": "Resolution",
    "correct_answer": "A",
    "explanation": "Refresh rate determines how many times per second the screen can be redrawn. A slow refresh rate can make video appear blurry or jumpy. Pixel density is a measure of how many pixels a device can display in a specified space, such as Pixels Per Inch (PPI). A larger display with the same resolution will have a lower pixel density. Aspect ratio defines the relationship between the dimensions (width \u00d7 height) of a display or image. For example, a screen that has a maximum resolution of 1366 \u00d7 768 has an aspect ratio of 16:9. For every 9 pixels in height, there are 16 pixels in width. Resolution is the number of pixels that a given device can display, expressed as two numbers such as 1366 \u00d7 768.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      50,
      53,
      51,
      49,
      48
    ],
    "source": "9781394330348"
  },
  {
    "id": 921,
    "question": "You\u2019re having trouble installing a new 2.5-inch SATA SSD in a server and either need a longer cable or need to move the drive. For maximum air flow in the case, the path that the cable needs to take is 33 inches long. You have a cable that is 18 inches long. What do you do?",
    "choice_a": "Move the drive; cables are limited to 18 inches.",
    "choice_b": "Purchase a 1-meter cable.",
    "choice_c": "Purchase a cable extender.",
    "choice_d": "Buy a new M.2 drive instead.",
    "correct_answer": "B",
    "explanation": "The maximum length for a Serial Advanced Technology Attachment (SATA) cable is 1 meter, which is about 39 inches. Your best course of action is to purchase a longer cable, so you can maintain maximum air flow.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      4,
      35,
      40,
      21
    ],
    "source": "9781394330348"
  },
  {
    "id": 922,
    "question": "A user on your network has a laser printer that is several years old with no Ethernet connection. It\u2019s connected to their computer and shared on the network for others to use. Now, the user no longer wants the printer, but others still need to use it on the network. What would be the best upgrade to install in this printer to enable others to send print jobs to it directly over the network?",
    "choice_a": "A network card",
    "choice_b": "A print server",
    "choice_c": "TCP/IP printing",
    "choice_d": "AirPrint",
    "correct_answer": "B",
    "explanation": "To get this printer off the original user\u2019s desk, it probably needs to be its own print server. Installing an integrated (or standalone) print server with a network connection should work well in this situation. Installing a network card wouldn\u2019t take care of the sharing aspect of the problem. You need a network connection before you can use Transmission Control Protocol/Internet Protocol (TCP/IP) settings to connect to it. AirPrint is Apple\u2019s wireless printing, which would also need to have the printer connected to a wireless network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      92,
      29,
      93,
      89
    ],
    "source": "9781394330348"
  },
  {
    "id": 923,
    "question": "A technician needs to perform maintenance on an inkjet\u2019s dirty paper pickup rollers. What should they use to clean them?",
    "choice_a": "Rubbing alcohol",
    "choice_b": "Mild soap and water",
    "choice_c": "A dry, lint-free cloth",
    "choice_d": "Compressed air",
    "correct_answer": "B",
    "explanation": "Clean pickup rollers (and other rubber rollers) with mild soap and water and not alcohol. Alcohol will dry out the rollers, making them brittle and ineffective. A dry clothwill not remove the dirt or debris, and compressed air would just blow the debris into other internal printer components.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      96,
      75,
      74,
      97,
      89
    ],
    "source": "9781394330348"
  },
  {
    "id": 924,
    "question": "A friend asks what the numbers are that they see advertised on displays, such as 1366 \u00d7 768 or 1920 \u00d7 1080. Which of the following terms will you explain to them?",
    "choice_a": "Refresh rate",
    "choice_b": "Pixel density",
    "choice_c": "Aspect ratio",
    "choice_d": "Resolution",
    "correct_answer": "D",
    "explanation": "Resolution is the number of pixels that a given device can display, expressed as two numbers such as 1366 \u00d7 768. The refresh rate determines how many times per second the screen can be redrawn. A slow refresh rate can make video appear blurry or jumpy. Pixel density is a measure of how many pixels a device can display in a specified space, such as Pixels Per Inch (PPI). A larger display with the same resolution will have a lower pixel density. Aspect ratio defines the relationship between the dimensions (width \u00d7 height) of a display or image. For example, a screen that has a maximum resolution of 1366 \u00d7 768 has an aspect ratio of 16:9. For every 9 pixels in height, there are 16 pixels in width.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      51,
      53,
      27,
      49,
      60
    ],
    "source": "9781394330348"
  },
  {
    "id": 925,
    "question": "You are installing and configuring a magnetic hard drive and have several models from which to choose. Which hard drive is most likely to have the highest data throughput rates?",
    "choice_a": "500 GB, 7200 rpm",
    "choice_b": "750 GB, 5400 rpm",
    "choice_c": "750 GB, 10,000 rpm",
    "choice_d": "1 TB, 7200 rpm",
    "correct_answer": "C",
    "explanation": "The primary factor in determining data throughput for a magnetic hard drive is the spindle speed, which is measured in Revolutions Per Minute (RPM). Higher spin rates will result in faster data reads and writes and increase data throughput.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      33,
      25,
      40,
      44,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 926,
    "question": "Your manager tells you to buy a high-capacity magnetic hard drive with the highest data transfer rate possible. Which hard drive parameter do manufacturers modify to increase hard drive data transfer rates?",
    "choice_a": "Read/write head size",
    "choice_b": "Connector size",
    "choice_c": "Spin rate (rpm)",
    "choice_d": "Platter size",
    "correct_answer": "C",
    "explanation": "To make information available to the rest of the computer more quickly, hard drive manufacturers increase the speed at which the hard drive platters spin, which is measured in Revolutions Per Minute (RPM). The downside of higher speed is usually more heat generated by the drive, so faster hard drives may require additional cooling in the case.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      33,
      25,
      22,
      21,
      23
    ],
    "source": "9781394330348"
  },
  {
    "id": 927,
    "question": "Three of these four motherboard form factors can be mounted in the same style of case. Which ones are they? (Choose three.)",
    "choice_a": "ATX",
    "choice_b": "MicroATX",
    "choice_c": "Mini-ITX",
    "choice_d": "Nano-ITX",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "The Advanced Technology eXtended (ATX), Micro Advanced Technology eXtended (MicroATX), and mini-Information Technology eXtended (Mini-ITX) motherboard form factors can all be mounted inside a standard ATX case. The Mini-ITX will have only three of the four mounting holes line up with the case, but the rear interfaces are placed in the same location as those on ATX motherboards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      2,
      6,
      7,
      24
    ],
    "source": "9781394330348"
  },
  {
    "id": 928,
    "question": "Which RAM feature can detect and possibly fix errors within memory?",
    "choice_a": "Parity",
    "choice_b": "Non-parity",
    "choice_c": "ECC",
    "choice_d": "Non-ECC",
    "correct_answer": "C",
    "explanation": "If memory supports Error-Correcting Code (ECC), check bits are generated and stored with the data. If one of the eight memory bits is in error, ECC can correct the error. ECC tends to be more expensive than non-ECC memory, so it is more often found in servers than in workstations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      14,
      20,
      16,
      15,
      25
    ],
    "source": "9781394330348"
  },
  {
    "id": 929,
    "question": "You have a client who needs a hot-swappable, nonvolatile, long-term storage technology that lets them conveniently carry data from one location to another in their pocket. Which technologies can you recommend? (Choose two.)",
    "choice_a": "USB flash drive",
    "choice_b": "Hybrid SSD",
    "choice_c": "SATA",
    "choice_d": "SD",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Universal Serial Bus (USB) flash drives and Secure Digital (SD) cards are hot-swappable. (In the case of USB, be sure that the flash drive does not contain key file system files needed for the computer to run!) Hybrid Solid-State Drives (SSDs) might or might not be hot-swappable and are physically larger than USB and SD devices. Serial Advanced Technology Attachment (SATA) is a technology for connecting storage drives to motherboards and other devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      38,
      39,
      56,
      34,
      33
    ],
    "source": "9781394330348"
  },
  {
    "id": 930,
    "question": "What type of expansion slots are the first, third, and fifth slots (from the top down) on the motherboard shown here?<img src=\"/question_assets/220-1201/c03f010.png\" alt=\"Close-up of computer motherboard with multiple P C I Express slots, capacitors, and electronic components.\"/>\n\n<figcaption>Close-up of computer motherboard with multiple P C I Express slots, capacitors, and electronic components.</figcaption>",
    "choice_a": "PCIe x1",
    "choice_b": "PCIe x8",
    "choice_c": "PCIe x16",
    "choice_d": "PCI",
    "correct_answer": "C",
    "explanation": "This Scalable Link Interface-ready (SLI-ready) motherboard has three PCIe x16 slots (every other slot, starting with the top one), one Peripheral Component Interconnect Express (PCIe) x1 slot (second slot from the top), and two Peripheral Component Interconnect (PCI) slots (first and third slots from the bottom). Notice the latch and tab that secures the x16 adapters in place by their hooks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      27,
      30,
      1,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 931,
    "question": "You have been asked to assemble 20 new desktop PCs for a client. When you look at the first motherboard, you see eight memory slots. Four of them are blue, and four of them are white. You have four identical RAM modules to install. Which of the following statements are true? (Choose two.)",
    "choice_a": "This is a quad-channel motherboard.",
    "choice_b": "This is a dual-channel motherboard.",
    "choice_c": "For optimal performance, you should install two RAM modules into the blue slots and two into the white slots.",
    "choice_d": "For optimal performance, you should install RAM modules into the same-color slots.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Quad-channel motherboards have four banks of Random Access Memory (RAM) slots. They are usually color-coded such that slots of the same color belong to different channels. For best performance, a RAM module needs to be installed into each channel, so four can be accessed at a time. It\u2019s always best to refer to the motherboard manual for proper RAM placement. Some motherboards will revert to single-channel mode if, for example, three RAM modules were placed in a dual-channel motherboard with four slots. Channels are typically marked with letters.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      15,
      6,
      26,
      18,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 932,
    "question": "You have a computer running Windows 11. Every time you boot, the computer insists on trying to boot from the USB drive. Where can you change the setting to have the system boot to the hard drive first?",
    "choice_a": "BIOS/UEFI",
    "choice_b": "Windows Configuration",
    "choice_c": "System Manager",
    "choice_d": "Device Manager",
    "correct_answer": "A",
    "explanation": "The boot sequence of a computer is changed in the Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI) settings.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      5,
      8,
      13,
      4,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 933,
    "question": "Which of the following types of connectors are generally found on the front or top panel of the computer? (Choose two.)",
    "choice_a": "SATA",
    "choice_b": "PCIe",
    "choice_c": "Power button",
    "choice_d": "USB",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Typical front- or top-panel connectors include Universal Serial Bus (USB), audio, power button, power light, drive activity lights, and the reset button. Serial Advanced Technology Attachment (SATA) and Peripheral Component Interconnect Express (PCIe) connectors are found inside the case, on the motherboard.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      7,
      57,
      61,
      60,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 934,
    "question": "Your manager is excited because they just purchased a fast USB 3.2 Gen 2x2 external hard drive for their team. They want to set it in the middle of the cubicles, allowing everyone to have access to it. Some of the cubicles are about 15 feet away from each other. What is the recommended maximum cable length for this type of device?",
    "choice_a": "3 meters",
    "choice_b": "5 meters",
    "choice_c": "10 meters",
    "choice_d": "15 meters",
    "correct_answer": "A",
    "explanation": "The Universal Serial Bus (USB) 3.0 standard doesn\u2019t specify a cable length limitation, but it does recommend a cable length of 3 meters or less. USB 2.0 cables can be up to 5 meters in length. USB4 cables should be only 0.8 meters. The manager will need a USB hub, and to extend the distance the manager could purchase active USB cables, some of which have an external power supply or extra USB A connector for extra power, or a Cat 5/Cat 6 USB extender.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      56,
      57,
      58,
      30,
      38
    ],
    "source": "9781394330348"
  },
  {
    "id": 935,
    "question": "There are new features for your printer that you\u2019ve read about recently and would like to deploy. How will you install these new features on your printer?",
    "choice_a": "Add them to the printer settings of your operating system.",
    "choice_b": "Turn the printer off and back on.",
    "choice_c": "Upgrade the printer\u2019s firmware.",
    "choice_d": "Stop and restart the spooler service.",
    "correct_answer": "C",
    "explanation": "Firmware upgrades can add new features to your printer, update printer apps with features and security patches, and sometimes fix printing problems. The exact method for installing the firmware upgrade depends on the printer being upgraded.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      91,
      89,
      90,
      96,
      92
    ],
    "source": "9781394330348"
  },
  {
    "id": 936,
    "question": "A medical office needs to make all old records available electronically. What device can they install on their printer to make scanning hundreds of documents go more quickly?",
    "choice_a": "High-capacity paper tray",
    "choice_b": "Flatbed scanner",
    "choice_c": "Duplexing assembly",
    "choice_d": "Automatic document feeder",
    "correct_answer": "D",
    "explanation": "An Automatic Document Feeder (ADF) is a device that sits on top of a flatbed scanner. It is used to pull a stack of papers through and scan them one at a time without user intervention. Some Multifunction Devices (MFDs) will scan the front and back of the paper at the same time.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      95,
      74,
      75,
      93,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 937,
    "question": "You have a desktop computer with three PCI expansion slots. What will happen when you mix cards of different speeds on the same motherboard?",
    "choice_a": "The cards will operate at their original speeds.",
    "choice_b": "None of the cards will function.",
    "choice_c": "The cards will all operate at the faster speed.",
    "choice_d": "The cards will all operate at the slower speed.",
    "correct_answer": "D",
    "explanation": "Peripheral Component Interconnect (PCI) is a shared-bus topology, so mixing 33 MHz and 66 MHz adapters in a 66 MHz system will slow all adapters to 33 MHz. Note: These are quickly becoming legacy expansion slots, but you\u2019ll still find them on some motherboards and the CompTIA objectives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      27,
      32,
      29,
      35
    ],
    "source": "9781394330348"
  },
  {
    "id": 938,
    "question": "You\u2019re working with an artist who creates digital art and wants your input on purchasing a new display. What factor will most likely be the most important in rendering accurate colors?",
    "choice_a": "Color gamut",
    "choice_b": "Pixel density",
    "choice_c": "Aspect ratio",
    "choice_d": "Resolution",
    "correct_answer": "A",
    "explanation": "The color gamut is the range of colors that can be created by a device. Organic Light-Emitting Diode (OLED) displays have the greatest gamut of any display devices. A gamut is more likely represented by a section of a graph showing all possible colors. There\u2019s no specific unit of measure. Several standards exist for explaining a device\u2019s gamut. Pixel density is how many pixels per inch a device has. Aspect ratio defines the relationship between the dimensions (width \u00d7 height) of a display or image. Resolution is the maximum number of pixels of color that a device can display, such as 1024 \u00d7 768 (width by height).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      49,
      48,
      53,
      50,
      51
    ],
    "source": "9781394330348"
  },
  {
    "id": 939,
    "question": "Which of the following is the defining characteristic of a passive heat sink cooling system for a CPU?",
    "choice_a": "It uses water.",
    "choice_b": "It uses heat pipes.",
    "choice_c": "It uses liquid nitrogen or helium.",
    "choice_d": "It does not require a fan or power.",
    "correct_answer": "D",
    "explanation": "Passive cooling systems come in a variety of models, and some are very effective. The defining characteristic is that they do not use a fan or require a power source. Their advantage is that they are the ultimate in cooling-system quiet, because there is no fan or pump running.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      22,
      25,
      24,
      21,
      23
    ],
    "source": "9781394330348"
  },
  {
    "id": 940,
    "question": "Which of the following system settings are configurable in the UEFI? (Choose three.)",
    "choice_a": "Date and time",
    "choice_b": "Enabling and disabling services",
    "choice_c": "CPU fan speeds",
    "choice_d": "Power-on password",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The Unified Extensible Firmware Interface (UEFI) configures many hardware components and settings, such as system date and time, boot sequence, enabling and disabling devices, clock speeds, virtualization support, fans, and UEFI/Boot security.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      13,
      8,
      6,
      41
    ],
    "source": "9781394330348"
  },
  {
    "id": 941,
    "question": "Which level of cache is typically the smallest and closest to the processor die in a computer?",
    "choice_a": "L1",
    "choice_b": "L2",
    "choice_c": "L3",
    "choice_d": "L4",
    "correct_answer": "A",
    "explanation": "The typical increasing order of capacity and distance from the processor die is L1 cache, L2 cache, L3 cache, Random Access Memory (RAM), and Hard Disk Drive/Solid-State Drive (HDD/SSD). The closest caches are located on the processor die.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      6,
      20,
      12,
      16,
      18
    ],
    "source": "9781394330348"
  },
  {
    "id": 942,
    "question": "Why does this power connector have a 20-pin and a 4-pin connector on the side?<img src=\"/question_assets/220-1201/c03f011.png\" alt=\"Close-up of A T X power connector with multiple pins and wires.\"/>\n\n<figcaption>Close-up of A T X power connector with multiple pins and wires.</figcaption>",
    "choice_a": "To support ATX or ATX12V motherboards",
    "choice_b": "To provide power to a hard drive",
    "choice_c": "To power the expansion cards",
    "choice_d": "To power a secondary case fan",
    "correct_answer": "A",
    "explanation": "The figure shows a motherboard power connector that can convert between Advanced Technology eXtended (ATX, 20-pin) and ATX12V (24-pin) power connectors, so it can support either type of motherboard. While technically it can provide power to the hard drive, expansion cards, and case fan, the purpose of the 20+4 connectors is for motherboard compatibility.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      43,
      45,
      41,
      1,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 943,
    "question": "Which of the following are types of CPU sockets? (Choose two.)",
    "choice_a": "LGA2066",
    "choice_b": "CGA",
    "choice_c": "Pentium",
    "choice_d": "TR4",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A Central Processing Unit (CPU) socket is the place on the motherboard where the CPU connects. The Land Grid Array (LGA) socket is used for Intel processors and will include a number that indicates the number of processor pins. LGA places the delicate pins on the motherboard, instead of where they were placed on the CPU like the older Pin Grid Array (PGA) sockets did. TR4 is one of the sockets used by Advanced Micro Devices (AMD) processors. There are many others! A Color Graphics Adapter (CGA) is an ancient type of graphics card. Pentium was the first processor with two arithmetic logic units and is type of Intel processor, not a socket. Tip: Although you might not remember all of the sockets, ensure that you have a good understanding of which groups of sockets are AMD and which are Intel.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      3,
      11,
      9,
      12,
      13
    ],
    "source": "9781394330348"
  },
  {
    "id": 944,
    "question": "Your office has a laser printer, and your manager asks if it can be upgraded to print on both sides of the paper. What type of device can add this functionality?",
    "choice_a": "Flipping assembly",
    "choice_b": "Dual-paper feed assembly",
    "choice_c": "Duplexing assembly",
    "choice_d": "Automatic document feed assembly",
    "correct_answer": "C",
    "explanation": "A printer\u2019s duplexing assembly is used for two-sided printing. After the first page is printed, it\u2019s fed into the duplexing assembly, turned over, and fed back into the paper feed assembly for printing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      75,
      78,
      80,
      77,
      89
    ],
    "source": "9781394330348"
  },
  {
    "id": 945,
    "question": "You\u2019re looking at the A end of a USB cable, and the connector is blue. You want to use it to plug in a USB 2.0 device. The cable is about 2 meters long. Which of the following statements are true? (Choose two.)",
    "choice_a": "The cable is compatible with your device.",
    "choice_b": "The maximum length of the connection is 3 meters.",
    "choice_c": "The connection will run slower than it should.",
    "choice_d": "The cable is likely a 3.0 cable.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The cable is likely a 3.0 cable because of the blue connector. A Universal Serial Bus (USB) 3.0 cable is backward compatible with a USB 2.0 device, so this cable will work with your device. If, however, you had a 3.0 device and a 2.0 cable, the cable would not be able to function at 3.0 speed. The USB 3.0 standard doesn\u2019t specify a cable length limitation, but it does recommend a cable length of 3 meters or less. USB 2.0 cables can be up to 5 meters in length.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      56,
      57,
      63,
      30,
      38
    ],
    "source": "9781394330348"
  },
  {
    "id": 946,
    "question": "What types of RAM modules are shown here, from top to bottom?<img src=\"/question_assets/220-1201/c03f012.png\" alt=\"Two memory modules depict an older-generation and a newer-generation RAM stick, each with multiple integrated circuits.\"/>\n\n<figcaption>Two memory modules depict an older-generation and a newer-generation RAM stick, each with multiple integrated circuits.</figcaption>",
    "choice_a": "DDR3 and DDR4",
    "choice_b": "DDR5 and DDR3",
    "choice_c": "DDR4 and DDR3",
    "choice_d": "DDR4 and DDR5",
    "correct_answer": "A",
    "explanation": "The top module is Double Data Rate 3 (DDR3), and the bottom one is Double Data Rate 4 (DDR4). DDR3 has 240 pins, whereas DDR4 has 288 pins. Double Data Rate 5 (DDR5) also has 288 pins, but the DDR5 key position might vary depending on whether it is an Unbuffered Dual In-Line Memory Module (UDIMM) or Registered (buffered) Dual In-Line Memory Module (RDIMM). Buffered Dual In-Line Memory Module (DIMMs) have several advantages over unbuffered dims, often including Error-Correcting Code (ECC).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      16,
      18,
      6,
      14,
      26
    ],
    "source": "9781394330348"
  },
  {
    "id": 947,
    "question": "The Acme company has a laser printer in its Chicago office that has been used for three months. A technician needs to ship the printer to the Detroit office for use there. What, if any, preparations should be made for the toner cartridge?",
    "choice_a": "No preparations are needed for the toner cartridge before shipping.",
    "choice_b": "Insert a toner blocker into the toner cartridge before shipping.",
    "choice_c": "Seal the toner cartridge with tape before shipping.",
    "choice_d": "Remove the toner cartridge from the printer before shipping.",
    "correct_answer": "D",
    "explanation": "Never ship a printer anywhere with a toner cartridge installed! The jostling that happens during shipping could cause toner to spill out of the cartridge and all over the inside of the printer, and a toner spill is very difficult to clean up. Remove the toner cartridge first. You can put it in a sealed airtight bag to ship, if needed.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      96,
      89,
      77,
      79,
      78
    ],
    "source": "9781394330348"
  },
  {
    "id": 948,
    "question": "A client wants you to upgrade their desktop computer to have two video cards. You want to ensure that this computer can support the extra adapter. What type of open internal expansion slot should you look for?",
    "choice_a": "PCIe",
    "choice_b": "ISA",
    "choice_c": "VGA",
    "choice_d": "DVI",
    "correct_answer": "A",
    "explanation": "Most internal video adapters today are Peripheral Component Interconnect Express (PCIe) cards. You might still find Peripheral Component Interconnect (PCI) video cards available. Industry Standard Architecture (ISA) is a legacy expansion slot type not used today. Video Graphics Array (VGA) and Digital Visual Interface (DVI) are types of display connectors, not expansion slot types.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      2,
      27,
      30,
      60,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 949,
    "question": "You\u2019re unable to boot your computer and are getting an error from BitLocker that no TPM is found. What would most likely solve the problem? (Choose two.)",
    "choice_a": "Update the TPM firmware.",
    "choice_b": "Remove and reinstall the RAM.",
    "choice_c": "Turn on TPM in the UEFI settings.",
    "choice_d": "Reinstall the operating system.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "If a drive is encrypted and the Trusted Platform Module (TPM) module is not found, then the drive won\u2019t start. First, ensure that TPM is enabled/on in the Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI). If that\u2019s not possible or it\u2019s not there, you might need to refresh/update the TPM\u2019s firmware or the motherboard\u2019s BIOS/UEFI.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      8,
      19,
      41,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 950,
    "question": "Which of the following are services created by Apple to enable the automatic discovery of printers on local networks? (Choose two.)",
    "choice_a": "Bonjour",
    "choice_b": "AirPrint",
    "choice_c": "TCP printing",
    "choice_d": "Virtual printing",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Apple created Bonjour and AirPrint. Bonjour helps many devices find each other on a network, not just printers. While many different processes and products use TCP, TCP printing refers specifically to configuring a printer to be found using its TCP/IP address. Virtual printing doesn\u2019t print a hard copy; it prints to a file.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      93,
      90,
      94,
      95,
      92
    ],
    "source": "9781394330348"
  },
  {
    "id": 951,
    "question": "After installing a new print cartridge in an inkjet printer, what process must be run before printing to the device?",
    "choice_a": "Degaussing",
    "choice_b": "Driver installation",
    "choice_c": "Rasterizing",
    "choice_d": "Calibration",
    "correct_answer": "D",
    "explanation": "Before you print to an inkjet printer, you must ensure that the device is calibrated. Calibration is the process by which a device is brought within functional specifications. For example, inkjet printers need their printheads aligned, so that they print evenly and don\u2019t print funny-looking letters and unevenly spaced lines. Degaussing is a process for removing static electricity that develops over some electronics and may interfere with proper color display. Drivers are pieces of software that are specific to a device and operating system and enable the operating system to communicate with the device. Each piece of hardware must have drivers installed. Rasterizing, a term more commonly used in visual communications, means converting an image to pixels.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      76,
      74,
      97,
      31,
      92
    ],
    "source": "9781394330348"
  },
  {
    "id": 952,
    "question": "Which type of printing technology might require replacing or cleaning debris from a heating element if it is no longer making images on waxy paper?",
    "choice_a": "Laser",
    "choice_b": "Inkjet",
    "choice_c": "Thermal",
    "choice_d": "3D printer",
    "correct_answer": "C",
    "explanation": "Thermal printers use a heating element. It heats up spots on special thermal paper (which is waxy and heat-sensitive) to form the image. Laser printers also use heat to bond toner to plain paper. Some inkjet printers use heat to expand bubbles of ink, forcing the ink onto paper. Many types of 3D printers use heat to melt materials that are then extruded onto the paper. While not mentioned under a specific objective, 3D printers are in the hardware and software list recommended by CompTIA.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81,
      96,
      74,
      76,
      79
    ],
    "source": "9781394330348"
  },
  {
    "id": 953,
    "question": "You have a laser printer that is displaying the message \u201cPerform user maintenance.\u201d What should you do to resolve this situation?",
    "choice_a": "Apply a maintenance kit, and clear the message.",
    "choice_b": "Use compressed air to blow out the inside of the printer, and clear the message.",
    "choice_c": "Turn the printer off and back on again to clear the message.",
    "choice_d": "Replace the toner cartridge, and clear the message.",
    "correct_answer": "A",
    "explanation": "When a laser printer requests maintenance, it\u2019s because it has reached a certain page count. Apply a proper maintenance kit (one recommended by the manufacturer), and then clear the service message.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      96,
      77,
      79,
      80,
      78
    ],
    "source": "9781394330348"
  },
  {
    "id": 954,
    "question": "You need to create several UTP cables from a roll of bulk cable. Your company uses the T568B standard. What is the correct order for wires in the connectors?",
    "choice_a": "White/orange, orange, white/green, blue, white/blue, green, white/brown, brown",
    "choice_b": "White/orange, orange, white/green, green, white/blue, blue, white/brown, brown",
    "choice_c": "White/orange, green, white/green, blue, white/blue, orange, white/brown, brown",
    "choice_d": "Orange, white/orange, white/green, blue, white/blue, green, white/brown, brown",
    "correct_answer": "A",
    "explanation": "The correct order for a T568B cable is white/orange, orange, white/green, blue, white/blue, green, white/brown, brown. In the T568A standard, the orange and green cables are swapped. The blue and brown wires don\u2019t change position between the two standards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      63,
      4,
      2,
      58
    ],
    "source": "9781394330348"
  },
  {
    "id": 955,
    "question": "You are installing a coaxial network cable that will support digital cable television signals. What type of cable should you install?",
    "choice_a": "RG-6",
    "choice_b": "RG-59",
    "choice_c": "UTP",
    "choice_d": "STP",
    "correct_answer": "A",
    "explanation": "Cable television installations typically use Radio Guide-6 (RG-6) but may also use Radio Guide-59 (RG-59) coaxial cable. RG-6 is slightly thicker, can run longer distances, and supports digital signals. RG-59 is suited only for analog TV signals and is used for some security cameras. Unshielded Twisted Pair (UTP) and Shielded Twisted Pair (STP) are used in Ethernet networking.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      63,
      90,
      44,
      40
    ],
    "source": "9781394330348"
  },
  {
    "id": 956,
    "question": "You need to replace a faulty 250-foot section of RG-6 cable, but all you have available is RG-59. Which of the following statements is true?",
    "choice_a": "The replacement cable will not work because the distance exceeds RG-59 specifications.",
    "choice_b": "The replacement cable will not work because RG-6 and RG-59 use different connectors.",
    "choice_c": "The replacement cable will not work because RG-6 and RG-59 have different impedances.",
    "choice_d": "If the replacement cable works, it won\u2019t work as well. RG-6 should be purchased.",
    "correct_answer": "D",
    "explanation": "Radio Guide-6 (RG-6) and Radio Guide-59 (RG-59) are types of coaxial cable. RG-6 is a better choice for the given situation because it supports digital signals and has a longer range (304 meters, or 1,000 feet). RG-59 can run up to 228 meters (750 feet). Both have impedance of 75 Ohms, and both use Bayonet Neill-Concelman (BNC) connectors or F-type connectors. RG-6 is usually better insulated and will have less signal loss. While the RG-59 might work, if it doesn\u2019t, would you want to do the job over?",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90
    ],
    "source": "9781394330348"
  },
  {
    "id": 957,
    "question": "You have been asked to design a new network that requires 10 Gbps transmission speeds. Which cable types will meet the minimum specifications? (Choose two.)",
    "choice_a": "MMF",
    "choice_b": "Cat 5",
    "choice_c": "Cat 5e",
    "choice_d": "Cat 6a",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Multimode Fiber (MMF) and Unshielded Twisted Pair (UTP) Cat 6 and newer support 10 Gigabits per second (Gbps) transmission speeds. Cat 5 supports up to 100 Megabits per second (Mbps), and Cat 5e supports up to 1,000 Mbps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      56,
      62,
      4,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 958,
    "question": "What characteristic differentiates STP from UTP?",
    "choice_a": "STP uses RJ-45s connectors instead of RJ-45.",
    "choice_b": "STP follows the T568A wiring standard.",
    "choice_c": "STP does not produce poisonous gas when burned.",
    "choice_d": "STP has a layer of foil shielding inside the cable insulation.",
    "correct_answer": "D",
    "explanation": "Shielded Twisted Pair (STP) cabling has a foil shield surrounding the wire pairs to decrease electrical interference. Some STP cables also shield individual wire pairs. Unshielded Twisted Pair (UTP) does not have the shielding. Both types use Registered Jack-45 (RJ-45) connectors, can follow the T568A and T568B wiring standards, and can be produced as plenum-rated cable that does not produce poisonous gas when burned.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      63,
      56,
      90,
      61,
      57
    ],
    "source": "9781394330348"
  },
  {
    "id": 959,
    "question": "You are investigating remnants of a network setup in an unused building. At the end of a conduit, all you see are the connectors shown here. What type of cable do you expect these connectors to be attached to?<img src=\"/question_assets/220-1201/c03f015.png\" alt=\"Two ends of a fiber optic cable with connectors.\"/>\n\n<figcaption>Two ends of a fiber optic cable with connectors.</figcaption>",
    "choice_a": "Coaxial",
    "choice_b": "STP",
    "choice_c": "UTP",
    "choice_d": "Fiber-optic",
    "correct_answer": "D",
    "explanation": "The connectors shown are Straight Tip (ST) connectors, which are used with fiber-optic cable. ST connectors attach with a Bayonet Neill-Concelman (BNC)-like locking mechanism.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      63,
      60,
      61,
      90,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 960,
    "question": "While cleaning out a storage room, a technician finds several rolls of Cat 5e network cable. The technician thinks they might be able to use it to create replacement cables for their network. What is the maximum speed that this cable will support?",
    "choice_a": "100 Mbps",
    "choice_b": "1 Gbps",
    "choice_c": "10 Gbps",
    "choice_d": "20 Gbps",
    "correct_answer": "B",
    "explanation": "Cat 5e cable can support speeds of 1 Gbps. Cat 5 has a maximum of 100 Megabits per second (Mbps). Cat 6 and newer can support 10 Gigabits per second (Gbps) and Cat 8 cabling can support speeds around 40 Gbps but only for short distances. To run at a given speed, all components of the network must support that speed, including Network Interface Cards (NICs), cable, routers, and switches.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      63,
      4,
      35,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 961,
    "question": "You are replacing cabling in a network. The existing cable was only capable of 100 Mbps maximum speed. What type of cable are you replacing?",
    "choice_a": "Cat 5",
    "choice_b": "Cat 5e",
    "choice_c": "Cat 6a",
    "choice_d": "Single mode",
    "correct_answer": "A",
    "explanation": "Category 5 Unshielded Twisted Pair (Cat 5 UTP) can transmit data at speeds up to 100 Megabits per second (Mbps), for a distance of 100 meters. Category 5 Enhanced (Cat 5e) is capable of 1 Gigabit per second (Gbps). Cat 6 and newer can support 10 Gbps. Single mode is a type of fiber-optic cable and is very fast.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      63,
      60,
      4,
      35,
      2
    ],
    "source": "9781394330348"
  },
  {
    "id": 962,
    "question": "You are installing UTP network cable for a client. The client\u2019s policies require that network cables do not produce poisonous gas when burned. What type of cable do you need to install?",
    "choice_a": "Plenum",
    "choice_b": "PVC",
    "choice_c": "STP",
    "choice_d": "Cat 5e or higher",
    "correct_answer": "A",
    "explanation": "Most network cables are coated with a plastic Polyvinyl Chloride (PVC) coating, which produces toxic gas when burned. Plenum-rated cables are coated with a Teflon-like material that is not poisonous when burned.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      63,
      56,
      57,
      61
    ],
    "source": "9781394330348"
  },
  {
    "id": 963,
    "question": "You\u2019re working to create an enterprise storage system and need to determine the best option. You\u2019re considering whether SATA or SAS drives would be the better choice. Which of the following is not true regarding SAS technology?",
    "choice_a": "SAS is cost effective for desktop use.",
    "choice_b": "SAS supports 12 Gbps or more data speeds.",
    "choice_c": "SAS supports up to 64,000 connections.",
    "choice_d": "SAS operates in full duplex.",
    "correct_answer": "A",
    "explanation": "Serial Attached SCSI (SAS) is a point-to-point serial protocol that is used to send data between Small Computer System Interface (SCSI) storage systems and the device they\u2019re attached to. SAS is a storage system designed for enterprise use. Yes, it can run at 12 Gbps or faster, supports up to 64,000 connections, and operates in full duplex. It provides a serial point-to-point connection, provides error correction, and has a wide base of enterprise installations. However, SAS is not cost effective for desktop use.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      4,
      33,
      30,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 964,
    "question": "A technician has a tablet whose documentation says it can connect to an HDMI display. However, the tablet has a port far smaller than HDMI. What type of video connection would be typical for this small-form-factor device?",
    "choice_a": "USB-C",
    "choice_b": "RS-232",
    "choice_c": "DB-9",
    "choice_d": "Mini-HDMI",
    "correct_answer": "D",
    "explanation": "On small form-factor devices like tablets, the video-out connector is the small version of High-Definition Multimedia Interface (HDMI): a mini-High-Definition Multimedia Interface (mini-HDMI). It resembles a Universal Serial Bus-C (USB-C) but is still tapered on only one side like the larger HDMI connector. To connect to an HDMI display, you would need a mini-HDMI-to-HDMI adapter.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      61,
      63,
      57,
      60,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 965,
    "question": "What was the connectivity port/cable end Apple used to replace the 30-pin dock connector beginning in 2012?",
    "choice_a": "RS-232",
    "choice_b": "Mini-HDMI",
    "choice_c": "MicroUSB",
    "choice_d": "Lightning",
    "correct_answer": "D",
    "explanation": "Lightning was introduced in Autumn 2012 and still works on the Apple 13, released in 2021. Recommended Standard-232 (RS-232) is a type of serial connection that dates back to 1960. A Mini-High-Definition Multimedia Interface (mini-HDMI) is a smaller version of High-Definition Multimedia Interface (HDMI) for smaller devices and requires a mini-HDMI-to-HDMI adapter to plug in a display. Micro-Universal Serial Bus (MicroUSB) is a type of USB connector that was popular for a time.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      61,
      30,
      58
    ],
    "source": "9781394330348"
  },
  {
    "id": 966,
    "question": "With what connection standard is the Apple Thunderbolt 3 cable fully compatible?",
    "choice_a": "USB-C",
    "choice_b": "Mini-HDMI",
    "choice_c": "MicroUSB",
    "choice_d": "DB9",
    "correct_answer": "A",
    "explanation": "Thunderbolt 3 cables work as Universal Serial Bus-Type C (USB-C) cables and are fully compatible. Thunderbolt 3 are capable of transferring at 40 Gbps, but USB 3.1 (on USB-C) can only reach 10 Gbps. USB4 can reach 40 Gbps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      59,
      57,
      56,
      63,
      61
    ],
    "source": "9781394330348"
  },
  {
    "id": 967,
    "question": "Which of the following connection types can be inserted or first flipped over and inserted?",
    "choice_a": "DB9",
    "choice_b": "RS-232",
    "choice_c": "MicroUSB",
    "choice_d": "USB-C",
    "correct_answer": "D",
    "explanation": "Universal Serial Bus-Type C (USB-C) is the only one of these that can be inserted correctly both ways, as you try the first time or flip over and try again. Micro-Universal Serial Bus (MicroUSB) resembles Universal Serial Bus-C (USB-C) but it is not \u201cflippable\u201d\u2014one edge is slightly tapered. A 9-pin D-subminiature connector (DB9) and Recommended Standard-232 (RS-232) are legacy serial connectors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      63,
      61,
      60,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 968,
    "question": "What serial connector type was commonly used for communication, keyboards, mice, or game controllers before USB became popular?",
    "choice_a": "SCSI",
    "choice_b": "PS/2",
    "choice_c": "DB9",
    "choice_d": "Lightning",
    "correct_answer": "C",
    "explanation": "DB9 was the \u201cD\u201d format, 9-pin serial connector type that was the standard format for keyboards, mice, and other small peripherals. It was also used for communications between a Personal Computer (PC) and some managed switches. Small Computer Systems Interface (SCSI) is a type of drive connector and technology that would enable up to 15 drives on one daisy chain. The Personal System/2 (PS/2) connector, also called a mini-DIN, is newer than a DB9 connector but older than Universal Serial Bus (USB). It has six pins and was used for connecting mice (color-coded green) and keyboards (color-coded purple). Lightning connectors are used on Apple devices but have been replaced by Universal Serial Bus-C (USB-C) connectors on newer devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      61,
      60,
      7,
      58
    ],
    "source": "9781394330348"
  },
  {
    "id": 969,
    "question": "Which of the following does not apply to triple channel memory?",
    "choice_a": "Triple the 64-bit communication path to the CPU",
    "choice_b": "Triple the speed with which memory is accessed",
    "choice_c": "Requires installation of three matched memory modules",
    "choice_d": "Triple the memory access latency",
    "correct_answer": "D",
    "explanation": "Triple channel memory is achieved when three matching memory modules are installed, permitting data to be spread and memory accessed simultaneously. The effect is lower memory latency, triple the access speed (compared to a single channel), and triple the 64-bit communication path.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      15,
      6,
      16,
      19,
      25
    ],
    "source": "9781394330348"
  },
  {
    "id": 970,
    "question": "What form factor for solid-state drives (SSDs) measures 22 mm wide, with lengths varying between 30 mm, 42 mm, 60 mm, and longer?",
    "choice_a": "NVMe",
    "choice_b": "SATA",
    "choice_c": "PCIe",
    "choice_d": "M.2",
    "correct_answer": "D",
    "explanation": "M.2 is a Solid-State Drive (SSD) form factor measuring 22 mm wide. Its lengths vary between 30 mm, 42 mm, 60 mm, 80 mm, and 120 mm. Non-Volatile Memory Express (NVMe) is a storage protocol, not a form factor. Many M.2 drives use the Non-Volatile Memory Express (NVMe) protocol. Serial Advanced Technology Attachment (SATA) andPeripheral Component Interface Express (PCIe) are bus interface standards found on a motherboard.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      4,
      35,
      34,
      40
    ],
    "source": "9781394330348"
  },
  {
    "id": 971,
    "question": "What form factor for solid-state hard (SSH) drives has dimensions that mirror the older, platter-type magnetic drives?",
    "choice_a": "M.2",
    "choice_b": "mSATA",
    "choice_c": "2.5-inch",
    "choice_d": "NVMe",
    "correct_answer": "C",
    "explanation": "Magnetic drives were available in 1.8-, 2.5-, and 3.5-inch formats. Solid-State Drives (SSDs) come in multiple form factors, such as a \u201cstick\u201d called an M.2, resembling a tiny memory module, but with connectors on the end rather than the long edge, or a 2.5-inch box. SSDs also come in a 3.5-inch form factor. M.2 and Mini-Serial Advanced Technology Attachment (mSATA) are form factors for SSDs. Non-Volatile Memory Express (NVMe) is a protocol for storing data that is commonly used with M.2 drives, although M.2 drives can also use the older Advanced Host Controller Interface (AHCI).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      34,
      35,
      33,
      36,
      40
    ],
    "source": "9781394330348"
  },
  {
    "id": 972,
    "question": "You want to connect a 3.5-inch external hard drive to your computer. What port is used to connect external drives to the SATA bus?",
    "choice_a": "NVMe",
    "choice_b": "eSATA",
    "choice_c": "M.2",
    "choice_d": "mSATA",
    "correct_answer": "B",
    "explanation": "External Serial Advanced Technology Attachment (eSATA) is a type of connector for eSATA drives. Nonvolatile Memory Express (NVMe) is a protocol and communications interface designed to connect small Solid-State Drive (SSD) storage to the Peripheral Component Interface Express (PCIe) bus of a motherboard. The Advanced Host Controller Interface (AHCI) technology preceded Nonvolatile Memory Express (NVMe) and was much slower. M.2 and Mini-Serial Advanced Technology Attachment (mSATA) are form factors for SSDs that connect directly to a motherboard. An mSATA drive looks similar to an M.2 drive, but the connectors are slightly different and mSATA only connects to the slower SATA bus using AHCI technology. M.2 drives can be either NVMe or AHCI, so checking the documentation is important.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      4,
      62,
      35,
      33,
      40
    ],
    "source": "9781394330348"
  },
  {
    "id": 973,
    "question": "You want to protect your system from someone not authorized to start the OS. What is your best option?",
    "choice_a": "Password-protect the lock screen.",
    "choice_b": "Password-protect in the BIOS/UEFI settings.",
    "choice_c": "Encrypt the hard drive.",
    "choice_d": "Use a 12-character login password.",
    "correct_answer": "B",
    "explanation": "The system Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI) settings include password protection to not enable system bootup unless someone enters a password. This would prohibit the Operating System (OS) from loading upon boot.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      8,
      13,
      11,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 974,
    "question": "What is used to ensure an efficient and effective heat exchange into a heat sink and away from the CPU?",
    "choice_a": "Thermal paste",
    "choice_b": "High-tension clamps to heat sink",
    "choice_c": "Dihydrogen monoxide coolant",
    "choice_d": "Lower CPU speeds",
    "correct_answer": "A",
    "explanation": "Thermal paste is like a grease that ensures that the heat generated from the Central Processing Unit (CPU) is efficiently conducted away and into the heat sink. New coolers (fan/heat sink combinations) often come with thermal pads (paste) preinstalled. Lowering the CPU\u2019s speed might result in less heat generated, but it would obviously also result in degraded performance.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      22,
      21,
      23,
      25,
      12
    ],
    "source": "9781394330348"
  },
  {
    "id": 975,
    "question": "A coworker has asked you to upgrade their computer. You research the model number and see x86 in the listing. Which of the following are true about this computer? (Choose two.)",
    "choice_a": "The computer has a 64-bit processor.",
    "choice_b": "The computer has a 32-bit processor.",
    "choice_c": "The computer supports 86 GB of RAM.",
    "choice_d": "The maximum RAM supported is 4 GB.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "x86 refers to computers that are only capable of supporting 32-bit processors and software. It\u2019s unlikely that you\u2019ll find one of these in the wild, but CompTIA still wants you to know what they are. The bus width on these motherboards limits the number of possible memory addresses to 4 GB, so it won\u2019t recognize more Random Access Memory (RAM) than that. x64 denotes a 64-bit processor, which has a theoretical limit of approximately 16 Exabytes (EB) of addresses.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      10,
      19,
      20,
      6,
      15
    ],
    "source": "9781394330348"
  },
  {
    "id": 976,
    "question": "You attempt to plug a professional-level headphone jack into a computer but can\u2019t find the 3.5-mm jack. The headphones don\u2019t support Bluetooth or Wi-Fi. What are your best options? (Choose two.)",
    "choice_a": "Install a sound card.",
    "choice_b": "Buy a new professional headset.",
    "choice_c": "Cut the jack off and replace it with a USB end.",
    "choice_d": "Purchase a USB-C\u2013to\u20133.5-mm adapter.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "If the computer is a desktop, you could install a new sound card. Otherwise, the best option is to purchase a Universal Serial Bus-C (USB-C) to 3.5mm adapter. You wouldn\u2019t want to buy a new professional headset because it will still likely have a 3.5mm or 6.35mm jack, and no place to plug it into the computer. As for cutting the jack off, just buy the adapter instead. Other expansion cards include but are not limited to capture cards, Network Interface Cards (NICs), video, and Universal Serial Bus (USB) ports.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      28,
      56,
      30,
      2,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 977,
    "question": "You need to purchase RAM for a computer. Which factors determine the speed of memory you should purchase? (Choose two.)",
    "choice_a": "CPU speed",
    "choice_b": "RAM speed supported by the motherboard",
    "choice_c": "RAM speed supported by the processor",
    "choice_d": "RAM speed supported by the TPM chip",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The speed of Random Access Memory (RAM) that a computer can use is limited by the speed of the motherboard\u2019s memory bus and the speed of RAM supported by the processor, especially now that the memory controller is part of the processor. Even if faster RAM is purchased, it will run at the slower speed of the memory bus or what the processor supports.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      19,
      16,
      12,
      15,
      17
    ],
    "source": "9781394330348"
  },
  {
    "id": 978,
    "question": "You installed a new motherboard because the previous one failed. Your new motherboard doesn\u2019t have a VGA display port; it has onboard HDMI. Your display only uses VGA. What is the least expensive option to resolve this dilemma?",
    "choice_a": "Purchase a new display.",
    "choice_b": "Return the motherboard, and choose a different one.",
    "choice_c": "Purchase a video card with a VGA port on it.",
    "choice_d": "Purchase an HDMI-to-VGA adapter.",
    "correct_answer": "D",
    "explanation": "Although the more fun answer is to purchase a new display, the question asks what would be the least expensive, and that is to purchase a High-Definition Multimedia Interface-to-Video Graphics Array (HDMI-to-VGA) adapter. There are adapters for almost everything on a computer system, so in a case like this, that would be the quickest and least expensive solution.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      60,
      63,
      27,
      52,
      53
    ],
    "source": "9781394330348"
  },
  {
    "id": 979,
    "question": "You need to replace an older, inefficient power supply on a desktop computer with a newer, more efficient one. Your manager has asked you to find one that is at least 90% efficient with a 50% load. Which of the following 80 Plus efficiency ratings would be appropriate? (Choose two.)",
    "choice_a": "Bronze",
    "choice_b": "Gold",
    "choice_c": "Silver",
    "choice_d": "Titanium",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The 80 Plus efficiency rating standards are widely recognized and are a great way to determine how efficient a power supply is. There are three standards that would meet the requirement to be 90 percent efficient with a 50 percent load on the power supply. Those are 80 Plus Gold, 80 Plus Platinum, and 80 Plus Titanium, with 90, 92, and 94 percent, respectively. Other ratings are simply 80 Plus, 80 Plus Bronze, and 80 Plus Silver. Their ratings with a 50 percent load are 80, 85, and 88 percent, respectively.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      47,
      41,
      45,
      43,
      44
    ],
    "source": "9781394330348"
  },
  {
    "id": 980,
    "question": "A new technician is tasked with replacing power supplies in 10 computers. They ask you why, because the computers seem to be working fine. What will you tell them the advantages of a new, more efficient power supply are? (Choose two.)",
    "choice_a": "More space in the case.",
    "choice_b": "Reduced heat.",
    "choice_c": "Lower cost to run.",
    "choice_d": "They\u2019re noiseless.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A more efficient Power Supply Unit (PSU) will lose less energy as heat, so there will be less heat in the case and less wasted electricity, which results in a lower cost to run. They\u2019re also more likely to be able to run at their maximum capacity without having problems. The 80 Plus efficiency rating standards are widely recognized and are a great way to determine efficiency of a power supply.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      47,
      21,
      45,
      41,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 981,
    "question": "You\u2019ve been asked to replace some UTP network cable with other UTP cable that is capable of 10 Gbps. The longest drop is 75 meters (246 feet) from the network rack. What is the lowest category of cable that can meet your needs?",
    "choice_a": "Cat 5",
    "choice_b": "Cat 5e",
    "choice_c": "Cat 6",
    "choice_d": "Cat 6a",
    "correct_answer": "D",
    "explanation": "Cat 6 and newer can support 10 Gigabits per second (Gbps), but Cat 6 can only go 55 meters at 10 Gbps. To go 100 meters (328 feet), you need Cat 6a. Cat 5e\u2019s top speed is 1 Gbps, and Cat 5 is only 100 Megabits per second (Mbps).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      56,
      63,
      90,
      93
    ],
    "source": "9781394330348"
  },
  {
    "id": 982,
    "question": "Which of the following steps might not be necessary when setting up a printer share?",
    "choice_a": "Share a printer that\u2019s installed on a network.",
    "choice_b": "Install a printer sharing app.",
    "choice_c": "Add the printer to the PrintShare app, and configure it with a sharename and or IP address.",
    "choice_d": "Install a printer driver.",
    "correct_answer": "D",
    "explanation": "A printer share is a service that enables a user to print from a mobile device to a shared printer. The printer first needs to be installed and shared on a network. A user can then download a printer share app, or connect to a printer share service, and add the shared printer. Sometimes, but not always, the printer driver will need to be installed in the printer share service.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      89,
      90,
      93,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 983,
    "question": "Your friend wants to run cable for a Power over Ethernet (PoE) WAP in their workshop, which is about 100 feet (about 30 meters) from the network connection in their house. They\u2019re not sure how to go about it, but they know that they don\u2019t want to have wires overhead. They also want to make sure it is shielded. What type of cable can you suggest that can go that far and has superior insulation and a water blocking layer?",
    "choice_a": "Cat 7",
    "choice_b": "Direct burial STP",
    "choice_c": "UTP Cat 10",
    "choice_d": "Cat 6e",
    "correct_answer": "B",
    "explanation": "Direct burial cable is made to go underground without any kind of conduit around it. The coating is made to be waterproof and block moisture vapor as well. A good cable will also protect against degradation from sunlight.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      95,
      45,
      41,
      44,
      46
    ],
    "source": "9781394330348"
  },
  {
    "id": 984,
    "question": "What are advantages of UTP over STP? (Choose two.)",
    "choice_a": "UTP is more flexible.",
    "choice_b": "UTP can run faster.",
    "choice_c": "UTP can be buried.",
    "choice_d": "UTP is less expensive.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Shielded Twisted Pair (STP) has at least one extra layer of shielding to protect the cable from crosstalk and interference. Some types of STP have shielding around each wire. With all the extra material, STP tends to be less flexible and more expensive than Unshielded Twisted Pair (UTP). Being shielded or unshielded doesn\u2019t affect the maximum transmission speed of a cable, and UTP is not suitable for direct burial.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81
    ],
    "source": "9781394330348"
  },
  {
    "id": 985,
    "question": "What type of network cable uses pulses of light to transmit data instead of an electrical charge?",
    "choice_a": "STP",
    "choice_b": "Coaxial",
    "choice_c": "Plenum",
    "choice_d": "Fiber-optic",
    "correct_answer": "D",
    "explanation": "Only fiber-optic cables use pulses of light to transmit data. The other three listed are types of copper cable that use electrical charges to transmit data signals.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      60,
      61,
      29,
      4,
      2
    ],
    "source": "9781394330348"
  },
  {
    "id": 986,
    "question": "You\u2019re setting up a datacenter and need a nonproprietary cable that will operate at 40 Gbps for 20 meters. Which category of cable should you choose?",
    "choice_a": "Cat 6",
    "choice_b": "Cat 6a",
    "choice_c": "Cat 7",
    "choice_d": "Cat 8",
    "correct_answer": "D",
    "explanation": "Category 8 cable is the only acceptable choice. It is capable of 40 Gbps up to 30 meters (100 feet), 10 Gbps over 100 meters (328 feet), and is approved by the Institute of Electrical and Electronics Engineers (IEEE). Category 8 is a popular choice for datacenters and storage area networks (SANs). Category 6 and 6a cable are not fast enough. Category 7 is not a ratified IEEE standard, nor is it approved by the Telecommunications Industry Association/Electronic Industries Alliance (TIA/EIA), and it doesn\u2019t use a standard Random Jack-45 (RJ-45) connector.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      60,
      4,
      63,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 987,
    "question": "What type of connector is shown here?<img src=\"/question_assets/220-1201/c03f017.png\" alt=\"Close-up of a computer's U S B port on a device with internal pins.\"/>\n\n<figcaption>Close-up of a computer's U S B port on a device with internal pins.</figcaption>",
    "choice_a": "SATA",
    "choice_b": "eSATA",
    "choice_c": "HDMI",
    "choice_d": "SATAe",
    "correct_answer": "B",
    "explanation": "External Serial Advanced Technology Attachment (eSATA) connectors provide a way to access the Serial Advanced Technology Attachment (SATA) bus via an external connector. SATA is a type of internal drive connection and bus that replaced the older Parallel Advanced Technology Attachment (PATA). High-Definition Multimedia Interface (HDMI) is an audio/video interface. Serial Advanced Technology Attachment Express (SATAe) is a motherboard bus that supports both SATA and Peripheral Component Interconnect Express (PCIe).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      62,
      4,
      44,
      57,
      60
    ],
    "source": "9781394330348"
  },
  {
    "id": 988,
    "question": "An employee called the help desk because they\u2019re printing a document and it always gets cut off on the sides of the page. What settings will you guide this employee to change?",
    "choice_a": "Duplexing",
    "choice_b": "Collating",
    "choice_c": "Print Quality",
    "choice_d": "Orientation",
    "correct_answer": "D",
    "explanation": "The orientation of paper refers to whether it is printing wider than long (i.e., landscape) or longer than wide (i.e., portrait). Sometimes, getting a document to print correctly requires changing the print job\u2019s orientation. Duplexing is printing on the front and back. Other common options or settings include collating (i.e., printing pages in sets such as 1, 2, 3, 1, 2, 3) and print quality (such as draft or high resolution).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      74,
      75,
      90,
      94
    ],
    "source": "9781394330348"
  },
  {
    "id": 989,
    "question": "You have a motherboard that has 16 RAM slots. It is a quad-channel, with four RAM slots for each channel. The slots are all black, but they are labeled A1, A2, A3, A4, B1, B2, B3, B4, and so on. To take advantage of the quad-channel feature, how will you install the RAM modules?",
    "choice_a": "Any four slots will work for quad channel.",
    "choice_b": "Install them all in the A slots.",
    "choice_c": "Install them in A1, B2, C3, and D4.",
    "choice_d": "Install them in A1, B1, C1, and D1.",
    "correct_answer": "D",
    "explanation": "Typically in a motherboard with multichannel support, the channels will be labeled with a letter (A, B, C, D). To take advantage of the multichannel capabilities, you would install one Random Access Memory (RAM) module in each channel. Lowest numbered slots are usually filled first, so you would use slot 1 (or 0\u2014zero\u2014if numbering starts there) of each channel. You should, of course, always consult the motherboard documentation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      15,
      6,
      26,
      16,
      8
    ],
    "source": "9781394330348"
  },
  {
    "id": 990,
    "question": "One of the users you support is using a great deal of ink, although they print less than some other users. What setting will you change for this user?",
    "choice_a": "Duplexing",
    "choice_b": "Collating",
    "choice_c": "Print Quality",
    "choice_d": "Orientation",
    "correct_answer": "C",
    "explanation": "Print quality settings affect how a print job looks by changing the speed and/or amount of material (in this case, ink) that is used to create the hard copy. Printers will usually enable you to change the amount of ink used to print a document. The Draft setting is lower quality and uses less ink, and often prints faster. High-resolution settings will use more ink and usually print slower, but produce better output. Often, the draft setting is sufficient for a user\u2019s needs and can save money on ink. Duplexing is printing on the front and back. Other common options or settings include orientation (i.e., portrait or landscape) and collating (i.e., printing pages in sets such as 1, 2, 3, 1, 2, 3).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      74,
      90,
      97,
      76
    ],
    "source": "9781394330348"
  },
  {
    "id": 991,
    "question": "What network connectivity device is shown here?<img src=\"/question_assets/220-1201/c03f018.png\" alt=\"Close-up of 24-port R J 45 network patch panel with Ethernet ports and connectors.\"/>\n\n<figcaption>Close-up of 24-port R J 45 network patch panel with Ethernet ports and connectors.</figcaption>",
    "choice_a": "Hub",
    "choice_b": "Switch",
    "choice_c": "Router",
    "choice_d": "Punchdown block",
    "correct_answer": "D",
    "explanation": "This is a punchdown block. It can be found in a telecommunications closet mounted on a networking rack. Network drops from work areas are terminated (punched down) in the back, and cables with Registered Jack-45 (RJ-45) connectors connect the front to a switch or router.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      63,
      56,
      57,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 992,
    "question": "What is the purpose of a Molex connector?",
    "choice_a": "Parallel data communications",
    "choice_b": "Serial data communications",
    "choice_c": "Power connections",
    "choice_d": "Fan connectors on the motherboard",
    "correct_answer": "C",
    "explanation": "Molex connectors have a metal sleeve inside a plastic housing. Technically, they can come in any number of connections, but those used most often in computer systems are 4-pin, 6-pin, 8-pin, and 20/24-pin. They are used to provide power to various devices and the motherboard.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      44,
      43,
      45,
      41,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 993,
    "question": "You just purchased a network-enabled MFD for a secure environment. Several users will be using this same printer, and you want to ensure that print jobs won\u2019t be output to a tray unless the user is at the printer. Which of the following security practices will not meet your needs?",
    "choice_a": "Badging",
    "choice_b": "PINs",
    "choice_c": "Audit logs",
    "choice_d": "Biometric authentication",
    "correct_answer": "C",
    "explanation": "Audit logs can show you what\u2019s happened after the fact, but they won\u2019t help prevent a problem. Badging, personal identification numbers (PINs), and biometrics are all methods of authentication when working with secure printing. With badging, the user will need a physical badge to gain access to the printer. A PIN is something known to the user that should not be shared with other users, and biometrics are using part of your body, such as a fingerprint, to authenticate to the printer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      94,
      92,
      90,
      89,
      95
    ],
    "source": "9781394330348"
  },
  {
    "id": 994,
    "question": "What are the two types of connectors shown here, left to right?<img src=\"/question_assets/220-1201/c03f019.png\" alt=\"Close-up of Micro H D M I cable with two male angled connectors.\"/>\n\n<figcaption>Close-up of Micro H D M I cable with two male angled connectors.</figcaption>",
    "choice_a": "MicroUSB, MiniUSB",
    "choice_b": "MiniUSB, MicroUSB",
    "choice_c": "USB-A, USB-B",
    "choice_d": "USB-C, USB4",
    "correct_answer": "B",
    "explanation": "The connector on the left is a Mini-Universal Serial Bus (MiniUSB), and the one on the right is a Micro-Universal Serial Bus (MicroUSB).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      61,
      63,
      60,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 995,
    "question": "What type of drive is likely to be a 15,000-rpm drive?",
    "choice_a": "NVMe",
    "choice_b": "SSD",
    "choice_c": "Blu-ray",
    "choice_d": "Magnetic",
    "correct_answer": "D",
    "explanation": "Non-Volatile Memory Express (NVMe) storage and Solid-State Drives (SSDs) don\u2019t have platters that spin. Blu-ray optical discs spin, but their spin speed is not how they are measured. Only magnetic Hard Disk Drives (HDDs) are measured in rpms, and 15,000 would be a very fast magnetic drive.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      33,
      34,
      36,
      4,
      39
    ],
    "source": "9781394330348"
  },
  {
    "id": 996,
    "question": "What type of hard drives are not available in a 3.5-inch form factor?",
    "choice_a": "SSD",
    "choice_b": "mSATA",
    "choice_c": "SATA",
    "choice_d": "HDD",
    "correct_answer": "B",
    "explanation": "Mini-Serial Advanced Technology Attachment (mSATA) and M.2 storage are Solid-State Drives (SSDs) consisting of a very small circuit board that connects directly to the motherboard via a slot with a screw or connector to hold it in place. Solid-State Drives (SSDs) and Hard-Disk Drives (HDDs) can both be found in the 3.5-inch and 2.5-inch form factors that are used in desktop computers, and they often connect via a Serial Advanced Technology Attachment (SATA) interface. The 2.5-inch drive form factor is used in some laptops; others use M.2 storage.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      34,
      33,
      4,
      40
    ],
    "source": "9781394330348"
  },
  {
    "id": 997,
    "question": "What keys are used for M.2 slots? (Choose two.)",
    "choice_a": "A",
    "choice_b": "B",
    "choice_c": "E",
    "choice_d": "M",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "M.2 drives are keyed with B or M, or B and M keys. A and E keys are for Wi-Fi, Bluetooth, or cellular devices such as networking cards (not M.2s) found in laptops. In computers, a key is a device such as a notch\u2014an indent on a circuit board\u2014that ensures you can\u2019t plug the wrong type of device into something. Power connectors are keyed by shape, Random Access Memory (RAM) modules are keyed with notches in different places, Central Processing Units (CPUs) will have keys, Serial Advanced Technology Attachment (SATA) connectors have an L shape for a key, and M.2 drives are keyed as well. In an M.2, a B key is for Peripheral Component Interconnect Express (PCIe) x 2/SATA/USB and so on, and an M key is Peripheral Component Interconnect Express (PCIe) x 4/SATA.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      4,
      34,
      1,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 998,
    "question": "Which version of SATA ties SATA drives into the PCIe bus on the motherboard, boosting the data throughput far beyond 600 Mbps?",
    "choice_a": "SATA 1",
    "choice_b": "SATA 2",
    "choice_c": "SATA 3.2",
    "choice_d": "SATA 4",
    "correct_answer": "C",
    "explanation": "Serial Advanced Technology Attachment 3 (SATA 3) has a speed of 6 Gigabits per second (Gbps) and a data throughput of 600 Megabytes per second (MBps), but Serial Advanced Technology Attachment 3.2 (SATA 3.2)\u2014also called Serial Advanced Technology Attachment Express (SATAe)\u2014ties compatible drives into the Peripheral Component Interconnect Express (PCIe) bus on the motherboard, decreasing overhead and taking advantage of the PCIe bus speeds, which makes the data throughput multiple times better.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      4,
      36,
      2,
      33
    ],
    "source": "9781394330348"
  },
  {
    "id": 999,
    "question": "Which of the following are AMD socket types? (Choose two.)",
    "choice_a": "Socket AM4",
    "choice_b": "LGA 1200",
    "choice_c": "Socket TR4",
    "choice_d": "LGA 2066 Socket R4",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Socket AM4 and Socket TR4 are only compatible with Advanced Micro Devices (AMD) processors. The two Land Grid Array (LGA) sockets listed are for use with Intel processors only.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      3,
      11,
      9,
      1,
      13
    ],
    "source": "9781394330348"
  },
  {
    "id": 1000,
    "question": "What connects in the motherboard socket shown here?<img src=\"/question_assets/220-1201/c03f020.png\" alt=\"Close-up of a computer motherboard with a highlighted C P U socket.\"/>\n\n<figcaption>Close-up of a computer motherboard with a highlighted C P U socket.</figcaption>",
    "choice_a": "M.2 drive",
    "choice_b": "Hard drive",
    "choice_c": "RAM",
    "choice_d": "TPM",
    "correct_answer": "A",
    "explanation": "This socket is for an M.2 drive. Notice the holes for a screw to hold the different drive lengths. An HDD would usually connect via a SATA connection, RAM uses slots, and TPM connects to the motherboard via a socket.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      36,
      4,
      35,
      11,
      3
    ],
    "source": "9781394330348"
  },
  {
    "id": 1001,
    "question": "The server motherboard shown here has a processor (with a heat sink) on the right and a location for a second processor to be inserted on the left. What term describes this type of motherboard?<img src=\"/question_assets/220-1201/c03f021.png\" alt=\"Close-up of motherboard with a processor on the right and a slot for a second processor on the left with multiple RAM slots.\"/>\n\n<figcaption>Close-up of motherboard with a processor on the right and a slot for a second processor on the left with multiple RAM slots.</figcaption>",
    "choice_a": "Multicore",
    "choice_b": "Multithreaded",
    "choice_c": "Coprocessor",
    "choice_d": "Multisocket",
    "correct_answer": "D",
    "explanation": "This is a multisocket motherboard, meaning that it has sockets for more than one processor. The other three terms describe characteristics of processors. Multicore is more than one core on a die. All new processors are multicore. Multithreaded means each core can perform more than one string of code at a time, and a coprocessor is usually a chip designed to perform a specific function to help a processor be more efficient.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      9,
      3,
      11,
      12,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 1002,
    "question": "What type of motherboard may have multiple processors, multiple power supplies, and plenty of ECC RAM and can sometimes be found mounted in a networking rack?",
    "choice_a": "Server",
    "choice_b": "Workstation",
    "choice_c": "Desktop",
    "choice_d": "Mobile",
    "correct_answer": "A",
    "explanation": "Servers often perform more work than any other computer on a network, especially in a virtualization environment. A server could be as simple as an ordinary desktop computer, but more often the server will have extra processing power and loads of Random Access Memory (RAM), and be rack-mounted for easy access by technicians in a corporateenvironment. Error-Correcting Code (ECC) RAM is most often used only in servers, because it\u2019s too expensive for the desktop market.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      9,
      14,
      46,
      15,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 1003,
    "question": "Which of the following processors are you more likely to find in a server than a workstation? (Choose two.)",
    "choice_a": "Intel Atom",
    "choice_b": "Intel Xeon",
    "choice_c": "AMD EPYC",
    "choice_d": "AMD Ryzen 3",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Intel Xeon and Advanced Micro Devices (AMD) EPYC processors are designed to be high-end server processors. The Atom processor is a small form factor processor, and the Ryzen 3 is a desktop processor.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      9,
      12,
      14,
      3,
      11
    ],
    "source": "9781394330348"
  },
  {
    "id": 1004,
    "question": "What type of motherboard is designed to be very compact and is generally proprietary?",
    "choice_a": "Server",
    "choice_b": "Workstation",
    "choice_c": "Desktop",
    "choice_d": "Mobile",
    "correct_answer": "D",
    "explanation": "Motherboards found in smaller devices, such as laptops and cellphones, tend to be very proprietary, meaning that if you can replace them, you must replace them with a board made by the same manufacturer for that precise device.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      9,
      1,
      6,
      7,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 1005,
    "question": "Which of the following are true about ARM architecture? (Choose two.)",
    "choice_a": "It\u2019s licensed by ARM Holdings to many chip manufacturers.",
    "choice_b": "It uses Complex Instruction Set Computing (CISC).",
    "choice_c": "It uses Reduced Instruction Set Computing (RISC).",
    "choice_d": "It is only found in smartphones.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "ARM Holdings, LTD., is the company that has developed the various iterations of ARM processors. ARM is famous for developing Reduced Instruction Set Computing (RISC), and their intellectual property can be found in everything from embedded systems and smartphones, all the way up to servers. An ARM processor is considered to be a System-on-a-Chip (SoC) rather than a Central Processing Unit (CPU), because processors are built with various features around the ARM processor.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      10,
      13,
      11,
      3,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 1006,
    "question": "You work in a secure environment, and it\u2019s your responsibility to ensure that no data leaves the network. You\u2019ve just received a batch of new computers. What can you do in the UEFI to help ensure that users can\u2019t copy data to a USB drive?",
    "choice_a": "Look for a setting to disable USB ports, and disable them.",
    "choice_b": "Put USB ports first in the boot options.",
    "choice_c": "Remove USB from the boot options.",
    "choice_d": "Look for a setting to enable USB ports, and enable them.",
    "correct_answer": "A",
    "explanation": "If you disable the Universal Serial Bus (USB) ports, users won\u2019t be able to attach a USB drive to copy files. Removing USB from the boot options will keep them from booting to it, but it won\u2019t prohibit someone from using a USB drive. You can also purchase USB drive locks, which are little plugs for the USB ports. Just don\u2019t lose your key!",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      5,
      7,
      30,
      58,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 1007,
    "question": "What are the four motherboard connectors shown here?<img src=\"/question_assets/220-1201/c03f022.png\" alt=\"Close-up of a motherboard with four connectors.\"/>\n\n<figcaption>Close-up of a motherboard with four connectors.</figcaption>",
    "choice_a": "USB",
    "choice_b": "SATA data",
    "choice_c": "SATA power",
    "choice_d": "M.2 drives",
    "correct_answer": "B",
    "explanation": "The connectors shown are for data connections to Serial Advanced Technology Attachment (SATA) drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      4,
      62,
      44,
      35,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 1008,
    "question": "You\u2019re building a SAN for your company. Which of the following will you most likely need to install in your server to attach the server to the SAN?",
    "choice_a": "NIC",
    "choice_b": "Modem",
    "choice_c": "Fibre Channel HBA",
    "choice_d": "WAP",
    "correct_answer": "C",
    "explanation": "A Storage Area Network (SAN) is a separate network that has only storage devices on it, but you still need a way to connect to that storage. Connecting can be done through a Host Bus Adapter (HBA) connected through the PeripheralComponent Interconnect Express (PCIe) bus on a network server\u2019s motherboard. Because Fibre Channel (FC) networks are so fast, they are often used for SANs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      59,
      4,
      9,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 1009,
    "question": "Your friend is looking over your shoulder as you work on a computer. They ask what all the pins sticking up are. Some are labeled USB1, some USB2, and others are labeled \u201cfront panel.\u201d What is the generic term for these pins on the motherboard?",
    "choice_a": "Ports",
    "choice_b": "Pins",
    "choice_c": "Standoffs",
    "choice_d": "Headers",
    "correct_answer": "D",
    "explanation": "These pins are called headers. The ones mentioned connect the motherboard to the case front, where you will find Universal Serial Bus (USB) ports, power buttons, Hard Disk Drive (HDD) status lights, and reset switches.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      7,
      1,
      2,
      23,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 1010,
    "question": "You\u2019re receiving a \u201cLow Toner\u201d message from your printer. What type of printer are you using?",
    "choice_a": "Laser",
    "choice_b": "Thermal",
    "choice_c": "Impact",
    "choice_d": "Inkjet",
    "correct_answer": "A",
    "explanation": "Laser printers need toner cartridges and will often let you know when it\u2019s time to replace them. Inkjet printers use ink cartridges that need replacing when the ink level is low or empty. Impact printers need ink ribbons, and thermal printers need special thermal paper.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      77,
      74,
      73,
      96,
      81
    ],
    "source": "9781394330348"
  },
  {
    "id": 1011,
    "question": "What advantage does RAID-6 have over RAID-5?",
    "choice_a": "Striping",
    "choice_b": "Parity",
    "choice_c": "Fewer disks needed",
    "choice_d": "Double parity",
    "correct_answer": "C",
    "explanation": "Redundant Array of Independent Disks-5 (RAID-5) and Redundant Array of Independent Disks-6 (RAID-6) both use striping with parity, but RAID-6 has two parity bits per bit of information, so it can lose two drives and still rebuild all its data. A RAID-5 array can only lose one drive and still rebuild its data. This extra security requires a minimum of one more drive than RAID-5.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      33,
      34,
      36,
      44
    ],
    "source": "9781394330348"
  },
  {
    "id": 1012,
    "question": "You need a PC solution that can accept video footage from a gaming console or video camera and save it to a file. You also want to ensure that it won\u2019t skip, lag, or freeze. Which of the following would be the best solution?",
    "choice_a": "Webcam",
    "choice_b": "FireWire card",
    "choice_c": "Capture card",
    "choice_d": "Screen-capture software",
    "correct_answer": "C",
    "explanation": "A webcam would be very inefficient and a difficult solution at best, and FireWire would not be fast enough for today\u2019s systems. While screen-capture software might work, the best solution is to install a capture card either as a discrete (external) unit or in a Peripheral Component Interconnect Express (PCIe) slot on a motherboard. The capture card can take some of the workload off the processor, making the video less likely to skip, lag, or freeze.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      32,
      2,
      30,
      56,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 1013,
    "question": "A business has a PC that a user needs to work with in a room that is not air-conditioned. The PC keeps shutting down because the processor is overheating. You\u2019ve checked the cooler and thermal paste, and it\u2019s fine. What can you do to this PC to help it run cool enough?",
    "choice_a": "Add case fans.",
    "choice_b": "Add heat-monitoring software.",
    "choice_c": "Remove the chassis cover.",
    "choice_d": "Set it inside a refrigerator.",
    "correct_answer": "A",
    "explanation": "Adding case fans can draw excess heat out of a case and bring cooler air into the case. Most processors won\u2019t shut down until they reach 70 to 100\u00b0 Celsius (158\u2013212\u00b0 Fahrenheit), so if a person is working in that room, the ambient temperature won\u2019t be that high (although the processor gets very hot). Heat-monitoring software lets you see what\u2019s going on but won\u2019t help cool the case. Removing the chassis cover subjects the computer to debris and dust that can cause other problems, and a refrigerator is likely to cause condensation, which can short out electrical systems. Adding case fans is the best choice given. Using a liquid CPU-cooling system or adding a bigger heat sink to the processor might also help.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      21,
      22,
      24,
      5,
      47
    ],
    "source": "9781394330348"
  },
  {
    "id": 1014,
    "question": "You are replacing the power supply in a computer system that uses a 24-pin P1 connector. You have a few power supplies in the closet from which to choose. Which of the following connections will work? (Choose two.)",
    "choice_a": "20-pin P1 connector and P4 connector",
    "choice_b": "20-pin+4-pin P1 connector",
    "choice_c": "An ATX12V PSU",
    "choice_d": "An ATX12VO power supply",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Some power supplies will have a 20-pin+4-pin connector designed to connect to a 24-pin P1 motherboard connector. An ATX12V Power Supply Unit (PSU) is the perfect solution. A 20-pin P1 connector plus a P4 connector is the right number of pins, but the P4 connector is not compatible with the main motherboard power. ATX12VO is a 12-volt only connector that has only ten pins and would not be compatible with this motherboard, unless it had other connections.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      43,
      45,
      42,
      41,
      47
    ],
    "source": "9781394330348"
  },
  {
    "id": 1015,
    "question": "You\u2019re considering a power supply with interchangeable output cables that plug into and out of the power supply so that you can have exactly the connectors you need and not have extra cables taking up space in the case. What type of power supply is this?",
    "choice_a": "ATX",
    "choice_b": "ATX12V",
    "choice_c": "Molex",
    "choice_d": "Modular",
    "correct_answer": "D",
    "explanation": "A modular power supply enables you to use only the connectors you need by plugging and unplugging compatible cables into the Power Supply Unit (PSU).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      45,
      43,
      44,
      23,
      21
    ],
    "source": "9781394330348"
  },
  {
    "id": 1016,
    "question": "You\u2019re setting up a server that can\u2019t possibly have downtime. Which of the following items do you need to ensure that you have connected to it?",
    "choice_a": "HBA",
    "choice_b": "Redundant power supply",
    "choice_c": "Display",
    "choice_d": "Dual-rail power supply",
    "correct_answer": "B",
    "explanation": "If you have a system that can\u2019t have any downtime, you need to have redundant everything. You will only need a Host Bus Adapter (HBA) if you\u2019re connecting external devices. A display doesn\u2019t have anything to do with keeping the system running. A dual rail power supply can still fail. For this situation, you would want redundant power supplies that are hot-swappable, and a uninterruptable power supply (UPS) rated high enough for your server to keep running.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      46,
      43,
      44,
      41,
      47
    ],
    "source": "9781394330348"
  },
  {
    "id": 1017,
    "question": "Your new tech is unboxing a new printer, and you see them open the top, flip the box upside-down, and then pull the box off the printer. What will you say? (Choose two.)",
    "choice_a": "Great job; that\u2019s exactly how I would do it.",
    "choice_b": "That\u2019s not the right way to unbox a printer.",
    "choice_c": "It\u2019s better to lay the box on its side and pull the materials out.",
    "choice_d": "Please use a box cutter next time to cut the corners from top to bottom.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Whenever you get new equipment for the first time, the best choice is to check for manufacturer\u2019s directions. Lacking those, flipping a printer over and pulling the box off the printer may cause damage before you\u2019ve even set it up! The best course of action is to slide the contents gently out of the box. Using box cutters could damage the printer or its cables.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      89,
      96,
      74,
      76,
      90
    ],
    "source": "9781394330348"
  },
  {
    "id": 1018,
    "question": "You just purchased a network-enabled MFD. Which one of the following connection types is likely not built into it?",
    "choice_a": "Bluetooth",
    "choice_b": "Wi-Fi",
    "choice_c": "Ethernet",
    "choice_d": "RFID",
    "correct_answer": "D",
    "explanation": "Most modern network-enabled Multifunction Devices (MFDs) will have Bluetooth, Wi-Fi, and Ethernet connections. They are not likely to have Radio Frequency Identification (RFID) as a connection type, although they may have an RFID reader for secure print job authentication.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      90,
      29,
      94,
      93,
      61
    ],
    "source": "9781394330348"
  },
  {
    "id": 1019,
    "question": "You have a client who wants to use carbonless, multipart forms with their new printer. What type of printer will you recommend for them?",
    "choice_a": "Laser",
    "choice_b": "Inkjet",
    "choice_c": "Impact",
    "choice_d": "Thermal",
    "correct_answer": "C",
    "explanation": "The only type of printer that prints on all copies of multipart forms is an impact printer, usually dot-matrix. It\u2019s the only type of printer listed that makes a mark by physically striking the paper. These multipart forms are sometimes called No Carbon Required (NCR) or carbonless multipart forms. The back of each page, except the last one, will have a coating of microencapsulated ink or dye that produces an image when it is pressed or written on.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      73,
      74,
      80,
      81,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 1020,
    "question": "Your company\u2019s administrative assistant needs to be able to choose between printing on letterhead or plain paper for each print job. You\u2019re training them how to do it. What settings will you be showing them?",
    "choice_a": "Orientation",
    "choice_b": "Duplexing",
    "choice_c": "Quality",
    "choice_d": "Tray settings",
    "correct_answer": "D",
    "explanation": "If you have a printer with multiple trays, normally when you print there will be a setting that enables you to choose a tray from which to print. Letterhead can be in one tray andplain paper in another. Orientation refers to whether the paper printed in a taller or wider direction. Duplexing refers to printing on both sides, and quality settings enable the user choose either faster or better printing.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      92,
      90,
      74,
      75,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 1021,
    "question": "Which types of printers require calibration as a part of maintenance? (Choose two.)",
    "choice_a": "Laser",
    "choice_b": "Thermal",
    "choice_c": "Impact",
    "choice_d": "Inkjet",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Both laser and inkjet printers occasionally need to be calibrated. Exactly when depends on the printer. For inkjet printers, it\u2019s often after installing a new ink cartridge, and for laser printers, it\u2019s when you need to adjust the colors.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      76,
      74,
      79,
      80,
      91
    ],
    "source": "9781394330348"
  },
  {
    "id": 1022,
    "question": "What printer feature will store documents on the printer and not print them until the user enters a password or scans an ID card on the print device?",
    "choice_a": "Secured prints",
    "choice_b": "Snap prints",
    "choice_c": "User authentication",
    "choice_d": "Auditing",
    "correct_answer": "A",
    "explanation": "Secure print jobs are retrieved at the device, based on user authentication, by using a password, a security badge, or biometrics, depending on the printer. Auditing won\u2019t prevent attacks, but it will show you when the printer is being accessed and by whom, much like the Windows Event Viewer. Other security features might include removable hard drives with the printer, overwriting documents following Department of Defense (DoD) requirements, and data encryption.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      94,
      92,
      96,
      91,
      90
    ],
    "source": "9781394330348"
  },
  {
    "id": 1023,
    "question": "What type of connectivity device is used to terminate network runs in a telecommunications closet?",
    "choice_a": "Punchdown block",
    "choice_b": "Switch",
    "choice_c": "Router",
    "choice_d": "Terminator",
    "correct_answer": "A",
    "explanation": "A punchdown block can be found in a telecommunications closet mounted on a networking rack. Its main purpose is network connectivity, but it also provides a neat way to keep cables organized. Network drops from work areas are terminated (punched down) in the back, and cables with Registered Jack-45 (RJ-45) connectors connect the front to a switch or router. Switches and routers are network connectivity devices. A terminator is another name for a terminating resistor, which is sometimes needed at the end of a length of coaxial cable to avoid a signal echo.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      29,
      63,
      7,
      62,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 1024,
    "question": "Which of the following is appropriate for cleaning the thermal paper feed assembly on a thermal printer?",
    "choice_a": "Compressed air can",
    "choice_b": "Clean, lint-free cloth",
    "choice_c": "Water",
    "choice_d": "Vacuum cleaner",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Occasionally, the paper feed assembly on a thermal printer will become clogged with dust or debris. To clean it, use either pressurized air or a clean, lint-free cloth. Using water or a vacuum cleaner isn\u2019t recommended. Use isopropyl alcohol if moisture is needed, and only use a vacuum cleaner that is specifically for electronics, because other vacuum cleaners can build up static that will damage sensitive electronic components.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      96,
      81,
      97,
      89,
      75
    ],
    "source": "9781394330348"
  },
  {
    "id": 1025,
    "question": "What are three communication interfaces that are used by SSDs to send data across a motherboard? (Choose three.)",
    "choice_a": "NVMe",
    "choice_b": "SATA",
    "choice_c": "PCIe",
    "choice_d": "IDE",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Nonvolatile Memory Express (NVMe), Serial Advanced Technology Attachment (SATA), and Peripheral Component Interconnect Express (PCIe) are all communication methods used by Solid-State Drives (SSDs) to connect to the motherboard for transferring data between the drive and Central Processing Unit (CPU). Integrated Drive Electronics (IDE) is a legacy connection technology that was used with the original Advanced Technology Attachment (ATA) drives and Parallel Advanced Technology Attachment (PATA) drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      35,
      34,
      4,
      36,
      2
    ],
    "source": "9781394330348"
  },
  {
    "id": 1026,
    "question": "What is the (approximate) maximum theoretical bandwidth of a PCIe x16 slot, version 5.0?",
    "choice_a": "500 MBps",
    "choice_b": "1000 MBps",
    "choice_c": "64 GBps",
    "choice_d": "128 GBps",
    "correct_answer": "C",
    "explanation": "There are six major versions of Peripheral Component Interconnect Express (PCIe) currently specified: 1.x, 2.x, 3.0, 4.0, 5.0 and 6.x. For the six versions, a single bidirectional lane operates at a data rate of 250 Megabytes per second (MBps), 500 MBps, approximately 1 Gigabyte per second (GBps), roughly 2 GBps, nearly 4 GBps, and 8 GBps, respectively. Each PCIe slot can have up to 16 lanes, with the number of lanes being indicated by x1, x4, x8, x16. (The \u201cx\u201d is pronounced asby.) Therefore, a PCIe 5.0 x16 slot can support up to 64 GBps of bandwidth (16 \u00d7 4 = 64), and a PCIe 6.0 \u00d7 16 boasts a whopping 128 GBps.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      2,
      27,
      36,
      30,
      35
    ],
    "source": "9781394330348"
  },
  {
    "id": 1027,
    "question": "What are important considerations when replacing thermal printer paper? (Choose two.)",
    "choice_a": "Be sure to align the feed holes correctly.",
    "choice_b": "Make sure you have the right cleaning card.",
    "choice_c": "Use only the paper specified by the printer.",
    "choice_d": "Ensure that the paper is oriented correctly.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Changing the paper on a thermal printer is simple. Lift the cover, remove the existing roll, and replace it with a new roll. Press the paper feed button. However, thermal printers are very specific in the special thermal paper that they use, so be sure you have the correctpaper. There is a right side and wrong side to the paper, so you need to ensure the paper has the correct side facing the printhead, which uses heat from a heating element to make the image.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81,
      96,
      89,
      91,
      78
    ],
    "source": "9781394330348"
  },
  {
    "id": 1028,
    "question": "Which of the following is not a valid way to clean a thermal printer\u2019s printhead and heating element?",
    "choice_a": "Cleaning card.",
    "choice_b": "Cleaning paper.",
    "choice_c": "Wet a cloth with water.",
    "choice_d": "Cleaning pen.",
    "correct_answer": "C",
    "explanation": "Water and electronics simply don\u2019t mix. Cleaning cards and papers will clean both the heating element (thermal printhead) and the paper path. A cleaning pen will contain isopropyl alcohol and can clean the printhead, or you can use an isopropyl alcohol lint-free wipe.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      96,
      81,
      97,
      75,
      22
    ],
    "source": "9781394330348"
  },
  {
    "id": 1029,
    "question": "Which of the following type of printers requires replacing an inked ribbon when the printout becomes unreadable?",
    "choice_a": "Laser",
    "choice_b": "Thermal",
    "choice_c": "Impact",
    "choice_d": "Inkjet",
    "correct_answer": "C",
    "explanation": "Laser printers need toner cartridges, impact printers need ink ribbons, and inkjet printers use ink cartridges. Thermal printers heat up paper to produce images.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      73,
      77,
      96,
      74,
      81
    ],
    "source": "9781394330348"
  },
  {
    "id": 1030,
    "question": "You need to clean a laser printer of debris in the print path. Which of the following are appropriate to use? (Choose two.)",
    "choice_a": "Canned compressed air.",
    "choice_b": "Cleaning paper.",
    "choice_c": "Wet a cloth with water.",
    "choice_d": "Vacuum cleaner.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Canned compressed air can be used to gently blow debris out of a laser printer. Some printers may also use a special sticky paper to pull out debris. Water and electronics don\u2019t mix. Vacuum cleaners build up static that can damage electronics, so unless they are specifically designed for a computer, vacuum cleaners should not be used.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      77,
      78,
      79,
      80,
      74
    ],
    "source": "9781394330348"
  },
  {
    "id": 1031,
    "question": "What may need cleaning on an inkjet printer? (Choose two.)",
    "choice_a": "Toner cartridges",
    "choice_b": "Paper feeder rollers",
    "choice_c": "Printheads",
    "choice_d": "Thermal unit",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Inkjet printers sometimes need the paper feeder rollers cleaned with mild soap and water. They also occasionally need the printheads cleaned. Each printer will have a software option to clean them, or you can use a swab with isopropyl alcohol on it if the software routine doesn\u2019t solve the problem. Toner cartridges are found in laser printers, and thermal units are found in thermal printers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      74,
      75,
      96,
      97,
      76
    ],
    "source": "9781394330348"
  },
  {
    "id": 1032,
    "question": "You\u2019re receiving a message that your printer\u2019s ink cartridge is low. What type of printer are you using?",
    "choice_a": "Laser",
    "choice_b": "Thermal",
    "choice_c": "Impact",
    "choice_d": "Inkjet",
    "correct_answer": "D",
    "explanation": "Inkjet printers use ink cartridges that need replacing when the ink level is low or empty. Laser printers need toner cartridges, impact printers need ink ribbons, and thermal printers use heat to produce images on special thermal paper.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      74,
      77,
      73,
      81,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 1033,
    "question": "While replacing a toner cartridge in a laser printer, a technician spilled toner on and around the printer. What should be used to clean up the spill?",
    "choice_a": "A damp cloth",
    "choice_b": "Compressed air",
    "choice_c": "A toner vacuum",
    "choice_d": "Denatured alcohol",
    "correct_answer": "C",
    "explanation": "If you have a toner spill, don\u2019t use compressed air to blow it away. You should use a specialized toner vacuum to pick it up. Also, never use a damp cloth to try to clean up a toner spill. If a cloth is needed, use a dry one.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      96,
      77,
      78,
      79,
      92
    ],
    "source": "9781394330348"
  },
  {
    "id": 1034,
    "question": "What type of cloud service offers the best security?",
    "choice_a": "Community",
    "choice_b": "Private",
    "choice_c": "Public",
    "choice_d": "Hybrid",
    "correct_answer": "B",
    "explanation": "Companies can purchase virtualization software to set up individual clouds within their own network. That type of setup is referred to as a private cloud. Running a private cloud pretty much eliminates many of the features that companies want from the cloud, such as rapid scalability and not needing to purchase and manage computer assets. The big advantage, though, is that it enables the company to control its own security within the cloud. A hybrid model would be the scenario providing benefits of both public and private clouds. The community model is something akin to a shared private cloud, with responsibilities and benefits shared collaboratively.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      181,
      180,
      179,
      182,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1035,
    "question": "Your manager tells you to purchase cloud-based services. Your network needs extra processing power and file storage. What type of service should you purchase?",
    "choice_a": "PaaS",
    "choice_b": "IaaS",
    "choice_c": "SaaS",
    "choice_d": "FWaaS",
    "correct_answer": "B",
    "explanation": "Let\u2019s say that your company needs extra network capacity, including processing power, storage, and networking services (such as firewalls), but doesn\u2019t have the money to buy morenetwork hardware. Instead, you can purchase Infrastructure as a Service (IaaS), which is a lot like paying for utilities\u2014you pay for what you use. Of the four, IaaS requires the most network management expertise from the client side. In an IaaS setup, the client provides and manages the software. PaaS is Platform as a Service, and SaaS is Software as a Service. FWaaS is sometimes used and means Firewall as a Service but is not widely recognized or on the CompTIA 220\u20131201 objectives.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      182,
      180,
      183,
      185,
      187
    ],
    "source": "9781394330348"
  },
  {
    "id": 1036,
    "question": "Your company has decided to purchase cloud services from Google. It will be getting infrastructure with on-demand computing services, including processing power, storage, and bandwidth over the Internet. Anyone can purchase these same services from Google, and a third party is responsible for maintaining and managing the hardware. What type of cloud is Google providing for your company?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Hybrid",
    "choice_d": "Community",
    "correct_answer": "A",
    "explanation": "The traditional type of cloud that usually comes to mind is a public cloud, like the ones operated by third-party companies, such as Microsoft, Google, HP, Apple, Netflix, and Amazon, with its Amazon Web Services (AWS). These clouds offer the best in scalability, reliability, flexibility, geographical independence, and cost effectiveness. Whatever the client wants, the client gets. For example, if the client needs more resources, it simply scales up and uses more.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      181,
      182,
      180,
      183,
      185
    ],
    "source": "9781394330348"
  },
  {
    "id": 1037,
    "question": "Your company produces software and employs about 20 developers. They need to program apps for different OSs. You decide to purchase cloud-based services to support the development team. What type of service should you purchase so they can develop their programs and then test them in environments other than where they were developed?",
    "choice_a": "IaaS",
    "choice_b": "SaaS",
    "choice_c": "PaaS",
    "choice_d": "NaaS",
    "correct_answer": "C",
    "explanation": "Platform as a Service (PaaS) adds a layer to Infrastructure as a Service (IaaS) that includes software development tools such as runtime environments. Because of this, it can be helpful to software developers; the vendor manages the various hardware platforms. This frees up the software developers to focus on building their application and scaling it. The best PaaS solutions enable the client to export its developed programs and run them in an environment other than where they were developed. SaaS is Software as a Service. NaaS is Networking as a Service but is not included in the CompTIA A+ exam.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      182,
      180,
      175,
      178,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1038,
    "question": "Which type of cloud service provides your company with application hosting, such as productivity applications, calendaring software, and development tools, which the employees can access over the Internet from wherever they are?",
    "choice_a": "PaaS",
    "choice_b": "FWaaS",
    "choice_c": "IaaS",
    "choice_d": "SaaS",
    "correct_answer": "D",
    "explanation": "The highest of the three levels of cloud service is Software as a Service (SaaS), which handles the task of managing software and its deployment. This is the model used by Google Docs, Microsoft Office 365, and even storage solutions such as Dropbox. Platform as a Service (PaaS) provides software development tools in addition to Infrastructure as a Service (IaaS), which provides hardware and connectivity. Firewall as a Service (FWaaS) is not widely used, nor is it on the CompTIA A+ Exam.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      182,
      186,
      180,
      183,
      185
    ],
    "source": "9781394330348"
  },
  {
    "id": 1039,
    "question": "Which feature of cloud service enables you to instantly obtain additional storage space or processing power as your company needs it?",
    "choice_a": "Ubiquitous access",
    "choice_b": "Elasticity",
    "choice_c": "Resource pooling",
    "choice_d": "Metering",
    "correct_answer": "B",
    "explanation": "In most cases, clients can get more resources instantly (or at least quickly or on-demand), which is called elasticity. For the client, this is a great feature because they can scale up without needing to purchase, install, and configure new hardware. Ubiquitous access refers to clients being able to access the cloud ubiquitously, or from anywhere, anytime. Resource pooling, particularly when a cloud provider deals with multiple tenants, refers to the provider effectively saving money by not duplicating available capacity. Finally, when the service provided to those tenants is monitored and paid for according to their use, it\u2019s metered egress or metered ingress, depending on whether information is traveling out of or into the cloud service.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      183,
      180,
      182,
      185,
      187
    ],
    "source": "9781394330348"
  },
  {
    "id": 1040,
    "question": "You are installing virtualization on a workstation that needs to support multiple OSs. Which type of hypervisor is best suited for this environment?",
    "choice_a": "Type 1",
    "choice_b": "Type 2",
    "choice_c": "Either Type 1 or Type 2 will function in the same way",
    "choice_d": "Virtual machine manager",
    "correct_answer": "B",
    "explanation": "A Type 2 hypervisor sits on top of an existing Operating System (OS), called the host OS. This is most commonly used in desktop virtualization, where multiple OSs are managed on the client machine as opposed to on a server. The hypervisor is also called a Virtual Machine Manager (VMM).",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      176,
      174,
      178,
      175,
      179
    ],
    "source": "9781394330348"
  },
  {
    "id": 1041,
    "question": "You are configuring desktop virtualization on an existing Windows 11 64-bit workstation. You will be running an installation of Windows 10 in the virtual environment as a test system. The bare minimum RAM requirements are 2 GB for Windows 10 and 4 GB for Windows 11. Windows 10 needs 20 GB of disk space, and Windows 11 requires 64 GB of disk space. What are the absolute minimum hardware requirements for this workstation?",
    "choice_a": "4 GB RAM, 64 GB disk space",
    "choice_b": "4 GB RAM, 84 GB disk space",
    "choice_c": "6 GB RAM, 64 GB disk space",
    "choice_d": "6 GB RAM, 84 GB disk space",
    "correct_answer": "D",
    "explanation": "If presented with a scenario for installing multiple Operating Systems (OSs) on a computer running desktop virtualization, just add the minimum hardware requirements (or recommendations) for Random Access Memory (RAM) and storage for each OS together. Treat it as if each OS needs its own minimum (which it does), and they are just sharing theavailable physical hardware (which they are). Also, each OS needs its own Virtual Network Interface Card (vNIC) to participate on the network and needs its security to be individually configured based on OS requirements and user needs. Treat it as though it is a separate computer. In reality, you\u2019re never going to go with just the absolute minimum because, although the OS will run, it won\u2019t run well, and you\u2019ll want extra storage based on the software that each OS will be running.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      178,
      174,
      175,
      176,
      179
    ],
    "source": "9781394330348"
  },
  {
    "id": 1042,
    "question": "You are setting up virtualization on a server that will be running four instances of Windows Server 2019. Four different departments will be using one instance each, and all departments have been promised 32 GB RAM. Using resource pooling and using a bare-metal hypervisor, what is the minimum amount of physical RAM needed on the server?",
    "choice_a": "32 GB",
    "choice_b": "64 GB",
    "choice_c": "128 GB",
    "choice_d": "16 GB",
    "correct_answer": "C",
    "explanation": "If each client has been promised 32 GB Random Access Memory (RAM), then the server must have enough RAM to give each client their allotment. In this case, this means 128 GB. The assumption is that the hypervisor will require no RAM on its own. In reality, it probably will require a little, but not much. Resource pooling, when a cloud provider deals with multiple tenants, refers to the provider having additional capacity available but saving money by sharing that availability.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      178,
      176,
      183,
      174,
      180
    ],
    "source": "9781394330348"
  },
  {
    "id": 1043,
    "question": "Your company has an application developer who creates programs for Windows 10, Windows 11, and various distributions of Linux. What is the most cost-effective solution for them to be able to test their programs in multiple OSs as quickly as possible?",
    "choice_a": "Buy workstations for each of the OSs they will be writing code in.",
    "choice_b": "Set up their workstation to multi-boot.",
    "choice_c": "Set up their workstation with virtual machines.",
    "choice_d": "Create one version of each application that will run in all three OSs.",
    "correct_answer": "C",
    "explanation": "The major feature of virtualization is breaking down that one-to-one hardware and software barrier. The virtualized version of a computer is appropriately called a Virtual Machine (VM). Thanks to VMs, it is becoming far less common to need dual or multi-boot machines. VMs enable computers to do things like run five instances of an Operating System (OS) or one instance each of several different OSs.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      174,
      175,
      178,
      176,
      177
    ],
    "source": "9781394330348"
  },
  {
    "id": 1044,
    "question": "Your company wants to begin transferring services to the cloud, but the team\u2019s migration schedule will cover several months. Management wants to pay for cloud computing based on usage, not a fixed flat fee. What payment model would you recommend?",
    "choice_a": "On-demand",
    "choice_b": "Resource pool",
    "choice_c": "Metered utilization",
    "choice_d": "Shared resources",
    "correct_answer": "C",
    "explanation": "Metered utilization is synonymous with pay-as-you-use. The resources are available, but payment is calculated according to your actual usage. This is a common model for enterprise environments, especially during the early \u201cmigration of services\u201d period. On-demand means services can be added as needed, on-the-fly. A resource pool refers to the resources owned by a cloud provider, such as Random Access Memory (RAM) and storage capacity that are available to the cloud provider\u2019s clients. Shared resources refer to the idea that a cloud provider\u2019s physical resources may be shared among many different companies.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      183,
      182,
      180,
      181,
      184
    ],
    "source": "9781394330348"
  },
  {
    "id": 1045,
    "question": "A client complains about the occupied space, abundant power usage, and hardware costs of the multiple machines used in its small datacenter. Still, the client does not want to lose control over any of the machines. What might you recommend to the client to resolve all those issues?",
    "choice_a": "Establish clusters for high availability.",
    "choice_b": "Create virtual machines.",
    "choice_c": "Outsource to an IaaS provider.",
    "choice_d": "Shut down the nonessential machines.",
    "correct_answer": "B",
    "explanation": "The creation of Virtual Machines (VMs) would alleviate the issue of space, power, and most of the hardware costs associated with maintaining bare-metal systems. VMs can provide many of the same services at a fraction of the costs. Control and management of the machines would not change.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      174,
      176,
      178,
      179,
      180
    ],
    "source": "9781394330348"
  },
  {
    "id": 1046,
    "question": "Which term describes the physical and virtual servers, storage, and software that are used by multiple clients in a cloud computing environment?",
    "choice_a": "Measured resources",
    "choice_b": "Shared resources",
    "choice_c": "Private cloud",
    "choice_d": "Community cloud",
    "correct_answer": "B",
    "explanation": "Shared resources describe the cloud infrastructure shared among clients of a cloud provider. For example, a cloud provider may have one physical server that is shared by multiple companies. Shared resources are also those resources made available to multiple employees or users on a local network. Measured resources are synonymous with pay-as-you-go services, where the company only pays for the resources they are using. A private cloud negates many of the advantages of a public cloud such as elasticity, but control remains with the cloud\u2019s owner. A community cloud is shared by a small group of users with similar needs, who pool their resources for a more cost-effective solution.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      183,
      180,
      181,
      182,
      178
    ],
    "source": "9781394330348"
  },
  {
    "id": 1047,
    "question": "What are potential problems associated with the shared resource structure of public cloud computing? (Choose two.)",
    "choice_a": "Security and confidentiality",
    "choice_b": "Flexibility",
    "choice_c": "Poor application performance",
    "choice_d": "Increased hardware costs",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Many companies go to cloud computing and the inevitable shared resources for the advantages of lowering their hardware costs and for the flexibility of adding on-the-fly resources. There are, however, some concerns with cloud computing, such as who has access to the data, the potential for another cloud computing client to introduce malware, and potentially poor application performance if another application is monopolizing the shared resources. Not included in the answer choices is another potential problem\u2014Internet connection downtime.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      180,
      183,
      179,
      181,
      178
    ],
    "source": "9781394330348"
  },
  {
    "id": 1048,
    "question": "Network control and security management of cloud assets is the difference between what two types of shared resources?",
    "choice_a": "Internal vs. external",
    "choice_b": "Private vs. public",
    "choice_c": "Hybrid vs. community",
    "choice_d": "Synchronized vs. unsynchronized",
    "correct_answer": "B",
    "explanation": "Private cloud resources would be under local network control and local security management, perhaps provided to different units within the same organization, while network and security concerns on public-shared resources are controlled and secured by an external cloud provider. The exception would be a company establishing its own security in an Infrastructure as a Service (IaaS) configuration, but even then, some of the security requirements (such as physical security) would fall to the public provider.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      181,
      182,
      180,
      183,
      179
    ],
    "source": "9781394330348"
  },
  {
    "id": 1049,
    "question": "A company using cloud services wants to better prepare for surges of what it needs. What sort of capacity provisioning by its cloud provider should the company ask for?",
    "choice_a": "Rapid metering",
    "choice_b": "Infrastructure as a service",
    "choice_c": "Metered utilization",
    "choice_d": "Resource pooling",
    "correct_answer": "C",
    "explanation": "For a company needing additional cloud resources on demand, they should request metered utilization, in which a cloud service will bill much like a utility would, as resources are used. Infrastructure as a Service (IaaS) refers to hardware and networking in the cloud, while resource pooling is used in cloud computing and means that resources are pooled and delivered as needed to many clients. Rapid metering is not an Information Technology (IT) term.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      183,
      182,
      180,
      181,
      184
    ],
    "source": "9781394330348"
  },
  {
    "id": 1050,
    "question": "You\u2019re setting up a virtual machine for one of your customers who needs a legacy OS to run software for a paper-cutting machine in an envelope factory. Windows 10 64-bit is the host OS. The legacy client OS requires a minimum of 1 GB of RAM, and the software running on it requires a minimum of 2 GB of RAM. What is the absolute minimum RAM needed on the virtual machine?",
    "choice_a": "1 GB",
    "choice_b": "4 GB",
    "choice_c": "5 GB",
    "choice_d": "10 GB",
    "correct_answer": "C",
    "explanation": "This configuration would need 2 GB for Windows 10 (the host) plus 3 GB for the client Operating System (OS) and running software at a minimum. In reality, more Random Access Memory (RAM) would be better.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      178,
      175,
      174,
      176,
      179
    ],
    "source": "9781394330348"
  },
  {
    "id": 1051,
    "question": "The company\u2019s sales manager wants to ensure that the laptop files of its traveling sales engineers stay consistent with the files on the company cloud. What sort of applications could assist with that business need?",
    "choice_a": "File security monitoring",
    "choice_b": "File virtualization",
    "choice_c": "File emulator",
    "choice_d": "File synchronization",
    "correct_answer": "D",
    "explanation": "Synchronization applications work to keep all files consistent, updating from multiple locations as needed. Emulation is when one thing acts like (i.e., emulates) something else. File security is ubiquitous, needed everywhere, but it does not address the need to keep the files consistent whether the users are traveling or on-premises. Virtualization is using a single hardware set as if it were multiple machines to run multiple Operating System (OS) instances or multiple OSs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      180,
      182,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1052,
    "question": "What service enables a user to access a virtual OS, either in the cloud using a browser or client on their local devices, or from a local virtualization server?",
    "choice_a": "DOD",
    "choice_b": "BAD",
    "choice_c": "VDI",
    "choice_d": "DTI",
    "correct_answer": "C",
    "explanation": "Virtual Desktop Infrastructure (VDI) can be managed/hosted on either a local server (i.e., local cloud) or over the Internet by a third party. When in the cloud and managed by a third party, it is sometimes called Desktop as a Service (DaaS). The advantages of VDI are savings in hardware costs and configuration time. Data sensitivity and security may preclude using VDI in the cloud. Desktop on Demand (DOD) isn\u2019t part of the CompTIA A+ terms, Binary Application Desktop (BAD) isn\u2019t a real term, and Debt-to-Income ratio (DTI) is an accounting term.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      182,
      180,
      174,
      178,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1053,
    "question": "An employee travels between multiple offices, using a desktop system in each office. What technology would ensure that the employee\u2019s desktop icons, files, and applications remain uniform across systems in all the offices?",
    "choice_a": "On-demand desktop",
    "choice_b": "VDI in the cloud",
    "choice_c": "Desktop emulation",
    "choice_d": "Synchronized folders",
    "correct_answer": "B",
    "explanation": "A Virtual Desktop Infrastructure (VDI) moves the desktop icons, files, and folders to a server instead of the desktop originating from the local machine. When the desktop experience is hosted on a centralized server location, the icons, files, and folders are the same. With this user working from various offices, the best solution for them is VDI in the cloud.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      182,
      180,
      185,
      186,
      174
    ],
    "source": "9781394330348"
  },
  {
    "id": 1054,
    "question": "When running a hypervisor, what enables a guest machine to connect to a network?",
    "choice_a": "Cat 5 network cable",
    "choice_b": "Guest applications",
    "choice_c": "Virtual NIC",
    "choice_d": "Host OS",
    "correct_answer": "C",
    "explanation": "In a virtual environment, a virtual Network Interface Card (vNIC) connects the guest machine to its local virtual network and any external networks.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      178,
      176,
      174,
      179,
      177
    ],
    "source": "9781394330348"
  },
  {
    "id": 1055,
    "question": "How can an organization permit employees who need to run an application on one mobile device to instead run it from multiple devices?",
    "choice_a": "Application virtualization",
    "choice_b": "Wrapping",
    "choice_c": "Binary application desktop",
    "choice_d": "On-demand desktop",
    "correct_answer": "A",
    "explanation": "Application virtualization delivers software using a virtual structure, which enables an organization to make a needed application available across multiple devices, without having to install it on each of these devices. This might apply to any platform the organization needs, whether a desktop computer or a mobile device. Wrapping is a programming term meaning one section of code is encapsulated (wrapped) in another. The other two options are not real IT terms.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      175,
      177,
      174,
      186,
      185
    ],
    "source": "9781394330348"
  },
  {
    "id": 1056,
    "question": "In setting up and configuring desktop virtualization, what must you consider before purchasing computing and storage hardware?",
    "choice_a": "Resource requirements",
    "choice_b": "Management response",
    "choice_c": "Resale value",
    "choice_d": "Physical size",
    "correct_answer": "A",
    "explanation": "Before purchasing hardware of a host system to support a number of virtual systems, it is wise to consider the resource requirements of those virtual systems. The more virtual systems a single hardware system supports, the more resources are needed.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      178,
      174,
      176,
      179,
      175
    ],
    "source": "9781394330348"
  },
  {
    "id": 1057,
    "question": "What must be defined when wanting to maintain confidentiality, integrity, and availability of system resources and should be a part of the decision when considering a virtual machine or cloud solution?",
    "choice_a": "Scalability",
    "choice_b": "Emulation",
    "choice_c": "Elasticity",
    "choice_d": "Security",
    "correct_answer": "D",
    "explanation": "When wanting to maintain confidentiality, integrity, and availability, security requirements and regulations must first be defined. A company can then consider if an Internet cloud solution or virtualization would be appropriate.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      179,
      180,
      181,
      182,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1058,
    "question": "In setting up and configuring desktop virtualization, what is necessary to consider before configuring a VLAN?",
    "choice_a": "Network requirements",
    "choice_b": "Emulation demands",
    "choice_c": "Cloud service providers",
    "choice_d": "Storage capacity",
    "correct_answer": "A",
    "explanation": "Network requirements dictate the need for and configuration of Virtual Local Area Networks (VLANs). A VLAN is a network design feature that isolates network traffic by the switch port. Just like a physical machine, a Virtual Machine (VM) must be compatible with the network on which it is intended to run.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      178,
      179,
      174,
      176,
      175
    ],
    "source": "9781394330348"
  },
  {
    "id": 1059,
    "question": "Your IT team is developing an application that must be able to run in any environment, including Windows, Linux, and macOS. What is the best way to achieve this?",
    "choice_a": "Write three separate programs.",
    "choice_b": "Run it in a VM.",
    "choice_c": "Deploy it using a container.",
    "choice_d": "Run it on a cloud server.",
    "correct_answer": "C",
    "explanation": "Your best option is to deploy it using a container. Containers are complete software packages, often stored in an image, which include all the code and software dependencies, such as programming libraries and runtime environments, that are needed to run the application. They can make deploying a program for multiple Operating Systems (OSs) much simpler. However, a container made by someone with ill intent can be detrimental to your computer systems and network. Writing three separate programs would be time-consuming and make updating the program more difficult. Running in a Virtual Machine (VM) or on a cloud server won\u2019t help because you would still need a separate Mac computer to run macOS in a VM.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      177,
      175,
      174,
      179,
      186
    ],
    "source": "9781394330348"
  },
  {
    "id": 1060,
    "question": "Which of the following is not considered to be a major category of cloud computing?",
    "choice_a": "SaaS",
    "choice_b": "PaaS",
    "choice_c": "IaaS",
    "choice_d": "XaaS",
    "correct_answer": "D",
    "explanation": "While Software as a Service (SaaS), Platform as a Service (PaaS), and Infrastructure as a Service (IaaS) are widely considered to be the major categories of cloud computing, Anything as a Service (XaaS) is not.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      182,
      180,
      183,
      181,
      177
    ],
    "source": "9781394330348"
  },
  {
    "id": 1061,
    "question": "Which of the cloud computing models combines on-premises infrastructure and Internet-accessed resources?",
    "choice_a": "Private cloud",
    "choice_b": "Public cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Combined cloud",
    "correct_answer": "C",
    "explanation": "A private cloud pools a company\u2019s on-premises resources for use within the company; there is no Internet component. A public cloud is owned by a third-party provider that delivers resources, including storage, platforms, and software, via the Internet. A hybrid cloud combines the two other forms, where some resources are on-premises and others are available over the Internet. The on-premises resources may provide more control over data, while the Internet resources offer on-demand scalability. Different data types could be kept in different locations, depending on the company\u2019s needs.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      181,
      180,
      182,
      183,
      185
    ],
    "source": "9781394330348"
  },
  {
    "id": 1062,
    "question": "With today\u2019s more mobile workforce, what technology provides the benefits of centralized security, ease of configuring new desktops for remote workers, and scalability regardless of where a user is or works from? (Choose the best answer.)",
    "choice_a": "IaaS",
    "choice_b": "SaaS",
    "choice_c": "VDI in the cloud",
    "choice_d": "VDI on-premises",
    "correct_answer": "C",
    "explanation": "Virtual Desktop Infrastructure (VDI) in the cloud, which is sometimes called Desktop as a Service (DaaS), enables a network admin to easily and almost immediately configure desktops for new users, even if they are in a remote location halfway around the world. Infrastructure as a Service (IaaS) provides the physical computing, network, memory, and storage resources enabling the cloud provider\u2019s customers to set up virtual servers and networks in the cloud. IaaS can also provide server software and databases, although not all providers do. Think of IaaS as renting the entire network structure. The cloud provider is responsible for the resource provisioning and maintenance needed for the organization\u2019s infrastructure. Software as a Service (SaaS) provides applications but not necessarily desktops. VDI on-premises offers similar advantages, but the scalability is limited by local servers.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      182,
      180,
      183,
      181,
      187
    ],
    "source": "9781394330348"
  },
  {
    "id": 1063,
    "question": "A group of real estate agents has realized that they have similar computing resource needs. Collectively, they\u2019ve reached out to your IT services company and asked if there is a solution that will let them pool their resources, save money, and possibly share industry-specific software but still have their servers and information held securely and locally. What would you recommend?",
    "choice_a": "Community cloud",
    "choice_b": "Public cloud",
    "choice_c": "Private cloud",
    "choice_d": "VDI in the cloud",
    "correct_answer": "A",
    "explanation": "A community cloud is the solution for such situations, as it enables a limited group of people or companies to share cloud resources. The group can then benefit from economies ofscale, while keeping their resources separate from other organizations. They could even share in joint projects. Their servers could be located in a datacenter or stored locally by one of the members. The group will have more control than they would over a public cloud and would share the maintenance costs of their cloud. A community cloud is similar to a private cloud but consists of multiple members.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      181,
      180,
      183,
      182,
      185
    ],
    "source": "9781394330348"
  },
  {
    "id": 1064,
    "question": "Which of the following options is a benefit of cloud computing that means the information is available constantly, regardless of location?",
    "choice_a": "Shared resources",
    "choice_b": "High availability",
    "choice_c": "Rapid elasticity",
    "choice_d": "File synchronization",
    "correct_answer": "B",
    "explanation": "While all of the items listed are advantages of using cloud-computing, high availability means that data and applications are available around the clock, regardless of the users\u2019 location. Shared resources often lead to lower costs and rapid elasticity. File synchronization means that users\u2019 files are updated with the newest changes whether they\u2019re working at home or in the office.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      184,
      183,
      180,
      185,
      186
    ],
    "source": "9781394330348"
  },
  {
    "id": 1065,
    "question": "A graphic artist at your company needs to manipulate files in both Linux and Windows environments. You, as the IT support person, want as few physical machines to support as possible. What technology enables both OSs to run on a single machine?",
    "choice_a": "File sharing.",
    "choice_b": "Cross-platform virtualization.",
    "choice_c": "Dual-boot system.",
    "choice_d": "It can\u2019t be done.",
    "correct_answer": "B",
    "explanation": "Configuring a Virtual Machine (VM) using Virtual Machine Manager (VMM) software whose features include cross-platform virtualization will enable you to configure multiple desktop platforms on one physical machine regardless of the host Operating System (OS). Sharing files isn\u2019t really the question being addressed; using different OSs is.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      174,
      175,
      176,
      178,
      179
    ],
    "source": "9781394330348"
  },
  {
    "id": 1066,
    "question": "You\u2019ve received a file from a salesperson who recently separated from your company. You want to open this file and see what it contains without subjecting your computer to possible malicious content. What Windows feature can you turn on that will create a protected environment for opening this file?",
    "choice_a": "Shared Files",
    "choice_b": "System Information",
    "choice_c": "Sandbox",
    "choice_d": "File Manager",
    "correct_answer": "C",
    "explanation": "In general terms, a sandbox is an isolated test environment separate from your network where you can \u201cplay\u201d with applications and settings, without worrying about negative effects on your network or computers. Sandbox is also a feature that can be enabled in Windows 10 Pro and higher editions. When launched, it opens a separate instance of Windows running as a Virtual Machine (VM) on your Windows desktop. A file can be opened in that VM to help protect your computer against malicious code. When the sandbox is closed, anything running in it is discarded. Shared files is exactly what it sounds like\u2014when files are shared between people. System Information is a utility with lots of information on the computer\u2019s hardware and operating system. The File Manager is a useful utility that, if you\u2019re not familiar with it, you need to spend some time on.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      175,
      174,
      179,
      178,
      176
    ],
    "source": "9781394330348"
  },
  {
    "id": 1067,
    "question": "Your friend is a software developer. They have Windows 11 Pro installed on their SOHO computer. They are creating an application that needs to run smoothly on both Windows and Linux machines, so it will need to be tested in both environments. What is the best solution for your friend?",
    "choice_a": "Windows 11 Sandbox",
    "choice_b": "Dual-boot system",
    "choice_c": "Two separate machines",
    "choice_d": "Virtual machines on their PC",
    "correct_answer": "D",
    "explanation": "Your friend will need to run both Operating Systems (OSs) to test the software. A Windows 11 sandbox will protect their host OS from any problems the application might cause, but it won\u2019t let them test the application on a Linux OS. Dual boot systems are clunky at best and require rebooting between OSs. Running two computers would cost more in terms of utilities and hardware, not to mention precious office space. The best solution for your friend is to install Virtual Machines (VMs) on their office PC. This would enable them to test in either Linux or Windows, without shutting the PC down in between, saving time while making corrections. It would also protect their machine against unintentionally bad code that could otherwise cause damage.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      174,
      175,
      178,
      176,
      179
    ],
    "source": "9781394330348"
  },
  {
    "id": 1068,
    "question": "A manufacturing client has a piece of equipment that is running on Windows 7 OS. The equipment-specific software won\u2019t run on any other OS, and the client is concerned about what they will do when the Windows 7 computer inevitably crashes. Cost is always a concern. What is a viable, cost-effective solution for your client?",
    "choice_a": "Have the programmers rewrite the code to run on Windows 10.",
    "choice_b": "Migrate the software to a Windows 7 VM.",
    "choice_c": "Wait until the hardware crashes, and then shut the equipment down permanently.",
    "choice_d": "Tell the client they need to upgrade their manufacturing equipment to something more modern as soon as possible.",
    "correct_answer": "B",
    "explanation": "Developing software for a specific manufacturing function is often costly and time-consuming, so a manufacturer might want to keep that equipment and software running as long as possible. If the equipment is doing the job they need it to do, they will be disinclined to upgrade to something new. Shutting the equipment down when it fails may spell disaster for the company. The best option here is to prepare a Virtual Machine (VM) to run the legacy Operating System (OS) and software, then test the software. Finally, during a planned shutdown, transfer the control of the manufacturing machine over to the new PC with the VM, and, of course, make sure you have an image to rapidly deploy if the new machine or VM fails in the future.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      175,
      174,
      178,
      179,
      176
    ],
    "source": "9781394330348"
  },
  {
    "id": 1069,
    "question": "Why would a company prefer to run multiple applications each on its own VM rather than on a single server?",
    "choice_a": "Security",
    "choice_b": "Scalability",
    "choice_c": "Less maintenance",
    "choice_d": "Less cost",
    "correct_answer": "A",
    "explanation": "The advantage of having applications each running in their own Virtual Machine (VM) is that if one application or VM\u2019s security is penetrated, the others may still be secure. Scalability would still be limited to the server\u2019s resources. The hardware maintenance would be the same, but the security maintenance might be more. However, being able to set up different access for each machine may simplify security configuration. The cost would be more, because a separate license would be needed for each Operating System (OS) running on its own VM.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      175,
      179,
      174,
      178,
      177
    ],
    "source": "9781394330348"
  },
  {
    "id": 1070,
    "question": "Which of the following would essentially be the same, whether running an OS on a virtual server or a physical server? (Choose two.)",
    "choice_a": "Security configuration",
    "choice_b": "Hardware",
    "choice_c": "Licensing",
    "choice_d": "Portability",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Regardless of whether a server is physical or virtual, it will need the same security configuration, and a license must exist for every virtual server just as it must for every physical server. While Random Access Memory (RAM) and storage requirements would be the same, one of the advantages of using a Virtual Machine (VM) is being able to put more than one server on a single piece of computer hardware, so overall hardware cost would be less and maintaining that hardware would be less expensive. Virtual servers are much more portable than physical servers, meaning they can easily be moved from one piece of hardware to another.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      179,
      174,
      178,
      180,
      187
    ],
    "source": "9781394330348"
  },
  {
    "id": 1071,
    "question": "Which cloud model offers the greatest control over data and security?",
    "choice_a": "Private cloud",
    "choice_b": "Public cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Community cloud",
    "correct_answer": "A",
    "explanation": "While each model has its advantages, if security is the greatest concern, then a private cloud is the best solution. Public, hybrid, and community clouds all involve other entities that may introduce additional potential security problems.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      181,
      180,
      183,
      179,
      182
    ],
    "source": "9781394330348"
  },
  {
    "id": 1072,
    "question": "You are a manager in a call center that employs 300 people who may be working any of three shifts on any given day, taking whichever of your 100 seats is available. Company regulations require that all information remain hosted locally. What technology can you use so that their files, folders, and desktop icons all appear the same regardless of what computer they log in to?",
    "choice_a": "On-demand desktop",
    "choice_b": "VDI in the cloud",
    "choice_c": "Desktop emulation",
    "choice_d": "VDI on-premises",
    "correct_answer": "D",
    "explanation": "A Virtual Desktop Infrastructure (VDI) moves the desktop icons, files, and folders to a server, instead of the desktop originating from the local machine. When the desktop experience is hosted on a centralized server location, the icons, files, and folders are the same, regardless of where a user logs in. VDI on-premises hosts the desktop on a local server, whereas VDI in the cloud hosts the desktop on a remote server.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      180,
      182,
      185,
      174,
      178
    ],
    "source": "9781394330348"
  },
  {
    "id": 1073,
    "question": "Which of these is not an advantage of cloud computing?",
    "choice_a": "Reduced capital expenditures",
    "choice_b": "Frees IT employees\u2019 time for other needs",
    "choice_c": "Complete control over data",
    "choice_d": "Rapid elasticity (i.e., dynamic growth)",
    "correct_answer": "C",
    "explanation": "Cloud computing has many advantages, including reduced capital expenditures, which can help growing companies. It relieves IT personnel of infrastructure management, so they can focus more on other objectives such as customer support. It also boasts rapid elasticity, which means a company can grow its IT infrastructure on a moment\u2019s notice as needed. Adding new employees can be easier with cloud computing. There are a few downsides, though. Some are that someone else has control of your data, fees can be surprising when usage is more than expected, and moving from one Infrastructure as a Service (IaaS) provider to another might be difficult. There are more advantages and disadvantages than can reasonably be listed here.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      180,
      182,
      183,
      184,
      185
    ],
    "source": "9781394330348"
  },
  {
    "id": 1074,
    "question": "You need to set up a hypervisor to run multiple OSs, but the computer you\u2019ll be installing it on has just enough resources for the VMs. What is your best, most expedient option? (Choose two.)",
    "choice_a": "Use a bare-metal hypervisor.",
    "choice_b": "Use a Type 1 hypervisor.",
    "choice_c": "Use a Type 2 hypervisor.",
    "choice_d": "Upgrade the computer hardware.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Bare-metal hypervisor is another name for a Type 1 hypervisor and are typically used in enterprise environments. A Type 1 hypervisor has Virtual Machine (VM) software installed directly on the computer, without needing an Operating System (OS) to run it. Type 2 hypervisors need an OS on which to install the VM software. Upgrading the computer hardware would be a great idea, but not if you\u2019re in a hurry to get it set up.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      176,
      178,
      174,
      179,
      177
    ],
    "source": "9781394330348"
  },
  {
    "id": 1075,
    "question": "Your client is a government contractor that has highly sensitive data. They need to be able to access it via the cloud, so that it can be accessed from anywhere in the world. Of course, security is a concern, so they don\u2019t want anyone else using space on, or having access to, the hardware that houses their information. Which of these will they request from the cloud provider?",
    "choice_a": "Metered egress",
    "choice_b": "Metered ingress",
    "choice_c": "Shared resources",
    "choice_d": "Dedicated resources",
    "correct_answer": "D",
    "explanation": "In a situation where security is essential and the customer doesn\u2019t want to share hardware/resources with anyone else, they could deploy a cloud solution with dedicated resources. Dedicated resources in the cloud have the benefits of both a private network (security and performance) and the cloud (always accessible).",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      181,
      182,
      183,
      180,
      185
    ],
    "source": "9781394330348"
  },
  {
    "id": 1076,
    "question": "Your company just received an unexpectedly high bill for services from the cloud provider. You explain to the accounting department that it\u2019s because you were running a special on a downloadable book, and there was a great deal of data downloaded from your site. What type of utilization are you being billed for?",
    "choice_a": "Metered egress",
    "choice_b": "Metered ingress",
    "choice_c": "Shared resources",
    "choice_d": "Dedicated resources",
    "correct_answer": "A",
    "explanation": "Metered egress means that you\u2019re being billed for the amount of data that is leaving your cloud server. Ingress refers to something being uploaded onto your server. Shared resourcesand dedicated resources describe whether the cloud hardware is being used by others or only your company.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      180,
      182,
      183,
      185,
      186
    ],
    "source": "9781394330348"
  },
  {
    "id": 1077,
    "question": "You\u2019re explaining to your company\u2019s board how cloud computing works and that, although other companies will be using the same hardware and infrastructure, your data will be separated. What is this concept called? (Choose two.)",
    "choice_a": "Multitenancy",
    "choice_b": "Sandbox",
    "choice_c": "Shared resources",
    "choice_d": "Dedicated resources",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Multitenancy in cloud computing is somewhat like an apartment building. There may be hundreds of people there, but their belongings are kept separate from everyone else\u2019s, and they all are able to enjoy the same building amenities. In the case of cloud computing, multitenancy (i.e., sharing resources) lets each company use what they need at the time and provides more efficient management of the hardware and updates, which helps to keep costs down while keeping their data separate. A sandbox is a test environment typically established by creating one or more virtual machines to mimic the actual environment. In a sandbox, technicians are able to make changes and ensure that they will work before making changes to a live computing environment. Dedicated resources means that you\u2019re not sharing those resources with any other entity.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      183,
      180,
      175,
      174,
      179
    ],
    "source": "9781394330348"
  },
  {
    "id": 1078,
    "question": "You\u2019re configuring a test environment using virtual machines to see how a software update will work with your systems before you deploy it in a live environment. Which of these are you using?",
    "choice_a": "Multitenancy",
    "choice_b": "Sandbox",
    "choice_c": "Shared resources",
    "choice_d": "Dedicated resources",
    "correct_answer": "B",
    "explanation": "A sandbox is a test environment that can be a feature of an Operating System (OS), but often Virtual Machines (VMs) are used to create sandboxes. Multitenancy, also known as sharing resources, lets each company use what they need from a cloud environment at any given time. Multitenancy is a key concept in cloud computing. Dedicated resources means that you\u2019re not sharing system resources like Random Access Memory (RAM), processing power, or storage space with any other entity.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      175,
      174,
      178,
      179,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1079,
    "question": "A Linux user calls the IT help desk in a panic because they have a BSOD on the screen. What would be a good first step to resolve the BSOD? (Choose two.)",
    "choice_a": "Try rebooting the system.",
    "choice_b": "Refresh the operating system.",
    "choice_c": "Reinstall the operating system.",
    "choice_d": "Scan the QR code with a smartphone.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A Blue Screen of Death (BSOD) is a warning screen indicating a stop error or kernel panic. Linux, Windows, and macOS each have their own (proprietary crash screen) version of BSOD. Regardless of the Operating System (OS), sometimes the solution is as simple as rebooting the system and the problem will resolve. If it doesn\u2019t, then the solution depends on any error messages received, and what you find in the troubleshooting process. The Linux BSOD may include a QR code for more information, the Linux penguin logo, and can be various colors depending on the distribution.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      188,
      190,
      189,
      199,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1080,
    "question": "A user approaches you and asks for a CPU upgrade so their Lenovo laptop will run faster. What is most likely the easiest way to meet this user\u2019s needs?",
    "choice_a": "Remove the CPU, and replace it with a faster one that fits the same socket.",
    "choice_b": "Replace the laptop with one that has a faster CPU.",
    "choice_c": "Replace the motherboard with a generic laptop motherboard with a faster processor.",
    "choice_d": "Replace the motherboard with a Lenovo laptop motherboard with a faster processor.",
    "correct_answer": "B",
    "explanation": "Laptop processors are usually permanently attached to the laptop\u2019s motherboard. Furthermore, motherboards are normally proprietary, meaning one from a certain model will not fit into a different case. Therefore, the best course of action is likely a laptop upgrade, although, if they have the ability to add more Random Access Memory (RAM), that might help with speed issues.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      200,
      199,
      233,
      189,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1081,
    "question": "You\u2019re at the doctor\u2019s office, and the nurse is using a tablet to enter data. You notice that they are hitting the screen repeatedly with their finger, obviously getting annoyed. You tell them that you work in IT and may be able to help. They tell you that when they touch one spot, it thinks they\u2019re touching somewhere else. In addition, it sometimes thinks they touched the screen when they didn\u2019t, causing the wrong data to be selected. What will you tell the nurse that might fix this problem quickly and at no cost? (Choose two.)",
    "choice_a": "Replace the digitizer.",
    "choice_b": "Clean the screen with a microfiber cloth.",
    "choice_c": "Calibrate the display.",
    "choice_d": "Reinstall the operating system.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Tablets and other computing devices that use touchscreens sometimes have problems with calibration. Symptoms include identifying the wrong spot when touched, \u201cghost\u201d touches, or no response to touches. Sometimes, cleaning the screen with a microfiber cloth will solve the problem, but if it doesn\u2019t, the next step is to look for a calibration option in the device\u2019s software. Replacing the digitizer is neither quick nor free, and reinstalling the operating system would be a bit drastic and may not resolve the problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      228,
      190,
      191,
      188,
      227
    ],
    "source": "9781394330348"
  },
  {
    "id": 1082,
    "question": "You have decided to start playing video-intensive games on your laptop computer. The video appears jumpy and slow to respond. What should you do first to try to increase the performance during game play?",
    "choice_a": "Upgrade the video card.",
    "choice_b": "Install additional video memory.",
    "choice_c": "Use the Windows Control Panel to increase the amount of video memory available.",
    "choice_d": "Use the system BIOS/UEFI to increase the amount of video memory available.",
    "correct_answer": "D",
    "explanation": "Many laptops use shared video memory, meaning that the system\u2019s Random Access Memory (RAM) is divided up for use between the processor and the video card. On these system types, the amount of RAM available for video is configured in the Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      195,
      200,
      233,
      199,
      226
    ],
    "source": "9781394330348"
  },
  {
    "id": 1083,
    "question": "A guest presenter plugs an external projector into their laptop using the HDMI port on the back of the laptop. They then use the Fn key and video toggle switch; the projector displays the presentation, but the laptop screen goes dark. What should they do if they want to see the presentation on both the projector and laptop?",
    "choice_a": "Install a second video driver, and then use the video toggle key to switch the video output to both screens.",
    "choice_b": "Unplug the projector, and then plug it back in to synchronize it with the laptop.",
    "choice_c": "Unplug the projector, use the video toggle key to switch the video output, and then plug the projector back in.",
    "choice_d": "Press the video toggle key again until the presentation is shown on both screens.",
    "correct_answer": "D",
    "explanation": "Because of the much smaller space available for keys, some laptop keys are consolidated into special multifunction keys. These keys are accessed through the standard keys by using a special function (Fn) key. Nearly every laptop has a video connector on the back or the side to plug in an external display or a projector. You will need to use the video toggle key to get this external port to work. Usually there are three or four states: laptop only, external output only, duplicate, or extend the desktop.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      218,
      227,
      202,
      219,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1084,
    "question": "A user has a laptop that is intermittently locking up. Initial diagnostics indicate that the processor is overheating. What can you do to try to remediate the issue? (Choose two.)",
    "choice_a": "Leave the case open while the system is running to allow for better airflow and cooling.",
    "choice_b": "Lower the CPU voltage in the system BIOS/UEFI.",
    "choice_c": "Lower the CPU clock speed in the system BIOS/UEFI.",
    "choice_d": "Run the laptop on AC power instead of battery power.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "To combat heat, you can either slow the processor down (i.e., run it at a lower speed) or give it less juice (i.e., run it at a lower voltage). Most of the time, this is configured in the system Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI). For example, many Intel processors use SpeedStep technology to slow the processor (i.e., clock speed) down to produce less heat, and they may also have adaptive thermal management. All computer cases are built with optimum air flow in mind, and in addition to not helping the situation, leaving the case open would subject the motherboard and components to dust and dirt that could potentially cause other problems. All computers run on Direct Current (DC) and will have either the transformer (which converts Alternating Current [AC] to DC) in a block on the power cord (as in the case of laptops) or in the power supply, as in most desktop computers.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      194,
      226,
      233,
      195,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1085,
    "question": "A client has a laptop with an integrated video card. The system seems to boot but produces no video, even with an external display hooked up. What can you do to fix this?",
    "choice_a": "Add an external USB video card, and connect the display to it.",
    "choice_b": "Remove the existing video card, and replace it with a new internal video card.",
    "choice_c": "Replace the motherboard.",
    "choice_d": "Leave the existing card in the system, and add an internal Mini-PCIe video card.",
    "correct_answer": "C",
    "explanation": "If the integrated video card fails, you\u2019re looking at a motherboard replacement. Some laptops do have a replaceable video card or may work with an external Graphics Processing Unit (GPU), but this is not common. If a replaceable video card fails or if you choose to upgrade it, the procedure will probably resemble replacing system memory.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      202,
      218,
      197,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1086,
    "question": "A user has brought their older laptop to you because the screen is unusually dim. Which display component is most likely causing this?",
    "choice_a": "Backlight",
    "choice_b": "LCD",
    "choice_c": "Screen",
    "choice_d": "Inverter",
    "correct_answer": "D",
    "explanation": "If you are having problems with flickering screens or dimness, it\u2019s more likely that the inverter is the problem and not the backlight itself. The inverter converts Direct Current (DC) to Alternating Current (AC) for the display. Modern displays use Light-Emitting Diodes (LEDs), which are DC components, to produce light, so they likely won\u2019t have an inverter.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      222,
      223,
      189,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1087,
    "question": "A purchasing agent ordered replacement printer paper that is a thicker caliper than recommended by the printer manufacturer. What is the biggest risk in using this paper?",
    "choice_a": "Images will not print.",
    "choice_b": "Paper will not feed.",
    "choice_c": "Paper will jam.",
    "choice_d": "Images print normally.",
    "correct_answer": "C",
    "explanation": "Thicker paper can cause paper jams, especially in printers with curved paper paths. Paper that is too thin may not get picked up by the printer rollers.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      236,
      234,
      241,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1088,
    "question": "You have an OLED display that you just plugged into a desktop computer. One of your coworkers changes the resolution from 1920\u00d71080 to 1920\u00d71200, but then the image looks highly distorted. What is the most likely cause of this?",
    "choice_a": "The video driver does not support 1920\u00d71200 resolution.",
    "choice_b": "The display has a native resolution of 1920\u00d71080.",
    "choice_c": "The video adapter has a native resolution of 1920\u00d71080.",
    "choice_d": "The monitor is plugged into the wrong display interface to support the new resolution.",
    "correct_answer": "B",
    "explanation": "Most digital displays have a native resolution, which is based on the number of physical pixels the device has. The resolution can be changed, but doing so may result in distorted images, poor image quality, or the image may not display at all.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      220,
      222,
      224,
      202,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1089,
    "question": "A user has an LCD display that flashes a black screen every few seconds. What is likely set incorrectly and causing the problem?",
    "choice_a": "Refresh rate",
    "choice_b": "Frame rate",
    "choice_c": "Native resolution",
    "choice_d": "Aspect ratio",
    "correct_answer": "A",
    "explanation": "The refresh rate defines the vertical scan frequency of a display and determines how many times, in one second, an image can be redrawn on the screen. Many Liquid Crystal Displays (LCDs) have a fixed refresh rate. If the refresh rate is set faster than the video card or software can run, then problems such as a black screen every few seconds may result. The solution is to lower the refresh rate or invest in new hardware. Frame rate is the number of frames that are displayed in a second, expressed as frames per second (FPS). Native resolution is the number of pixels across and down (like 1920\u00d71080) that a monitor is comprised of. Although the monitor will function at other resolutions, the native resolutionoften looks best. Aspect ratio expresses the relationship between pixel width and height. For example, the 1920\u00d71080 pixel monitor mentioned in the question has an aspect ratio of 16:9, that is, for each 16 pixels across, there are 9 pixels vertically.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      222,
      223,
      224,
      220,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1090,
    "question": "A friend who plays video games has asked you how they can fix tearing on their display. What will you tell them?",
    "choice_a": "They need a new display.",
    "choice_b": "The refresh rate is set too low.",
    "choice_c": "The screen\u2019s refresh rate is set too high.",
    "choice_d": "It\u2019s a software defect.",
    "correct_answer": "B",
    "explanation": "Tearing in a display looks as it sounds\u2014the image will have an area where parts of the image don\u2019t appear to line up, as if a picture were torn. Often when tearing happens, a video game sends frames to the display faster than the display can render them. Setting the refresh rate of the display higher, if it supports this, may solve the problem. If not, consider replacing the display and ensuring that the graphics card and monitor have compatible frame/refresh rates.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      222,
      220,
      223,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1091,
    "question": "What is the name of the boot routine that verifies the size and integrity of the system memory, among other tasks, and will produce error messages as beeps before the video is available?",
    "choice_a": "RAMCheck",
    "choice_b": "BIOS",
    "choice_c": "UEFI",
    "choice_d": "POST",
    "correct_answer": "D",
    "explanation": "The Power-On Self-Test (POST) is a series of system checks performed by the system Basic Input/Output System (BIOS) when the computer is turned on. Checking the system memory, video, and hard drive availability is part of the POST routine. If POST fails before the video is checked, the system may give errors in the form of beep codes. The BIOS holds information that includes instructions for the POST routine, UEFI is the newer version of BIOS, and RAMCheck is the name of a third-party utility, not part of the computer\u2019s boot routine.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      196,
      195,
      193,
      199,
      189
    ],
    "source": "9781394330348"
  },
  {
    "id": 1092,
    "question": "Which of the following are considered improper charging, which could result in damage to a battery, or possibly a fire starting? (Choose two.)",
    "choice_a": "Charging the battery over 100%",
    "choice_b": "Fully charging a battery",
    "choice_c": "Letting a battery charge drop to zero",
    "choice_d": "Using a charger that isn\u2019t approved for this device",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Sometimes, it\u2019s necessary to charge a battery to 100 percent or to discharge it completely. Overcharging a battery or using a charger that isn\u2019t approved for the device may have disastrous results, such as a damaged battery or one that overheats to the point of explosion. Lithium-Ion batteries are particularly prone to catching on fire, and they\u2019re used in most mobile devices.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      225,
      226,
      233,
      230,
      231
    ],
    "source": "9781394330348"
  },
  {
    "id": 1093,
    "question": "You moved a projector from an old conference room to a new one. The projector was working fine in the other room, but the image seems to be dim in the new room. Before you purchase a new projector, which of the following should you try?",
    "choice_a": "Increase the frame rate.",
    "choice_b": "Lower the native resolution.",
    "choice_c": "Adjust the aspect ratio.",
    "choice_d": "Turn the brightness up.",
    "correct_answer": "D",
    "explanation": "If the projector worked fine in a different room, then it\u2019s something about the new conference room. If the room is brighter, you\u2019ll need to turn up the brightness of the projector or turn off lights and close shades. If these don\u2019t solve the issue, then you might need a new projector. Lumens is the measure of brightness for a projector. For a well-lit business setting, you probably want a projector rated at 5,000\u20136,000 lumens. You can\u2019t use the projector to change the frame rate, native resolution, or aspect ratio.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      223,
      190,
      188,
      191,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1094,
    "question": "Your friend has just finished building a computer. After installing the operating system, all seems fine except that they found that flash drives placed in the USB ports on the top of the case do not get noticed by the OS. What do you suspect the problem is?",
    "choice_a": "Outdated device drivers",
    "choice_b": "Misconfigured USB settings",
    "choice_c": "Disconnected motherboard internal USB connector",
    "choice_d": "System clock",
    "correct_answer": "C",
    "explanation": "Likely the friend forgot to connect the internal Universal Serial Bus (USB) connector on the motherboard to the case\u2019s USB ports.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      197,
      190,
      188,
      205,
      204
    ],
    "source": "9781394330348"
  },
  {
    "id": 1095,
    "question": "You are troubleshooting a Mac running macOS. Intermittently, the computer will completely lock up and display a rotating pinwheel instead of the mouse cursor. It happens when different applications are running. What is most likely causing this problem?",
    "choice_a": "CPU",
    "choice_b": "RAM",
    "choice_c": "Motherboard",
    "choice_d": "Faulty application",
    "correct_answer": "B",
    "explanation": "The spinning pinwheel, also known as the \u201cSpinning Wheel of Death,\u201d can happen for several reasons. Sometimes, it\u2019s a frozen app, but in this case it\u2019s happening when different apps are running, so hardware would be suspect. Of the hardware listed, the Random Access Memory (RAM), is the most likely problem. A faulty hard drive could also cause the problem.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      199,
      200,
      194,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1096,
    "question": "You\u2019re at a friend\u2019s house when you notice a burning smell from their computer. What is the first thing you should do?",
    "choice_a": "Grab a fire extinguisher.",
    "choice_b": "Unplug the computer.",
    "choice_c": "Call the fire department.",
    "choice_d": "Tell your friend to get a new computer.",
    "correct_answer": "B",
    "explanation": "It\u2019s rare that a computer will catch on fire, but sometimes frayed wires and excessive dust can result in short circuits, which can cause overheating. Burning electronics have an unmistakable odor. If you ever smell electronics burning, even if you don\u2019t see smoke or flame, immediately unplug the device.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      194,
      190,
      193,
      196,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1097,
    "question": "You are troubleshooting a desktop computer that is prone to unexpected shutdowns. They seem to happen randomly, sometimes shortly after the computer starts and other times after several minutes. The user reports that no error messages appear before the computer shuts down. Which two of the following things are most likely to cause this type of problem? (Choose two.)",
    "choice_a": "Failing hard drive",
    "choice_b": "Bad RAM",
    "choice_c": "BIOS/UEFI misconfiguration",
    "choice_d": "Improperly seated chips",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Unexpected shutdowns are difficult to troubleshoot, as are all intermittent issues. The first thing to check is to ensure that all socketed chips are seated properly; in fact, reseating them is a good option. If that does not resolve the issue, test the Random Access Memory (RAM) or replace it if possible.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      199,
      194,
      190,
      196,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1098,
    "question": "You\u2019re troubleshooting a computer that the user says shuts down after 10 minutes of use every time they start the computer. If they wait a few minutes and restart it, the same thing happens. What is most likely the problem?",
    "choice_a": "RAM",
    "choice_b": "Hard drive",
    "choice_c": "Processor",
    "choice_d": "Motherboard",
    "correct_answer": "C",
    "explanation": "Most likely, the processor is overheating. Check that the thermal paste/pad between the processor and heat sink have not dried out. If they are fine, then consider adding better or additional fans in the case. This is also a good time to clean any dust out of the case.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      198,
      194,
      188,
      190,
      189
    ],
    "source": "9781394330348"
  },
  {
    "id": 1099,
    "question": "A computer user calls the IT help desk in a panic because they have a BSOD on the screen. You ask them if there is a specific error message displayed and if they have installed any hardware or software lately. They haven\u2019t. What would be a good first step to resolve the BSOD?",
    "choice_a": "Try rebooting the system; Windows will try to fix it.",
    "choice_b": "Refresh the OS.",
    "choice_c": "Reinstall the OS.",
    "choice_d": "Restore to the previous OS version.",
    "correct_answer": "A",
    "explanation": "A Blue Screen of Death (BSOD) is a warning screen on a Windows system. It may be blue and have a sad smiley face or an error message on it. Sometimes, the solution is as simple as rebooting the system and the problem will resolve. If it doesn\u2019t, then the solution depends on any error messages received and what you find in the troubleshooting process. The macOS equivalent is a spinning pinwheel. As of 2023, Linux also has a BSOD, which may include a QR code for more information and/or the Linux penguin logo. The BSOD in a Linux system isn\u2019t always blue. It can be various colors depending on the Linux distribution being used.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      188,
      190,
      189,
      199,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1100,
    "question": "You have just replaced faulty RAM in a desktop computer. You reboot the computer, and after a few seconds it beeps once. What does this indicate?",
    "choice_a": "The RAM is faulty.",
    "choice_b": "The motherboard needs to be replaced.",
    "choice_c": "The system BIOS detected an error in the POST routine.",
    "choice_d": "The system BIOS completed the POST routine normally.",
    "correct_answer": "D",
    "explanation": "Every computer has a diagnostic program built into its Basic Input/Output System (BIOS) called the Power-On Self-Test (POST). When you turn on the computer, it executes this set of diagnostics. If the computer doesn\u2019t perform the POST as it should, one way to determine the source of a problem is to listen for a beep code. This is a series of beeps from the computer\u2019s speaker. A successful POST generally produces a single beep. Beep codes vary depending on the manufacturer, so it\u2019s always a good idea to consult the motherboard\u2019s documentation.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      196,
      199,
      190,
      188,
      193
    ],
    "source": "9781394330348"
  },
  {
    "id": 1101,
    "question": "You are troubleshooting a computer that will not boot. It tells you that there is no bootable device. You check the BIOS, and it does not show any installed hard drives. What should you do next?",
    "choice_a": "Runbootrec /fixmbr.",
    "choice_b": "Replace the hard drive with an external drive.",
    "choice_c": "Flash the BIOS.",
    "choice_d": "Check the hard drive connections.",
    "correct_answer": "D",
    "explanation": "Failure to boot at all likely means the drive is dead. But first, perform your due diligence and reseat the connections and determine whether the Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI) recognizes the drive before replacing it. BIOS/UEFI should autodetect the hard drive. If that autodetection fails, it\u2019s bad news for the hard drive, unless there\u2019s a cable, connection, or jumper issue. If the internal hard drive is indeed dead, you might be able to get by temporarily by plugging in an external drive.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      204,
      195,
      190,
      203,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1102,
    "question": "A technician just replaced a failed internal hard drive in a desktop computer with an empty hard drive. They need to boot to the network to connect to an imaging server to restore the computer. How should they do this?",
    "choice_a": "During boot, press the F2 key to boot to the network.",
    "choice_b": "During boot, enter the BIOS/UEFI, and change the boot sequence to boot to the network.",
    "choice_c": "Let the boot complete normally. When the UEFI does not find a bootable partition on the hard drive, it will boot from the network.",
    "choice_d": "During boot, press the F7 key to edit the boot sequence menu.",
    "correct_answer": "B",
    "explanation": "The system\u2019s Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI) contains the boot sequence for a system. Most systems probably boot to the first hard drive by default, but they can also be configured to boot from a secondary hard drive, a Universal Serial Bus (USB) drive, an optical drive, or the network. This setting is configured in the BIOS/UEFI. The BIOS/UEFI will attempt to boot from devices based on the priority order that is set in the BIOS/UEFI until it either finds a bootable device or determines that no available device is bootable. A device won\u2019t be available if it isn\u2019t connected to the system properly, or if that type of device is disabled in the BIOS/UEFI.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      195,
      204,
      188,
      190,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1103,
    "question": "A user\u2019s laptop computer does not show anything on the screen, although the power light and other indicator lights are on. You plug in an external display, which does not show an image either. Which component is most likely causing the problem?",
    "choice_a": "Inverter",
    "choice_b": "Backlight",
    "choice_c": "Screen",
    "choice_d": "Integrated video",
    "correct_answer": "D",
    "explanation": "If a laptop does not display any video, it could be the screen or the integrated video. To test it, plug in an external display (that you know works), and use the function keys on the laptop to switch to external video output. If that doesn\u2019t work, it\u2019s likely that the video card is defective.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      202,
      218,
      196,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1104,
    "question": "You are troubleshooting a computer making a loud whining noise. Looking at the exhaust fan, you see a thick dust coating. What should you do next?",
    "choice_a": "Use compressed air to clean the fan.",
    "choice_b": "Use a computer vacuum to clean the fan.",
    "choice_c": "Use a damp cloth to clean the fan.",
    "choice_d": "Replace the power supply.",
    "correct_answer": "A",
    "explanation": "Try cleaning the fan before replacing any parts. The power supply fan has a protective grid covering it, and you won\u2019t really be able to get to it with a computer vacuum or a damp cloth. Using compressed air to blow it out is your best option. Be sure to insert something nonconductive, like a plastic knife, between the blades of the fan to keep the fan from spinning to protect the fan\u2019s motor. You must, of course, do this with the computer off.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      194,
      193,
      189,
      190,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1105,
    "question": "A user reports that their laptop battery does not charge when the laptop is plugged into an AC outlet. What is the best solution to try first?",
    "choice_a": "Replace the battery.",
    "choice_b": "Replace the AC adapter.",
    "choice_c": "Reseat the battery connection.",
    "choice_d": "Drain the battery completely, and then recharge it.",
    "correct_answer": "C",
    "explanation": "Most laptops have a battery that can be replaced after removing a panel or the keyboard. Legacy laptops may have an external battery. If the battery won\u2019t charge while the laptopis plugged in, try removing or disconnecting the battery and reinserting/reconnecting it. If it still won\u2019t charge, you might try replacing the battery.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      225,
      189,
      190,
      188,
      226
    ],
    "source": "9781394330348"
  },
  {
    "id": 1106,
    "question": "A technician has determined that they need to replace a laptop\u2019s motherboard. Which of the following procedures should be followed? (Choose two.)",
    "choice_a": "Never use a power screwdriver with a laptop.",
    "choice_b": "Document and label screw locations.",
    "choice_c": "Refer to the manufacturer\u2019s instructions.",
    "choice_d": "Remove the keyboard before removing the motherboard.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "When repairing laptops, you should always document and label screw and cable locations, organize parts, refer to manufacturer instructions, and use appropriate hand tools. Power screwdrivers can be used, but if you choose to use them, do so carefully to avoid damaging the laptop. In some cases, but not all, you might need to remove the keyboard to remove the motherboard. Refer to the manufacturer\u2019s instructions.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      197,
      190,
      188,
      230,
      226
    ],
    "source": "9781394330348"
  },
  {
    "id": 1107,
    "question": "You are troubleshooting a desktop computer that has been randomly rebooting, and now it refuses to boot properly. While it\u2019s booting, you receive one long beep and three short beeps but no video on the screen. What tool should you use to troubleshoot the situation?",
    "choice_a": "Multimeter",
    "choice_b": "Power supply tester",
    "choice_c": "Loopback plug",
    "choice_d": "POST card",
    "correct_answer": "D",
    "explanation": "This computer gives you a beep code during the Power-On Self-Test (POST) routine. You may be able to determine the problem by reading the vendor documentation, but another way to troubleshoot this issue is to use a POST card. A POST card is a circuit board that fits into an expansion slot in the motherboard or connects via a USB port and reports numeric codes as the boot process progresses. Each of these codes corresponds to a particular component being checked. If the POST card stops at a certain number, you can look up that number in the POST card\u2019s manual to determine the problem. A power supply tester and multimeter are used to troubleshoot problems with power, and a loopback plug is used to troubleshoot problems with the network card.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      196,
      201,
      190,
      188,
      202
    ],
    "source": "9781394330348"
  },
  {
    "id": 1108,
    "question": "You are troubleshooting a computer that has been randomly rebooting, and now it refuses to boot properly. Upon booting, you receive one long beep and three short beeps but no video on the screen. You don\u2019t have a POST diagnostic card that will work with this motherboard. What tool should you use to troubleshoot the situation?",
    "choice_a": "Motherboard documentation",
    "choice_b": "Power supply tester",
    "choice_c": "Multimeter",
    "choice_d": "Loopback plug",
    "correct_answer": "A",
    "explanation": "This computer hasn\u2019t reached the video part of the Power-On Self-Test (POST) yet, so the only way it has to communicate error codes with the user is through a series of beeps. The pattern of beeps has a specific meaning. Often, continuous short beeps indicate a Random Access Memory (RAM) problem, while one short beep and three long beeps indicate a video problem, but you would need to consult the motherboard documentation to be sure. A power supply tester and multimeter are both used to troubleshoot problems with power, and a loopback plug is used to troubleshoot problems with the network card.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      196,
      190,
      188,
      193,
      201
    ],
    "source": "9781394330348"
  },
  {
    "id": 1109,
    "question": "Over time, the HDD performance of your computer has gotten slower. A quick check of Performance Monitor shows that your disk read/writes are slower than the baseline. What should you do to resolve this issue?",
    "choice_a": "Run Optimize, and defragment the drive.",
    "choice_b": "Format the hard drive, and restore the data.",
    "choice_c": "Delete the partition, create a new one, and restore the data.",
    "choice_d": "Runchkdsk.",
    "correct_answer": "A",
    "explanation": "First of all, troubleshooting this on a Hard Disk Drive (HDD) is different than a Solid-State Drive (SSD). You should never defragment an SSD. When files are written to an HDD, they\u2019re not always written contiguously (i.e., with all of the data in a single location). As a result, file data is spread out over the disk, and the time it takes to retrieve files from the disk increases. Defragmenting a disk involves analyzing the disk, and then consolidating fragmented files and folders so that they occupy a contiguous space, thus increasing performance during file retrieval. Luckily for us the defragment utility makes the task easy. SSDs use flash memory, so they don\u2019t experience the latency that an HDD does when retrieving data. Running the check disk utility (chkdsk) will find some problems with file allocation units and physical sectors but won\u2019t fix a fragmented drive. The other two options are drastic measures and not usually needed to fix this issue.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      206,
      207,
      200,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1110,
    "question": "A user\u2019s computer has failed. When you try to boot it up, you hear a loud, rhythmic clicking sound, and the system does not boot properly. What is most likely the issue?",
    "choice_a": "HDD failure",
    "choice_b": "SSD failure",
    "choice_c": "RAM failure",
    "choice_d": "Power supply fan failure",
    "correct_answer": "A",
    "explanation": "A rhythmic clicking sound can be made only by components with mechanical parts, such as a conventional Hard Disk Drive (HDD). A power supply fan failure usually results in a whining sound or no sound at all because the fan doesn\u2019t work, but it may not cause a system boot failure. Solid-State Drives (SSDs) and Random Access Memory (RAM) don\u2019t make any sound when they fail.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      193,
      203,
      196,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1111,
    "question": "A laser printer you are working with consistently produces images with white streaks running down the page. What can you do first to resolve this issue?",
    "choice_a": "Clean the transfer corona wires.",
    "choice_b": "Clean the EP drum.",
    "choice_c": "Clean the fusing assembly.",
    "choice_d": "Gently shake or replace the toner cartridge.",
    "correct_answer": "D",
    "explanation": "Vertical white lines running down the page are likely due to the toner being clumped together and not transferring properly to the drum. It\u2019s a common problem when the ambientair\u2019s humidity is too high. To fix this issue, first remove and try gently shaking the toner cartridge to loosen the toner. If that doesn\u2019t work, you may have to replace the toner cartridge with a new one.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      239,
      238,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1112,
    "question": "The laser printer in your office recently started creasing papers and producing paper jams. Which of the following are likely to cause these problems? (Choose three.)",
    "choice_a": "Bits of paper in the paper path",
    "choice_b": "Paper tension settings",
    "choice_c": "Using the wrong paper",
    "choice_d": "Damaged rollers",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Printer jams and creased paper happen when something prevents the paper from advancing through the printer evenly. There are several reasons this could be happening. If the rollers that pull the paper along are damaged, they won\u2019t pick paper up properly. If the paper is too humid, it can crease, jam, or tear easily. Paper that is too thick or debris in the paper path can also cause paper to crease or jam.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      236,
      239,
      238,
      234,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1113,
    "question": "You power on a desktop computer and hear the fan spinning. However, you do not see any indicator lights or get a POST beep. Which component is likely causing the problem?",
    "choice_a": "CPU",
    "choice_b": "RAM",
    "choice_c": "PSU",
    "choice_d": "HDD",
    "correct_answer": "C",
    "explanation": "This is most likely a problem with the power supply. Test it with a power supply tester or a multimeter. Even though the fan is spinning, the power supply might still not be providing the correct power to run the computer. Not having any indicator lights would indicate a problem with the power supply. If it were Random Access Memory (RAM), Central Processing Unit (CPU), or Hard Disk Drive (HDD) issue, there would at least be some lights (like the power light) illuminated.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      201,
      196,
      194,
      200,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1114,
    "question": "Your computer is making an intermittent grinding noise. What component is most likely failing?",
    "choice_a": "Magnetic hard drive",
    "choice_b": "Solid-state drive",
    "choice_c": "Processor fan",
    "choice_d": "RAM",
    "correct_answer": "A",
    "explanation": "If you hear a grinding noise, consider yourself fortunate to have a warning that your hard drive is failing. If you don\u2019t have a good backup and a way to reinstall the Operating System (OS), you\u2019ll want to take care of that immediately, then invest in a new hard drive. Solid-State Drives (SSDs) and Random Access Memory (RAM) don\u2019t make any noise when they fail. A failing processor fan would result in an overheating Central Processing Unit (CPU), which would shut the system down.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      193,
      203,
      207,
      198,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1115,
    "question": "Your office uses an inkjet printer. Recently, it started having problems picking up paper. Which component is likely to cause this problem?",
    "choice_a": "Transport rollers",
    "choice_b": "Pickup rollers",
    "choice_c": "Corona wire",
    "choice_d": "Transmission rollers",
    "correct_answer": "B",
    "explanation": "If your printer fails to pick up paper, it could indicate that the pickup rollers are too worn. They press up against small rubber or cork patches known as separation pads. These pads help to keep the rest of the paper in the tray, so that only one sheet gets picked up at a time. A pickup stepper motor turns the pickup rollers.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      236,
      234,
      190,
      188,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1116,
    "question": "Your office uses an impact printer and multipart carbonless forms. The office manager noticed that the bottom copies of the forms are legible but the top copy is too light to read. What needs to be replaced?",
    "choice_a": "Toner cartridge",
    "choice_b": "Printhead",
    "choice_c": "Ink ribbon",
    "choice_d": "Ribbon advance motor",
    "correct_answer": "C",
    "explanation": "Most likely, the ink ribbon has reached its maximum number of prints or has dried out. Because the bottom copies are printing fine, the printhead is working. Replace the worn-out ribbon, and it should work fine again.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      234,
      235,
      190,
      188,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1117,
    "question": "Your network uses 802.11ac and a single WAP for all client computers. Recently, several users moved from one office space to another, increasing the number of users in the area from 20 to about 50. Now, both new and old users are reporting very slow network transfer speeds. What is most likely the cause of the problem?",
    "choice_a": "802.11ac can\u2019t support that many concurrent users.",
    "choice_b": "The new office space is too far from the WAP.",
    "choice_c": "There are too many users for one wireless access point.",
    "choice_d": "The new users all have 802.11n network cards.",
    "correct_answer": "C",
    "explanation": "The users are connecting; it\u2019s just slower than it should be. This is likely due to too many people accessing the Wireless Access Point (WAP) at once. The more devices there are connected, the more likely that their signals will interfere with each other, even if the WAP hasn\u2019t reached the theoretical maximum that the manufacturer says it can support. To solve this problem, install a second WAP.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      229,
      210,
      188,
      191,
      233
    ],
    "source": "9781394330348"
  },
  {
    "id": 1118,
    "question": "You purchased a mobile device that requires the use of a stylus to input information; it does not respond to the touch of a finger but sometimes works using your fingernail. However, using your fingernail isn\u2019t convenient. You purchased a stylus, but it doesn\u2019t work with the mobile device. What type of stylus does this device need?",
    "choice_a": "Tempered",
    "choice_b": "Resistive",
    "choice_c": "Capacitive",
    "choice_d": "Object-oriented",
    "correct_answer": "B",
    "explanation": "Resistive touchscreens respond to pressure, and they are highly accurate in detecting the touch position. These types of touchscreens require the use of a stylus or other hard object, such as a fingernail. Capacitive screens work by detecting interruptions in an electric field. You can use your finger with them, but they can\u2019t tell how hard you are pressing. Tempered is a type of glass that is very strong, and object-oriented is a type of programming/software.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      228,
      227,
      230,
      225,
      232
    ],
    "source": "9781394330348"
  },
  {
    "id": 1119,
    "question": "You have installed an 802.11ax WAP for a company. To cut costs, the company wanted only one central WAP in the building, which is about 400 feet long. Users at both ends of the building report intermittent connectivity drops and slow access. What is most likely the cause of the problem?",
    "choice_a": "Low RF signal",
    "choice_b": "Oversaturated WAP",
    "choice_c": "SSID not found",
    "choice_d": "IP address conflicts",
    "correct_answer": "A",
    "explanation": "The most common reason that users on wireless networks experience intermittent connectivity issues is distance. The farther away from the Wireless Access Point (WAP) the user gets, the weaker the signal becomes. When the signal weakens, the transfer rates dropdramatically. Ways to fix a low Radio Frequency (RF) signal include using a more powerful transmitter, using a larger antenna, focusing the signal toward where it is needed, or moving the users closer. The maximum distance for an 802.11ax signal is 230 feet, so in theory, an 802.11ax WAP in the center of a building could transmit 230 feet in any direction. Transmission distance is also affected by obstacles in its path, such as walls and stairwells. The most important feature of 802.11ax is its ability to support a greater number of simultaneous users than previous standards.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      229,
      210,
      188,
      190,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1120,
    "question": "A customer complains that although they installed a 10 Gb Ethernet card in their server and their cable supports 10 Gbps, the network connection is still running at 1 Gbps. What is most likely the problem?",
    "choice_a": "Debris in the PCIe slot",
    "choice_b": "Faulty network cable",
    "choice_c": "Slower switch",
    "choice_d": "Slower PC",
    "correct_answer": "C",
    "explanation": "Unless you replace all the network connectivity devices with faster 10 Gbps devices, the network will run at the slower device\u2019s speed. The customer needs to replace the switch with a 10 Gbps switch.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      216,
      190,
      188,
      214,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1121,
    "question": "You receive a call from the accounting department that their printer is printing something very strange, including unexpected characters and text that is missing. Which of the following are likely culprits? (Choose two.)",
    "choice_a": "Loose or defective printer cable",
    "choice_b": "Overheating",
    "choice_c": "Wrong language keyboard",
    "choice_d": "Incorrect or corrupted printer driver",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Try reseating the printer\u2019s data and power cable. The printer may need to be reset, which can sometimes be done by unplugging it for 30 seconds, then plugging the power back in. If the print jobs are still garbled, replace the printer driver.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      237,
      240,
      201,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1122,
    "question": "You\u2019re having lunch with a friend. They are charging their phone, and you notice that their phone is swelling. What action should be taken first?",
    "choice_a": "Nothing, it\u2019s fine.",
    "choice_b": "Disconnect the power, and then turn it off.",
    "choice_c": "Turn it off, and then remove the battery if possible.",
    "choice_d": "Replace the battery.",
    "correct_answer": "B",
    "explanation": "An overheating, swelling battery has the potential to explode and should be handled carefully. If the phone is plugged in, immediately unplug it. Turn the phone off and discontinue using it. While you might be able to replace the battery, most often the phone will need to be replaced.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      225,
      226,
      194,
      230,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1123,
    "question": "You have a laptop that the user says won\u2019t charge since they dropped it on the floor while it was plugged in. It landed on the side where the charger connects. It was running fine until the battery ran out. What might be the most expedient solution?",
    "choice_a": "Replace the motherboard.",
    "choice_b": "Replace the power connector.",
    "choice_c": "Solder the power jack back onto the motherboard.",
    "choice_d": "Solder the power cord to the motherboard.",
    "correct_answer": "C",
    "explanation": "Most laptops have a power jack, which is soldered onto the motherboard. They have been known to be knocked loose with rough handling, or when a laptop is dropped or bumped while the power cord is plugged in. If the power jack isn\u2019t damaged, you might be able to rectify the problem by simply soldering the power jack back into place. However, if the power jack is damaged, you\u2019ll need to find a replacement jack.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      225,
      230,
      190,
      188,
      201
    ],
    "source": "9781394330348"
  },
  {
    "id": 1124,
    "question": "A user complains that their laptop charges only when they wiggle the connector and move it to a certain angle. What do you most likely need to do?",
    "choice_a": "Solder the port back into place.",
    "choice_b": "Replace the port.",
    "choice_c": "Replace the charger.",
    "choice_d": "This can\u2019t be fixed.",
    "correct_answer": "B",
    "explanation": "When a charger wiggles in a port, it\u2019s usually a sign that the port has been damaged by pressure against the cord plugged in, causing the port to bend out of shape. Of course, you should check the port and the cable first, but most likely you\u2019ll need to replace the port. Soldering it back into place won\u2019t help.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      230,
      225,
      190,
      189,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1125,
    "question": "Lately your friend\u2019s phone hasn\u2019t been charging very well from a wall outlet. It charges very slowly, if at all. Once it\u2019s charged, it seems to work okay. But when they connect it to their laptop, the laptop doesn\u2019t recognize the phone. What will you try first to remedy the situation?",
    "choice_a": "Check for debris in the charging port.",
    "choice_b": "Spray a port-cleaning solution into the phone.",
    "choice_c": "Replace the phone battery.",
    "choice_d": "Replace the charger block and cord.",
    "correct_answer": "A",
    "explanation": "Phones that are stuffed in back pockets or purses often end up with lint and other debris in their charging port. Using canned air to remove debris from a port isn\u2019t recommended. Try holding the phone with the port facing downward, and gently tap the phone to remove the debris. Don\u2019t blow into the port as this can introduce moisture into the phone. You might be able to remove the debris with a small sewing needle, but this could also damage the port if you\u2019re not careful. If debris isn\u2019t the problem, you\u2019ll need to try some other solutions, such as a different block and cord or replacing the battery or the port. You would never spray cleaning solution or any liquid into the phone. If the phone is compatible with wireless charging, you could try charging the battery wirelessly to determine if the battery is the problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      225,
      230,
      188,
      190,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1126,
    "question": "Your tablet is not charging properly. When you look inside the port, you can see corrosion on the connectors. What should you do?",
    "choice_a": "Replace the tablet.",
    "choice_b": "Replace the port.",
    "choice_c": "Use lint-free swabs with a small amount of isopropyl alcohol to gently clean the connection.",
    "choice_d": "Use a toothbrush dampened with isopropyl alcohol to brush the connector clean.",
    "correct_answer": "C",
    "explanation": "Corrosion can limit or totally prevent a tablet\u2019s charger port and cable from making a connection, but you don\u2019t necessarily need to replace the port or tablet. Tread carefully when cleaning corrosion. Isopropyl alcohol is used to clean because it will dry very quickly. Ensure that the tablet is powered off, and then remove the battery if it is one that is intended to be removed. Use as little liquid as possible on a lint-free cleaning swab and be gentle. Never use a toothbrush to clean the tablet\u2019s power port.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      225,
      230,
      188,
      190,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1127,
    "question": "Your office\u2019s laser printer recently started producing images that aren\u2019t completely set. People are smudging the images as they pick up the completed print jobs. What is causing this problem?",
    "choice_a": "Fusing assembly",
    "choice_b": "Exit rollers",
    "choice_c": "Drying assembly",
    "choice_d": "Charging corona",
    "correct_answer": "A",
    "explanation": "The fusing assembly heats up the toner, and the toner melts into the paper. If the fuser isn\u2019t heating properly, images can smudge or smear.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      239,
      238,
      237,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1128,
    "question": "Guests in your office lobby are complaining that their wireless connection is often dropped and seems to be very slow (i.e., has high latency). The company president wants the visitors to be happy, so they\u2019ve asked you to take care of the situation. You analyze the wireless signal strength in the lobby and discover that it\u2019s very weak when compared to the rest of the building. What are the two best solutions? (Choose two.)",
    "choice_a": "Install wired connections in the lobby for visitors.",
    "choice_b": "Install a WAP in the lobby.",
    "choice_c": "Buy a faster WAP.",
    "choice_d": "Install a wireless range extender.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Installing another Wireless Access Point (WAP) closer to where the users are will extend the overall wireless network range and give them a better signal. A wireless range extender might also do the trick. You wouldn\u2019t install wired connections for the users because not all visitors will have a Registered Jack 45 (RJ-45) connection on their device or carry a cable with them. Buying a faster WAP won\u2019t help if the network doesn\u2019t support it, and it doesn\u2019t solve the issue of the signal being weak in the lobby.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      229,
      190,
      191,
      210,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1129,
    "question": "A technician is troubleshooting a computer that is unable to connect to a wired network connection. They verified that the cable is plugged in, but there are no lights lit on the network card. The computer could connect yesterday, and no other users have reported an issue. Which of the following are most likely to be causing this problem? (Choose two.)",
    "choice_a": "Faulty network cable",
    "choice_b": "Faulty network card driver",
    "choice_c": "Incorrect TCP/IP configuration",
    "choice_d": "Cable unplugged at the other end",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "If the network card doesn\u2019t have any lights, it doesn\u2019t have a connection. It could be that the cable is bad or that it\u2019s not plugged in on the other side, or it could also be a problem with the Network Interface Card (NIC) or the connectivity device on the other side. If nobody else in the same area is having the same problem, it points to an issue with this computer or cable as themost likelyproblem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      216,
      190,
      188,
      209,
      217
    ],
    "source": "9781394330348"
  },
  {
    "id": 1130,
    "question": "You are troubleshooting a network connectivity issue in one area of a large building. The connections are wired. What should be the first action you take?",
    "choice_a": "Ask the user if they can reach the Internet.",
    "choice_b": "Test the NIC.",
    "choice_c": "Test the cable.",
    "choice_d": "Determine if more than one person is affected.",
    "correct_answer": "D",
    "explanation": "When troubleshooting connectivity issues, the first thing to determine is how widespread the problem is, because that determines where you\u2019ll look first. If the user has no network connectivity, they won\u2019t be able to reach the Internet. Testing the Network Interface Card (NIC) and the cable might be part of the process, but not the first action to take.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      190,
      188,
      216,
      212,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 1131,
    "question": "You have just installed a new HP LaserJet printer on your network. You\u2019ve plugged it directly into a Cat 6a network cable. You try to install the printer on a client computer using the printer\u2019s IP address, but you are unable to connect. The printer is in the Ready state. What should you do next?",
    "choice_a": "Double-check the printer\u2019s IP configuration information.",
    "choice_b": "Stop and restart the spooler service.",
    "choice_c": "Take the printer offline, and then bring it back online.",
    "choice_d": "Turn the printer off and back on to save the IP configuration information.",
    "correct_answer": "A",
    "explanation": "For network-enabled laser printers, no connectivity can be a sign of improperly configured Internet Protocol (IP) settings such as the IP address. While each printer is somewhat different, you can manually configure most laser printers\u2019 IP settings through the Liquid Crystal Display (LCD) control panel.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      237,
      190,
      188,
      216,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1132,
    "question": "Your network has recently grown from 50 client computers to about 90. All workstations on the network are connected using Cat 6 or better cabling, and all network devices support at least 1 Gbps data transfers. Users have been reporting very slow network speeds since the expansion, and complaints are now coming more frequently. Which of the following actions is most likely to help resolve the issue?",
    "choice_a": "Add another hub to the network.",
    "choice_b": "Upgrade all the cabling to Cat 8.",
    "choice_c": "Upgrade the existing router to support 10 Gbps data transfers.",
    "choice_d": "Add another switch to the network.",
    "correct_answer": "D",
    "explanation": "On a wired network, if you run into slow speeds or intermittent connectivity, it\u2019s likely a load issue. There\u2019s too much traffic for the network to handle, and the network is bogging down. Solutions include adding a switch, replacing any old hubs with switches, and even creating Virtual Local Area Networks (VLANs) by using managed switches. Even without creating VLANs, each port of a switch is its own collision domain, so adding a switch reduces network traffic and will result in less latency. The switches will be connected to a router (or a higher level switch in a network hierarchy) that manages network traffic between the switches. If you want to upgrade the cabling or connectivity infrastructure to combat a speed issue, you should do all of it and not just cables or a router. Hopefully your network doesn\u2019t have any hubs! They are legacy devices.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      190,
      188,
      189,
      216,
      233
    ],
    "source": "9781394330348"
  },
  {
    "id": 1133,
    "question": "Your junior IT administrator has identified a port on your Cisco switch that changes between up and down repeatedly. What have they observed?",
    "choice_a": "Port flapping",
    "choice_b": "Port toggling",
    "choice_c": "Port flashing",
    "choice_d": "Port flagging",
    "correct_answer": "A",
    "explanation": "This is known as port flapping, also known as link flapping. It can be caused by a faulty or nonstandard network cable, non-Energy Efficient Ethernet (EEE) devices, or Small Form-factor Pluggable (SFP) devices that are not working or synchronizing properly.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      217,
      216,
      190,
      210,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1134,
    "question": "Users have been complaining that a network resource has intermittent connectivity. You\u2019ve identified the problem: the switch port is flapping. The connected device is not EEE-compliant, and users need it to be available. What should you do?",
    "choice_a": "Configure link-flap-prevention settings.",
    "choice_b": "Replace the offending device.",
    "choice_c": "Disable EEE on the switch.",
    "choice_d": "Disable EEE on the device.",
    "correct_answer": "C",
    "explanation": "You would need to disable Energy Efficient Ethernet (EEE) on the switch. The port is flapping because the device connected to it is not EEE-compliant. Link flap prevention settings would disable the port when port flapping is detected and require the network administrator to enable the port each time it is disabled. Eventually you might want to replace the offending device, but until that is done, disabling EEE on the switch is the best option.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      216,
      190,
      188,
      191,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1135,
    "question": "A user calls you about a printer not working. The user is standing next to the printer, and you are in the next building. How can the user be helpful to you while you\u2019re diagnosing the problem? Choose the best first action.",
    "choice_a": "Turn the printer off and on.",
    "choice_b": "Read the printer error code.",
    "choice_c": "Remove the jammed paper.",
    "choice_d": "Check the network link light.",
    "correct_answer": "B",
    "explanation": "Without knowing the printer\u2019s problem, it would be most helpful if the user could tell you the error code seen on the printer\u2019s display. The error code might signify a paper jam or no connectivity, but knowing the error code will save you guesswork and possibly avoid creating more problems. While it\u2019s true that often turning a printer off and on will clear a problem, it may result in a print job being deleted, especially on older printers. It\u2019s best to see what the printer error code is first.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      190,
      188,
      191,
      189,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1136,
    "question": "A user calls to report that they can\u2019t access the Internet or a corporate server. However, they are still able to print to a printer nearby. They have not received any error messages. Other users in the area are also unable to access the Internet. Of the options given, which is most likely the problem?",
    "choice_a": "IP address conflict",
    "choice_b": "Default gateway down",
    "choice_c": "Incorrect subnet mask",
    "choice_d": "Network card failure",
    "correct_answer": "B",
    "explanation": "You can immediately rule out client-side hardware issues, because the user can connect to some resources. You need to figure out why they can\u2019t connect to others. This is most likely caused by one of two things: a configuration issue or a connectivity device (such as a router) problem. Because it\u2019s affecting multiple people, it\u2019s probably a problem with the router (i.e., default gateway).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      216,
      211,
      212,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1137,
    "question": "A workstation is sending print jobs directly to a printer with a stapler as a finishing option. When they retrieve the print job, the document is not stapled. Which of the following could be the problem? (Choose three.)",
    "choice_a": "The stapler is empty.",
    "choice_b": "The staples are in backward.",
    "choice_c": "A different printer driver is needed.",
    "choice_d": "The stapler is not enabled.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The answer will depend on the specific printer, but common causes are that the stapler is empty, a different printer driver is needed, or the staple unit isn\u2019t enabled on the printer. It\u2019s usually almost physically impossible to put the staples in backward.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      235,
      236,
      238,
      240,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1138,
    "question": "A message has appeared on the office copier/printer that says \u201cStapler Jam.\u201d Which of the following are true? (Choose three.)",
    "choice_a": "The jam must be cleared before anything else is printed.",
    "choice_b": "Print jobs not involving the stapler may still occur.",
    "choice_c": "The symptom can be caused by trying to staple too many pages.",
    "choice_d": "The manufacturer\u2019s documentation should be consulted for procedures to follow.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Depending on the copier/printer, you might still be able to print to it, even though the stapler is jammed. Trying to staple too many pages or unsupported paper can certainly cause staple jams as well as installing the wrong staples. Because the procedure for removing jammed staples varies by company, you\u2019ll want to consult the specific printer manufacturer\u2019s documentation to resolve the problem.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      190,
      188,
      234,
      236,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1139,
    "question": "You set your phone in a cubby on the dashboard of your car while you\u2019re driving. It\u2019s a cold winter day in upstate New York, so you have the car\u2019s heat on fully. When you get to your destination and grab your phone, you discover that it has shut down and won\u2019t turn on again. What do you need to do?",
    "choice_a": "Buy a new phone.",
    "choice_b": "Heat the phone with a blow dryer.",
    "choice_c": "Let the phone cool down before turning it on again.",
    "choice_d": "Remove the battery and reinstall it.",
    "correct_answer": "C",
    "explanation": "The phone has overheated due to the car\u2019s heater blowing hot air on it while in an unventilated area. It must cool down before you try to use it again. The phone wouldn\u2019t be too cold, because you had the car\u2019s heat on. It\u2019s probably not necessary to buy a new phone. Most modern phones will shut down before damage occurs, and most modern phones don\u2019t have batteries that can be removed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      226,
      194,
      225,
      233,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1140,
    "question": "The print tray in your multifunction device (MFD) is not being recognized. Which of these could be the problem? (Choose two.)",
    "choice_a": "The tray isn\u2019t fully inserted.",
    "choice_b": "The printer isn\u2019t installed.",
    "choice_c": "There is a paper jam or other material in the way.",
    "choice_d": "The printer is out of paper.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Multifunction Devices (MFDs) are printers that can do a host of other tasks like scanning, emailing, copying, and so on. There are so many conditions that can result in an MFD\u2019s tray not being recognized that it is nearly impossible to list them all here. The one I\u2019ve seen most often is that the tray isn\u2019t fully inserted. Remove and reinsert the tray fully to resolve this problem. The second most common issue is that paper is jammed at the back of the tray where it is picked up and pulled into the printer. Remove the tray, remove the paper or debris, and then reinsert the tray. Beyond that, the problem could be that the tray isn\u2019t installed in the software, is improperly configured in the software, it isn\u2019t compatible with the Operating System (OS), or the wrong driver is installed. Sometimes, it\u2019s just a glitch, and you\u2019ll need to restart the printer. It could also be a problem with the paper itself\u2014perhaps it\u2019s curling, too thin, or contains too much humidity.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      241,
      190,
      188,
      236,
      240
    ],
    "source": "9781394330348"
  },
  {
    "id": 1141,
    "question": "A user reports that the video on their desktop computer does not display properly. There are several places where the screen will not light up; those spots are always black dots. What is this a symptom of?",
    "choice_a": "Artifacts",
    "choice_b": "Dead pixels",
    "choice_c": "Backlight failure",
    "choice_d": "Overheating",
    "correct_answer": "B",
    "explanation": "Dead pixels are spots on the screen that never light up. You can check for these by setting the background to white and seeing if any spots don\u2019t light up. If the display is under warranty, you might want to return it, as there isn\u2019t much you can do to fix a dead pixel.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      221,
      222,
      223,
      220,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1142,
    "question": "A user calls the help desk, stating that the icons on their computer screen are huge. They can see only about six of them and can\u2019t see the Start menu. What most likely caused this issue?",
    "choice_a": "Failing backlight",
    "choice_b": "Incorrect video resolution",
    "choice_c": "External interference, such as a fan or a motor",
    "choice_d": "Incorrect video driver",
    "correct_answer": "B",
    "explanation": "Oversized images and icons are related to screen resolution; it usually means that your resolution is set too low for the display or projector you are using. Set the resolution to the native setting (or higher than it was), and the problem should disappear.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      220,
      224,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1143,
    "question": "You are troubleshooting a desktop computer and receive S.M.A.R.T. errors. To which component do these errors refer?",
    "choice_a": "SSD",
    "choice_b": "RAM",
    "choice_c": "CPU",
    "choice_d": "Network card",
    "correct_answer": "A",
    "explanation": "Nearly every hard drive is built with Self-Monitoring, Analysis, and Reporting Technology (S.M.A.R.T.) software installed on it, which monitors hard drive reliability and can theoretically warn you in the event of an imminent failure.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      207,
      206,
      203,
      200,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1144,
    "question": "You are troubleshooting a computer system that received a S.M.A.R.T. error. Which of the following will you do first?",
    "choice_a": "Check that the system has adequate cooling/ventilation.",
    "choice_b": "Back up the system\u2019s data.",
    "choice_c": "Run a drive diagnostic tool.",
    "choice_d": "Run a RAM diagnostic tool.",
    "correct_answer": "B",
    "explanation": "Before you do anything else, you need to back up the system\u2019s drive. Self-monitoring, Analysis, and Reporting Technology (S.M.A.R.T.) errors indicate that a hard drive failure will likely happen. Drive failure may be averted, if the error is because of excessive heat, and there is a way to correct it. Otherwise, expect the drive to fail sooner rather than later. The best course of action is to ensure that the system is backed up regularly until a new drive can be installed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      207,
      189,
      200,
      226,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1145,
    "question": "You\u2019re troubleshooting a computer that isn\u2019t booting properly. When the computer is powered on, the power supply fan spins, but the computer will not POST. When you remove the cover, you notice a swollen capacitor, as shown in the center of the following figure. What should you do?<img src=\"/question_assets/220-1201/c05f001.png\" alt=\"Close-up of computer motherboard depicts four capacitors, with one in the center swollen and bulging.\"/>\n\n<figcaption>Close-up of computer motherboard depicts four capacitors, with one in the center swollen and bulging.</figcaption>",
    "choice_a": "Replace the power supply.",
    "choice_b": "Replace the capacitor.",
    "choice_c": "Replace the motherboard.",
    "choice_d": "Discharge the capacitor.",
    "correct_answer": "C",
    "explanation": "Almost every circuit board will have a capacitor or several on it. Capacitors store electricity between two dielectric plates and discharge that energy rapidly, as needed. When they fail, they can swell or burst, and electrolyte (i.e., acid) will seep out of its top vent. If you see a swollen or weeping capacitor on a motherboard, the best option is to replace the motherboard immediately.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      197,
      196,
      201,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1146,
    "question": "You are troubleshooting a Lenovo laptop that has a track point in the center of the keyboard. If nobody is moving the external mouse or track point, the cursor will slowly drift up and to the right. You have tried a different external mouse and the problem still happens. What should you do to resolve the problem?",
    "choice_a": "Replace the laptop\u2019s keyboard.",
    "choice_b": "Recenter the laptop\u2019s track point.",
    "choice_c": "Recenter the laptop\u2019s touchpad.",
    "choice_d": "Replace the laptop\u2019s motherboard.",
    "correct_answer": "B",
    "explanation": "Cursor drift is the mouse cursor slowly drifting in one direction even though you are not trying to make it move. If the laptop has a track point, this issue is generally related to the track point not centering properly after it\u2019s been used. If you have cursor drift, try using the track point and moving it back and forth a few times to get it to recenter itself. You can also try rebooting. If the problem persists, disable the track point and replace it with a mouse, or purchase a new laptop.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      227,
      190,
      188,
      191,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1147,
    "question": "The desktop computer you are troubleshooting will not retain the proper time and date. You set the time and date, power the system down, wait a few seconds, and then power it back on. Again, the settings are incorrect. Which component is likely causing the issue?",
    "choice_a": "CMOS battery",
    "choice_b": "UEFI",
    "choice_c": "Hard drive",
    "choice_d": "RAM",
    "correct_answer": "A",
    "explanation": "When the Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI) fails to retain your computer\u2019s settings, such as time, date, and hard drive configuration, it indicates one specific problem: a depleted CMOS battery. The BIOS/UEFI uses a small battery (often a CR2032 lithium battery, much like a watch battery) on the motherboard to help it retain settings when the system\u2019s power is off. If this battery fails, the BIOS/UEFI won\u2019t retain its settings. Simply replace the battery to solve the problem.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      195,
      197,
      190,
      188,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1148,
    "question": "Your friend\u2019s smartphone always has the wrong time. You tell them it\u2019s a simple fix. What should they do?",
    "choice_a": "Trade in the phone for a new one.",
    "choice_b": "Go to Settings, select the System or General tab, look for Date and Time, and then choose Set Automatically or a similar setting, depending on the phone\u2019s OS.",
    "choice_c": "Replace the phone\u2019s battery.",
    "choice_d": "Update the iOS to the latest version.",
    "correct_answer": "B",
    "explanation": "If Set Automatically in an iPhone\u2019s Date and Time settings is turned off, the date and time will be based on what the user set it at initially, which might not be correct. The setting in an Android phone can also be found in Settings, Data, and Time, but the setting is Use Network Data and Time or similar, depending on the Operating System (OS). Automatic settings will change the time for daylight savings time and receive the correct time from cell towers. They can also use the Global Positioning System (GPS) features of the phone to determine date and time.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      190,
      188,
      189,
      191,
      233
    ],
    "source": "9781394330348"
  },
  {
    "id": 1149,
    "question": "A technician is troubleshooting a RAID-5 array with four hard disks. One of the disks has failed. What can the technician do to recover the array?",
    "choice_a": "Replace the failed disk, and rebuild the array.",
    "choice_b": "Replace the failed disk, and restore from backup.",
    "choice_c": "Rebuild the failed disk, and restore from backup.",
    "choice_d": "Remove the failed disk, and rebuild the array.",
    "correct_answer": "A",
    "explanation": "If you\u2019re using Redundant Array of Independent Disks version 5 (RAID-5), which provides disk striping with parity, a single drive failure usually means that your data will be fine, provided you replace the failed drive. If you lose multiple drives at the same time, you will need to restore from backup. Incidentally, the minimum number of disks for a RAID-5 array is only three, but the additional disk to stripe across will increase speed.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      208,
      206,
      203,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1150,
    "question": "Your corporate finance team is getting ready for a presentation in the conference room in about an hour. They frantically call you because the image the projector is putting on the screen is fuzzy. Which of the following is the least likely cause?",
    "choice_a": "The projector\u2019s lens needs to be cleaned.",
    "choice_b": "The projector focus needs to be adjusted.",
    "choice_c": "The contrast setting is too high.",
    "choice_d": "The PC\u2019s resolution is too high for the projector.",
    "correct_answer": "C",
    "explanation": "Of the possible issues, the least likely is the contrast setting. Having an incorrect contrast may make the image difficult to see, but it shouldn\u2019t make it blurry. Adjusting the focus and cleaning the lens are easy fixes. The most likely issue, if they\u2019re using their own laptop, is that the laptop\u2019s resolution is too high for the projector. In that case, change the PC\u2019s resolution to match the native resolution of the projector, if possible. Depending on the projector, you might need to adjust the sharpness setting or turn on automatic keystone adjustment. The projector\u2019s position shouldn\u2019t matter if it\u2019s in a room where it\u2019s mounted to the ceiling and doesn\u2019t get moved; otherwise, having it too far away could also be a problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      220,
      219,
      218,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1151,
    "question": "A user reports that regardless of what is showing on their LCD desktop display, they can always see an outline of another image that never changes. What is the solution to this problem?",
    "choice_a": "Replace the video card.",
    "choice_b": "Degauss the display.",
    "choice_c": "Replace the display.",
    "choice_d": "Clean the screen.",
    "correct_answer": "C",
    "explanation": "With display burn-in, no matter what you have on your screen, you can still see the outlines of a different image. That image has been \u201cburned\u201d into the display and isn\u2019t going away. The only solution is to replace the display. Burn-in is also called image persistence or ghosting. Organic Light-Emitting Diode (OLED) displays are more susceptible to burn-in than other display types.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      221,
      222,
      223,
      202,
      228
    ],
    "source": "9781394330348"
  },
  {
    "id": 1152,
    "question": "A user claims that on their laptop, the mouse cursor will occasionally jump to a different screen area when they are typing. It is causing problems with their work because they end up typing in different fields than they need to. What can you suggest that will help this issue?",
    "choice_a": "Disable the track point.",
    "choice_b": "Replace the keyboard.",
    "choice_c": "Replace the motherboard.",
    "choice_d": "Disable the touchpad.",
    "correct_answer": "D",
    "explanation": "When users are typing, their palm might inadvertently touch the touchpad, causing erratic pointer behavior. This is referred to as a ghost cursor because it seems like the cursor just randomly jumps all over the screen. The touchpad can be turned off through Control Panel in Windows. Depending on the Operating System (OS), you can disable the touchpad under Settings. You might also be able to adjust the touchpad\u2019s sensitivity. On a laptop, there may be a function button to turn the touchpad on and off easily.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      227,
      188,
      191,
      190,
      233
    ],
    "source": "9781394330348"
  },
  {
    "id": 1153,
    "question": "A user is complaining that the mouse pointer drifts away on its own while they are working on their company laptop. They have changed the batteries, tried a new mouse pad, and cleaned the mouse\u2019s sensor. What should they try next to resolve the issue? (Choose two.)",
    "choice_a": "Remove and reinstall the mouse driver.",
    "choice_b": "Get a new mouse.",
    "choice_c": "Plug the mouse into a different USB port.",
    "choice_d": "Disable the mouse in the control panel.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A corrupt driver can make any device behave in a nonstandard way. Check the driver\u2019s name in Device Manager, then locate and rename the driver file with a different extension such as.old. Again, in Device Manager, remove the old driver and then install a new one.The driver file being renamed keeps Windows from reusing it, and leaving it there means you\u2019ll still have the file to revert to if needed. There could also be a problem with connectivity to the mouse port. Try using a different port to see if the problem disappears.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      227,
      190,
      188,
      191,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1154,
    "question": "A coworker comes to you for help with their iPhone. When they touch the screen, it acts as if they touched it somewhere else. They have already cleaned the touchscreen with a microfiber cloth. What will you do to help them?",
    "choice_a": "Download a calibration app.",
    "choice_b": "Adjust the touch accommodations settings.",
    "choice_c": "Suggest they get the digitizer replaced.",
    "choice_d": "Suggest they get a new phone.",
    "correct_answer": "C",
    "explanation": "Most smartphones use capacitive touchscreens. Calibrating the screen is not an option. You can check to see if something is pressing on the phone where it shouldn\u2019t be, but otherwise fixing this problem is likely going to require replacing the digitizer. Capacitive touchscreens detect the minute changes in an electrical field when an object such as a finger comes into contact with the screen. Resistive screens require a much heavier touch and react to pressure on a touchscreen.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      228,
      190,
      188,
      191,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1155,
    "question": "Your RAID controller is beeping for three seconds and then off for one second continuously. What does this indicate? (Choose the best two options.)",
    "choice_a": "In the process of installing a drive with the power off",
    "choice_b": "A normally functioning RAID array",
    "choice_c": "A problem with the RAID array",
    "choice_d": "Depends on the controller manufacturer",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The answer will depend on the manufacturer of your Redundant Array of Independent Disks (RAID) controller, but generally speaking, a beeping controller isn\u2019t a good thing. At the very least, this will mean that there is a problem with a RAID array. If you don\u2019t know the codes for your array by heart, you\u2019ll want to have the list of beep codes handy for reference. It could mean a driver failure, or it could mean you\u2019re in the process of a hot (i.e., power on) repair replacing a failed drive. In any case, you\u2019ve got a problem and need to look at the manufacturer documentation to figure out what exactly that problem is.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      196,
      208,
      193,
      190,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1156,
    "question": "Your Surface Pro tablet running Windows 11 is not responding properly to your touch gestures. What will you do?",
    "choice_a": "Buy a new tablet.",
    "choice_b": "Use the built-in calibration software.",
    "choice_c": "Replace the digitizer.",
    "choice_d": "Replace the device.",
    "correct_answer": "B",
    "explanation": "If the touchscreen on a Microsoft Surface Pro isn\u2019t working properly, search for calibrate and select Calibrate the Screen for Pen or Touch. Then follow the onscreen instructions.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      228,
      190,
      188,
      225,
      229
    ],
    "source": "9781394330348"
  },
  {
    "id": 1157,
    "question": "Your smartphone slipped into the ocean when you were taking pictures. You retrieved it after a minute or so, but it\u2019s wet. What do you do first?",
    "choice_a": "Place it in a bag of rice.",
    "choice_b": "Use a hairdryer to dry it out.",
    "choice_c": "Nothing. It\u2019s fine.",
    "choice_d": "Immediately turn it off.",
    "correct_answer": "D",
    "explanation": "While modern smartphones are water resistant, the water-resistant feature fades over time and doesn\u2019t protect the phone against water under pressure (like a shower) or extreme temperatures. If your phone gets wet, immediately turn it off. Tap it gently with the power port facing downward to remove excess water, and then leave it off in a well-ventilated area to allow it to dry out for several hours. A fan gently blowing cool air into the power connector may also help. Wipe any visible water off the phone with a clean, soft cloth, but don\u2019t stick anything into the phone\u2019s ports. Water, especially salt water, is conductive and can cause a short in the phone, which could damage or destroy it or cause the battery to swell or explode. The danger of placing the phone in a bag of rice is that a rice particle might go into the phone\u2019s port and cause more problems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      230,
      225,
      226,
      233,
      197
    ],
    "source": "9781394330348"
  },
  {
    "id": 1158,
    "question": "A customer enters your shop with a smartphone that is acting strangely. Its sound is distorted, and there is static when they plug in their headphones. You look into the SIM card slot and see a red line. What will you tell the customer? (Choose two.)",
    "choice_a": "This phone may have water damage.",
    "choice_b": "This phone has been exposed to high temperatures.",
    "choice_c": "There is no way to fix your phone.",
    "choice_d": "We can replace corroded components, but the fix may not last.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Water and electronics don\u2019t mix. A darkened screen, inability to charge, and distorted pictures and sound are all symptoms of water damage. Water inside a phone can cause a short circuit and damage the phone or battery. Some problems might not show up until much later, when components have had time to corrode and lose their connectivity. Most phones will have some type of visible indicator, like a red line, to show when the phone has been exposed to excessive moisture.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      230,
      225,
      226,
      233,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1159,
    "question": "A coworker is trying to print, but the paper isn\u2019t feeding into the printer. An error message displayed on the printer says, \u201cPaper Mismatch.\u201d What do you tell them to do? (Choose three.)",
    "choice_a": "Verify that the setting is correct in printer properties or tray properties, depending on the printer.",
    "choice_b": "Ensure that they\u2019ve selected the right paper size in their software.",
    "choice_c": "Remove and replace the paper in the tray, and verify that the paper guides are properly placed.",
    "choice_d": "Change the orientation in the software.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Exactly what to do will depend on the printer and software being used, but most likely it\u2019s a default setting somewhere either on the printer or in the software. It could also be caused by the paper guide being inadvertently moved when paper was placed in the tray or choosing the wrong tray in a multi-tray printer. Changing the paper orientation won\u2019t fix this problem, as a paper mismatch or wrong paper size error means exactly that. There is a disconnect between the paper they\u2019re telling the software to print on, and the paper size that the printer believes is in the tray.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      241,
      240,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1160,
    "question": "You\u2019ve recently doubled the number of employees in your call center. Users of your company\u2019s VoIP phones have been complaining that the calls sound like the person on the other end is stuttering, if they can understand them at all. What can you do to remedy this situation? (Choose two.)",
    "choice_a": "Add more RAM to each VoIP phone.",
    "choice_b": "Set up a VLAN for the phones.",
    "choice_c": "Configure QoS to prioritize phones.",
    "choice_d": "Configure WoL.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "What the users are experiencing is called jitter. There can be many causes for jitter but setting up a Virtual Local Area Network (VLAN) for the phones to segment traffic may help, as well as configuring Quality of Service (QoS) to prioritize the phone traffic. Wake-on-LAN (WoL) is a feature to remotely turn on a computer. Most Voice over Internet Protocol (VoIP) phones don\u2019t have user-upgradable Random Access Memory (RAM).",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      190,
      188,
      210,
      211,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1161,
    "question": "Laser printer users are complaining that their print jobs aren\u2019t printing. They\u2019re using an accounting package that won\u2019t let them reprint the reports they have printed. When you look at the print queue, you see their print jobs just sitting there. What will you do? (Choose two.)",
    "choice_a": "Ensure that the printer is turned on.",
    "choice_b": "Ensure that there is paper in the printer.",
    "choice_c": "Stop and restart the print server service.",
    "choice_d": "Delete and reinstall the printer in the OS.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Always look for the simple fixes first. Is the printer turned on? Does it have the right paper in the selected tray? Restarting the print server service will delete all the jobs in the queue, which would result in some very upset accountants, and so would deleting and reinstalling the printer in the Operating System (OS). If one particular job is causing problems, you might be able to stop or cancel that print job and print the others, then you can try to resolve the problem with that one print job.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      240,
      242,
      190,
      237,
      241
    ],
    "source": "9781394330348"
  },
  {
    "id": 1162,
    "question": "A presenter using a projector is near the end of a lengthy presentation when an audible pop is heard, and the image goes dark. What will you do to fix the situation?",
    "choice_a": "Allow the projector to cool down for a while.",
    "choice_b": "Unplug the projector, wait 30 seconds, and plug it back in.",
    "choice_c": "Reset the lamp timer.",
    "choice_d": "Replace the projector bulb.",
    "correct_answer": "D",
    "explanation": "An audible pop sound and darkness is most likely the projector bulb burning out. It\u2019s time to replace the bulb. Most projectors have an indicator light or display a message telling you that the bulb is near its end-of-life (EOL)so ideally you will have already purchased one and have it on hand. Projectors should not be unplugged without allowing the fan to cool the lamp down. Resetting the lamp timer is something that either you manually do or that automatically occurs when the bulb is replaced, so that it can keep track of the remaining bulb life for you.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      219,
      193,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1163,
    "question": "Your Wi-Fi network has very high latency. Which of the following will not improve this?",
    "choice_a": "Enable SSID broadcast.",
    "choice_b": "Disable SSID broadcast.",
    "choice_c": "Add switches to the network to divide traffic.",
    "choice_d": "Scan and remove any network malware.",
    "correct_answer": "A",
    "explanation": "Latency is the time it takes for a packet to get from point A to point B. High latency means that your network is running too slowly. There are actions you can take that can improve this, such as segmenting network traffic with switches to cut down on collisions, adding a Content Delivery Network (CDN), and ensuring that your network is free of malware. If the Service Set Identifier (SSID) broadcast is enabled, it will increase network traffic, so disabling it will reduce traffic (and latency).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      229,
      216,
      214,
      212,
      217
    ],
    "source": "9781394330348"
  },
  {
    "id": 1164,
    "question": "Which of the following does not cause authentication failure on a network?",
    "choice_a": "Wrong username or password",
    "choice_b": "Damaged router",
    "choice_c": "Disabling the SSID broadcast",
    "choice_d": "Outdated firmware/encryption protocols",
    "correct_answer": "C",
    "explanation": "There are many reasons why there could be an authentication error on a network. It could be a problem with a server that checks user credentials, too many devices on a network, or outdated firmware and old encryption protocols. There could also be heat damage to a router or damage to any other network connectivity device that would keep a user from connecting. Sometimes, changing to a different channel on a Wi-Fi network where there is less traffic will solve the problem, or you might need to update Network Interface Card (NIC) drivers. Disabling the Service Set Identifier (SSID) broadcast has no effect on authentication, but having the wrong SSID entered in your Wi-Fi settings could certainly cause an authentication error.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      229,
      217,
      211,
      216,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1165,
    "question": "You have a NAS system and have observed alternating blinking red and white LEDs. What is happening?",
    "choice_a": "The array is ready to receive data.",
    "choice_b": "The drives are booting up or shutting down.",
    "choice_c": "The RAID is synchronizing, or the software is updating.",
    "choice_d": "You\u2019re not sure, so you must check the vendor\u2019s documentation.",
    "correct_answer": "D",
    "explanation": "Hard drives, Network Attached Storage (NAS), Redundant Array of Independent Disks (RAID) arrays, Network Interface Cards (NICs), and other devices\u2014even motherboards\u2014use Light-Emitting Diode (LED) codes to let you know what\u2019s going on with them. Knowing the LED codes for your particular system is important. In the device used for this question (a Seagate NAS array), alternating red and white means the RAID is synchronizing or software is updating. Blinking white happens when the drive is starting up, shutting down, or has activity. When the LED is solid white, the system is ready, but even an experienced tech wouldn\u2019t know that, without checking the manufacturer\u2019s documentation or having familiarity with the specific product.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      203,
      208,
      190,
      188,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1166,
    "question": "Your home computer was working fine yesterday, but today you get an error stating \u201cbootable device not found.\u201d Which of the following is most likely?",
    "choice_a": "The hard drive has failed.",
    "choice_b": "The OS was deleted.",
    "choice_c": "The POST is faulty.",
    "choice_d": "A USB drive is in a USB port.",
    "correct_answer": "D",
    "explanation": "While this error can be caused by a faulty hard drive, it\u2019s more likely that someone left a Universal Serial Bus (USB) drive in the computer, and it\u2019s set to boot to USB before the hard drive. It\u2019s unlikely that the Operating System (OS) was deleted, unless there was an electrical event or someone sneaking in and deleting it. If the Power-On Self-Test (POST) detected a problem with the system, you would not have gotten this far. To remedy the situation, enter the Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI) and change the boot order so that USB ports are not included, or at the very least, so that it looks for the hard drive first.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      204,
      195,
      196,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1167,
    "question": "Which two of the following are finishing processes that can cause problems with print jobs? (Choose two.)",
    "choice_a": "Paper orientation",
    "choice_b": "Staple",
    "choice_c": "Hole punch",
    "choice_d": "Paper size",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Hole punching and stapling are considered finishing options on printers. Both of these options can occasionally cause print jobs to stall. Incorrect paper size can also cause printers to stall but is not a finishing option. Paper orientation will usually cause undesirable effects on the output, or an error message, and might stall a print job, but again this is not a printer finishing option.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      242,
      240,
      236,
      235,
      237
    ],
    "source": "9781394330348"
  },
  {
    "id": 1168,
    "question": "Users on your network are complaining about the quality of their VoIP calls. They\u2019re experiencing calls where they only hear every other word. What is this a symptom of?",
    "choice_a": "Jitter",
    "choice_b": "High bandwidth",
    "choice_c": "Packet loss",
    "choice_d": "Low latency",
    "correct_answer": "C",
    "explanation": "Packet loss occurs when a chunk of data doesn\u2019t make it to its destination, and words cutting out is one symptom. Increasing bandwidth, setting up a Virtual Local Area Network (VLAN) for the phones, or updating hardware may fix it. Jitter manifests as garbled or stuttered speech. High bandwidth and low latency are always desirable features.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      214,
      212,
      213,
      216,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1169,
    "question": "A user is trying to print and hole-punch reports on the shared office printer/copier, but the documents print out without holes every time the print job is sent to the printer. Which of the following would be related to this problem? (Choose two.)",
    "choice_a": "The hole-punch waste tray is full.",
    "choice_b": "The user didn\u2019t properly select hole punch.",
    "choice_c": "A document was left in the ADF.",
    "choice_d": "The hole-punch feature is not enabled.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "If hole punching isn\u2019t enabled, the printer/copier won\u2019t hole punch the documents. User error could also be a problem. Ensure that users are trained in selecting finishing options. If the hole punch waste tray is full, but everything else is in order, most printers will pause the print job until the tray is emptied. A document in the Automatic Document Feeder (ADF) should have no effect on the current print job. If the document were left on the scanning tray, it might pause printing, depending on the printer.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      190,
      188,
      189,
      191,
      241
    ],
    "source": "9781394330348"
  },
  {
    "id": 1170,
    "question": "Which of the following is not a symptom of a projector bulb that is burning out?",
    "choice_a": "Flickering projector image",
    "choice_b": "Dim image, even in a dark room with the projector brightness up",
    "choice_c": "Muddled (not crisp) colors being projected",
    "choice_d": "A fan running when you\u2019re done projecting",
    "correct_answer": "D",
    "explanation": "Typically, a fan should run a while to cool the bulb down when you\u2019ve finished using a projector. A single loud pop sound, dim or flickering image, and muddy colors are all symptoms of a projector lamp that is has or is about to burn out.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      219,
      223,
      222,
      193,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1171,
    "question": "You\u2019re working on a server RAID array and observe that the drive is blinking first green, then amber, then off. What does this tell you?",
    "choice_a": "The drive is preparing to be ejected.",
    "choice_b": "You\u2019re not sure but should check the vendor documentation.",
    "choice_c": "The drive has failed.",
    "choice_d": "The drive is online and is working fine.",
    "correct_answer": "B",
    "explanation": "Most Redundant Array of Independent Disks (RAID) arrays have indicator lights to tell you the drive\u2019s status. These may vary by manufacturer, but anything other than a green light is usually a cause for concern. Other statuses that the lights may tell you are when the drive is rebuilding, a rebuild is aborted, or the drive is predicted to fail.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      203,
      208,
      196,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1172,
    "question": "You have a multitude of USB drives that you use for different storage purposes, but whenever you leave one in your PC, the computer tries to boot to the USB port instead of your Windows SSD and gives you an error message about \u201cno boot device found.\u201d What can you do to remedy this situation?",
    "choice_a": "Enter BIOS/UEFI, and change the boot order so that USB is disabled or last.",
    "choice_b": "Put USB locks on all the USB ports.",
    "choice_c": "Install the OS on a USB.",
    "choice_d": "Install Linux.",
    "correct_answer": "A",
    "explanation": "Putting Universal Serial Bus (USB) locks on all the USB ports would certainly prevent the Personal Computer (PC) from booting to them, but it would also prohibit you from using those ports when you need them. If the Operating System (OS) was installed on a bootable USB, you could likely boot from it, but that\u2019s not what you want either. You want it to boot to the hard drive. Whether it\u2019s Windows or Linux isn\u2019t the issue, either. You need to change the Basic Input/Output System/Unified Extensible Firmware Interface (BIOS/UEFI) boot order settings or disable booting to USB.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      195,
      204,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1173,
    "question": "Your Wi-Fi network is experiencing some interference, which is causing poor performance and making it unstable. Which of the following might help? (Choose two.)",
    "choice_a": "Enable SSID broadcast.",
    "choice_b": "Disable SSID broadcast.",
    "choice_c": "Lower the bandwidth.",
    "choice_d": "Choose a different channel.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The best answer will depend on the exact situation. Lowering the bandwidth, for example, from 80MHz to 40MHz, might decrease interference but will also lower throughput. Changing the channel might help decrease interference. You would want to run a network analyzer and choose the channel with the least traffic, or optionally, if the WirelessAccess Point (WAP) allows, let it choose the best channel for you. If your WAP is experiencing interference from other WAPs or networks, you might want to lower, rather than raise, the signal strength. Installing an antenna with a lower gain might also work. Changing the SSID won\u2019t have any effect on interference.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      229,
      210,
      190,
      189,
      217
    ],
    "source": "9781394330348"
  },
  {
    "id": 1174,
    "question": "You\u2019ve just built a new system with an SSD drive. It POSTs just fine, but it\u2019s telling you that the hard drive is not found. What should you do first?",
    "choice_a": "Replace the SSD with an HDD.",
    "choice_b": "Format the hard drive.",
    "choice_c": "Ensure that the hard drive\u2019s data and power cables are plugged in.",
    "choice_d": "Install the OS.",
    "correct_answer": "C",
    "explanation": "You can\u2019t format or install an Operating System (OS) on the hard drive until the system can see that it\u2019s there. Occasionally, you\u2019ll find a drive that is Dead on Arrival (DOA), but it\u2019s more likely that you forgot to plug in either the data cable or power cable for the drive. You would certainly check those before installing a different drive.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      190,
      188,
      205,
      204,
      201
    ],
    "source": "9781394330348"
  },
  {
    "id": 1175,
    "question": "You are troubleshooting a Windows 10 computer that has crashed. It displays a blue screen with the errorUNEXPECTED_KERNEL_MODE_TRAPon it. Which component most likely caused this problem?",
    "choice_a": "RAM",
    "choice_b": "CPU",
    "choice_c": "SSD",
    "choice_d": "PSU",
    "correct_answer": "A",
    "explanation": "While the Central Processing Unit (CPU) may be the component that generated the error, the most common cause of this particular error is Random Access Memory (RAM). This is considered a fatal error in your Operating System (OS), producing the infamous Blue Screen of Death (BSOD) in Windows and Linux, or the rotating/spinning pinwheel in macOS.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      199,
      196,
      188,
      190,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1176,
    "question": "Your computer has been intermittently rebooting when you play an online video game. You install a hardware monitoring utility and notice in the log that the CPU temperature spikes before the system shuts down. Which action should you take first to help resolve the issue?",
    "choice_a": "Use the system BIOS to overclock the CPU.",
    "choice_b": "Replace the CPU and heat sink.",
    "choice_c": "Reseat the CPU heat sink.",
    "choice_d": "Replace the power supply.",
    "correct_answer": "C",
    "explanation": "If the Central Processing Unit (CPU) is overheating, it may be that the heat sink is not functioning properly or is not connected properly to the CPU. After the system cools down, try using new thermal paste and reseating the heat sink. Overclocking will only make the processor run hotter. If reseating the heat sink doesn\u2019t work, you might need to replace the processor, install a better cooler, or add case fans.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      198,
      194,
      190,
      188,
      200
    ],
    "source": "9781394330348"
  },
  {
    "id": 1177,
    "question": "A user reports that their tablet computer will work on battery power for only about 20 minutes, even after the battery icon says it\u2019s full. They claim that it initially worked on battery power for several hours. What is the most likely cause of the problem?",
    "choice_a": "The user is running too many apps.",
    "choice_b": "The user is constantly using the Wi-Fi connection.",
    "choice_c": "The battery needs to be charged longer.",
    "choice_d": "The battery is failing.",
    "correct_answer": "D",
    "explanation": "As batteries age, they are not able to hold as much of a charge, and in some cases, they are not able to hold a charge at all. It might be time for a new tablet, unless the tablet battery is removable and replaceable.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      225,
      233,
      226,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1178,
    "question": "A user complains that when they turn on their desktop computer, nothing appears on the screen. It sounds like the computer\u2019s fan is running, and the user reported hearing one beep when the computer powered on. What is the first thing you should check?",
    "choice_a": "Is the display plugged into the video port?",
    "choice_b": "Did the computer complete the POST properly?",
    "choice_c": "Is there a power light illuminated on the display?",
    "choice_d": "Does another display work on this computer?",
    "correct_answer": "C",
    "explanation": "Check the easy fixes first. It might seem silly but be sure that the display is plugged into a power outlet and turned on. Check to see if its power light is on.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      189,
      188,
      190,
      218,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1179,
    "question": "The AC adapter for your laptop has a green LED indicator on it. When you plug the adapter into a wall outlet, the light does not illuminate. You\u2019ve ensured that all power connections from the wall to the PC are physically connected. What could be the reasons for this? (Choose two.)",
    "choice_a": "The laptop is off.",
    "choice_b": "The wall outlet is defective.",
    "choice_c": "The AC adapter is defective.",
    "choice_d": "The voltage selector for the AC adapter is set incorrectly.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Many laptop power adapters have a light on them indicating that they\u2019re plugged in. If there\u2019s no light, check to ensure that the outlet is working or switch outlets. Also, most laptops have a power-ready indicator light when plugged into a wall outlet. Check to see whether it\u2019s lit. If the outlet is fine, try another power adapter. They do fail on occasion.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      225,
      201,
      190,
      188,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1180,
    "question": "You\u2019re taking a walk around the exterior of your office building to survey the wireless network, when your Wi-Fi analyzer shows that your network is visible in the parking lot. You\u2019re concerned that an unauthorized person can connect to your wireless network. What should you do?",
    "choice_a": "Enable SSID broadcast.",
    "choice_b": "Lower the WAP\u2019s power setting.",
    "choice_c": "Increase the WAP\u2019s power setting.",
    "choice_d": "Turn off the WAP\u2019s broadcast.",
    "correct_answer": "B",
    "explanation": "Setting a Wireless Access Point (WAP) to transmit at the maximum power may cause the Wi-Fi to extend into areas you would rather it didn\u2019t. It can also cause problems like more interference resulting in poor performance and stability because it\u2019s picking up signals from nearby Wi-Fi networks. Enabling or disabling the Service Set Identifier (SSID) broadcast will have no effect on the signal strength. It may take a bit of playing with settings, antennas, and placement to get the Wi-Fi transmission exactly how you need it to be, but in this case, lowering the WAP\u2019s power setting is a good start.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      229,
      210,
      190,
      191,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1181,
    "question": "You have a macOS desktop computer that does not produce an image on the screen when it boots. You hear a chime sound, and the normal indicator lights are on. The display is connected to the computer, and the power light is on. What should be your next troubleshooting step?",
    "choice_a": "Try the display on another computer or another display on this computer.",
    "choice_b": "Replace the video card.",
    "choice_c": "Switch the display to another video connector on the video card.",
    "choice_d": "Replace the motherboard.",
    "correct_answer": "A",
    "explanation": "Most macOS machines will make a chime sound on a successful bootup, so you can be relatively certain the problem is not the motherboard itself. Before going that route, try another display or try the current display on another computer. That will narrow the problem down quickly. Remember, if it\u2019s not the display, it\u2019s probably the video card.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      202,
      196,
      193,
      218,
      224
    ],
    "source": "9781394330348"
  },
  {
    "id": 1182,
    "question": "The desktop computer you are troubleshooting will not boot. When you push the power button, no status light indicators come on, and you do not hear a fan. You verify that the outlet is working and try a power cord that you know works, but it doesn\u2019t help. Which component is most likely causing the problem?",
    "choice_a": "RAM",
    "choice_b": "PSU",
    "choice_c": "CPU",
    "choice_d": "HDD",
    "correct_answer": "B",
    "explanation": "If you try to power on the system but get no lights or fan, first check the obvious things. Is it plugged in? Does the cord work? Is the wall receptacle working properly? If those all check out, then it\u2019s probably the Power Supply Unit (PSU).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      201,
      190,
      188,
      196,
      193
    ],
    "source": "9781394330348"
  },
  {
    "id": 1183,
    "question": "While plugging in an older display with a VGA connector, a user bent some of the pins on the connector. You attempted to straighten them, but two of them broke off. If you use this display, what will most likely happen?",
    "choice_a": "It will work properly.",
    "choice_b": "It will display incorrect colors.",
    "choice_c": "It will display a distorted image.",
    "choice_d": "It will produce dim or flickering images.",
    "correct_answer": "B",
    "explanation": "A display can present incorrect colors if the pins on the connector are damaged, or if the connector isn\u2019t plugged all the way in. Depending on the exact pins that were damaged, you may have other issues like a distorted image or the monitor not working at all, but likely the colors will be incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      223,
      202,
      220,
      222,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1184,
    "question": "You have a macOS computer that is beeping during startup. It beeps once every five seconds. What do you need to do?",
    "choice_a": "Reseat the RAM if the model allows it.",
    "choice_b": "Replace the motherboard.",
    "choice_c": "Replace the video card.",
    "choice_d": "Nothing. It\u2019s updating firmware.",
    "correct_answer": "A",
    "explanation": "One beep every five seconds indicates that the Mac isn\u2019t detecting any Random Access Memory (RAM). Sometimes, RAM will creep out of place because of heating and cooling of the metal contacts. This might also happen if you just installed new RAM. Newer Mac computers have RAM soldered onto the motherboard, therefore they won\u2019t experience chip creep, and you won\u2019t be able to upgrade them either. (So, buy a Mac with as much memory as you can afford at the time.) If it\u2019s updating firmware, the Mac will beep three long, three short, and three long beeps. After a time, the Mac should start up normally. If it produces three beeps, a five-second pause, and three more beeps, then the RAM didn\u2019t pass its integrity check and needs to be reinstalled or replaced.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      196,
      199,
      193,
      190,
      195
    ],
    "source": "9781394330348"
  },
  {
    "id": 1185,
    "question": "You\u2019re troubleshooting a printing problem. The user selected to print in landscape mode in the software, but it comes out as a small box in the middle of a portrait-mode page. What can you do to attempt to fix this? (Choose two.)",
    "choice_a": "Tell the user to change their setting to portrait mode.",
    "choice_b": "Verify that the printer is set to print in landscape mode.",
    "choice_c": "Have the user select a different printer tray.",
    "choice_d": "Take the paper out of the printer tray, and turn it 90 degrees.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Depending on the printer and settings, either choosing a different tray or changing the printer settings may do the trick. The printer may be overriding the software settings. Most printers don\u2019t have a single automatic tray that lets you turn the paper 90 degrees (it\u2019s done using multiple trays), although some manual-feed trays will.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      241,
      240,
      188,
      190,
      236
    ],
    "source": "9781394330348"
  },
  {
    "id": 1186,
    "question": "Your child has a new inkjet printer. They\u2019ve been having fun printing all sorts of things, but today it\u2019s making a grinding noise and the printhead is not moving. What can you do quickly that might fix it? (Choose two.)",
    "choice_a": "Ensure that the cable moving the printhead moves freely.",
    "choice_b": "Check for blockages and debris.",
    "choice_c": "Replace the printer\u2019s ink ribbon.",
    "choice_d": "Replace the printhead.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Depending on your printer, there may be several reasons it\u2019s making a grinding sound, and the fixes vary by printer, but the two solutions here are fairly universal. If a cable moves along with the printhead, make sure that it is not caught on something or obstructed in some way. Check for any blockages or debris that may be preventing moving parts from moving. If those two things don\u2019t resolve the issue, refer to the manufacturer\u2019s documentation or online resources, as there are many different kinds and manufacturers of printers. Inkjet printers don\u2019t have ink ribbons, and you wouldn\u2019t replace the printhead without further troubleshooting first.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      235,
      236,
      193,
      190,
      189
    ],
    "source": "9781394330348"
  },
  {
    "id": 1187,
    "question": "Your company\u2019s advertising group is complaining that their printer is not printing the correct colors. Which of the following can you try to correct this problem? (Choose two.)",
    "choice_a": "Change the print orientation.",
    "choice_b": "Dispose of generic print cartridges, and use those made by the manufacturer for this printer.",
    "choice_c": "Reinstall the printer.",
    "choice_d": "Change the printer settings to better quality, not faster speed.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Sometimes, using off-brand ink and toner works just fine, and other times it doesn\u2019t. It may be close enough for most of us but not for an artist\u2019s eye. Try using ink or toner made specifically for that make and model of printer. Another quick fix is to ensure that the printer is defaulting to better quality, not faster speed. The exact steps to do that depend on the specific printer being used. Paper orientation has nothing to do with color, and you might need to reinstall a corrupted printer driver, but it\u2019s unlikely that you\u2019ll need to delete and reinstall the printer to correct a color problem.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      236,
      235,
      238,
      239,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1188,
    "question": "A laser printer you are servicing has been producing echo images. That is, regardless of whatever prints, you can always see a faint copy of a previous image that was printed. What can be causing this? (Choose two.)",
    "choice_a": "Dirty charging corona wire",
    "choice_b": "Broken cleaning blade",
    "choice_c": "Broken fusing assembly",
    "choice_d": "Bad erasure lamps",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Two things that can cause echoes are a broken cleaning blade and bad erasure lamps. A broken cleaning blade causes old toner to build up on the EP drum and consequently present itself in the next printed image. If the erasure lamps are bad, then the previous electrostatic discharges aren\u2019t completely wiped away. When the photosensitive drum rotates toward the developing roller, some toner sticks to the slightly discharged areas. A third cause can be printing many copies of a document without allowing the printer to cool off between. In that case, the toner can stick onto the fusing roller.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      239,
      238,
      188,
      190,
      237
    ],
    "source": "9781394330348"
  },
  {
    "id": 1189,
    "question": "The desktop computer you are troubleshooting will not boot. When you push the power button, no status light indicators come on, and you do not hear a fan. You verify that the outlet is working and try a power cord that you know works, but it doesn\u2019t help. What two things will you do next? (Choose two.)",
    "choice_a": "Push the power button in for 10 seconds.",
    "choice_b": "Check the I/O switch on the back of the PSU.",
    "choice_c": "Check the 115/220 switch on the back of the PSU.",
    "choice_d": "Reseat the motherboard\u2019s RAM.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The Input/Output (I/O) switch will not enable the Power Supply Unit (PSU) to power on if it is in the Off position; equally, the wrong voltage being selected may prevent the computer from starting, and if it does start, using the wrong voltage would have disastrous consequences. Note that not all PSUs support dual-input voltages, and some detect thevoltage automatically. Most often the voltage options are 110 or 220. The other two choices are irrelevant to the problem at hand.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      201,
      190,
      188,
      197,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1190,
    "question": "You just installed and configured a new WAP to provide better network connectivity in a remote part of the building. When you turn on your laptop to check the connectivity, there are only a couple of bars even though you\u2019re looking up at the WAP. What do you need to do?",
    "choice_a": "Increase the WAP\u2019s signal strength.",
    "choice_b": "Broadcast its WAP\u2019s SSID.",
    "choice_c": "Turn on the laptop\u2019s Wi-Fi.",
    "choice_d": "Adjust the WAP\u2019s antennas.",
    "correct_answer": "D",
    "explanation": "Improperly adjusted antennas can make a significant difference in wireless connectivity. In this case, take a few minutes and use a Wi-Fi analyzer to check the signal strength and adjust the antenna until it is just where you want it. You would not need to adjust the Wireless Access Point (WAP) signal strength because you\u2019re right under it, looking up at it. Even on the lowest power setting, you should still see more bars. The Service Set Identifier (SSID) being broadcast or not is irrelevant to the question being asked.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      210,
      229,
      217,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1191,
    "question": "A user complains of a burning smell coming from their desktop computer. You instruct them to immediately shut down the system. What should be your next step?",
    "choice_a": "Replace the power supply.",
    "choice_b": "Replace the motherboard.",
    "choice_c": "Test the power supply with a multimeter.",
    "choice_d": "Inspect the inside of the computer for visible signs of damage.",
    "correct_answer": "D",
    "explanation": "If you smell an odd odor or see smoke coming from a computer, shut it down immediately. Open the case and start looking for visible signs of damage. Things to look for include melted plastic components and burn marks on circuit boards. If components appear to be damaged, it\u2019s best to replace them before returning the computer to service.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      194,
      190,
      188,
      189,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1192,
    "question": "You have a Xerox color laser printer that makes a grinding noise when printing. What is the first thing you\u2019ll try to fix the problem?",
    "choice_a": "Replace the toner cartridge.",
    "choice_b": "Clean the printhead lenses.",
    "choice_c": "Cycle the power.",
    "choice_d": "Gently shake the toner cartridge.",
    "correct_answer": "C",
    "explanation": "Modern printers (called Multifunction Devices [MFDs]) are practically computers on their own. As such, like computers, restarting them will sometimes clear existing problems. If that fails, you could try the other three options, but refer to the individual printer manufacturer\u2019s troubleshooting procedures.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      190,
      188,
      237,
      239,
      240
    ],
    "source": "9781394330348"
  },
  {
    "id": 1193,
    "question": "The company\u2019s advertising department has been printing documents for an upcoming seminar all day. They\u2019ve called you because they noticed that the last few printouts have lighter images (echoes) of the print job displayed under the original one. What component will you clean or replace?",
    "choice_a": "The photosensitive drum",
    "choice_b": "The corona wire",
    "choice_c": "The fusing roller",
    "choice_d": "The HVPS",
    "correct_answer": "C",
    "explanation": "When the fusing assembly of a laser printer doesn\u2019t have a chance to cool off, toner can melt onto the overheated fusing roller, causing ghost images (also called double or echo images) to appear on the printed page. The roller will need to be cleaned or replaced. Replacing the photosensitive drum, corona wire, or High-Voltage Power Supply (HVPS) will not fix this problem.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      239,
      238,
      190,
      188,
      226
    ],
    "source": "9781394330348"
  },
  {
    "id": 1194,
    "question": "Users are printing to a laser printer, but nothing is coming out. When you look at the print queue, you see several jobs backed up. You try to restart them, but your mouse clicks aren\u2019t recognized. The printer is online, has paper, and says Ready. What should you do to resolve the problem?",
    "choice_a": "Turn the printer off and back on.",
    "choice_b": "Stop and restart the print spooler.",
    "choice_c": "Press the Reset button on the printer.",
    "choice_d": "Use the printer\u2019s display to clear out the oldest job, take it offline, and put it back online.",
    "correct_answer": "B",
    "explanation": "If jobs aren\u2019t printing and you\u2019re unable to perform any actions in the print queue, it could be that the print spooler service has stalled. To fix the problem, you need to stop and restart the print spooler service. This is done through your operating system. The downside is that the print jobs in the queue will be deleted, and users will need to reprint them. Unfortunately, if the print queue isn\u2019t responding, you must restart the print spooler service before you can do anything else.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      240,
      242,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1195,
    "question": "You are troubleshooting an inkjet printer. Users report that the printer is printing in the wrong colors. The problem just started happening recently. What could be causing it? (Choose two.)",
    "choice_a": "Incorrect paper",
    "choice_b": "Leaking ink cartridges",
    "choice_c": "Malfunctioning fusing assembly",
    "choice_d": "Malfunctioning stepper motor",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Sometimes, when you print a color document, the colors might not be the same colors that you expected based on what you saw on the screen. A few different issues could cause this problem. First, ink could be bleeding from adjacent picture areas, causing the color to be off. A leaking cartridge can cause this, as can using the wrong type of paper for your printer. Paper that is designed for an ink-jet printer has different characteristics than paper designed for a laser printer. You should always use the right paper for your type of printer to avoid problems like incorrect colors or ink bleeding into unintended areas. Second, it could be a dirty printhead. Try running the self-cleaning routine. If that doesn\u2019t work, consider replacing the ink cartridges with ink cartridges made by the printer\u2019s manufacturer.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      235,
      236,
      241,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1196,
    "question": "Lately, print jobs have been pulling multiple sheets of paper from the tray instead of just one. You\u2019ve verified that the paper is the correct weight and that the tray is properly adjusted, and you\u2019ve fanned the paper\u2019s edges, but it still happens. What component will you likely need to replace in the printer?",
    "choice_a": "Fusing assembly",
    "choice_b": "Paper tray",
    "choice_c": "Pickup roller or separation pad",
    "choice_d": "Printhead",
    "correct_answer": "C",
    "explanation": "If the pickup roller or separation pads get dirty or damaged, the result can be multiple pages picked up instead of just one at a time. To remedy the situation, either clean them or replace them. Pickup rollers and separation pads can be found on both laser and inkjet printers. The fusing assembly is part of a laser printer that has to do with melting toner on the paper, and a printhead can be found in both inkjet and impact printers but doesn\u2019t affect how many sheets of paper are picked up. It\u2019s unlikely that a paper tray would need replacing, and you\u2019ve already verified that it is properly adjusted.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      236,
      235,
      234,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1197,
    "question": "People are complaining that the output from the company\u2019s printer has little spots all over it, and it\u2019s been getting gradually worse. What will you do to correct this? (Choose two.)",
    "choice_a": "Replace the HVPS.",
    "choice_b": "Ensure that the correct paper is being used.",
    "choice_c": "Thoroughly clean the printer.",
    "choice_d": "Blow debris out of the printer with canned air.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The spots (speckling) are likely caused by dirt or debris in the printer, on the scanning tray, or in the Automatic Document Feeder (ADF). Replacing the High-Voltage Power Supply (HVPS) is not going to fix this problem, and you would never use compressed air to blow debris out of a printer. It may cause dust and debris to go even deeper into the device or contain an explosive material that shouldn\u2019t be used with electronics. Instead, follow the manufacturer\u2019s instructions for thoroughly cleaning all parts of the machine.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      236,
      239,
      238,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1198,
    "question": "A user is upset because their Android tablet does not ring whenever they receive a phone call. What is the first thing you should have them check?",
    "choice_a": "If the tablet is configured to receive voice calls",
    "choice_b": "If the tablet is in Airplane mode",
    "choice_c": "If the tablet is set to silent mode",
    "choice_d": "If the tablet\u2019s speakers are working in another application",
    "correct_answer": "C",
    "explanation": "There\u2019s probably a simple explanation for this one. The device may be in silent or vibrate mode. Most mobile devices will have a switch on the side that sets them to silent or vibrate mode, which will mute the device, preventing it from making a noise when it receives a call or a message. If that doesn\u2019t resolve the problem, it might also be a good idea to check their volume settings.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      189,
      188,
      191,
      226,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1199,
    "question": "A routine check of IOPS of your RAID array reveals that it has dropped significantly. What is the likely cause? (Choose two.)",
    "choice_a": "The HDDs were replaced by SSDs.",
    "choice_b": "Usage patterns have changed.",
    "choice_c": "The HDDs were replaced with M.2 drives.",
    "choice_d": "A drive in the array has failed.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "A significant change in usage patterns can affect the Input/Output Operations Per Second (IOPS) on the system based on the type/size of files being transferred and the software used to do it. If a drive in the array has failed, it will also affect the maximum IOPS the system is capable of, as there is one less drive to do the work.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      206,
      208,
      207,
      200,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1200,
    "question": "A user complains that they can barely see the image on their smartphone. Everything seems to work fine, but they can\u2019t see it. What will you do first?",
    "choice_a": "Check the brightness settings.",
    "choice_b": "Replace the display assembly.",
    "choice_c": "Turn on location settings.",
    "choice_d": "Replace the battery.",
    "correct_answer": "A",
    "explanation": "A dim or flickering screen can be a sign that the display assembly needs to be replaced. But before you go that route, it\u2019s best to check the brightness or auto-brightness features. Location settings and battery are irrelevant in this situation. The battery is still working because they can see something.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      223,
      189,
      190,
      228,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1201,
    "question": "The inkjet printer in your office is producing consistently faded prints. What should you do to resolve the problem?",
    "choice_a": "Replace the paper feed mechanism.",
    "choice_b": "Turn up the color dithering.",
    "choice_c": "Replace the ink cartridge.",
    "choice_d": "Adjust the printhead to be closer to the paper.",
    "correct_answer": "C",
    "explanation": "Faded prints generally mean the printer is running out of ink. Replace the ink cartridge, and the problem should disappear.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      235,
      190,
      188,
      191,
      236
    ],
    "source": "9781394330348"
  },
  {
    "id": 1202,
    "question": "The day after an electrical thunderstorm, you are troubleshooting a computer. After you power it up, it flashes information briefly on the screen and then reboots. It continuously reboots itself after this. Which components are most likely to cause this problem? (Choose two.)",
    "choice_a": "Hard drive",
    "choice_b": "Power supply",
    "choice_c": "Motherboard",
    "choice_d": "CPU",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "A failing motherboard or Central Processing Unit (CPU) often causes continuous reboots. A hard drive failure might give an error such as \u201cNo operating system found.\u201d If the power supply failed, the computer would not be booting at all.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      197,
      196,
      201,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1203,
    "question": "Within the last five minutes, several users in one part of the building have called in to report that they have lost their network connection. The connection had been working earlier in the day. What is most likely the cause of the problem?",
    "choice_a": "Faulty network card drivers",
    "choice_b": "Incorrect TCP/IP configuration",
    "choice_c": "Bad network cable",
    "choice_d": "Faulty switch",
    "correct_answer": "D",
    "explanation": "If the problem affects multiple users, chances are that it\u2019s an issue with the central connectivity device. Suspect an issue with the switch that the computers are plugged into, or a router port.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      216,
      190,
      188,
      212,
      211
    ],
    "source": "9781394330348"
  },
  {
    "id": 1204,
    "question": "A user reports that they cannot see their network shares or email, or even connect to the printer, but local applications are working fine. You ask what has changed since the last access, and the user mentions cleaning their desk. What is most likely the problem?",
    "choice_a": "The user might not have logged in.",
    "choice_b": "The printer, email, and file server could be offline.",
    "choice_c": "The network cable may not be connected.",
    "choice_d": "The Group Policy was reconfigured.",
    "correct_answer": "C",
    "explanation": "Given that the user recently cleaned their desk, it is likely cables were moved. The first thing to check would be the network cable. You know that they have logged into their computer because they are working locally. If the servers were offline or the problem was caused by a reconfigured Group Policy, you would receive other complaints.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      189,
      190,
      216,
      209,
      211
    ],
    "source": "9781394330348"
  },
  {
    "id": 1205,
    "question": "During a meeting, the manager mentions that the projector has been problematic since the start of the meeting. They tried running the projector from a few laptops with no success. Multiple popups were occurring, but it\u2019s unknown what the popup windows reported. What might be your next step?",
    "choice_a": "Open the log for information on failed jobs.",
    "choice_b": "Check the light source for failure.",
    "choice_c": "Verify that cables were attached.",
    "choice_d": "Allow the projector to cool down, and try again.",
    "correct_answer": "A",
    "explanation": "Opening the projector\u2019s log to review relevant information is a good step to take. From the description, it doesn\u2019t sound like the culprit is loose cables, lighting, or overheating.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      219,
      218,
      190,
      188,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1206,
    "question": "A user reports that the wireless Internet connection will randomly shut down in the afternoon. You check the Internet router by the window and find it still has power. What is the most likely cause of this problem?",
    "choice_a": "Network overloaded",
    "choice_b": "Printer queue full",
    "choice_c": "Wireless router overheating",
    "choice_d": "Workstation requires patching",
    "correct_answer": "C",
    "explanation": "The most likely explanation is that the wireless router is overheating. If it randomly shuts down in the afternoon, being in the sun may contribute to overheating. Also note that the sun provides electromagnetic energy, which can cause problems with some devices. For these reasons, it\u2019s best not to place electronic equipment in direct sunlight.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      226,
      194,
      229,
      189,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1207,
    "question": "Your client is running a RAID-6 array with twelve 16 TB HDDs, for a total capacity of 192 TB. They are complaining that the array\u2019s average IOPS isn\u2019t enough to keep up with company demands. How might you reconfigure or change the array for your client to maintain capacity but increase performance? (Choose two.)",
    "choice_a": "Buy a single 192 TB HDD.",
    "choice_b": "Reconfigure the array to be RAID-5.",
    "choice_c": "Replace the HDDs with SSDs",
    "choice_d": "Use six 32 TB HDDs instead of twelve 16 TB HDDs.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Reconfiguring the array to RAID-5 instead of RAID-6 would increase performance and available storage space but would provide less fault tolerance. RAID-6 is slower thanRAID-5 due to the extra parity stripe, and it requires a minimum of four drives instead of RAID-5\u2019s three drives. By changing to RAID-5 you\u2019re only able to lose one drive and still rebuild the array, whereas with RAID-6 you can lose two drives and still rebuild the array without having to recover from a backup. The question doesn\u2019t address fault tolerance, so changing from RAID-6 to RAID-5 would meet the requirements of better performance without losing storage space. Hard Disk Drives (HDDs) have a natural speed disadvantage compared to Solid-State Drives (SSDs) because of their moving parts, so replacing the HDDs with SSDs would maintain the capacity and increase performance. As hard drive storage gets bigger, the performance lag is exaggerated, so using a single large drive is a very bad idea. In addition to the higher performance lag, the fault tolerance would no longer exist. Again, the option to replace the existing HDDs with fewer and larger HDDs would make performance worse, not better. SSDs have no moving parts, so their latency is much lower. Either replacing the existing HDDs with a greater number of smaller drives or the same size of SSDs would increase the performance, but also the cost of the drives. Input/Output Operations Per Second (IOPS) is the best measure to use when comparing drive performance.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      206,
      208,
      207,
      200,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1208,
    "question": "A billing clerk just moved from their normal office out to a new office, which is separated from the loading dock by a cement block wall. The shipping clerk on the loading dock doesn\u2019t have a problem with wireless connectivity, but the billing clerk can\u2019t get reception in their new office. When they step out onto the loading dock, their laptop works just fine. Why are they losing connectivity in their office?",
    "choice_a": "They\u2019re too far from the WAP.",
    "choice_b": "The cement walls block the signal.",
    "choice_c": "The shipping clerk\u2019s PC interferes with the signal.",
    "choice_d": "The billing clerk accidentally turned off their Wi-Fi.",
    "correct_answer": "B",
    "explanation": "Wi-Fi signals can be blocked by thick walls, and concrete walls are very thick indeed. While the office might be a safe place for the billing clerk to work, the walls are blocking their Wi-Fi signal.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      229,
      210,
      216,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1209,
    "question": "Your spouse just began working from home. They\u2019ve decided that they like to work on the kitchen island, so they moved the router into the kitchen to get a better signal. Now the Wi-Fi connection gets dropped periodically no matter where they are in the home. What is going on?",
    "choice_a": "Your service provider is limiting the bandwidth.",
    "choice_b": "The router is old and needs replacing.",
    "choice_c": "The motors in the kitchen appliances are interfering with the Wi-Fi signal.",
    "choice_d": "Your spouse needs a better laptop to work from home.",
    "correct_answer": "C",
    "explanation": "Although your spouse may want a better laptop, if it was working fine before and the only thing that has changed is router placement, that\u2019s most likely the problem. Large motors and microwaves, among other things, can cause Electromagnetic Interference (EMI), which can wreak havoc on Wi-Fi signals. To solve the problem, move the router and work area to another location.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      210,
      229,
      190,
      191,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1210,
    "question": "You\u2019ve moved to a new two-story townhouse and are trying to decide where to put your router. The townhouse is a rather open concept with the dining room near its center. Which of the following options would be best?",
    "choice_a": "On a stand in the corner of the dining room.",
    "choice_b": "Next to the metal staircase, so there will be a good signal upstairs.",
    "choice_c": "Hide it behind the sofa.",
    "choice_d": "Set it on a sunny windowsill to reflect the signal back in.",
    "correct_answer": "A",
    "explanation": "Wi-Fi signals are radio waves and part of the electromagnetic spectrum. The metal staircase would act like an antenna, absorbing the energy of the signal. Sofas are thick and most have metal in them that will also absorb the signal. The sunny windowsill is out in the open, but sunlight (which is also on the electromagnetic spectrum) can interfere with radio signals too, and too much heat might damage the router. The best option here is on a stand in the corner of the dining room, which is in the center of the home. While you have chairs and a table there, there would likely not be as much furniture to block the signal as behind the sofa. Placement would, of course, depend on the exact situation.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      210,
      217,
      229,
      194,
      226
    ],
    "source": "9781394330348"
  },
  {
    "id": 1211,
    "question": "Your friend dropped their iPad, and it landed on its corner, on a rock. Now the screen has three large cracks from the corner radiating outward. The icons are still visible, and the Home button works, but the screen only responds in some places to touch, and they cut their fingers on the broken screen. What will you tell them? (Choose two.)",
    "choice_a": "Recycle it and get a new one.",
    "choice_b": "If possible, back up the device.",
    "choice_c": "The digitizer and glass need replacing.",
    "choice_d": "The display assembly needs replacing.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Newer iPads, like smartphones, have the display, digitizer, and glass front neatly bonded together, so if you must replace one, you must replace them all. If a backup has not been recently made and the device is still working, make one immediately. A bit of package sealing tape over the crack may keep it together until it can be repaired and keep your friend from cutting their finger again.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      228,
      230,
      189,
      191,
      233
    ],
    "source": "9781394330348"
  },
  {
    "id": 1212,
    "question": "A mobile phone user is unable to connect the phone to their wireless headset so they can make hands-free calls. Their iPhone screen is shown here. What is most likely the problem?<img src=\"/question_assets/220-1201/c05f002.png\" alt=\"Screenshot of an i O S device's control center overlaying the home screen, with Wi-Fi enabled and all other options disabled.\"/>\n\n<figcaption>Screenshot of an i O S device's control center overlaying the home screen, with Wi-Fi enabled and all other options disabled.</figcaption>",
    "choice_a": "Their wireless headset is turned off.",
    "choice_b": "Bluetooth is disabled.",
    "choice_c": "AirPlay is disabled.",
    "choice_d": "Airplane mode is enabled.",
    "correct_answer": "B",
    "explanation": "Most wireless headsets use a Bluetooth connection. The first thing to check is that Bluetooth is enabled, which also means double-checking that Airplane mode is not turned on. In this case, Bluetooth is off. AirPlay is specific to Apple devices, and it shares output with other Apple devices and compatible TVs, not headsets.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      229,
      191,
      190,
      225,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1213,
    "question": "You\u2019re considering storage devices for a RAID array. Some drives are HDD, and some are SSD. You need to balance drive speeds and price. What will you use to compare the drive speeds?",
    "choice_a": "RPM",
    "choice_b": "IOPS",
    "choice_c": "Mbps",
    "choice_d": "Gbps",
    "correct_answer": "B",
    "explanation": "Input/Output Operations Per Second (IOPS) is the only way to truly compare the speed when some drives are solid-state and others are mechanical. Mechanical drives often use Revolutions per Minute (RPM), which is also known as spindle speed, as an indication of how fast they can access data. Solid-State Drives (SSDs) have no moving parts, so there is no spindle speed. Regardless of the drive type, IOPS is a better way to compare drive performance, and the only way when they are not the same type of drive. Other factors to consider are how long the drive is expected to last and drive latency.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      206,
      208,
      233,
      194,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1214,
    "question": "You\u2019re at your favorite coffee shop. You want to use its Wi-Fi, but your smartphone didn\u2019t automatically connect like it usually does. What do you suspect?",
    "choice_a": "The coffee shop\u2019s WAP is down.",
    "choice_b": "Airplane mode is on.",
    "choice_c": "The coffee shop\u2019s DNS server is down.",
    "choice_d": "Your phone is damaged.",
    "correct_answer": "B",
    "explanation": "It\u2019s easy to accidentally bump the Airplane mode button on some smartphones. Airplane mode turns off cellular and Wi-Fi service on your device, so that it won\u2019t interfere with a plane\u2019s controls during takeoff and landing. Fortunately, turning off Airplane mode is equally easy.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      229,
      190,
      188,
      191,
      233
    ],
    "source": "9781394330348"
  },
  {
    "id": 1215,
    "question": "You\u2019re in an office building and need to make a phone call, but when you look at your phone, you have half a bar. What should you do?",
    "choice_a": "Ask to join the company\u2019s Wi-Fi, and use it to make a call.",
    "choice_b": "Move toward an outside wall.",
    "choice_c": "Move closer to the elevator.",
    "choice_d": "Go to a lower floor.",
    "correct_answer": "B",
    "explanation": "Multiple walls and floors between you and the outside world, not to mention all the electronic equipment found inside an office building, may be interfering with your signal. Move toward an outside wall or window away from the interfering walls and equipment to see if the connection improves.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      229,
      217,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1216,
    "question": "You are troubleshooting a computer with a RAID-0 array using four disks. One of the disks fails. What can you do to recover the array?",
    "choice_a": "Rebuild the failed disk, and restore it from backup.",
    "choice_b": "Replace the failed disk, and rebuild the array.",
    "choice_c": "Replace the failed disk, and restore it from backup.",
    "choice_d": "Remove the failed disk, and rebuild the array.",
    "correct_answer": "C",
    "explanation": "If you are using Redundant Array of Independent Disks, version 0 (RAID-0), which provides disk striping, you have increased performance but not fault tolerance. RAID-0 has more points of failure than a single drive would, meaning that you\u2019re at a greater risk of failure versus using just one hard drive. One drive failure will cause the entire set to fail. To recover it, your only option is to replace the failed disk and restore it from backup. You cannot rebuild the array as you can with RAID-1, RAID-5, RAID-6, or RAID-10.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      208,
      190,
      188,
      201,
      199
    ],
    "source": "9781394330348"
  },
  {
    "id": 1217,
    "question": "A user is trying to display a presentation on a projector, but nothing appears on the external screen. It looks fine on their laptop screen. They try toggling their LCD cutoff switch, and it doesn\u2019t help. Another user had just presented on the projector, and it worked fine. Which component is most likely causing the problem?",
    "choice_a": "Video card",
    "choice_b": "Display",
    "choice_c": "Video port",
    "choice_d": "Inverter",
    "correct_answer": "C",
    "explanation": "If the laptop won\u2019t output a screen image to an external display or projector, it means one of two things (assuming you know that the display or projector works): Either the external video port is malfunctioning, or the function keys aren\u2019t working. In either case, you likely need to replace the motherboard if you want the display to appear on an external device. It wouldn\u2019t be the laptop\u2019s video card or display because the laptop\u2019s display is working. An inverter is part of a Liquid Crystal Display (LCD) that doesn\u2019t use Light-Emitting Diodes (LEDs) for backlighting.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      218,
      202,
      219,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1218,
    "question": "The laser printer in your office is about eight years old. It seems to be printing slowly, and there are multiple jobs in the print queue. Recently, when you print, you occasionally get \u201cLow Memory\u201d error messages, and large print jobs sometimes won\u2019t print at all. What should you do to fix the problem?",
    "choice_a": "Stop and restart the print spooler.",
    "choice_b": "Implement printing priorities for the most important users.",
    "choice_c": "Upgrade the printer\u2019s memory.",
    "choice_d": "Upgrade the printer\u2019s hard drive.",
    "correct_answer": "C",
    "explanation": "If print jobs are processed very slowly or if you are continually seeing \u201cLow Memory\u201d error messages, it might be a good time to upgrade the memory in the printer.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      199,
      190,
      188,
      237,
      239
    ],
    "source": "9781394330348"
  },
  {
    "id": 1219,
    "question": "You are troubleshooting a recently installed three-disk RAID array. The original technician left notes that they were concerned about creating multiple points of potential failure in the system. Which type of RAID array creates more points of potential failure than a single hard drive?",
    "choice_a": "RAID-10",
    "choice_b": "RAID-1",
    "choice_c": "RAID-0",
    "choice_d": "RAID-5",
    "correct_answer": "C",
    "explanation": "If you are using Redundant Array of Independent Disks, version 0 (RAID-0), which provides disk striping, you have more points of failure than a single device, meaning that you\u2019re at a greater risk of failure versus using just one hard drive. One drive failure will cause the entire set to fail. If a single drive fails with RAID-1, RAID-5, RAID-6, or RAID-10, the system will not crash, and you can rebuild the failed drive from the information on the other drives. If the drives are hot-swappable, you may be able to do it without incurring any downtime.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      208,
      190,
      188,
      197,
      199
    ],
    "source": "9781394330348"
  },
  {
    "id": 1220,
    "question": "You\u2019ve been working a while and decide to restart your Windows computer, but instead of booting into the OS, the screen flashes on and off several times and seems to restart. What is likely happening?",
    "choice_a": "The OS is performing updates.",
    "choice_b": "The display is about to fail.",
    "choice_c": "The hard drive is about to fail.",
    "choice_d": "The display cable is loose.",
    "correct_answer": "A",
    "explanation": "If this happens, don\u2019t panic. Wait several minutes to see if it stops. Most likely the screen is flashing on and off several times because the Operating System (OS) is updating. Flashing could indicate a display that is failing; however, it was working fine before you restarted it, so it\u2019s more likely to be an update.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      195,
      190,
      188,
      222,
      224
    ],
    "source": "9781394330348"
  },
  {
    "id": 1221,
    "question": "You are troubleshooting a laser printer that keeps producing vertical black lines running down the page. Which component is most likely causing this problem?",
    "choice_a": "Fusing assembly",
    "choice_b": "Pickup rollers",
    "choice_c": "Exit rollers",
    "choice_d": "EP drum",
    "correct_answer": "D",
    "explanation": "A groove or scratch in the EP drum can cause the problem of vertical black lines running down all or part of the page. Because a scratch is lower than the surface, it doesn\u2019t receive as much (if any) of a charge as the other areas. The result is that toner sticks to it as though it were discharged. The groove may go around the circumference of the drum, so the line may go all the way down the page.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      239,
      238,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1222,
    "question": "The display on your laptop seems to go off and on whenever you move it. What\u2019s happening?",
    "choice_a": "The video cable is loose.",
    "choice_b": "The laptop is failing.",
    "choice_c": "The battery is failing.",
    "choice_d": "The motherboard is failing.",
    "correct_answer": "A",
    "explanation": "A loose video cable may be fine while you\u2019re stationary but wiggle enough to lose connection between the motherboard and display when the laptop is moved. Luckily, this is an easy fix. The video cable in a laptop is a very thin and delicate ribbon cable. Disassemble the laptop following manufacturer\u2019s instructions to the point where you can reseat the video cable, then carefully reseat it.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      202,
      222,
      197,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1223,
    "question": "Your employer has a heavily used conference room with a ceiling-mounted projector. The projector connects to users\u2019 laptops with an HDMI cable. Lately, users are complaining that no matter what computer is connected to the projector, the sound is muffled. What will you try first to fix it?",
    "choice_a": "Replace the lamp assembly.",
    "choice_b": "Replace the HDMI cable.",
    "choice_c": "Clean the speakers.",
    "choice_d": "Clean the lens.",
    "correct_answer": "B",
    "explanation": "High-Definition Multimedia Interface (HDMI) cables carry both video and audio signals. These cables can wear out over time from excessive use, plugging and unplugging, or excessive heat.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      224,
      188,
      190,
      219,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 1224,
    "question": "A day-long training is taking place in your company\u2019s conference room. The group took a break for lunch, and when they returned, the projector was off. The presenter has called you for help. What has most likely happened?",
    "choice_a": "The projector overheated.",
    "choice_b": "The projector entered standby.",
    "choice_c": "The power cable is loose.",
    "choice_d": "The lamp has burned out.",
    "correct_answer": "B",
    "explanation": "While an overheated projector will shut down, and a burned-out lamp will not project an image, the most likely cause in this scenario is that the projector simply went to sleep after a time of inactivity. Usually, touching the power button will wake it up again.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      219,
      218,
      190,
      191,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1225,
    "question": "You have just upgraded the RAM in a desktop computer. After you power on the computer, no video appears on the screen, and the computer produces a series of three long beeps. What does this indicate?",
    "choice_a": "The system BIOS detected an error in the POST routine.",
    "choice_b": "The system BIOS completed the POST routine normally.",
    "choice_c": "The RAM is faulty.",
    "choice_d": "The motherboard needs to be replaced.",
    "correct_answer": "A",
    "explanation": "Every computer has a diagnostic program built into its Basic Input/Output System (BIOS) called the Power-On Self-Test (POST). When you turn on the computer, it executes this set of diagnostics. If the computer doesn\u2019t perform the POST as it should, one way to determine the source of a problem is to listen for a beep code. This is a series of beeps from the computer\u2019s speaker. A successful POST generally produces a single beep. If there\u2019s more than one beep, the number, duration, and pattern of the beeps can sometimes tell you which component is causing the problem. Check the motherboard manufacturer\u2019s documentation to determine the specific issue.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      196,
      199,
      202,
      197,
      193
    ],
    "source": "9781394330348"
  },
  {
    "id": 1226,
    "question": "A user\u2019s Android phone has been crashing, and they complain that their data usage has gone way up, although their phone habits haven\u2019t changed. What will you suspect is the problem?",
    "choice_a": "Bad battery",
    "choice_b": "Water damage",
    "choice_c": "Malware",
    "choice_d": "Loose data cable",
    "correct_answer": "C",
    "explanation": "Repeated crashes and soaring data usage can both indicate malware on a phone. Typically, Android\u2019s Operating System (OS) security updates end three years after the OS release, and without security updates, an older device is more at risk of contracting malware. The best thing to do is go to the Google Play store and download anti-malware software to check the device. It might also be time to consider an upgrade.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      231,
      233,
      226,
      200,
      189
    ],
    "source": "9781394330348"
  },
  {
    "id": 1227,
    "question": "Your friend\u2019s home theater projector is turning off unexpectedly. Which one of the following is not a possible cause?",
    "choice_a": "The power cable is loose.",
    "choice_b": "The unit is overheating.",
    "choice_c": "The filter needs cleaning.",
    "choice_d": "The HDMI cable is loose.",
    "correct_answer": "D",
    "explanation": "A loose power cable can cause intermittent shutdown. Try reseating the cables. If the unit is overheating, it will shut down and not turn back on until it cools. Check to see if there is excessive dust on the cooling fan, and if so, clean it. Projectors also have a filter that may need periodic cleaning to avoid overheating. A loose HDMI cable would have other symptoms, such as a flickering image or distorted sound.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      219,
      194,
      201,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1228,
    "question": "Over time, the hard drive performance of your computer has gotten slower. A quick check of Performance Monitor shows that your disk read/writes are taking more time as compared to the baseline. What should you do to resolve this issue?",
    "choice_a": "Format the hard drive, and restore the data.",
    "choice_b": "Enable write caching on the drive.",
    "choice_c": "Delete the partition, create a new one, and restore the data.",
    "choice_d": "Runchkdsk.",
    "correct_answer": "B",
    "explanation": "The hard drive cache will hold information that is being used repeatedly, so it can be accessed more quickly, much like the cache on a processor. It also acts as a buffer between writing data and the hard drive, improving system performance. However, if the power goes out unexpectedly, data stored in the hard drive\u2019s cache will be lost.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      206,
      200,
      194,
      233,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1229,
    "question": "Your server\u2019s drive read/write times are a bottleneck in your system, and you\u2019re concerned about downtime in the event of a drive failure. Which of the following will improve performance and fault tolerance?",
    "choice_a": "Replace the HDD with an SSD.",
    "choice_b": "Install RAID-0.",
    "choice_c": "Install RAID-1.",
    "choice_d": "Install RAID-6.",
    "correct_answer": "D",
    "explanation": "Replacing the mechanical drives with Solid-State Drives (SSDs) will improve the performance, but not the fault tolerance of the system. Redundant Array of Independent Disks, version 0 (RAID-0), which provides disk striping, does the same. RAID-1(mirroring) will provide fault tolerance but does nothing to help performance. RAID-5 provides disk striping and parity. Striping improves system read/write speed. The parity means that if one drive crashes, the system can continue working until the drive is replaced. RAID-6 enables the system to recover from the failure of two drives, so although its performance is slightly less than RAID-5 because of the extra parity, it vastly increases fault tolerance and it\u2019s still faster than a single drive. RAID-5 isn\u2019t one of the options.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      208,
      206,
      207,
      203,
      200
    ],
    "source": "9781394330348"
  },
  {
    "id": 1230,
    "question": "A user complains of a loud whining noise coming from their computer. It occurs whenever the computer is on and is relatively constant. Which component is most likely to cause this problem?",
    "choice_a": "RAM",
    "choice_b": "SSD",
    "choice_c": "CPU",
    "choice_d": "PSU",
    "correct_answer": "D",
    "explanation": "The power supply is the only component listed with moving parts, and therefore is the most likely component to cause a whining sound. It\u2019s more than likely a fan. Either it needs to be cleaned (desperately) or replaced. Power supplies that are failing can also sound louder and quieter intermittently, because a fan will run at alternating speeds. If a power supply\u2019s functioning is questionable, it should be replaced because its failure or intermittent failure can cause problems with other devices.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      193,
      201,
      194,
      188,
      200
    ],
    "source": "9781394330348"
  },
  {
    "id": 1231,
    "question": "You are troubleshooting a computer that will not boot properly. When you power it on, it produces a series of beeps. Which components are most likely to be causing this to happen? (Choose two.)",
    "choice_a": "BIOS",
    "choice_b": "Hard drive",
    "choice_c": "Network card",
    "choice_d": "RAM",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Every computer has a diagnostic program built into its Basic Input/Output System (BIOS) called the Power-On Self-Test (POST). When you turn on the computer, it executes this set of diagnostics. The steps include checking the Central Processing Unit (CPU), checking the Random Access Memory (RAM), checking for the presence of a video card, and verifying basic hardware functionality. An error in the BIOS or in one of the checked components can cause a beep code.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      196,
      195,
      199,
      202,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1232,
    "question": "You are working on a laptop that appears to be frozen. You press the Num Lock key several times, but the indicator light remains on. What should you do to try to resolve this issue?",
    "choice_a": "Push and hold the power button until the laptop turns off, and reboot.",
    "choice_b": "Remove the battery and disconnect the laptop from an AC power source, and reboot.",
    "choice_c": "Press and hold the Num Lock key until the light turns off.",
    "choice_d": "Press Ctrl+Alt+Del to reboot the laptop.",
    "correct_answer": "A",
    "explanation": "If the laptop is locked up, the only way to reboot it is with a hard boot. Although removing all the power sources would work, it\u2019s not necessary to do so. Simply hold down the power button for about five seconds, and the laptop will power off. If that does not work, you might need to remove the power sources.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      188,
      190,
      225,
      193,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1233,
    "question": "A user reports that their mobile phone is extremely hot and appears to be locked up. What should you instruct them to do?",
    "choice_a": "Plug the phone into a wall outlet or USB port to charge it.",
    "choice_b": "Turn the phone off, and let it cool down.",
    "choice_c": "Perform a factory reset of the phone.",
    "choice_d": "Open the Power app, and set the phone to operate on the low-voltage setting.",
    "correct_answer": "B",
    "explanation": "If a mobile device is overheating, turn it off to let it cool down. (Most phones will automatically shut down if they\u2019re overheating.) Overheating could be from overuse, or perhaps the device was left in a hot environment or did not have proper ventilation. If it continues to overheat or does so for no reason, expect a problem with the battery, and if possible, replace the battery. If the battery can\u2019t be replaced, replace the phone.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      226,
      225,
      194,
      233,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1234,
    "question": "You have installed a PCIe RAID controller and want to create a RAID-5 array with three disks. You plug the disks in and boot up the computer. The RAID array is not detected. Where should you go to set up or troubleshoot the RAID array?",
    "choice_a": "Windows Device Manager",
    "choice_b": "Windows Disk Management",
    "choice_c": "The RAID controller\u2019s BIOS",
    "choice_d": "System BIOS/UEFI",
    "correct_answer": "C",
    "explanation": "Nearly all Peripheral Component Interconnect Express (PCIe) Redundant Array of Independent Disks (RAID) controllers will have their own Basic Input/Output System (BIOS) for setup, configuration, and troubleshooting. Some will have utilities available for use within an Operating System (OS) as well. If a motherboard has an onboard RAID controller, you will likely need to go to the BIOS or Unified Extensible Firmware Interface (UEFI) to configure it. Note that the question says the array isn\u2019t detected. It doesn\u2019t say the controller isn\u2019t detected.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      208,
      195,
      190,
      188,
      197
    ],
    "source": "9781394330348"
  },
  {
    "id": 1235,
    "question": "The desktop computer in your office\u2019s lobby plays a welcome video for guests. Recently, the audio started intermittently failing. You replaced the speakers, and it still happens. What is the next step you should take in troubleshooting the issue?",
    "choice_a": "Replace the motherboard.",
    "choice_b": "Reseat the speakers.",
    "choice_c": "Replace the sound card.",
    "choice_d": "Reseat the sound card.",
    "correct_answer": "D",
    "explanation": "One potential cause of intermittent device failures is chip creep, which happens when components such as expansion cards start to creep out of their socket. This can be caused by heating and cooling that happens when the equipment is running then shut down. Remove and reinstall (reseat) the card (and screw it into the case!) and see whether that resolves the issue. If not, you might need to replace the sound card.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      199,
      190,
      188,
      194,
      224
    ],
    "source": "9781394330348"
  },
  {
    "id": 1236,
    "question": "You have just used administrative privileges to install a printer on a user\u2019s workstation. When the user tries to print to the printer, they get an error message saying, \u201cAccess Denied.\u201d What is the cause of this problem?",
    "choice_a": "The printer is offline.",
    "choice_b": "The printer is out of memory.",
    "choice_c": "The print spooler needs to be restarted.",
    "choice_d": "The user does not have the security permissions to print.",
    "correct_answer": "D",
    "explanation": "In a networked environment, users need the proper permissions both to install and to print to the printer. Not having permission will result in access being denied.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      232,
      191,
      188,
      190,
      189
    ],
    "source": "9781394330348"
  },
  {
    "id": 1237,
    "question": "The inkjet printer in your office jams often and produces many crinkled papers. What is the most likely cause of this? (Choose two.)",
    "choice_a": "Incorrect paper",
    "choice_b": "Dirty printheads",
    "choice_c": "Obstructed paper path",
    "choice_d": "Paper that is too dry",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Printer jams (also known as \u201cThe printer crinkled my paper!\u201d) happen when something prevents the paper from advancing through the printer evenly. There are generally four causes of printer jams: an obstructed paper path, stripped drive gears, using the wrong paper, and excess humidity, which can make the paper swell and become less rigid.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      236,
      234,
      190,
      188,
      233
    ],
    "source": "9781394330348"
  },
  {
    "id": 1238,
    "question": "You are troubleshooting a laptop that has poor battery life. It will work for only about 30 minutes on a full charge. Which two things should you try first? (Choose two.)",
    "choice_a": "Replace the battery.",
    "choice_b": "Perform battery calibration.",
    "choice_c": "Drain the battery completely, and then charge it fully.",
    "choice_d": "Open the Power Management app, and set the laptop to run on low-energy mode.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Small devices sometimes suffer from an extremely short battery life. If it\u2019s a laptop, you might be able to perform battery calibration. For all mobile devices, you can try to drain the battery completely, and then charge it fully before turning the device back on. If these options don\u2019t work, then it\u2019s likely that the battery needs to be replaced.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      225,
      233,
      190,
      188,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1239,
    "question": "You have sent several print jobs to a networked printer, yet nothing has printed. You do not have printer administrator access. What can you do to see if your Windows computer is communicating properly with the printer?",
    "choice_a": "Send the print job in RAW format.",
    "choice_b": "Stop and restart the print spooler.",
    "choice_c": "Print a test page.",
    "choice_d": "Print a blank document from Notepad.",
    "correct_answer": "C",
    "explanation": "If your printer isn\u2019t spitting out print jobs, it may be a good idea to print a test page and see whether that works. The test page information is stored in the printer\u2019s memory, so there\u2019s no formatting or translating of jobs required. It\u2019s simply a test to make sure that your printer hears your computer. If the test page works but other print jobs don\u2019t print, there could be a problem with the application or the driver.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      190,
      188,
      237,
      242,
      240
    ],
    "source": "9781394330348"
  },
  {
    "id": 1240,
    "question": "A user reports that their two-year-old LCD display is unusually dim and flickering constantly. What is the easiest course of action to resolve this problem?",
    "choice_a": "Replace the video card.",
    "choice_b": "Replace the display.",
    "choice_c": "Remove external interference such as fans or motors.",
    "choice_d": "Degauss the display.",
    "correct_answer": "B",
    "explanation": "Modern Liquid Crystal Displays (LCDs) use Light-Emitting Diodes (LEDs) to provide backlighting. Dimness or flickering is most commonly caused by a problem with the power supply or failed LED strips. In those cases, if you have electronics and soldering knowledge, you could replace the LED strips, but the easiest course of action is to replace the display.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      222,
      223,
      201,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1241,
    "question": "You are having problems printing to a networked printer from your Windows workstation. Several jobs were sent, but none printed. You just tried to print a test page, and nothing came out. What should you do?",
    "choice_a": "Check your connections, and stop and restart the print spooler service.",
    "choice_b": "Turn the printer off and back on.",
    "choice_c": "Use the printer\u2019s display to clear out the oldest job, take it offline, and put it back online.",
    "choice_d": "Press the printer\u2019s Reset button.",
    "correct_answer": "A",
    "explanation": "If your printer isn\u2019t spitting out print jobs, it may be a good idea to print a test page and see whether that works. The test page information is stored in the printer\u2019s memory, so there\u2019s no formatting or translating of jobs required. If the test page works, then the problem is not communication between your PC and printer. If nothing happens, double-check your connections and stop and restart the print spooler service. If garbage prints, there is likely a problem with the printer or the print driver.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      240,
      242,
      190,
      188,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1242,
    "question": "A user reports that none of the keys on their laptop keyboard seem to work. They have rebooted the computer, and the problem has not gone away. They need to finish an important paper before lunch. What should you do next?",
    "choice_a": "Replace the keyboard.",
    "choice_b": "Check to ensure that the internal keyboard is still connected properly.",
    "choice_c": "Connect an external keyboard using the USB port.",
    "choice_d": "Clean under the keys of the keyboard with compressed air.",
    "correct_answer": "C",
    "explanation": "If a laptop keyboard is not responding, you can always plug in an external keyboard and use that. It might not be an ideal long-term solution, but it will generally get the user back up and running, and it\u2019s faster than troubleshooting the keyboard.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      227,
      191,
      189,
      188,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1243,
    "question": "At random times, your computer will completely lock up, requiring a hard reboot. Which two components are most likely to cause this type of problem? (Choose two.)",
    "choice_a": "CPU",
    "choice_b": "RAM",
    "choice_c": "PSU",
    "choice_d": "GPU",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The most likely components are the processor and the memory. Try reseating the chips or testing them. If the problems persist, you may need to replace those components. It could also be the motherboard.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      199,
      196,
      188,
      190,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1244,
    "question": "A user just replaced the toner cartridge in their laser printer. Now the printer only prints blank pages. What should you do to resolve the problem?",
    "choice_a": "Stop and restart the print spooler.",
    "choice_b": "Reinstall the printer driver.",
    "choice_c": "Replace the toner cartridge with a new toner cartridge.",
    "choice_d": "Remove the toner cartridge, remove the sealing tape, and then reinstall the cartridge.",
    "correct_answer": "D",
    "explanation": "Toner cartridges are often shipped with a strip of sealing tape across the cartridge to keep the toner from getting shaken out during shipment. If the user forgets to remove the tape, the printer will only print blank pages. The solution to this problem is fortunately quite easy. Remove the toner cartridge from the printer, remove the sealing tape, and reinstall the cartridge.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      238,
      189,
      191,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1245,
    "question": "A user reports that they are not able to install any apps on their mobile device. When you investigate, you notice that there is very little free space. What is the first solution to try?",
    "choice_a": "Add more RAM.",
    "choice_b": "Remove old files or unused applications.",
    "choice_c": "Restore the device to factory settings.",
    "choice_d": "Replace the device.",
    "correct_answer": "B",
    "explanation": "Fortunately with today\u2019s large capacity storage devices, this problem doesn\u2019t happen often. However, if a device\u2019s storage is too full and has less than ten percent free space, it can slow down dramatically. The first solution to try is to remove files and uninstall unused apps to free up space.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      232,
      233,
      200,
      189,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1246,
    "question": "A user complains that sometimes their computer will not open files, applications crash, and it happens in different programs, not just one. Which component is most likely to cause this problem?",
    "choice_a": "RAM",
    "choice_b": "CPU",
    "choice_c": "HDD/SSD",
    "choice_d": "Motherboard",
    "correct_answer": "C",
    "explanation": "A failure to open files means that the computer can\u2019t properly read those files. In most cases, this indicates an issue with the Hard Disk Drive (HDD) or Solid-State Drive (SSD). Problems with drives can also cause slow read/write or application speeds.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      207,
      206,
      203,
      200,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1247,
    "question": "A user calls the help desk to complain that they\u2019re getting an error message stating, \u201cSSID not found.\u201d Then you get a second call for the same reason. Both users were connected from the same locations the day before. What is most likely the problem?",
    "choice_a": "Low RF signal",
    "choice_b": "Oversaturated WAP",
    "choice_c": "Disabled SSID broadcast",
    "choice_d": "Nonfunctioning WAP",
    "correct_answer": "D",
    "explanation": "Suspect that the Wireless Access Point (WAP) has failed. A low Radio Frequency (RF) signal would show fewer bars but should still be able to connect to the WAP, especially if they did the day before. An oversaturated WAP would show sluggish performance and dropped packets. The Service Set Identifier (SSID) broadcast shouldn\u2019t be the issue because they\u2019ve connected to this network before and likely have saved the network to their device. Because there is more than one user, the problem probably isn\u2019t the individual user. It is, most likely, that the WAP has failed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      229,
      190,
      188,
      210,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1248,
    "question": "You have just installed a printer on a client computer. When you print to the printer, the output is completely garbled characters. What is the most likely cause of this problem?",
    "choice_a": "The print spooler",
    "choice_b": "The printer\u2019s memory",
    "choice_c": "The printer driver",
    "choice_d": "The print queue",
    "correct_answer": "C",
    "explanation": "The correct printer driver needs to be installed for the printer and operating system. For example, if you have an HP LaserJet Pro M15w and a Windows 11 computer, you need to install an HP LaserJet Pro M15w driver made for Windows 11. If this is not done, you will likely get garbled characters out of the printer. Often, the Windows Operating System (OS) will have adequate drivers for your printer, but the manufacturer\u2019s driver downloads often come with other software that provides additional features for you to use with your printer, and if the output is garbled, then you certainly want to use the manufacturer\u2019s printer drivers, not those provided with Windows.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      188,
      190,
      235,
      236,
      241
    ],
    "source": "9781394330348"
  },
  {
    "id": 1249,
    "question": "A user\u2019s laptop computer does not display anything on the screen, although the power light and other indicator lights are on. You plug in an external display, and after you toggle the LCD cutoff switch, an image appears on the external display. Which component is most likely causing the problem?",
    "choice_a": "Video driver",
    "choice_b": "Backlight",
    "choice_c": "Display",
    "choice_d": "Video card",
    "correct_answer": "C",
    "explanation": "If a laptop does not display any video, it could be the screen or the video card/integrated video. To test it, plug in an external display (that you know works) and use the function keys on the laptop to switch to external video output. If that doesn\u2019t work, it\u2019s likely that the video card is defective. If the external display works, you know it\u2019s a problem with the display on the laptop. The backlight (or inverter) could be dead, or it could be that the screen has become disconnected.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      202,
      218,
      222,
      223,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1250,
    "question": "You have an Android phone that\u2019s running very slowly. The apps aren\u2019t working as quickly as they used to, but you still have plenty of free memory. You have rebooted the phone several times, and it\u2019s still slow. You tried running only one app at a time, and it\u2019s still slow regardless of what app you\u2019re running. You\u2019ve run a malware-removal tool. What should you try next?",
    "choice_a": "Hold the Power button and the Home button simultaneously for 10 seconds, and the phone will reset.",
    "choice_b": "Back up the phone, and then reset it to factory specifications.",
    "choice_c": "Uninstall and reinstall all apps.",
    "choice_d": "Get a new phone.",
    "correct_answer": "B",
    "explanation": "If the phone is extremely slow but isn\u2019t completely locked up, isolate the issue. Is it one app or overall performance? It could be that apps are running in the background and need to be closed. Shutting down those apps or powering the device off and then back on is a good step. You can also check to see how much memory is available. If it\u2019s one app giving you problems instead of the entire device, look for updates to the app or delete and reinstall the app. The symptom could also indicate malware. Use a malware removal tool. Finally, if none of these steps works, perform a restore to factory settings. If the problems persist, it\u2019s time for a new device.",
    "topic_id": 5,
    "practice_test_id": 10,
    "related_articles": [
      233,
      231,
      190,
      188,
      226
    ],
    "source": "9781394330348"
  },
  {
    "id": 1251,
    "question": "You have installed an internal Redundant Array of Independent Disks (RAID) controller and configured a RAID-5 array on it with four physical drives. It has been operating normally. Today, when you boot up, you receive an error message saying, \u201cMissing RAID array.\u201d Which components are most likely causing this issue? (Choose two.)",
    "choice_a": "One of the four drives",
    "choice_b": "The RAID controller",
    "choice_c": "The system BIOS/UEFI",
    "choice_d": "The onboard SATA controller",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "If the system had been operating normally but now tells you that the Redundant Array of Independent Disks (RAID) array is not found, it\u2019s likely something is wrong with one of the drives or the RAID controller. The RAID array was working fine yesterday, so it\u2019s not likely to be the Basic Input/Output Settings (BIOS), although that\u2019s a possibility. It\u2019s also not likely to be a drive controller on the motherboard, although that\u2019s also possible if the motherboard has been damaged. A drive failure or RAID controller failure is most likely. (My bet would be the controller.) Double-check to ensure that the RAID controller BIOS is configured properly, and that everything is connected as it should be.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      208,
      203,
      207,
      195,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1252,
    "question": "You have a laptop with a dead hard drive. You want to replace it with a newer SSD but have a few concerns. What disadvantage do SSDs have versus HDDs?",
    "choice_a": "They produce more heat.",
    "choice_b": "They are slower.",
    "choice_c": "They are more susceptible to damage.",
    "choice_d": "They cost more per gigabyte.",
    "correct_answer": "D",
    "explanation": "Solid-state drives (SSDs) have many advantages over hard disk drives (HDDs), including producing less heat, retrieving data faster, and being less susceptible to damage from shock or overheating. However, they are more expensive per gigabyte.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      34,
      33,
      35,
      4,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 1253,
    "question": "Your friend is an artist, and they have recently purchased a new convertible laptop. It can be used as a regular laptop or it can be folded into a tablet computer. You\u2019ve recommended they purchase a stylus to use with their new computer. Which of the following is not an advantage of a stylus?",
    "choice_a": "They don\u2019t leave greasy fingerprints on your screen.",
    "choice_b": "There are never compatibility issues.",
    "choice_c": "They can make more precise lines than fingers can.",
    "choice_d": "You can use them in cold weather and have gloves on your hands.",
    "correct_answer": "B",
    "explanation": "There are many benefits to using a stylus with your touchscreen computer. Using a stylus can aid artists in being more precise in their art than is possible using fingertips. Styli are more sanitary than fingers and don\u2019t leave behind the oils that your skin would on the touchscreen. Their use makes it easier to create handwritten notes than simply using your fingers. Not every stylus is compatible with every touchscreen, so you must know what kind of touchscreen you have to ensure that your stylus is compatible with it. Most touchscreens are capacitive, which means that the stylus must be constructed so that it will interrupt an electrostatic field. Resistive screens only register pressure and are better for uses such as making lines darker in a drawing program. Almost any material can be used to make a stylus. A stylus can connect via a USB port or wirelessly using Bluetooth.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      70,
      66,
      71,
      64,
      65
    ],
    "source": "9781394330348"
  },
  {
    "id": 1254,
    "question": "In a tablet computer with an LCD, which component is responsible for providing the right kind of energy to light the display?",
    "choice_a": "Inverter",
    "choice_b": "LCD",
    "choice_c": "Backlight",
    "choice_d": "Screen",
    "correct_answer": "A",
    "explanation": "Fluorescent lighting, and liquid crystal display (LCD) backlights in particular, require fairly high-voltage, high-frequency energy. The component that provides the right kind of energy is the inverter, which is a small circuit board installed behind the LCD panel that takes direct current (DC) and inverts it to alternating current (AC) for the backlight. An inverter is not needed in a display that uses LED backlighting because LEDs use DC just like motherboards do.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      49,
      41,
      47,
      48,
      54
    ],
    "source": "9781394330348"
  },
  {
    "id": 1255,
    "question": "You\u2019re hiking in the mountains and have brought along a mobile device that has an app with all local trail maps on it to ensure that you don\u2019t get lost. You look at the map and notice that the blue dot indicating where you are hasn\u2019t moved since you left home. What do you need to enable in your mobile device for the app to work properly?",
    "choice_a": "Airplane mode",
    "choice_b": "GPS",
    "choice_c": "Wi-Fi",
    "choice_d": "Location services",
    "correct_answer": "D",
    "explanation": "Location services on your device may use the global positioning system (GPS), which relies on satellites, Bluetooth, Wi-Fi, or cellular location services to determine your approximate location. Location services can be enabled, disabled, or conditionally enabled for different apps on your phone that need the service to function properly. Airplane mode turns off all network connectivity.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      167,
      165,
      166,
      159,
      162
    ],
    "source": "9781394330348"
  },
  {
    "id": 1256,
    "question": "What protocol/type of protocol guarantees delivery of a packet of information across a network (or networks) and will resend the packet if its arrival is not acknowledged? (Choose two.)",
    "choice_a": "TCP",
    "choice_b": "UDP",
    "choice_c": "Connectionless",
    "choice_d": "Connection-oriented",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Protocols are either connection-oriented, meaning they will guarantee delivery, or connectionless, meaning they will not guarantee delivery. Connectionless protocols are used for activities such as streaming, where a missing packet here and there is less important than continuing to send the information. Connection-oriented protocols are used when it is important that each packet arrives. Some connection-oriented protocols are Transmission Control Protocol (TCP), Hypertext Transfer Protocol Secure (HTTPS), and Secure Shell (SSH) Protocol, whereas User Datagram Protocol (UDP), Dynamic Host Configuration Protocol (DHCP), and Trivial File Transfer Protocol (TFTP) are examples of connectionless protocols.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      117,
      120,
      106,
      129
    ],
    "source": "9781394330348"
  },
  {
    "id": 1257,
    "question": "Which two port numbers need to be opened to enable communications for FTP?",
    "choice_a": "20/21",
    "choice_b": "21/22",
    "choice_c": "22/23",
    "choice_d": "23/25",
    "correct_answer": "A",
    "explanation": "File Transfer Protocol (FTP) uses ports 20 and 21. Port 22 is used by Secure Shell (SSH), port 23 is/was used by Telnet, and port 25 is used by Simple Mail Transfer Protocol (SMTP). Note that Telnet is insecure and has been deprecated.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      128,
      121,
      155,
      119
    ],
    "source": "9781394330348"
  },
  {
    "id": 1258,
    "question": "Which Internet appliance stands between a PC and the Internet and can include stateful packet inspection (i.e., packet filtering) and act as a gateway translating traffic between networks or protocols? (Choose two.)",
    "choice_a": "Spam gateway",
    "choice_b": "Unified Threat Management (UTM)",
    "choice_c": "Load balancers",
    "choice_d": "Proxy servers",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "A unified threat management (UTM) appliance is a single device on your network that provides multiple security functions. It is usually placed between the outside world and the local area network (LAN), so it can function as a gateway as well as a security appliance. A proxy server can be a very powerful force for good on your network. Proxy servers can be a firewall blocking traffic based on port number. They can also inspect packets for objectionable content or malware. They can even work as a cache for frequently visited websites, and because all traffic goes through the proxy server into and out of your network, they are the default gateway. A spam gateway is software that is used for filtering spam out of email. A load balancer appliance is used in an environment where there are multiple servers to distribute the workload across those servers instead of it all going to one.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      135,
      155,
      124,
      125,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 1259,
    "question": "In IPv6, which of the following identifies the multicast range?",
    "choice_a": "::1",
    "choice_b": "2001;dba:45c:1::5/64",
    "choice_c": "FE80::abc:1:2/64",
    "choice_d": "FF00::/8",
    "correct_answer": "D",
    "explanation": "The FF00::/8 range in IPv6 is for multicasts. Remember that IPv6 does not use broadcasts. The closest IPv6 gets is the use of multicast addresses. The::1 is the loopback address for IPv6. IP addresses that begin with 2001 are in the global unicast range, meaning that they are routable on the Internet, and the first 64 bits identify the network. Any number that starts with FE80 is non-routable and is called a link-local address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      123,
      118,
      106,
      121
    ],
    "source": "9781394330348"
  },
  {
    "id": 1260,
    "question": "Several Bluetooth devices are connected in an ad hoc (without a hub, switch, or WAP) network. Which acronym best describes this type of network?",
    "choice_a": "LAN",
    "choice_b": "WAN",
    "choice_c": "PAN",
    "choice_d": "MAN",
    "correct_answer": "C",
    "explanation": "A personal area network (PAN) is a small-scale network designed around one person within a limited boundary area. The term generally refers to networks that use Bluetooth technology. A local area network (LAN) connects devices in a small area, such as a house or business or a single floor in an office building. A wide area network (WAN) covers a very large geographic area, traversing many roads or areas not owned by the entity, and it may use leased lines. The Internet is a worldwide WAN, but a WAN can also connect a single company with offices in New York, Chicago, and D.C., for example. A metropolitan area network (MAN) connects devices in a smaller geographic area, such as a city or community.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      99,
      145,
      102,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 1261,
    "question": "Users on your network complain of poor wireless network access in a certain part of your building. They say that the connection is slow and disconnects frequently. You are using 802.11ac wireless routers and access points. What tool should you use to troubleshoot the situation?",
    "choice_a": "Wi-Fi analyzer",
    "choice_b": "Loopback plug",
    "choice_c": "Tone generator and probe",
    "choice_d": "Multimeter",
    "correct_answer": "A",
    "explanation": "A wireless locator or a Wi-Fi analyzer can be either a handheld hardware device or specialized software that is installed on a laptop or smartphone, and its purpose is to detect and analyze Wi-Fi signals. A loopback plug is used to test a network interface card (NIC). A toner probe (or tone generator and probe) is used to find a wire out of a bunch of wires or to figure out where the wire runs. A multimeter has many uses, among them is testing for continuity, checking power supplies, and checking electrical wall outlets.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      142,
      138,
      139,
      154,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 1262,
    "question": "What type of audio/video connector is shown in the graphic?<img src=\"/question_assets/220-1201/c10f001.png\" alt=\"Close-up of a rectangular electronic connector with multiple pins arranged in two rows.\"/>\n\n<figcaption>Close-up of a rectangular electronic connector with multiple pins arranged in two rows.</figcaption>",
    "choice_a": "DisplayPort",
    "choice_b": "DVI",
    "choice_c": "HDMI",
    "choice_d": "VGA",
    "correct_answer": "C",
    "explanation": "The image shown is a high-definition multimedia interface (HDMI) cable. HDMI carries audio and video signals in a digital format. A DisplayPort connector is angled on one side, not both. DisplayPort connectors are intended for video only but can also carry audio signals. DisplayPorts provide a digital connection. A digital video interface (DVI) connector is rectangular with 24 pins on the left side in eight rows of three, and four pins on the right, arranged in a square. By definition, a DVI is digital, but there are DVI-A connectors that are analog, and integrated DVI (DVI-I) connectors that are both analog and digital, whereas DIV-D connectors are strictly digital. The number and arrangement of pins changes, depending on which type of DVI connector is being used. A video graphics array (VGA) connector has a total of 15 pins arranged in three rows. VGA is strictly video and transmits only an analog signal.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      60,
      61,
      62,
      63,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 1263,
    "question": "The computer users in your accounting department have called you stating that their laser printer keeps jamming and have asked that you resolve the issue. Which of the following are common reasons for jamming that you can check? (Choose two.)",
    "choice_a": "Incorrect paper thickness or the tray is too full",
    "choice_b": "Ink cartridges need cleaning",
    "choice_c": "Debris in the paper path",
    "choice_d": "Printhead needs cleaning",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "There are several reasons that paper might jam in a laser printer: if you buy the least expensive paper and it\u2019s the wrong weight or coating for the printer, debris in the paper path such as dust and pieces of paper, paper with wrinkles or bent corners, too much humidity causing sheets to stick together, and worn paper feed rollers. Ink cartridges are used in inkjet printers, not laser printers, and printheads are found in impact and thermal printers, not laser printers.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      239,
      238,
      237,
      235,
      236
    ],
    "source": "9781394330348"
  },
  {
    "id": 1264,
    "question": "About four computer users in the HR area of the building are complaining that their Wi-Fi connection is very slow. You use your Wi-Fi analyzer and find out that they are on the same channel as your neighbors in the office next door. What can you do?",
    "choice_a": "Set the radio signal to maximum.",
    "choice_b": "Change the channel that the WAP uses.",
    "choice_c": "Add another WAP.",
    "choice_d": "Check the cable from the WAP to the router.",
    "correct_answer": "B",
    "explanation": "The best option to try first is changing the channel that the wireless access point (WAP) uses to connect. The intermittent connections could be caused by interference with the neighboring Wi-Fi. Turning up the power on your WAP would only make the crossover more between your Wi-Fi and the neighbor\u2019s Wi-Fi, increasing the interference and slowing the connection even more. Adding another WAP might help if the problem was too many users, but with only four users in that area, it\u2019s not that. You could check the cable connecting the WAP to the router, if changing the channel doesn\u2019t resolve the issue.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      210,
      229,
      188,
      191,
      217
    ],
    "source": "9781394330348"
  },
  {
    "id": 1265,
    "question": "Which type of connector, shown in the graphic, is used for network connections?<img src=\"/question_assets/220-1201/c10f002.png\" alt=\"Close-up of two ethernet cables with connectors.\"/>\n\n<figcaption>Close-up of two ethernet cables with connectors.</figcaption>",
    "choice_a": "RJ11",
    "choice_b": "RJ45",
    "choice_c": "F-type",
    "choice_d": "ST",
    "correct_answer": "B",
    "explanation": "An registered jack 45 (RJ45) connector is used to terminate Ethernet cables used in local area networks (LANs). It has eight wires. An RJ11 connector is narrower than an RJ45 because it only has four wires. RJ11 is used for landline telephones. An F-type connector is used for cable television transmission, satellite television connections, and cable modems. It has a twist-on connector with a solid pin in the middle and is used with coaxial cables. A straight tip (ST) connector has a bayonet-type plug and socket. It is used with fiber-optic cable, and if bidirectional signals are needed, two cables and two connectors are needed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      29,
      63,
      90,
      62,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 1266,
    "question": "You\u2019re reading the documentation for a desktop motherboard, which says it uses 240-pin DIMMs. What type of DIMM does it use?",
    "choice_a": "DDR3",
    "choice_b": "DDR4",
    "choice_c": "DDR5",
    "choice_d": "SODIMM",
    "correct_answer": "A",
    "explanation": "Double data rate 3 dual in-line memory modules (DDR3 DIMMs) have 240 pins, double data rate 4 (DDR4) and double data rate 5 (DDR5) both have 288 pins, and a small outline dual in-line memory module (SODIMM) is not a type of desktop random access memory (RAM); it is used in laptops.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      18,
      16,
      6,
      15,
      26
    ],
    "source": "9781394330348"
  },
  {
    "id": 1267,
    "question": "You don\u2019t have enough ports on your laptop for all the devices that you want to connect. What should you purchase?",
    "choice_a": "Port replicator",
    "choice_b": "Trackpad",
    "choice_c": "Docking station",
    "choice_d": "Stylus",
    "correct_answer": "A",
    "explanation": "One simple way to add ports is to use a port replicator, sometimes sold as a \u201chub.\u201d It usually plugs into one USB-C port and supplies multiple USB-C ports. A trackpad is a surface, usually on a laptop, that enables the user to move their finger(s) either across it or in pinch-and-spread fashion, to control the mouse. A stylus looks like a pen but has a special tip and is used with a touchscreen to control a mouse. A docking station is a bit different than a port replicator, although the terms are often used interchangeably. A docking station replicates the functions of the ports on the back of a laptop, so that peripherals, such as displays, keyboards, printers, and so on, that don\u2019t travel with thelaptop can remain connected to the dock and don\u2019t all have to be unplugged physically whenever the laptop is removed. Docking stations effectively turn a laptop computer into a desktop computer, and the docking station may offer its own devices, such as an optical drive and speakers. It may have a generic connector such as a universal serial bus (USB) USB-C or a proprietary connector. Docking station can also refer to a charging cradle for a smartphone or tablet to plug in vertically that provides other functions such as built-in speakers for music playback or a clock. This differs from a port replicator, whose main function is to let the user connect several devices at once and doesn\u2019t require the laptop to be connected to offer that connectivity between the devices.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      70,
      71,
      64,
      65,
      66
    ],
    "source": "9781394330348"
  },
  {
    "id": 1268,
    "question": "A user reports that their smartphone will not make any sounds. They have turned the phone off and back on, and the problem is still there. You check the settings, and the phone is not in silent mode and the volume is set to maximum. What can you do to fix this problem?",
    "choice_a": "Reset the phone to factory specifications.",
    "choice_b": "Replace the speakers.",
    "choice_c": "Replace the sound card.",
    "choice_d": "Replace the phone.",
    "correct_answer": "D",
    "explanation": "If the device does not produce sound, first ensure that it\u2019s not set to silent operation. Most mobile devices will have a switch on the side that users can set to silent or vibrate mode, which will mute the device and keep it from making noises. Also check settings for volume as well as the possible redirection of sound, such as an active Bluetooth pairing. If the speakers have failed on a mobile device, it\u2019s time for a new device. You could try cycling the power on the phone, or the other options listed as possible answers, but they likely won\u2019t work.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      224,
      229,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1269,
    "question": "A laser printer you are working on is producing images with vertical black streaks running the length of the page. Which of the following could be causing this? (Choose two.)",
    "choice_a": "There is a scratch in the EP drum.",
    "choice_b": "The fusing assembly is not heating up properly.",
    "choice_c": "The paper exit rollers are worn.",
    "choice_d": "The charging corona wire is dirty.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A groove or scratch in the EP drum can cause the problem of vertical black lines running down all or part of the page. Because a scratch is lower than the surface, it doesn\u2019t receive as much (if any) of a charge as the other areas. The result is that toner sticks to it as though it were discharged. The groove may go around the circumference of the drum, so the line may go all the way down the page. Another possible cause of vertical black lines is a dirty charging corona wire, which prevents a sufficient charge from being placed on the EP drum. Because the charge on the EP drum is almost zero, toner sticks to the areas that correspond to the dirty areas on the charging corona. The symptom displayed when a fusing assembly isn\u2019t heating properly is toner sliding off the page when the paper is removed from the printer. Worn exit rollers might cause a paper jam, but not lines down every page.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      239,
      190,
      188,
      237,
      238
    ],
    "source": "9781394330348"
  },
  {
    "id": 1270,
    "question": "The motherboard documentation you are reading says that the RAM modules for this motherboard must be purchased in identical sets of four. What type of motherboard is this?",
    "choice_a": "Dual channel",
    "choice_b": "Triple channel",
    "choice_c": "Quad channel",
    "choice_d": "Single channel",
    "correct_answer": "C",
    "explanation": "Some motherboards support accessing more than one random access memory (RAM) module at a time. When that is the case, we say that the motherboard has multiple channels. Typically, you will purchase identical RAM modules in quantities that match the number of channels there are. In this case, the documentation says to purchase RAM in identical sets of four, so you can assume it is a quad-channel motherboard. Dual would require identical sets of two, and triple would require identical sets of three, although triple channel motherboards were only popular for a brief period of time.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      6,
      19,
      16,
      20,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 1271,
    "question": "You have installed an 802.11ac Wi-Fi network. The network has three overlapping wireless access points. What channel width should the access points be set to in order to avoid communications problems while providing the best bandwidth?",
    "choice_a": "20 MHz",
    "choice_b": "40 MHz",
    "choice_c": "80 MHz",
    "choice_d": "It doesn\u2019t matter in 802.11ac.",
    "correct_answer": "B",
    "explanation": "An 802.11ac network operates in the 5 GHz band, and can be 20, 40, or 80 MHz wide. With the 80 MHz channel width, there are effectively two channels: channel 36\u201348 and channel 149\u2013161. Because you have three access points, you should use the 40 MHz channel width, which provides four possible channels: 36\u201340, 44\u201348, 149\u2013153, and 157\u2013161. The 20 MHz channel width provides nine channels, but you don\u2019t need that many, and the narrower channel width would decrease the performance per client. The 20 MHz channels are 36, 40, 44, 48, 149, 153, 157, 161, and 165.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      154,
      138,
      107,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 1272,
    "question": "A user complains that their desktop computer randomly shuts down. No error messages are displayed before it happens, and there is not a specific program that triggers the reboot. Which of the following components is most likely to be causing this problem?",
    "choice_a": "RAM",
    "choice_b": "Storage drive",
    "choice_c": "BIOS/UEFI",
    "choice_d": "Network adapter",
    "correct_answer": "A",
    "explanation": "Memory problems can cause system lockups, unexpected shutdowns or reboots, or errors such as the dreaded blue screen of death (BSOD) in Windows or the rotating/spinning pinwheel in macOS. Issues with a central processing unit (CPU) can also cause intermittentrebooting. BIOS/UEFI, network adapters, and storage drives would produce different symptoms than those in the question.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      199,
      190,
      194,
      196,
      200
    ],
    "source": "9781394330348"
  },
  {
    "id": 1273,
    "question": "A user calls the Help Desk to report that their display is black. It was working yesterday, but when the desktop computer was booted this morning, nothing showed on the display. They did hear a beep like normal when the computer booted up. What is the first thing you should do?",
    "choice_a": "Reseat the plug on the video card.",
    "choice_b": "Replace the video card.",
    "choice_c": "Ask the user to press the display\u2019s power button.",
    "choice_d": "Refresh the operating system.",
    "correct_answer": "C",
    "explanation": "When troubleshooting, always start with simple things first. It would not be the first time that a display had been inadvertently turned off. If that doesn\u2019t resolve it, check the cabling to ensure that nothing is loose, check display settings to ensure that the brightness isn\u2019t turned all the way down, and whether the display is using the correct input if it has more than one.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      189,
      190,
      202,
      223,
      218
    ],
    "source": "9781394330348"
  },
  {
    "id": 1274,
    "question": "In your company\u2019s lobby, there is a desktop computer with an LCD that plays a continuous loop of a welcome video. The display is enclosed in a cabinet. Recently, the display shuts itself down near the end of the day for no apparent reason. What is likely causing this problem?",
    "choice_a": "Backlight failure",
    "choice_b": "Incorrect video resolution",
    "choice_c": "Display card failure",
    "choice_d": "Display overheating",
    "correct_answer": "D",
    "explanation": "Displays may have their own internal power supply, and they all have internal circuitry, which means they can overheat. Ensure that the air vents on the back of the display are free of both dust and debris. In this case, removing the display from the cabinet might help to increase cooling air flow to the display. If the problem persists, it\u2019s best to replace the display. The other options would exhibit different symptoms.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      194,
      219,
      226,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1275,
    "question": "Your pet\u2019s veterinarian has implanted a microchip under their skin so that if your pet is lost, whoever finds the pet can take them to almost any veterinarian and the pet\u2019s name as well as your name and contact information can be read from the microchip using a special reader device. This tag does not provide GPS tracking. What type of technology is in this chip?",
    "choice_a": "NFC",
    "choice_b": "RFID",
    "choice_c": "HDD",
    "choice_d": "GPU",
    "correct_answer": "B",
    "explanation": "Radio frequency identification (RFID) tags have numerous uses, including tagging pets to locate the owners when the pet is lost. Near-field communication (NFC) technology is also used to transfer data over a small distance, but that technology is not used in animal tags. Hard disk drives (HDDs) and graphics processing units (GPUs) are found inside computers, not inside a pet, unless of course the pet is a robot.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      106,
      108,
      145,
      100,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 1276,
    "question": "The design of the micro-ATX motherboard makes which of the following statements true?",
    "choice_a": "It will fit in standard ATX cases.",
    "choice_b": "It will fit in standard ATX cases when used with a mounting adapter kit.",
    "choice_c": "It will fit in standard ATX cases but can\u2019t support full-length expansion cards.",
    "choice_d": "It will not fit in standard ATX cases.",
    "correct_answer": "A",
    "explanation": "The micro-advanced technology extended (ATX) form factor is designed to work in standard ATX cases as well as its own smaller cases, with no adapter or special cards required.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1,
      6,
      19,
      43,
      21
    ],
    "source": "9781394330348"
  },
  {
    "id": 1277,
    "question": "You are examining an existing coaxial cable installation and notice that the previous technician installed a splitter. Which of the following statements is true?",
    "choice_a": "The splitter will cause the network connection to fail.",
    "choice_b": "The splitter will increase the distance the network signal will travel.",
    "choice_c": "The splitter will degrade the quality of the network signal.",
    "choice_d": "The splitter will have no effect on the network signal.",
    "correct_answer": "C",
    "explanation": "Splitters generally have two effects on a coaxial cable: They degrade the signal and limit the distance the signal will travel. Avoid using them whenever possible.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      40
    ],
    "source": "9781394330348"
  },
  {
    "id": 1278,
    "question": "A desktop computer will not retain the system time or date. The user always needs to reset them after the system is powered off. What should you do to fix the problem?",
    "choice_a": "Flash the BIOS/UEFI.",
    "choice_b": "Replace the BIOS/UEFI chips.",
    "choice_c": "Replace the CMOS battery.",
    "choice_d": "Use the jumper on the motherboard to reset the BIOS/UEFI to factory settings.",
    "correct_answer": "C",
    "explanation": "If a computer is a few years old, the basic input/output system/unified extensible firmware interface (BIOS/UEFI) may fail to retain your computer\u2019s settings, such as time and date and hard drive configuration. The BIOS/UEFI uses a small, flat, 3-volt battery (much like a watch battery) on the motherboard to help it retain settings when the system power is off. If this battery fails, the BIOS/UEFI won\u2019t retain its settings. Simply replace the battery with the same type to solve the problem. There is usually a number printed on top of the battery, such as CR2032 or 2035 so you know which one to get. You would not flash the BIOS to fix this problem, and BIOS/UEFI chips are not user replaceable. Resetting the BIOS/UEFI jumper on the motherboard will clear the settings, which is what you\u2019re trying to avoid.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      195,
      197,
      190,
      188,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1279,
    "question": "A new technician trainee just turned a computer on, and it beeped once. They had heard about motherboard beep codes and ask you what that single beep means. What will you tell them?",
    "choice_a": "Bad RAM",
    "choice_b": "CPU issue",
    "choice_c": "Video isn\u2019t working",
    "choice_d": "POST completed successfully",
    "correct_answer": "D",
    "explanation": "When the power-on self-test (POST) completes successfully, most motherboards will emit a single beep to let you know. If it doesn\u2019t turn on normally after one beep, or multiple beeps, refer to the motherboard manufacturer\u2019s documentation, but continuous beeps are usually a RAM issue, and a series of long and short beeps are usually a video issue. Some motherboards have status indicator lights on the motherboard instead of beep codes. If it\u2019s the CPU, it usually just won\u2019t start.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      196,
      199,
      202,
      193,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1280,
    "question": "A user has turned in a tablet computer that has a swollen battery. What should you do to resolve the problem?",
    "choice_a": "Turn the tablet off, let it cool down, and then return it to the user.",
    "choice_b": "Order a new tablet for the user, drain the excess electrolyte from the battery, and then dispose of the defective one in the trash.",
    "choice_c": "Order a new tablet for the user, and take the defective one to a recycling center.",
    "choice_d": "Order a new tablet for the user, and throw the defective one in the trash.",
    "correct_answer": "C",
    "explanation": "If you have a swollen battery, turn the device off immediately and ensure that it\u2019s not plugged into a charger. It might be possible to remove the battery, but swollen batteries are more prone to explosions than normal ones because the casing is already compromised, and most batteries in small devices are not user replaceable. The best course of action is topurchase a new device. Take the battery or device to a proper recycling center to dispose of it. Never just throw it in the trash because it can explode and harm sanitation workers as well as cause significant environmental damage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      71,
      65,
      64,
      68,
      69
    ],
    "source": "9781394330348"
  },
  {
    "id": 1281,
    "question": "You have multiple web servers and want to ensure that the web traffic is equally distributed between them to maintain fast response times. What network appliance will you employ to achieve the desired result?",
    "choice_a": "Spam gateway",
    "choice_b": "Proxy server",
    "choice_c": "Load balancer",
    "choice_d": "UTM",
    "correct_answer": "C",
    "explanation": "A load balancer distributes requests among different servers. One of the main reasons for using a load balancer is to improve server response times, whether the servers support a website or internal data. Not surprisingly, spam gateways detect and block spam. A proxy server usually serves as the gateway between networks or a network and the Internet and will filter traffic based on various user specified criteria. Unified threat management (UTM) combines multiple security features such as a firewall, anti-malware, packet filtering, intrusion detection services (IDS), and intrusion protection services (IPS) all in a single network appliance or software.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      135,
      137,
      102,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 1282,
    "question": "Your motherboard supports up-plugging for PCIe adapter cards. Which of the following statements is true?",
    "choice_a": "You can\u2019t put an x8 card into an x16 slot.",
    "choice_b": "You can put an x8 card into an x16 slot, but it will run at x1 speed.",
    "choice_c": "You can put an x8 card into an x16 slot, but it will run at x8 speed.",
    "choice_d": "You can put an x8 card into an x16 slot, and it will run at x16 speed.",
    "correct_answer": "C",
    "explanation": "The x8 card won\u2019t completely fill the x16 slot, but it will work at x8 speeds if up-plugging is supported by the motherboard. Otherwise, the specification requires up-plugged devices to operate at only the x1 rate.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      2,
      27,
      30,
      35,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 1283,
    "question": "Your company needs a fast Internet connection, so it has purchased a fiber-optic connection from an ISP. You need to connect your router to the ISP using an Ethernet cable. Where will this connection take place?",
    "choice_a": "At the DSL",
    "choice_b": "At a NIC",
    "choice_c": "At a PoE",
    "choice_d": "At the ONT",
    "correct_answer": "D",
    "explanation": "An optical network terminal (ONT) is usually a box on the outside of a building where a fiber-optic line connects to a network. The ONT will have fiber-optic connections, Ethernet (RJ45) connections, and perhaps others. It also contains a transducer that converts the flashes of light from the fiber-optic cable to pulses of electricity needed by the Ethernet cable.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      113,
      112,
      116,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 1284,
    "question": "Your coworker needs to transfer files from a mobile device using a memory card reader and an SD memory card. They quickly discover that the maximum capacity on their SD card is 1 TB. Which technology does the coworker have?",
    "choice_a": "SD",
    "choice_b": "SDXC",
    "choice_c": "SDHC",
    "choice_d": "SDLC",
    "correct_answer": "B",
    "explanation": "Currently there are three form factors for secure digital (SD) cards; they are SD, MiniSD, and MicroSD. The cards also come in different capacities and filesystems as follows:Secure Digital (SD): 2 GB or less, FAT12 or FAT16Secure Digital High Capacity (SDHC): 2 GB to 32 GB, FAT32Secure Digital Extended Capacity (SDXC): 32 GB to 2 TB, exFATSecure Digital Ultra Capacity (SDUC): 2 TB to 128 TB, exFAT.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      38,
      4,
      34,
      36,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 1285,
    "question": "A user reports that when they press the L key on their laptop keyboard, the L character repeats across the screen and doesn\u2019t stop until the L key is pressed several more times. When you look at the laptop, it does not appear that the key is physically sticking. What should you do next?",
    "choice_a": "Replace the keyboard.",
    "choice_b": "Replace the L key.",
    "choice_c": "Clean under the key with compressed air.",
    "choice_d": "Reboot the laptop.",
    "correct_answer": "D",
    "explanation": "If a key on the laptop keyboard is stuck, you need to determine whether the contact is having problems or whether the key itself is stuck. If the key is not physically stuck but the laptop thinks it is, rebooting generally solves the problem.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      227,
      190,
      188,
      189,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1286,
    "question": "You\u2019re working on a stormy night and the power in your house goes out, but your cellular service (i.e., smartphone) is working. You have a report on your laptop that absolutely must be submitted tonight, and luckily your laptop is fully charged. What can you do to submit your report?",
    "choice_a": "Connect your laptop to your car\u2019s antenna to send via Wi-Fi.",
    "choice_b": "Use your smartphone\u2019s hotspot feature.",
    "choice_c": "Go out in the storm and drive to the nearest place with power that has public Wi-Fi.",
    "choice_d": "Call and let them know that the report won\u2019t be submitted because your power is out.",
    "correct_answer": "B",
    "explanation": "The hotspot feature available on virtually all smartphones will enable you to connect other devices to the Internet via the cellular tower system. Typically, you turn the hotspot feature on in the phone\u2019s settings. It will display a wireless password and allow you to connect wirelessly via Wi-Fi or Bluetooth or connect physically via universal serial bus (USB) by connecting a cable between your laptop and phone. The downside of using your smartphone as a hotspot is that it eats up data quickly and could be expensive if you don\u2019t have unlimited data on your cellular plan.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      162,
      163,
      171,
      159
    ],
    "source": "9781394330348"
  },
  {
    "id": 1287,
    "question": "You have determined that you need to replace the Wi-Fi antenna in your laptop. Where will you most likely find it?",
    "choice_a": "In the housing with the display",
    "choice_b": "Under the keyboard",
    "choice_c": "Under a removable panel on the back/bottom of the laptop",
    "choice_d": "Plugged into a USB port",
    "correct_answer": "A",
    "explanation": "Most laptop antennas connect to the main board and have wires that run up the sides of the display. Occasionally, you might find one on the mainboard. Modern laptops typically don\u2019t have removable areas on the bottom/back like legacy laptops do. If a laptop\u2019s antenna quits working, one option is to purchase a Wi-Fi network card that plugs into an external port, such as a universal serial bus (USB) port.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      66,
      65,
      64,
      71,
      67
    ],
    "source": "9781394330348"
  },
  {
    "id": 1288,
    "question": "Which of the following are common components of cloud storage applications that can be used to store and synchronize data on all of your devices, including smartphones, laptops, desktop computers, and other devices? (Choose three.)",
    "choice_a": "Calendar",
    "choice_b": "Contacts",
    "choice_c": "Microsoft 365 Copilot",
    "choice_d": "Cloud Mail",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Calendar, Contacts, Mail, and storage are common components of cloud applications that enable you to synchronize information across your devices. Microsoft 365 Copilot, Google, and other companies provide could application services.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      185,
      186,
      182,
      180,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1289,
    "question": "You pay a premium for faster Internet service at home but have noticed that the download times have slowed considerably, and you see a spinning wheel indicating slow downloads more than normal. What is likely the problem?",
    "choice_a": "You have reached a data cap.",
    "choice_b": "You didn\u2019t pay your last bill, so they\u2019re slowing the service down.",
    "choice_c": "You\u2019re synchronizing too much data all at once.",
    "choice_d": "The Internet is down.",
    "correct_answer": "A",
    "explanation": "Most Internet Service Providers (ISPs) offer faster Internet access for a premium price, but they also put a cap on that service, and although they won\u2019t turn your service off, they may slow it down when you reach that cap.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      148,
      156,
      150,
      147,
      149
    ],
    "source": "9781394330348"
  },
  {
    "id": 1290,
    "question": "You have a small office with frequent visitors and want to provide a separate VLAN to segregate the visitor traffic from your network traffic for security reasons. What is the minimum connectivity device needed to accomplish this?",
    "choice_a": "Hub",
    "choice_b": "Bridge",
    "choice_c": "Managed switch",
    "choice_d": "Unmanaged switch",
    "correct_answer": "C",
    "explanation": "To segregate a local area network (LAN) into two virtual LANs (VLANs), you would need a managed switch. Managed switches contain software that allows for port configuration, diagnostics, and monitoring situations, such as port flapping. An unmanaged switch is simply a connectivity device. It can\u2019t be used to segregate ports into separate VLANs. A bridge is used to aggregate two or more networks into one. A hub is simply a connectivity device that is a single collision domain, whereas each port on a switch (managed or not) is its own collision domain. Hubs are seldom found on networks now, but they are often used to provide multiple ports for a single connection on a computer, such as a USB port. Note that some routers have the ability to create a VLAN by using different IP address ranges, but more often a switch is used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      125,
      106,
      99,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 1291,
    "question": "You are creating a virtual machine (VM) host that will support multiple VMs. The host software will be installed directly on the computer hardware, not in an operating system. What type of hypervisor is being used?",
    "choice_a": "Type 1",
    "choice_b": "Type 2",
    "choice_c": "Sandbox",
    "choice_d": "Storage",
    "correct_answer": "A",
    "explanation": "A Type 1 hypervisor is also called a bare metal hypervisor, because it is installed directly on the hardware and not within an operating system (OS) such as Microsoft Windows. Type 2 requires an operating system for installation. Virtual machines (VMs) can be used to create a sandbox, which is a network or system for testing software or configuration changes, or even malware, without compromising the live network. Storage is simply space in RAM or on a drive where data is kept.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      176,
      174,
      175,
      178,
      179
    ],
    "source": "9781394330348"
  },
  {
    "id": 1292,
    "question": "Which of the following IP addresses is not routable on the Internet?",
    "choice_a": "192.169.1.1",
    "choice_b": "192.168.1.1",
    "choice_c": "168.192.1.1",
    "choice_d": "169.192.1.1",
    "correct_answer": "B",
    "explanation": "Private IP addresses are not routable on the Internet. The following are the IPv4 private address ranges and non-routable number ranges, with the/nindicating the bits in the subnet mask that identify the network portion of each group:10.0.0.0\u201310.255.255.255/8 (Class A)172.16.0.0/16\u2013172.31.255.255/12 (Class B)192.168.0.0\u2013192.168.255.255/16 (Class C)169.254.0.0\u2013169.254.255.255 (APIPA)127.0.0.1 (Loopback address).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      123,
      122,
      155,
      121
    ],
    "source": "9781394330348"
  },
  {
    "id": 1293,
    "question": "When setting up your network, you configured your clients to obtain IP addressing information automatically from a DHCP server. You set the group of numbers that it can assign from 192.168.100.11 to 192.168.100.211. What is this group of assignable numbers called?",
    "choice_a": "APIPA",
    "choice_b": "Leases",
    "choice_c": "Scope",
    "choice_d": "Reservations",
    "correct_answer": "D",
    "explanation": "A Dynamic Host Configuration Protocol (DHCP) server can be configured to provide all required and optional Transmission Control Protocol/Internet Protocol (TCP/IP) configuration information to clients. This includes an IP address, subnet mask (for IPv4), default gateway, and Domain Name System (DNS) server address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      124,
      123,
      122
    ],
    "source": "9781394330348"
  },
  {
    "id": 1294,
    "question": "You\u2019re considering setting up a WISP. What is an advantage of using an unlicensed frequency versus using a licensed frequency?",
    "choice_a": "The frequencies are not congested.",
    "choice_b": "The radiated power is unlimited by regulations.",
    "choice_c": "The performance is better than licensed frequencies.",
    "choice_d": "Equipment is readily available.",
    "correct_answer": "D",
    "explanation": "There are advantages and disadvantages to using the unlicensed frequency bands. Advantages include equipment is widely available and inexpensive, there are no fees for using the unlicensed spectrum, and its use is widespread, so information is available tohelp set one up. The disadvantages of using the unlicensed frequency spectrum are that it is congested (because it\u2019s free) and many places regulate how powerful the signal can be.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      99,
      141,
      142,
      147
    ],
    "source": "9781394330348"
  },
  {
    "id": 1295,
    "question": "What type of port is shown in the graphic?<img src=\"/question_assets/220-1201/c10f003.png\" alt=\"Close-up of a port with horizontal stripe and two screws.\"/>\n\n<figcaption>Close-up of a port with horizontal stripe and two screws.</figcaption>",
    "choice_a": "USB-C",
    "choice_b": "Molex",
    "choice_c": "SC",
    "choice_d": "LC",
    "correct_answer": "A",
    "explanation": "The port shown in the graphic is a universal serial bus Type C (USB-C) port. It is identical in shape to a lightning port. A Molex connector is a type of 4-pin power connector used for legacy hard drives and some motherboard and expansion card power connections. The subscriber connector (SC) and Lucent connector (LC) are used for fiber-optic connections. An SC is about twice the size of the LC connector. Both have square housing. The SC uses a small locking tab, and the LC uses a locking latch to hold it in place.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      63,
      61,
      60
    ],
    "source": "9781394330348"
  },
  {
    "id": 1296,
    "question": "Which of the following would most likely use NVMe technology?",
    "choice_a": "5,400 rpm drive",
    "choice_b": "HDD",
    "choice_c": "mSATA",
    "choice_d": "M.2",
    "correct_answer": "D",
    "explanation": "Nonvolatile memory express (NVMe) is a driver and communication interface for Peripheral component interconnect express (PCIe)-based solid-state drives (SSDs). It uses the PCIe bus but can be in PCIe, M.2, and U.2 form factors. It transfers data much faster than the advanced host controller interface (AHCI) that was used for serial advanced technology attachment (SATA). Both AHCI and NVMe SSDs can use the PCIe slot and M.2 connectors on motherboards, so it\u2019s important to know whether the M.2 connector supports AHCI, NVMe, or both. U.2 is only NVMe, but it isn\u2019t on the CompTIA A+ objectives. SATA will use the AHCI interface, even if it\u2019s connected to an M.2 slot on the motherboard. Mini SATA (mSATA) is a different form factor and can\u2019t be used in an M.2 slot.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      35,
      36,
      34,
      2,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 1297,
    "question": "Which level of RAID will provide both better performance and fault tolerance with the fewest drives possible?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "C",
    "explanation": "Redundant array of independent disks (RAID) level 0 is disk striping and provides improved performance but no fault tolerance. RAID 1, mirroring, provides fault tolerance but no improvement in performance. Both RAID 0 and RAID 1 require two drives. RAID 5 provides both fault tolerance and enhanced performance and requires a minimum of three drives. RAID 10 (or 1+0) is a stripe of mirrored drives and provides both fault tolerance and enhanced performance but requires a minimum of four drives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      37,
      34,
      33,
      35,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 1298,
    "question": "You purchased an expansion card for your desktop that fits in a PCIe x1 slot. The documentation says that the card supports USB 3.0 with a 5 Gbps maximum transfer rate. What version of PCIe is the card?",
    "choice_a": "PCIe 1.0",
    "choice_b": "PCIe 2.0",
    "choice_c": "PCIe 3.x",
    "choice_d": "PCIe 4.x",
    "correct_answer": "B",
    "explanation": "Mini PCIe cards running in PCIe 1.0 x1 mode have a maximum speed of 2.5 Gbps per lane. Each send and receive pair in Peripheral Component Interconnect Express (PCIe) is a lane, and PCIe can have 1, 2, 4, 8, 12, or 16 lanes. PCIe that uses one lane is noted as PCIe x1, two lanes are x2, and so on. Successive versions of PCIe have increased the speed per lane. PCIe 2.0 speed per lane is 5 Gbps, 3.xis 8 Gbps, and 4.xis 16 Gbps per lane. Those speeds are the bandwidth, the theoretical speeds, but the actual throughput will be slightly less.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      2,
      56,
      30,
      35,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 1299,
    "question": "A user complains of a burning smell coming from their computer. After shutting it down, you notice that the motherboard has burn marks on it. You replace the motherboard. The next day, the user complains again of a burning smell, and you see this motherboard is burnt as well. What should you do next?",
    "choice_a": "Replace the motherboard.",
    "choice_b": "Replace the power supply.",
    "choice_c": "Replace the motherboard and power supply.",
    "choice_d": "Plug the computer into a different wall outlet.",
    "correct_answer": "C",
    "explanation": "If you have scorch marks on a component, say a video card or a motherboard, it could be that the specific component has gone bad. It could also be a sign of a problem with the power supply. If you see a component with a burn mark, it would be a good idea to test the power supply as well. Not all power supply problems will show up by using a tester, so if you replace the component and a similar problem occurs, definitely replace the power supply as well as the damaged component.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      201,
      197,
      188,
      190,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1300,
    "question": "You are installing an ATX12V (sometimes called ATX2) power supply with a 24-pin main power connector. Which of the following is not a voltage provided by the power supply?",
    "choice_a": "\u22123.3 VDC",
    "choice_b": "+5 VDC",
    "choice_c": "+12 VDC",
    "choice_d": "\u221212 VDC",
    "correct_answer": "A",
    "explanation": "Power supplies convert the volts of alternating current (VAC) from a wall outlet into volts of direct current (VDC) that computers can use. ATX12V power supplies provide the following voltages for the computer: +3.3 VDC, +5 VDC, +12 VDC, and \u221212 VDC. Older (ATX) power supplies that have a 20-pin main power connector also supply \u22125 VDC. Power supplies use shapes as keys so connectors can\u2019t be plugged in incorrectly. Manycompanies also have proprietary power supplies, meaning that you must replace their power supply with an identical one, because they don\u2019t match the standard.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      41,
      43,
      42,
      44,
      47
    ],
    "source": "9781394330348"
  },
  {
    "id": 1301,
    "question": "You have a Windows 11 desktop computer that is connected directly to your office printer. Your office is running a workgroup (not a domain). You want to share the office printer with a new user. What are two places you can do this? (Choose two.)",
    "choice_a": "Search for printers, right-click the desired printer, and choose Share.",
    "choice_b": "In the Settings app, choose Bluetooth & Devices and then Printers & Scanners. Select the printer to share, and then, on the window that displays, choose Printer Properties, and choose the Sharing tab.",
    "choice_c": "In the Control Panel, choose Devices and Printers, which will take you to Bluetooth & Devices in the Settings app.",
    "choice_d": "In Device Manager, click the printer and select the Sharing tab.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A local printer can easily be shared with other people in your workgroup. Simply navigate to the Printer properties, which can be accomplished in various ways, and choose the Sharing tab.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      92,
      31,
      89,
      90,
      91
    ],
    "source": "9781394330348"
  },
  {
    "id": 1302,
    "question": "Your company produces software and employs about 20 developers. They need to program apps for different operating systems. You decide to purchase cloud-based services to support the development team. What type of service should you purchase so that they can develop their programs and then test them in environments other than where they were developed?",
    "choice_a": "IaaS",
    "choice_b": "SaaS",
    "choice_c": "PaaS",
    "choice_d": "NaaS",
    "correct_answer": "C",
    "explanation": "Platform-as-a-Service (PaaS) adds a layer to Infrastructure-as-a-Service (IaaS) that includes software development tools, such as runtime environments. Because of this, it can be helpful to software developers; the vendor manages the various hardware platforms. This frees up the software developers to focus on building their application and scaling it. The best PaaS solutions allow for the client to export its developed programs and run them in an environment other than where they were developed. Software-as-a-Service (SaaS) provides access to applications online, and Network-as-a-Service (NaaS) provides a scalable network infrastructure.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      182,
      180,
      175,
      177,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1303,
    "question": "Your RAID array is beeping steadily. What could be the problem? (Choose two.)",
    "choice_a": "Faulty NIC",
    "choice_b": "Controller problem",
    "choice_c": "Failed VM",
    "choice_d": "Missing or nonworking drive",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "If your redundant array of independent disks (RAID) system is beeping steadily, it\u2019s warning you that there is a problem with the array. It might be the controller, but it\u2019s more likely that the problem is a failed drive. You might have to replace a drive or rebuild the array, depending on how the RAID is configured.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      203,
      208,
      196,
      193,
      207
    ],
    "source": "9781394330348"
  },
  {
    "id": 1304,
    "question": "What feature of cloud computing means that you can expand your network immediately as needed?",
    "choice_a": "Shared resources",
    "choice_b": "Metered utilization",
    "choice_c": "Elasticity",
    "choice_d": "File synchronization",
    "correct_answer": "C",
    "explanation": "Elasticity is one of the greatest benefits of cloud computing. You can add servers or network components as needed, on the fly. Shared resources are what makes rapid elasticity possible. Metered utilization means you pay for what you use, and file synchronization keeps your files up to date across different devices.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      183,
      180,
      182,
      185,
      178
    ],
    "source": "9781394330348"
  },
  {
    "id": 1305,
    "question": "A client complains about the occupied space, profuse power usage, and hardware costs of the multiple machines used in its small data center. Still, the client does not wish to lose control over any of the machines. What might you recommend to the client to resolve all of those issues?",
    "choice_a": "Establish clusters for high availability.",
    "choice_b": "Create virtual machines.",
    "choice_c": "Outsource to an IaaS provider.",
    "choice_d": "Shut down the nonessential machines.",
    "correct_answer": "B",
    "explanation": "The creation of virtual machines (VMs) would alleviate the issue of space, power, and most of the hardware costs associated with maintaining individual computer systems. VMs can provide the same functionality at a fraction of the cost by enabling a single set of hardware to provide much of the computing power needed. Control and management of the machines would remain with the company.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      174,
      176,
      178,
      180,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1306,
    "question": "A computer is making a grinding noise and is working but seems to be very slow in accessing information. Which component will you likely need to replace?",
    "choice_a": "HDD",
    "choice_b": "SSD",
    "choice_c": "NIC",
    "choice_d": "LED",
    "correct_answer": "A",
    "explanation": "Grinding noise is a telltale sign of a hard disk drive (HDD) that is failing. Unlike solid-state drives (SSDs), HDDs have moving parts that sometimes wear out. If you hear a grinding noise, back up the data and replace the HDD as soon as possible!",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      193,
      203,
      200,
      206,
      207
    ],
    "source": "9781394330348"
  },
  {
    "id": 1307,
    "question": "You have configured two hard drives so that when you write to one, it makes an exact copy on the other, and it looks like one drive in your operating system. What level of RAID is this?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "B",
    "explanation": "This configuration is a mirrored drive, Redundant Array of Independent Disks 1 (RAID 1). If one drive fails, you have an exact duplicate on the other. It provides fault tolerance, but it doesn\u2019t protect your system against human error, so you still need backups! RAID 0 is disk striping, which enhances performance but doesn\u2019t help at all with fault tolerance. RAID 5 is disk striping with parity, so it offers fault tolerance and performance improvement. Data is written on two drives, and the third is striped with recovery data. The recovery data is put on each drive in turn. If one drive fails, there is enough recovery data on the other two to rebuild it. RAID 10 is a striped set of mirrors, so like RAID 5 it offers fault tolerance and performance improvement but does so in a different way.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      208,
      207,
      206,
      203,
      200
    ],
    "source": "9781394330348"
  },
  {
    "id": 1308,
    "question": "A technician is troubleshooting a computer in the field and calls you to report that they are getting a S.M.A.R.T. error ID 188 and command timeout. Which component is likely to be causing this error?",
    "choice_a": "CPU",
    "choice_b": "RAM",
    "choice_c": "Motherboard",
    "choice_d": "HDD",
    "correct_answer": "D",
    "explanation": "Nearly every hard drive is built with Self-Monitoring, Analysis, and Reporting Technology (S.M.A.R.T.) software installed on it, which monitors hard drive reliability and theoreticallycan warn you in the event of an imminent failure. The error ID makes no difference. If it is a S.M.A.R.T. error, it\u2019s the hard drive.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      207,
      203,
      188,
      190,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 1309,
    "question": "You just took a new display out of the box and set it up. Now, you notice that it has two dead pixels. What do you do?",
    "choice_a": "Return the display for a refund.",
    "choice_b": "Keep the display but ask for a discount.",
    "choice_c": "Calibrate the display.",
    "choice_d": "Keep the display; it is fine.",
    "correct_answer": "D",
    "explanation": "It is normal that a display may have a dead (i.e., black) pixel or two. This is not considered a big flaw; there is nothing you, as a tech, can do to fix it. If there are many dead pixels or you\u2019re just not happy with your display, your only recourse is to return it for another one, if the vendor will take it back.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      221,
      223,
      220,
      222,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1310,
    "question": "A user complains that the color on their display is strange. It was working fine yesterday. What will you do first?",
    "choice_a": "Check for a loose cable connection at both ends.",
    "choice_b": "Replace the display.",
    "choice_c": "Turn the display off and back on.",
    "choice_d": "Check the settings on the display itself.",
    "correct_answer": "A",
    "explanation": "This is a typical symptom of a loose cable. You need to check both ends of the cable and ensure that they are properly seated. Turning the display or the PC off and back on may also fix it and checking that someone hasn\u2019t bumped or changed the display\u2019s settings is a quick fix too. If none of those work, the next step would be to try a known good display on the computer. If the problem still exists, it\u2019s not the display. It might be time to get a new graphics card.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      223,
      190,
      189,
      202,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1311,
    "question": "A mobile device user dropped their smartphone, and now the charging port is damaged. The device is fairly new, but they didn\u2019t pay for a warranty to cover user error. They don\u2019t typically plug it into a computer or anything else. What should you do first?",
    "choice_a": "Take the phone apart and replace the charging port.",
    "choice_b": "Return the phone to the store for a refund.",
    "choice_c": "See if the device supports wireless charging.",
    "choice_d": "Replace the phone.",
    "correct_answer": "C",
    "explanation": "If the phone will charge wirelessly, then it should be fine. If it\u2019s not covered by a warranty, the store isn\u2019t going to fix or replace it for free. Charging ports aren\u2019t normally considered a user-replaceable part. Components like charging ports can be replaced by a service center where there are people trained to work on smartphones. In any case, make sure that person is backing up the data on their phone to the cloud.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      230,
      225,
      191,
      188,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1312,
    "question": "A grinding noise is coming from your office printer. You know that can\u2019t be good, and you just put new toner in two days ago. What do you do?",
    "choice_a": "Try replacing the toner cartridge.",
    "choice_b": "Take all the paper out and reload it.",
    "choice_c": "Thoroughly clean the printer.",
    "choice_d": "Check for any loose rollers or gears.",
    "correct_answer": "A",
    "explanation": "In troubleshooting, try the simple things first. If it wasn\u2019t grinding before, and it is since you installed a new toner cartridge, then the problem is most likely the toner cartridge. Take it out and put a new one in. If that doesn\u2019t fix it, then look for loose rollers or gears and jammed paper. Thoroughly cleaning it would be the next step. Chances are that reloading the paper won\u2019t help.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      193,
      188,
      189,
      238,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 1313,
    "question": "Several users who access the network through the same WAP are complaining that they have limited connectivity. They can see each other on the network but not any network resources like printers and servers. Everything was working fine yesterday, and network users in other parts of the building are not having problems. What should you troubleshoot first?",
    "choice_a": "The power of the radio signal from the WAP",
    "choice_b": "The connection between the WAP and the router",
    "choice_c": "Their IP configuration",
    "choice_d": "The default gateway",
    "correct_answer": "B",
    "explanation": "When a Wi-Fi user is getting limited connectivity messages, it means that they are able to connect to the wireless access point (WAP) but not the Internet. Because others are also receiving this error message, you can assume it\u2019s the connection between the WAP they\u2019re connecting to and the wired network where the router resides. The router connects the WAP to the wired network and the Internet.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      216,
      229,
      190,
      212,
      214
    ],
    "source": "9781394330348"
  },
  {
    "id": 1314,
    "question": "You just bought a new laptop and were told that it uses biometrics to log you in. Which of the following might they be? (Choose two.)",
    "choice_a": "Face scanner",
    "choice_b": "Entering your password",
    "choice_c": "Fingerprint reader",
    "choice_d": "Entering a code from your phone",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Biometrics are any device that uses a part of your body to identify you. It\u2019s common on modern laptops to have the availability of a face scanner or fingerprint reader to log in to the computer. Other biometrics are retina scanners, palm scanners, and voice recognition.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      81
    ],
    "source": "9781394330348"
  },
  {
    "id": 1315,
    "question": "There is a white streak down all of the printouts of your inkjet printer. What will you do to fix it? (Choose two.)",
    "choice_a": "Change the toner cartridge.",
    "choice_b": "Clean the printheads (nozzle-cleaning routine).",
    "choice_c": "Clear debris from the paper path.",
    "choice_d": "Use different paper.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "It is likely that the ink on your print nozzles is dried out, or if there is something stuck in the printer, like a piece of sticky label, it could be blocking the ink from going where you want it on the paper. The first step would be to do the nozzle-cleaning routine, which cleans the printheads, and you may have to do it more than once. If the nozzle-cleaning check printout looks good, but you\u2019re still having the issue, look inside for something blocking the ink. You might need to replace the ink cartridges. Inkjet printers don\u2019t use toner cartridges, and the wrong paper would present different problems.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      235,
      236,
      190,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1316,
    "question": "The company president is presenting at a meeting in the conference room, and the projector there keeps shutting down after a few minutes. What will you do to remedy the problem? (Choose two.)",
    "choice_a": "Unplug the projector and plug it in again.",
    "choice_b": "Remove dust from the vents.",
    "choice_c": "Allow the fan to run and cool down the system.",
    "choice_d": "Change the input source.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The most likely problem is overheating. DO NOT unplug the projector, as this will stop the fan from cooling down the system and could result in a blown bulb. You can use canned air or a small anti-static brush to remove dust from the vents to promote better air flow. Allow the fan to run and cool down the projector. If an incorrect input source is chosen,it could shut the projector down because it doesn\u2019t sense any input, but then you would have received a call that it simply \u201cdoesn\u2019t work.\u201d.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      219,
      194,
      191,
      190,
      226
    ],
    "source": "9781394330348"
  },
  {
    "id": 1317,
    "question": "Users at your workplace are complaining that the audio over their VoIP phones is of poor quality. It\u2019s often choppy and difficult to understand. Which of these would help with that and could be done fairly quickly? (Choose two.)",
    "choice_a": "Configure QoS to give the VoIP phones priority.",
    "choice_b": "Upgrade the cabling on the network.",
    "choice_c": "Set up the VoIP phones on their own VLAN.",
    "choice_d": "Set up the VoIP phones using a VPN.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Configuring quality of service (QoS) to give priority to the voice over IP (VoIP) phones would likely help the situation, but not as much as putting them on their own virtual local area network (VLAN). Upgrading the cabling to something with more bandwidth might help, but that isn\u2019t a quick solution. If you have a managed switch, setting up a VLAN could be done fairly quickly and would segregate your VoIP traffic on its own network, so that it isn\u2019t competing with computer traffic. A virtual private network (VPN) enables a remote user to connect to a network as if they were in the same physical location.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      114,
      119,
      148,
      156
    ],
    "source": "9781394330348"
  },
  {
    "id": 1318,
    "question": "You notice that your friend\u2019s smartphone is swollen. They said that it happens all the time. What should be done?",
    "choice_a": "Replace the battery.",
    "choice_b": "Replace the device.",
    "choice_c": "Unplug it and let it cool down, and then plug it back in.",
    "choice_d": "Use a different power outlet.",
    "correct_answer": "B",
    "explanation": "First, if it is plugged in, unplug it. A swollen smartphone is usually a sign of a battery problem, and compromised batteries may explode or burst into flame. Most modern smartphones don\u2019t have replaceable batteries, so your friend should replace the smartphone.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      225,
      226,
      189,
      188,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 1319,
    "question": "What are the benefits of virtualization? (Choose two.)",
    "choice_a": "Saves power",
    "choice_b": "Requires more licenses",
    "choice_c": "Less hardware to pay for",
    "choice_d": "Distributed management",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Virtualization has many benefits. If you need, for example, Windows 10, Windows 11, and a Linux distro, instead of having three computers you would only need one. Windows 11 could be the host operating system (OS) and the other two could reside in a virtual machine (VM). This saves power, space, and hardware expense. You would need the same number of licenses whether or not you have the OSs installed on a VM, and managing the OSs is simple because they are all in one box.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      174,
      175,
      178,
      180,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1320,
    "question": "All the users on your network, wired and wireless, are complaining that they\u2019re getting a limited-connectivity message. Where will you start troubleshooting? (Choose the best answer.)",
    "choice_a": "WAP",
    "choice_b": "Default gateway",
    "choice_c": "Switch",
    "choice_d": "Router",
    "correct_answer": "B",
    "explanation": "If everyone is receiving a limited connectivity message, then no one is connecting to the Internet. The place to start troubleshooting is the default gateway, which on many networks could be a router, but it could also be a proxy server, so the default gateway is the best answer here. It\u2019s not the wireless access point (WAP) because wired users are having trouble too. It\u2019s not the switch because switches connect devices on a LAN; they don\u2019t connect the LAN to the Internet.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      216,
      190,
      211,
      212,
      229
    ],
    "source": "9781394330348"
  },
  {
    "id": 1321,
    "question": "You\u2019re shopping for a wireless speaker to use with your smartphone and considering different connection methods. Which of the following wireless connection types generally has a functional communication distance of 10 meters?",
    "choice_a": "NFC",
    "choice_b": "IR",
    "choice_c": "Bluetooth",
    "choice_d": "Wi-Fi",
    "correct_answer": "C",
    "explanation": "The vast majority of consumer Bluetooth mobile devices are Class 2 devices, which have a maximum communication distance of 10 meters (i.e., about 30 feet). The maximum communicating distance for near-field communication (NFC) is only about four inches, infrared (IR) requires line of sight, and Wi-Fi has a much greater distance depending on the Wi-Fi standard being used.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      159,
      162,
      157,
      166,
      165
    ],
    "source": "9781394330348"
  },
  {
    "id": 1322,
    "question": "What type of display is increasingly being used in smaller mobile devices for its picture quality, lower power consumption, and foldability?",
    "choice_a": "IPS",
    "choice_b": "OLED",
    "choice_c": "LED",
    "choice_d": "VA",
    "correct_answer": "B",
    "explanation": "Organic light-emitting diode (OLED) displays have many advantages over liquid-crystal displays (LCDs). In-plane switching (IPS) and vertical alignment (VA) are both types of LCDs, and some displays use light-emitting diode (LED) backlighting. OLEDs don\u2019t need backlighting because the carbon-based material they are created from provides light and color. Fewer layers are needed so OLED displays can be made thinner than LED displays. The color contrast is better than LED displays, and they have faster refresh rates and the unique characteristic of being foldable.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      49,
      48,
      53,
      50,
      52
    ],
    "source": "9781394330348"
  },
  {
    "id": 1323,
    "question": "Your company allows workers to use their personal devices for company business. What will you, as the IT director, use to ensure that company information is safe on those personal devices?",
    "choice_a": "MDM",
    "choice_b": "BYOD",
    "choice_c": "PRL",
    "choice_d": "GSM",
    "correct_answer": "A",
    "explanation": "Mobile device management (MDM) systems can be used to ensure the security of your company information on employees\u2019 personal devices. They can be used to block downloading or printing of certain information and can be used to lock or wipe lost or stolen devices or remove company data from mobile devices when an employee has leftthe company. A bring your own device (BYOD) policy is agreed to by an employee at onboarding and defines how BYOD devices will be used and secured, but the policy doesn\u2019t actually do the securing. A preferred roaming list (PRL) will be updated as needed on a mobile device, to ensure that you can roam and connect to the proper cell towers. The Global System for Mobile Communications (GSM) defines how 2G cellular networks work. GSM is used in Europe and in much of the world. Code Division Multiple Access (CDMA) is mainly used in the United States and was used on 2G and 3G phone systems. The current standard is 5G in many places.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      231,
      191,
      190,
      188,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 1324,
    "question": "Which of the following would not be considered authentication in a system using MFA?",
    "choice_a": "Key fob",
    "choice_b": "Authenticator app",
    "choice_c": "Username",
    "choice_d": "Soft token",
    "correct_answer": "C",
    "explanation": "Your username is identification\u2014telling a system who you are. Authentication means proving to a system that you are who you say you are, and that is done by providing something you know, something you have, something you are (i.e., biometrics), or somewhere you are. These are the factors used to authenticate you. In a multifactor authentication (MFA) system, you first identify yourself to the system (i.e., by providing your username), and provide your first authentication, usually a password (i.e., something you know), then you need another authentication factor. A key fob is a small device, about the size of a key chain, that uses algorithms to generate a numeric key that lasts for only a few seconds and is unique to the application and the user. An authenticator app is software on a device, which does the same thing, and is a type of soft token. A key fob is considered a hard token.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      127,
      126,
      120,
      119
    ],
    "source": "9781394330348"
  },
  {
    "id": 1325,
    "question": "Which two TCP/IP protocols are designed to download email from mail servers? (Choose two.)",
    "choice_a": "SMTP",
    "choice_b": "POP3",
    "choice_c": "IMAP",
    "choice_d": "SMB",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Post Office Protocol version 3 (POP3) and Internet Message Access Protocol (IMAP) are used for downloading email messages from a server. The difference between the two is that IMAP allows the messages to remain on the server so they can be accessed from different devices, where with POP3 the email messages will only exist on the device on which they were downloaded. Simple Mail Transfer Protocol (SMTP) is used for sending an email. A good way to remember which is for sending and receiving is to remember that S (as in SMTP) is for sending. Server Message Block (SMB) is a protocol for sharing files across a network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      106,
      128,
      119,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 1326,
    "question": "Which TCP/IP protocol is responsible for resolving IP addresses to MAC addresses?",
    "choice_a": "IP",
    "choice_b": "SSH",
    "choice_c": "DHCP",
    "choice_d": "ARP",
    "correct_answer": "D",
    "explanation": "Address Resolution Protocol (ARP) is responsible for resolving Internet Protocol (IP) addresses to media access control (MAC) addresses. IP is used in routing information packets from one Internet location to another. Secure Shell (SSH) is a connection-oriented protocol used to securely manage a network and its devices remotely. Dynamic Host Configuration Protocol (DHCP) is a connectionless protocol used to dynamically assign network configuration information to clients that request it on a network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      118,
      117,
      122,
      108,
      121
    ],
    "source": "9781394330348"
  },
  {
    "id": 1327,
    "question": "You need a WAP in a loading dock, but there is not an appropriate power receptacle close enough to plug it into, so you decided to use a PoE WAP. The problem is that your switch is not PoE compliant. Which of the following will you need to purchase in addition to the PoE WAP?",
    "choice_a": "Very long extension cord",
    "choice_b": "PoE injector",
    "choice_c": "New switch",
    "choice_d": "New router",
    "correct_answer": "B",
    "explanation": "If your wireless access point (WAP) is Power-over-Ethernet (PoE) compliant but your switch is not, then you can purchase a PoE injector to send power (along with the data) to a PoE device with a single Ethernet cable. The distance is limited by the cable category and Ethernet standard being used.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      115,
      114,
      108,
      107,
      102
    ],
    "source": "9781394330348"
  },
  {
    "id": 1328,
    "question": "Which wireless networking (Wi-Fi) standards can use both the 2.4 GHz and 5 GHz frequencies? (Choose two.)",
    "choice_a": "802.11g",
    "choice_b": "802.11n",
    "choice_c": "802.11ac (Wi-Fi 5)",
    "choice_d": "802.11ax (Wi-Fi 6)",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Only the 802.11n, 802.11ax, and 802.11be standards can use both the 2.4 GHz and 5 GHz frequencies, which makes them backward compatible with all the other standards. Standards 802.11a and 802.11ac use only the 5 GHz frequency. Standards 802.11b and 802.11g use only the 2.4 GHz frequency.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      138,
      144,
      142,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 1329,
    "question": "When setting up your network, you configured your clients to obtain IP addressing information automatically from a DHCP server. Which of the following configuration items can the DHCP server provide?",
    "choice_a": "IP address",
    "choice_b": "IP address and subnet mask",
    "choice_c": "IP address, subnet mask, and default gateway",
    "choice_d": "IP address, subnet mask, default gateway, and DNS server address",
    "correct_answer": "D",
    "explanation": "A Dynamic Host Configuration Protocol (DHCP) server can be configured to provide all required and optional Transmission Control Protocol/Internet Protocol (TCP/IP) configuration information to clients. This includes an IP address, subnet mask (for IPv4), default gateway, and Domain Name System (DNS) server address.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      122,
      129,
      128
    ],
    "source": "9781394330348"
  },
  {
    "id": 1330,
    "question": "A computer on your network is not able to reach the DHCP server. The DHCP server assigns addresses in the 200.100.1.11\u2013200.100.1.110 range. What address might this computer get when it boots up? (Choose two.)",
    "choice_a": "APIPA",
    "choice_b": "Class C",
    "choice_c": "169.254.1.101",
    "choice_d": "200.100.1.15",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Because this computer is not able to reach the Dynamic Host Configuration Protocol (DHCP) server, it will self-assign an Automatic Private Internet Protocol Addressing (APIPA) address. The APIPA address range is 169.254.0.0\u2013169.254.255.255. (In the last octet, 0 and 255 would not be assigned, because the last number of a range is the broadcast number and the first number of a range identifies the network.).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      121,
      124,
      122,
      123
    ],
    "source": "9781394330348"
  },
  {
    "id": 1331,
    "question": "Which of the following is not true about DNS servers?",
    "choice_a": "They translate IP addresses to domain names likeSybex.com.",
    "choice_b": "AAAA DNS records identify IPv6 addresses.",
    "choice_c": "A records identify IPv4 addresses.",
    "choice_d": "There is a setting in the IP configuration to identify the DNS server to use.",
    "correct_answer": "A",
    "explanation": "Domain Name Service (DNS) servers reconcile human friendly names likeSybex.comto Internet Protocol (IP) addresses so that a browser can find them (not IP address to domain name). A Domain Name System (DNS) server setting can be configured on a client computer automatically by a Dynamic Host Configuration Protocol (DHCP) server, or manually on the Networking tab of a network connection by clicking on either IPv4 or IPv6 properties. DNS differentiates between IPv4 and IPv6 by identifying IPv6 addresses as AAAA records and IPv4 addresses as A records.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      129,
      130,
      118,
      119
    ],
    "source": "9781394330348"
  },
  {
    "id": 1332,
    "question": "A UTP cable just failed and needs to replaced. You have a spool of cable and connectors but no premade cables. Which tool do you need to use to make a new cable?",
    "choice_a": "Toner probe",
    "choice_b": "Punchdown tool",
    "choice_c": "Multimeter",
    "choice_d": "Crimper and cable stripper",
    "correct_answer": "D",
    "explanation": "A crimper is a handy tool for helping you put connectors on the ends of a cable. Most crimpers will be a combination tool that strips and snips wires, as well as crimps the connector onto the end. A toner probe helps a technician locate a particular wire in a bunch that look the same. A punchdown tool is used to attach wires to a punchdown block on a wiring rack in a telecommunications closet. A multimeter has many uses, among them testing continuity, checking power supplies, and checking wall outlets. UTP is unshielded twisted pair.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      111,
      115,
      116,
      146
    ],
    "source": "9781394330348"
  },
  {
    "id": 1333,
    "question": "You need to create several UTP patch cables from a roll of bulk cable. Your company uses the T568A standard. What is the correct order for wires in the connectors?",
    "choice_a": "Orange stripe, orange, green stripe, blue, blue stripe, green, brown stripe, brown",
    "choice_b": "Orange stripe, green, green stripe, blue, blue stripe, orange, brown stripe, brown",
    "choice_c": "Green stripe, green, orange stripe, blue, blue stripe, orange, brown stripe, brown",
    "choice_d": "Green stripe, green, orange, blue, blue stripe, orange stripe, brown stripe, brown",
    "correct_answer": "C",
    "explanation": "Unshielded twisted pair (UTP) wire has eight wires. The colors are orange, green, blue, and brown, with a solid and striped wire of each color. The American National Standards Institute/Telecommunications Industry Association (ANSI/TIA) 568A Standard is green stripe, green, orange stripe, blue, blue stripe, orange, brown stripe, brown. The ANSI/TIA 568B standard is orange stripe, orange, green stripe, blue, blue stripe, green, brown stripe, brown. To make it easier to remember, notice that only the green and orange change positions. Blue and brown stay in the same positions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      63,
      57,
      60,
      90,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 1334,
    "question": "You need a cable that will run a distance of 200 feet and support speeds up to 10 Gbps. Which cable will you use?",
    "choice_a": "Cat 5e",
    "choice_b": "Cat 6",
    "choice_c": "Cat 6a",
    "choice_d": "Plenum",
    "correct_answer": "C",
    "explanation": "Both Cat 6 and Cat 6a will support up to 10 Gbps, but for Cat 6 the maximum distance for 10 Gbps is about 55 meters (i.e., 165 feet). Cat 6a can support a frequency that is twice as fast, so it can support 10 Gbps up to 328 feet (i.e., 100 meters). Because the distance in the question is 200 feet, you would need to use Cat 6a cable. Cat 5e has a maximum bandwidth of 1 Gbps. Plenum simply means that the cable has a coating that doesn\u2019t produce toxic fumes when burned. It is required by certain building codes.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      63,
      4,
      35
    ],
    "source": "9781394330348"
  },
  {
    "id": 1335,
    "question": "A new technician on your team has been asked to replace memory in a laptop. They removed a card and brought it to you; it\u2019s shown here. What did they remove?<img src=\"/question_assets/220-1201/c10f004.png\" alt=\"Close-up of Kingston 120 G B S S D circuit board.\"/>\n\n<figcaption>Close-up of Kingston 120 G B S S D circuit board.</figcaption>",
    "choice_a": "SODIMM",
    "choice_b": "ECC",
    "choice_c": "DIMM",
    "choice_d": "M.2",
    "correct_answer": "D",
    "explanation": "This isn\u2019t memory at all. It is an M.2, which is a solid-state drive (SSD) used for storage. It may look similar to a dual inline memory module (DIMM), but it\u2019s smaller and the connectors are on one (short) end, not on the long edge. Error correcting code (ECC) is a feature of some random access memory (RAM) modules that will detect and attempt to correct errors in storing or retrieving information. ECC is usually found on servers rather than desktopcomputers and is more expensive. Small outline DIMMs (SODIMMs), the memory used in laptops, will have a notch and connectors on the long side as will regular DIMMs, which are used in desktop computers. DIMMs are larger than SODIMMs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      4,
      18,
      34,
      14,
      26
    ],
    "source": "9781394330348"
  },
  {
    "id": 1336,
    "question": "The people in your office want a printer that will print on both sides of the paper automatically. What feature is this?",
    "choice_a": "Duplex",
    "choice_b": "Orientation",
    "choice_c": "Tray settings",
    "choice_d": "Print quality",
    "correct_answer": "A",
    "explanation": "Duplexing is automatically printing on both sides of the paper\u2014no need to stand at the printer and flip the copies over. Orientation refers to whether a paper is wider than it is tall (i.e., landscape), or taller than it is wide (i.e., portrait). Tray settings refer to configuration settings, such as if a print job is 11 14 inches instead of 8.5 11, then you must select tray two which is filled with the larger paper. It\u2019s just one of many settings. Most printers will have a fast print mode or a quality print mode.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      75,
      74,
      96,
      92,
      89
    ],
    "source": "9781394330348"
  },
  {
    "id": 1337,
    "question": "A receipt printer is unable to print receipts because it has run out of paper. You\u2019ll be replacing a roll of thermal paper to fix the problem. What type of printer are you working on?",
    "choice_a": "Inkjet",
    "choice_b": "Impact",
    "choice_c": "Laser",
    "choice_d": "Thermal",
    "correct_answer": "D",
    "explanation": "Thermal printers require a special thermal paper that will turn black when subjected to heat. Inkjet printers use paper that resists colors bleeding into other areas; impact printers often use no carbon required (NCR) forms to make multiple copies of a form when they print; and laser printers use toner, electricity, and heat to transfer an image to paper.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      235,
      236,
      239,
      238,
      234
    ],
    "source": "9781394330348"
  },
  {
    "id": 1338,
    "question": "A friend has asked for your help because their smartphone thinks they\u2019re clicking where they aren\u2019t. It seems like the touch calibration is incorrect. What is the first step to resolve their problem?",
    "choice_a": "Calibrate the screen.",
    "choice_b": "Replace the screen protector.",
    "choice_c": "Clean the screen.",
    "choice_d": "Look for damage.",
    "correct_answer": "C",
    "explanation": "Cleaning the screen should be your first step. Dirty screens can cause problems because even clean hands can leave oil from your skin on the screen\u2019s surface. Although any or all of the options could be a part of your troubleshooting, cleaning the screen should be your first step.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      228,
      190,
      188,
      191,
      227
    ],
    "source": "9781394330348"
  },
  {
    "id": 1339,
    "question": "You\u2019re comparing current performance to a baseline on a computer system and have noticed that the drive\u2019s read/write times are extended. Which of the following would be your last resort?",
    "choice_a": "Check for low available disk space.",
    "choice_b": "Replace the drive.",
    "choice_c": "Check for malware.",
    "choice_d": "Defragment if it\u2019s an HDD.",
    "correct_answer": "B",
    "explanation": "There are many reasons why a drive might be working more slowly, but you don\u2019t necessarily need to replace it. My first thought would be to check for malware in the system. Then, you should defragment it if it is a hard disk drive (HDD). Solid-state drives (SSDs) should not be defragmented. Ensure that the drive has ample available space, look for physical problems, suspect that the HDD may be failing, and replace it with an SSD for improved performance.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      206,
      190,
      207,
      200,
      231
    ],
    "source": "9781394330348"
  },
  {
    "id": 1340,
    "question": "A technician has two hard drives and wants to increase the data access speed of a computer. You tell them to install both drives, but which of the following configurations is their best option?",
    "choice_a": "Configure them as separate volumes.",
    "choice_b": "Implement RAID 0.",
    "choice_c": "Implement RAID 1.",
    "choice_d": "Implement RAID 6.",
    "correct_answer": "B",
    "explanation": "RAID 0 is called disk striping. Data can be written to or read from multiple devices at the same time, increasing data access speed. However, if one drive fails, all data is lost. (Back up early and often!) RAID 1 is a mirror set, which does not increase data access but provides fault tolerance. RAID 5 is disk striping with parity, which provides both speed and fault tolerance but requires three drives. RAID 6 is disk striping with double parity, so two drives can fail, and the array\u2019s data is still safe, but it requires a minimum of four drives to implement.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      208,
      206,
      200,
      190,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 1341,
    "question": "You\u2019re setting up a virtual machine for a developer who needs three instances of Windows 11, plus the host OS, which is also Windows 11. How many licenses will you need?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Four",
    "choice_d": "None",
    "correct_answer": "C",
    "explanation": "Generally speaking, you will need a license for each instance of an operating system (OS) that is running in your virtual machine (VM), plus the host OS.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      174,
      178,
      176,
      179,
      175
    ],
    "source": "9781394330348"
  },
  {
    "id": 1342,
    "question": "What are the three major categories of cloud computing? (Choose three.)",
    "choice_a": "SaaS",
    "choice_b": "RaaS",
    "choice_c": "PaaS",
    "choice_d": "IaaS",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "While Software-as-a-Service (SaaS), Platform-as-a-Service (PaaS), and Infrastructure-as-a-Service (IaaS) are widely considered to be the major categories of cloud computing, RaaS is not an acronym for a specific type of cloud computing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      182,
      180,
      183,
      181,
      174
    ],
    "source": "9781394330348"
  },
  {
    "id": 1343,
    "question": "A user calls the Help Desk because their printer isn\u2019t printing. They tell you that \u201cnothing happens\u201d when they send a print job. Which of the following is the least likely solution?",
    "choice_a": "Help them choose the right printer.",
    "choice_b": "Replace the paper with paper designed for the printer.",
    "choice_c": "Stop and restart the print queue.",
    "choice_d": "Troubleshoot a connectivity issue.",
    "correct_answer": "B",
    "explanation": "The least likely problem in this scenario is the paper. If the paper is too thin, too heavy, or too humid, then they would hear the printer attempt to pick up the paper, and there may be a paper jam. They said, \u201cnothing happens,\u201d so look for an issue that happensbeforethe printer tries to pick up the paper. Some common issues are that they have chosen the wrong printer, the print queue is frozen for some reason, or they have a connectivity issue with the printer. If it prints from another application, then they have a software issue.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      242,
      240,
      190,
      237,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1344,
    "question": "The Help Desk receives a call that the printout from a printer is garbled, with strange characters printing. What will you do?",
    "choice_a": "Replace the paper.",
    "choice_b": "Clear a paper jam.",
    "choice_c": "Clean the pickup rollers.",
    "choice_d": "Replace the printer driver.",
    "correct_answer": "D",
    "explanation": "Garbled print is a classic sign of a corrupted printer driver. Update or replace the printer driver.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      190,
      188,
      240,
      242,
      241
    ],
    "source": "9781394330348"
  },
  {
    "id": 1345,
    "question": "Your company has grown drastically, and rather than adding more networking devices and computers, it wants to move its network\u2019s hardware to the cloud so employees can access it from anywhere. What is the company using?",
    "choice_a": "IaaS",
    "choice_b": "SaaS",
    "choice_c": "PaaS",
    "choice_d": "NaaS",
    "correct_answer": "A",
    "explanation": "Infrastructure-as-a-Service (IaaS) enables companies to scale their environments without purchasing new hardware and running network wires. IaaS services are typically \u201cpay as you go\u201d and work well for companies experiencing rapid expansion. Software-as-a-Service (SaaS) means that software is being provided online, such as accounting and tax preparation software, sales management, and data backup services. Platform-as-a-Service (PaaS) provides developers all that they need to develop software such as the infrastructure and development software. Network-as-a-Service (NaaS) provides network infrastructure and management. Examples of NaaS providers are Palo Alto Networks and CISCO.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      182,
      180,
      181,
      183,
      187
    ],
    "source": "9781394330348"
  },
  {
    "id": 1346,
    "question": "What must be defined when wanting to maintain confidentiality, integrity, and availability of the system resources and should be a part of the decision when choosing a cloud solution?",
    "choice_a": "Scalability",
    "choice_b": "Security requirements",
    "choice_c": "Elasticity",
    "choice_d": "Emulation ability",
    "correct_answer": "B",
    "explanation": "When wanting to maintain confidentiality, integrity, and availability, security requirements and regulations must first be defined. A company can then consider if an Internet cloud solution would be appropriate. Scalability is the ability to purchase more services over time. Elasticity is similar but is on-demand scaling up or down in service levels automatically. Emulation is when one hardware or software is able to act as if it were another. It is especially helpful when, for example, a piece of hardware that a manufacturing process uses is no longer viable, so more modern hardware is used but software is written to interface between the manufacturing process and the newer hardware. The manufacturing process acts as if it is still running on the older hardware because it can\u2019t detect the difference.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      180,
      181,
      182,
      183,
      184
    ],
    "source": "9781394330348"
  },
  {
    "id": 1347,
    "question": "A company using cloud services wishes to better prepare for surges in the services it needs from the cloud services provider. What sort of capacity provisioning by its cloud provider should the company ask for?",
    "choice_a": "Elasticity",
    "choice_b": "IaaS",
    "choice_c": "Metered utilization",
    "choice_d": "Multitenancy",
    "correct_answer": "C",
    "explanation": "For a company needing additional cloud resources on demand, they should request metered utilization, in which a cloud service will bill much like a utility would, as resources are used. Elasticity means that the cloud service can provide additional or fewer resources as the company needs them, on demand. Infrastructure-as-a-Service (IaaS) refers to hardware and networking in the cloud. Multitenancy means that resources are pooled and delivered as needed to many clients.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      183,
      182,
      180,
      184,
      181
    ],
    "source": "9781394330348"
  },
  {
    "id": 1348,
    "question": "A group of real estate agents has realized that they have similar computing resource needs. They\u2019ve reached out collectively to your IT services company and asked if there is a solution that will enable them to pool their resources and save money, possibly sharing industry-specific software, but still have their servers and information held securely and locally. What will you recommend?",
    "choice_a": "Community cloud",
    "choice_b": "Public cloud",
    "choice_c": "Private cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "A",
    "explanation": "A community cloud is the solution for such situations. It enables a limited group of people or companies to share cloud resources. The group can benefit from economies of scale, but each keep their information separate from the other organizations in the community. They could even share in joint projects. Their servers could be in a data center or stored locally by one of the members. The group will have more control than they would over a public cloud but could share the maintenance costs of their cloud. A community cloud is similar to a private cloud but with multiple members. A private cloud is owned by a single entity, although it may be accessed by several locations owned by that entity. A public cloud service is one that anyone can purchase shared resources or services from, suchas Amazon Web Service (AWS), Google cloud, and IBM cloud. A hybrid cloud is a combination of public and private cloud features, such as having a private data center but leasing management services from a cloud provider.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      181,
      180,
      183,
      182,
      185
    ],
    "source": "9781394330348"
  },
  {
    "id": 1349,
    "question": "An employee travels between multiple offices, using a desktop system in each office. What technology would ensure that the employee\u2019s desktop icons, files, and applications stay uniform across systems in all the offices?",
    "choice_a": "On-demand desktop streaming",
    "choice_b": "VDI in the cloud",
    "choice_c": "Desktop emulation",
    "choice_d": "Synchronized folders",
    "correct_answer": "B",
    "explanation": "A virtual desktop infrastructure (VDI) moves the desktop icons, files, and folders to a server instead of the desktop originating from the local machine. When the desktop experience is hosted on a centralized server location, the icons, files, and folders are the same. With this user working from different offices, the best solution for them is VDI in the cloud. On-demand desktop streaming is a Dell streaming service where the desktops and files are stored on a server that provides them to thin clients without drives over gigabit Ethernet. Desktop emulation is software that imitates a desktop. Synchronized folders means that your documents will be the same whether you log in to a desktop, laptop, or other mobile device. Changes on one are synchronized to the other devices.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      180,
      182,
      185,
      186,
      174
    ],
    "source": "9781394330348"
  }
];
